function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0742"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0742"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.1";

});



parcelRequire.register("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_createPortal", () => $0b2e6adb871a3b94$export$2577ef5d2565d52f, (v) => $0b2e6adb871a3b94$export$2577ef5d2565d52f = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$2577ef5d2565d52f;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error($0b2e6adb871a3b94$var$y(227));
var $0b2e6adb871a3b94$var$ba = new Set, $0b2e6adb871a3b94$var$ca = {};
function $0b2e6adb871a3b94$var$da(a, b) {
    $0b2e6adb871a3b94$var$ea(a, b);
    $0b2e6adb871a3b94$var$ea(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ea(a, b) {
    $0b2e6adb871a3b94$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$ba.add(b[a]);
}
var $0b2e6adb871a3b94$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$ia = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ja = {}, $0b2e6adb871a3b94$var$ka = {};
function $0b2e6adb871a3b94$var$la(a) {
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ka, a)) return !0;
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ja, a)) return !1;
    if ($0b2e6adb871a3b94$var$ha.test(a)) return $0b2e6adb871a3b94$var$ka[a] = !0;
    $0b2e6adb871a3b94$var$ja[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$oa = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$D.xlinkHref = new $0b2e6adb871a3b94$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$D.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($0b2e6adb871a3b94$var$na(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $0b2e6adb871a3b94$var$ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$sa = 60103, $0b2e6adb871a3b94$var$ta = 60106, $0b2e6adb871a3b94$var$ua = 60107, $0b2e6adb871a3b94$var$wa = 60108, $0b2e6adb871a3b94$var$xa = 60114, $0b2e6adb871a3b94$var$ya = 60109, $0b2e6adb871a3b94$var$za = 60110, $0b2e6adb871a3b94$var$Aa = 60112, $0b2e6adb871a3b94$var$Ba = 60113, $0b2e6adb871a3b94$var$Ca = 60120, $0b2e6adb871a3b94$var$Da = 60115, $0b2e6adb871a3b94$var$Ea = 60116, $0b2e6adb871a3b94$var$Fa = 60121, $0b2e6adb871a3b94$var$Ga = 60128, $0b2e6adb871a3b94$var$Ha = 60129, $0b2e6adb871a3b94$var$Ia = 60130, $0b2e6adb871a3b94$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $0b2e6adb871a3b94$var$E = Symbol.for;
    $0b2e6adb871a3b94$var$sa = $0b2e6adb871a3b94$var$E("react.element");
    $0b2e6adb871a3b94$var$ta = $0b2e6adb871a3b94$var$E("react.portal");
    $0b2e6adb871a3b94$var$ua = $0b2e6adb871a3b94$var$E("react.fragment");
    $0b2e6adb871a3b94$var$wa = $0b2e6adb871a3b94$var$E("react.strict_mode");
    $0b2e6adb871a3b94$var$xa = $0b2e6adb871a3b94$var$E("react.profiler");
    $0b2e6adb871a3b94$var$ya = $0b2e6adb871a3b94$var$E("react.provider");
    $0b2e6adb871a3b94$var$za = $0b2e6adb871a3b94$var$E("react.context");
    $0b2e6adb871a3b94$var$Aa = $0b2e6adb871a3b94$var$E("react.forward_ref");
    $0b2e6adb871a3b94$var$Ba = $0b2e6adb871a3b94$var$E("react.suspense");
    $0b2e6adb871a3b94$var$Ca = $0b2e6adb871a3b94$var$E("react.suspense_list");
    $0b2e6adb871a3b94$var$Da = $0b2e6adb871a3b94$var$E("react.memo");
    $0b2e6adb871a3b94$var$Ea = $0b2e6adb871a3b94$var$E("react.lazy");
    $0b2e6adb871a3b94$var$Fa = $0b2e6adb871a3b94$var$E("react.block");
    $0b2e6adb871a3b94$var$E("react.scope");
    $0b2e6adb871a3b94$var$Ga = $0b2e6adb871a3b94$var$E("react.opaque.id");
    $0b2e6adb871a3b94$var$Ha = $0b2e6adb871a3b94$var$E("react.debug_trace_mode");
    $0b2e6adb871a3b94$var$Ia = $0b2e6adb871a3b94$var$E("react.offscreen");
    $0b2e6adb871a3b94$var$Ja = $0b2e6adb871a3b94$var$E("react.legacy_hidden");
}
var $0b2e6adb871a3b94$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $0b2e6adb871a3b94$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ka && a[$0b2e6adb871a3b94$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$Ma;
function $0b2e6adb871a3b94$var$Na(a) {
    if (void 0 === $0b2e6adb871a3b94$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$Ma = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$Ma + a;
}
var $0b2e6adb871a3b94$var$Oa = !1;
function $0b2e6adb871a3b94$var$Pa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Oa) return "";
    $0b2e6adb871a3b94$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Na(a) : "";
}
function $0b2e6adb871a3b94$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Na(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Na("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Na("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $0b2e6adb871a3b94$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return "Fragment";
        case $0b2e6adb871a3b94$var$ta:
            return "Portal";
        case $0b2e6adb871a3b94$var$xa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$wa:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ba:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $0b2e6adb871a3b94$var$Da:
            return $0b2e6adb871a3b94$var$Ra(a.type);
        case $0b2e6adb871a3b94$var$Fa:
            return $0b2e6adb871a3b94$var$Ra(a._render);
        case $0b2e6adb871a3b94$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$$a(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$qa(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    $0b2e6adb871a3b94$var$$a(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$bb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$bb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $0b2e6adb871a3b94$var$db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $0b2e6adb871a3b94$var$eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = $0b2e6adb871a3b94$var$db(b.children)) a.children = b;
    return a;
}
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($0b2e6adb871a3b94$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $0b2e6adb871a3b94$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $0b2e6adb871a3b94$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$nb, $0b2e6adb871a3b94$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $0b2e6adb871a3b94$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$nb = $0b2e6adb871a3b94$var$nb || document.createElement("div");
        $0b2e6adb871a3b94$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$qb).forEach(function(a) {
    $0b2e6adb871a3b94$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$qb[b] = $0b2e6adb871a3b94$var$qb[a];
    });
});
function $0b2e6adb871a3b94$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$qb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$y(62));
    }
}
function $0b2e6adb871a3b94$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$y(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $0b2e6adb871a3b94$var$Ib() {}
var $0b2e6adb871a3b94$var$Jb = $0b2e6adb871a3b94$var$Gb, $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Lb = !1;
function $0b2e6adb871a3b94$var$Mb() {
    if (null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Ib(), $0b2e6adb871a3b94$var$Fb();
}
function $0b2e6adb871a3b94$var$Nb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Lb) return a(b, c);
    $0b2e6adb871a3b94$var$Lb = !0;
    try {
        return $0b2e6adb871a3b94$var$Jb(a, b, c);
    } finally{
        $0b2e6adb871a3b94$var$Lb = !1, $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$y(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Pb = !1;
if ($0b2e6adb871a3b94$var$fa) try {
    var $0b2e6adb871a3b94$var$Qb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Qb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Pb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
} catch (a) {
    $0b2e6adb871a3b94$var$Pb = !1;
}
function $0b2e6adb871a3b94$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0b2e6adb871a3b94$var$Sb = !1, $0b2e6adb871a3b94$var$Tb = null, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, $0b2e6adb871a3b94$var$Wb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Sb = !0;
        $0b2e6adb871a3b94$var$Tb = a;
    }
};
function $0b2e6adb871a3b94$var$Xb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Sb = !1;
    $0b2e6adb871a3b94$var$Tb = null;
    $0b2e6adb871a3b94$var$Rb.apply($0b2e6adb871a3b94$var$Wb, arguments);
}
function $0b2e6adb871a3b94$var$Yb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Xb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Sb) {
        if ($0b2e6adb871a3b94$var$Sb) {
            var l = $0b2e6adb871a3b94$var$Tb;
            $0b2e6adb871a3b94$var$Sb = !1;
            $0b2e6adb871a3b94$var$Tb = null;
        } else throw Error($0b2e6adb871a3b94$var$y(198));
        $0b2e6adb871a3b94$var$Ub || ($0b2e6adb871a3b94$var$Ub = !0, $0b2e6adb871a3b94$var$Vb = l);
    }
}
function $0b2e6adb871a3b94$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$ac(a) {
    if ($0b2e6adb871a3b94$var$Zb(a) !== a) throw Error($0b2e6adb871a3b94$var$y(188));
}
function $0b2e6adb871a3b94$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Zb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$ac(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$y(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$cc(a) {
    a = $0b2e6adb871a3b94$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $0b2e6adb871a3b94$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $0b2e6adb871a3b94$var$ec, $0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$gc, $0b2e6adb871a3b94$var$hc, $0b2e6adb871a3b94$var$ic = !1, $0b2e6adb871a3b94$var$jc = [], $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null, $0b2e6adb871a3b94$var$mc = null, $0b2e6adb871a3b94$var$nc = new Map, $0b2e6adb871a3b94$var$oc = new Map, $0b2e6adb871a3b94$var$pc = [], $0b2e6adb871a3b94$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $0b2e6adb871a3b94$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$oc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $0b2e6adb871a3b94$var$rc(b, c, d, e, f), null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$mc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$nc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$oc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$vc(a) {
    var b = $0b2e6adb871a3b94$var$wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            $0b2e6adb871a3b94$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$zc(a, b, c) {
    $0b2e6adb871a3b94$var$xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$Ac() {
    for($0b2e6adb871a3b94$var$ic = !1; 0 < $0b2e6adb871a3b94$var$jc.length;){
        var a = $0b2e6adb871a3b94$var$jc[0];
        if (null !== a.blockedOn) {
            a = $0b2e6adb871a3b94$var$Cb(a.blockedOn);
            null !== a && $0b2e6adb871a3b94$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $0b2e6adb871a3b94$var$jc.shift();
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$kc) && ($0b2e6adb871a3b94$var$kc = null);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$lc) && ($0b2e6adb871a3b94$var$lc = null);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$mc) && ($0b2e6adb871a3b94$var$mc = null);
    $0b2e6adb871a3b94$var$nc.forEach($0b2e6adb871a3b94$var$zc);
    $0b2e6adb871a3b94$var$oc.forEach($0b2e6adb871a3b94$var$zc);
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$ic || ($0b2e6adb871a3b94$var$ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Ac)));
}
function $0b2e6adb871a3b94$var$Cc(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$Bc(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$jc.length) {
        $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$jc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$jc.length; c++){
            var d = $0b2e6adb871a3b94$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$kc, a);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$lc, a);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$mc, a);
    $0b2e6adb871a3b94$var$nc.forEach(b);
    $0b2e6adb871a3b94$var$oc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$pc.length; c++)d = $0b2e6adb871a3b94$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$pc.length && (c = $0b2e6adb871a3b94$var$pc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$pc.shift();
}
function $0b2e6adb871a3b94$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$Ec = {
    animationend: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Dc("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Fc = {}, $0b2e6adb871a3b94$var$Gc = {};
$0b2e6adb871a3b94$var$fa && ($0b2e6adb871a3b94$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$Ec.animationend.animation, delete $0b2e6adb871a3b94$var$Ec.animationiteration.animation, delete $0b2e6adb871a3b94$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$Ec.transitionend.transition);
function $0b2e6adb871a3b94$var$Hc(a) {
    if ($0b2e6adb871a3b94$var$Fc[a]) return $0b2e6adb871a3b94$var$Fc[a];
    if (!$0b2e6adb871a3b94$var$Ec[a]) return a;
    var b = $0b2e6adb871a3b94$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Gc) return $0b2e6adb871a3b94$var$Fc[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$Ic = $0b2e6adb871a3b94$var$Hc("animationend"), $0b2e6adb871a3b94$var$Jc = $0b2e6adb871a3b94$var$Hc("animationiteration"), $0b2e6adb871a3b94$var$Kc = $0b2e6adb871a3b94$var$Hc("animationstart"), $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Hc("transitionend"), $0b2e6adb871a3b94$var$Mc = new Map, $0b2e6adb871a3b94$var$Nc = new Map, $0b2e6adb871a3b94$var$Oc = [
    "abort",
    "abort",
    $0b2e6adb871a3b94$var$Ic,
    "animationEnd",
    $0b2e6adb871a3b94$var$Jc,
    "animationIteration",
    $0b2e6adb871a3b94$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $0b2e6adb871a3b94$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $0b2e6adb871a3b94$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $0b2e6adb871a3b94$var$Nc.set(d, b);
        $0b2e6adb871a3b94$var$Mc.set(d, e);
        $0b2e6adb871a3b94$var$da(e, [
            d
        ]);
    }
}
var $0b2e6adb871a3b94$var$Qc = $fO90s.unstable_now;
$0b2e6adb871a3b94$var$Qc();
var $0b2e6adb871a3b94$var$F = 8;
function $0b2e6adb871a3b94$var$Rc(a) {
    if (0 !== (1 & a)) return $0b2e6adb871a3b94$var$F = 15, 1;
    if (0 !== (2 & a)) return $0b2e6adb871a3b94$var$F = 14, 2;
    if (0 !== (4 & a)) return $0b2e6adb871a3b94$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 12, b;
    if (0 !== (a & 32)) return $0b2e6adb871a3b94$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 10, b;
    if (0 !== (a & 256)) return $0b2e6adb871a3b94$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 8, b;
    if (0 !== (a & 4096)) return $0b2e6adb871a3b94$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 5, b;
    if (a & 67108864) return $0b2e6adb871a3b94$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $0b2e6adb871a3b94$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $0b2e6adb871a3b94$var$F = 1, 1073741824;
    $0b2e6adb871a3b94$var$F = 8;
    return a;
}
function $0b2e6adb871a3b94$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $0b2e6adb871a3b94$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($0b2e6adb871a3b94$var$y(358, a));
    }
}
function $0b2e6adb871a3b94$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $0b2e6adb871a3b94$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $0b2e6adb871a3b94$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $0b2e6adb871a3b94$var$Rc(k), e = $0b2e6adb871a3b94$var$F) : (h &= f, 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F));
    } else f = c & ~g, 0 !== f ? (d = $0b2e6adb871a3b94$var$Rc(f), e = $0b2e6adb871a3b94$var$F) : 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F);
    if (0 === d) return 0;
    d = 31 - $0b2e6adb871a3b94$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $0b2e6adb871a3b94$var$Rc(b);
        if (e <= $0b2e6adb871a3b94$var$F) return b;
        $0b2e6adb871a3b94$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $0b2e6adb871a3b94$var$Yc(24 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(10, b) : a;
        case 10:
            return a = $0b2e6adb871a3b94$var$Yc(192 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(8, b) : a;
        case 8:
            return a = $0b2e6adb871a3b94$var$Yc(3584 & ~b), 0 === a && (a = $0b2e6adb871a3b94$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $0b2e6adb871a3b94$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($0b2e6adb871a3b94$var$y(358, a));
}
function $0b2e6adb871a3b94$var$Yc(a) {
    return a & -a;
}
function $0b2e6adb871a3b94$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$Vc(b);
    a[b] = c;
}
var $0b2e6adb871a3b94$var$Vc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$ad, $0b2e6adb871a3b94$var$bd = Math.log, $0b2e6adb871a3b94$var$cd = Math.LN2;
function $0b2e6adb871a3b94$var$ad(a) {
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$bd(a) / $0b2e6adb871a3b94$var$cd | 0) | 0;
}
var $0b2e6adb871a3b94$var$dd = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$ed = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$fd = !0;
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    $0b2e6adb871a3b94$var$Kb || $0b2e6adb871a3b94$var$Ib();
    var e = $0b2e6adb871a3b94$var$hd, f = $0b2e6adb871a3b94$var$Kb;
    $0b2e6adb871a3b94$var$Kb = !0;
    try {
        $0b2e6adb871a3b94$var$Hb(e, a, b, c, d);
    } finally{
        ($0b2e6adb871a3b94$var$Kb = f) || $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$id(a, b, c, d) {
    $0b2e6adb871a3b94$var$ed($0b2e6adb871a3b94$var$dd, $0b2e6adb871a3b94$var$hd.bind(null, a, b, c, d));
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $0b2e6adb871a3b94$var$jc.length && -1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) a = $0b2e6adb871a3b94$var$rc(null, a, b, c, d), $0b2e6adb871a3b94$var$jc.push(a);
        else {
            var f = $0b2e6adb871a3b94$var$yc(a, b, c, d);
            if (null === f) e && $0b2e6adb871a3b94$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) {
                        a = $0b2e6adb871a3b94$var$rc(f, a, b, c, d);
                        $0b2e6adb871a3b94$var$jc.push(a);
                        return;
                    }
                    if ($0b2e6adb871a3b94$var$uc(f, a, b, c, d)) return;
                    $0b2e6adb871a3b94$var$sc(a, d);
                }
                $0b2e6adb871a3b94$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $0b2e6adb871a3b94$var$yc(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$xb(d);
    e = $0b2e6adb871a3b94$var$wc(e);
    if (null !== e) {
        var f = $0b2e6adb871a3b94$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $0b2e6adb871a3b94$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $0b2e6adb871a3b94$var$jd(a, b, d, e, c);
    return null;
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$fa && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$fa && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$fa && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$fa && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$fa) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$fa) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        a = $0b2e6adb871a3b94$var$re;
        if ($0b2e6adb871a3b94$var$Kb) a(b);
        else {
            $0b2e6adb871a3b94$var$Kb = !0;
            try {
                $0b2e6adb871a3b94$var$Gb(a, b);
            } finally{
                $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Mb();
            }
        }
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge, $0b2e6adb871a3b94$var$Ie = Object.prototype.hasOwnProperty;
function $0b2e6adb871a3b94$var$Je(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$0b2e6adb871a3b94$var$Ie.call(b, c[d]) || !$0b2e6adb871a3b94$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    var c = $0b2e6adb871a3b94$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Ke(c);
    }
}
function $0b2e6adb871a3b94$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Ne() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$fa && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Je($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
$0b2e6adb871a3b94$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$0b2e6adb871a3b94$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$0b2e6adb871a3b94$var$Pc($0b2e6adb871a3b94$var$Oc, 2);
for(var $0b2e6adb871a3b94$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $0b2e6adb871a3b94$var$We = 0; $0b2e6adb871a3b94$var$We < $0b2e6adb871a3b94$var$Ve.length; $0b2e6adb871a3b94$var$We++)$0b2e6adb871a3b94$var$Nc.set($0b2e6adb871a3b94$var$Ve[$0b2e6adb871a3b94$var$We], 0);
$0b2e6adb871a3b94$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$Xe));
function $0b2e6adb871a3b94$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Ub) throw a = $0b2e6adb871a3b94$var$Vb, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, a;
}
function $0b2e6adb871a3b94$var$G(a, b) {
    var c = $0b2e6adb871a3b94$var$$e(b), d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$af(b, a, 2, !1), c.add(d));
}
var $0b2e6adb871a3b94$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$cf(a) {
    a[$0b2e6adb871a3b94$var$bf] || (a[$0b2e6adb871a3b94$var$bf] = !0, $0b2e6adb871a3b94$var$ba.forEach(function(b) {
        $0b2e6adb871a3b94$var$Ye.has(b) || $0b2e6adb871a3b94$var$df(b, !1, a, null);
        $0b2e6adb871a3b94$var$df(b, !0, a, null);
    }));
}
function $0b2e6adb871a3b94$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $0b2e6adb871a3b94$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $0b2e6adb871a3b94$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $0b2e6adb871a3b94$var$af(f, a, e, b), g.add(h));
}
function $0b2e6adb871a3b94$var$af(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        case 1:
            e = $0b2e6adb871a3b94$var$id;
            break;
        default:
            e = $0b2e6adb871a3b94$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Nb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$Ic:
                    case $0b2e6adb871a3b94$var$Jc:
                    case $0b2e6adb871a3b94$var$Kc:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$Lc:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $0b2e6adb871a3b94$var$Ob(t, u), null != v && w.push($0b2e6adb871a3b94$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$wc(x) || x[$0b2e6adb871a3b94$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $0b2e6adb871a3b94$var$wc(x) : null, null !== x && (z = $0b2e6adb871a3b94$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $0b2e6adb871a3b94$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0b2e6adb871a3b94$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        q = null == x ? h : $0b2e6adb871a3b94$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $0b2e6adb871a3b94$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $0b2e6adb871a3b94$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $0b2e6adb871a3b94$var$gf(v))q++;
                            for(; 0 < t - q;)w = $0b2e6adb871a3b94$var$gf(w), t--;
                            for(; 0 < q - t;)u = $0b2e6adb871a3b94$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $0b2e6adb871a3b94$var$gf(w);
                                u = $0b2e6adb871a3b94$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0b2e6adb871a3b94$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $0b2e6adb871a3b94$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) J = $0b2e6adb871a3b94$var$Fe;
                    else {
                        J = $0b2e6adb871a3b94$var$De;
                        var K = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $0b2e6adb871a3b94$var$Ee);
                if (J && (J = J(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $0b2e6adb871a3b94$var$bb(h, "number", h.value);
            }
            K = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(K) || "true" === K.contentEditable) $0b2e6adb871a3b94$var$Qe = K, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var Q;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $0b2e6adb871a3b94$var$ie && (Q = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), K = $0b2e6adb871a3b94$var$oe(d, L), 0 < K.length && (L = new $0b2e6adb871a3b94$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $0b2e6adb871a3b94$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Ob(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$ef(a, f, e)), f = $0b2e6adb871a3b94$var$Ob(a, b), null != f && d.push($0b2e6adb871a3b94$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$ef(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.push($0b2e6adb871a3b94$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $0b2e6adb871a3b94$var$jf() {}
var $0b2e6adb871a3b94$var$kf = null, $0b2e6adb871a3b94$var$lf = null;
function $0b2e6adb871a3b94$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $0b2e6adb871a3b94$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $0b2e6adb871a3b94$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $0b2e6adb871a3b94$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$tf = 0;
function $0b2e6adb871a3b94$var$uf(a) {
    return {
        $$typeof: $0b2e6adb871a3b94$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $0b2e6adb871a3b94$var$vf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$wf = "__reactFiber$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$xf = "__reactProps$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$ff = "__reactContainer$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$yf = "__reactEvents$" + $0b2e6adb871a3b94$var$vf;
function $0b2e6adb871a3b94$var$wc(a) {
    var b = a[$0b2e6adb871a3b94$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$ff] || c[$0b2e6adb871a3b94$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$sf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$wf]) return c;
                a = $0b2e6adb871a3b94$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$wf] || a[$0b2e6adb871a3b94$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$y(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$xf] || null;
}
function $0b2e6adb871a3b94$var$$e(a) {
    var b = a[$0b2e6adb871a3b94$var$yf];
    void 0 === b && (b = a[$0b2e6adb871a3b94$var$yf] = new Set);
    return b;
}
var $0b2e6adb871a3b94$var$zf = [], $0b2e6adb871a3b94$var$Af = -1;
function $0b2e6adb871a3b94$var$Bf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$H(a) {
    0 > $0b2e6adb871a3b94$var$Af || (a.current = $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af], $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = null, $0b2e6adb871a3b94$var$Af--);
}
function $0b2e6adb871a3b94$var$I(a, b) {
    $0b2e6adb871a3b94$var$Af++;
    $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Cf = {}, $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$Cf), $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$Bf(!1), $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$Gf() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
}
function $0b2e6adb871a3b94$var$Hf(a, b, c) {
    if ($0b2e6adb871a3b94$var$M.current !== $0b2e6adb871a3b94$var$Cf) throw Error($0b2e6adb871a3b94$var$y(168));
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
function $0b2e6adb871a3b94$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($0b2e6adb871a3b94$var$y(108, $0b2e6adb871a3b94$var$Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function $0b2e6adb871a3b94$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Cf;
    $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$M.current;
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, $0b2e6adb871a3b94$var$N.current);
    return !0;
}
function $0b2e6adb871a3b94$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$y(169));
    c ? (a = $0b2e6adb871a3b94$var$If(a, b, $0b2e6adb871a3b94$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a)) : $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
var $0b2e6adb871a3b94$var$Lf = null, $0b2e6adb871a3b94$var$Mf = null, $0b2e6adb871a3b94$var$Nf = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$Of = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$Pf = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$Qf = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$Rf = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$Sf = $fO90s.unstable_now, $0b2e6adb871a3b94$var$Tf = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$Uf = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$Vf = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$Wf = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Xf = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$Yf = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$Zf = {}, $0b2e6adb871a3b94$var$$f = void 0 !== $0b2e6adb871a3b94$var$Rf ? $0b2e6adb871a3b94$var$Rf : function() {}, $0b2e6adb871a3b94$var$ag = null, $0b2e6adb871a3b94$var$bg = null, $0b2e6adb871a3b94$var$cg = !1, $0b2e6adb871a3b94$var$dg = $0b2e6adb871a3b94$var$Sf(), $0b2e6adb871a3b94$var$O = 1E4 > $0b2e6adb871a3b94$var$dg ? $0b2e6adb871a3b94$var$Sf : function() {
    return $0b2e6adb871a3b94$var$Sf() - $0b2e6adb871a3b94$var$dg;
};
function $0b2e6adb871a3b94$var$eg() {
    switch($0b2e6adb871a3b94$var$Tf()){
        case $0b2e6adb871a3b94$var$Uf:
            return 99;
        case $0b2e6adb871a3b94$var$Vf:
            return 98;
        case $0b2e6adb871a3b94$var$Wf:
            return 97;
        case $0b2e6adb871a3b94$var$Xf:
            return 96;
        case $0b2e6adb871a3b94$var$Yf:
            return 95;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$fg(a) {
    switch(a){
        case 99:
            return $0b2e6adb871a3b94$var$Uf;
        case 98:
            return $0b2e6adb871a3b94$var$Vf;
        case 97:
            return $0b2e6adb871a3b94$var$Wf;
        case 96:
            return $0b2e6adb871a3b94$var$Xf;
        case 95:
            return $0b2e6adb871a3b94$var$Yf;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$gg(a, b) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Nf(a, b);
}
function $0b2e6adb871a3b94$var$hg(a, b, c) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Of(a, b, c);
}
function $0b2e6adb871a3b94$var$ig() {
    if (null !== $0b2e6adb871a3b94$var$bg) {
        var a = $0b2e6adb871a3b94$var$bg;
        $0b2e6adb871a3b94$var$bg = null;
        $0b2e6adb871a3b94$var$Pf(a);
    }
    $0b2e6adb871a3b94$var$jg();
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$cg && null !== $0b2e6adb871a3b94$var$ag) {
        $0b2e6adb871a3b94$var$cg = !0;
        var a = 0;
        try {
            var b = $0b2e6adb871a3b94$var$ag;
            $0b2e6adb871a3b94$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $0b2e6adb871a3b94$var$ag = null;
        } catch (c) {
            throw null !== $0b2e6adb871a3b94$var$ag && ($0b2e6adb871a3b94$var$ag = $0b2e6adb871a3b94$var$ag.slice(a + 1)), $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$ig), c;
        } finally{
            $0b2e6adb871a3b94$var$cg = !1;
        }
    }
}
var $0b2e6adb871a3b94$var$kg = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$Bf(null), $0b2e6adb871a3b94$var$ng = null, $0b2e6adb871a3b94$var$og = null, $0b2e6adb871a3b94$var$pg = null;
function $0b2e6adb871a3b94$var$qg() {
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = null;
}
function $0b2e6adb871a3b94$var$rg(a) {
    var b = $0b2e6adb871a3b94$var$mg.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$mg);
    a.type._context._currentValue = b;
}
function $0b2e6adb871a3b94$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$ng = a;
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$vg(a, b) {
    if ($0b2e6adb871a3b94$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $0b2e6adb871a3b94$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $0b2e6adb871a3b94$var$og) {
            if (null === $0b2e6adb871a3b94$var$ng) throw Error($0b2e6adb871a3b94$var$y(308));
            $0b2e6adb871a3b94$var$og = b;
            $0b2e6adb871a3b94$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$og.next = b;
    }
    return a._currentValue;
}
var $0b2e6adb871a3b94$var$wg = !1;
function $0b2e6adb871a3b94$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $0b2e6adb871a3b94$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $0b2e6adb871a3b94$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $0b2e6adb871a3b94$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$y(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$Fg = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$Hg(), d = $0b2e6adb871a3b94$var$Ig(a), e = $0b2e6adb871a3b94$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $0b2e6adb871a3b94$var$Ag(a, e);
        $0b2e6adb871a3b94$var$Jg(a, d, c);
    }
};
function $0b2e6adb871a3b94$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Je(c, d) || !$0b2e6adb871a3b94$var$Je(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Mg(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$vg(f) : (e = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Ef(a, e) : $0b2e6adb871a3b94$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$Fg;
    $0b2e6adb871a3b94$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$vg(f) : (f = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, e.context = $0b2e6adb871a3b94$var$Ef(a, f));
    $0b2e6adb871a3b94$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $0b2e6adb871a3b94$var$Pg = Array.isArray;
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $0b2e6adb871a3b94$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$y(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$y(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($0b2e6adb871a3b94$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $0b2e6adb871a3b94$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c = $0b2e6adb871a3b94$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Qg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$ta:
                    return b = $0b2e6adb871a3b94$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($0b2e6adb871a3b94$var$Pg(b) || $0b2e6adb871a3b94$var$La(b)) return b = $0b2e6adb871a3b94$var$Xg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c.key === e ? c.type === $0b2e6adb871a3b94$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($0b2e6adb871a3b94$var$Pg(c) || $0b2e6adb871a3b94$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $0b2e6adb871a3b94$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $0b2e6adb871a3b94$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($0b2e6adb871a3b94$var$Pg(d) || $0b2e6adb871a3b94$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$La(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $0b2e6adb871a3b94$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $0b2e6adb871a3b94$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $0b2e6adb871a3b94$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $0b2e6adb871a3b94$var$ua ? (d = $0b2e6adb871a3b94$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $0b2e6adb871a3b94$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $0b2e6adb871a3b94$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($0b2e6adb871a3b94$var$Pg(f)) return x(a, d, f, h);
        if ($0b2e6adb871a3b94$var$La(f)) return w(a, d, f, h);
        l && $0b2e6adb871a3b94$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($0b2e6adb871a3b94$var$y(152, $0b2e6adb871a3b94$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Sg(!0), $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Sg(!1), $0b2e6adb871a3b94$var$$g = {}, $0b2e6adb871a3b94$var$ah = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$bh = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$ch = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g);
function $0b2e6adb871a3b94$var$dh(a) {
    if (a === $0b2e6adb871a3b94$var$$g) throw Error($0b2e6adb871a3b94$var$y(174));
    return a;
}
function $0b2e6adb871a3b94$var$eh(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ch, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, $0b2e6adb871a3b94$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$mb(b, a);
    }
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, b);
}
function $0b2e6adb871a3b94$var$fh() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ch);
}
function $0b2e6adb871a3b94$var$gh(a) {
    $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
    var b = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
    var c = $0b2e6adb871a3b94$var$mb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, c));
}
function $0b2e6adb871a3b94$var$hh(a) {
    $0b2e6adb871a3b94$var$bh.current === a && ($0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh));
}
var $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$Bf(0);
function $0b2e6adb871a3b94$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$jh = null, $0b2e6adb871a3b94$var$kh = null, $0b2e6adb871a3b94$var$lh = !1;
function $0b2e6adb871a3b94$var$mh(a, b) {
    var c = $0b2e6adb871a3b94$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $0b2e6adb871a3b94$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$ph(a) {
    if ($0b2e6adb871a3b94$var$lh) {
        var b = $0b2e6adb871a3b94$var$kh;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$oh(a, b)) {
                b = $0b2e6adb871a3b94$var$rf(c.nextSibling);
                if (!b || !$0b2e6adb871a3b94$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $0b2e6adb871a3b94$var$lh = !1;
                    $0b2e6adb871a3b94$var$jh = a;
                    return;
                }
                $0b2e6adb871a3b94$var$mh($0b2e6adb871a3b94$var$jh, c);
            }
            $0b2e6adb871a3b94$var$jh = a;
            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $0b2e6adb871a3b94$var$lh = !1, $0b2e6adb871a3b94$var$jh = a;
    }
}
function $0b2e6adb871a3b94$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$jh = a;
}
function $0b2e6adb871a3b94$var$rh(a) {
    if (a !== $0b2e6adb871a3b94$var$jh) return !1;
    if (!$0b2e6adb871a3b94$var$lh) return $0b2e6adb871a3b94$var$qh(a), $0b2e6adb871a3b94$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$nf(b, a.memoizedProps)) for(b = $0b2e6adb871a3b94$var$kh; b;)$0b2e6adb871a3b94$var$mh(a, b), b = $0b2e6adb871a3b94$var$rf(b.nextSibling);
    $0b2e6adb871a3b94$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$kh = null;
        }
    } else $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh ? $0b2e6adb871a3b94$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$sh() {
    $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh = null;
    $0b2e6adb871a3b94$var$lh = !1;
}
var $0b2e6adb871a3b94$var$th = [];
function $0b2e6adb871a3b94$var$uh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$th.length; a++)$0b2e6adb871a3b94$var$th[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$th.length = 0;
}
var $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$xh = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$S = null, $0b2e6adb871a3b94$var$T = null, $0b2e6adb871a3b94$var$yh = !1, $0b2e6adb871a3b94$var$zh = !1;
function $0b2e6adb871a3b94$var$Ah() {
    throw Error($0b2e6adb871a3b94$var$y(321));
}
function $0b2e6adb871a3b94$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ch(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$xh = f;
    $0b2e6adb871a3b94$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$vh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Dh : $0b2e6adb871a3b94$var$Eh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$zh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$zh = !1;
            if (!(25 > f)) throw Error($0b2e6adb871a3b94$var$y(301));
            f += 1;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Fh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$zh);
    }
    $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
    b = null !== $0b2e6adb871a3b94$var$S && null !== $0b2e6adb871a3b94$var$S.next;
    $0b2e6adb871a3b94$var$xh = 0;
    $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$yh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$y(300));
    return a;
}
function $0b2e6adb871a3b94$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Ih() {
    if (null === $0b2e6adb871a3b94$var$S) {
        var a = $0b2e6adb871a3b94$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$S.next;
    var b = null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState : $0b2e6adb871a3b94$var$T.next;
    if (null !== b) $0b2e6adb871a3b94$var$T = b, $0b2e6adb871a3b94$var$S = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$y(310));
        $0b2e6adb871a3b94$var$S = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$S.memoizedState,
            baseState: $0b2e6adb871a3b94$var$S.baseState,
            baseQueue: $0b2e6adb871a3b94$var$S.baseQueue,
            queue: $0b2e6adb871a3b94$var$S.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    }
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Kh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($0b2e6adb871a3b94$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $0b2e6adb871a3b94$var$R.lanes |= l;
                $0b2e6adb871a3b94$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Lh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($0b2e6adb871a3b94$var$xh & a) === a) b._workInProgressVersionPrimary = d, $0b2e6adb871a3b94$var$th.push(b);
    if (a) return c(b._source);
    $0b2e6adb871a3b94$var$th.push(b);
    throw Error($0b2e6adb871a3b94$var$y(350));
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$U;
    if (null === e) throw Error($0b2e6adb871a3b94$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $0b2e6adb871a3b94$var$vh.current, k = h.useState(function() {
        return $0b2e6adb871a3b94$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $0b2e6adb871a3b94$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $0b2e6adb871a3b94$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$0b2e6adb871a3b94$var$He(g, a)) {
            a = c(b._source);
            $0b2e6adb871a3b94$var$He(n, a) || (l(a), a = $0b2e6adb871a3b94$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $0b2e6adb871a3b94$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $0b2e6adb871a3b94$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $0b2e6adb871a3b94$var$He(C, c) && $0b2e6adb871a3b94$var$He(x, b) && $0b2e6adb871a3b94$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a), k.queue = a, k.baseQueue = null, n = $0b2e6adb871a3b94$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $0b2e6adb871a3b94$var$Ph(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Ih();
    return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
}
function $0b2e6adb871a3b94$var$Qh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $0b2e6adb871a3b94$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$Sh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $0b2e6adb871a3b94$var$Th() {
    return $0b2e6adb871a3b94$var$Ih().memoizedState;
}
function $0b2e6adb871a3b94$var$Uh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Hh();
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$Vh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$S) {
        var g = $0b2e6adb871a3b94$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Bh(d, g.deps)) {
            $0b2e6adb871a3b94$var$Rh(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    return $0b2e6adb871a3b94$var$Uh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Xh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Yh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$Vh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ai() {}
function $0b2e6adb871a3b94$var$bi(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ci(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$di(a, b) {
    var c = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $0b2e6adb871a3b94$var$gg(97 < c ? 97 : c, function() {
        var c = $0b2e6adb871a3b94$var$wh.transition;
        $0b2e6adb871a3b94$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $0b2e6adb871a3b94$var$wh.transition = c;
        }
    });
}
function $0b2e6adb871a3b94$var$Oh(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $0b2e6adb871a3b94$var$R || null !== g && g === $0b2e6adb871a3b94$var$R) $0b2e6adb871a3b94$var$zh = $0b2e6adb871a3b94$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($0b2e6adb871a3b94$var$He(k, h)) return;
        } catch (l) {} finally{}
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    }
}
var $0b2e6adb871a3b94$var$Gh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$Ah,
    useContext: $0b2e6adb871a3b94$var$Ah,
    useEffect: $0b2e6adb871a3b94$var$Ah,
    useImperativeHandle: $0b2e6adb871a3b94$var$Ah,
    useLayoutEffect: $0b2e6adb871a3b94$var$Ah,
    useMemo: $0b2e6adb871a3b94$var$Ah,
    useReducer: $0b2e6adb871a3b94$var$Ah,
    useRef: $0b2e6adb871a3b94$var$Ah,
    useState: $0b2e6adb871a3b94$var$Ah,
    useDebugValue: $0b2e6adb871a3b94$var$Ah,
    useDeferredValue: $0b2e6adb871a3b94$var$Ah,
    useTransition: $0b2e6adb871a3b94$var$Ah,
    useMutableSource: $0b2e6adb871a3b94$var$Ah,
    useOpaqueIdentifier: $0b2e6adb871a3b94$var$Ah,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Dh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$Uh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $0b2e6adb871a3b94$var$Sh,
    useState: $0b2e6adb871a3b94$var$Qh,
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Qh(a), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Wh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Qh(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$di.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($0b2e6adb871a3b94$var$lh) {
            var a = !1, b = $0b2e6adb871a3b94$var$uf(function() {
                a || (a = !0, c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36)));
                throw Error($0b2e6adb871a3b94$var$y(355));
            }), c = $0b2e6adb871a3b94$var$Qh(b)[1];
            0 === ($0b2e6adb871a3b94$var$R.mode & 2) && ($0b2e6adb871a3b94$var$R.flags |= 516, $0b2e6adb871a3b94$var$Rh(5, function() {
                c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($0b2e6adb871a3b94$var$tf++).toString(36);
        $0b2e6adb871a3b94$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Eh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Kh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Fh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Lh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$ei = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$ug = !1;
function $0b2e6adb871a3b94$var$fi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Zg(b, null, c, d) : $0b2e6adb871a3b94$var$Yg(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$tg(b, e);
    d = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$0b2e6adb871a3b94$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $0b2e6adb871a3b94$var$ki(a, b, g, d, e, f);
        a = $0b2e6adb871a3b94$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $0b2e6adb871a3b94$var$Je, c(e, d) && a.ref === b.ref)) return $0b2e6adb871a3b94$var$hi(a, b, f);
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d, e, f) {
    if (null !== a && $0b2e6adb871a3b94$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($0b2e6adb871a3b94$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($0b2e6adb871a3b94$var$ug = !0);
        else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$hi(a, b, f);
    }
    return $0b2e6adb871a3b94$var$li(a, b, c, d, f);
}
function $0b2e6adb871a3b94$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $0b2e6adb871a3b94$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$ni(b, d);
    $0b2e6adb871a3b94$var$fi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $0b2e6adb871a3b94$var$li(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current;
    f = $0b2e6adb871a3b94$var$Ef(b, f);
    $0b2e6adb871a3b94$var$tg(b, e);
    c = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$pi(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Ff(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$Jf(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $0b2e6adb871a3b94$var$Mg(b, c, d), $0b2e6adb871a3b94$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$vg(l) : (l = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, l = $0b2e6adb871a3b94$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Ng(b, g, d, l);
        $0b2e6adb871a3b94$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof n && ($0b2e6adb871a3b94$var$Gg(b, c, n, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$vg(k) : (k = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, k = $0b2e6adb871a3b94$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $0b2e6adb871a3b94$var$Ng(b, g, d, k);
        $0b2e6adb871a3b94$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof C && ($0b2e6adb871a3b94$var$Gg(b, c, C, d), x = b.memoizedState), (l = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $0b2e6adb871a3b94$var$qi(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$qi(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$Kf(b, c, !1), $0b2e6adb871a3b94$var$hi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Yg(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Yg(b, null, h, f)) : $0b2e6adb871a3b94$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$Kf(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$Hf(a, b.context, !1);
    $0b2e6adb871a3b94$var$eh(a, b.containerInfo);
}
var $0b2e6adb871a3b94$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$ti(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $0b2e6adb871a3b94$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, b.lanes = 33554432, a;
        c = $0b2e6adb871a3b94$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
        c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
    c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $0b2e6adb871a3b94$var$vi(b, e, 0, null);
    c = $0b2e6adb871a3b94$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $0b2e6adb871a3b94$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $0b2e6adb871a3b94$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $0b2e6adb871a3b94$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $0b2e6adb871a3b94$var$Tg(g, h);
    null !== a ? d = $0b2e6adb871a3b94$var$Tg(a, d) : (d = $0b2e6adb871a3b94$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $0b2e6adb871a3b94$var$sg(a.return, b);
}
function $0b2e6adb871a3b94$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $0b2e6adb871a3b94$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$fi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$yi(a, c);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $0b2e6adb871a3b94$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Bi, $0b2e6adb871a3b94$var$Ci, $0b2e6adb871a3b94$var$Di, $0b2e6adb871a3b94$var$Ei;
$0b2e6adb871a3b94$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Ci = function() {};
$0b2e6adb871a3b94$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $0b2e6adb871a3b94$var$eb(a, e);
                d = $0b2e6adb871a3b94$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
        }
        $0b2e6adb871a3b94$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Fi(a, b) {
    if (!$0b2e6adb871a3b94$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $0b2e6adb871a3b94$var$Ci(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$hh(b);
            var e = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                    return null;
                }
                a = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                if ($0b2e6adb871a3b94$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$wf] = b;
                    d[$0b2e6adb871a3b94$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", d);
                            $0b2e6adb871a3b94$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $0b2e6adb871a3b94$var$Xe.length; a++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[a], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", d);
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$G("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $0b2e6adb871a3b94$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $0b2e6adb871a3b94$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $0b2e6adb871a3b94$var$kb.html && (a = $0b2e6adb871a3b94$var$lb(c));
                    a === $0b2e6adb871a3b94$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$wf] = b;
                    a[$0b2e6adb871a3b94$var$xf] = d;
                    $0b2e6adb871a3b94$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $0b2e6adb871a3b94$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", a);
                            $0b2e6adb871a3b94$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$Xe.length; e++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", a);
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(a, d);
                            e = $0b2e6adb871a3b94$var$Ya(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "option":
                            e = $0b2e6adb871a3b94$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(a, d);
                            e = $0b2e6adb871a3b94$var$gb(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $0b2e6adb871a3b94$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $0b2e6adb871a3b94$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$pb(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$G("scroll", a) : null != k && $0b2e6adb871a3b94$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    $0b2e6adb871a3b94$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                c = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
                $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                $0b2e6adb871a3b94$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$0b2e6adb871a3b94$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $0b2e6adb871a3b94$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($0b2e6adb871a3b94$var$P.current & 1)) 0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 3);
                else {
                    if (0 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V) $0b2e6adb871a3b94$var$V = 4;
                    null === $0b2e6adb871a3b94$var$U || 0 === ($0b2e6adb871a3b94$var$Dg & 134217727) && 0 === ($0b2e6adb871a3b94$var$Hi & 134217727) || $0b2e6adb871a3b94$var$Ii($0b2e6adb871a3b94$var$U, $0b2e6adb871a3b94$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), $0b2e6adb871a3b94$var$Ci(b), null === a && $0b2e6adb871a3b94$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 19:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $0b2e6adb871a3b94$var$Fi(d, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $0b2e6adb871a3b94$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $0b2e6adb871a3b94$var$O() > $0b2e6adb871a3b94$var$Ji && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $0b2e6adb871a3b94$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $0b2e6adb871a3b94$var$O() - d.renderingStartTime > $0b2e6adb871a3b94$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $0b2e6adb871a3b94$var$O(), c.sibling = null, b = $0b2e6adb871a3b94$var$P.current, $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
}
function $0b2e6adb871a3b94$var$Li(a) {
    switch(a.tag){
        case 1:
            $0b2e6adb871a3b94$var$Ff(a.type) && $0b2e6adb871a3b94$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($0b2e6adb871a3b94$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $0b2e6adb871a3b94$var$hh(a), null;
        case 13:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(a), null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $0b2e6adb871a3b94$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Pi(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Qi || ($0b2e6adb871a3b94$var$Qi = !0, $0b2e6adb871a3b94$var$Ri = d);
        $0b2e6adb871a3b94$var$Ni(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $0b2e6adb871a3b94$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ti ? $0b2e6adb871a3b94$var$Ti = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ti.add(this), $0b2e6adb871a3b94$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $0b2e6adb871a3b94$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $0b2e6adb871a3b94$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $0b2e6adb871a3b94$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $0b2e6adb871a3b94$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $0b2e6adb871a3b94$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $0b2e6adb871a3b94$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($0b2e6adb871a3b94$var$Zi(c, a), $0b2e6adb871a3b94$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $0b2e6adb871a3b94$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $0b2e6adb871a3b94$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $0b2e6adb871a3b94$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $0b2e6adb871a3b94$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $0b2e6adb871a3b94$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $0b2e6adb871a3b94$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$bj(a, b) {
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount($0b2e6adb871a3b94$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $0b2e6adb871a3b94$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $0b2e6adb871a3b94$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $0b2e6adb871a3b94$var$Wi(b, f);
            }
            break;
        case 5:
            $0b2e6adb871a3b94$var$Vi(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$cj(a, b);
    }
}
function $0b2e6adb871a3b94$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($0b2e6adb871a3b94$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($0b2e6adb871a3b94$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$y(161));
    }
    c.flags & 16 && ($0b2e6adb871a3b94$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $0b2e6adb871a3b94$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $0b2e6adb871a3b94$var$gj(a, c, b) : $0b2e6adb871a3b94$var$hj(a, c, b);
}
function $0b2e6adb871a3b94$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($0b2e6adb871a3b94$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($0b2e6adb871a3b94$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($0b2e6adb871a3b94$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$0b2e6adb871a3b94$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $0b2e6adb871a3b94$var$$a(c, d);
                    $0b2e6adb871a3b94$var$wb(a, e);
                    b = $0b2e6adb871a3b94$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $0b2e6adb871a3b94$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $0b2e6adb871a3b94$var$ob(c, h) : "children" === g ? $0b2e6adb871a3b94$var$pb(c, h) : $0b2e6adb871a3b94$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $0b2e6adb871a3b94$var$ab(c, d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $0b2e6adb871a3b94$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($0b2e6adb871a3b94$var$jj = $0b2e6adb871a3b94$var$O(), $0b2e6adb871a3b94$var$aj(b.child, !0));
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 19:
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $0b2e6adb871a3b94$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Ui);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $0b2e6adb871a3b94$var$nj = Math.ceil, $0b2e6adb871a3b94$var$oj = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$pj = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$X = 0, $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$W = 0, $0b2e6adb871a3b94$var$qj = 0, $0b2e6adb871a3b94$var$rj = $0b2e6adb871a3b94$var$Bf(0), $0b2e6adb871a3b94$var$V = 0, $0b2e6adb871a3b94$var$sj = null, $0b2e6adb871a3b94$var$tj = 0, $0b2e6adb871a3b94$var$Dg = 0, $0b2e6adb871a3b94$var$Hi = 0, $0b2e6adb871a3b94$var$uj = 0, $0b2e6adb871a3b94$var$vj = null, $0b2e6adb871a3b94$var$jj = 0, $0b2e6adb871a3b94$var$Ji = Infinity;
function $0b2e6adb871a3b94$var$wj() {
    $0b2e6adb871a3b94$var$Ji = $0b2e6adb871a3b94$var$O() + 500;
}
var $0b2e6adb871a3b94$var$Z = null, $0b2e6adb871a3b94$var$Qi = !1, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$Ti = null, $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = null, $0b2e6adb871a3b94$var$zj = 90, $0b2e6adb871a3b94$var$Aj = [], $0b2e6adb871a3b94$var$Bj = [], $0b2e6adb871a3b94$var$Cj = null, $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, $0b2e6adb871a3b94$var$Fj = -1, $0b2e6adb871a3b94$var$Gj = 0, $0b2e6adb871a3b94$var$Hj = 0, $0b2e6adb871a3b94$var$Ij = null, $0b2e6adb871a3b94$var$Jj = !1;
function $0b2e6adb871a3b94$var$Hg() {
    return 0 !== ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$O() : -1 !== $0b2e6adb871a3b94$var$Fj ? $0b2e6adb871a3b94$var$Fj : $0b2e6adb871a3b94$var$Fj = $0b2e6adb871a3b94$var$O();
}
function $0b2e6adb871a3b94$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2;
    0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj);
    if (0 !== $0b2e6adb871a3b94$var$kg.transition) {
        0 !== $0b2e6adb871a3b94$var$Hj && ($0b2e6adb871a3b94$var$Hj = null !== $0b2e6adb871a3b94$var$vj ? $0b2e6adb871a3b94$var$vj.pendingLanes : 0);
        a = $0b2e6adb871a3b94$var$Gj;
        var b = 4186112 & ~$0b2e6adb871a3b94$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $0b2e6adb871a3b94$var$eg();
    0 !== ($0b2e6adb871a3b94$var$X & 4) && 98 === a ? a = $0b2e6adb871a3b94$var$Xc(12, $0b2e6adb871a3b94$var$Gj) : (a = $0b2e6adb871a3b94$var$Sc(a), a = $0b2e6adb871a3b94$var$Xc(a, $0b2e6adb871a3b94$var$Gj));
    return a;
}
function $0b2e6adb871a3b94$var$Jg(a, b, c) {
    if (50 < $0b2e6adb871a3b94$var$Dj) throw $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, Error($0b2e6adb871a3b94$var$y(185));
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    if (null === a) return null;
    $0b2e6adb871a3b94$var$$c(a, b, c);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Hi |= b, 4 === $0b2e6adb871a3b94$var$V && $0b2e6adb871a3b94$var$Ii(a, $0b2e6adb871a3b94$var$W));
    var d = $0b2e6adb871a3b94$var$eg();
    1 === b ? 0 !== ($0b2e6adb871a3b94$var$X & 8) && 0 === ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$Lj(a) : ($0b2e6adb871a3b94$var$Mj(a, c), 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig())) : (0 === ($0b2e6adb871a3b94$var$X & 4) || 98 !== d && 99 !== d || (null === $0b2e6adb871a3b94$var$Cj ? $0b2e6adb871a3b94$var$Cj = new Set([
        a
    ]) : $0b2e6adb871a3b94$var$Cj.add(a)), $0b2e6adb871a3b94$var$Mj(a, c));
    $0b2e6adb871a3b94$var$vj = a;
}
function $0b2e6adb871a3b94$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $0b2e6adb871a3b94$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $0b2e6adb871a3b94$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $0b2e6adb871a3b94$var$Rc(k);
                var n = $0b2e6adb871a3b94$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    b = $0b2e6adb871a3b94$var$F;
    if (0 === d) null !== c && (c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c);
        }
        15 === b ? (c = $0b2e6adb871a3b94$var$Lj.bind(null, a), null === $0b2e6adb871a3b94$var$ag ? ($0b2e6adb871a3b94$var$ag = [
            c
        ], $0b2e6adb871a3b94$var$bg = $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$jg)) : $0b2e6adb871a3b94$var$ag.push(c), c = $0b2e6adb871a3b94$var$Zf) : 14 === b ? c = $0b2e6adb871a3b94$var$hg(99, $0b2e6adb871a3b94$var$Lj.bind(null, a)) : (c = $0b2e6adb871a3b94$var$Tc(b), c = $0b2e6adb871a3b94$var$hg(c, $0b2e6adb871a3b94$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Nj(a) {
    $0b2e6adb871a3b94$var$Fj = -1;
    $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$Gj = 0;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var b = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Oj() && a.callbackNode !== b) return null;
    var c = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var f = $0b2e6adb871a3b94$var$Pj();
    if ($0b2e6adb871a3b94$var$U !== a || $0b2e6adb871a3b94$var$W !== d) $0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$Qj(a, d);
    for(;;)try {
        $0b2e6adb871a3b94$var$Rj();
        break;
    } catch (h) {
        $0b2e6adb871a3b94$var$Sj(a, h);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$oj.current = f;
    $0b2e6adb871a3b94$var$X = e;
    null !== $0b2e6adb871a3b94$var$Y ? d = 0 : ($0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0, d = $0b2e6adb871a3b94$var$V);
    if (0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi)) $0b2e6adb871a3b94$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), c = $0b2e6adb871a3b94$var$Wc(a), 0 !== c && (d = $0b2e6adb871a3b94$var$Tj(a, c)));
        if (1 === d) throw b = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, c), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($0b2e6adb871a3b94$var$y(345));
            case 2:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 3:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $0b2e6adb871a3b94$var$jj + 500 - $0b2e6adb871a3b94$var$O(), 10 < d)) {
                    if (0 !== $0b2e6adb871a3b94$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $0b2e6adb871a3b94$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), d);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $0b2e6adb871a3b94$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $0b2e6adb871a3b94$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $0b2e6adb871a3b94$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), c);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 5:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            default:
                throw Error($0b2e6adb871a3b94$var$y(329));
        }
    }
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return a.callbackNode === b ? $0b2e6adb871a3b94$var$Nj.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    b &= ~$0b2e6adb871a3b94$var$uj;
    b &= ~$0b2e6adb871a3b94$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Lj(a) {
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    $0b2e6adb871a3b94$var$Oj();
    if (a === $0b2e6adb871a3b94$var$U && 0 !== (a.expiredLanes & $0b2e6adb871a3b94$var$W)) {
        var b = $0b2e6adb871a3b94$var$W;
        var c = $0b2e6adb871a3b94$var$Tj(a, b);
        0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi) && (b = $0b2e6adb871a3b94$var$Uc(a, b), c = $0b2e6adb871a3b94$var$Tj(a, b));
    } else b = $0b2e6adb871a3b94$var$Uc(a, 0), c = $0b2e6adb871a3b94$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), b = $0b2e6adb871a3b94$var$Wc(a), 0 !== b && (c = $0b2e6adb871a3b94$var$Tj(a, b)));
    if (1 === c) throw c = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, b), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Uj(a);
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return null;
}
function $0b2e6adb871a3b94$var$Vj() {
    if (null !== $0b2e6adb871a3b94$var$Cj) {
        var a = $0b2e6adb871a3b94$var$Cj;
        $0b2e6adb871a3b94$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
        });
    }
    $0b2e6adb871a3b94$var$ig();
}
function $0b2e6adb871a3b94$var$Wj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$Xj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X &= -2;
    $0b2e6adb871a3b94$var$X |= 8;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$rj, $0b2e6adb871a3b94$var$qj);
    $0b2e6adb871a3b94$var$qj |= b;
    $0b2e6adb871a3b94$var$tj |= b;
}
function $0b2e6adb871a3b94$var$Ki() {
    $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$rj.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$rj);
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$pf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$Gf();
                break;
            case 3:
                $0b2e6adb871a3b94$var$fh();
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
                $0b2e6adb871a3b94$var$uh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$hh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$fh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 19:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 10:
                $0b2e6adb871a3b94$var$rg(d);
                break;
            case 23:
            case 24:
                $0b2e6adb871a3b94$var$Ki();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$U = a;
    $0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Tg(a.current, null);
    $0b2e6adb871a3b94$var$W = $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$tj = b;
    $0b2e6adb871a3b94$var$V = 0;
    $0b2e6adb871a3b94$var$sj = null;
    $0b2e6adb871a3b94$var$uj = $0b2e6adb871a3b94$var$Hi = $0b2e6adb871a3b94$var$Dg = 0;
}
function $0b2e6adb871a3b94$var$Sj(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$qg();
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
            if ($0b2e6adb871a3b94$var$yh) {
                for(var d = $0b2e6adb871a3b94$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$yh = !1;
            }
            $0b2e6adb871a3b94$var$xh = 0;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
            $0b2e6adb871a3b94$var$zh = !1;
            $0b2e6adb871a3b94$var$pj.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$V = 1;
                $0b2e6adb871a3b94$var$sj = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($0b2e6adb871a3b94$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $0b2e6adb871a3b94$var$zg(-1, 1);
                                        t.tag = 2;
                                        $0b2e6adb871a3b94$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $0b2e6adb871a3b94$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $0b2e6adb871a3b94$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($0b2e6adb871a3b94$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 2);
                k = $0b2e6adb871a3b94$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $0b2e6adb871a3b94$var$Pi(p, f, b);
                            $0b2e6adb871a3b94$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $0b2e6adb871a3b94$var$Si(p, f, b);
                                $0b2e6adb871a3b94$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $0b2e6adb871a3b94$var$Zj(c);
        } catch (va) {
            b = va;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Pj() {
    var a = $0b2e6adb871a3b94$var$oj.current;
    $0b2e6adb871a3b94$var$oj.current = $0b2e6adb871a3b94$var$Gh;
    return null === a ? $0b2e6adb871a3b94$var$Gh : a;
}
function $0b2e6adb871a3b94$var$Tj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var d = $0b2e6adb871a3b94$var$Pj();
    $0b2e6adb871a3b94$var$U === a && $0b2e6adb871a3b94$var$W === b || $0b2e6adb871a3b94$var$Qj(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$ak();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Sj(a, e);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$X = c;
    $0b2e6adb871a3b94$var$oj.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$y(261));
    $0b2e6adb871a3b94$var$U = null;
    $0b2e6adb871a3b94$var$W = 0;
    return $0b2e6adb871a3b94$var$V;
}
function $0b2e6adb871a3b94$var$ak() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Rj() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$Qf();)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = $0b2e6adb871a3b94$var$ck(a.alternate, a, $0b2e6adb871a3b94$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Zj(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$pj.current = null;
}
function $0b2e6adb871a3b94$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $0b2e6adb871a3b94$var$Gi(c, b, $0b2e6adb871a3b94$var$qj);
            if (null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($0b2e6adb871a3b94$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $0b2e6adb871a3b94$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 5);
}
function $0b2e6adb871a3b94$var$Uj(a) {
    var b = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(99, $0b2e6adb871a3b94$var$dk.bind(null, a, b));
    return null;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    do $0b2e6adb871a3b94$var$Oj();
    while (null !== $0b2e6adb871a3b94$var$yj);
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $0b2e6adb871a3b94$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $0b2e6adb871a3b94$var$Cj && 0 === (d & 24) && $0b2e6adb871a3b94$var$Cj.has(a) && $0b2e6adb871a3b94$var$Cj.delete(a);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $0b2e6adb871a3b94$var$X;
        $0b2e6adb871a3b94$var$X |= 32;
        $0b2e6adb871a3b94$var$pj.current = null;
        $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$fd;
        g = $0b2e6adb871a3b94$var$Ne();
        if ($0b2e6adb871a3b94$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $0b2e6adb871a3b94$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $0b2e6adb871a3b94$var$fd = !1;
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Jj = !1;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            $0b2e6adb871a3b94$var$ek();
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(g = a; null !== $0b2e6adb871a3b94$var$Z;){
                var t = $0b2e6adb871a3b94$var$Z.flags;
                t & 16 && $0b2e6adb871a3b94$var$pb($0b2e6adb871a3b94$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $0b2e6adb871a3b94$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        break;
                    case 6:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 1024:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 4:
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 8:
                        h = $0b2e6adb871a3b94$var$Z;
                        $0b2e6adb871a3b94$var$cj(g, h);
                        var J = h.alternate;
                        $0b2e6adb871a3b94$var$dj(h);
                        null !== J && $0b2e6adb871a3b94$var$dj(J);
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        v = $0b2e6adb871a3b94$var$lf;
        q = $0b2e6adb871a3b94$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $0b2e6adb871a3b94$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $0b2e6adb871a3b94$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $0b2e6adb871a3b94$var$Le(t, J), f = $0b2e6adb871a3b94$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $0b2e6adb871a3b94$var$fd = !!$0b2e6adb871a3b94$var$kf;
        $0b2e6adb871a3b94$var$lf = $0b2e6adb871a3b94$var$kf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(t = a; null !== $0b2e6adb871a3b94$var$Z;){
                var K = $0b2e6adb871a3b94$var$Z.flags;
                K & 36 && $0b2e6adb871a3b94$var$Yi(t, $0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $0b2e6adb871a3b94$var$Z.ref;
                    if (null !== Q) {
                        var L = $0b2e6adb871a3b94$var$Z.stateNode;
                        switch($0b2e6adb871a3b94$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Z = null;
        $0b2e6adb871a3b94$var$$f();
        $0b2e6adb871a3b94$var$X = e;
    } else a.current = c;
    if ($0b2e6adb871a3b94$var$xj) $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = a, $0b2e6adb871a3b94$var$zj = b;
    else for($0b2e6adb871a3b94$var$Z = d; null !== $0b2e6adb871a3b94$var$Z;)b = $0b2e6adb871a3b94$var$Z.nextEffect, $0b2e6adb871a3b94$var$Z.nextEffect = null, $0b2e6adb871a3b94$var$Z.flags & 8 && (K = $0b2e6adb871a3b94$var$Z, K.sibling = null, K.stateNode = null), $0b2e6adb871a3b94$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($0b2e6adb871a3b94$var$Ti = null);
    1 === d ? a === $0b2e6adb871a3b94$var$Ej ? $0b2e6adb871a3b94$var$Dj++ : ($0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = a) : $0b2e6adb871a3b94$var$Dj = 0;
    c = c.stateNode;
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot($0b2e6adb871a3b94$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    if ($0b2e6adb871a3b94$var$Qi) throw $0b2e6adb871a3b94$var$Qi = !1, a = $0b2e6adb871a3b94$var$Ri, $0b2e6adb871a3b94$var$Ri = null, a;
    if (0 !== ($0b2e6adb871a3b94$var$X & 8)) return null;
    $0b2e6adb871a3b94$var$ig();
    return null;
}
function $0b2e6adb871a3b94$var$ek() {
    for(; null !== $0b2e6adb871a3b94$var$Z;){
        var a = $0b2e6adb871a3b94$var$Z.alternate;
        $0b2e6adb871a3b94$var$Jj || null === $0b2e6adb871a3b94$var$Ij || (0 !== ($0b2e6adb871a3b94$var$Z.flags & 8) ? $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0) : 13 === $0b2e6adb871a3b94$var$Z.tag && $0b2e6adb871a3b94$var$mj(a, $0b2e6adb871a3b94$var$Z) && $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0));
        var b = $0b2e6adb871a3b94$var$Z.flags;
        0 !== (b & 256) && $0b2e6adb871a3b94$var$Xi(a, $0b2e6adb871a3b94$var$Z);
        0 === (b & 512) || $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
            $0b2e6adb871a3b94$var$Oj();
            return null;
        }));
        $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
    }
}
function $0b2e6adb871a3b94$var$Oj() {
    if (90 !== $0b2e6adb871a3b94$var$zj) {
        var a = 97 < $0b2e6adb871a3b94$var$zj ? 97 : $0b2e6adb871a3b94$var$zj;
        $0b2e6adb871a3b94$var$zj = 90;
        return $0b2e6adb871a3b94$var$gg(a, $0b2e6adb871a3b94$var$fk);
    }
    return !1;
}
function $0b2e6adb871a3b94$var$$i(a, b) {
    $0b2e6adb871a3b94$var$Aj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$Zi(a, b) {
    $0b2e6adb871a3b94$var$Bj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$fk() {
    if (null === $0b2e6adb871a3b94$var$yj) return !1;
    var a = $0b2e6adb871a3b94$var$yj;
    $0b2e6adb871a3b94$var$yj = null;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(331));
    var b = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 32;
    var c = $0b2e6adb871a3b94$var$Bj;
    $0b2e6adb871a3b94$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    c = $0b2e6adb871a3b94$var$Aj;
    $0b2e6adb871a3b94$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $0b2e6adb871a3b94$var$X = b;
    $0b2e6adb871a3b94$var$ig();
    return !0;
}
function $0b2e6adb871a3b94$var$gk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Mi(c, b);
    b = $0b2e6adb871a3b94$var$Pi(a, b, 1);
    $0b2e6adb871a3b94$var$Ag(a, b);
    b = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, 1);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, 1, b), $0b2e6adb871a3b94$var$Mj(a, b));
}
function $0b2e6adb871a3b94$var$Wi(a, b) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $0b2e6adb871a3b94$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) {
                a = $0b2e6adb871a3b94$var$Mi(b, a);
                var e = $0b2e6adb871a3b94$var$Si(c, a, 1);
                $0b2e6adb871a3b94$var$Ag(c, e);
                e = $0b2e6adb871a3b94$var$Hg();
                c = $0b2e6adb871a3b94$var$Kj(c, 1);
                if (null !== c) $0b2e6adb871a3b94$var$$c(c, 1, e), $0b2e6adb871a3b94$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$U === a && ($0b2e6adb871a3b94$var$W & c) === c && (4 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$W & 62914560) === $0b2e6adb871a3b94$var$W && 500 > $0b2e6adb871a3b94$var$O() - $0b2e6adb871a3b94$var$jj ? $0b2e6adb871a3b94$var$Qj(a, 0) : $0b2e6adb871a3b94$var$uj |= c);
    $0b2e6adb871a3b94$var$Mj(a, b);
}
function $0b2e6adb871a3b94$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2 : (0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj), b = $0b2e6adb871a3b94$var$Yc(62914560 & ~$0b2e6adb871a3b94$var$Gj), 0 === b && (b = 4194304)));
    c = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, b, c), $0b2e6adb871a3b94$var$Mj(a, c));
}
var $0b2e6adb871a3b94$var$ck;
$0b2e6adb871a3b94$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$N.current) $0b2e6adb871a3b94$var$ug = !0;
        else if (0 !== (c & d)) $0b2e6adb871a3b94$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $0b2e6adb871a3b94$var$ug = !1;
            switch(b.tag){
                case 3:
                    $0b2e6adb871a3b94$var$ri(b);
                    $0b2e6adb871a3b94$var$sh();
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$gh(b);
                    break;
                case 1:
                    $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Jf(b);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$ti(a, b, c);
                        $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                        b = $0b2e6adb871a3b94$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $0b2e6adb871a3b94$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $0b2e6adb871a3b94$var$mi(a, b, c);
            }
            return $0b2e6adb871a3b94$var$hi(a, b, c);
        }
    } else $0b2e6adb871a3b94$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $0b2e6adb871a3b94$var$Ef(b, $0b2e6adb871a3b94$var$M.current);
            $0b2e6adb871a3b94$var$tg(b, c);
            e = $0b2e6adb871a3b94$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($0b2e6adb871a3b94$var$Ff(d)) {
                    var f = !0;
                    $0b2e6adb871a3b94$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $0b2e6adb871a3b94$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $0b2e6adb871a3b94$var$Gg(b, d, g, a);
                e.updater = $0b2e6adb871a3b94$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $0b2e6adb871a3b94$var$Og(b, d, a, c);
                b = $0b2e6adb871a3b94$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $0b2e6adb871a3b94$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $0b2e6adb871a3b94$var$hk(e);
                a = $0b2e6adb871a3b94$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $0b2e6adb871a3b94$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$ii(null, b, e, $0b2e6adb871a3b94$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$pi(a, b, d, e, c);
        case 3:
            $0b2e6adb871a3b94$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($0b2e6adb871a3b94$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $0b2e6adb871a3b94$var$yg(a, b);
            $0b2e6adb871a3b94$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $0b2e6adb871a3b94$var$sh(), b = $0b2e6adb871a3b94$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$jh = b, f = $0b2e6adb871a3b94$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $0b2e6adb871a3b94$var$th.push(f);
                    c = $0b2e6adb871a3b94$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $0b2e6adb871a3b94$var$fi(a, b, d, c), $0b2e6adb871a3b94$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$gh(b), null === a && $0b2e6adb871a3b94$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$nf(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$nf(d, f) && (b.flags |= 16), $0b2e6adb871a3b94$var$oi(a, b), $0b2e6adb871a3b94$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$ph(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$ti(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Yg(b, null, d, c) : $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$gi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $0b2e6adb871a3b94$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$0b2e6adb871a3b94$var$N.current) {
                            b = $0b2e6adb871a3b94$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $0b2e6adb871a3b94$var$zg(-1, c & -c), l.tag = 2, $0b2e6adb871a3b94$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $0b2e6adb871a3b94$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $0b2e6adb871a3b94$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $0b2e6adb871a3b94$var$tg(b, c), e = $0b2e6adb871a3b94$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $0b2e6adb871a3b94$var$lg(e, b.pendingProps), f = $0b2e6adb871a3b94$var$lg(e.type, f), $0b2e6adb871a3b94$var$ii(a, b, e, f, d, c);
        case 15:
            return $0b2e6adb871a3b94$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $0b2e6adb871a3b94$var$Ff(d) ? (a = !0, $0b2e6adb871a3b94$var$Jf(b)) : a = !1, $0b2e6adb871a3b94$var$tg(b, c), $0b2e6adb871a3b94$var$Mg(b, d, e), $0b2e6adb871a3b94$var$Og(b, d, e, c), $0b2e6adb871a3b94$var$qi(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$Ai(a, b, c);
        case 23:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
        case 24:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
};
function $0b2e6adb871a3b94$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$nh(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$ik(a, b, c, d);
}
function $0b2e6adb871a3b94$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$hk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Aa) return 11;
        if (a === $0b2e6adb871a3b94$var$Da) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return $0b2e6adb871a3b94$var$Xg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $0b2e6adb871a3b94$var$wa:
            g = 8;
            e |= 1;
            break;
        case $0b2e6adb871a3b94$var$xa:
            return a = $0b2e6adb871a3b94$var$nh(12, c, b, e | 8), a.elementType = $0b2e6adb871a3b94$var$xa, a.type = $0b2e6adb871a3b94$var$xa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ba:
            return a = $0b2e6adb871a3b94$var$nh(13, c, b, e), a.type = $0b2e6adb871a3b94$var$Ba, a.elementType = $0b2e6adb871a3b94$var$Ba, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ca:
            return a = $0b2e6adb871a3b94$var$nh(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ca, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$vi(c, e, f, b);
        case $0b2e6adb871a3b94$var$Ja:
            return a = $0b2e6adb871a3b94$var$nh(24, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$ya:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$za:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Aa:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $0b2e6adb871a3b94$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Xg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$vi(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(23, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Ug(a, b, c) {
    a = $0b2e6adb871a3b94$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Wg(a, b, c) {
    b = $0b2e6adb871a3b94$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$Zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$lk(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$Hg(), g = $0b2e6adb871a3b94$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($0b2e6adb871a3b94$var$Zb(c) !== c || 1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($0b2e6adb871a3b94$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($0b2e6adb871a3b94$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($0b2e6adb871a3b94$var$Ff(k)) {
                c = $0b2e6adb871a3b94$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $0b2e6adb871a3b94$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $0b2e6adb871a3b94$var$Ag(e, b);
    $0b2e6adb871a3b94$var$Jg(e, g, f);
    return g;
}
function $0b2e6adb871a3b94$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$ok(a, b) {
    $0b2e6adb871a3b94$var$nk(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$nk(a, b);
}
function $0b2e6adb871a3b94$var$pk() {
    return null;
}
function $0b2e6adb871a3b94$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $0b2e6adb871a3b94$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $0b2e6adb871a3b94$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $0b2e6adb871a3b94$var$xg(b);
    a[$0b2e6adb871a3b94$var$ff] = c.current;
    $0b2e6adb871a3b94$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$0b2e6adb871a3b94$var$qk.prototype.render = function(a) {
    $0b2e6adb871a3b94$var$lk(a, this._internalRoot, null, null);
};
$0b2e6adb871a3b94$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $0b2e6adb871a3b94$var$lk(null, a, null, function() {
        b[$0b2e6adb871a3b94$var$ff] = null;
    });
};
function $0b2e6adb871a3b94$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $0b2e6adb871a3b94$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $0b2e6adb871a3b94$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $0b2e6adb871a3b94$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                k.call(a);
            };
        }
        $0b2e6adb871a3b94$var$Xj(function() {
            $0b2e6adb871a3b94$var$lk(b, g, a, e);
        });
    }
    return $0b2e6adb871a3b94$var$mk(g);
}
$0b2e6adb871a3b94$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 4, b);
        $0b2e6adb871a3b94$var$ok(a, 4);
    }
};
$0b2e6adb871a3b94$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 67108864, b);
        $0b2e6adb871a3b94$var$ok(a, 67108864);
    }
};
$0b2e6adb871a3b94$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg(), c = $0b2e6adb871a3b94$var$Ig(a);
        $0b2e6adb871a3b94$var$Jg(a, c, b);
        $0b2e6adb871a3b94$var$ok(a, c);
    }
};
$0b2e6adb871a3b94$var$hc = function(a, b) {
    return b();
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$y(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$var$Hb = function(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 4;
    try {
        return $0b2e6adb871a3b94$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $0b2e6adb871a3b94$var$X = f, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
$0b2e6adb871a3b94$var$Ib = function() {
    0 === ($0b2e6adb871a3b94$var$X & 49) && ($0b2e6adb871a3b94$var$Vj(), $0b2e6adb871a3b94$var$Oj());
};
$0b2e6adb871a3b94$var$Jb = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 2;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
function $0b2e6adb871a3b94$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$kk(a, b, null, c);
}
var $0b2e6adb871a3b94$var$vk = {
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Oj,
        {
            current: !1
        }
    ]
}, $0b2e6adb871a3b94$var$wk = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wc,
    bundleType: 0,
    version: "17.0.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$xk = {
    bundleType: $0b2e6adb871a3b94$var$wk.bundleType,
    version: $0b2e6adb871a3b94$var$wk.version,
    rendererPackageName: $0b2e6adb871a3b94$var$wk.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wk.findFiberByHostInstance || $0b2e6adb871a3b94$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$yk.isDisabled && $0b2e6adb871a3b94$var$yk.supportsFiber) try {
        $0b2e6adb871a3b94$var$Lf = $0b2e6adb871a3b94$var$yk.inject($0b2e6adb871a3b94$var$xk), $0b2e6adb871a3b94$var$Mf = $0b2e6adb871a3b94$var$yk;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$vk;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = $0b2e6adb871a3b94$var$uk;
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$y(188));
        throw Error($0b2e6adb871a3b94$var$y(268, Object.keys(a)));
    }
    a = $0b2e6adb871a3b94$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    if (0 !== (c & 48)) return a(b);
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        if (a) return $0b2e6adb871a3b94$var$gg(99, a.bind(null, b));
    } finally{
        $0b2e6adb871a3b94$var$X = c, $0b2e6adb871a3b94$var$ig();
    }
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$rk(a)) throw Error($0b2e6adb871a3b94$var$y(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Xj(function() {
        $0b2e6adb871a3b94$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$ff] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$export$2577ef5d2565d52f = function(a, b) {
    return $0b2e6adb871a3b94$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$rk(c)) throw Error($0b2e6adb871a3b94$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$y(38));
    return $0b2e6adb871a3b94$var$tk(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "17.0.1";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});




var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $1u0KT = parcelRequire("1u0KT");
var $defdd53b1fb54413$exports = {};
var $5607221af92f9c3a$exports = {};

$parcel$export($5607221af92f9c3a$exports, "App", () => $5607221af92f9c3a$export$86fbec116b87613f);

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


var $09297afe86dd7d0e$export$acb42adc2faed244 = {
    /**
     * Avoids style injection, use getRules() to read the styles.
     */ none: 0,
    /**
     * Inserts rules using the insertRule api.
     */ insertNode: 1,
    /**
     * Appends rules using appendChild.
     */ appendChild: 2
};
var $09297afe86dd7d0e$var$STYLESHEET_SETTING = "__stylesheet__";
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */ var $09297afe86dd7d0e$var$REUSE_STYLE_NODE = typeof navigator !== "undefined" && /rv:11.0/.test(navigator.userAgent);
var $09297afe86dd7d0e$var$_global = {};
// Grab window.
try {
    // Why the cast?
    // if compiled/type checked in same program with `@fluentui/font-icons-mdl2` which extends `Window` on global
    // ( check packages/font-icons-mdl2/src/index.ts ) the definitions don't match! Thus the need of this extra assertion
    $09297afe86dd7d0e$var$_global = window || {};
} catch (_a) {
/* leave as blank object */ }
var $09297afe86dd7d0e$var$_stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */ var $09297afe86dd7d0e$export$cd02bf5de16fbd7c = /** @class */ function() {
    function Stylesheet(config, serializedStylesheet) {
        var _a, _b, _c, _d, _e, _f;
        this._rules = [];
        this._preservedRules = [];
        this._counter = 0;
        this._keyToClassName = {};
        this._onInsertRuleCallbacks = [];
        this._onResetCallbacks = [];
        this._classNameToArgs = {};
        this._config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            // If there is no document we won't have an element to inject into.
            injectionMode: typeof document === "undefined" ? $09297afe86dd7d0e$export$acb42adc2faed244.none : $09297afe86dd7d0e$export$acb42adc2faed244.insertNode,
            defaultPrefix: "css",
            namespace: undefined,
            cspSettings: undefined
        }, config);
        this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.classNameToArgs) !== null && _a !== void 0 ? _a : this._classNameToArgs;
        this._counter = (_b = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.counter) !== null && _b !== void 0 ? _b : this._counter;
        this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== void 0 ? _c : serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.keyToClassName) !== null && _d !== void 0 ? _d : this._keyToClassName;
        this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.preservedRules) !== null && _e !== void 0 ? _e : this._preservedRules;
        this._rules = (_f = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.rules) !== null && _f !== void 0 ? _f : this._rules;
    }
    /**
     * Gets the singleton instance.
     */ Stylesheet.getInstance = function() {
        $09297afe86dd7d0e$var$_stylesheet = $09297afe86dd7d0e$var$_global[$09297afe86dd7d0e$var$STYLESHEET_SETTING];
        if (!$09297afe86dd7d0e$var$_stylesheet || $09297afe86dd7d0e$var$_stylesheet._lastStyleElement && $09297afe86dd7d0e$var$_stylesheet._lastStyleElement.ownerDocument !== document) {
            var fabricConfig = ($09297afe86dd7d0e$var$_global === null || $09297afe86dd7d0e$var$_global === void 0 ? void 0 : $09297afe86dd7d0e$var$_global.FabricConfig) || {};
            var stylesheet = new Stylesheet(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
            $09297afe86dd7d0e$var$_stylesheet = stylesheet;
            $09297afe86dd7d0e$var$_global[$09297afe86dd7d0e$var$STYLESHEET_SETTING] = stylesheet;
        }
        return $09297afe86dd7d0e$var$_stylesheet;
    };
    /**
     * Serializes the Stylesheet instance into a format which allows rehydration on creation.
     * @returns string representation of `ISerializedStylesheet` interface.
     */ Stylesheet.prototype.serialize = function() {
        return JSON.stringify({
            classNameToArgs: this._classNameToArgs,
            counter: this._counter,
            keyToClassName: this._keyToClassName,
            preservedRules: this._preservedRules,
            rules: this._rules
        });
    };
    /**
     * Configures the stylesheet.
     */ Stylesheet.prototype.setConfig = function(config) {
        this._config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this._config), config);
    };
    /**
     * Configures a reset callback.
     *
     * @param callback - A callback which will be called when the Stylesheet is reset.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onReset = function(callback) {
        var _this = this;
        this._onResetCallbacks.push(callback);
        return function() {
            _this._onResetCallbacks = _this._onResetCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Configures an insert rule callback.
     *
     * @param callback - A callback which will be called when a rule is inserted.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onInsertRule = function(callback) {
        var _this = this;
        this._onInsertRuleCallbacks.push(callback);
        return function() {
            _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Generates a unique classname.
     *
     * @param displayName - Optional value to use as a prefix.
     */ Stylesheet.prototype.getClassName = function(displayName) {
        var namespace = this._config.namespace;
        var prefix = displayName || this._config.defaultPrefix;
        return "".concat(namespace ? namespace + "-" : "").concat(prefix, "-").concat(this._counter++);
    };
    /**
     * Used internally to cache information about a class which was
     * registered with the stylesheet.
     */ Stylesheet.prototype.cacheClassName = function(className, key, args, rules) {
        this._keyToClassName[key] = className;
        this._classNameToArgs[className] = {
            args: args,
            rules: rules
        };
    };
    /**
     * Gets the appropriate classname given a key which was previously
     * registered using cacheClassName.
     */ Stylesheet.prototype.classNameFromKey = function(key) {
        return this._keyToClassName[key];
    };
    /**
     * Gets all classnames cache with the stylesheet.
     */ Stylesheet.prototype.getClassNameCache = function() {
        return this._keyToClassName;
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.argsFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.args;
    };
    /**
     * Gets the rules associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.insertedRulesFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.rules;
    };
    /**
     * Inserts a css rule into the stylesheet.
     * @param preserve - Preserves the rule beyond a reset boundary.
     */ Stylesheet.prototype.insertRule = function(rule, preserve) {
        var injectionMode = this._config.injectionMode;
        var element = injectionMode !== $09297afe86dd7d0e$export$acb42adc2faed244.none ? this._getStyleElement() : undefined;
        if (preserve) this._preservedRules.push(rule);
        if (element) switch(injectionMode){
            case $09297afe86dd7d0e$export$acb42adc2faed244.insertNode:
                var sheet = element.sheet;
                try {
                    sheet.insertRule(rule, sheet.cssRules.length);
                } catch (e) {
                // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
                // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
                // which could be slower and bulkier.
                }
                break;
            case $09297afe86dd7d0e$export$acb42adc2faed244.appendChild:
                element.appendChild(document.createTextNode(rule));
                break;
        }
        else this._rules.push(rule);
        // eslint-disable-next-line deprecation/deprecation
        if (this._config.onInsertRule) // eslint-disable-next-line deprecation/deprecation
        this._config.onInsertRule(rule);
        this._onInsertRuleCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    /**
     * Gets all rules registered with the stylesheet; only valid when
     * using InsertionMode.none.
     */ Stylesheet.prototype.getRules = function(includePreservedRules) {
        return (includePreservedRules ? this._preservedRules.join("") : "") + this._rules.join("");
    };
    /**
     * Resets the internal state of the stylesheet. Only used in server
     * rendered scenarios where we're using InsertionMode.none.
     */ Stylesheet.prototype.reset = function() {
        this._rules = [];
        this._counter = 0;
        this._classNameToArgs = {};
        this._keyToClassName = {};
        this._onResetCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
    Stylesheet.prototype.resetKeys = function() {
        this._keyToClassName = {};
    };
    Stylesheet.prototype._getStyleElement = function() {
        var _this = this;
        if (!this._styleElement && typeof document !== "undefined") {
            this._styleElement = this._createStyleElement();
            if (!$09297afe86dd7d0e$var$REUSE_STYLE_NODE) // Reset the style element on the next frame.
            window.requestAnimationFrame(function() {
                _this._styleElement = undefined;
            });
        }
        return this._styleElement;
    };
    Stylesheet.prototype._createStyleElement = function() {
        var head = document.head;
        var styleElement = document.createElement("style");
        var nodeToInsertBefore = null;
        styleElement.setAttribute("data-merge-styles", "true");
        var cspSettings = this._config.cspSettings;
        if (cspSettings) {
            if (cspSettings.nonce) styleElement.setAttribute("nonce", cspSettings.nonce);
        }
        if (this._lastStyleElement) // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
        nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
        else {
            var placeholderStyleTag = this._findPlaceholderStyleTag();
            if (placeholderStyleTag) nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
            else nodeToInsertBefore = head.childNodes[0];
        }
        head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
        this._lastStyleElement = styleElement;
        return styleElement;
    };
    Stylesheet.prototype._findPlaceholderStyleTag = function() {
        var head = document.head;
        if (head) return head.querySelector("style[data-merge-styles]");
        return null;
    };
    return Stylesheet;
}();


function $1fbb556661b56077$export$b1c01d3d68dc0b88() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var classes = [];
    var objects = [];
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    function _processArgs(argsList) {
        for(var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++){
            var arg = argsList_1[_i];
            if (arg) {
                if (typeof arg === "string") {
                    if (arg.indexOf(" ") >= 0) _processArgs(arg.split(" "));
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) _processArgs(translatedArgs);
                        else // Avoid adding the same class twice.
                        if (classes.indexOf(arg) === -1) classes.push(arg);
                    }
                } else if (Array.isArray(arg)) _processArgs(arg);
                else if (typeof arg === "object") objects.push(arg);
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}


/**
 * Sets the current RTL value.
 */ function $83a2b0773b0b5f26$export$64006deca925fb65(isRTL) {
    if ($83a2b0773b0b5f26$var$_rtl !== isRTL) $83a2b0773b0b5f26$var$_rtl = isRTL;
}
function $83a2b0773b0b5f26$export$b2303637e9533380() {
    if ($83a2b0773b0b5f26$var$_rtl === undefined) $83a2b0773b0b5f26$var$_rtl = typeof document !== "undefined" && !!document.documentElement && document.documentElement.getAttribute("dir") === "rtl";
    return $83a2b0773b0b5f26$var$_rtl;
}
// This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.
var $83a2b0773b0b5f26$var$_rtl;
$83a2b0773b0b5f26$var$_rtl = $83a2b0773b0b5f26$export$b2303637e9533380();
function $83a2b0773b0b5f26$export$6c4e12d3949051a() {
    return {
        rtl: $83a2b0773b0b5f26$export$b2303637e9533380()
    };
}




var $1297e85c823d0447$var$rules = {};
function $1297e85c823d0447$export$81a4f1c533782259(rulePairs, index) {
    var rule = rulePairs[index];
    if (rule.charAt(0) !== "-") rulePairs[index] = $1297e85c823d0447$var$rules[rule] = $1297e85c823d0447$var$rules[rule] || rule.replace(/([A-Z])/g, "-$1").toLowerCase();
}


var $72c15e38e4ff2eb0$var$_vendorSettings;
function $72c15e38e4ff2eb0$export$80b0e239f56c8c7d() {
    var _a;
    if (!$72c15e38e4ff2eb0$var$_vendorSettings) {
        var doc = typeof document !== "undefined" ? document : undefined;
        var nav = typeof navigator !== "undefined" ? navigator : undefined;
        var userAgent = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!doc) $72c15e38e4ff2eb0$var$_vendorSettings = {
            isWebkit: true,
            isMoz: true,
            isOpera: true,
            isMs: true
        };
        else $72c15e38e4ff2eb0$var$_vendorSettings = {
            isWebkit: !!(doc && "WebkitAppearance" in doc.documentElement.style),
            isMoz: !!(userAgent && userAgent.indexOf("firefox") > -1),
            isOpera: !!(userAgent && userAgent.indexOf("opera") > -1),
            isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
        };
    }
    return $72c15e38e4ff2eb0$var$_vendorSettings;
}
function $72c15e38e4ff2eb0$export$9f7e3c53560dab05(vendorSettings) {
    $72c15e38e4ff2eb0$var$_vendorSettings = vendorSettings;
}


var $b359f16d76871ecd$var$autoPrefixNames = {
    "user-select": 1
};
function $b359f16d76871ecd$export$6c6679cd94cc8e5a(rulePairs, index) {
    var vendorSettings = (0, $72c15e38e4ff2eb0$export$80b0e239f56c8c7d)();
    var name = rulePairs[index];
    if ($b359f16d76871ecd$var$autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if ($b359f16d76871ecd$var$autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) rulePairs.push("-webkit-" + name, value);
            if (vendorSettings.isMoz) rulePairs.push("-moz-" + name, value);
            if (vendorSettings.isMs) rulePairs.push("-ms-" + name, value);
            if (vendorSettings.isOpera) rulePairs.push("-o-" + name, value);
        }
    }
}


var $4c7513fab2ae30d8$var$NON_PIXEL_NUMBER_PROPS = [
    "column-count",
    "font-weight",
    "flex",
    "flex-grow",
    "flex-shrink",
    "fill-opacity",
    "opacity",
    "order",
    "z-index",
    "zoom"
];
function $4c7513fab2ae30d8$export$4d98e579c8cf34c8(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === "number") {
        var isNonPixelProp = $4c7513fab2ae30d8$var$NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
        var isVariableOrPrefixed = name.indexOf("--") > -1;
        var unit = isNonPixelProp || isVariableOrPrefixed ? "" : "px";
        rulePairs[index + 1] = "".concat(value).concat(unit);
    }
}


var $63553894ba0df07e$var$_a;
var $63553894ba0df07e$var$LEFT = "left";
var $63553894ba0df07e$var$RIGHT = "right";
var $63553894ba0df07e$var$NO_FLIP = "@noflip";
var $63553894ba0df07e$var$NAME_REPLACEMENTS = ($63553894ba0df07e$var$_a = {}, $63553894ba0df07e$var$_a[$63553894ba0df07e$var$LEFT] = $63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$_a[$63553894ba0df07e$var$RIGHT] = $63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$_a);
var $63553894ba0df07e$var$VALUE_REPLACEMENTS = {
    "w-resize": "e-resize",
    "sw-resize": "se-resize",
    "nw-resize": "ne-resize"
};
function $63553894ba0df07e$export$79e12f79f6fb4537(options, rulePairs, index) {
    if (options.rtl) {
        var name_1 = rulePairs[index];
        if (!name_1) return;
        var value = rulePairs[index + 1];
        if (typeof value === "string" && value.indexOf($63553894ba0df07e$var$NO_FLIP) >= 0) rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, "");
        else if (name_1.indexOf($63553894ba0df07e$var$LEFT) >= 0) rulePairs[index] = name_1.replace($63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$RIGHT);
        else if (name_1.indexOf($63553894ba0df07e$var$RIGHT) >= 0) rulePairs[index] = name_1.replace($63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$LEFT);
        else if (String(value).indexOf($63553894ba0df07e$var$LEFT) >= 0) rulePairs[index + 1] = value.replace($63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$RIGHT);
        else if (String(value).indexOf($63553894ba0df07e$var$RIGHT) >= 0) rulePairs[index + 1] = value.replace($63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$LEFT);
        else if ($63553894ba0df07e$var$NAME_REPLACEMENTS[name_1]) rulePairs[index] = $63553894ba0df07e$var$NAME_REPLACEMENTS[name_1];
        else if ($63553894ba0df07e$var$VALUE_REPLACEMENTS[value]) rulePairs[index + 1] = $63553894ba0df07e$var$VALUE_REPLACEMENTS[value];
        else switch(name_1){
            case "margin":
            case "padding":
                rulePairs[index + 1] = $63553894ba0df07e$var$flipQuad(value);
                break;
            case "box-shadow":
                rulePairs[index + 1] = $63553894ba0df07e$var$negateNum(value, 0);
                break;
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */ function $63553894ba0df07e$var$negateNum(value, partIndex) {
    var parts = value.split(" ");
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(" ");
}
/**
 * Given a string quad, flips the left and right values.
 */ function $63553894ba0df07e$var$flipQuad(value) {
    if (typeof value === "string") {
        var parts = value.split(" ");
        if (parts.length === 4) return "".concat(parts[0], " ").concat(parts[3], " ").concat(parts[2], " ").concat(parts[1]);
    }
    return value;
}


/**
 * Split a string into tokens separated by whitespace, except all text within parentheses
 * is treated as a single token (whitespace is ignored within parentheses).
 *
 * Unlike String.split(' '), multiple consecutive space characters are collapsed and
 * removed from the returned array (including leading and trailing spaces).
 *
 * For example:
 * `tokenizeWithParentheses("3px calc(var(--x) / 2) 9px    0 ")`
 *   => `["3px", "calc(var(--x) / 2)", "9px", "0"]`
 *
 * @returns The array of tokens. Returns an empty array if the string was empty or contained only whitespace.
 */ function $52be0e6a60d47477$export$73b82e713dad971(value) {
    var parts = [];
    var partStart = 0;
    var parens = 0;
    for(var i = 0; i < value.length; i++)switch(value[i]){
        case "(":
            parens++;
            break;
        case ")":
            if (parens) parens--;
            break;
        case "	":
        case " ":
            if (!parens) {
                // Add the new part if it's not an empty string
                if (i > partStart) parts.push(value.substring(partStart, i));
                partStart = i + 1;
            }
            break;
    }
    // Add the last part
    if (partStart < value.length) parts.push(value.substring(partStart));
    return parts;
}


var $3984cc6e71239662$var$DISPLAY_NAME = "displayName";
function $3984cc6e71239662$var$getDisplayName(rules) {
    var rootStyle = rules && rules["&"];
    return rootStyle ? rootStyle.displayName : undefined;
}
var $3984cc6e71239662$var$globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */ function $3984cc6e71239662$var$expandCommaSeparatedGlobals(selectorWithGlobals) {
    // We the selector does not have a :global() we can shortcut
    if (!$3984cc6e71239662$var$globalSelectorRegExp.test(selectorWithGlobals)) return selectorWithGlobals;
    var replacementInfo = [];
    var findGlobal = /\:global\((.+?)\)/g;
    var match = null;
    // Create a result list for global selectors so we can replace them.
    while(match = findGlobal.exec(selectorWithGlobals))// Only if the found selector is a comma separated list we'll process it.
    if (match[1].indexOf(",") > -1) replacementInfo.push([
        match.index,
        match.index + match[0].length,
        // Wrap each of the found selectors in :global()
        match[1].split(",").map(function(v) {
            return ":global(".concat(v.trim(), ")");
        }).join(", ")
    ]);
    // Replace the found selectors with their wrapped variants in reverse order
    return replacementInfo.reverse().reduce(function(selector, _a) {
        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
        var prefix = selector.slice(0, matchIndex);
        var suffix = selector.slice(matchEndIndex);
        return prefix + replacement + suffix;
    }, selectorWithGlobals);
}
function $3984cc6e71239662$var$expandSelector(newSelector, currentSelector) {
    if (newSelector.indexOf(":global(") >= 0) return newSelector.replace($3984cc6e71239662$var$globalSelectorRegExp, "$1");
    else if (newSelector.indexOf(":") === 0) return currentSelector + newSelector;
    else if (newSelector.indexOf("&") < 0) return currentSelector + " " + newSelector;
    return newSelector;
}
function $3984cc6e71239662$var$extractSelector(currentSelector, rules, selector, value) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (selector.indexOf("@") === 0) {
        selector = selector + "{" + currentSelector;
        $3984cc6e71239662$var$extractRules([
            value
        ], rules, selector);
    } else if (selector.indexOf(",") > -1) $3984cc6e71239662$var$expandCommaSeparatedGlobals(selector).split(",").map(function(s) {
        return s.trim();
    }).forEach(function(separatedSelector) {
        return $3984cc6e71239662$var$extractRules([
            value
        ], rules, $3984cc6e71239662$var$expandSelector(separatedSelector, currentSelector));
    });
    else $3984cc6e71239662$var$extractRules([
        value
    ], rules, $3984cc6e71239662$var$expandSelector(selector, currentSelector));
}
function $3984cc6e71239662$var$extractRules(args, rules, currentSelector) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (currentSelector === void 0) currentSelector = "&";
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var currentRules = rules[currentSelector];
    if (!currentRules) {
        currentRules = {};
        rules[currentSelector] = currentRules;
        rules.__order.push(currentSelector);
    }
    for(var _i = 0, args_1 = args; _i < args_1.length; _i++){
        var arg = args_1[_i];
        // If the arg is a string, we need to look up the class map and merge.
        if (typeof arg === "string") {
            var expandedRules = stylesheet.argsFromClassName(arg);
            if (expandedRules) $3984cc6e71239662$var$extractRules(expandedRules, rules, currentSelector);
        // Else if the arg is an array, we need to recurse in.
        } else if (Array.isArray(arg)) $3984cc6e71239662$var$extractRules(arg, rules, currentSelector);
        else {
            for(var prop in arg)if (arg.hasOwnProperty(prop)) {
                var propValue = arg[prop];
                if (prop === "selectors") {
                    // every child is a selector.
                    var selectors = arg.selectors;
                    for(var newSelector in selectors)if (selectors.hasOwnProperty(newSelector)) $3984cc6e71239662$var$extractSelector(currentSelector, rules, newSelector, selectors[newSelector]);
                } else if (typeof propValue === "object") // prop is a selector.
                {
                    if (propValue !== null) $3984cc6e71239662$var$extractSelector(currentSelector, rules, prop, propValue);
                } else if (propValue !== undefined) {
                    // Else, add the rule to the currentSelector.
                    if (prop === "margin" || prop === "padding") $3984cc6e71239662$var$expandQuads(currentRules, prop, propValue);
                    else currentRules[prop] = propValue;
                }
            }
        }
    }
    return rules;
}
function $3984cc6e71239662$var$expandQuads(currentRules, name, value) {
    var parts = typeof value === "string" ? (0, $52be0e6a60d47477$export$73b82e713dad971)(value) : [
        value
    ];
    if (parts.length === 0) parts.push(value);
    if (parts[parts.length - 1] === "!important") // Remove !important from parts, and append it to each part individually
    parts = parts.slice(0, -1).map(function(p) {
        return p + " !important";
    });
    currentRules[name + "Top"] = parts[0];
    currentRules[name + "Right"] = parts[1] || parts[0];
    currentRules[name + "Bottom"] = parts[2] || parts[0];
    currentRules[name + "Left"] = parts[3] || parts[1] || parts[0];
}
function $3984cc6e71239662$var$getKeyForRules(options, rules) {
    var serialized = [
        options.rtl ? "rtl" : "ltr"
    ];
    var hasProps = false;
    for(var _i = 0, _a = rules.__order; _i < _a.length; _i++){
        var selector = _a[_i];
        serialized.push(selector);
        var rulesForSelector = rules[selector];
        for(var propName in rulesForSelector)if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
            hasProps = true;
            serialized.push(propName, rulesForSelector[propName]);
        }
    }
    return hasProps ? serialized.join("") : undefined;
}
function $3984cc6e71239662$var$repeatString(target, count) {
    if (count <= 0) return "";
    if (count === 1) return target;
    return target + $3984cc6e71239662$var$repeatString(target, count - 1);
}
function $3984cc6e71239662$export$4080b13ebe249c61(options, ruleEntries) {
    if (!ruleEntries) return "";
    var allEntries = [];
    for(var entry in ruleEntries)if (ruleEntries.hasOwnProperty(entry) && entry !== $3984cc6e71239662$var$DISPLAY_NAME && ruleEntries[entry] !== undefined) allEntries.push(entry, ruleEntries[entry]);
    // Apply transforms.
    for(var i = 0; i < allEntries.length; i += 2){
        (0, $1297e85c823d0447$export$81a4f1c533782259)(allEntries, i);
        (0, $4c7513fab2ae30d8$export$4d98e579c8cf34c8)(allEntries, i);
        (0, $63553894ba0df07e$export$79e12f79f6fb4537)(options, allEntries, i);
        (0, $b359f16d76871ecd$export$6c6679cd94cc8e5a)(allEntries, i);
    }
    // Apply punctuation.
    for(var i = 1; i < allEntries.length; i += 4)allEntries.splice(i, 1, ":", allEntries[i], ";");
    return allEntries.join("");
}
function $3984cc6e71239662$export$f51c5a57f5409a02(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var rules = $3984cc6e71239662$var$extractRules(args);
    var key = $3984cc6e71239662$var$getKeyForRules(options, rules);
    if (key) {
        var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
        var registration = {
            className: stylesheet.classNameFromKey(key),
            key: key,
            args: args
        };
        if (!registration.className) {
            registration.className = stylesheet.getClassName($3984cc6e71239662$var$getDisplayName(rules));
            var rulesToInsert = [];
            for(var _a = 0, _b = rules.__order; _a < _b.length; _a++){
                var selector = _b[_a];
                rulesToInsert.push(selector, $3984cc6e71239662$export$4080b13ebe249c61(options, rules[selector]));
            }
            registration.rulesToInsert = rulesToInsert;
        }
        return registration;
    }
    return undefined;
}
function $3984cc6e71239662$export$cf30abcc7f4a413c(registration, specificityMultiplier) {
    if (specificityMultiplier === void 0) specificityMultiplier = 1;
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
    if (rulesToInsert) {
        // rulesToInsert is an ordered array of selector/rule pairs.
        for(var i = 0; i < rulesToInsert.length; i += 2){
            var rules = rulesToInsert[i + 1];
            if (rules) {
                var selector = rulesToInsert[i];
                selector = selector.replace(/&/g, $3984cc6e71239662$var$repeatString(".".concat(registration.className), specificityMultiplier));
                // Insert. Note if a media query, we must close the query with a final bracket.
                var processedRule = "".concat(selector, "{").concat(rules, "}").concat(selector.indexOf("@") === 0 ? "}" : "");
                stylesheet.insertRule(processedRule);
            }
        }
        stylesheet.cacheClassName(className, key, args, rulesToInsert);
    }
}
function $3984cc6e71239662$export$40e90054d98a04a(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var registration = $3984cc6e71239662$export$f51c5a57f5409a02.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        options
    ], args, false));
    if (registration) {
        $3984cc6e71239662$export$cf30abcc7f4a413c(registration, options.specificityMultiplier);
        return registration.className;
    }
    return "";
}


function $aa1d034ba9a4cf1b$export$e618dc39ac9ad607() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $aa1d034ba9a4cf1b$export$f77a3199de250644(args, (0, $83a2b0773b0b5f26$export$6c4e12d3949051a)());
}
function $aa1d034ba9a4cf1b$export$f77a3199de250644(args, options) {
    var styleArgs = args instanceof Array ? args : [
        args
    ];
    var _a = (0, $1fbb556661b56077$export$b1c01d3d68dc0b88)(styleArgs), classes = _a.classes, objects = _a.objects;
    if (objects.length) classes.push((0, $3984cc6e71239662$export$40e90054d98a04a)(options || {}, objects));
    return classes.join(" ");
}


function $7bf22b09420ef54a$export$c78c3a64e19cf4fb(styles) {
    var classes = {};
    var _loop_1 = function(styleName) {
        if (styles.hasOwnProperty(styleName)) {
            var className_1;
            Object.defineProperty(classes, styleName, {
                get: function() {
                    if (className_1 === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    className_1 = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles[styleName]).toString();
                    return className_1;
                },
                enumerable: true,
                configurable: true
            });
        }
    };
    for(var styleName in styles)_loop_1(styleName);
    return classes;
}





function $20f518cc12336d5a$export$d25ddfdf17c3ad3e(timeline) {
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var rulesArray = [];
    for(var prop in timeline)if (timeline.hasOwnProperty(prop)) rulesArray.push(prop, "{", (0, $3984cc6e71239662$export$4080b13ebe249c61)((0, $83a2b0773b0b5f26$export$6c4e12d3949051a)(), timeline[prop]), "}");
    var rules = rulesArray.join("");
    var className = stylesheet.classNameFromKey(rules);
    if (className) return className;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@keyframes ".concat(name, "{").concat(rules, "}"), true);
    stylesheet.cacheClassName(name, rules, [], [
        "keyframes",
        rules
    ]);
    return name;
}


/* Register the keyframes */ var $ca17ef8e897e1cc4$var$EASING_FUNCTION_1 = "cubic-bezier(.1,.9,.2,1)";
var $ca17ef8e897e1cc4$var$EASING_FUNCTION_2 = "cubic-bezier(.1,.25,.75,.9)";
var $ca17ef8e897e1cc4$var$DURATION_1 = "0.167s";
var $ca17ef8e897e1cc4$var$DURATION_2 = "0.267s";
var $ca17ef8e897e1cc4$var$DURATION_3 = "0.367s";
var $ca17ef8e897e1cc4$var$DURATION_4 = "0.467s";
var $ca17ef8e897e1cc4$var$FADE_IN = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $ca17ef8e897e1cc4$var$FADE_OUT = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 1
    },
    to: {
        opacity: 0,
        visibility: "hidden"
    }
});
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN10 = $ca17ef8e897e1cc4$var$_createSlideInX(-10);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN20 = $ca17ef8e897e1cc4$var$_createSlideInX(-20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN40 = $ca17ef8e897e1cc4$var$_createSlideInX(-40);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN400 = $ca17ef8e897e1cc4$var$_createSlideInX(-400);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN10 = $ca17ef8e897e1cc4$var$_createSlideInX(10);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN20 = $ca17ef8e897e1cc4$var$_createSlideInX(20);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN40 = $ca17ef8e897e1cc4$var$_createSlideInX(40);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN400 = $ca17ef8e897e1cc4$var$_createSlideInX(400);
var $ca17ef8e897e1cc4$var$SLIDE_UP_IN10 = $ca17ef8e897e1cc4$var$_createSlideInY(10);
var $ca17ef8e897e1cc4$var$SLIDE_UP_IN20 = $ca17ef8e897e1cc4$var$_createSlideInY(20);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_IN10 = $ca17ef8e897e1cc4$var$_createSlideInY(-10);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_IN20 = $ca17ef8e897e1cc4$var$_createSlideInY(-20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutX(10);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutX(20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT40 = $ca17ef8e897e1cc4$var$_createSlideOutX(40);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT400 = $ca17ef8e897e1cc4$var$_createSlideOutX(400);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutX(-10);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutX(-20);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT40 = $ca17ef8e897e1cc4$var$_createSlideOutX(-40);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT400 = $ca17ef8e897e1cc4$var$_createSlideOutX(-400);
var $ca17ef8e897e1cc4$var$SLIDE_UP_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutY(-10);
var $ca17ef8e897e1cc4$var$SLIDE_UP_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutY(-20);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutY(10);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutY(20);
var $ca17ef8e897e1cc4$var$SCALE_UP100 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scale3d(.98,.98,1)"
    },
    to: {
        transform: "scale3d(1,1,1)"
    }
});
var $ca17ef8e897e1cc4$var$SCALE_DOWN98 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scale3d(1,1,1)"
    },
    to: {
        transform: "scale3d(.98,.98,1)"
    }
});
var $ca17ef8e897e1cc4$var$SCALE_DOWN100 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scale3d(1.03,1.03,1)"
    },
    to: {
        transform: "scale3d(1,1,1)"
    }
});
var $ca17ef8e897e1cc4$var$SCALE_UP103 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scale3d(1,1,1)"
    },
    to: {
        transform: "scale3d(1.03,1.03,1)"
    }
});
var $ca17ef8e897e1cc4$var$ROTATE90 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "rotateZ(0deg)"
    },
    to: {
        transform: "rotateZ(90deg)"
    }
});
var $ca17ef8e897e1cc4$var$ROTATE_N90 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "rotateZ(0deg)"
    },
    to: {
        transform: "rotateZ(-90deg)"
    }
});
var $ca17ef8e897e1cc4$export$8b2661a06dc8473f = {
    easeFunction1: $ca17ef8e897e1cc4$var$EASING_FUNCTION_1,
    easeFunction2: $ca17ef8e897e1cc4$var$EASING_FUNCTION_2,
    durationValue1: $ca17ef8e897e1cc4$var$DURATION_1,
    durationValue2: $ca17ef8e897e1cc4$var$DURATION_2,
    durationValue3: $ca17ef8e897e1cc4$var$DURATION_3,
    durationValue4: $ca17ef8e897e1cc4$var$DURATION_4
};
var $ca17ef8e897e1cc4$export$30948f134ffb9e45 = {
    slideRightIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleUpIn100: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SCALE_UP100), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleDownIn100: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SCALE_DOWN100), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleUpOut103: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SCALE_UP103), $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    scaleDownOut98: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SCALE_DOWN98), $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn100: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn200: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_2, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn400: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn500: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_4, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut100: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut200: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_2, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut400: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut500: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_4, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    rotate90deg: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$ROTATE90, "0.1s", $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    rotateN90deg: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$ROTATE_N90, "0.1s", $ca17ef8e897e1cc4$var$EASING_FUNCTION_2)
};
function $ca17ef8e897e1cc4$var$_createAnimation(animationName, animationDuration, animationTimingFunction) {
    return {
        animationName: animationName,
        animationDuration: animationDuration,
        animationTimingFunction: animationTimingFunction,
        animationFillMode: "both"
    };
}
function $ca17ef8e897e1cc4$var$_createSlideInX(fromX) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(".concat(fromX, "px,0,0)"),
            pointerEvents: "none"
        },
        to: {
            transform: "translate3d(0,0,0)",
            pointerEvents: "auto"
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideInY(fromY) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,".concat(fromY, "px,0)"),
            pointerEvents: "none"
        },
        to: {
            transform: "translate3d(0,0,0)",
            pointerEvents: "auto"
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideOutX(toX) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,0,0)"
        },
        to: {
            transform: "translate3d(".concat(toX, "px,0,0)")
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideOutY(toY) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,0,0)"
        },
        to: {
            transform: "translate3d(0,".concat(toY, "px,0)")
        }
    });
}


var $e2629e8d47c94809$export$a386448ab9904275 = (0, $7bf22b09420ef54a$export$c78c3a64e19cf4fb)((0, $ca17ef8e897e1cc4$export$30948f134ffb9e45));


var $905fed6f1ccd845a$export$77a09a3b0466bd17 = "@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)";
var $905fed6f1ccd845a$export$f57e8a065222a88e = // eslint-disable-next-line @fluentui/max-len
"@media screen and (-ms-high-contrast: black-on-white), screen and (forced-colors: active) and (prefers-color-scheme: light)";
var $905fed6f1ccd845a$export$46e50d23541200fa = // eslint-disable-next-line @fluentui/max-len
"@media screen and (-ms-high-contrast: white-on-black), screen and (forced-colors: active) and (prefers-color-scheme: dark)";
var $905fed6f1ccd845a$export$e795cfe26983ca2b = "@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)";
var $905fed6f1ccd845a$export$a91d390a6282498 = 320;
var $905fed6f1ccd845a$export$2a2cf3a4e575f28 = 480;
var $905fed6f1ccd845a$export$3b8f430e18451172 = 640;
var $905fed6f1ccd845a$export$8063c2544c1fd1ee = 1024;
var $905fed6f1ccd845a$export$21a5264b301ff8d4 = 1366;
var $905fed6f1ccd845a$export$9d47a7778008a6dd = 1920;
var $905fed6f1ccd845a$export$b7949b403ba42a41 = $905fed6f1ccd845a$export$2a2cf3a4e575f28 - 1;
var $905fed6f1ccd845a$export$af97800cf211974a = $905fed6f1ccd845a$export$3b8f430e18451172 - 1;
var $905fed6f1ccd845a$export$9d555ccb57f8acb0 = $905fed6f1ccd845a$export$8063c2544c1fd1ee - 1;
var $905fed6f1ccd845a$export$eb3f4d948789a51d = $905fed6f1ccd845a$export$21a5264b301ff8d4 - 1;
var $905fed6f1ccd845a$export$cb61294b6ad9e14c = $905fed6f1ccd845a$export$9d47a7778008a6dd - 1;
var $905fed6f1ccd845a$export$db6df1a0c5d780ca = 768;
function $905fed6f1ccd845a$export$be136f2e7621e736(min, max) {
    var minSelector = typeof min === "number" ? " and (min-width: ".concat(min, "px)") : "";
    var maxSelector = typeof max === "number" ? " and (max-width: ".concat(max, "px)") : "";
    return "@media only screen".concat(minSelector).concat(maxSelector);
}
function $905fed6f1ccd845a$export$ea44bc327145cc4d() {
    return {
        forcedColorAdjust: "none",
        MsHighContrastAdjust: "none"
    };
}
function $905fed6f1ccd845a$export$85ad7d67343aaedb() {
    var _a;
    return _a = {}, // eslint-disable-next-line deprecation/deprecation
    _a[$905fed6f1ccd845a$export$e795cfe26983ca2b] = {
        forcedColorAdjust: "none",
        MsHighContrastAdjust: "none"
    }, _a;
}


/**
 * Verifies if an application can use DOM.
 */ function $18aa0efffa2a3752$export$71594e8a50f746f4() {
    return typeof window !== "undefined" && !!(window.document && // eslint-disable-next-line deprecation/deprecation
    window.document.createElement);
}


var $1e1f791b4ec4e821$var$_window = undefined;
// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    $1e1f791b4ec4e821$var$_window = window;
} catch (e) {
/* no-op */ }
function $1e1f791b4ec4e821$export$38b2d434cce3ea22(rootElement) {
    if (!(0, $18aa0efffa2a3752$export$71594e8a50f746f4)() || typeof $1e1f791b4ec4e821$var$_window === "undefined") return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : $1e1f791b4ec4e821$var$_window;
    }
}


var $68e6902efa21380a$export$d4b0d4f3148ab6bf = "ms-Fabric--isFocusVisible";
var $68e6902efa21380a$export$e9dc2f0a678c0693 = "ms-Fabric--isFocusHidden";
function $68e6902efa21380a$var$updateClassList(el, enabled) {
    if (el) {
        el.classList.add(enabled ? $68e6902efa21380a$export$d4b0d4f3148ab6bf : $68e6902efa21380a$export$e9dc2f0a678c0693);
        el.classList.remove(enabled ? $68e6902efa21380a$export$e9dc2f0a678c0693 : $68e6902efa21380a$export$d4b0d4f3148ab6bf);
    }
}
function $68e6902efa21380a$export$760b5674477e9343(enabled, target, registeredProviders) {
    var _a;
    if (registeredProviders) registeredProviders.forEach(function(ref) {
        return $68e6902efa21380a$var$updateClassList(ref.current, enabled);
    });
    else $68e6902efa21380a$var$updateClassList((_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(target)) === null || _a === void 0 ? void 0 : _a.document.body, enabled);
}


var $e718b14ff8496161$export$ee30d3e11c8625f1;
(function(ZIndexes) {
    ZIndexes.Nav = 1;
    /**
     * @deprecated Do not use
     */ ZIndexes.ScrollablePane = 1;
    ZIndexes.FocusStyle = 1;
    ZIndexes.Coachmark = 1000;
    ZIndexes.Layer = 1000000;
    ZIndexes.KeytipLayer = 1000001;
})($e718b14ff8496161$export$ee30d3e11c8625f1 || ($e718b14ff8496161$export$ee30d3e11c8625f1 = {}));


function $3c8eab4e1d179dea$export$58062d1b35a0b5bd(theme, insetOrOptions, position, highContrastStyle, borderColor, outlineColor, isFocusedOnly, borderRadius) {
    if (typeof insetOrOptions === "number" || !insetOrOptions) return $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, {
        inset: insetOrOptions,
        position: position,
        highContrastStyle: highContrastStyle,
        borderColor: borderColor,
        outlineColor: outlineColor,
        isFocusedOnly: isFocusedOnly,
        borderRadius: borderRadius
    });
    else return $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, insetOrOptions);
}
function $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, options) {
    var _a, _b;
    if (options === void 0) options = {};
    var borderRadius = options.borderRadius, _c = options.inset, inset = _c === void 0 ? 0 : _c, _d = options.width, width = _d === void 0 ? 1 : _d, _e = options.position, position = _e === void 0 ? "relative" : _e, highContrastStyle = options.highContrastStyle, _f = options.borderColor, borderColor = _f === void 0 ? theme.palette.white : _f, _g = options.outlineColor, outlineColor = _g === void 0 ? theme.palette.neutralSecondary : _g, _h = options.isFocusedOnly, isFocusedOnly = _h === void 0 ? true : _h, pointerEvents = options.pointerEvents;
    return {
        // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
        outline: "transparent",
        // Requirement because pseudo-element is absolutely positioned.
        position: position,
        selectors: (_a = {
            // Clear the focus border in Firefox.
            // Reference: http://stackoverflow.com/a/199319/1436671
            "::-moz-focus-inner": {
                border: "0"
            }
        }, // When the element that uses this mixin is in a :focus state, add a pseudo-element to
        // create a border.
        _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &").concat(isFocusedOnly ? ":focus" : "", ":after")] = {
            content: '""',
            position: "absolute",
            pointerEvents: pointerEvents,
            left: inset + 1,
            top: inset + 1,
            bottom: inset + 1,
            right: inset + 1,
            border: "".concat(width, "px solid ").concat(borderColor),
            outline: "".concat(width, "px solid ").concat(outlineColor),
            zIndex: (0, $e718b14ff8496161$export$ee30d3e11c8625f1).FocusStyle,
            borderRadius: borderRadius,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = highContrastStyle, _b)
        }, _a)
    };
}
function $3c8eab4e1d179dea$export$47933a1040be8871() {
    return {
        selectors: {
            "&::-moz-focus-inner": {
                // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
                border: 0
            },
            "&": {
                // Clear browser specific focus styles and use transparent as placeholder for focus style
                outline: "transparent"
            }
        }
    };
}
function $3c8eab4e1d179dea$export$e336755c5511e49c(theme, inset, width, color) {
    var _a;
    if (inset === void 0) inset = 0;
    if (width === void 0) width = 1;
    return {
        selectors: (_a = {}, _a[":global(".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus")] = {
            outline: "".concat(width, " solid ").concat(color || theme.palette.neutralSecondary),
            outlineOffset: "".concat(-inset, "px")
        }, _a)
    };
}
var $3c8eab4e1d179dea$export$47ad9ea05ccc047b = function(borderColor, borderRadius, borderType, borderPosition) {
    var _a, _b, _c;
    if (borderType === void 0) borderType = "border";
    if (borderPosition === void 0) borderPosition = -1;
    var isBorderBottom = borderType === "borderBottom";
    return {
        borderColor: borderColor,
        selectors: {
            ":after": (_a = {
                pointerEvents: "none",
                content: "''",
                position: "absolute",
                left: isBorderBottom ? 0 : borderPosition,
                top: borderPosition,
                bottom: borderPosition,
                right: isBorderBottom ? 0 : borderPosition
            }, _a[borderType] = "2px solid ".concat(borderColor), _a.borderRadius = borderRadius, _a.width = borderType === "borderBottom" ? "100%" : undefined, _a.selectors = (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (_c = {}, _c[borderType === "border" ? "borderColor" : "borderBottomColor"] = "Highlight", _c), _b), _a)
        }
    };
};

// Font face names to be registered.
var $1ba480b26914dcf0$export$ed6682c3a2de350f;
(function(LocalizedFontNames) {
    LocalizedFontNames.Arabic = "Segoe UI Web (Arabic)";
    LocalizedFontNames.Cyrillic = "Segoe UI Web (Cyrillic)";
    LocalizedFontNames.EastEuropean = "Segoe UI Web (East European)";
    LocalizedFontNames.Greek = "Segoe UI Web (Greek)";
    LocalizedFontNames.Hebrew = "Segoe UI Web (Hebrew)";
    LocalizedFontNames.Thai = "Leelawadee UI Web";
    LocalizedFontNames.Vietnamese = "Segoe UI Web (Vietnamese)";
    LocalizedFontNames.WestEuropean = "Segoe UI Web (West European)";
    LocalizedFontNames.Selawik = "Selawik Web";
    LocalizedFontNames.Armenian = "Segoe UI Web (Armenian)";
    LocalizedFontNames.Georgian = "Segoe UI Web (Georgian)";
})($1ba480b26914dcf0$export$ed6682c3a2de350f || ($1ba480b26914dcf0$export$ed6682c3a2de350f = {}));
var $1ba480b26914dcf0$export$a84f0633d5188de4;
(function(LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Arabic, "'");
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Cyrillic, "'");
    LocalizedFontFamilies.EastEuropean = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.EastEuropean, "'");
    LocalizedFontFamilies.Greek = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Greek, "'");
    LocalizedFontFamilies.Hebrew = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Hebrew, "'");
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Selawik, "'");
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Vietnamese, "'");
    LocalizedFontFamilies.WestEuropean = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.WestEuropean, "'");
    LocalizedFontFamilies.Armenian = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Armenian, "'");
    LocalizedFontFamilies.Georgian = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Georgian, "'");
})($1ba480b26914dcf0$export$a84f0633d5188de4 || ($1ba480b26914dcf0$export$a84f0633d5188de4 = {}));
var $1ba480b26914dcf0$export$f2bd2ec6ef52693e;
(function(FontSizes) {
    FontSizes.size10 = "10px";
    FontSizes.size12 = "12px";
    FontSizes.size14 = "14px";
    FontSizes.size16 = "16px";
    FontSizes.size18 = "18px";
    FontSizes.size20 = "20px";
    FontSizes.size24 = "24px";
    FontSizes.size28 = "28px";
    FontSizes.size32 = "32px";
    FontSizes.size42 = "42px";
    FontSizes.size68 = "68px";
    FontSizes.mini = "10px";
    FontSizes.xSmall = "10px";
    FontSizes.small = "12px";
    FontSizes.smallPlus = "12px";
    FontSizes.medium = "14px";
    FontSizes.mediumPlus = "16px";
    FontSizes.icon = "16px";
    FontSizes.large = "18px";
    FontSizes.xLarge = "20px";
    FontSizes.xLargePlus = "24px";
    FontSizes.xxLarge = "28px";
    FontSizes.xxLargePlus = "32px";
    FontSizes.superLarge = "42px";
    FontSizes.mega = "68px";
})($1ba480b26914dcf0$export$f2bd2ec6ef52693e || ($1ba480b26914dcf0$export$f2bd2ec6ef52693e = {}));
var $1ba480b26914dcf0$export$32743b01f42d159e;
(function(FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})($1ba480b26914dcf0$export$32743b01f42d159e || ($1ba480b26914dcf0$export$32743b01f42d159e = {}));
var $1ba480b26914dcf0$export$7f8918a48f5782fd;
(function(IconFontSizes) {
    IconFontSizes.xSmall = "10px";
    IconFontSizes.small = "12px";
    IconFontSizes.medium = "16px";
    IconFontSizes.large = "20px";
})($1ba480b26914dcf0$export$7f8918a48f5782fd || ($1ba480b26914dcf0$export$7f8918a48f5782fd = {}));



var $ccf88a0d18e38068$var$_initializedStylesheetResets = false;
var $ccf88a0d18e38068$var$_resetCounter = 0;
var $ccf88a0d18e38068$var$_emptyObject = {
    empty: true
};
var $ccf88a0d18e38068$var$_dictionary = {};
var $ccf88a0d18e38068$var$_weakMap = typeof WeakMap === "undefined" ? null : WeakMap;
function $ccf88a0d18e38068$export$c05f7913c3736a3a(weakMap) {
    $ccf88a0d18e38068$var$_weakMap = weakMap;
}
function $ccf88a0d18e38068$export$73eecc6b962b0486() {
    $ccf88a0d18e38068$var$_resetCounter++;
}
function $ccf88a0d18e38068$export$fc10aeed3a532e2a(_target, _key, descriptor) {
    // We bind to "null" to prevent people from inadvertently pulling values from "this",
    // rather than passing them in as input values which can be memoized.
    var fn = $ccf88a0d18e38068$export$c008d290adbd8ce5(descriptor.value && descriptor.value.bind(null));
    return {
        configurable: true,
        get: function() {
            return fn;
        }
    };
}
function $ccf88a0d18e38068$export$c008d290adbd8ce5(cb, maxCacheSize, ignoreNullOrUndefinedResult) {
    if (maxCacheSize === void 0) maxCacheSize = 100;
    if (ignoreNullOrUndefinedResult === void 0) ignoreNullOrUndefinedResult = false;
    // Avoid breaking scenarios which don't have weak map.
    if (!$ccf88a0d18e38068$var$_weakMap) return cb;
    if (!$ccf88a0d18e38068$var$_initializedStylesheetResets) {
        var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
        if (stylesheet && stylesheet.onReset) (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance().onReset($ccf88a0d18e38068$export$73eecc6b962b0486);
        $ccf88a0d18e38068$var$_initializedStylesheetResets = true;
    }
    var rootNode;
    var cacheSize = 0;
    var localResetCounter = $ccf88a0d18e38068$var$_resetCounter;
    return function memoizedFunction() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var currentNode = rootNode;
        if (rootNode === undefined || localResetCounter !== $ccf88a0d18e38068$var$_resetCounter || maxCacheSize > 0 && cacheSize > maxCacheSize) {
            rootNode = $ccf88a0d18e38068$var$_createNode();
            cacheSize = 0;
            localResetCounter = $ccf88a0d18e38068$var$_resetCounter;
        }
        currentNode = rootNode;
        // Traverse the tree until we find the match.
        for(var i = 0; i < args.length; i++){
            var arg = $ccf88a0d18e38068$var$_normalizeArg(args[i]);
            if (!currentNode.map.has(arg)) currentNode.map.set(arg, $ccf88a0d18e38068$var$_createNode());
            currentNode = currentNode.map.get(arg);
        }
        if (!currentNode.hasOwnProperty("value")) {
            currentNode.value = cb.apply(void 0, args);
            cacheSize++;
        }
        if (ignoreNullOrUndefinedResult && (currentNode.value === null || currentNode.value === undefined)) currentNode.value = cb.apply(void 0, args);
        return currentNode.value;
    };
}
function $ccf88a0d18e38068$export$99061b04f99342f(getValue) {
    if (!$ccf88a0d18e38068$var$_weakMap) // Without a `WeakMap` implementation, memoization is not possible.
    return getValue;
    var cache = new $ccf88a0d18e38068$var$_weakMap();
    function memoizedGetValue(input) {
        if (!input || typeof input !== "function" && typeof input !== "object") // A WeakMap can only be used to test against reference values, i.e. 'function' and 'object'.
        // All other inputs cannot be memoized against in this manner.
        return getValue(input);
        if (cache.has(input)) return cache.get(input);
        var value = getValue(input);
        cache.set(input, value);
        return value;
    }
    return memoizedGetValue;
}
function $ccf88a0d18e38068$var$_normalizeArg(val) {
    if (!val) return $ccf88a0d18e38068$var$_emptyObject;
    else if (typeof val === "object" || typeof val === "function") return val;
    else if (!$ccf88a0d18e38068$var$_dictionary[val]) $ccf88a0d18e38068$var$_dictionary[val] = {
        val: val
    };
    return $ccf88a0d18e38068$var$_dictionary[val];
}
function $ccf88a0d18e38068$var$_createNode() {
    return {
        map: $ccf88a0d18e38068$var$_weakMap ? new $ccf88a0d18e38068$var$_weakMap() : null
    };
}


/**
 * Internal memoized function which simply takes in the class map and the
 * disable boolean. These immutable values can be memoized.
 */ var $82e4fc67b7d16117$var$_getGlobalClassNames = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(classNames, disableGlobalClassNames) {
    var styleSheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    if (disableGlobalClassNames) // disable global classnames
    return Object.keys(classNames).reduce(function(acc, className) {
        acc[className] = styleSheet.getClassName(classNames[className]);
        return acc;
    }, {});
    // use global classnames
    return classNames;
});
function $82e4fc67b7d16117$export$e14385d8f1853921(classNames, theme, disableGlobalClassNames) {
    return $82e4fc67b7d16117$var$_getGlobalClassNames(classNames, disableGlobalClassNames !== undefined ? disableGlobalClassNames : theme.disableGlobalClassNames);
}

/**
 * Generates placeholder style for each of the browsers supported by `@fluentui/react`.
 * @param styles - The style to use.
 * @returns The placeholder style object for each browser depending on the placeholder directive it uses.
 */ function $0f1b07507d939466$export$be3d79419dd9c4a2(styles) {
    return {
        selectors: {
            "::placeholder": styles,
            ":-ms-input-placeholder": styles,
            "::-ms-input-placeholder": styles
        }
    };
}




/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */ var $2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME = "__globalSettings__";
var $2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME = "__callbacks__";
var $2a6b20086a42f1ef$var$_counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */ var $2a6b20086a42f1ef$export$e962ef7984a884aa = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.getValue = function(key, defaultValue) {
        var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
        if (globalSettings[key] === undefined) globalSettings[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue;
        return globalSettings[key];
    };
    GlobalSettings.setValue = function(key, value) {
        var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
        var callbacks = globalSettings[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME];
        var oldValue = globalSettings[key];
        if (value !== oldValue) {
            globalSettings[key] = value;
            var changeDescription = {
                oldValue: oldValue,
                value: value,
                key: key
            };
            for(var id in callbacks)if (callbacks.hasOwnProperty(id)) callbacks[id](changeDescription);
        }
        return value;
    };
    GlobalSettings.addChangeListener = function(cb) {
        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
        var id = cb.__id__;
        var callbacks = $2a6b20086a42f1ef$var$_getCallbacks();
        if (!id) id = cb.__id__ = String($2a6b20086a42f1ef$var$_counter++);
        callbacks[id] = cb;
    };
    GlobalSettings.removeChangeListener = function(cb) {
        var callbacks = $2a6b20086a42f1ef$var$_getCallbacks();
        delete callbacks[cb.__id__];
    };
    return GlobalSettings;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2a6b20086a42f1ef$var$_getGlobalSettings() {
    var _a;
    var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObj = win || {};
    if (!globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME]) globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME] = {}, _a);
    return globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME];
}
function $2a6b20086a42f1ef$var$_getCallbacks() {
    var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
    return globalSettings[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME];
}


var $dae4fc66435db4e1$var$CustomizationsGlobalKey = "customizations";
var $dae4fc66435db4e1$var$NO_CUSTOMIZATIONS = {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
};
var $dae4fc66435db4e1$var$_allSettings = (0, $2a6b20086a42f1ef$export$e962ef7984a884aa).getValue($dae4fc66435db4e1$var$CustomizationsGlobalKey, {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
});
var $dae4fc66435db4e1$var$_events = [];
var $dae4fc66435db4e1$export$cbb5b5586292cdb = /** @class */ function() {
    function Customizations() {}
    Customizations.reset = function() {
        $dae4fc66435db4e1$var$_allSettings.settings = {};
        $dae4fc66435db4e1$var$_allSettings.scopedSettings = {};
    };
    /** Apply global Customization settings.
     * @example Customizations.applySettings(\{ theme: \{...\} \});
     */ Customizations.applySettings = function(settings) {
        $dae4fc66435db4e1$var$_allSettings.settings = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $dae4fc66435db4e1$var$_allSettings.settings), settings);
        Customizations._raiseChange();
    };
    /** Apply Customizations to a particular named scope, like a component.
     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
     */ Customizations.applyScopedSettings = function(scopeName, settings) {
        $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName]), settings);
        Customizations._raiseChange();
    };
    Customizations.getSettings = function(properties, scopeName, localSettings) {
        if (localSettings === void 0) localSettings = $dae4fc66435db4e1$var$NO_CUSTOMIZATIONS;
        var settings = {};
        var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
        var globalScopedSettings = scopeName && $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName] || {};
        for(var _i = 0, properties_1 = properties; _i < properties_1.length; _i++){
            var property = properties_1[_i];
            settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || $dae4fc66435db4e1$var$_allSettings.settings[property];
        }
        return settings;
    };
    /** Used to run some code that sets Customizations without triggering an update until the end.
     * Useful for applying Customizations that don't affect anything currently rendered, or for
     * applying many customizations at once.
     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
     */ Customizations.applyBatchedUpdates = function(code, suppressUpdate) {
        Customizations._suppressUpdates = true;
        try {
            code();
        } catch (_a) {
        /* do nothing */ }
        Customizations._suppressUpdates = false;
        if (!suppressUpdate) Customizations._raiseChange();
    };
    Customizations.observe = function(onChange) {
        $dae4fc66435db4e1$var$_events.push(onChange);
    };
    Customizations.unobserve = function(onChange) {
        $dae4fc66435db4e1$var$_events = $dae4fc66435db4e1$var$_events.filter(function(cb) {
            return cb !== onChange;
        });
    };
    Customizations._raiseChange = function() {
        if (!Customizations._suppressUpdates) $dae4fc66435db4e1$var$_events.forEach(function(cb) {
            return cb();
        });
    };
    return Customizations;
}();


var $3f49b970b29d910a$exports = {};

$parcel$export($3f49b970b29d910a$exports, "loadTheme", () => $3f49b970b29d910a$export$a1d87755f3c9500d);
// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var $3f49b970b29d910a$var$__assign = undefined && undefined.__assign || function() {
    $3f49b970b29d910a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f49b970b29d910a$var$__assign.apply(this, arguments);
};
// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.
var $3f49b970b29d910a$var$_root = typeof window === "undefined" ? $parcel$global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
var $3f49b970b29d910a$var$_styleNonce = $3f49b970b29d910a$var$_root && $3f49b970b29d910a$var$_root.CSPSettings && $3f49b970b29d910a$var$_root.CSPSettings.nonce;
var $3f49b970b29d910a$var$_themeState = $3f49b970b29d910a$var$initializeThemeState();
/**
 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
 */ var $3f49b970b29d910a$var$_themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
var $3f49b970b29d910a$var$now = function() {
    return typeof performance !== "undefined" && !!performance.now ? performance.now() : Date.now();
};
function $3f49b970b29d910a$var$measure(func) {
    var start = $3f49b970b29d910a$var$now();
    func();
    var end = $3f49b970b29d910a$var$now();
    $3f49b970b29d910a$var$_themeState.perf.duration += end - start;
}
/**
 * initialize global state object
 */ function $3f49b970b29d910a$var$initializeThemeState() {
    var state = $3f49b970b29d910a$var$_root.__themeState__ || {
        theme: undefined,
        lastStyleElement: undefined,
        registeredStyles: []
    };
    if (!state.runState) state = $3f49b970b29d910a$var$__assign($3f49b970b29d910a$var$__assign({}, state), {
        perf: {
            count: 0,
            duration: 0
        },
        runState: {
            flushTimer: 0,
            mode: 0 /* Mode.sync */ ,
            buffer: []
        }
    });
    if (!state.registeredThemableStyles) state = $3f49b970b29d910a$var$__assign($3f49b970b29d910a$var$__assign({}, state), {
        registeredThemableStyles: []
    });
    $3f49b970b29d910a$var$_root.__themeState__ = state;
    return state;
}
function $3f49b970b29d910a$export$277cf3cf4a1518cd(styles, loadAsync) {
    if (loadAsync === void 0) loadAsync = false;
    $3f49b970b29d910a$var$measure(function() {
        var styleParts = Array.isArray(styles) ? styles : $3f49b970b29d910a$export$bb01df06f2c55008(styles);
        var _a = $3f49b970b29d910a$var$_themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
        if (loadAsync || mode === 1 /* Mode.async */ ) {
            buffer.push(styleParts);
            if (!flushTimer) $3f49b970b29d910a$var$_themeState.runState.flushTimer = $3f49b970b29d910a$var$asyncLoadStyles();
        } else $3f49b970b29d910a$var$applyThemableStyles(styleParts);
    });
}
function $3f49b970b29d910a$export$181b9c90f55ff807(loadStylesFn) {
    $3f49b970b29d910a$var$_themeState.loadStyles = loadStylesFn;
}
function $3f49b970b29d910a$export$116c501adb0c3234(mode) {
    $3f49b970b29d910a$var$_themeState.runState.mode = mode;
}
function $3f49b970b29d910a$export$4909b86c8034bf73() {
    $3f49b970b29d910a$var$measure(function() {
        var styleArrays = $3f49b970b29d910a$var$_themeState.runState.buffer.slice();
        $3f49b970b29d910a$var$_themeState.runState.buffer = [];
        var mergedStyleArray = [].concat.apply([], styleArrays);
        if (mergedStyleArray.length > 0) $3f49b970b29d910a$var$applyThemableStyles(mergedStyleArray);
    });
}
/**
 * register async loadStyles
 */ function $3f49b970b29d910a$var$asyncLoadStyles() {
    return setTimeout(function() {
        $3f49b970b29d910a$var$_themeState.runState.flushTimer = 0;
        $3f49b970b29d910a$export$4909b86c8034bf73();
    }, 0);
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */ function $3f49b970b29d910a$var$applyThemableStyles(stylesArray, styleRecord) {
    if ($3f49b970b29d910a$var$_themeState.loadStyles) $3f49b970b29d910a$var$_themeState.loadStyles($3f49b970b29d910a$var$resolveThemableArray(stylesArray).styleString, stylesArray);
    else $3f49b970b29d910a$var$registerStyles(stylesArray);
}
function $3f49b970b29d910a$export$a1d87755f3c9500d(theme) {
    $3f49b970b29d910a$var$_themeState.theme = theme;
    // reload styles.
    $3f49b970b29d910a$var$reloadStyles();
}
function $3f49b970b29d910a$export$537f61d53c932351(option) {
    if (option === void 0) option = 3 /* ClearStyleOptions.all */ ;
    if (option === 3 /* ClearStyleOptions.all */  || option === 2 /* ClearStyleOptions.onlyNonThemable */ ) {
        $3f49b970b29d910a$var$clearStylesInternal($3f49b970b29d910a$var$_themeState.registeredStyles);
        $3f49b970b29d910a$var$_themeState.registeredStyles = [];
    }
    if (option === 3 /* ClearStyleOptions.all */  || option === 1 /* ClearStyleOptions.onlyThemable */ ) {
        $3f49b970b29d910a$var$clearStylesInternal($3f49b970b29d910a$var$_themeState.registeredThemableStyles);
        $3f49b970b29d910a$var$_themeState.registeredThemableStyles = [];
    }
}
function $3f49b970b29d910a$var$clearStylesInternal(records) {
    records.forEach(function(styleRecord) {
        var styleElement = styleRecord && styleRecord.styleElement;
        if (styleElement && styleElement.parentElement) styleElement.parentElement.removeChild(styleElement);
    });
}
/**
 * Reloads styles.
 */ function $3f49b970b29d910a$var$reloadStyles() {
    if ($3f49b970b29d910a$var$_themeState.theme) {
        var themableStyles = [];
        for(var _i = 0, _a = $3f49b970b29d910a$var$_themeState.registeredThemableStyles; _i < _a.length; _i++){
            var styleRecord = _a[_i];
            themableStyles.push(styleRecord.themableStyle);
        }
        if (themableStyles.length > 0) {
            $3f49b970b29d910a$export$537f61d53c932351(1 /* ClearStyleOptions.onlyThemable */ );
            $3f49b970b29d910a$var$applyThemableStyles([].concat.apply([], themableStyles));
        }
    }
}
function $3f49b970b29d910a$export$208ca8297aba2218(styles) {
    if (styles) styles = $3f49b970b29d910a$var$resolveThemableArray($3f49b970b29d910a$export$bb01df06f2c55008(styles)).styleString;
    return styles;
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */ function $3f49b970b29d910a$var$resolveThemableArray(splitStyleArray) {
    var theme = $3f49b970b29d910a$var$_themeState.theme;
    var themable = false;
    // Resolve the array of theming instructions to an array of strings.
    // Then join the array to produce the final CSS string.
    var resolvedArray = (splitStyleArray || []).map(function(currentValue) {
        var themeSlot = currentValue.theme;
        if (themeSlot) {
            themable = true;
            // A theming annotation. Resolve it.
            var themedValue = theme ? theme[themeSlot] : undefined;
            var defaultValue = currentValue.defaultValue || "inherit";
            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
            // Allow the themedValue to be undefined to explicitly request the default value.
            if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== "undefined" && DEBUG) console.warn('Theming value not provided for "'.concat(themeSlot, '". Falling back to "').concat(defaultValue, '".'));
            return themedValue || defaultValue;
        } else // A non-themable string. Preserve it.
        return currentValue.rawString;
    });
    return {
        styleString: resolvedArray.join(""),
        themable: themable
    };
}
function $3f49b970b29d910a$export$bb01df06f2c55008(styles) {
    var result = [];
    if (styles) {
        var pos = 0; // Current position in styles.
        var tokenMatch = void 0;
        while(tokenMatch = $3f49b970b29d910a$var$_themeTokenRegex.exec(styles)){
            var matchIndex = tokenMatch.index;
            if (matchIndex > pos) result.push({
                rawString: styles.substring(pos, matchIndex)
            });
            result.push({
                theme: tokenMatch[1],
                defaultValue: tokenMatch[2] // May be undefined
            });
            // index of the first character after the current match
            pos = $3f49b970b29d910a$var$_themeTokenRegex.lastIndex;
        }
        // Push the rest of the string after the last match.
        result.push({
            rawString: styles.substring(pos)
        });
    }
    return result;
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */ function $3f49b970b29d910a$var$registerStyles(styleArray) {
    if (typeof document === "undefined") return;
    var head = document.getElementsByTagName("head")[0];
    var styleElement = document.createElement("style");
    var _a = $3f49b970b29d910a$var$resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
    styleElement.setAttribute("data-load-themed-styles", "true");
    if ($3f49b970b29d910a$var$_styleNonce) styleElement.setAttribute("nonce", $3f49b970b29d910a$var$_styleNonce);
    styleElement.appendChild(document.createTextNode(styleString));
    $3f49b970b29d910a$var$_themeState.perf.count++;
    head.appendChild(styleElement);
    var ev = document.createEvent("HTMLEvents");
    ev.initEvent("styleinsert", true, false);
    ev.args = {
        newStyle: styleElement
    };
    document.dispatchEvent(ev);
    var record = {
        styleElement: styleElement,
        themableStyle: styleArray
    };
    if (themable) $3f49b970b29d910a$var$_themeState.registeredThemableStyles.push(record);
    else $3f49b970b29d910a$var$_themeState.registeredStyles.push(record);
}


// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var $b4b0355870aa648e$export$109c1b21def6ffa4 = {
    themeDarker: "#004578",
    themeDark: "#005a9e",
    themeDarkAlt: "#106ebe",
    themePrimary: "#0078d4",
    themeSecondary: "#2b88d8",
    themeTertiary: "#71afe5",
    themeLight: "#c7e0f4",
    themeLighter: "#deecf9",
    themeLighterAlt: "#eff6fc",
    black: "#000000",
    blackTranslucent40: "rgba(0,0,0,.4)",
    neutralDark: "#201f1e",
    neutralPrimary: "#323130",
    neutralPrimaryAlt: "#3b3a39",
    neutralSecondary: "#605e5c",
    neutralSecondaryAlt: "#8a8886",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#c8c6c4",
    neutralQuaternary: "#d2d0ce",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralLight: "#edebe9",
    neutralLighter: "#f3f2f1",
    neutralLighterAlt: "#faf9f8",
    accent: "#0078d4",
    white: "#ffffff",
    whiteTranslucent40: "rgba(255,255,255,.4)",
    yellowDark: "#d29200",
    yellow: "#ffb900",
    yellowLight: "#fff100",
    orange: "#d83b01",
    orangeLight: "#ea4300",
    orangeLighter: "#ff8c00",
    redDark: "#a4262c",
    red: "#e81123",
    magentaDark: "#5c005c",
    magenta: "#b4009e",
    magentaLight: "#e3008c",
    purpleDark: "#32145a",
    purple: "#5c2d91",
    purpleLight: "#b4a0ff",
    blueDark: "#002050",
    blueMid: "#00188f",
    blue: "#0078d4",
    blueLight: "#00bcf2",
    tealDark: "#004b50",
    teal: "#008272",
    tealLight: "#00b294",
    greenDark: "#004b1c",
    green: "#107c10",
    greenLight: "#bad80a"
};


var $f656f986859a9dca$export$9b00c83187ceb0d1;
(function(Depths) {
    Depths.depth0 = "0 0 0 0 transparent";
    Depths.depth4 = "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth8 = "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth16 = "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth64 = "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)";
})($f656f986859a9dca$export$9b00c83187ceb0d1 || ($f656f986859a9dca$export$9b00c83187ceb0d1 = {}));


var $b23fc3a5e3a63797$export$1b052b16bf67042a = {
    elevation4: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth4,
    elevation8: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth8,
    elevation16: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth16,
    elevation64: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth64,
    roundedCorner2: "2px",
    roundedCorner4: "4px",
    roundedCorner6: "6px"
};





function $14126b943c3ed2af$export$566c6c2ff0443c7(font) {
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var rule = (0, $3984cc6e71239662$export$4080b13ebe249c61)((0, $83a2b0773b0b5f26$export$6c4e12d3949051a)(), font);
    var className = stylesheet.classNameFromKey(rule);
    if (className) return;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@font-face{".concat(rule, "}"), true);
    stylesheet.cacheClassName(name, rule, [], [
        "font-face",
        rule
    ]);
}




// Fallback fonts, if specified system or web fonts are unavailable.
var $34eafb537e5c5200$var$FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var $34eafb537e5c5200$var$defaultFontFamily = "'Segoe UI', '".concat((0, $1ba480b26914dcf0$export$ed6682c3a2de350f).WestEuropean, "'");
// Mapping of language prefix to to font family.
var $34eafb537e5c5200$var$LanguageToFontMap = {
    ar: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Arabic,
    bg: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    cs: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    el: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Greek,
    et: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    he: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Hebrew,
    hi: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Hindi,
    hr: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    hu: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ja: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Japanese,
    kk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ko: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Korean,
    lt: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    lv: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    pl: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ru: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    sk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    "sr-latn": (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    th: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Thai,
    tr: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    uk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    vi: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Vietnamese,
    "zh-hans": (0, $1ba480b26914dcf0$export$a84f0633d5188de4).ChineseSimplified,
    "zh-hant": (0, $1ba480b26914dcf0$export$a84f0633d5188de4).ChineseTraditional,
    hy: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Armenian,
    ka: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Georgian
};
function $34eafb537e5c5200$var$_fontFamilyWithFallbacks(fontFamily) {
    return "".concat(fontFamily, ", ").concat($34eafb537e5c5200$var$FontFamilyFallbacks);
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */ function $34eafb537e5c5200$var$_getLocalizedFontFamily(language) {
    for(var lang in $34eafb537e5c5200$var$LanguageToFontMap){
        if ($34eafb537e5c5200$var$LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $34eafb537e5c5200$var$LanguageToFontMap[lang];
    }
    return $34eafb537e5c5200$var$defaultFontFamily;
}
function $34eafb537e5c5200$var$_createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        fontSize: size,
        fontWeight: weight
    };
}
function $34eafb537e5c5200$export$a4fa8de6a1c20b63(localeCode) {
    var localizedFont = $34eafb537e5c5200$var$_getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = $34eafb537e5c5200$var$_fontFamilyWithFallbacks(localizedFont);
    var fontStyles = {
        tiny: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mini, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xSmall: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xSmall, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        small: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).small, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        smallPlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).smallPlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        medium: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).medium, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        mediumPlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mediumPlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        large: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).large, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xLargePlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xLargePlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xxLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLargePlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xxLargePlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        superLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).superLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        mega: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mega, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback)
    };
    return fontStyles;
}



function $6787cc90d6254b3e$export$f65ca476c09acec0(rootElement) {
    if (!(0, $18aa0efffa2a3752$export$71594e8a50f746f4)() || typeof document === "undefined") return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument ? el.ownerDocument : document;
    }
}



function $f962a8dfcd8ca8ce$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        result = win ? win.localStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $f962a8dfcd8ca8ce$export$8a8216c44337cd5(key, data) {
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        win && win.localStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}



function $6e93d649f0f85bbf$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        result = win ? win.sessionStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $6e93d649f0f85bbf$export$8a8216c44337cd5(key, data) {
    var _a;
    try {
        (_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) === null || _a === void 0 || _a.sessionStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}


// Default to undefined so that we initialize on first read.
var $4a1314ddc25702e6$var$_language;
var $4a1314ddc25702e6$var$STORAGE_KEY = "language";
function $4a1314ddc25702e6$export$64783e31db14f0ba(persistenceType) {
    if (persistenceType === void 0) persistenceType = "sessionStorage";
    if ($4a1314ddc25702e6$var$_language === undefined) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        var savedLanguage = persistenceType === "localStorage" ? $f962a8dfcd8ca8ce$export$f92dfeb71e9bb569($4a1314ddc25702e6$var$STORAGE_KEY) : persistenceType === "sessionStorage" ? $6e93d649f0f85bbf$export$f92dfeb71e9bb569($4a1314ddc25702e6$var$STORAGE_KEY) : undefined;
        if (savedLanguage) $4a1314ddc25702e6$var$_language = savedLanguage;
        if ($4a1314ddc25702e6$var$_language === undefined && doc) $4a1314ddc25702e6$var$_language = doc.documentElement.getAttribute("lang");
        if ($4a1314ddc25702e6$var$_language === undefined) $4a1314ddc25702e6$var$_language = "en";
    }
    return $4a1314ddc25702e6$var$_language;
}
function $4a1314ddc25702e6$export$4b6bf64406ec64af(language, persistenceParam) {
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute("lang", language);
    var persistenceType = persistenceParam === true ? "none" : !persistenceParam ? "sessionStorage" : persistenceParam;
    if (persistenceType === "localStorage") $f962a8dfcd8ca8ce$export$8a8216c44337cd5($4a1314ddc25702e6$var$STORAGE_KEY, language);
    else if (persistenceType === "sessionStorage") $6e93d649f0f85bbf$export$8a8216c44337cd5($4a1314ddc25702e6$var$STORAGE_KEY, language);
    $4a1314ddc25702e6$var$_language = language;
}


// Default urls.
var $f4e14b7f1ed61365$var$DefaultBaseUrl = "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets";
var $f4e14b7f1ed61365$export$3d534eec2182c14b = (0, $34eafb537e5c5200$export$a4fa8de6a1c20b63)((0, $4a1314ddc25702e6$export$64783e31db14f0ba)());
function $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'".concat(fontFamily, "'");
    var localFontSrc = localFontName !== undefined ? "local('".concat(localFontName, "'),") : "";
    (0, $14126b943c3ed2af$export$566c6c2ff0443c7)({
        fontFamily: fontFamily,
        src: localFontSrc + "url('".concat(url, ".woff2') format('woff2'),") + "url('".concat(url, ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: "normal",
        fontDisplay: "swap"
    });
}
function $f4e14b7f1ed61365$var$_registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === void 0) cdnFontName = "segoeui";
    var urlBase = "".concat(baseUrl, "/").concat(cdnFolder, "/").concat(cdnFontName);
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + "-light", (0, $1ba480b26914dcf0$export$32743b01f42d159e).light, localFontName && localFontName + " Light");
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + "-semilight", (0, $1ba480b26914dcf0$export$32743b01f42d159e).semilight, localFontName && localFontName + " SemiLight");
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + "-regular", (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, localFontName);
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + "-semibold", (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, localFontName && localFontName + " SemiBold");
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + "-bold", (0, $1ba480b26914dcf0$export$32743b01f42d159e).bold, localFontName && localFontName + " Bold");
}
function $f4e14b7f1ed61365$export$1c5ba4c2e362bd9e(baseUrl) {
    if (baseUrl) {
        var fontUrl = "".concat(baseUrl, "/fonts");
        // Produce @font-face definitions for all supported web fonts.
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Thai, "leelawadeeui-thai", "leelawadeeui");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Arabic, "segoeui-arabic");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Cyrillic, "segoeui-cyrillic");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).EastEuropean, "segoeui-easteuropean");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Greek, "segoeui-greek");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Hebrew, "segoeui-hebrew");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Vietnamese, "segoeui-vietnamese");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).WestEuropean, "segoeui-westeuropean", "segoeui", "Segoe UI");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Selawik, "selawik", "selawik");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Armenian, "segoeui-armenian");
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Georgian, "segoeui-georgian");
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        $f4e14b7f1ed61365$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-semilight"), (0, $1ba480b26914dcf0$export$32743b01f42d159e).light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        $f4e14b7f1ed61365$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-bold"), (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */ function $f4e14b7f1ed61365$var$_getFontBaseUrl() {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var fabricConfig = (_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
    return (_b = fabricConfig === null || fabricConfig === void 0 ? void 0 : fabricConfig.fontBaseUrl) !== null && _b !== void 0 ? _b : $f4e14b7f1ed61365$var$DefaultBaseUrl;
}
/**
 * Register the font faces.
 */ $f4e14b7f1ed61365$export$1c5ba4c2e362bd9e($f4e14b7f1ed61365$var$_getFontBaseUrl());


/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */ function $6f99f03776d37396$export$4950aa0f605343fb(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        $6f99f03776d37396$var$_merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6f99f03776d37396$var$_merge(target, source, circularReferences) {
    if (circularReferences === void 0) circularReferences = [];
    circularReferences.push(source);
    for(var name_1 in source){
        if (source.hasOwnProperty(name_1)) {
            if (name_1 !== "__proto__" && name_1 !== "constructor" && name_1 !== "prototype") {
                var value = source[name_1];
                if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                    var isCircularReference = circularReferences.indexOf(value) > -1;
                    target[name_1] = isCircularReference ? value : $6f99f03776d37396$var$_merge(target[name_1] || {}, value, circularReferences);
                } else target[name_1] = value;
            }
        }
    }
    circularReferences.pop();
    return target;
}



function $121003e76cb3da39$export$1084519c371c0719(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var semanticColors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        primaryButtonBorder: "transparent",
        errorText: !isInverted ? "#a4262c" : "#F1707B",
        messageText: !isInverted ? "#323130" : "#F3F2F1",
        messageLink: !isInverted ? "#005A9E" : "#6CB8F6",
        messageLinkHovered: !isInverted ? "#004578" : "#82C7FF",
        infoIcon: !isInverted ? "#605e5c" : "#C8C6C4",
        errorIcon: !isInverted ? "#A80000" : "#F1707B",
        blockingIcon: !isInverted ? "#FDE7E9" : "#442726",
        warningIcon: !isInverted ? "#797775" : "#C8C6C4",
        severeWarningIcon: !isInverted ? "#D83B01" : "#FCE100",
        successIcon: !isInverted ? "#107C10" : "#92C353",
        infoBackground: !isInverted ? "#f3f2f1" : "#323130",
        errorBackground: !isInverted ? "#FDE7E9" : "#442726",
        blockingBackground: !isInverted ? "#FDE7E9" : "#442726",
        warningBackground: !isInverted ? "#FFF4CE" : "#433519",
        severeWarningBackground: !isInverted ? "#FED9CC" : "#4F2A0F",
        successBackground: !isInverted ? "#DFF6DD" : "#393D1B",
        // deprecated
        warningHighlight: !isInverted ? "#ffb900" : "#fff100",
        successText: !isInverted ? "#107C10" : "#92c353"
    }, s);
    var fullSemanticColors = $121003e76cb3da39$export$aca509a1becd8a60(p, e, semanticColors, isInverted);
    return $121003e76cb3da39$var$_fixDeprecatedSlots(fullSemanticColors, depComments);
}
function $121003e76cb3da39$export$aca509a1becd8a60(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var result = {};
    // map palette
    var _a = p || {}, white = _a.white, black = _a.black, themePrimary = _a.themePrimary, themeDark = _a.themeDark, themeDarker = _a.themeDarker, themeDarkAlt = _a.themeDarkAlt, themeLighter = _a.themeLighter, neutralLight = _a.neutralLight, neutralLighter = _a.neutralLighter, neutralDark = _a.neutralDark, neutralQuaternary = _a.neutralQuaternary, neutralQuaternaryAlt = _a.neutralQuaternaryAlt, neutralPrimary = _a.neutralPrimary, neutralSecondary = _a.neutralSecondary, neutralSecondaryAlt = _a.neutralSecondaryAlt, neutralTertiary = _a.neutralTertiary, neutralTertiaryAlt = _a.neutralTertiaryAlt, neutralLighterAlt = _a.neutralLighterAlt, accent = _a.accent;
    if (white) {
        result.bodyBackground = white;
        result.bodyFrameBackground = white;
        result.accentButtonText = white;
        result.buttonBackground = white;
        result.primaryButtonText = white;
        result.primaryButtonTextHovered = white;
        result.primaryButtonTextPressed = white;
        result.inputBackground = white;
        result.inputForegroundChecked = white;
        result.listBackground = white;
        result.menuBackground = white;
        result.cardStandoutBackground = white;
    }
    if (black) {
        result.bodyTextChecked = black;
        result.buttonTextCheckedHovered = black;
    }
    if (themePrimary) {
        result.link = themePrimary;
        result.primaryButtonBackground = themePrimary;
        result.inputBackgroundChecked = themePrimary;
        result.inputIcon = themePrimary;
        result.inputFocusBorderAlt = themePrimary;
        result.menuIcon = themePrimary;
        result.menuHeader = themePrimary;
        result.accentButtonBackground = themePrimary;
    }
    if (themeDark) {
        result.primaryButtonBackgroundPressed = themeDark;
        result.inputBackgroundCheckedHovered = themeDark;
        result.inputIconHovered = themeDark;
    }
    if (themeDarker) result.linkHovered = themeDarker;
    if (themeDarkAlt) result.primaryButtonBackgroundHovered = themeDarkAlt;
    if (themeLighter) result.inputPlaceholderBackgroundChecked = themeLighter;
    if (neutralLight) {
        result.bodyBackgroundChecked = neutralLight;
        result.bodyFrameDivider = neutralLight;
        result.bodyDivider = neutralLight;
        result.variantBorder = neutralLight;
        result.buttonBackgroundCheckedHovered = neutralLight;
        result.buttonBackgroundPressed = neutralLight;
        result.listItemBackgroundChecked = neutralLight;
        result.listHeaderBackgroundPressed = neutralLight;
        result.menuItemBackgroundPressed = neutralLight;
        // eslint-disable-next-line deprecation/deprecation
        result.menuItemBackgroundChecked = neutralLight;
    }
    if (neutralLighter) {
        result.bodyBackgroundHovered = neutralLighter;
        result.buttonBackgroundHovered = neutralLighter;
        result.buttonBackgroundDisabled = neutralLighter;
        result.buttonBorderDisabled = neutralLighter;
        result.primaryButtonBackgroundDisabled = neutralLighter;
        result.disabledBackground = neutralLighter;
        result.listItemBackgroundHovered = neutralLighter;
        result.listHeaderBackgroundHovered = neutralLighter;
        result.menuItemBackgroundHovered = neutralLighter;
    }
    if (neutralQuaternary) {
        result.primaryButtonTextDisabled = neutralQuaternary;
        result.disabledSubtext = neutralQuaternary;
    }
    if (neutralQuaternaryAlt) result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
    if (neutralTertiary) {
        result.disabledBodyText = neutralTertiary;
        result.variantBorderHovered = (s === null || s === void 0 ? void 0 : s.variantBorderHovered) || neutralTertiary;
        result.buttonTextDisabled = neutralTertiary;
        result.inputIconDisabled = neutralTertiary;
        result.disabledText = neutralTertiary;
    }
    if (neutralPrimary) {
        result.bodyText = neutralPrimary;
        result.actionLink = neutralPrimary;
        result.buttonText = neutralPrimary;
        result.inputBorderHovered = neutralPrimary;
        result.inputText = neutralPrimary;
        result.listText = neutralPrimary;
        result.menuItemText = neutralPrimary;
    }
    if (neutralLighterAlt) {
        result.bodyStandoutBackground = neutralLighterAlt;
        result.defaultStateBackground = neutralLighterAlt;
    }
    if (neutralDark) {
        result.actionLinkHovered = neutralDark;
        result.buttonTextHovered = neutralDark;
        result.buttonTextChecked = neutralDark;
        result.buttonTextPressed = neutralDark;
        result.inputTextHovered = neutralDark;
        result.menuItemTextHovered = neutralDark;
    }
    if (neutralSecondary) {
        result.bodySubtext = neutralSecondary;
        result.focusBorder = neutralSecondary;
        result.inputBorder = neutralSecondary;
        result.smallInputBorder = neutralSecondary;
        result.inputPlaceholderText = neutralSecondary;
    }
    if (neutralSecondaryAlt) result.buttonBorder = neutralSecondaryAlt;
    if (neutralTertiaryAlt) {
        result.disabledBodySubtext = neutralTertiaryAlt;
        result.disabledBorder = neutralTertiaryAlt;
        result.buttonBackgroundChecked = neutralTertiaryAlt;
        result.menuDivider = neutralTertiaryAlt;
    }
    if (accent) result.accentButtonBackground = accent;
    // map effects
    if (e === null || e === void 0 ? void 0 : e.elevation4) result.cardShadow = e.elevation4;
    if (!isInverted && (e === null || e === void 0 ? void 0 : e.elevation8)) result.cardShadowHovered = e.elevation8;
    else if (result.variantBorderHovered) result.cardShadowHovered = "0 0 1px " + result.variantBorderHovered;
    result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), s);
    return result;
}
function $121003e76cb3da39$var$_fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = "";
    if (depComments === true) dep = " /* @deprecated */";
    /* eslint-disable deprecation/deprecation */ s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    s.warningHighlight += dep;
    s.warningText = s.messageText + dep;
    s.successText += dep;
    /* eslint-enable deprecation/deprecation */ return s;
}


function $535786ba16bdff82$export$919aa3481b25eaec(theme, partialTheme) {
    var _a, _b, _c;
    if (partialTheme === void 0) partialTheme = {};
    var mergedTheme = (0, $6f99f03776d37396$export$4950aa0f605343fb)({}, theme, partialTheme, {
        semanticColors: (0, $121003e76cb3da39$export$aca509a1becd8a60)(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
    });
    if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) mergedTheme.palette.accent = partialTheme.palette.themePrimary;
    if (partialTheme.defaultFontStyle) for(var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++){
        var fontStyle = _d[_i];
        mergedTheme.fonts[fontStyle] = (0, $6f99f03776d37396$export$4950aa0f605343fb)(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === void 0 ? void 0 : partialTheme.fonts) === null || _c === void 0 ? void 0 : _c[fontStyle]);
    }
    return mergedTheme;
}


var $2587f08b2750d110$export$f1e7669f0aafe571 = {
    s2: "4px",
    s1: "8px",
    m: "16px",
    l1: "20px",
    l2: "32px"
};



function $49b644eef671596b$export$25d302a5b900a763(theme, depComments) {
    if (theme === void 0) theme = {};
    if (depComments === void 0) depComments = false;
    var isInverted = !!theme.isInverted;
    var baseTheme = {
        palette: (0, $b4b0355870aa648e$export$109c1b21def6ffa4),
        effects: (0, $b23fc3a5e3a63797$export$1b052b16bf67042a),
        fonts: (0, $f4e14b7f1ed61365$export$3d534eec2182c14b),
        spacing: (0, $2587f08b2750d110$export$f1e7669f0aafe571),
        isInverted: isInverted,
        disableGlobalClassNames: false,
        semanticColors: (0, $121003e76cb3da39$export$1084519c371c0719)((0, $b4b0355870aa648e$export$109c1b21def6ffa4), (0, $b23fc3a5e3a63797$export$1b052b16bf67042a), undefined, isInverted, depComments),
        rtl: undefined
    };
    return (0, $535786ba16bdff82$export$919aa3481b25eaec)(baseTheme, theme);
}


var $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)({});
var $756f0943cb677ee4$var$_onThemeChangeCallbacks = [];
var $756f0943cb677ee4$export$cf613f78cce4b73f = "theme";
function $756f0943cb677ee4$export$8a248add43552e89() {
    var _a;
    var _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    if ((_b = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _b === void 0 ? void 0 : _b.legacyTheme) // does everything the `else` clause does and more, such as invoke legacy theming
    $756f0943cb677ee4$export$a1d87755f3c9500d(win.FabricConfig.legacyTheme);
    else if (!(0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings([
        $756f0943cb677ee4$export$cf613f78cce4b73f
    ]).theme) {
        if ((_c = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _c === void 0 ? void 0 : _c.theme) $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)(win.FabricConfig.theme);
        // Set the default theme.
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$756f0943cb677ee4$export$cf613f78cce4b73f] = $756f0943cb677ee4$var$_theme, _a));
    }
}
$756f0943cb677ee4$export$8a248add43552e89();
function $756f0943cb677ee4$export$89cbf1a0881c8b9c(depComments) {
    if (depComments === void 0) depComments = false;
    if (depComments === true) $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)({}, depComments);
    return $756f0943cb677ee4$var$_theme;
}
function $756f0943cb677ee4$export$e7b32ab372e04de(callback) {
    if ($756f0943cb677ee4$var$_onThemeChangeCallbacks.indexOf(callback) === -1) $756f0943cb677ee4$var$_onThemeChangeCallbacks.push(callback);
}
function $756f0943cb677ee4$export$d0ea9fdf152462c9(callback) {
    var i = $756f0943cb677ee4$var$_onThemeChangeCallbacks.indexOf(callback);
    if (i === -1) return;
    $756f0943cb677ee4$var$_onThemeChangeCallbacks.splice(i, 1);
}
function $756f0943cb677ee4$export$a1d87755f3c9500d(theme, depComments) {
    var _a;
    if (depComments === void 0) depComments = false;
    $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    (0, $3f49b970b29d910a$exports.loadTheme)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $756f0943cb677ee4$var$_theme.palette), $756f0943cb677ee4$var$_theme.semanticColors), $756f0943cb677ee4$var$_theme.effects), $756f0943cb677ee4$var$_loadFonts($756f0943cb677ee4$var$_theme)));
    (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$756f0943cb677ee4$export$cf613f78cce4b73f] = $756f0943cb677ee4$var$_theme, _a));
    $756f0943cb677ee4$var$_onThemeChangeCallbacks.forEach(function(callback) {
        try {
            callback($756f0943cb677ee4$var$_theme);
        } catch (e) {
        // don't let a bad callback break everything else
        }
    });
    return $756f0943cb677ee4$var$_theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */ function $756f0943cb677ee4$var$_loadFonts(theme) {
    var lines = {};
    for(var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++){
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for(var _b = 0, _c = Object.keys(font); _b < _c.length; _b++){
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === "fontSize" && typeof value === "number") // if it's a number, convert it to px by default like our theming system does
            value = value + "px";
            lines[name_1] = value;
        }
    }
    return lines;
}

var $34563ae103a23d08$export$35835471cbe77db4 = {
    position: "absolute",
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: "hidden",
    whiteSpace: "nowrap"
};

// This file mimics styles and mixins from _General.Mixins.scss
var $3472c0f90c64fe40$export$a3295358bff77e = {
    boxShadow: "none",
    margin: 0,
    padding: 0,
    boxSizing: "border-box"
};
var $3472c0f90c64fe40$export$2e0098041746c0f4 = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};



/* eslint-disable no-console */ var $6f044242a3d99d90$var$_warningCallback = undefined;
function $6f044242a3d99d90$export$c106dd0671a0fc2d(message) {
    if (console && console.warn) console.warn(message);
}
function $6f044242a3d99d90$export$70b267401ac98961(warningCallback) {
    $6f044242a3d99d90$var$_warningCallback = warningCallback;
}



var $157fc0f40a8f1c26$var$ICON_SETTING_NAME = "icons";
var $157fc0f40a8f1c26$var$_iconSettings = (0, $2a6b20086a42f1ef$export$e962ef7984a884aa).getValue($157fc0f40a8f1c26$var$ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true
    },
    __remapped: {}
});
// Reset icon registration on stylesheet resets.
var $157fc0f40a8f1c26$var$stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
if ($157fc0f40a8f1c26$var$stylesheet && $157fc0f40a8f1c26$var$stylesheet.onReset) $157fc0f40a8f1c26$var$stylesheet.onReset(function() {
    for(var name_1 in $157fc0f40a8f1c26$var$_iconSettings)if ($157fc0f40a8f1c26$var$_iconSettings.hasOwnProperty(name_1) && !!$157fc0f40a8f1c26$var$_iconSettings[name_1].subset) $157fc0f40a8f1c26$var$_iconSettings[name_1].subset.className = undefined;
});
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */ var $157fc0f40a8f1c26$var$normalizeIconName = function(name) {
    return name.toLowerCase();
};
function $157fc0f40a8f1c26$export$99b432e1290ef823(iconSubset, options) {
    var subset = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, iconSubset), {
        isRegistered: false,
        className: undefined
    });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $157fc0f40a8f1c26$var$_iconSettings.__options), options) : $157fc0f40a8f1c26$var$_iconSettings.__options;
    for(var iconName in icons)if (icons.hasOwnProperty(iconName)) {
        var code = icons[iconName];
        var normalizedIconName = $157fc0f40a8f1c26$var$normalizeIconName(iconName);
        if ($157fc0f40a8f1c26$var$_iconSettings[normalizedIconName]) $157fc0f40a8f1c26$var$_warnDuplicateIcon(iconName);
        else $157fc0f40a8f1c26$var$_iconSettings[normalizedIconName] = {
            code: code,
            subset: subset
        };
    }
}
function $157fc0f40a8f1c26$export$d4eb2d2d2a4efe94(iconNames) {
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    var _loop_1 = function(iconName) {
        var normalizedIconName = $157fc0f40a8f1c26$var$normalizeIconName(iconName);
        if ($157fc0f40a8f1c26$var$_iconSettings[normalizedIconName]) delete $157fc0f40a8f1c26$var$_iconSettings[normalizedIconName];
        else // Warn that we are trying to delete an icon that doesn't exist
        if (!options.disableWarnings) (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)('The icon "'.concat(iconName, '" tried to unregister but was not registered.'));
        // Delete any aliases for this iconName
        if ($157fc0f40a8f1c26$var$_iconSettings.__remapped[normalizedIconName]) delete $157fc0f40a8f1c26$var$_iconSettings.__remapped[normalizedIconName];
        // Delete any items that were an alias for this iconName
        Object.keys($157fc0f40a8f1c26$var$_iconSettings.__remapped).forEach(function(key) {
            if ($157fc0f40a8f1c26$var$_iconSettings.__remapped[key] === normalizedIconName) delete $157fc0f40a8f1c26$var$_iconSettings.__remapped[key];
        });
    };
    for(var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++){
        var iconName = iconNames_1[_i];
        _loop_1(iconName);
    }
}
function $157fc0f40a8f1c26$export$4fad376c7613260(iconName, mappedToName) {
    $157fc0f40a8f1c26$var$_iconSettings.__remapped[$157fc0f40a8f1c26$var$normalizeIconName(iconName)] = $157fc0f40a8f1c26$var$normalizeIconName(mappedToName);
}
function $157fc0f40a8f1c26$export$16b26cd5e98d9100(name) {
    var icon = undefined;
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    name = name ? $157fc0f40a8f1c26$var$normalizeIconName(name) : "";
    name = $157fc0f40a8f1c26$var$_iconSettings.__remapped[name] || name;
    if (name) {
        icon = $157fc0f40a8f1c26$var$_iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    (0, $14126b943c3ed2af$export$566c6c2ff0443c7)(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) subset.className = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(subset.style, {
                    fontFamily: subset.fontFace.fontFamily,
                    fontWeight: subset.fontFace.fontWeight || "normal",
                    fontStyle: subset.fontFace.fontStyle || "normal"
                });
            }
        } else // eslint-disable-next-line deprecation/deprecation
        if (!options.disableWarnings && options.warnOnMissingIcons) (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)('The icon "'.concat(name, '" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information.'));
    }
    return icon;
}
function $157fc0f40a8f1c26$export$931896f68834c675(options) {
    $157fc0f40a8f1c26$var$_iconSettings.__options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $157fc0f40a8f1c26$var$_iconSettings.__options), options);
}
var $157fc0f40a8f1c26$var$_missingIcons = [];
var $157fc0f40a8f1c26$var$_missingIconsTimer = undefined;
function $157fc0f40a8f1c26$var$_warnDuplicateIcon(iconName) {
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        $157fc0f40a8f1c26$var$_missingIcons.push(iconName);
        if ($157fc0f40a8f1c26$var$_missingIconsTimer === undefined) $157fc0f40a8f1c26$var$_missingIconsTimer = setTimeout(function() {
            (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)("Some icons were re-registered. Applications should only call registerIcons for any given icon once. Redefining what an icon is may have unintended consequences. Duplicates include: \n" + $157fc0f40a8f1c26$var$_missingIcons.slice(0, maxIconsInMessage).join(", ") + ($157fc0f40a8f1c26$var$_missingIcons.length > maxIconsInMessage ? " (+ ".concat($157fc0f40a8f1c26$var$_missingIcons.length - maxIconsInMessage, " more)") : ""));
            $157fc0f40a8f1c26$var$_missingIconsTimer = undefined;
            $157fc0f40a8f1c26$var$_missingIcons = [];
        }, warningDelay);
    }
}




function $9f80d64ff1d557a5$export$b9e8701096551fdc() {
    var styleSets = [];
    for(var _i = 0; _i < arguments.length; _i++)styleSets[_i] = arguments[_i];
    if (styleSets && styleSets.length === 1 && styleSets[0] && !styleSets[0].subComponentStyles) return styleSets[0];
    var mergedSet = {};
    // We process sub component styles in two phases. First we collect them, then we combine them into 1 style function.
    var workingSubcomponentStyles = {};
    for(var _a = 0, styleSets_1 = styleSets; _a < styleSets_1.length; _a++){
        var currentSet = styleSets_1[_a];
        if (currentSet) {
            for(var prop in currentSet)if (currentSet.hasOwnProperty(prop)) {
                if (prop === "subComponentStyles" && currentSet.subComponentStyles !== undefined) {
                    // subcomponent styles - style functions or objects
                    var currentComponentStyles = currentSet.subComponentStyles;
                    for(var subCompProp in currentComponentStyles)if (currentComponentStyles.hasOwnProperty(subCompProp)) {
                        if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) workingSubcomponentStyles[subCompProp].push(currentComponentStyles[subCompProp]);
                        else workingSubcomponentStyles[subCompProp] = [
                            currentComponentStyles[subCompProp]
                        ];
                    }
                    continue;
                }
                // the as any casts below is a workaround for ts 2.8.
                // todo: remove cast to any in ts 2.9.
                var mergedValue = mergedSet[prop];
                var currentValue = currentSet[prop];
                if (mergedValue === undefined) mergedSet[prop] = currentValue;
                else mergedSet[prop] = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], Array.isArray(mergedValue) ? mergedValue : [
                    mergedValue
                ], true), Array.isArray(currentValue) ? currentValue : [
                    currentValue
                ], true);
            }
        }
    }
    if (Object.keys(workingSubcomponentStyles).length > 0) {
        mergedSet.subComponentStyles = {};
        var mergedSubStyles = mergedSet.subComponentStyles;
        var _loop_1 = function(subCompProp) {
            if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                var workingSet_1 = workingSubcomponentStyles[subCompProp];
                mergedSubStyles[subCompProp] = function(styleProps) {
                    return $9f80d64ff1d557a5$export$b9e8701096551fdc.apply(void 0, workingSet_1.map(function(styleFunctionOrObject) {
                        return typeof styleFunctionOrObject === "function" ? styleFunctionOrObject(styleProps) : styleFunctionOrObject;
                    }));
                };
            }
        };
        // now we process the subcomponent styles if there are any
        for(var subCompProp in workingSubcomponentStyles)_loop_1(subCompProp);
    }
    return mergedSet;
}


function $386ae5a2cd0e8632$export$5136bfd779f95982(styleProps) {
    var allStyles = [];
    for(var _i = 1; _i < arguments.length; _i++)allStyles[_i - 1] = arguments[_i];
    var result = [];
    for(var _a = 0, allStyles_1 = allStyles; _a < allStyles_1.length; _a++){
        var styles = allStyles_1[_a];
        if (styles) result.push(typeof styles === "function" ? styles(styleProps) : styles);
    }
    if (result.length === 1) return result[0];
    else if (result.length) // cliffkoh: I cannot figure out how to avoid the cast to any here.
    // It is something to do with the use of Omit in IStyleSet.
    // It might not be necessary once  Omit becomes part of lib.d.ts (when we remove our own Omit and rely on
    // the official version).
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, result);
    return {};
}





function $00784e00f3e28b27$export$fbaf15ac64fa8f3e() {
    var styleSets = [];
    for(var _i = 0; _i < arguments.length; _i++)styleSets[_i] = arguments[_i];
    return $00784e00f3e28b27$export$3ea21144e9973d29(styleSets, (0, $83a2b0773b0b5f26$export$6c4e12d3949051a)());
}
function $00784e00f3e28b27$export$3ea21144e9973d29(styleSets, options) {
    var classNameSet = {
        subComponentStyles: {}
    };
    var styleSet = styleSets[0];
    if (!styleSet && styleSets.length <= 1) return {
        subComponentStyles: {}
    };
    var concatenatedStyleSet = (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, styleSets);
    var registrations = [];
    for(var styleSetArea in concatenatedStyleSet)if (concatenatedStyleSet.hasOwnProperty(styleSetArea)) {
        if (styleSetArea === "subComponentStyles") {
            classNameSet.subComponentStyles = concatenatedStyleSet.subComponentStyles || {};
            continue;
        }
        var styles = concatenatedStyleSet[styleSetArea];
        var _a = (0, $1fbb556661b56077$export$b1c01d3d68dc0b88)(styles), classes = _a.classes, objects = _a.objects;
        if (objects === null || objects === void 0 ? void 0 : objects.length) {
            var registration = (0, $3984cc6e71239662$export$f51c5a57f5409a02)(options || {}, {
                displayName: styleSetArea
            }, objects);
            if (registration) {
                registrations.push(registration);
                // FIXME: classNameSet invalid types - exposed in TS 4.5 - cast needed
                classNameSet[styleSetArea] = classes.concat([
                    registration.className
                ]).join(" ");
            }
        } else // FIXME: classNameSet invalid types - exposed in TS 4.5 - cast needed
        classNameSet[styleSetArea] = classes.join(" ");
    }
    for(var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++){
        var registration = registrations_1[_i];
        if (registration) (0, $3984cc6e71239662$export$cf30abcc7f4a413c)(registration, options === null || options === void 0 ? void 0 : options.specificityMultiplier);
    }
    return classNameSet;
}


var $1886b30a34b0cd2c$export$61818e3b2f7b5d12 = "https://res.cdn.office.net/files/fabric-cdn-prod_20230524.001";


// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var $8bcf2d68614748d6$var$packagesCache = {};
// Cache access to window to avoid IE11 memory leak.
var $8bcf2d68614748d6$var$_win = undefined;
try {
    $8bcf2d68614748d6$var$_win = window;
} catch (e) {
/* no-op */ }
function $8bcf2d68614748d6$export$f99c3c9c04cda7ae(packageName, packageVersion) {
    if (typeof $8bcf2d68614748d6$var$_win !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var packages = $8bcf2d68614748d6$var$_win.__packages__ = $8bcf2d68614748d6$var$_win.__packages__ || {};
        // We allow either the global packages or local packages caches to invalidate so testing can
        // just clear the global to set this state
        if (!packages[packageName] || !$8bcf2d68614748d6$var$packagesCache[packageName]) {
            $8bcf2d68614748d6$var$packagesCache[packageName] = packageVersion;
            var versions = packages[packageName] = packages[packageName] || [];
            versions.push(packageVersion);
        }
    }
}


(0, $8bcf2d68614748d6$export$f99c3c9c04cda7ae)("@fluentui/set-version", "6.0.0");


(0, $8bcf2d68614748d6$export$f99c3c9c04cda7ae)("@fluentui/style-utilities", "8.9.16");



(0, $756f0943cb677ee4$export$8a248add43552e89)();


function $8ad0e698627a4235$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons"',
            src: "url('".concat(baseUrl, "fabric-icons-a13498cf.woff') format('woff')")
        },
        icons: {
            GlobalNavButton: "",
            ChevronDown: "",
            ChevronUp: "",
            Edit: "",
            Add: "",
            Cancel: "",
            More: "",
            Settings: "",
            Mail: "",
            Filter: "",
            Search: "",
            Share: "",
            BlockedSite: "",
            FavoriteStar: "",
            FavoriteStarFill: "",
            CheckMark: "",
            Delete: "",
            ChevronLeft: "",
            ChevronRight: "",
            Calendar: "",
            Megaphone: "",
            Undo: "",
            Flag: "",
            Page: "",
            Pinned: "",
            View: "",
            Clear: "",
            Download: "",
            Upload: "",
            Folder: "",
            Sort: "",
            AlignRight: "",
            AlignLeft: "",
            Tag: "",
            AddFriend: "",
            Info: "",
            SortLines: "",
            List: "",
            CircleRing: "",
            Heart: "",
            HeartFill: "",
            Tiles: "",
            Embed: "",
            Glimmer: "",
            Ascending: "",
            Descending: "",
            SortUp: "",
            SortDown: "",
            SyncToPC: "",
            LargeGrid: "",
            SkypeCheck: "",
            SkypeClock: "",
            SkypeMinus: "",
            ClearFilter: "",
            Flow: "",
            StatusCircleCheckmark: "",
            MoreVertical: ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $50450c11193711e2$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-0"',
            src: "url('".concat(baseUrl, "fabric-icons-0-467ee27f.woff') format('woff')")
        },
        icons: {
            "PageLink": "",
            "CommentSolid": "",
            "ChangeEntitlements": "",
            "Installation": "",
            "WebAppBuilderModule": "",
            "WebAppBuilderFragment": "",
            "WebAppBuilderSlot": "",
            "BullseyeTargetEdit": "",
            "WebAppBuilderFragmentCreate": "",
            "PageData": "",
            "PageHeaderEdit": "",
            "ProductList": "",
            "UnpublishContent": "",
            "DependencyAdd": "",
            "DependencyRemove": "",
            "EntitlementPolicy": "",
            "EntitlementRedemption": "",
            "SchoolDataSyncLogo": "",
            "PinSolid12": "",
            "PinSolidOff12": "",
            "AddLink": "",
            "SharepointAppIcon16": "",
            "DataflowsLink": "",
            "TimePicker": "",
            "UserWarning": "",
            "ComplianceAudit": "",
            "InternetSharing": "",
            "Brightness": "",
            "MapPin": "",
            "Airplane": "",
            "Tablet": "",
            "QuickNote": "",
            "Video": "",
            "People": "",
            "Phone": "",
            "Pin": "",
            "Shop": "",
            "Stop": "",
            "Link": "",
            "AllApps": "",
            "Zoom": "",
            "ZoomOut": "",
            "Microphone": "",
            "Camera": "",
            "Attach": "",
            "Send": "",
            "FavoriteList": "",
            "PageSolid": "",
            "Forward": "",
            "Back": "",
            "Refresh": "",
            "Lock": "",
            "ReportHacked": "",
            "EMI": "",
            "MiniLink": "",
            "Blocked": "",
            "ReadingMode": "",
            "Favicon": "",
            "Remove": "",
            "Checkbox": "",
            "CheckboxComposite": "",
            "CheckboxFill": "",
            "CheckboxIndeterminate": "",
            "CheckboxCompositeReversed": "",
            "BackToWindow": "",
            "FullScreen": "",
            "Print": "",
            "Up": "",
            "Down": "",
            "OEM": "",
            "Save": "",
            "ReturnKey": "",
            "Cloud": "",
            "Flashlight": "",
            "CommandPrompt": "",
            "Sad": "",
            "RealEstate": "",
            "SIPMove": "",
            "EraseTool": "",
            "GripperTool": "",
            "Dialpad": "",
            "PageLeft": "",
            "PageRight": "",
            "MultiSelect": "",
            "KeyboardClassic": "",
            "Play": "",
            "Pause": "",
            "InkingTool": "",
            "Emoji2": "",
            "GripperBarHorizontal": "",
            "System": "",
            "Personalize": "",
            "SearchAndApps": "",
            "Globe": "",
            "EaseOfAccess": "",
            "ContactInfo": "",
            "Unpin": "",
            "Contact": "",
            "Memo": "",
            "IncomingCall": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $33c17d66fb352128$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-1"',
            src: "url('".concat(baseUrl, "fabric-icons-1-4d521695.woff') format('woff')")
        },
        icons: {
            "Paste": "",
            "WindowsLogo": "",
            "Error": "",
            "GripperBarVertical": "",
            "Unlock": "",
            "Slideshow": "",
            "Trim": "",
            "AutoEnhanceOn": "",
            "AutoEnhanceOff": "",
            "Color": "",
            "SaveAs": "",
            "Light": "",
            "Filters": "",
            "AspectRatio": "",
            "Contrast": "",
            "Redo": "",
            "Crop": "",
            "PhotoCollection": "",
            "Album": "",
            "Rotate": "",
            "PanoIndicator": "",
            "Translate": "",
            "RedEye": "",
            "ViewOriginal": "",
            "ThumbnailView": "",
            "Package": "",
            "Telemarketer": "",
            "Warning": "",
            "Financial": "",
            "Education": "",
            "ShoppingCart": "",
            "Train": "",
            "Move": "",
            "TouchPointer": "",
            "Merge": "",
            "TurnRight": "",
            "Ferry": "",
            "Highlight": "",
            "PowerButton": "",
            "Tab": "",
            "Admin": "",
            "TVMonitor": "",
            "Speakers": "",
            "Game": "",
            "HorizontalTabKey": "",
            "UnstackSelected": "",
            "StackIndicator": "",
            "Nav2DMapView": "",
            "StreetsideSplitMinimize": "",
            "Car": "",
            "Bus": "",
            "EatDrink": "",
            "SeeDo": "",
            "LocationCircle": "",
            "Home": "",
            "SwitcherStartEnd": "",
            "ParkingLocation": "",
            "IncidentTriangle": "",
            "Touch": "",
            "MapDirections": "",
            "CaretHollow": "",
            "CaretSolid": "",
            "History": "",
            "Location": "",
            "MapLayers": "",
            "SearchNearby": "",
            "Work": "",
            "Recent": "",
            "Hotel": "",
            "Bank": "",
            "LocationDot": "",
            "Dictionary": "",
            "ChromeBack": "",
            "FolderOpen": "",
            "PinnedFill": "",
            "RevToggleKey": "",
            "USB": "",
            "Previous": "",
            "Next": "",
            "Sync": "",
            "Help": "",
            "Emoji": "",
            "MailForward": "",
            "ClosePane": "",
            "OpenPane": "",
            "PreviewLink": "",
            "ZoomIn": "",
            "Bookmarks": "",
            "Document": "",
            "ProtectedDocument": "",
            "OpenInNewWindow": "",
            "MailFill": "",
            "ViewAll": "",
            "Switch": "",
            "Rename": "",
            "Go": "",
            "Remote": "",
            "SelectAll": "",
            "Orientation": "",
            "Import": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $70bbc05a92e62c83$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-2"',
            src: "url('".concat(baseUrl, "fabric-icons-2-63c99abf.woff') format('woff')")
        },
        icons: {
            "Picture": "",
            "ChromeClose": "",
            "ShowResults": "",
            "Message": "",
            "CalendarDay": "",
            "CalendarWeek": "",
            "MailReplyAll": "",
            "Read": "",
            "Cut": "",
            "PaymentCard": "",
            "Copy": "",
            "Important": "",
            "MailReply": "",
            "GotoToday": "",
            "Font": "",
            "FontColor": "",
            "FolderFill": "",
            "Permissions": "",
            "DisableUpdates": "",
            "Unfavorite": "",
            "Italic": "",
            "Underline": "",
            "Bold": "",
            "MoveToFolder": "",
            "Dislike": "",
            "Like": "",
            "AlignCenter": "",
            "OpenFile": "",
            "ClearSelection": "",
            "FontDecrease": "",
            "FontIncrease": "",
            "FontSize": "",
            "CellPhone": "",
            "RepeatOne": "",
            "RepeatAll": "",
            "Calculator": "",
            "Library": "",
            "PostUpdate": "",
            "NewFolder": "",
            "CalendarReply": "",
            "UnsyncFolder": "",
            "SyncFolder": "",
            "BlockContact": "",
            "Accept": "",
            "BulletedList": "",
            "Preview": "",
            "News": "",
            "Chat": "",
            "Group": "",
            "World": "",
            "Comment": "",
            "DockLeft": "",
            "DockRight": "",
            "Repair": "",
            "Accounts": "",
            "Street": "",
            "RadioBullet": "",
            "Stopwatch": "",
            "Clock": "",
            "WorldClock": "",
            "AlarmClock": "",
            "Photo": "",
            "ActionCenter": "",
            "Hospital": "",
            "Timer": "",
            "FullCircleMask": "",
            "LocationFill": "",
            "ChromeMinimize": "",
            "ChromeRestore": "",
            "Annotation": "",
            "Fingerprint": "",
            "Handwriting": "",
            "ChromeFullScreen": "",
            "Completed": "",
            "Label": "",
            "FlickDown": "",
            "FlickUp": "",
            "FlickLeft": "",
            "FlickRight": "",
            "MiniExpand": "",
            "MiniContract": "",
            "Streaming": "",
            "MusicInCollection": "",
            "OneDriveLogo": "",
            "CompassNW": "",
            "Code": "",
            "LightningBolt": "",
            "CalculatorMultiply": "",
            "CalculatorAddition": "",
            "CalculatorSubtract": "",
            "CalculatorPercentage": "",
            "CalculatorEqualTo": "",
            "PrintfaxPrinterFile": "",
            "StorageOptical": "",
            "Communications": "",
            "Headset": "",
            "Health": "",
            "Webcam2": "",
            "FrontCamera": "",
            "ChevronUpSmall": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $3cb020e4b6031643$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-3"',
            src: "url('".concat(baseUrl, "fabric-icons-3-089e217a.woff') format('woff')")
        },
        icons: {
            "ChevronDownSmall": "",
            "ChevronLeftSmall": "",
            "ChevronRightSmall": "",
            "ChevronUpMed": "",
            "ChevronDownMed": "",
            "ChevronLeftMed": "",
            "ChevronRightMed": "",
            "Devices2": "",
            "PC1": "",
            "PresenceChickletVideo": "",
            "Reply": "",
            "HalfAlpha": "",
            "ConstructionCone": "",
            "DoubleChevronLeftMed": "",
            "Volume0": "",
            "Volume1": "",
            "Volume2": "",
            "Volume3": "",
            "Chart": "",
            "Robot": "",
            "Manufacturing": "",
            "LockSolid": "",
            "FitPage": "",
            "FitWidth": "",
            "BidiLtr": "",
            "BidiRtl": "",
            "RightDoubleQuote": "",
            "Sunny": "",
            "CloudWeather": "",
            "Cloudy": "",
            "PartlyCloudyDay": "",
            "PartlyCloudyNight": "",
            "ClearNight": "",
            "RainShowersDay": "",
            "Rain": "",
            "Thunderstorms": "",
            "RainSnow": "",
            "Snow": "",
            "BlowingSnow": "",
            "Frigid": "",
            "Fog": "",
            "Squalls": "",
            "Duststorm": "",
            "Unknown": "",
            "Precipitation": "",
            "Ribbon": "",
            "AreaChart": "",
            "Assign": "",
            "FlowChart": "",
            "CheckList": "",
            "Diagnostic": "",
            "Generate": "",
            "LineChart": "",
            "Equalizer": "",
            "BarChartHorizontal": "",
            "BarChartVertical": "",
            "Freezing": "",
            "FunnelChart": "",
            "Processing": "",
            "Quantity": "",
            "ReportDocument": "",
            "StackColumnChart": "",
            "SnowShowerDay": "",
            "HailDay": "",
            "WorkFlow": "",
            "HourGlass": "",
            "StoreLogoMed20": "",
            "TimeSheet": "",
            "TriangleSolid": "",
            "UpgradeAnalysis": "",
            "VideoSolid": "",
            "RainShowersNight": "",
            "SnowShowerNight": "",
            "Teamwork": "",
            "HailNight": "",
            "PeopleAdd": "",
            "Glasses": "",
            "DateTime2": "",
            "Shield": "",
            "Header1": "",
            "PageAdd": "",
            "NumberedList": "",
            "PowerBILogo": "",
            "Info2": "",
            "MusicInCollectionFill": "",
            "Asterisk": "",
            "ErrorBadge": "",
            "CircleFill": "",
            "Record2": "",
            "AllAppsMirrored": "",
            "BookmarksMirrored": "",
            "BulletedListMirrored": "",
            "CaretHollowMirrored": "",
            "CaretSolidMirrored": "",
            "ChromeBackMirrored": "",
            "ClearSelectionMirrored": "",
            "ClosePaneMirrored": "",
            "DockLeftMirrored": "",
            "DoubleChevronLeftMedMirrored": "",
            "GoMirrored": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $bdce5a7fb2b20401$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-4"',
            src: "url('".concat(baseUrl, "fabric-icons-4-a656cc0a.woff') format('woff')")
        },
        icons: {
            "HelpMirrored": "",
            "ImportMirrored": "",
            "ImportAllMirrored": "",
            "ListMirrored": "",
            "MailForwardMirrored": "",
            "MailReplyMirrored": "",
            "MailReplyAllMirrored": "",
            "MiniContractMirrored": "",
            "MiniExpandMirrored": "",
            "OpenPaneMirrored": "",
            "ParkingLocationMirrored": "",
            "SendMirrored": "",
            "ShowResultsMirrored": "",
            "ThumbnailViewMirrored": "",
            "Media": "",
            "Devices3": "",
            "Focus": "",
            "VideoLightOff": "",
            "Lightbulb": "",
            "StatusTriangle": "",
            "VolumeDisabled": "",
            "Puzzle": "",
            "EmojiNeutral": "",
            "EmojiDisappointed": "",
            "HomeSolid": "",
            "Ringer": "",
            "PDF": "",
            "HeartBroken": "",
            "StoreLogo16": "",
            "MultiSelectMirrored": "",
            "Broom": "",
            "AddToShoppingList": "",
            "Cocktails": "",
            "Wines": "",
            "Articles": "",
            "Cycling": "",
            "DietPlanNotebook": "",
            "Pill": "",
            "ExerciseTracker": "",
            "HandsFree": "",
            "Medical": "",
            "Running": "",
            "Weights": "",
            "Trackers": "",
            "AddNotes": "",
            "AllCurrency": "",
            "BarChart4": "",
            "CirclePlus": "",
            "Coffee": "",
            "Cotton": "",
            "Market": "",
            "Money": "",
            "PieDouble": "",
            "PieSingle": "",
            "RemoveFilter": "",
            "Savings": "",
            "Sell": "",
            "StockDown": "",
            "StockUp": "",
            "Lamp": "",
            "Source": "",
            "MSNVideos": "",
            "Cricket": "",
            "Golf": "",
            "Baseball": "",
            "Soccer": "",
            "MoreSports": "",
            "AutoRacing": "",
            "CollegeHoops": "",
            "CollegeFootball": "",
            "ProFootball": "",
            "ProHockey": "",
            "Rugby": "",
            "SubstitutionsIn": "",
            "Tennis": "",
            "Arrivals": "",
            "Design": "",
            "Website": "",
            "Drop": "",
            "HistoricalWeather": "",
            "SkiResorts": "",
            "Snowflake": "",
            "BusSolid": "",
            "FerrySolid": "",
            "AirplaneSolid": "",
            "TrainSolid": "",
            "Ticket": "",
            "WifiWarning4": "",
            "Devices4": "",
            "AzureLogo": "",
            "BingLogo": "",
            "MSNLogo": "",
            "OutlookLogoInverse": "",
            "OfficeLogo": "",
            "SkypeLogo": "",
            "Door": "",
            "EditMirrored": "",
            "GiftCard": "",
            "DoubleBookmark": "",
            "StatusErrorFull": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $afbaa8541f56b4aa$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-5"',
            src: "url('".concat(baseUrl, "fabric-icons-5-f95ba260.woff') format('woff')")
        },
        icons: {
            "Certificate": "",
            "FastForward": "",
            "Rewind": "",
            "Photo2": "",
            "OpenSource": "",
            "Movers": "",
            "CloudDownload": "",
            "Family": "",
            "WindDirection": "",
            "Bug": "",
            "SiteScan": "",
            "BrowserScreenShot": "",
            "F12DevTools": "",
            "CSS": "",
            "JS": "",
            "DeliveryTruck": "",
            "ReminderPerson": "",
            "ReminderGroup": "",
            "ReminderTime": "",
            "TabletMode": "",
            "Umbrella": "",
            "NetworkTower": "",
            "CityNext": "",
            "CityNext2": "",
            "Section": "",
            "OneNoteLogoInverse": "",
            "ToggleFilled": "",
            "ToggleBorder": "",
            "SliderThumb": "",
            "ToggleThumb": "",
            "Documentation": "",
            "Badge": "",
            "Giftbox": "",
            "VisualStudioLogo": "",
            "HomeGroup": "",
            "ExcelLogoInverse": "",
            "WordLogoInverse": "",
            "PowerPointLogoInverse": "",
            "Cafe": "",
            "SpeedHigh": "",
            "Commitments": "",
            "ThisPC": "",
            "MusicNote": "",
            "MicOff": "",
            "PlaybackRate1x": "",
            "EdgeLogo": "",
            "CompletedSolid": "",
            "AlbumRemove": "",
            "MessageFill": "",
            "TabletSelected": "",
            "MobileSelected": "",
            "LaptopSelected": "",
            "TVMonitorSelected": "",
            "DeveloperTools": "",
            "Shapes": "",
            "InsertTextBox": "",
            "LowerBrightness": "",
            "WebComponents": "",
            "OfflineStorage": "",
            "DOM": "",
            "CloudUpload": "",
            "ScrollUpDown": "",
            "DateTime": "",
            "Event": "",
            "Cake": "",
            "Org": "",
            "PartyLeader": "",
            "DRM": "",
            "CloudAdd": "",
            "AppIconDefault": "",
            "Photo2Add": "",
            "Photo2Remove": "",
            "Calories": "",
            "POI": "",
            "AddTo": "",
            "RadioBtnOff": "",
            "RadioBtnOn": "",
            "ExploreContent": "",
            "Product": "",
            "ProgressLoopInner": "",
            "ProgressLoopOuter": "",
            "Blocked2": "",
            "FangBody": "",
            "Toolbox": "",
            "PageHeader": "",
            "ChatInviteFriend": "",
            "Brush": "",
            "Shirt": "",
            "Crown": "",
            "Diamond": "",
            "ScaleUp": "",
            "QRCode": "",
            "Feedback": "",
            "SharepointLogoInverse": "",
            "YammerLogo": "",
            "Hide": "",
            "Uneditable": "",
            "ReturnToSession": "",
            "OpenFolderHorizontal": "",
            "CalendarMirrored": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $7c49db08dbe589d1$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-6"',
            src: "url('".concat(baseUrl, "fabric-icons-6-ef6fd590.woff') format('woff')")
        },
        icons: {
            "SwayLogoInverse": "",
            "OutOfOffice": "",
            "Trophy": "",
            "ReopenPages": "",
            "EmojiTabSymbols": "",
            "AADLogo": "",
            "AccessLogo": "",
            "AdminALogoInverse32": "",
            "AdminCLogoInverse32": "",
            "AdminDLogoInverse32": "",
            "AdminELogoInverse32": "",
            "AdminLLogoInverse32": "",
            "AdminMLogoInverse32": "",
            "AdminOLogoInverse32": "",
            "AdminPLogoInverse32": "",
            "AdminSLogoInverse32": "",
            "AdminYLogoInverse32": "",
            "DelveLogoInverse": "",
            "ExchangeLogoInverse": "",
            "LyncLogo": "",
            "OfficeVideoLogoInverse": "",
            "SocialListeningLogo": "",
            "VisioLogoInverse": "",
            "Balloons": "",
            "Cat": "",
            "MailAlert": "",
            "MailCheck": "",
            "MailLowImportance": "",
            "MailPause": "",
            "MailRepeat": "",
            "SecurityGroup": "",
            "Table": "",
            "VoicemailForward": "",
            "VoicemailReply": "",
            "Waffle": "",
            "RemoveEvent": "",
            "EventInfo": "",
            "ForwardEvent": "",
            "WipePhone": "",
            "AddOnlineMeeting": "",
            "JoinOnlineMeeting": "",
            "RemoveLink": "",
            "PeopleBlock": "",
            "PeopleRepeat": "",
            "PeopleAlert": "",
            "PeoplePause": "",
            "TransferCall": "",
            "AddPhone": "",
            "UnknownCall": "",
            "NoteReply": "",
            "NoteForward": "",
            "NotePinned": "",
            "RemoveOccurrence": "",
            "Timeline": "",
            "EditNote": "",
            "CircleHalfFull": "",
            "Room": "",
            "Unsubscribe": "",
            "Subscribe": "",
            "HardDrive": "",
            "RecurringTask": "",
            "TaskManager": "",
            "TaskManagerMirrored": "",
            "Combine": "",
            "Split": "",
            "DoubleChevronUp": "",
            "DoubleChevronLeft": "",
            "DoubleChevronRight": "",
            "TextBox": "",
            "TextField": "",
            "NumberField": "",
            "Dropdown": "",
            "PenWorkspace": "",
            "BookingsLogo": "",
            "ClassNotebookLogoInverse": "",
            "DelveAnalyticsLogo": "",
            "DocsLogoInverse": "",
            "Dynamics365Logo": "",
            "DynamicSMBLogo": "",
            "OfficeAssistantLogo": "",
            "OfficeStoreLogo": "",
            "OneNoteEduLogoInverse": "",
            "PlannerLogo": "",
            "PowerApps": "",
            "Suitcase": "",
            "ProjectLogoInverse": "",
            "CaretLeft8": "",
            "CaretRight8": "",
            "CaretUp8": "",
            "CaretDown8": "",
            "CaretLeftSolid8": "",
            "CaretRightSolid8": "",
            "CaretUpSolid8": "",
            "CaretDownSolid8": "",
            "ClearFormatting": "",
            "Superscript": "",
            "Subscript": "",
            "Strikethrough": "",
            "Export": "",
            "ExportMirrored": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $1744dc9c68ab9938$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-7"',
            src: "url('".concat(baseUrl, "fabric-icons-7-2b97bb99.woff') format('woff')")
        },
        icons: {
            "SingleBookmark": "",
            "SingleBookmarkSolid": "",
            "DoubleChevronDown": "",
            "FollowUser": "",
            "ReplyAll": "",
            "WorkforceManagement": "",
            "RecruitmentManagement": "",
            "Questionnaire": "",
            "ManagerSelfService": "",
            "ProductionFloorManagement": "",
            "ProductRelease": "",
            "ProductVariant": "",
            "ReplyMirrored": "",
            "ReplyAllMirrored": "",
            "Medal": "",
            "AddGroup": "",
            "QuestionnaireMirrored": "",
            "CloudImportExport": "",
            "TemporaryUser": "",
            "CaretSolid16": "",
            "GroupedDescending": "",
            "GroupedAscending": "",
            "AwayStatus": "",
            "MyMoviesTV": "",
            "GenericScan": "",
            "AustralianRules": "",
            "WifiEthernet": "",
            "TrackersMirrored": "",
            "DateTimeMirrored": "",
            "StopSolid": "",
            "DoubleChevronUp12": "",
            "DoubleChevronDown12": "",
            "DoubleChevronLeft12": "",
            "DoubleChevronRight12": "",
            "CalendarAgenda": "",
            "ConnectVirtualMachine": "",
            "AddEvent": "",
            "AssetLibrary": "",
            "DataConnectionLibrary": "",
            "DocLibrary": "",
            "FormLibrary": "",
            "FormLibraryMirrored": "",
            "ReportLibrary": "",
            "ReportLibraryMirrored": "",
            "ContactCard": "",
            "CustomList": "",
            "CustomListMirrored": "",
            "IssueTracking": "",
            "IssueTrackingMirrored": "",
            "PictureLibrary": "",
            "OfficeAddinsLogo": "",
            "OfflineOneDriveParachute": "",
            "OfflineOneDriveParachuteDisabled": "",
            "TriangleSolidUp12": "",
            "TriangleSolidDown12": "",
            "TriangleSolidLeft12": "",
            "TriangleSolidRight12": "",
            "TriangleUp12": "",
            "TriangleDown12": "",
            "TriangleLeft12": "",
            "TriangleRight12": "",
            "ArrowUpRight8": "",
            "ArrowDownRight8": "",
            "DocumentSet": "",
            "GoToDashboard": "",
            "DelveAnalytics": "",
            "ArrowUpRightMirrored8": "",
            "ArrowDownRightMirrored8": "",
            "CompanyDirectory": "",
            "OpenEnrollment": "",
            "CompanyDirectoryMirrored": "",
            "OneDriveAdd": "",
            "ProfileSearch": "",
            "Header2": "",
            "Header3": "",
            "Header4": "",
            "RingerSolid": "",
            "Eyedropper": "",
            "MarketDown": "",
            "CalendarWorkWeek": "",
            "SidePanel": "",
            "GlobeFavorite": "",
            "CaretTopLeftSolid8": "",
            "CaretTopRightSolid8": "",
            "ViewAll2": "",
            "DocumentReply": "",
            "PlayerSettings": "",
            "ReceiptForward": "",
            "ReceiptReply": "",
            "ReceiptCheck": "",
            "Fax": "",
            "RecurringEvent": "",
            "ReplyAlt": "",
            "ReplyAllAlt": "",
            "EditStyle": "",
            "EditMail": "",
            "Lifesaver": "",
            "LifesaverLock": "",
            "InboxCheck": "",
            "FolderSearch": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $f259cfdb9a99ce6b$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-8"',
            src: "url('".concat(baseUrl, "fabric-icons-8-6fdf1528.woff') format('woff')")
        },
        icons: {
            "CollapseMenu": "",
            "ExpandMenu": "",
            "Boards": "",
            "SunAdd": "",
            "SunQuestionMark": "",
            "LandscapeOrientation": "",
            "DocumentSearch": "",
            "PublicCalendar": "",
            "PublicContactCard": "",
            "PublicEmail": "",
            "PublicFolder": "",
            "WordDocument": "",
            "PowerPointDocument": "",
            "ExcelDocument": "",
            "GroupedList": "",
            "ClassroomLogo": "",
            "Sections": "",
            "EditPhoto": "",
            "Starburst": "",
            "ShareiOS": "",
            "AirTickets": "",
            "PencilReply": "",
            "Tiles2": "",
            "SkypeCircleCheck": "",
            "SkypeCircleClock": "",
            "SkypeCircleMinus": "",
            "SkypeMessage": "",
            "ClosedCaption": "",
            "ATPLogo": "",
            "OfficeFormsLogoInverse": "",
            "RecycleBin": "",
            "EmptyRecycleBin": "",
            "Hide2": "",
            "Breadcrumb": "",
            "BirthdayCake": "",
            "TimeEntry": "",
            "CRMProcesses": "",
            "PageEdit": "",
            "PageArrowRight": "",
            "PageRemove": "",
            "Database": "",
            "DataManagementSettings": "",
            "CRMServices": "",
            "EditContact": "",
            "ConnectContacts": "",
            "AppIconDefaultAdd": "",
            "AppIconDefaultList": "",
            "ActivateOrders": "",
            "DeactivateOrders": "",
            "ProductCatalog": "",
            "ScatterChart": "",
            "AccountActivity": "",
            "DocumentManagement": "",
            "CRMReport": "",
            "KnowledgeArticle": "",
            "Relationship": "",
            "HomeVerify": "",
            "ZipFolder": "",
            "SurveyQuestions": "",
            "TextDocument": "",
            "TextDocumentShared": "",
            "PageCheckedOut": "",
            "PageShared": "",
            "SaveAndClose": "",
            "Script": "",
            "Archive": "",
            "ActivityFeed": "",
            "Compare": "",
            "EventDate": "",
            "ArrowUpRight": "",
            "CaretRight": "",
            "SetAction": "",
            "ChatBot": "",
            "CaretSolidLeft": "",
            "CaretSolidDown": "",
            "CaretSolidRight": "",
            "CaretSolidUp": "",
            "PowerAppsLogo": "",
            "PowerApps2Logo": "",
            "SearchIssue": "",
            "SearchIssueMirrored": "",
            "FabricAssetLibrary": "",
            "FabricDataConnectionLibrary": "",
            "FabricDocLibrary": "",
            "FabricFormLibrary": "",
            "FabricFormLibraryMirrored": "",
            "FabricReportLibrary": "",
            "FabricReportLibraryMirrored": "",
            "FabricPublicFolder": "",
            "FabricFolderSearch": "",
            "FabricMovetoFolder": "",
            "FabricUnsyncFolder": "",
            "FabricSyncFolder": "",
            "FabricOpenFolderHorizontal": "",
            "FabricFolder": "",
            "FabricFolderFill": "",
            "FabricNewFolder": "",
            "FabricPictureLibrary": "",
            "PhotoVideoMedia": "",
            "AddFavorite": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $8623626083eacde5$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-9"',
            src: "url('".concat(baseUrl, "fabric-icons-9-c6162b42.woff') format('woff')")
        },
        icons: {
            "AddFavoriteFill": "",
            "BufferTimeBefore": "",
            "BufferTimeAfter": "",
            "BufferTimeBoth": "",
            "PublishContent": "",
            "ClipboardList": "",
            "ClipboardListMirrored": "",
            "CannedChat": "",
            "SkypeForBusinessLogo": "",
            "TabCenter": "",
            "PageCheckedin": "",
            "PageList": "",
            "ReadOutLoud": "",
            "CaretBottomLeftSolid8": "",
            "CaretBottomRightSolid8": "",
            "FolderHorizontal": "",
            "MicrosoftStaffhubLogo": "",
            "GiftboxOpen": "",
            "StatusCircleOuter": "",
            "StatusCircleInner": "",
            "StatusCircleRing": "",
            "StatusTriangleOuter": "",
            "StatusTriangleInner": "",
            "StatusTriangleExclamation": "",
            "StatusCircleExclamation": "",
            "StatusCircleErrorX": "",
            "StatusCircleInfo": "",
            "StatusCircleBlock": "",
            "StatusCircleBlock2": "",
            "StatusCircleQuestionMark": "",
            "StatusCircleSync": "",
            "Toll": "",
            "ExploreContentSingle": "",
            "CollapseContent": "",
            "CollapseContentSingle": "",
            "InfoSolid": "",
            "GroupList": "",
            "ProgressRingDots": "",
            "CaloriesAdd": "",
            "BranchFork": "",
            "MuteChat": "",
            "AddHome": "",
            "AddWork": "",
            "MobileReport": "",
            "ScaleVolume": "",
            "HardDriveGroup": "",
            "FastMode": "",
            "ToggleLeft": "",
            "ToggleRight": "",
            "TriangleShape": "",
            "RectangleShape": "",
            "CubeShape": "",
            "Trophy2": "",
            "BucketColor": "",
            "BucketColorFill": "",
            "Taskboard": "",
            "SingleColumn": "",
            "DoubleColumn": "",
            "TripleColumn": "",
            "ColumnLeftTwoThirds": "",
            "ColumnRightTwoThirds": "",
            "AccessLogoFill": "",
            "AnalyticsLogo": "",
            "AnalyticsQuery": "",
            "NewAnalyticsQuery": "",
            "AnalyticsReport": "",
            "WordLogo": "",
            "WordLogoFill": "",
            "ExcelLogo": "",
            "ExcelLogoFill": "",
            "OneNoteLogo": "",
            "OneNoteLogoFill": "",
            "OutlookLogo": "",
            "OutlookLogoFill": "",
            "PowerPointLogo": "",
            "PowerPointLogoFill": "",
            "PublisherLogo": "",
            "PublisherLogoFill": "",
            "ScheduleEventAction": "",
            "FlameSolid": "",
            "ServerProcesses": "",
            "Server": "",
            "SaveAll": "",
            "LinkedInLogo": "",
            "Decimals": "",
            "SidePanelMirrored": "",
            "ProtectRestrict": "",
            "Blog": "",
            "UnknownMirrored": "",
            "PublicContactCardMirrored": "",
            "GridViewSmall": "",
            "GridViewMedium": "",
            "GridViewLarge": "",
            "Step": "",
            "StepInsert": "",
            "StepShared": "",
            "StepSharedAdd": "",
            "StepSharedInsert": "",
            "ViewDashboard": "",
            "ViewList": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $983a0abb70ad7a58$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-10"',
            src: "url('".concat(baseUrl, "fabric-icons-10-c4ded8e4.woff') format('woff')")
        },
        icons: {
            "ViewListGroup": "",
            "ViewListTree": "",
            "TriggerAuto": "",
            "TriggerUser": "",
            "PivotChart": "",
            "StackedBarChart": "",
            "StackedLineChart": "",
            "BuildQueue": "",
            "BuildQueueNew": "",
            "UserFollowed": "",
            "ContactLink": "",
            "Stack": "",
            "Bullseye": "",
            "VennDiagram": "",
            "FiveTileGrid": "",
            "FocalPoint": "",
            "Insert": "",
            "RingerRemove": "",
            "TeamsLogoInverse": "",
            "TeamsLogo": "",
            "TeamsLogoFill": "",
            "SkypeForBusinessLogoFill": "",
            "SharepointLogo": "",
            "SharepointLogoFill": "",
            "DelveLogo": "",
            "DelveLogoFill": "",
            "OfficeVideoLogo": "",
            "OfficeVideoLogoFill": "",
            "ExchangeLogo": "",
            "ExchangeLogoFill": "",
            "Signin": "",
            "DocumentApproval": "",
            "CloneToDesktop": "",
            "InstallToDrive": "",
            "Blur": "",
            "Build": "",
            "ProcessMetaTask": "",
            "BranchFork2": "",
            "BranchLocked": "",
            "BranchCommit": "",
            "BranchCompare": "",
            "BranchMerge": "",
            "BranchPullRequest": "",
            "BranchSearch": "",
            "BranchShelveset": "",
            "RawSource": "",
            "MergeDuplicate": "",
            "RowsGroup": "",
            "RowsChild": "",
            "Deploy": "",
            "Redeploy": "",
            "ServerEnviroment": "",
            "VisioDiagram": "",
            "HighlightMappedShapes": "",
            "TextCallout": "",
            "IconSetsFlag": "",
            "VisioLogo": "",
            "VisioLogoFill": "",
            "VisioDocument": "",
            "TimelineProgress": "",
            "TimelineDelivery": "",
            "Backlog": "",
            "TeamFavorite": "",
            "TaskGroup": "",
            "TaskGroupMirrored": "",
            "ScopeTemplate": "",
            "AssessmentGroupTemplate": "",
            "NewTeamProject": "",
            "CommentAdd": "",
            "CommentNext": "",
            "CommentPrevious": "",
            "ShopServer": "",
            "LocaleLanguage": "",
            "QueryList": "",
            "UserSync": "",
            "UserPause": "",
            "StreamingOff": "",
            "ArrowTallUpLeft": "",
            "ArrowTallUpRight": "",
            "ArrowTallDownLeft": "",
            "ArrowTallDownRight": "",
            "FieldEmpty": "",
            "FieldFilled": "",
            "FieldChanged": "",
            "FieldNotChanged": "",
            "RingerOff": "",
            "PlayResume": "",
            "BulletedList2": "",
            "BulletedList2Mirrored": "",
            "ImageCrosshair": "",
            "GitGraph": "",
            "Repo": "",
            "RepoSolid": "",
            "FolderQuery": "",
            "FolderList": "",
            "FolderListMirrored": "",
            "LocationOutline": "",
            "POISolid": "",
            "CalculatorNotEqualTo": "",
            "BoxSubtractSolid": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $f75037a1e9b6d433$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-11"',
            src: "url('".concat(baseUrl, "fabric-icons-11-2a8393d6.woff') format('woff')")
        },
        icons: {
            "BoxAdditionSolid": "",
            "BoxMultiplySolid": "",
            "BoxPlaySolid": "",
            "BoxCheckmarkSolid": "",
            "CirclePauseSolid": "",
            "CirclePause": "",
            "MSNVideosSolid": "",
            "CircleStopSolid": "",
            "CircleStop": "",
            "NavigateBack": "",
            "NavigateBackMirrored": "",
            "NavigateForward": "",
            "NavigateForwardMirrored": "",
            "UnknownSolid": "",
            "UnknownMirroredSolid": "",
            "CircleAddition": "",
            "CircleAdditionSolid": "",
            "FilePDB": "",
            "FileTemplate": "",
            "FileSQL": "",
            "FileJAVA": "",
            "FileASPX": "",
            "FileCSS": "",
            "FileSass": "",
            "FileLess": "",
            "FileHTML": "",
            "JavaScriptLanguage": "",
            "CSharpLanguage": "",
            "CSharp": "",
            "VisualBasicLanguage": "",
            "VB": "",
            "CPlusPlusLanguage": "",
            "CPlusPlus": "",
            "FSharpLanguage": "",
            "FSharp": "",
            "TypeScriptLanguage": "",
            "PythonLanguage": "",
            "PY": "",
            "CoffeeScript": "",
            "MarkDownLanguage": "",
            "FullWidth": "",
            "FullWidthEdit": "",
            "Plug": "",
            "PlugSolid": "",
            "PlugConnected": "",
            "PlugDisconnected": "",
            "UnlockSolid": "",
            "Variable": "",
            "Parameter": "",
            "CommentUrgent": "",
            "Storyboard": "",
            "DiffInline": "",
            "DiffSideBySide": "",
            "ImageDiff": "",
            "ImagePixel": "",
            "FileBug": "",
            "FileCode": "",
            "FileComment": "",
            "BusinessHoursSign": "",
            "FileImage": "",
            "FileSymlink": "",
            "AutoFillTemplate": "",
            "WorkItem": "",
            "WorkItemBug": "",
            "LogRemove": "",
            "ColumnOptions": "",
            "Packages": "",
            "BuildIssue": "",
            "AssessmentGroup": "",
            "VariableGroup": "",
            "FullHistory": "",
            "Wheelchair": "",
            "SingleColumnEdit": "",
            "DoubleColumnEdit": "",
            "TripleColumnEdit": "",
            "ColumnLeftTwoThirdsEdit": "",
            "ColumnRightTwoThirdsEdit": "",
            "StreamLogo": "",
            "PassiveAuthentication": "",
            "AlertSolid": "",
            "MegaphoneSolid": "",
            "TaskSolid": "",
            "ConfigurationSolid": "",
            "BugSolid": "",
            "CrownSolid": "",
            "Trophy2Solid": "",
            "QuickNoteSolid": "",
            "ConstructionConeSolid": "",
            "PageListSolid": "",
            "PageListMirroredSolid": "",
            "StarburstSolid": "",
            "ReadingModeSolid": "",
            "SadSolid": "",
            "HealthSolid": "",
            "ShieldSolid": "",
            "GiftBoxSolid": "",
            "ShoppingCartSolid": "",
            "MailSolid": "",
            "ChatSolid": "",
            "RibbonSolid": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $97028caf89cc21ba$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-12"',
            src: "url('".concat(baseUrl, "fabric-icons-12-7e945a1e.woff') format('woff')")
        },
        icons: {
            "FinancialSolid": "",
            "FinancialMirroredSolid": "",
            "HeadsetSolid": "",
            "PermissionsSolid": "",
            "ParkingSolid": "",
            "ParkingMirroredSolid": "",
            "DiamondSolid": "",
            "AsteriskSolid": "",
            "OfflineStorageSolid": "",
            "BankSolid": "",
            "DecisionSolid": "",
            "Parachute": "",
            "ParachuteSolid": "",
            "FiltersSolid": "",
            "ColorSolid": "",
            "ReviewSolid": "",
            "ReviewRequestSolid": "",
            "ReviewRequestMirroredSolid": "",
            "ReviewResponseSolid": "",
            "FeedbackRequestSolid": "",
            "FeedbackRequestMirroredSolid": "",
            "FeedbackResponseSolid": "",
            "WorkItemBar": "",
            "WorkItemBarSolid": "",
            "Separator": "",
            "NavigateExternalInline": "",
            "PlanView": "",
            "TimelineMatrixView": "",
            "EngineeringGroup": "",
            "ProjectCollection": "",
            "CaretBottomRightCenter8": "",
            "CaretBottomLeftCenter8": "",
            "CaretTopRightCenter8": "",
            "CaretTopLeftCenter8": "",
            "DonutChart": "",
            "ChevronUnfold10": "",
            "ChevronFold10": "",
            "DoubleChevronDown8": "",
            "DoubleChevronUp8": "",
            "DoubleChevronLeft8": "",
            "DoubleChevronRight8": "",
            "ChevronDownEnd6": "",
            "ChevronUpEnd6": "",
            "ChevronLeftEnd6": "",
            "ChevronRightEnd6": "",
            "ContextMenu": "",
            "AzureAPIManagement": "",
            "AzureServiceEndpoint": "",
            "VSTSLogo": "",
            "VSTSAltLogo1": "",
            "VSTSAltLogo2": "",
            "FileTypeSolution": "",
            "WordLogoInverse16": "",
            "WordLogo16": "",
            "WordLogoFill16": "",
            "PowerPointLogoInverse16": "",
            "PowerPointLogo16": "",
            "PowerPointLogoFill16": "",
            "ExcelLogoInverse16": "",
            "ExcelLogo16": "",
            "ExcelLogoFill16": "",
            "OneNoteLogoInverse16": "",
            "OneNoteLogo16": "",
            "OneNoteLogoFill16": "",
            "OutlookLogoInverse16": "",
            "OutlookLogo16": "",
            "OutlookLogoFill16": "",
            "PublisherLogoInverse16": "",
            "PublisherLogo16": "",
            "PublisherLogoFill16": "",
            "VisioLogoInverse16": "",
            "VisioLogo16": "",
            "VisioLogoFill16": "",
            "TestBeaker": "",
            "TestBeakerSolid": "",
            "TestExploreSolid": "",
            "TestAutoSolid": "",
            "TestUserSolid": "",
            "TestImpactSolid": "",
            "TestPlan": "",
            "TestStep": "",
            "TestParameter": "",
            "TestSuite": "",
            "TestCase": "",
            "Sprint": "",
            "SignOut": "",
            "TriggerApproval": "",
            "Rocket": "",
            "AzureKeyVault": "",
            "Onboarding": "",
            "Transition": "",
            "LikeSolid": "",
            "DislikeSolid": "",
            "CRMCustomerInsightsApp": "",
            "EditCreate": "",
            "PlayReverseResume": "",
            "PlayReverse": "",
            "SearchData": "",
            "UnSetColor": "",
            "DeclineCall": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $24ebb05f37e8c5ab$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-13"',
            src: "url('".concat(baseUrl, "fabric-icons-13-c3989a02.woff') format('woff')")
        },
        icons: {
            "RectangularClipping": "",
            "TeamsLogo16": "",
            "TeamsLogoFill16": "",
            "Spacer": "",
            "SkypeLogo16": "",
            "SkypeForBusinessLogo16": "",
            "SkypeForBusinessLogoFill16": "",
            "FilterSolid": "",
            "MailUndelivered": "",
            "MailTentative": "",
            "MailTentativeMirrored": "",
            "MailReminder": "",
            "ReceiptUndelivered": "",
            "ReceiptTentative": "",
            "ReceiptTentativeMirrored": "",
            "Inbox": "",
            "IRMReply": "",
            "IRMReplyMirrored": "",
            "IRMForward": "",
            "IRMForwardMirrored": "",
            "VoicemailIRM": "",
            "EventAccepted": "",
            "EventTentative": "",
            "EventTentativeMirrored": "",
            "EventDeclined": "",
            "IDBadge": "",
            "BackgroundColor": "",
            "OfficeFormsLogoInverse16": "",
            "OfficeFormsLogo": "",
            "OfficeFormsLogoFill": "",
            "OfficeFormsLogo16": "",
            "OfficeFormsLogoFill16": "",
            "OfficeFormsLogoInverse24": "",
            "OfficeFormsLogo24": "",
            "OfficeFormsLogoFill24": "",
            "PageLock": "",
            "NotExecuted": "",
            "NotImpactedSolid": "",
            "FieldReadOnly": "",
            "FieldRequired": "",
            "BacklogBoard": "",
            "ExternalBuild": "",
            "ExternalTFVC": "",
            "ExternalXAML": "",
            "IssueSolid": "",
            "DefectSolid": "",
            "LadybugSolid": "",
            "NugetLogo": "",
            "TFVCLogo": "",
            "ProjectLogo32": "",
            "ProjectLogoFill32": "",
            "ProjectLogo16": "",
            "ProjectLogoFill16": "",
            "SwayLogo32": "",
            "SwayLogoFill32": "",
            "SwayLogo16": "",
            "SwayLogoFill16": "",
            "ClassNotebookLogo32": "",
            "ClassNotebookLogoFill32": "",
            "ClassNotebookLogo16": "",
            "ClassNotebookLogoFill16": "",
            "ClassNotebookLogoInverse32": "",
            "ClassNotebookLogoInverse16": "",
            "StaffNotebookLogo32": "",
            "StaffNotebookLogoFill32": "",
            "StaffNotebookLogo16": "",
            "StaffNotebookLogoFill16": "",
            "StaffNotebookLogoInverted32": "",
            "StaffNotebookLogoInverted16": "",
            "KaizalaLogo": "",
            "TaskLogo": "",
            "ProtectionCenterLogo32": "",
            "GallatinLogo": "",
            "Globe2": "",
            "Guitar": "",
            "Breakfast": "",
            "Brunch": "",
            "BeerMug": "",
            "Vacation": "",
            "Teeth": "",
            "Taxi": "",
            "Chopsticks": "",
            "SyncOccurence": "",
            "UnsyncOccurence": "",
            "GIF": "",
            "PrimaryCalendar": "",
            "SearchCalendar": "",
            "VideoOff": "",
            "MicrosoftFlowLogo": "",
            "BusinessCenterLogo": "",
            "ToDoLogoBottom": "",
            "ToDoLogoTop": "",
            "EditSolid12": "",
            "EditSolidMirrored12": "",
            "UneditableSolid12": "",
            "UneditableSolidMirrored12": "",
            "UneditableMirrored": "",
            "AdminALogo32": "",
            "AdminALogoFill32": "",
            "ToDoLogoInverse": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $20f15dab138d3f41$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-14"',
            src: "url('".concat(baseUrl, "fabric-icons-14-5cf58db8.woff') format('woff')")
        },
        icons: {
            "Snooze": "",
            "WaffleOffice365": "",
            "ImageSearch": "",
            "NewsSearch": "",
            "VideoSearch": "",
            "R": "",
            "FontColorA": "",
            "FontColorSwatch": "",
            "LightWeight": "",
            "NormalWeight": "",
            "SemiboldWeight": "",
            "GroupObject": "",
            "UngroupObject": "",
            "AlignHorizontalLeft": "",
            "AlignHorizontalCenter": "",
            "AlignHorizontalRight": "",
            "AlignVerticalTop": "",
            "AlignVerticalCenter": "",
            "AlignVerticalBottom": "",
            "HorizontalDistributeCenter": "",
            "VerticalDistributeCenter": "",
            "Ellipse": "",
            "Line": "",
            "Octagon": "",
            "Hexagon": "",
            "Pentagon": "",
            "RightTriangle": "",
            "HalfCircle": "",
            "QuarterCircle": "",
            "ThreeQuarterCircle": "",
            "6PointStar": "",
            "12PointStar": "",
            "ArrangeBringToFront": "",
            "ArrangeSendToBack": "",
            "ArrangeSendBackward": "",
            "ArrangeBringForward": "",
            "BorderDash": "",
            "BorderDot": "",
            "LineStyle": "",
            "LineThickness": "",
            "WindowEdit": "",
            "HintText": "",
            "MediaAdd": "",
            "AnchorLock": "",
            "AutoHeight": "",
            "ChartSeries": "",
            "ChartXAngle": "",
            "ChartYAngle": "",
            "Combobox": "",
            "LineSpacing": "",
            "Padding": "",
            "PaddingTop": "",
            "PaddingBottom": "",
            "PaddingLeft": "",
            "PaddingRight": "",
            "NavigationFlipper": "",
            "AlignJustify": "",
            "TextOverflow": "",
            "VisualsFolder": "",
            "VisualsStore": "",
            "PictureCenter": "",
            "PictureFill": "",
            "PicturePosition": "",
            "PictureStretch": "",
            "PictureTile": "",
            "Slider": "",
            "SliderHandleSize": "",
            "DefaultRatio": "",
            "NumberSequence": "",
            "GUID": "",
            "ReportAdd": "",
            "DashboardAdd": "",
            "MapPinSolid": "",
            "WebPublish": "",
            "PieSingleSolid": "",
            "BlockedSolid": "",
            "DrillDown": "",
            "DrillDownSolid": "",
            "DrillExpand": "",
            "DrillShow": "",
            "SpecialEvent": "",
            "OneDriveFolder16": "",
            "FunctionalManagerDashboard": "",
            "BIDashboard": "",
            "CodeEdit": "",
            "RenewalCurrent": "",
            "RenewalFuture": "",
            "SplitObject": "",
            "BulkUpload": "",
            "DownloadDocument": "",
            "GreetingCard": "",
            "Flower": "",
            "WaitlistConfirm": "",
            "WaitlistConfirmMirrored": "",
            "LaptopSecure": "",
            "DragObject": "",
            "EntryView": "",
            "EntryDecline": "",
            "ContactCardSettings": "",
            "ContactCardSettingsMirrored": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $4649dc6b05f9a2a7$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-15"',
            src: "url('".concat(baseUrl, "fabric-icons-15-3807251b.woff') format('woff')")
        },
        icons: {
            "CalendarSettings": "",
            "CalendarSettingsMirrored": "",
            "HardDriveLock": "",
            "HardDriveUnlock": "",
            "AccountManagement": "",
            "ReportWarning": "",
            "TransitionPop": "",
            "TransitionPush": "",
            "TransitionEffect": "",
            "LookupEntities": "",
            "ExploreData": "",
            "AddBookmark": "",
            "SearchBookmark": "",
            "DrillThrough": "",
            "MasterDatabase": "",
            "CertifiedDatabase": "",
            "MaximumValue": "",
            "MinimumValue": "",
            "VisualStudioIDELogo32": "",
            "PasteAsText": "",
            "PasteAsCode": "",
            "BrowserTab": "",
            "BrowserTabScreenshot": "",
            "DesktopScreenshot": "",
            "FileYML": "",
            "ClipboardSolid": "",
            "FabricUserFolder": "",
            "FabricNetworkFolder": "",
            "BullseyeTarget": "",
            "AnalyticsView": "",
            "Video360Generic": "",
            "Untag": "",
            "Leave": "",
            "Trending12": "",
            "Blocked12": "",
            "Warning12": "",
            "CheckedOutByOther12": "",
            "CheckedOutByYou12": "",
            "CircleShapeSolid": "",
            "SquareShapeSolid": "",
            "TriangleShapeSolid": "",
            "DropShapeSolid": "",
            "RectangleShapeSolid": "",
            "ZoomToFit": "",
            "InsertColumnsLeft": "",
            "InsertColumnsRight": "",
            "InsertRowsAbove": "",
            "InsertRowsBelow": "",
            "DeleteColumns": "",
            "DeleteRows": "",
            "DeleteRowsMirrored": "",
            "DeleteTable": "",
            "AccountBrowser": "",
            "VersionControlPush": "",
            "StackedColumnChart2": "",
            "TripleColumnWide": "",
            "QuadColumn": "",
            "WhiteBoardApp16": "",
            "WhiteBoardApp32": "",
            "PinnedSolid": "",
            "InsertSignatureLine": "",
            "ArrangeByFrom": "",
            "Phishing": "",
            "CreateMailRule": "",
            "PublishCourse": "",
            "DictionaryRemove": "",
            "UserRemove": "",
            "UserEvent": "",
            "Encryption": "",
            "PasswordField": "",
            "OpenInNewTab": "",
            "Hide3": "",
            "VerifiedBrandSolid": "",
            "MarkAsProtected": "",
            "AuthenticatorApp": "",
            "WebTemplate": "",
            "DefenderTVM": "",
            "MedalSolid": "",
            "D365TalentLearn": "",
            "D365TalentInsight": "",
            "D365TalentHRCore": "",
            "BacklogList": "",
            "ButtonControl": "",
            "TableGroup": "",
            "MountainClimbing": "",
            "TagUnknown": "",
            "TagUnknownMirror": "",
            "TagUnknown12": "",
            "TagUnknown12Mirror": "",
            "Link12": "",
            "Presentation": "",
            "Presentation12": "",
            "Lock12": "",
            "BuildDefinition": "",
            "ReleaseDefinition": "",
            "SaveTemplate": "",
            "UserGauge": "",
            "BlockedSiteSolid12": "",
            "TagSolid": "",
            "OfficeChat": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $fd57f6e97420cf06$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-16"',
            src: "url('".concat(baseUrl, "fabric-icons-16-9cf93f3b.woff') format('woff')")
        },
        icons: {
            "OfficeChatSolid": "",
            "MailSchedule": "",
            "WarningSolid": "",
            "Blocked2Solid": "",
            "SkypeCircleArrow": "",
            "SkypeArrow": "",
            "SyncStatus": "",
            "SyncStatusSolid": "",
            "ProjectDocument": "",
            "ToDoLogoOutline": "",
            "VisioOnlineLogoFill32": "",
            "VisioOnlineLogo32": "",
            "VisioOnlineLogoCloud32": "",
            "VisioDiagramSync": "",
            "Event12": "",
            "EventDateMissed12": "",
            "UserOptional": "",
            "ResponsesMenu": "",
            "DoubleDownArrow": "",
            "DistributeDown": "",
            "BookmarkReport": "",
            "FilterSettings": "",
            "GripperDotsVertical": "",
            "MailAttached": "",
            "AddIn": "",
            "LinkedDatabase": "",
            "TableLink": "",
            "PromotedDatabase": "",
            "BarChartVerticalFilter": "",
            "BarChartVerticalFilterSolid": "",
            "MicOff2": "",
            "MicrosoftTranslatorLogo": "",
            "ShowTimeAs": "",
            "FileRequest": "",
            "WorkItemAlert": "",
            "PowerBILogo16": "",
            "PowerBILogoBackplate16": "",
            "BulletedListText": "",
            "BulletedListBullet": "",
            "BulletedListTextMirrored": "",
            "BulletedListBulletMirrored": "",
            "NumberedListText": "",
            "NumberedListNumber": "",
            "NumberedListTextMirrored": "",
            "NumberedListNumberMirrored": "",
            "RemoveLinkChain": "",
            "RemoveLinkX": "",
            "FabricTextHighlight": "",
            "ClearFormattingA": "",
            "ClearFormattingEraser": "",
            "Photo2Fill": "",
            "IncreaseIndentText": "",
            "IncreaseIndentArrow": "",
            "DecreaseIndentText": "",
            "DecreaseIndentArrow": "",
            "IncreaseIndentTextMirrored": "",
            "IncreaseIndentArrowMirrored": "",
            "DecreaseIndentTextMirrored": "",
            "DecreaseIndentArrowMirrored": "",
            "CheckListText": "",
            "CheckListCheck": "",
            "CheckListTextMirrored": "",
            "CheckListCheckMirrored": "",
            "NumberSymbol": "",
            "Coupon": "",
            "VerifiedBrand": "",
            "ReleaseGate": "",
            "ReleaseGateCheck": "",
            "ReleaseGateError": "",
            "M365InvoicingLogo": "",
            "RemoveFromShoppingList": "",
            "ShieldAlert": "",
            "FabricTextHighlightComposite": "",
            "Dataflows": "",
            "GenericScanFilled": "",
            "DiagnosticDataBarTooltip": "",
            "SaveToMobile": "",
            "Orientation2": "",
            "ScreenCast": "",
            "ShowGrid": "",
            "SnapToGrid": "",
            "ContactList": "",
            "NewMail": "",
            "EyeShadow": "",
            "FabricFolderConfirm": "",
            "InformationBarriers": "",
            "CommentActive": "",
            "ColumnVerticalSectionEdit": "",
            "WavingHand": "",
            "ShakeDevice": "",
            "SmartGlassRemote": "",
            "Rotate90Clockwise": "",
            "Rotate90CounterClockwise": "",
            "CampaignTemplate": "",
            "ChartTemplate": "",
            "PageListFilter": "",
            "SecondaryNav": "",
            "ColumnVerticalSection": "",
            "SkypeCircleSlash": "",
            "SkypeSlash": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $8d6385ef54bec81d$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-17"',
            src: "url('".concat(baseUrl, "fabric-icons-17-0c4ed701.woff') format('woff')")
        },
        icons: {
            "CustomizeToolbar": "",
            "DuplicateRow": "",
            "RemoveFromTrash": "",
            "MailOptions": "",
            "Childof": "",
            "Footer": "",
            "Header": "",
            "BarChartVerticalFill": "",
            "StackedColumnChart2Fill": "",
            "PlainText": "",
            "AccessibiltyChecker": "",
            "DatabaseSync": "",
            "ReservationOrders": "",
            "TabOneColumn": "",
            "TabTwoColumn": "",
            "TabThreeColumn": "",
            "BulletedTreeList": "",
            "MicrosoftTranslatorLogoGreen": "",
            "MicrosoftTranslatorLogoBlue": "",
            "InternalInvestigation": "",
            "AddReaction": "",
            "ContactHeart": "",
            "VisuallyImpaired": "",
            "EventToDoLogo": "",
            "Variable2": "",
            "ModelingView": "",
            "DisconnectVirtualMachine": "",
            "ReportLock": "",
            "Uneditable2": "",
            "Uneditable2Mirrored": "",
            "BarChartVerticalEdit": "",
            "GlobalNavButtonActive": "",
            "PollResults": "",
            "Rerun": "",
            "QandA": "",
            "QandAMirror": "",
            "BookAnswers": "",
            "AlertSettings": "",
            "TrimStart": "",
            "TrimEnd": "",
            "TableComputed": "",
            "DecreaseIndentLegacy": "",
            "IncreaseIndentLegacy": "",
            "SizeLegacy": ""
        }
    };
    (0, $157fc0f40a8f1c26$export$99b432e1290ef823)(subset, options);
}




var $5eb97d7714117d69$export$9836c3198c99edae = function() {
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("trash", "delete");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("onedrive", "onedrivelogo");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("alertsolid12", "eventdatemissed12");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("sixpointstar", "6pointstar");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("twelvepointstar", "12pointstar");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("toggleon", "toggleleft");
    (0, $157fc0f40a8f1c26$export$4fad376c7613260)("toggleoff", "toggleright");
};
var $5eb97d7714117d69$export$2e2bcd8739ae039 = $5eb97d7714117d69$export$9836c3198c99edae;



// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.

(0, $8bcf2d68614748d6$export$f99c3c9c04cda7ae)("@fluentui/font-icons-mdl2", "8.5.23");


var $9efd9e0e93a4c86b$var$DEFAULT_BASE_URL = "".concat((0, $1886b30a34b0cd2c$export$61818e3b2f7b5d12), "/assets/icons/");
var $9efd9e0e93a4c86b$var$win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
function $9efd9e0e93a4c86b$export$daed2daeba655e15(baseUrl, options) {
    var _a, _b;
    if (baseUrl === void 0) baseUrl = ((_a = $9efd9e0e93a4c86b$var$win === null || $9efd9e0e93a4c86b$var$win === void 0 ? void 0 : $9efd9e0e93a4c86b$var$win.FabricConfig) === null || _a === void 0 ? void 0 : _a.iconBaseUrl) || ((_b = $9efd9e0e93a4c86b$var$win === null || $9efd9e0e93a4c86b$var$win === void 0 ? void 0 : $9efd9e0e93a4c86b$var$win.FabricConfig) === null || _b === void 0 ? void 0 : _b.fontBaseUrl) || $9efd9e0e93a4c86b$var$DEFAULT_BASE_URL;
    [
        (0, $8ad0e698627a4235$export$daed2daeba655e15),
        (0, $50450c11193711e2$export$daed2daeba655e15),
        (0, $33c17d66fb352128$export$daed2daeba655e15),
        (0, $70bbc05a92e62c83$export$daed2daeba655e15),
        (0, $3cb020e4b6031643$export$daed2daeba655e15),
        (0, $bdce5a7fb2b20401$export$daed2daeba655e15),
        (0, $afbaa8541f56b4aa$export$daed2daeba655e15),
        (0, $7c49db08dbe589d1$export$daed2daeba655e15),
        (0, $1744dc9c68ab9938$export$daed2daeba655e15),
        (0, $f259cfdb9a99ce6b$export$daed2daeba655e15),
        (0, $8623626083eacde5$export$daed2daeba655e15),
        (0, $983a0abb70ad7a58$export$daed2daeba655e15),
        (0, $f75037a1e9b6d433$export$daed2daeba655e15),
        (0, $97028caf89cc21ba$export$daed2daeba655e15),
        (0, $24ebb05f37e8c5ab$export$daed2daeba655e15),
        (0, $20f15dab138d3f41$export$daed2daeba655e15),
        (0, $4649dc6b05f9a2a7$export$daed2daeba655e15),
        (0, $fd57f6e97420cf06$export$daed2daeba655e15),
        (0, $8d6385ef54bec81d$export$daed2daeba655e15)
    ].forEach(function(initialize) {
        return initialize(baseUrl, options);
    });
    (0, $5eb97d7714117d69$export$9836c3198c99edae)();
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $841b877f8387ff91$export$3eb7f4ab94bcebc3 = $acw62.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {}
    }
});




var $acw62 = parcelRequire("acw62");

/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */ var $c011a102064f82ea$export$ec835b702d42f3f0 = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    pauseBreak: 19,
    capslock: 20,
    escape: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    del: 46,
    zero: 48,
    one: 49,
    two: 50,
    three: 51,
    four: 52,
    five: 53,
    six: 54,
    seven: 55,
    eight: 56,
    nine: 57,
    colon: 58,
    a: 65,
    b: 66,
    c: 67,
    d: 68,
    e: 69,
    f: 70,
    g: 71,
    h: 72,
    i: 73,
    j: 74,
    k: 75,
    l: 76,
    m: 77,
    n: 78,
    o: 79,
    p: 80,
    q: 81,
    r: 82,
    s: 83,
    t: 84,
    u: 85,
    v: 86,
    w: 87,
    x: 88,
    y: 89,
    z: 90,
    leftWindow: 91,
    rightWindow: 92,
    select: 93,
    /* eslint-disable @typescript-eslint/naming-convention */ zero_numpad: 96,
    one_numpad: 97,
    two_numpad: 98,
    three_numpad: 99,
    four_numpad: 100,
    five_numpad: 101,
    six_numpad: 102,
    seven_numpad: 103,
    eight_numpad: 104,
    nine_numpad: 105,
    /* eslint-enable @typescript-eslint/naming-convention */ multiply: 106,
    add: 107,
    subtract: 109,
    decimalPoint: 110,
    divide: 111,
    f1: 112,
    f2: 113,
    f3: 114,
    f4: 115,
    f5: 116,
    f6: 117,
    f7: 118,
    f8: 119,
    f9: 120,
    f10: 121,
    f11: 122,
    f12: 123,
    numlock: 144,
    scrollLock: 145,
    semicolon: 186,
    equalSign: 187,
    comma: 188,
    dash: 189,
    period: 190,
    forwardSlash: 191,
    graveAccent: 192,
    openBracket: 219,
    backSlash: 220,
    closeBracket: 221,
    singleQuote: 222
};





var $723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY = "isRTL";
// Default to undefined so that we initialize on first read.
var $723d0744d8fe4fde$var$_isRTL;
function $723d0744d8fe4fde$export$b2303637e9533380(theme) {
    if (theme === void 0) theme = {};
    if (theme.rtl !== undefined) return theme.rtl;
    if ($723d0744d8fe4fde$var$_isRTL === undefined) {
        // Fabric supports persisting the RTL setting between page refreshes via session storage
        var savedRTL = (0, $6e93d649f0f85bbf$export$f92dfeb71e9bb569)($723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY);
        if (savedRTL !== null) {
            $723d0744d8fe4fde$var$_isRTL = savedRTL === "1";
            $723d0744d8fe4fde$export$64006deca925fb65($723d0744d8fe4fde$var$_isRTL);
        }
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if ($723d0744d8fe4fde$var$_isRTL === undefined && doc) {
            $723d0744d8fe4fde$var$_isRTL = (doc.body && doc.body.getAttribute("dir") || doc.documentElement.getAttribute("dir")) === "rtl";
            (0, $83a2b0773b0b5f26$export$64006deca925fb65)($723d0744d8fe4fde$var$_isRTL);
        }
    }
    return !!$723d0744d8fe4fde$var$_isRTL;
}
function $723d0744d8fe4fde$export$64006deca925fb65(isRTL, persistSetting) {
    if (persistSetting === void 0) persistSetting = false;
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
    if (persistSetting) (0, $6e93d649f0f85bbf$export$8a8216c44337cd5)($723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY, isRTL ? "1" : "0");
    $723d0744d8fe4fde$var$_isRTL = isRTL;
    (0, $83a2b0773b0b5f26$export$64006deca925fb65)($723d0744d8fe4fde$var$_isRTL);
}
function $723d0744d8fe4fde$export$404175034cd47507(key, theme) {
    if (theme === void 0) theme = {};
    if ($723d0744d8fe4fde$export$b2303637e9533380(theme)) {
        if (key === (0, $c011a102064f82ea$export$ec835b702d42f3f0).left) key = (0, $c011a102064f82ea$export$ec835b702d42f3f0).right;
        else if (key === (0, $c011a102064f82ea$export$ec835b702d42f3f0).right) key = (0, $c011a102064f82ea$export$ec835b702d42f3f0).left;
    }
    return key;
}



var $d53776f84aaef75b$export$e6e34fd1f2686227 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b);


function $4ef47077a6518ef4$export$bb4665f044311879(type, props) {
    var children = [];
    for(var _i = 2; _i < arguments.length; _i++)children[_i - 2] = arguments[_i];
    var slotType = type;
    if (slotType.isSlot) {
        // Since we are bypassing createElement, use React.Children.toArray to make sure children are
        // properly assigned keys.
        // TODO: should this be mutating? does React mutate children subprop with createElement?
        // TODO: will toArray clobber existing keys?
        // TODO: React generates warnings because it doesn't detect hidden member _store that is set in createElement.
        //        Even children passed to createElement without keys don't generate this warning.
        //        Is there a better way to prevent slots from appearing in hierarchy? toArray doesn't address root issue.
        children = $acw62.Children.toArray(children);
        // TODO: There is something weird going on here with children embedded in props vs. rest args.
        // Comment out these lines to see. Make sure this function is doing the right things.
        if (children.length === 0) return slotType(props);
        return slotType((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
            children: children
        }));
    } else // TODO: Are there some cases where children should NOT be spread? Also, spreading reraises perf question.
    //        Children had to be spread to avoid breaking KeytipData in Toggle.view:
    //        react-dom.development.js:18931 Uncaught TypeError: children is not a function
    //        Without spread, function child is a child array of one element
    // TODO: is there a reason this can't be:
    // return React.createElement.apply(this, arguments);
    return $acw62.createElement.apply($acw62, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        type,
        props
    ], children, false));
}
function $4ef47077a6518ef4$export$d38cd72104c1f0e9(DefaultComponent, options) {
    if (options === void 0) options = {};
    var _a = options.defaultProp, defaultProp = _a === void 0 ? "children" : _a;
    var result = function(componentProps, userProps, userSlotOptions, defaultStyles, theme) {
        // If they passed in raw JSX, just return that.
        if ($acw62.isValidElement(userProps)) return userProps;
        var flattenedUserProps = $4ef47077a6518ef4$var$_translateShorthand(defaultProp, userProps);
        var finalProps = $4ef47077a6518ef4$var$_constructFinalProps(defaultStyles, theme, componentProps, flattenedUserProps);
        if (userSlotOptions) {
            if (userSlotOptions.component) {
                // TODO: Remove cast if possible. This cast is needed because TS errors on the intrinsic portion of ReactType.
                // return <userSlotOptions.component {...finalProps} />;
                var UserComponent = userSlotOptions.component;
                return $acw62.createElement(UserComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, finalProps));
            }
            if (userSlotOptions.render) return userSlotOptions.render(finalProps, DefaultComponent);
        }
        return $acw62.createElement(DefaultComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, finalProps));
    };
    return result;
}
/**
 * Default factory for components without explicit factories.
 */ var $4ef47077a6518ef4$var$defaultFactory = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(type) {
    return $4ef47077a6518ef4$export$d38cd72104c1f0e9(type);
});
function $4ef47077a6518ef4$export$47dfb797b70c39e3(userProps, slots) {
    var result = {};
    // userProps already has default props mixed in by createComponent. Recast here to gain typing for this function.
    var mixedProps = userProps;
    var _loop_1 = function(name_1) {
        if (slots.hasOwnProperty(name_1)) {
            // This closure method requires the use of withSlots to prevent unnecessary rerenders. This is because React
            // detects each closure as a different component (since it is a new instance) from the previous one and then
            // forces a rerender of the entire slot subtree. For now, the only way to avoid this is to use withSlots, which
            // bypasses the call to React.createElement.
            var slot = function(componentProps) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                if (args.length > 0) // If React.createElement is being incorrectly used with slots, there will be additional arguments.
                // We can detect these additional arguments and error on their presence.
                throw new Error("Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.");
                // TODO: having TS infer types here seems to cause infinite loop.
                //   use explicit types or casting to preserve typing if possible.
                // TODO: this should be a lookup on TProps property instead of being TProps directly, which is probably
                //   causing the infinite loop
                return $4ef47077a6518ef4$var$_renderSlot(slots[name_1], // TODO: this cast to any is hiding a relationship issue between the first two args
                componentProps, mixedProps[name_1], mixedProps.slots && mixedProps.slots[name_1], // _defaultStyles should always be present, but a check for existence is added to make view tests
                // easier to use.
                mixedProps._defaultStyles && mixedProps._defaultStyles[name_1], mixedProps.theme);
            };
            slot.isSlot = true;
            result[name_1] = slot;
        }
    };
    for(var name_1 in slots)_loop_1(name_1);
    return result;
}
/**
 * Helper function that translates shorthand as needed.
 * @param defaultProp
 * @param slotProps
 */ function $4ef47077a6518ef4$var$_translateShorthand(defaultProp, slotProps) {
    var _a;
    var transformedProps;
    if (typeof slotProps === "string" || typeof slotProps === "number" || typeof slotProps === "boolean") transformedProps = (_a = {}, _a[defaultProp] = slotProps, _a);
    else transformedProps = slotProps;
    return transformedProps;
}
/**
 * Helper function that constructs final styles and props given a series of props ordered by increasing priority.
 */ function $4ef47077a6518ef4$var$_constructFinalProps(defaultStyles, theme) {
    var allProps = [];
    for(var _i = 2; _i < arguments.length; _i++)allProps[_i - 2] = arguments[_i];
    var finalProps = {};
    var classNames = [];
    for(var _a = 0, allProps_1 = allProps; _a < allProps_1.length; _a++){
        var props = allProps_1[_a];
        classNames.push(props && props.className);
        (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(finalProps, props);
    }
    finalProps.className = (0, $aa1d034ba9a4cf1b$export$f77a3199de250644)([
        defaultStyles,
        classNames
    ], {
        rtl: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)
    });
    return finalProps;
}
/**
 * Render a slot given component and user props. Uses component factory if available, otherwise falls back
 * to default factory.
 * @param ComponentType Factory component type.
 * @param componentProps The properties passed into slot from within the component.
 * @param userProps The user properties passed in from outside of the component.
 */ function $4ef47077a6518ef4$var$_renderSlot(ComponentType, componentProps, userProps, slotOptions, defaultStyles, theme) {
    if (ComponentType.create !== undefined) return ComponentType.create(componentProps, userProps, slotOptions, defaultStyles);
    else // TODO: need to resolve typing / generic issues passing through memoizeFunction. for now, cast to 'unknown'
    return $4ef47077a6518ef4$var$defaultFactory(ComponentType)(componentProps, userProps, slotOptions, defaultStyles, theme);
}



function $8775c756093daf3d$export$60e54eaca7e7fb38(view, options) {
    if (options === void 0) options = {};
    var _a = options.factoryOptions, factoryOptions = _a === void 0 ? {} : _a;
    var defaultProp = factoryOptions.defaultProp;
    var ResultComponent = function(componentProps) {
        var settings = $8775c756093daf3d$var$_getCustomizations(options.displayName, $acw62.useContext((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3)), options.fields);
        var stateReducer = options.state;
        if (stateReducer) // Don't assume state will return all props, so spread useState result over component props.
        componentProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, componentProps), stateReducer(componentProps));
        var theme = componentProps.theme || settings.theme;
        var tokens = $8775c756093daf3d$var$_resolveTokens(componentProps, theme, options.tokens, settings.tokens, componentProps.tokens);
        var styles = $8775c756093daf3d$var$_resolveStyles(componentProps, theme, tokens, options.styles, settings.styles, componentProps.styles);
        var viewProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, componentProps), {
            styles: styles,
            tokens: tokens,
            _defaultStyles: styles,
            theme: theme
        });
        return view(viewProps);
    };
    ResultComponent.displayName = options.displayName || view.name;
    // If a shorthand prop is defined, create a factory for the component.
    // TODO: This shouldn't be a concern of createComponent.. factoryOptions should just be forwarded.
    //       Need to weigh creating default factories on component creation vs. memoizing them on use in slots.tsx.
    if (defaultProp) ResultComponent.create = (0, $4ef47077a6518ef4$export$d38cd72104c1f0e9)(ResultComponent, {
        defaultProp: defaultProp
    });
    (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(ResultComponent, options.statics);
    // Later versions of TypeSript should allow us to merge objects in a type safe way and avoid this cast.
    return ResultComponent;
}
/**
 * Resolve all styles functions with both props and tokens and flatten results along with all styles objects.
 */ function $8775c756093daf3d$var$_resolveStyles(props, theme, tokens) {
    var allStyles = [];
    for(var _i = 3; _i < arguments.length; _i++)allStyles[_i - 3] = arguments[_i];
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, allStyles.map(function(styles) {
        return typeof styles === "function" ? styles(props, theme, tokens) : styles;
    }));
}
/**
 * Resolve all tokens functions with props flatten results along with all tokens objects.
 */ function $8775c756093daf3d$var$_resolveTokens(props, theme) {
    var allTokens = [];
    for(var _i = 2; _i < arguments.length; _i++)allTokens[_i - 2] = arguments[_i];
    var tokens = {};
    for(var _a = 0, allTokens_1 = allTokens; _a < allTokens_1.length; _a++){
        var currentTokens = allTokens_1[_a];
        if (currentTokens) {
            // TODO: why is this cast needed? TS seems to think there is a (TToken | Function) union from somewhere.
            currentTokens = typeof currentTokens === "function" ? currentTokens(props, theme) : currentTokens;
            if (Array.isArray(currentTokens)) currentTokens = $8775c756093daf3d$var$_resolveTokens.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props,
                theme
            ], currentTokens, false));
            (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(tokens, currentTokens);
        }
    }
    return tokens;
}
/**
 * Helper function for calling Customizations.getSettings falling back to default fields.
 *
 * @param displayName Displayable name for component.
 * @param context React context passed to component containing contextual settings.
 * @param fields Optional list of properties to grab from global store and context.
 */ function $8775c756093daf3d$var$_getCustomizations(displayName, context, fields) {
    // TODO: do we want field props? should fields be part of IComponent and used here?
    // TODO: should we centrally define DefaultFields? (not exported from styling)
    // TODO: tie this array to ICustomizationProps, such that each array element is keyof ICustomizationProps
    var DefaultFields = [
        "theme",
        "styles",
        "tokens"
    ];
    return (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(fields || DefaultFields, displayName, context.customizations);
}


/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */ function $12c8f27fb57f0fcf$export$dbf350e5966cf602() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var classes = [];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        if (arg) {
            if (typeof arg === "string") classes.push(arg);
            else if (arg.hasOwnProperty("toString") && typeof arg.toString === "function") classes.push(arg.toString());
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                for(var key in arg)// eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (arg[key]) classes.push(key);
            }
        }
    }
    return classes.join(" ");
}

var $076f236b4b7f2dc0$var$toObjectMap = function() {
    var items = [];
    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
    var result = {};
    for(var _a = 0, items_1 = items; _a < items_1.length; _a++){
        var item = items_1[_a];
        var keys = Array.isArray(item) ? item : Object.keys(item);
        for(var _b = 0, keys_1 = keys; _b < keys_1.length; _b++){
            var key = keys_1[_b];
            result[key] = 1;
        }
    }
    return result;
};
var $076f236b4b7f2dc0$export$32eff4db2feb903 = $076f236b4b7f2dc0$var$toObjectMap([
    "onCopy",
    "onCut",
    "onPaste",
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onInput",
    "onSubmit",
    "onLoad",
    "onError",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyUp",
    "onAbort",
    "onCanPlay",
    "onCanPlayThrough",
    "onDurationChange",
    "onEmptied",
    "onEncrypted",
    "onEnded",
    "onLoadedData",
    "onLoadedMetadata",
    "onLoadStart",
    "onPause",
    "onPlay",
    "onPlaying",
    "onProgress",
    "onRateChange",
    "onSeeked",
    "onSeeking",
    "onStalled",
    "onSuspend",
    "onTimeUpdate",
    "onVolumeChange",
    "onWaiting",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "onScroll",
    "onWheel",
    "onPointerCancel",
    "onPointerDown",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerMove",
    "onPointerOut",
    "onPointerOver",
    "onPointerUp",
    "onGotPointerCapture",
    "onLostPointerCapture"
]);
var $076f236b4b7f2dc0$export$7256d73338e409fd = $076f236b4b7f2dc0$var$toObjectMap([
    "accessKey",
    "children",
    "className",
    "contentEditable",
    "dir",
    "draggable",
    "hidden",
    "htmlFor",
    "id",
    "lang",
    "ref",
    "role",
    "style",
    "tabIndex",
    "title",
    "translate",
    "spellCheck",
    "name"
]);
var $076f236b4b7f2dc0$export$e4936fed10ab2c40 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$7256d73338e409fd, $076f236b4b7f2dc0$export$32eff4db2feb903);
var $076f236b4b7f2dc0$export$ec8d81a3d8f61d0f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "form"
]);
var $076f236b4b7f2dc0$export$55af9cf105a52547 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "height",
    "loop",
    "muted",
    "preload",
    "src",
    "width"
]);
var $076f236b4b7f2dc0$export$cd2126b486be823e = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$55af9cf105a52547, [
    "poster"
]);
var $076f236b4b7f2dc0$export$9e755727cea4fd1f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "start"
]);
var $076f236b4b7f2dc0$export$8703767c2ecb797b = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "value"
]);
var $076f236b4b7f2dc0$export$bd4643a0b4568ed8 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "download",
    "href",
    "hrefLang",
    "media",
    "rel",
    "target",
    "type"
]);
var $076f236b4b7f2dc0$export$4fd534fb1e82b8b4 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "autoFocus",
    "disabled",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "type",
    "value"
]);
var $076f236b4b7f2dc0$export$33c6815a27d08ce5 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    "accept",
    "alt",
    "autoCapitalize",
    "autoComplete",
    "checked",
    "dirname",
    "form",
    "height",
    "inputMode",
    "list",
    "max",
    "maxLength",
    "min",
    "minLength",
    "multiple",
    "pattern",
    "placeholder",
    "readOnly",
    "required",
    "src",
    "step",
    "size",
    "type",
    "value",
    "width"
]);
var $076f236b4b7f2dc0$export$699534499318873d = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    "autoCapitalize",
    "cols",
    "dirname",
    "form",
    "maxLength",
    "minLength",
    "placeholder",
    "readOnly",
    "required",
    "rows",
    "wrap"
]);
var $076f236b4b7f2dc0$export$9475341421ea2846 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    "form",
    "multiple",
    "required"
]);
var $076f236b4b7f2dc0$export$9004c3828878727f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "selected",
    "value"
]);
var $076f236b4b7f2dc0$export$2f53f8cf7eb86ae5 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "cellPadding",
    "cellSpacing"
]);
var $076f236b4b7f2dc0$export$3ab2f4f445c2eb24 = $076f236b4b7f2dc0$export$e4936fed10ab2c40;
var $076f236b4b7f2dc0$export$2b115a026f474c83 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "rowSpan",
    "scope"
]);
var $076f236b4b7f2dc0$export$b5d753b2279d22cc = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "colSpan",
    "headers",
    "rowSpan",
    "scope"
]);
var $076f236b4b7f2dc0$export$d526cc4b9c261b42 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "span"
]);
var $076f236b4b7f2dc0$export$e487baa138d06e98 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "span"
]);
var $076f236b4b7f2dc0$export$477a3a6d251d97a7 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "acceptCharset",
    "action",
    "encType",
    "encType",
    "method",
    "noValidate",
    "target"
]);
var $076f236b4b7f2dc0$export$727a7f82229b450f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "allow",
    "allowFullScreen",
    "allowPaymentRequest",
    "allowTransparency",
    "csp",
    "height",
    "importance",
    "referrerPolicy",
    "sandbox",
    "src",
    "srcDoc",
    "width"
]);
var $076f236b4b7f2dc0$export$91f8cc2b546c057d = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    "alt",
    "crossOrigin",
    "height",
    "src",
    "srcSet",
    "useMap",
    "width"
]);
var $076f236b4b7f2dc0$export$dcff37c9c09e9e03 = $076f236b4b7f2dc0$export$91f8cc2b546c057d;
var $076f236b4b7f2dc0$export$eb42a981869108f0 = $076f236b4b7f2dc0$export$e4936fed10ab2c40;
function $076f236b4b7f2dc0$export$26fba481281db559(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, allowedPropNames, excludedPropNames) {
    // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
    // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
    // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
    // return native props.
    // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
    var isArray = Array.isArray(allowedPropNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    var keys = Object.keys(props);
    for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
        var key = keys_2[_i];
        var isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf("data-") === 0 || key.indexOf("aria-") === 0;
        if (isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === void 0 ? void 0 : excludedPropNames.indexOf(key)) === -1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = props[key];
    }
    return result;
}


function $9d47dbd69e7cba76$export$8f36788a39deb482(componentName, props, deprecationMap) {
    var propName, deprecationMessage, replacementPropName;
}





var $a6a15e2533bfbd6b$export$2ecde6259cbd2585 = {
    root: "ms-StackItem"
};
var $a6a15e2533bfbd6b$var$alignMap = {
    start: "flex-start",
    end: "flex-end"
};
var $a6a15e2533bfbd6b$export$180f1ee1f54d2183 = function(props, theme, tokens) {
    var grow = props.grow, shrink = props.shrink, disableShrink = props.disableShrink, align = props.align, verticalFill = props.verticalFill, order = props.order, className = props.className, _a = props.basis, basis = _a === void 0 ? "auto" : _a;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($a6a15e2533bfbd6b$export$2ecde6259cbd2585, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                flexBasis: basis,
                margin: tokens.margin,
                padding: tokens.padding,
                height: verticalFill ? "100%" : "auto",
                width: "auto"
            },
            grow && {
                flexGrow: grow === true ? 1 : grow
            },
            (disableShrink || !grow && !shrink) && {
                flexShrink: 0
            },
            shrink && !disableShrink && {
                flexShrink: 1
            },
            align && {
                alignSelf: $a6a15e2533bfbd6b$var$alignMap[align] || align
            },
            order && {
                order: order
            },
            className
        ]
    };
};


// Helper function that converts a themed spacing key (if given) to the corresponding themed spacing value.
var $de2b55cd863af155$var$_getThemedSpacing = function(space, theme) {
    if (theme.spacing.hasOwnProperty(space)) return theme.spacing[space];
    return space;
};
// Helper function that takes a gap as a string and converts it into a { value, unit } representation.
var $de2b55cd863af155$var$_getValueUnitGap = function(gap) {
    var numericalPart = parseFloat(gap);
    var numericalValue = isNaN(numericalPart) ? 0 : numericalPart;
    var numericalString = isNaN(numericalPart) ? "" : numericalPart.toString();
    var unitPart = gap.substring(numericalString.toString().length);
    return {
        value: numericalValue,
        unit: unitPart || "px"
    };
};
var $de2b55cd863af155$export$639eae2f079cf37f = function(gap, theme) {
    if (gap === undefined || gap === "") return {
        rowGap: {
            value: 0,
            unit: "px"
        },
        columnGap: {
            value: 0,
            unit: "px"
        }
    };
    if (typeof gap === "number") return {
        rowGap: {
            value: gap,
            unit: "px"
        },
        columnGap: {
            value: gap,
            unit: "px"
        }
    };
    var splitGap = gap.split(" ");
    // If the array has more than two values, then return 0px.
    if (splitGap.length > 2) return {
        rowGap: {
            value: 0,
            unit: "px"
        },
        columnGap: {
            value: 0,
            unit: "px"
        }
    };
    // If the array has two values, then parse each one.
    if (splitGap.length === 2) return {
        rowGap: $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(splitGap[0], theme)),
        columnGap: $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(splitGap[1], theme))
    };
    // Else, parse the numerical value and pass it as both the vertical and horizontal gap.
    var calculatedGap = $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(gap, theme));
    return {
        rowGap: calculatedGap,
        columnGap: calculatedGap
    };
};
var $de2b55cd863af155$export$4bc3c325941e6f67 = function(padding, theme) {
    if (padding === undefined || typeof padding === "number" || padding === "") return padding;
    var paddingValues = padding.split(" ");
    if (paddingValues.length < 2) return $de2b55cd863af155$var$_getThemedSpacing(padding, theme);
    return paddingValues.reduce(function(padding1, padding2) {
        return $de2b55cd863af155$var$_getThemedSpacing(padding1, theme) + " " + $de2b55cd863af155$var$_getThemedSpacing(padding2, theme);
    });
};


var $ce115449bc17fcbf$var$nameMap = {
    start: "flex-start",
    end: "flex-end"
};
var $ce115449bc17fcbf$export$2ecde6259cbd2585 = {
    root: "ms-Stack",
    inner: "ms-Stack-inner",
    child: "ms-Stack-child"
};
var $ce115449bc17fcbf$export$9dd6ff9ea0189349 = function(props, theme, tokens) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var className = props.className, disableShrink = props.disableShrink, enableScopedSelectors = props.enableScopedSelectors, grow = props.grow, horizontal = props.horizontal, horizontalAlign = props.horizontalAlign, reversed = props.reversed, verticalAlign = props.verticalAlign, verticalFill = props.verticalFill, wrap = props.wrap;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($ce115449bc17fcbf$export$2ecde6259cbd2585, theme);
    /* eslint-disable deprecation/deprecation */ var childrenGap = tokens && tokens.childrenGap ? tokens.childrenGap : props.gap;
    var maxHeight = tokens && tokens.maxHeight ? tokens.maxHeight : props.maxHeight;
    var maxWidth = tokens && tokens.maxWidth ? tokens.maxWidth : props.maxWidth;
    var padding = tokens && tokens.padding ? tokens.padding : props.padding;
    /* eslint-enable deprecation/deprecation */ var _p = (0, $de2b55cd863af155$export$639eae2f079cf37f)(childrenGap, theme), rowGap = _p.rowGap, columnGap = _p.columnGap;
    var horizontalMargin = "".concat(-0.5 * columnGap.value).concat(columnGap.unit);
    var verticalMargin = "".concat(-0.5 * rowGap.value).concat(rowGap.unit);
    // styles to be applied to all direct children regardless of wrap or direction
    var childStyles = {
        textOverflow: "ellipsis"
    };
    var childSelector = "> " + (enableScopedSelectors ? "." + $ce115449bc17fcbf$export$2ecde6259cbd2585.child : "*");
    var disableShrinkStyles = (_a = {}, // flexShrink styles are applied by the StackItem
    _a["".concat(childSelector, ":not(.").concat((0, $a6a15e2533bfbd6b$export$2ecde6259cbd2585).root, ")")] = {
        flexShrink: 0
    }, _a);
    if (wrap) return {
        root: [
            classNames.root,
            {
                flexWrap: "wrap",
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                width: "auto",
                overflow: "visible",
                height: "100%"
            },
            horizontalAlign && (_b = {}, _b[horizontal ? "justifyContent" : "alignItems"] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _b),
            verticalAlign && (_c = {}, _c[horizontal ? "alignItems" : "justifyContent"] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _c),
            className,
            {
                // not allowed to be overridden by className
                // since this is necessary in order to prevent collapsing margins
                display: "flex"
            },
            horizontal && {
                height: verticalFill ? "100%" : "auto"
            }
        ],
        inner: [
            classNames.inner,
            (_d = {
                display: "flex",
                flexWrap: "wrap",
                marginLeft: horizontalMargin,
                marginRight: horizontalMargin,
                marginTop: verticalMargin,
                marginBottom: verticalMargin,
                overflow: "visible",
                boxSizing: "border-box",
                padding: (0, $de2b55cd863af155$export$4bc3c325941e6f67)(padding, theme),
                // avoid unnecessary calc() calls if horizontal gap is 0
                width: columnGap.value === 0 ? "100%" : "calc(100% + ".concat(columnGap.value).concat(columnGap.unit, ")"),
                maxWidth: "100vw"
            }, _d[childSelector] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                margin: "".concat(0.5 * rowGap.value).concat(rowGap.unit, " ").concat(0.5 * columnGap.value).concat(columnGap.unit)
            }, childStyles), _d),
            disableShrink && disableShrinkStyles,
            horizontalAlign && (_e = {}, _e[horizontal ? "justifyContent" : "alignItems"] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _e),
            verticalAlign && (_f = {}, _f[horizontal ? "alignItems" : "justifyContent"] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _f),
            horizontal && (_g = {
                flexDirection: reversed ? "row-reverse" : "row",
                // avoid unnecessary calc() calls if vertical gap is 0
                height: rowGap.value === 0 ? "100%" : "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _g[childSelector] = {
                maxWidth: columnGap.value === 0 ? "100%" : "calc(100% - ".concat(columnGap.value).concat(columnGap.unit, ")")
            }, _g),
            !horizontal && (_h = {
                flexDirection: reversed ? "column-reverse" : "column",
                height: "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _h[childSelector] = {
                maxHeight: rowGap.value === 0 ? "100%" : "calc(100% - ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _h)
        ]
    };
    return {
        root: [
            classNames.root,
            (_j = {
                display: "flex",
                flexDirection: horizontal ? reversed ? "row-reverse" : "row" : reversed ? "column-reverse" : "column",
                flexWrap: "nowrap",
                width: "auto",
                height: verticalFill ? "100%" : "auto",
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                padding: (0, $de2b55cd863af155$export$4bc3c325941e6f67)(padding, theme),
                boxSizing: "border-box"
            }, _j[childSelector] = childStyles, _j),
            disableShrink && disableShrinkStyles,
            grow && {
                flexGrow: grow === true ? 1 : grow
            },
            horizontalAlign && (_k = {}, _k[horizontal ? "justifyContent" : "alignItems"] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _k),
            verticalAlign && (_l = {}, _l[horizontal ? "alignItems" : "justifyContent"] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _l),
            horizontal && columnGap.value > 0 && (_m = {}, // apply gap margin to every direct child except the first direct child if the direction is not reversed,
            // and the last direct one if it is
            _m[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                marginLeft: "".concat(columnGap.value).concat(columnGap.unit)
            }, _m),
            !horizontal && rowGap.value > 0 && (_o = {}, // apply gap margin to every direct child except the first direct child if the direction is not reversed,
            // and the last direct one if it is
            _o[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                marginTop: "".concat(rowGap.value).concat(rowGap.unit)
            }, _o),
            className
        ]
    };
};






var $5ed43aff81d2044b$var$StackItemView = function(props) {
    var children = props.children;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    // eslint-disable-next-line eqeqeq
    if (children == null) return null;
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: "div"
    });
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), children);
};
var $5ed43aff81d2044b$export$50d5391cd1a018c6 = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)($5ed43aff81d2044b$var$StackItemView, {
    displayName: "StackItem",
    styles: (0, $a6a15e2533bfbd6b$export$180f1ee1f54d2183)
});
var $5ed43aff81d2044b$export$2e2bcd8739ae039 = $5ed43aff81d2044b$export$50d5391cd1a018c6;


var $96647f41d860b545$var$StackView = function(props) {
    var _a = props.as, RootType = _a === void 0 ? "div" : _a, _b = props.disableShrink, disableShrink = _b === void 0 ? false : _b, _c = props.enableScopedSelectors, enableScopedSelectors = _c === void 0 ? false : _c, wrap = props.wrap, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "as",
        "disableShrink",
        "enableScopedSelectors",
        "wrap"
    ]);
    (0, $9d47dbd69e7cba76$export$8f36788a39deb482)("Stack", props, {
        gap: "tokens.childrenGap",
        maxHeight: "tokens.maxHeight",
        maxWidth: "tokens.maxWidth",
        padding: "tokens.padding"
    });
    var stackChildren = $96647f41d860b545$var$_processStackChildren(props.children, {
        disableShrink: disableShrink,
        enableScopedSelectors: enableScopedSelectors
    });
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(rest, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: RootType,
        inner: "div"
    });
    if (wrap) return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.inner, null, stackChildren));
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), stackChildren);
};
function $96647f41d860b545$var$_processStackChildren(children, _a) {
    var disableShrink = _a.disableShrink, enableScopedSelectors = _a.enableScopedSelectors;
    var childrenArray = $acw62.Children.toArray(children);
    childrenArray = $acw62.Children.map(childrenArray, function(child) {
        if (!child || !$acw62.isValidElement(child)) return child;
        if (child.type === $acw62.Fragment) return child.props.children ? $96647f41d860b545$var$_processStackChildren(child.props.children, {
            disableShrink: disableShrink,
            enableScopedSelectors: enableScopedSelectors
        }) : null;
        var childAsReactElement = child;
        var defaultItemProps = {};
        if ($96647f41d860b545$var$_isStackItem(child)) defaultItemProps = {
            shrink: !disableShrink
        };
        var childClassName = childAsReactElement.props.className;
        return $acw62.cloneElement(childAsReactElement, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultItemProps), childAsReactElement.props), childClassName && {
            className: childClassName
        }), enableScopedSelectors && {
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $ce115449bc17fcbf$export$2ecde6259cbd2585).child, childClassName)
        }));
    });
    return childrenArray;
}
function $96647f41d860b545$var$_isStackItem(item) {
    // In theory, we should be able to just check item.type === StackItem.
    // However, under certain unclear circumstances (see https://github.com/microsoft/fluentui/issues/10785),
    // the object identity is different despite the function implementation being the same.
    return !!item && typeof item === "object" && !!item.type && // StackItem is generated by createComponent, so we need to check its displayName instead of name
    item.type.displayName === (0, $5ed43aff81d2044b$export$50d5391cd1a018c6).displayName;
}
var $96647f41d860b545$var$StackStatics = {
    Item: (0, $5ed43aff81d2044b$export$50d5391cd1a018c6)
};
var $96647f41d860b545$export$694e0d28c7ffc90c = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)($96647f41d860b545$var$StackView, {
    displayName: "Stack",
    styles: (0, $ce115449bc17fcbf$export$9dd6ff9ea0189349),
    statics: $96647f41d860b545$var$StackStatics
});
var $96647f41d860b545$export$2e2bcd8739ae039 = $96647f41d860b545$export$694e0d28c7ffc90c;



var $acw62 = parcelRequire("acw62");

var $210db43103611d77$exports = {};

$parcel$export($210db43103611d77$exports, "ErrorBoundary", () => $210db43103611d77$export$e926676385687eaf);


var $acw62 = parcelRequire("acw62");
var $210db43103611d77$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $210db43103611d77$export$e926676385687eaf = /** @class */ function(_super) {
    $210db43103611d77$var$__extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            error: ""
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error.toString()
        };
    };
    ErrorBoundary.prototype.render = function() {
        if (this.state.error) // You can render any custom fallback UI
        return (0, $7b02d682eb115277$exports.jsx)("pre", {
            children: this.state.error
        }, void 0);
        return this.props.children;
    };
    return ErrorBoundary;
}($acw62.Component);


var $5607221af92f9c3a$var$__assign = undefined && undefined.__assign || function() {
    $5607221af92f9c3a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5607221af92f9c3a$var$__assign.apply(this, arguments);
};
(0, $9efd9e0e93a4c86b$export$daed2daeba655e15)();
function $5607221af92f9c3a$export$86fbec116b87613f() {
    var _a = (0, $acw62.useState)(""), company = _a[0], setCompany = _a[1];
    var onSignOutClicked = function() {
        setCompany("");
        if (logOutHandle.current) logOutHandle.current();
    };
    var logOutHandle = (0, $acw62.useRef)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $210db43103611d77$exports.ErrorBoundary), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $5607221af92f9c3a$var$__assign({
            className: "root",
            horizontalAlign: "center"
        }, {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $2da54d2112afb05d$exports.Login), $5607221af92f9c3a$var$__assign({
                onLogin: function(c) {
                    setCompany(c);
                },
                logOut: function(onLogout) {
                    logOutHandle.current = onLogout;
                }
            }, {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $dad8c4ad44cfb8f1$exports.JobSeekers), {
                    company: company,
                    onSignOut: onSignOutClicked
                }, void 0)
            }), void 0)
        }), void 0)
    }, void 0);
}


var $2da54d2112afb05d$exports = {};

$parcel$export($2da54d2112afb05d$exports, "Login", () => $2da54d2112afb05d$export$21a94553ffa41578);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $2a04d28498bd59af$export$e00cde8527a0be3f(properties, scopeName) {
    var forceUpdate = $2a04d28498bd59af$var$useForceUpdate();
    var customizations = $acw62.useContext((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3)).customizations;
    var inCustomizerContext = customizations.inCustomizerContext;
    $acw62.useEffect(function() {
        if (!inCustomizerContext) (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(forceUpdate);
        return function() {
            if (!inCustomizerContext) (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(forceUpdate);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude forceUpdate
    }, [
        inCustomizerContext
    ]);
    return (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(properties, scopeName, customizations);
}
function $2a04d28498bd59af$var$useForceUpdate() {
    var _a = $acw62.useState(0), setValue = _a[1];
    return function() {
        return setValue(function(value) {
            return ++value;
        });
    };
}


var $8af9a8c8d5cac055$var$DefaultFields = [
    "theme",
    "styles"
];
function $8af9a8c8d5cac055$export$3817b7a54a07cec7(Component, baseStyles, getProps, customizable, pure) {
    customizable = customizable || {
        scope: "",
        fields: undefined
    };
    var scope = customizable.scope, _a = customizable.fields, fields = _a === void 0 ? $8af9a8c8d5cac055$var$DefaultFields : _a;
    var Wrapped = $acw62.forwardRef(function(props, forwardedRef) {
        var styles = $acw62.useRef();
        var settings = (0, $2a04d28498bd59af$export$e00cde8527a0be3f)(fields, scope);
        var customizedStyles = settings.styles, dir = settings.dir, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(settings, [
            "styles",
            "dir"
        ]);
        var additionalProps = getProps ? getProps(props) : undefined;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var cache = styles.current && styles.current.__cachedInputs__ || [];
        var propStyles = props.styles;
        if (!styles.current || customizedStyles !== cache[1] || propStyles !== cache[2]) {
            // Using styled components as the Component arg will result in nested styling arrays.
            // The function can be cached and in order to prevent the props from being retained within it's closure
            // we pass in just the styles and not the entire props
            var concatenatedStyles = function(styleProps) {
                return (0, $386ae5a2cd0e8632$export$5136bfd779f95982)(styleProps, baseStyles, customizedStyles, propStyles);
            };
            // The __cachedInputs__ array is attached to the function and consumed by the
            // classNamesFunction as a list of keys to include for memoizing classnames.
            concatenatedStyles.__cachedInputs__ = [
                baseStyles,
                customizedStyles,
                propStyles
            ];
            concatenatedStyles.__noStyleOverride__ = !customizedStyles && !propStyles;
            styles.current = concatenatedStyles;
        }
        return $acw62.createElement(Component, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            ref: forwardedRef
        }, rest, additionalProps, props, {
            styles: styles.current
        }));
    });
    // Function.prototype.name is an ES6 feature, so the cast to any is required until we're
    // able to drop IE 11 support and compile with ES6 libs
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Wrapped.displayName = "Styled".concat(Component.displayName || Component.name);
    // This preserves backwards compatibility.
    var pureComponent = pure ? $acw62.memo(Wrapped) : Wrapped;
    // Check if the wrapper has a displayName after it has been memoized. Then assign it to the pure component.
    if (Wrapped.displayName) pureComponent.displayName = Wrapped.displayName;
    return pureComponent;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $7cd4cc59ef8f1433$export$8219f5c55c7cc288(initialValue) {
    // Use useRef to store the value because it's the least expensive built-in hook that works here
    // (we could also use `const [value] = React.useState(initialValue)` but that's more expensive
    // internally due to reducer handling which we don't need)
    var ref = $acw62.useRef();
    if (ref.current === undefined) // Box the value in an object so we can tell if it's initialized even if the initializer
    // returns/is undefined
    ref.current = {
        value: typeof initialValue === "function" ? initialValue() : initialValue
    };
    return ref.current.value;
}


function $55cf7aa9f769b3e9$export$2400c890ca0180b4(controlledValue, defaultUncontrolledValue, onChange) {
    var _a = $acw62.useState(defaultUncontrolledValue), value = _a[0], setValue = _a[1];
    var isControlled = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(controlledValue !== undefined);
    var currentValue = isControlled ? controlledValue : value;
    // Duplicate the current value and onChange in refs so they're accessible from
    // setValueOrCallOnChange without creating a new callback every time
    var valueRef = $acw62.useRef(currentValue);
    var onChangeRef = $acw62.useRef(onChange);
    $acw62.useEffect(function() {
        valueRef.current = currentValue;
        onChangeRef.current = onChange;
    });
    // To match the behavior of the setter returned by React.useState, this callback's identity
    // should never change. This means it MUST NOT directly reference variables that can change.
    var setValueOrCallOnChange = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function(update, ev) {
            // Assuming here that TValue is not a function, because a controllable value will typically
            // be something a user can enter as input
            var newValue = typeof update === "function" ? update(valueRef.current) : update;
            if (onChangeRef.current) onChangeRef.current(ev, newValue);
            if (!isControlled) setValue(newValue);
        };
    });
    return [
        currentValue,
        setValueOrCallOnChange
    ];
}


var $acw62 = parcelRequire("acw62");


// Initialize global window id.
var $532a46d3b196c0f3$var$CURRENT_ID_PROPERTY = "__currentId__";
var $532a46d3b196c0f3$var$DEFAULT_ID_STRING = "id__";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $532a46d3b196c0f3$var$_global = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)() || {};
if ($532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] === undefined) $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] = 0;
var $532a46d3b196c0f3$var$_initializedStylesheetResets = false;
function $532a46d3b196c0f3$export$218c8c3169c024d2(prefix) {
    if (!$532a46d3b196c0f3$var$_initializedStylesheetResets) {
        // Configure ids to reset on stylesheet resets.
        var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
        if (stylesheet && stylesheet.onReset) stylesheet.onReset($532a46d3b196c0f3$export$4cc3052e36a312db);
        $532a46d3b196c0f3$var$_initializedStylesheetResets = true;
    }
    var index = $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY]++;
    return (prefix === undefined ? $532a46d3b196c0f3$var$DEFAULT_ID_STRING : prefix) + index;
}
function $532a46d3b196c0f3$export$4cc3052e36a312db(counter) {
    if (counter === void 0) counter = 0;
    $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] = counter;
}


function $cd7f9b753e2e3aa8$export$f680877a34711e37(prefix, providedId) {
    // getId should only be called once since it updates the global constant for the next ID value.
    // (While an extra update isn't likely to cause problems in practice, it's better to avoid it.)
    var ref = $acw62.useRef(providedId);
    if (!ref.current) ref.current = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)(prefix);
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $0dfbd1d4e59c5781$export$9cf7d991616612b3() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    var mergedCallback = $acw62.useCallback(function(value) {
        // Update the "current" prop hanging on the function.
        mergedCallback.current = value;
        for(var _i = 0, refs_1 = refs; _i < refs_1.length; _i++){
            var ref = refs_1[_i];
            if (typeof ref === "function") ref(value);
            else if (ref) // work around the immutability of the React.Ref type
            ref.current = value;
        }
    }, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], refs, true));
    return mergedCallback;
}





var $f64c8e86ac270e43$var$MAX_CACHE_COUNT = 50;
var $f64c8e86ac270e43$var$DEFAULT_SPECIFICITY_MULTIPLIER = 5;
var $f64c8e86ac270e43$var$_memoizedClassNames = 0;
var $f64c8e86ac270e43$var$stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
if ($f64c8e86ac270e43$var$stylesheet && $f64c8e86ac270e43$var$stylesheet.onReset) $f64c8e86ac270e43$var$stylesheet.onReset(function() {
    return $f64c8e86ac270e43$var$_memoizedClassNames++;
});
// Note that because of the caching nature within the classNames memoization,
// I've disabled this rule to simply be able to work with any types.
/* eslint-disable @typescript-eslint/no-explicit-any */ // This represents a prop we attach to each Map to indicate the cached return value
// associated with the graph node.
var $f64c8e86ac270e43$var$retVal = "__retval__";
function $f64c8e86ac270e43$export$8584b618c75d395d(options) {
    // We build a trie where each node is a Map. The map entry key represents an argument
    // value, and the entry value is another node (Map). Each node has a `__retval__`
    // property which is used to hold the cached response.
    if (options === void 0) options = {};
    // To derive the response, we can simply ensure the arguments are added or already
    // exist in the trie. At the last node, if there is a `__retval__` we return that. Otherwise
    // we call the `getStyles` api to evaluate, cache on the property, and return that.
    var map = new Map();
    var styleCalcCount = 0;
    var getClassNamesCount = 0;
    var currentMemoizedClassNames = $f64c8e86ac270e43$var$_memoizedClassNames;
    var getClassNames = function(styleFunctionOrObject, styleProps) {
        var _a;
        if (styleProps === void 0) styleProps = {};
        // If useStaticStyles is true, styleFunctionOrObject returns slot to classname mappings.
        // If there is also no style overrides, we can skip merge styles completely and
        // simply return the result from the style funcion.
        if (options.useStaticStyles && typeof styleFunctionOrObject === "function" && styleFunctionOrObject.__noStyleOverride__) return styleFunctionOrObject(styleProps);
        getClassNamesCount++;
        var current = map;
        var theme = styleProps.theme;
        var rtl = theme && theme.rtl !== undefined ? theme.rtl : (0, $723d0744d8fe4fde$export$b2303637e9533380)();
        var disableCaching = options.disableCaching;
        // On reset of our stylesheet, reset memoized cache.
        if (currentMemoizedClassNames !== $f64c8e86ac270e43$var$_memoizedClassNames) {
            currentMemoizedClassNames = $f64c8e86ac270e43$var$_memoizedClassNames;
            map = new Map();
            styleCalcCount = 0;
        }
        if (!options.disableCaching) {
            current = $f64c8e86ac270e43$var$_traverseMap(map, styleFunctionOrObject);
            current = $f64c8e86ac270e43$var$_traverseMap(current, styleProps);
        }
        if (disableCaching || !current[$f64c8e86ac270e43$var$retVal]) {
            if (styleFunctionOrObject === undefined) current[$f64c8e86ac270e43$var$retVal] = {};
            else current[$f64c8e86ac270e43$var$retVal] = (0, $00784e00f3e28b27$export$3ea21144e9973d29)([
                typeof styleFunctionOrObject === "function" ? styleFunctionOrObject(styleProps) : styleFunctionOrObject
            ], {
                rtl: !!rtl,
                specificityMultiplier: options.useStaticStyles ? $f64c8e86ac270e43$var$DEFAULT_SPECIFICITY_MULTIPLIER : undefined
            });
            if (!disableCaching) styleCalcCount++;
        }
        if (styleCalcCount > (options.cacheSize || $f64c8e86ac270e43$var$MAX_CACHE_COUNT)) {
            var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
            if ((_a = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _a === void 0 ? void 0 : _a.enableClassNameCacheFullWarning) {
                // eslint-disable-next-line no-console
                console.warn("Styles are being recalculated too frequently. Cache miss rate is ".concat(styleCalcCount, "/").concat(getClassNamesCount, "."));
                // eslint-disable-next-line no-console
                console.trace();
            }
            map.clear();
            styleCalcCount = 0;
            // Mutate the options passed in, that's all we can do.
            options.disableCaching = true;
        }
        // Note: the retVal is an attached property on the Map; not a key in the Map. We use this attached property to
        // cache the return value for this branch of the graph.
        return current[$f64c8e86ac270e43$var$retVal];
    };
    return getClassNames;
}
function $f64c8e86ac270e43$var$_traverseEdge(current, value) {
    value = $f64c8e86ac270e43$var$_normalizeValue(value);
    if (!current.has(value)) current.set(value, new Map());
    return current.get(value);
}
function $f64c8e86ac270e43$var$_traverseMap(current, inputs) {
    if (typeof inputs === "function") {
        var cachedInputsFromStyled = inputs.__cachedInputs__;
        if (cachedInputsFromStyled) // The styled helper will generate the styles function and will attach the cached
        // inputs (consisting of the default styles, customzied styles, and user provided styles.)
        // These should be used as cache keys for deriving the memoized value.
        for(var _i = 0, _a = inputs.__cachedInputs__; _i < _a.length; _i++){
            var input = _a[_i];
            current = $f64c8e86ac270e43$var$_traverseEdge(current, input);
        }
        else current = $f64c8e86ac270e43$var$_traverseEdge(current, inputs);
    } else if (typeof inputs === "object") {
        for(var propName in inputs)if (inputs.hasOwnProperty(propName)) current = $f64c8e86ac270e43$var$_traverseEdge(current, inputs[propName]);
    }
    return current;
}
function $f64c8e86ac270e43$var$_normalizeValue(value) {
    switch(value){
        case undefined:
            return "__undefined__";
        case null:
            return "__null__";
        default:
            return value;
    }
}


var $acw62 = parcelRequire("acw62");


var $fef2641414ae093e$var$_a;
var $fef2641414ae093e$var$DirectionalKeyCodes = ($fef2641414ae093e$var$_a = {}, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).up] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).down] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).left] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).right] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).home] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).end] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).tab] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).pageUp] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).pageDown] = 1, $fef2641414ae093e$var$_a);
function $fef2641414ae093e$export$e5f9b34bb820f5e3(which) {
    return !!$fef2641414ae093e$var$DirectionalKeyCodes[which];
}
function $fef2641414ae093e$export$616d8c95f2a9d165(which) {
    $fef2641414ae093e$var$DirectionalKeyCodes[which] = 1;
}
function $fef2641414ae093e$export$795d157d4f303684(which) {
    delete $fef2641414ae093e$var$DirectionalKeyCodes[which];
}



var $872a30e3c6519016$var$mountCounters = new WeakMap();
var $872a30e3c6519016$var$callbackMap = new WeakMap();
function $872a30e3c6519016$var$setMountCounters(key, delta) {
    var newValue;
    var currValue = $872a30e3c6519016$var$mountCounters.get(key);
    if (currValue) newValue = currValue + delta;
    else newValue = 1;
    $872a30e3c6519016$var$mountCounters.set(key, newValue);
    return newValue;
}
function $872a30e3c6519016$var$setCallbackMap(context) {
    var callbacks = $872a30e3c6519016$var$callbackMap.get(context);
    if (callbacks) return callbacks;
    var onMouseDown = function(ev) {
        return $872a30e3c6519016$var$_onMouseDown(ev, context.registeredProviders);
    };
    var onPointerDown = function(ev) {
        return $872a30e3c6519016$var$_onPointerDown(ev, context.registeredProviders);
    };
    var onKeyDown = function(ev) {
        return $872a30e3c6519016$var$_onKeyDown(ev, context.registeredProviders);
    };
    var onKeyUp = function(ev) {
        return $872a30e3c6519016$var$_onKeyUp(ev, context.registeredProviders);
    };
    callbacks = {
        onMouseDown: onMouseDown,
        onPointerDown: onPointerDown,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    $872a30e3c6519016$var$callbackMap.set(context, callbacks);
    return callbacks;
}
var $872a30e3c6519016$export$683969f4bf72ffbd = $acw62.createContext(undefined);
function $872a30e3c6519016$export$471b875afaf1c0a9(rootRef) {
    var context = $acw62.useContext($872a30e3c6519016$export$683969f4bf72ffbd);
    $acw62.useEffect(function() {
        var _a, _b, _c, _d;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current);
        if (!win || ((_a = win.FabricConfig) === null || _a === void 0 ? void 0 : _a.disableFocusRects) === true) return undefined;
        var el = win;
        var onMouseDown;
        var onPointerDown;
        var onKeyDown;
        var onKeyUp;
        if (((_b = context === null || context === void 0 ? void 0 : context.providerRef) === null || _b === void 0 ? void 0 : _b.current) && ((_d = (_c = context === null || context === void 0 ? void 0 : context.providerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener)) {
            el = context.providerRef.current;
            // The NOINLINE directive tells terser not to move the setCallbackMap implementation into the call site during
            // minification.
            // This prevents the function from capturing additional variables in the closure, which can cause memory leaks.
            var callbacks = /*@__NOINLINE__*/ $872a30e3c6519016$var$setCallbackMap(context);
            onMouseDown = callbacks.onMouseDown;
            onPointerDown = callbacks.onPointerDown;
            onKeyDown = callbacks.onKeyDown;
            onKeyUp = callbacks.onKeyUp;
        } else {
            onMouseDown = $872a30e3c6519016$var$_onMouseDown;
            onPointerDown = $872a30e3c6519016$var$_onPointerDown;
            onKeyDown = $872a30e3c6519016$var$_onKeyDown;
            onKeyUp = $872a30e3c6519016$var$_onKeyUp;
        }
        var count = $872a30e3c6519016$var$setMountCounters(el, 1);
        if (count <= 1) {
            el.addEventListener("mousedown", onMouseDown, true);
            el.addEventListener("pointerdown", onPointerDown, true);
            el.addEventListener("keydown", onKeyDown, true);
            el.addEventListener("keyup", onKeyUp, true);
        }
        return function() {
            var _a;
            if (!win || ((_a = win.FabricConfig) === null || _a === void 0 ? void 0 : _a.disableFocusRects) === true) return;
            count = $872a30e3c6519016$var$setMountCounters(el, -1);
            if (count === 0) {
                el.removeEventListener("mousedown", onMouseDown, true);
                el.removeEventListener("pointerdown", onPointerDown, true);
                el.removeEventListener("keydown", onKeyDown, true);
                el.removeEventListener("keyup", onKeyUp, true);
            }
        };
    }, [
        context,
        rootRef
    ]);
}
var $872a30e3c6519016$export$5dedbdbae91633c9 = function(props) {
    $872a30e3c6519016$export$471b875afaf1c0a9(props.rootRef);
    return null;
};
function $872a30e3c6519016$var$_onMouseDown(ev, registeredProviders) {
    (0, $68e6902efa21380a$export$760b5674477e9343)(false, ev.target, registeredProviders);
}
function $872a30e3c6519016$var$_onPointerDown(ev, registeredProviders) {
    if (ev.pointerType !== "mouse") (0, $68e6902efa21380a$export$760b5674477e9343)(false, ev.target, registeredProviders);
}
// You need both a keydown and a keyup listener that sets focus visibility to true to handle two distinct scenarios when
// attaching the listeners and classnames to the provider instead of the document body.
// If you only have a keydown listener, then the focus rectangles will not show when moving from outside of the provider
// to inside it. That is why a keyup listener is needed, since it will always trigger after the focus event is fired.
// If you only have a keyup listener, then the focus rectangles will not show moving between different tabbable elements
// if the tab key is pressed without being released. That's is why we need a keydown listener, since it will trigger for
// every element that is being tabbed into.
// This works because `classList.add` is smart and will not duplicate a classname that already exists on the classList
// when focus visibility is turned on.
function $872a30e3c6519016$var$_onKeyDown(ev, registeredProviders) {
    // eslint-disable-next-line deprecation/deprecation
    if ((0, $fef2641414ae093e$export$e5f9b34bb820f5e3)(ev.which)) (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, registeredProviders);
}
function $872a30e3c6519016$var$_onKeyUp(ev, registeredProviders) {
    // eslint-disable-next-line deprecation/deprecation
    if ((0, $fef2641414ae093e$export$e5f9b34bb820f5e3)(ev.which)) (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, registeredProviders);
}





var $acw62 = parcelRequire("acw62");
/**
 * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
 * {@docCategory Icon}
 */ var $b2334e548db36fc7$export$13ff1290a9e22e77;
(function(IconType) {
    /**
     * Render using the fabric icon font.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["default"] = 0] = "default";
    /**
     * Render using an image, where imageProps would be used.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["image"] = 1] = "image";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["Default"] = 100000] = "Default";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["Image"] = 100001] = "Image";
})($b2334e548db36fc7$export$13ff1290a9e22e77 || ($b2334e548db36fc7$export$13ff1290a9e22e77 = {}));





var $acw62 = parcelRequire("acw62");

/**
 * The possible methods that can be used to fit the image.
 * {@docCategory Image}
 */ var $7ce18db28442d0b5$export$76ad86136a99d38d;
(function(ImageFit) {
    /**
     * The image is not scaled. The image is centered and cropped within the content box.
     */ ImageFit[ImageFit["center"] = 0] = "center";
    /**
     * The image is scaled to maintain its aspect ratio while being fully contained within the frame. The image will
     * be centered horizontally and vertically within the frame. The space in the top and bottom or in the sides of
     * the frame will be empty depending on the difference in aspect ratio between the image and the frame.
     */ ImageFit[ImageFit["contain"] = 1] = "contain";
    /**
     * The image is scaled to maintain its aspect ratio while filling the frame. Portions of the image will be cropped
     * from the top and bottom, or the sides, depending on the difference in aspect ratio between the image and the frame.
     */ ImageFit[ImageFit["cover"] = 2] = "cover";
    /**
     * Neither the image nor the frame are scaled. If their sizes do not match, the image will either be cropped or the
     * frame will have empty space.
     */ ImageFit[ImageFit["none"] = 3] = "none";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height or width is less than the Image frame's height or width,
     * but if both natural height and width are larger than the frame it will behave as ImageFit.cover.
     */ ImageFit[ImageFit["centerCover"] = 4] = "centerCover";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height and width is less than the Image frame's height and width,
     * but if either natural height or width are larger than the frame it will behave as ImageFit.contain.
     */ ImageFit[ImageFit["centerContain"] = 5] = "centerContain";
})($7ce18db28442d0b5$export$76ad86136a99d38d || ($7ce18db28442d0b5$export$76ad86136a99d38d = {}));
var $7ce18db28442d0b5$export$45bb2c5c61dbecf7;
(function(ImageCoverStyle) {
    /**
     * The image will be shown at 100% height of container and the width will be scaled accordingly
     */ ImageCoverStyle[ImageCoverStyle["landscape"] = 0] = "landscape";
    /**
     * The image will be shown at 100% width of container and the height will be scaled accordingly
     */ ImageCoverStyle[ImageCoverStyle["portrait"] = 1] = "portrait";
})($7ce18db28442d0b5$export$45bb2c5c61dbecf7 || ($7ce18db28442d0b5$export$45bb2c5c61dbecf7 = {}));
var $7ce18db28442d0b5$export$f1a20b6e49b78679;
(function(ImageLoadState) {
    /**
     * The image has not yet been loaded, and there is no error yet.
     */ ImageLoadState[ImageLoadState["notLoaded"] = 0] = "notLoaded";
    /**
     * The image has been loaded successfully.
     */ ImageLoadState[ImageLoadState["loaded"] = 1] = "loaded";
    /**
     * An error has been encountered while loading the image.
     */ ImageLoadState[ImageLoadState["error"] = 2] = "error";
    /**
     * @deprecated Not used. Use `onLoadingStateChange` and re-render the Image with a different src.
     */ ImageLoadState[ImageLoadState["errorLoaded"] = 3] = "errorLoaded";
})($7ce18db28442d0b5$export$f1a20b6e49b78679 || ($7ce18db28442d0b5$export$f1a20b6e49b78679 = {}));



var $acw62 = parcelRequire("acw62");

var $8c9c580731387b01$export$700979bc83e7db82 = (0, $18aa0efffa2a3752$export$71594e8a50f746f4)() ? $acw62.useLayoutEffect : $acw62.useEffect;


var $649c58d3f72a3825$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $649c58d3f72a3825$var$SVG_REGEX = /\.svg$/i;
var $649c58d3f72a3825$var$KEY_PREFIX = "fabricImage";
function $649c58d3f72a3825$var$useLoadState(props, imageElement) {
    var onLoadingStateChange = props.onLoadingStateChange, onLoad = props.onLoad, onError = props.onError, src = props.src;
    var _a = $acw62.useState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded), loadState = _a[0], setLoadState = _a[1];
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        // If the src property changes, reset the load state
        // (does nothing if the load state is already notLoaded)
        setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded);
    }, [
        src
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intended to run every render
    $acw62.useEffect(function() {
        if (loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded) {
            // testing if naturalWidth and naturalHeight are greater than zero is better than checking
            // .complete, because .complete will also be set to true if the image breaks. However,
            // for some browsers, SVG images do not have a naturalWidth or naturalHeight, so fall back
            // to checking .complete for these images.
            var isLoaded = imageElement.current ? src && imageElement.current.naturalWidth > 0 && imageElement.current.naturalHeight > 0 || imageElement.current.complete && $649c58d3f72a3825$var$SVG_REGEX.test(src) : false;
            if (isLoaded) setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded);
        }
    });
    $acw62.useEffect(function() {
        onLoadingStateChange === null || onLoadingStateChange === void 0 || onLoadingStateChange(loadState);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when loadState changes
    }, [
        loadState
    ]);
    var onImageLoaded = $acw62.useCallback(function(ev) {
        onLoad === null || onLoad === void 0 || onLoad(ev);
        if (src) setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded);
    }, [
        src,
        onLoad
    ]);
    var onImageError = $acw62.useCallback(function(ev) {
        onError === null || onError === void 0 || onError(ev);
        setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error);
    }, [
        onError
    ]);
    return [
        loadState,
        onImageLoaded,
        onImageError
    ];
}
var $649c58d3f72a3825$export$a3758d3f9ac64232 = $acw62.forwardRef(function(props, forwardedRef) {
    var frameElement = $acw62.useRef();
    var imageElement = $acw62.useRef();
    var _a = $649c58d3f72a3825$var$useLoadState(props, imageElement), loadState = _a[0], onImageLoaded = _a[1], onImageError = _a[2];
    var imageProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$91f8cc2b546c057d), [
        "width",
        "height"
    ]);
    var src = props.src, alt = props.alt, width = props.width, height = props.height, _b = props.shouldFadeIn, shouldFadeIn = _b === void 0 ? true : _b, shouldStartVisible = props.shouldStartVisible, className = props.className, imageFit = props.imageFit, role = props.role, maximizeFrame = props.maximizeFrame, styles = props.styles, theme = props.theme, loading = props.loading;
    var coverStyle = $649c58d3f72a3825$var$useCoverStyle(props, loadState, imageElement, frameElement);
    var classNames = $649c58d3f72a3825$var$getClassNames(styles, {
        theme: theme,
        className: className,
        width: width,
        height: height,
        maximizeFrame: maximizeFrame,
        shouldFadeIn: shouldFadeIn,
        shouldStartVisible: shouldStartVisible,
        isLoaded: loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded || loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded && props.shouldStartVisible,
        isLandscape: coverStyle === (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).landscape,
        isCenter: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).center,
        isCenterContain: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain,
        isCenterCover: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover,
        isContain: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).contain,
        isCover: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).cover,
        isNone: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).none,
        isError: loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error,
        isNotImageFit: imageFit === undefined
    });
    // If image dimensions aren't specified, the natural size of the image is used.
    return $acw62.createElement("div", {
        className: classNames.root,
        style: {
            width: width,
            height: height
        },
        ref: frameElement
    }, $acw62.createElement("img", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageProps, {
        onLoad: onImageLoaded,
        onError: onImageError,
        key: $649c58d3f72a3825$var$KEY_PREFIX + props.src || "",
        className: classNames.image,
        ref: (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(imageElement, forwardedRef),
        src: src,
        alt: alt,
        role: role,
        loading: loading
    })));
});
$649c58d3f72a3825$export$a3758d3f9ac64232.displayName = "ImageBase";
function $649c58d3f72a3825$var$useCoverStyle(props, loadState, imageElement, frameElement) {
    var previousLoadState = $acw62.useRef(loadState);
    var coverStyle = $acw62.useRef();
    if (coverStyle === undefined || previousLoadState.current === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded && loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded) coverStyle.current = $649c58d3f72a3825$var$computeCoverStyle(props, loadState, imageElement, frameElement);
    previousLoadState.current = loadState;
    return coverStyle.current;
}
function $649c58d3f72a3825$var$computeCoverStyle(props, loadState, imageElement, frameElement) {
    var imageFit = props.imageFit, width = props.width, height = props.height;
    // Do not compute cover style if it was already specified in props
    if (props.coverStyle !== undefined) return props.coverStyle;
    else if (loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded && (imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).cover || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).contain || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover) && imageElement.current && frameElement.current) {
        // Determine the desired ratio using the width and height props.
        // If those props aren't available, measure measure the frame.
        var desiredRatio = void 0;
        if (typeof width === "number" && typeof height === "number" && imageFit !== (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain && imageFit !== (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover) desiredRatio = width / height;
        else desiredRatio = frameElement.current.clientWidth / frameElement.current.clientHeight;
        // Examine the source image to determine its original ratio.
        var naturalRatio = imageElement.current.naturalWidth / imageElement.current.naturalHeight;
        // Should we crop from the top or the sides?
        if (naturalRatio > desiredRatio) return (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).landscape;
    }
    return (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).portrait;
}




var $c192249f2ea24da6$var$GlobalClassNames = {
    root: "ms-Image",
    rootMaximizeFrame: "ms-Image--maximizeFrame",
    image: "ms-Image-image",
    imageCenter: "ms-Image-image--center",
    imageContain: "ms-Image-image--contain",
    imageCover: "ms-Image-image--cover",
    imageCenterContain: "ms-Image-image--centerContain",
    imageCenterCover: "ms-Image-image--centerCover",
    imageNone: "ms-Image-image--none",
    imageLandscape: "ms-Image-image--landscape",
    imagePortrait: "ms-Image-image--portrait"
};
var $c192249f2ea24da6$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, width = props.width, height = props.height, maximizeFrame = props.maximizeFrame, isLoaded = props.isLoaded, shouldFadeIn = props.shouldFadeIn, shouldStartVisible = props.shouldStartVisible, isLandscape = props.isLandscape, isCenter = props.isCenter, isContain = props.isContain, isCover = props.isCover, isCenterContain = props.isCenterContain, isCenterCover = props.isCenterCover, isNone = props.isNone, isError = props.isError, isNotImageFit = props.isNotImageFit, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($c192249f2ea24da6$var$GlobalClassNames, theme);
    var ImageFitStyles = {
        position: "absolute",
        left: "50% /* @noflip */",
        top: "50%",
        transform: "translate(-50%,-50%)"
    };
    // Cut the mustard using msMaxTouchPoints to detect IE11 which does not support CSS object-fit
    var window = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    var supportsObjectFit = window !== undefined && // eslint-disable-next-line @fluentui/max-len
    // cast needed as vendor prefixed `msMaxTouchPoints` api is no longer part of TS lib declaration - introduced with TS 4.4
    window.navigator.msMaxTouchPoints === undefined;
    var fallbackObjectFitStyles = isContain && isLandscape || isCover && !isLandscape ? {
        width: "100%",
        height: "auto"
    } : {
        width: "auto",
        height: "100%"
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                overflow: "hidden"
            },
            maximizeFrame && [
                classNames.rootMaximizeFrame,
                {
                    height: "100%",
                    width: "100%"
                }
            ],
            isLoaded && shouldFadeIn && !shouldStartVisible && (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn400,
            (isCenter || isContain || isCover || isCenterContain || isCenterCover) && {
                position: "relative"
            },
            className
        ],
        image: [
            classNames.image,
            {
                display: "block",
                opacity: 0
            },
            isLoaded && [
                "is-loaded",
                {
                    opacity: 1
                }
            ],
            isCenter && [
                classNames.imageCenter,
                ImageFitStyles
            ],
            isContain && [
                classNames.imageContain,
                supportsObjectFit && {
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles
            ],
            isCover && [
                classNames.imageCover,
                supportsObjectFit && {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles
            ],
            isCenterContain && [
                classNames.imageCenterContain,
                isLandscape && {
                    maxWidth: "100%"
                },
                !isLandscape && {
                    maxHeight: "100%"
                },
                ImageFitStyles
            ],
            isCenterCover && [
                classNames.imageCenterCover,
                isLandscape && {
                    maxHeight: "100%"
                },
                !isLandscape && {
                    maxWidth: "100%"
                },
                ImageFitStyles
            ],
            isNone && [
                classNames.imageNone,
                {
                    width: "auto",
                    height: "auto"
                }
            ],
            isNotImageFit && [
                !!width && !height && {
                    height: "auto",
                    width: "100%"
                },
                !width && !!height && {
                    height: "100%",
                    width: "auto"
                },
                !!width && !!height && {
                    height: "100%",
                    width: "100%"
                }
            ],
            isLandscape && classNames.imageLandscape,
            !isLandscape && classNames.imagePortrait,
            !isLoaded && "is-notLoaded",
            shouldFadeIn && "is-fadeIn",
            isError && "is-error"
        ]
    };
};


var $6023154631a54d52$export$3e431a229df88919 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $649c58d3f72a3825$export$a3758d3f9ac64232), (0, $c192249f2ea24da6$export$ffd58b7f6f099a57), undefined, {
    scope: "Image"
}, true);
$6023154631a54d52$export$3e431a229df88919.displayName = "Image";






var $acw62 = parcelRequire("acw62");

var $91cc3acbdc44edfa$export$ce4ab0c55987d1ff = (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
    root: {
        display: "inline-block"
    },
    placeholder: [
        "ms-Icon-placeHolder",
        {
            width: "1em"
        }
    ],
    image: [
        "ms-Icon-imageContainer",
        {
            overflow: "hidden"
        }
    ]
});
var $91cc3acbdc44edfa$export$5895f18d7dadc168 = "ms-Icon";
var $91cc3acbdc44edfa$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, iconClassName = props.iconClassName, isPlaceholder = props.isPlaceholder, isImage = props.isImage, styles = props.styles;
    return {
        root: [
            isPlaceholder && $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.placeholder,
            $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.root,
            isImage && $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.image,
            iconClassName,
            className,
            styles && styles.root,
            // eslint-disable-next-line deprecation/deprecation
            styles && styles.imageContainer
        ]
    };
};




var $eec83b0087c5fe87$export$5222c8060583ee57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(iconName) {
    var _a = (0, $157fc0f40a8f1c26$export$16b26cd5e98d9100)(iconName) || {
        subset: {},
        code: undefined
    }, code = _a.code, subset = _a.subset;
    if (!code) return null;
    return {
        children: code,
        iconClassName: subset.className,
        fontFamily: subset.fontFace && subset.fontFace.fontFamily,
        mergeImageProps: subset.mergeImageProps
    };
}, undefined, true);
var $eec83b0087c5fe87$export$f56ea46797033f60 = function(props) {
    var iconName = props.iconName, className = props.className, _a = props.style, style = _a === void 0 ? {} : _a;
    var iconContent = $eec83b0087c5fe87$export$5222c8060583ee57(iconName) || {};
    var iconClassName = iconContent.iconClassName, children = iconContent.children, fontFamily = iconContent.fontFamily, mergeImageProps = iconContent.mergeImageProps;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    var accessibleName = props["aria-label"] || props.title;
    var containerProps = props["aria-label"] || props["aria-labelledby"] || props.title ? {
        role: mergeImageProps ? undefined : "img"
    } : {
        "aria-hidden": true
    };
    var finalChildren = children;
    if (mergeImageProps) {
        if (typeof children === "object" && typeof children.props === "object" && accessibleName) finalChildren = $acw62.cloneElement(children, {
            alt: accessibleName
        });
    }
    return $acw62.createElement("i", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        "data-icon-name": iconName
    }, containerProps, nativeProps, mergeImageProps ? {
        title: undefined,
        "aria-label": undefined
    } : {}, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $91cc3acbdc44edfa$export$5895f18d7dadc168), (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).root, iconClassName, !iconName && (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).placeholder, className),
        // Apply the font family this way to ensure it doesn't get overridden by Fabric Core ms-Icon styles
        // https://github.com/microsoft/fluentui/issues/10449
        style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            fontFamily: fontFamily
        }, style)
    }), finalChildren);
};
var $eec83b0087c5fe87$export$2160c7b76a453797 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(iconName, className, ariaLabel) {
    return $eec83b0087c5fe87$export$f56ea46797033f60({
        iconName: iconName,
        className: className,
        "aria-label": ariaLabel
    });
});


var $c165ae9cd6954cb9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    // Icon is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Icon.
    // Therefore setting a larger cache size.
    cacheSize: 100
});
var $c165ae9cd6954cb9$export$a188ecdd443fe91a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IconBase, _super);
    function IconBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onImageLoadingStateChange = function(state) {
            if (_this.props.imageProps && _this.props.imageProps.onLoadingStateChange) _this.props.imageProps.onLoadingStateChange(state);
            if (state === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error) _this.setState({
                imageLoadError: true
            });
        };
        _this.state = {
            imageLoadError: false
        };
        return _this;
    }
    IconBase.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, styles = _a.styles, iconName = _a.iconName, imageErrorAs = _a.imageErrorAs, theme = _a.theme;
        var isPlaceholder = typeof iconName === "string" && iconName.length === 0;
        var isImage = // eslint-disable-next-line deprecation/deprecation
        !!this.props.imageProps || this.props.iconType === (0, $b2334e548db36fc7$export$13ff1290a9e22e77).image || this.props.iconType === (0, $b2334e548db36fc7$export$13ff1290a9e22e77).Image;
        var iconContent = (0, $eec83b0087c5fe87$export$5222c8060583ee57)(iconName) || {};
        var iconClassName = iconContent.iconClassName, iconContentChildren = iconContent.children, mergeImageProps = iconContent.mergeImageProps;
        var classNames = $c165ae9cd6954cb9$var$getClassNames(styles, {
            theme: theme,
            className: className,
            iconClassName: iconClassName,
            isImage: isImage,
            isPlaceholder: isPlaceholder
        });
        var RootType = isImage ? "span" : "i";
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40), [
            "aria-label"
        ]);
        var imageLoadError = this.state.imageLoadError;
        var imageProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props.imageProps), {
            onLoadingStateChange: this._onImageLoadingStateChange
        });
        var ImageType = imageLoadError && imageErrorAs || (0, $6023154631a54d52$export$3e431a229df88919);
        // eslint-disable-next-line deprecation/deprecation
        var ariaLabel = this.props["aria-label"] || this.props.ariaLabel;
        var accessibleName = imageProps.alt || ariaLabel || this.props.title;
        var hasName = !!(accessibleName || this.props["aria-labelledby"] || imageProps["aria-label"] || imageProps["aria-labelledby"]);
        var containerProps = hasName ? {
            role: isImage || mergeImageProps ? undefined : "img",
            "aria-label": isImage || mergeImageProps ? undefined : accessibleName
        } : {
            "aria-hidden": true
        };
        var finalIconContentChildren = iconContentChildren;
        if (mergeImageProps && iconContentChildren && typeof iconContentChildren === "object" && accessibleName) finalIconContentChildren = $acw62.cloneElement(iconContentChildren, {
            alt: accessibleName
        });
        return $acw62.createElement(RootType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-icon-name": iconName
        }, containerProps, nativeProps, mergeImageProps ? {
            title: undefined,
            "aria-label": undefined
        } : {}, {
            className: classNames.root
        }), isImage ? $acw62.createElement(ImageType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageProps)) : children || finalIconContentChildren);
    };
    return IconBase;
}($acw62.Component);



var $4b3e235077c5b552$export$f04a61298a47a40f = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $c165ae9cd6954cb9$export$a188ecdd443fe91a), (0, $91cc3acbdc44edfa$export$ffd58b7f6f099a57), undefined, {
    scope: "Icon"
}, true);
$4b3e235077c5b552$export$f04a61298a47a40f.displayName = "Icon";


var $e2589b5bbccba108$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $e2589b5bbccba108$export$f56e96de55837300 = $acw62.forwardRef(function(props, forwardedRef) {
    var disabled = props.disabled, required = props.required, inputProps = props.inputProps, name = props.name, ariaLabel = props.ariaLabel, ariaLabelledBy = props.ariaLabelledBy, ariaDescribedBy = props.ariaDescribedBy, ariaPositionInSet = props.ariaPositionInSet, ariaSetSize = props.ariaSetSize, title = props.title, checkmarkIconProps = props.checkmarkIconProps, styles = props.styles, theme = props.theme, className = props.className, _a = props.boxSide, boxSide = _a === void 0 ? "start" : _a;
    var id = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)("checkbox-", props.id);
    var rootRef = $acw62.useRef(null);
    var mergedRootRefs = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, forwardedRef);
    var inputRef = $acw62.useRef(null);
    var _b = (0, $55cf7aa9f769b3e9$export$2400c890ca0180b4)(props.checked, props.defaultChecked, props.onChange), isChecked = _b[0], setIsChecked = _b[1];
    var _c = (0, $55cf7aa9f769b3e9$export$2400c890ca0180b4)(props.indeterminate, props.defaultIndeterminate), isIndeterminate = _c[0], setIsIndeterminate = _c[1];
    (0, $872a30e3c6519016$export$471b875afaf1c0a9)(rootRef);
    $e2589b5bbccba108$var$useDebugWarning(props);
    var classNames = $e2589b5bbccba108$var$getClassNames(styles, {
        theme: theme,
        className: className,
        disabled: disabled,
        indeterminate: isIndeterminate,
        checked: isChecked,
        reversed: boxSide !== "start",
        isUsingCustomLabelRender: !!props.onRenderLabel
    });
    var onChange = $acw62.useCallback(function(event) {
        if (isIndeterminate) {
            // If indeterminate, clicking the checkbox *only* removes the indeterminate state (or if
            // controlled, lets the consumer know to change it by calling onChange). It doesn't
            // change the checked state.
            setIsChecked(!!isChecked, event);
            setIsIndeterminate(false);
        } else setIsChecked(!isChecked, event);
    }, [
        setIsChecked,
        setIsIndeterminate,
        isIndeterminate,
        isChecked
    ]);
    var defaultLabelRenderer = $acw62.useCallback(function(checkboxProps) {
        if (!checkboxProps) return null;
        return checkboxProps.label ? $acw62.createElement("span", {
            className: classNames.text,
            title: checkboxProps.title
        }, checkboxProps.label) : null;
    }, [
        classNames.text
    ]);
    var setNativeIndeterminate = $acw62.useCallback(function(indeterminate1) {
        if (!inputRef.current) return;
        var value = !!indeterminate1;
        inputRef.current.indeterminate = value;
        setIsIndeterminate(value);
    }, [
        setIsIndeterminate
    ]);
    $e2589b5bbccba108$var$useComponentRef(props, isChecked, isIndeterminate, setNativeIndeterminate, inputRef);
    $acw62.useEffect(function() {
        return setNativeIndeterminate(isIndeterminate);
    }, [
        setNativeIndeterminate,
        isIndeterminate
    ]);
    var onRenderLabel = props.onRenderLabel || defaultLabelRenderer;
    var ariaChecked = isIndeterminate ? "mixed" : undefined;
    var mergedInputProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        className: classNames.input,
        type: "checkbox"
    }, inputProps), {
        checked: !!isChecked,
        disabled: disabled,
        required: required,
        name: name,
        id: id,
        title: title,
        onChange: onChange,
        "aria-disabled": disabled,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-posinset": ariaPositionInSet,
        "aria-setsize": ariaSetSize,
        "aria-checked": ariaChecked
    });
    return $acw62.createElement("div", {
        className: classNames.root,
        title: title,
        ref: mergedRootRefs
    }, $acw62.createElement("input", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, mergedInputProps, {
        ref: inputRef,
        title: title,
        "data-ktp-execute-target": true
    })), $acw62.createElement("label", {
        className: classNames.label,
        htmlFor: id
    }, $acw62.createElement("div", {
        className: classNames.checkbox,
        "data-ktp-target": true
    }, $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        iconName: "CheckMark"
    }, checkmarkIconProps, {
        className: classNames.checkmark
    }))), onRenderLabel(props, defaultLabelRenderer)));
});
$e2589b5bbccba108$export$f56e96de55837300.displayName = "CheckboxBase";
function $e2589b5bbccba108$var$useDebugWarning(props) {}
function $e2589b5bbccba108$var$useComponentRef(props, isChecked, isIndeterminate, setIndeterminate, checkBoxRef) {
    $acw62.useImperativeHandle(props.componentRef, function() {
        return {
            get checked () {
                return !!isChecked;
            },
            get indeterminate () {
                return !!isIndeterminate;
            },
            set indeterminate (indeterminate){
                setIndeterminate(indeterminate);
            },
            focus: function() {
                if (checkBoxRef.current) checkBoxRef.current.focus();
            }
        };
    }, [
        checkBoxRef,
        isChecked,
        isIndeterminate,
        setIndeterminate
    ]);
}





var $9adc8800b0b9b54e$var$GlobalClassNames = {
    root: "ms-Checkbox",
    label: "ms-Checkbox-label",
    checkbox: "ms-Checkbox-checkbox",
    checkmark: "ms-Checkbox-checkmark",
    text: "ms-Checkbox-text"
};
var $9adc8800b0b9b54e$var$MS_CHECKBOX_LABEL_SIZE = "20px";
var $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_DURATION = "200ms";
var $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_TIMING = "cubic-bezier(.4, 0, .23, 1)";
var $9adc8800b0b9b54e$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var className = props.className, theme = props.theme, reversed = props.reversed, checked = props.checked, disabled = props.disabled, isUsingCustomLabelRender = props.isUsingCustomLabelRender, indeterminate = props.indeterminate;
    var semanticColors = theme.semanticColors, effects = theme.effects, palette = theme.palette, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($9adc8800b0b9b54e$var$GlobalClassNames, theme);
    var checkmarkFontColor = semanticColors.inputForegroundChecked;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.inputBorder
    var checkmarkFontColorHovered = palette.neutralSecondary;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.smallInputBorder
    var checkboxBorderColor = palette.neutralPrimary;
    var checkboxBorderIndeterminateColor = semanticColors.inputBackgroundChecked;
    var checkboxBorderColorChecked = semanticColors.inputBackgroundChecked;
    var checkboxBorderColorDisabled = semanticColors.disabledBodySubtext;
    var checkboxBorderHoveredColor = semanticColors.inputBorderHovered;
    var checkboxBorderIndeterminateHoveredColor = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBackgroundChecked = semanticColors.inputBackgroundChecked;
    // TODO: after updating the semanticColors slots mapping the following 2 tokens need to be
    // semanticColors.inputBackgroundCheckedHovered
    var checkboxBackgroundCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBorderColorCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxHoveredTextColor = semanticColors.inputTextHovered;
    var checkboxBackgroundDisabledChecked = semanticColors.disabledBodySubtext;
    var checkboxTextColor = semanticColors.bodyText;
    var checkboxTextColorDisabled = semanticColors.disabledText;
    var indeterminateDotStyles = [
        (_a = {
            content: '""',
            borderRadius: effects.roundedCorner2,
            position: "absolute",
            width: 10,
            height: 10,
            top: 4,
            left: 4,
            boxSizing: "border-box",
            borderWidth: 5,
            borderStyle: "solid",
            borderColor: disabled ? checkboxBorderColorDisabled : checkboxBorderIndeterminateColor,
            transitionProperty: "border-width, border, border-color",
            transitionDuration: $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_DURATION,
            transitionTimingFunction: $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_TIMING
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            borderColor: "WindowText"
        }, _a)
    ];
    return {
        root: [
            classNames.root,
            {
                position: "relative",
                display: "flex"
            },
            reversed && "reversed",
            checked && "is-checked",
            !disabled && "is-enabled",
            disabled && "is-disabled",
            !disabled && [
                !checked && (_b = {}, _b[":hover .".concat(classNames.checkbox)] = (_c = {
                    borderColor: checkboxBorderHoveredColor
                }, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderColor: "Highlight"
                }, _c), _b[":focus .".concat(classNames.checkbox)] = {
                    borderColor: checkboxBorderHoveredColor
                }, _b[":hover .".concat(classNames.checkmark)] = (_d = {
                    color: checkmarkFontColorHovered,
                    opacity: "1"
                }, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "Highlight"
                }, _d), _b),
                checked && !indeterminate && (_e = {}, _e[":hover .".concat(classNames.checkbox)] = {
                    background: checkboxBackgroundCheckedHovered,
                    borderColor: checkboxBorderColorCheckedHovered
                }, _e[":focus .".concat(classNames.checkbox)] = {
                    background: checkboxBackgroundCheckedHovered,
                    borderColor: checkboxBorderColorCheckedHovered
                }, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (_f = {}, _f[":hover .".concat(classNames.checkbox)] = {
                    background: "Highlight",
                    borderColor: "Highlight"
                }, _f[":focus .".concat(classNames.checkbox)] = {
                    background: "Highlight"
                }, _f[":focus:hover .".concat(classNames.checkbox)] = {
                    background: "Highlight"
                }, _f[":focus:hover .".concat(classNames.checkmark)] = {
                    color: "Window"
                }, _f[":hover .".concat(classNames.checkmark)] = {
                    color: "Window"
                }, _f), _e),
                indeterminate && (_g = {}, _g[":hover .".concat(classNames.checkbox, ", :hover .").concat(classNames.checkbox, ":after")] = (_h = {
                    borderColor: checkboxBorderIndeterminateHoveredColor
                }, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderColor: "WindowText"
                }, _h), _g[":focus .".concat(classNames.checkbox)] = {
                    borderColor: checkboxBorderIndeterminateHoveredColor
                }, _g[":hover .".concat(classNames.checkmark)] = {
                    opacity: "0"
                }, _g),
                (_j = {}, _j[":hover .".concat(classNames.text, ", :focus .").concat(classNames.text)] = (_k = {
                    color: checkboxHoveredTextColor
                }, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: disabled ? "GrayText" : "WindowText"
                }, _k), _j)
            ],
            className
        ],
        input: (_l = {
            position: "absolute",
            background: "none",
            opacity: 0
        }, _l[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus + label::before")] = (_m = {
            outline: "1px solid " + theme.palette.neutralSecondary,
            outlineOffset: "2px"
        }, _m[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            outline: "1px solid WindowText"
        }, _m), _l),
        label: [
            classNames.label,
            theme.fonts.medium,
            {
                display: "flex",
                alignItems: isUsingCustomLabelRender ? "center" : "flex-start",
                cursor: disabled ? "default" : "pointer",
                position: "relative",
                userSelect: "none"
            },
            reversed && {
                flexDirection: "row-reverse",
                justifyContent: "flex-end"
            },
            {
                "&::before": {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    content: '""',
                    pointerEvents: "none"
                }
            }
        ],
        checkbox: [
            classNames.checkbox,
            (_o = {
                position: "relative",
                display: "flex",
                flexShrink: 0,
                alignItems: "center",
                justifyContent: "center",
                height: $9adc8800b0b9b54e$var$MS_CHECKBOX_LABEL_SIZE,
                width: $9adc8800b0b9b54e$var$MS_CHECKBOX_LABEL_SIZE,
                border: "1px solid ".concat(checkboxBorderColor),
                borderRadius: effects.roundedCorner2,
                boxSizing: "border-box",
                transitionProperty: "background, border, border-color",
                transitionDuration: $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_DURATION,
                transitionTimingFunction: $9adc8800b0b9b54e$var$MS_CHECKBOX_TRANSITION_TIMING,
                /* in case the icon is bigger than the box */ overflow: "hidden",
                ":after": indeterminate ? indeterminateDotStyles : null
            }, _o[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                borderColor: "WindowText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _o),
            indeterminate && {
                borderColor: checkboxBorderIndeterminateColor
            },
            !reversed ? // is used, there will be only a 4px margin from checkbox to label. The label by default would have
            // another 4px margin for a total of 8px margin between checkbox and label. We don't combine the two
            // (and move it into the text) to not incur a breaking change for everyone using custom render atm.
            {
                marginRight: 4
            } : {
                marginLeft: 4
            },
            !disabled && !indeterminate && checked && (_p = {
                background: checkboxBackgroundChecked,
                borderColor: checkboxBorderColorChecked
            }, _p[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                background: "Highlight",
                borderColor: "Highlight"
            }, _p),
            disabled && (_q = {
                borderColor: checkboxBorderColorDisabled
            }, _q[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                borderColor: "GrayText"
            }, _q),
            checked && disabled && (_r = {
                background: checkboxBackgroundDisabledChecked,
                borderColor: checkboxBorderColorDisabled
            }, _r[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                background: "Window"
            }, _r)
        ],
        checkmark: [
            classNames.checkmark,
            (_s = {
                opacity: checked && !indeterminate ? "1" : "0",
                color: checkmarkFontColor
            }, _s[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: disabled ? "GrayText" : "Window"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _s)
        ],
        text: [
            classNames.text,
            (_t = {
                color: disabled ? checkboxTextColorDisabled : checkboxTextColor,
                fontSize: fonts.medium.fontSize,
                lineHeight: "20px"
            }, _t[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: disabled ? "GrayText" : "WindowText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _t),
            !reversed ? {
                marginLeft: 4
            } : {
                marginRight: 4
            }
        ]
    };
};


var $53962458d2f2f182$export$48513f6b9f8ce62d = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $e2589b5bbccba108$export$f56e96de55837300), (0, $9adc8800b0b9b54e$export$ffd58b7f6f099a57), undefined, {
    scope: "Checkbox"
});



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Compares a to b and b to a.
 *
 * @public
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f504d2279336999d$export$90e866afbd6b9f1a(a, b) {
    if (!a || !b) // only return true if both a and b are falsy
    return !a && !b;
    for(var propName in a)if (a.hasOwnProperty(propName)) {
        if (!b.hasOwnProperty(propName) || b[propName] !== a[propName]) return false;
    }
    for(var propName in b)if (b.hasOwnProperty(propName)) {
        if (!a.hasOwnProperty(propName)) return false;
    }
    return true;
}
function $f504d2279336999d$export$e6e34fd1f2686227(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $f504d2279336999d$export$e0c55363f2296695.apply(this, [
        null,
        target
    ].concat(args));
}
function $f504d2279336999d$export$e0c55363f2296695(isAllowed, target) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    target = target || {};
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var sourceObject = args_1[_a];
        if (sourceObject) {
            for(var propName in sourceObject)if (sourceObject.hasOwnProperty(propName) && (!isAllowed || isAllowed(propName))) target[propName] = sourceObject[propName];
        }
    }
    return target;
}
function $f504d2279336999d$export$8951e1a012e6d096(// eslint-disable-next-line @typescript-eslint/no-explicit-any
theEnum, callback) {
    // map<any> to satisfy compiler since it doesn't realize we strip out undefineds in the .filter() call
    return Object.keys(theEnum).map(function(p) {
        // map on each property name as a string
        if (String(Number(p)) !== p) // if the property is not just a number (because enums in TypeScript will map both ways)
        return callback(p, theEnum[p]);
        return undefined;
    }).filter(function(v) {
        return !!v;
    }); // only return elements with values
}
function $f504d2279336999d$export$68c286be0e7e55b7(obj) {
    return Object.keys(obj).reduce(function(arr, key) {
        arr.push(obj[key]);
        return arr;
    }, []);
}
function $f504d2279336999d$export$30a06c8d3562193f(obj, exclusions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    for(var key in obj)if (exclusions.indexOf(key) === -1 && obj.hasOwnProperty(key)) result[key] = obj[key];
    return result;
}


/**
 * Bugs often appear in async code when stuff gets disposed, but async operations don't get canceled.
 * This Async helper class solves these issues by tying async code to the lifetime of a disposable object.
 *
 * Usage: Anything class extending from BaseModel can access this helper via this.async. Otherwise create a
 * new instance of the class and remember to call dispose() during your code's dispose handler.
 *
 * @public
 */ var $64b4350fe064431c$export$4d3c597da532240f = /** @class */ function() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Async(parent, onError) {
        this._timeoutIds = null;
        this._immediateIds = null;
        this._intervalIds = null;
        this._animationFrameIds = null;
        this._isDisposed = false;
        this._parent = parent || null;
        this._onErrorHandler = onError;
        this._noop = function() {
        /* do nothing */ };
    }
    /**
     * Dispose function, clears all async operations.
     */ Async.prototype.dispose = function() {
        var id;
        this._isDisposed = true;
        this._parent = null;
        // Clear timeouts.
        if (this._timeoutIds) {
            for(id in this._timeoutIds)if (this._timeoutIds.hasOwnProperty(id)) this.clearTimeout(parseInt(id, 10));
            this._timeoutIds = null;
        }
        // Clear immediates.
        if (this._immediateIds) {
            for(id in this._immediateIds)if (this._immediateIds.hasOwnProperty(id)) this.clearImmediate(parseInt(id, 10));
            this._immediateIds = null;
        }
        // Clear intervals.
        if (this._intervalIds) {
            for(id in this._intervalIds)if (this._intervalIds.hasOwnProperty(id)) this.clearInterval(parseInt(id, 10));
            this._intervalIds = null;
        }
        // Clear animation frames.
        if (this._animationFrameIds) {
            for(id in this._animationFrameIds)if (this._animationFrameIds.hasOwnProperty(id)) this.cancelAnimationFrame(parseInt(id, 10));
            this._animationFrameIds = null;
        }
    };
    /**
     * SetTimeout override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */ Async.prototype.setTimeout = function(callback, duration) {
        var _this = this;
        var timeoutId = 0;
        if (!this._isDisposed) {
            if (!this._timeoutIds) this._timeoutIds = {};
            timeoutId = setTimeout(function() {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._timeoutIds) delete _this._timeoutIds[timeoutId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._timeoutIds[timeoutId] = true;
        }
        return timeoutId;
    };
    /**
     * Clears the timeout.
     * @param id - Id to cancel.
     */ Async.prototype.clearTimeout = function(id) {
        if (this._timeoutIds && this._timeoutIds[id]) {
            clearTimeout(id);
            delete this._timeoutIds[id];
        }
    };
    /**
     * SetImmediate override, which will auto cancel the immediate during dispose.
     * @param callback - Callback to execute.
     * @param targetElement - Optional target element to use for identifying the correct window.
     * @returns The setTimeout id.
     */ Async.prototype.setImmediate = function(callback, targetElement) {
        var _this = this;
        var immediateId = 0;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (!this._isDisposed) {
            if (!this._immediateIds) this._immediateIds = {};
            var setImmediateCallback = function() {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._immediateIds) delete _this._immediateIds[immediateId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            };
            immediateId = win.setTimeout(setImmediateCallback, 0);
            this._immediateIds[immediateId] = true;
        }
        return immediateId;
    };
    /**
     * Clears the immediate.
     * @param id - Id to cancel.
     * @param targetElement - Optional target element to use for identifying the correct window.
     */ Async.prototype.clearImmediate = function(id, targetElement) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (this._immediateIds && this._immediateIds[id]) {
            win.clearTimeout(id);
            delete this._immediateIds[id];
        }
    };
    /**
     * SetInterval override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */ Async.prototype.setInterval = function(callback, duration) {
        var _this = this;
        var intervalId = 0;
        if (!this._isDisposed) {
            if (!this._intervalIds) this._intervalIds = {};
            intervalId = setInterval(function() {
                // Time to execute the interval callback, enqueue it as a foreground task to be executed.
                try {
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._intervalIds[intervalId] = true;
        }
        return intervalId;
    };
    /**
     * Clears the interval.
     * @param id - Id to cancel.
     */ Async.prototype.clearInterval = function(id) {
        if (this._intervalIds && this._intervalIds[id]) {
            clearInterval(id);
            delete this._intervalIds[id];
        }
    };
    /**
     * Creates a function that, when executed, will only call the func function at most once per
     * every wait milliseconds. Provide an options object to indicate that func should be invoked
     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
     * function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the throttled function is invoked more than once during the wait timeout.
     *
     * @param func - The function to throttle.
     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
     * @param options - The options object.
     * @returns The new throttled function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.throttle = function(func, wait, options) {
        var _this = this;
        if (this._isDisposed) return this._noop;
        var waitMS = wait || 0;
        var leading = true;
        var trailing = true;
        var lastExecuteTime = 0;
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === "boolean") leading = options.leading;
        if (options && typeof options.trailing === "boolean") trailing = options.trailing;
        var callback = function(userCall) {
            var now = Date.now();
            var delta = now - lastExecuteTime;
            var waitLength = leading ? waitMS - delta : waitMS;
            if (delta >= waitMS && (!userCall || leading)) {
                lastExecuteTime = now;
                if (timeoutId) {
                    _this.clearTimeout(timeoutId);
                    timeoutId = null;
                }
                lastResult = func.apply(_this._parent, lastArgs);
            } else if (timeoutId === null && trailing) timeoutId = _this.setTimeout(callback, waitLength);
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            lastArgs = args;
            return callback(true);
        };
        return resultFunction;
    };
    /**
     * Creates a function that will delay the execution of func until after wait milliseconds have
     * elapsed since the last time it was invoked. Provide an options object to indicate that func
     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
     * to the debounced function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the debounced function is invoked more than once during the wait
     * timeout.
     *
     * @param func - The function to debounce.
     * @param wait - The number of milliseconds to delay.
     * @param options - The options object.
     * @returns The new debounced function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.debounce = function(func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            var noOpFunction = function() {
            /** Do nothing */ };
            noOpFunction.cancel = function() {
                return;
            };
            noOpFunction.flush = function() {
                return null;
            };
            noOpFunction.pending = function() {
                return false;
            };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = false;
        var trailing = true;
        var maxWait = null;
        var lastCallTime = 0;
        var lastExecuteTime = Date.now();
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === "boolean") leading = options.leading;
        if (options && typeof options.trailing === "boolean") trailing = options.trailing;
        if (options && typeof options.maxWait === "number" && !isNaN(options.maxWait)) maxWait = options.maxWait;
        var markExecuted = function(time) {
            if (timeoutId) {
                _this.clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastExecuteTime = time;
        };
        var invokeFunction = function(time) {
            markExecuted(time);
            lastResult = func.apply(_this._parent, lastArgs);
        };
        var callback = function(userCall) {
            var now = Date.now();
            var executeImmediately = false;
            if (userCall) {
                if (leading && now - lastCallTime >= waitMS) executeImmediately = true;
                lastCallTime = now;
            }
            var delta = now - lastCallTime;
            var waitLength = waitMS - delta;
            var maxWaitDelta = now - lastExecuteTime;
            var maxWaitExpired = false;
            if (maxWait !== null) {
                // maxWait only matters when there is a pending callback
                if (maxWaitDelta >= maxWait && timeoutId) maxWaitExpired = true;
                else waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
            }
            if (delta >= waitMS || maxWaitExpired || executeImmediately) invokeFunction(now);
            else if ((timeoutId === null || !userCall) && trailing) timeoutId = _this.setTimeout(callback, waitLength);
            return lastResult;
        };
        var pending = function() {
            return !!timeoutId;
        };
        var cancel = function() {
            if (pending()) // Mark the debounced function as having executed
            markExecuted(Date.now());
        };
        var flush = function() {
            if (pending()) invokeFunction(Date.now());
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            lastArgs = args;
            return callback(true);
        };
        resultFunction.cancel = cancel;
        resultFunction.flush = flush;
        resultFunction.pending = pending;
        return resultFunction;
    };
    Async.prototype.requestAnimationFrame = function(callback, targetElement) {
        var _this = this;
        var animationFrameId = 0;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (!this._isDisposed) {
            if (!this._animationFrameIds) this._animationFrameIds = {};
            var animationFrameCallback = function() {
                try {
                    // Now delete the record and call the callback.
                    if (_this._animationFrameIds) delete _this._animationFrameIds[animationFrameId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            };
            animationFrameId = win.requestAnimationFrame ? win.requestAnimationFrame(animationFrameCallback) : win.setTimeout(animationFrameCallback, 0);
            this._animationFrameIds[animationFrameId] = true;
        }
        return animationFrameId;
    };
    Async.prototype.cancelAnimationFrame = function(id, targetElement) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (this._animationFrameIds && this._animationFrameIds[id]) {
            win.cancelAnimationFrame ? win.cancelAnimationFrame(id) : win.clearTimeout(id);
            delete this._animationFrameIds[id];
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype._logError = function(e) {
        if (this._onErrorHandler) this._onErrorHandler(e);
    };
    return Async;
}();



var $acw62 = parcelRequire("acw62");

function $7d0a77756f8e01ee$var$createComposedComponent(outer) {
    var Outer = outer;
    var outerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(inner) {
        if (outer === inner) throw new Error("Attempted to compose a component with itself.");
        var Inner = inner;
        var innerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(defaultRender) {
            var InnerWithDefaultRender = function(innerProps) {
                return $acw62.createElement(Inner, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, innerProps, {
                    defaultRender: defaultRender
                }));
            };
            return InnerWithDefaultRender;
        });
        var OuterWithDefaultRender = function(outerProps) {
            var defaultRender = outerProps.defaultRender;
            return $acw62.createElement(Outer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, outerProps, {
                defaultRender: defaultRender ? innerMemoizer(defaultRender) : Inner
            }));
        };
        return OuterWithDefaultRender;
    });
    return outerMemoizer;
}
var $7d0a77756f8e01ee$var$componentAsMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)($7d0a77756f8e01ee$var$createComposedComponent);
function $7d0a77756f8e01ee$export$a196dddec0747ba0(outer, inner) {
    return $7d0a77756f8e01ee$var$componentAsMemoizer(outer)(inner);
}

/**
 * Helper to find the index of an item within an array, using a callback to
 * determine the match.
 *
 * @public
 * @param array - Array to search.
 * @param cb - Callback which returns true on matches.
 * @param fromIndex - Optional index to start from (defaults to 0)
 */ function $b9105dc723fd02ea$export$de3a4d4a0d731119(array, cb, fromIndex) {
    if (fromIndex === void 0) fromIndex = 0;
    var index = -1;
    for(var i = fromIndex; array && i < array.length; i++)if (cb(array[i], i)) {
        index = i;
        break;
    }
    return index;
}
function $b9105dc723fd02ea$export$71aa6c912b956294(array, cb) {
    var index = $b9105dc723fd02ea$export$de3a4d4a0d731119(array, cb);
    if (index < 0) return undefined;
    return array[index];
}
function $b9105dc723fd02ea$export$7f1ebd623f131021(size, getItem) {
    var array = [];
    for(var i = 0; i < size; i++)array.push(getItem(i));
    return array;
}
function $b9105dc723fd02ea$export$88114232bee231be(items, columnCount) {
    return items.reduce(function(rows, currentValue, index) {
        if (index % columnCount === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
function $b9105dc723fd02ea$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, i) {
        return index !== i;
    });
}
function $b9105dc723fd02ea$export$2dfe578f95754f6a(array, newElement, index) {
    var copy = array.slice();
    copy[index] = newElement;
    return copy;
}
function $b9105dc723fd02ea$export$df2fbf469f510c97(array, index, itemToAdd) {
    var copy = array.slice();
    copy.splice(index, 0, itemToAdd);
    return copy;
}
function $b9105dc723fd02ea$export$bffa455ba8c619a6(array) {
    var result = [];
    array.forEach(function(item) {
        return result = result.concat(item);
    });
    return result;
}
function $b9105dc723fd02ea$export$234180f8206db11b(array1, array2) {
    if (array1.length !== array2.length) return false;
    for(var i = 0; i < array1.length; i++){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}


/**
 * Set up a ref resolver function given internal state managed for the ref.
 * @param local Set
 */ var $ad53d15595d1f5d5$var$createResolver = function(local) {
    return function(newValue) {
        for(var _i = 0, _a = local.refs; _i < _a.length; _i++){
            var ref = _a[_i];
            if (typeof ref === "function") ref(newValue);
            else if (ref) // work around the immutability of the React.Ref type
            ref.current = newValue;
        }
    };
};
var $ad53d15595d1f5d5$export$9f37a988498f0f9c = function(value) {
    var local = {
        refs: []
    };
    return function() {
        var newRefs = [];
        for(var _i = 0; _i < arguments.length; _i++)newRefs[_i] = arguments[_i];
        if (!local.resolver || !(0, $b9105dc723fd02ea$export$234180f8206db11b)(local.refs, newRefs)) local.resolver = $ad53d15595d1f5d5$var$createResolver(local);
        local.refs = newRefs;
        return local.resolver;
    };
};


/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
 *  If the target is an HTMLElement, the event will be attached to the element and can be
 *  triggered as usual (like clicking for onClick).
 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
 *  handled here in EventGroup, and the handler is called in the context of the parent
 *  (which is passed in in the constructor).
 *
 * @public
 * {@docCategory EventGroup}
 */ var $7e392406ee2126b8$export$7af5106782f53286 = /** @class */ function() {
    /** parent: the context in which events attached to non-HTMLElements are called */ function EventGroup(parent) {
        this._id = EventGroup._uniqueId++;
        this._parent = parent;
        this._eventRecords = [];
    }
    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
     *  Events raised here by default have bubbling set to false and cancelable set to true.
     *  This applies also to built-in events being raised manually here on HTMLElements,
     *  which may lead to unexpected behavior if it differs from the defaults.
     *
     */ EventGroup.raise = function(target, eventName, eventArgs, bubbleEvent) {
        var retVal;
        if (EventGroup._isElement(target)) {
            if (typeof document !== "undefined" && document.createEvent) {
                var ev = document.createEvent("HTMLEvents");
                // eslint-disable-next-line deprecation/deprecation
                ev.initEvent(eventName, bubbleEvent || false, true);
                (0, $f504d2279336999d$export$e6e34fd1f2686227)(ev, eventArgs);
                retVal = target.dispatchEvent(ev);
            } else if (typeof document !== "undefined" && document.createEventObject) {
                // IE8
                var evObj = document.createEventObject(eventArgs);
                // cannot set cancelBubble on evObj, fireEvent will overwrite it
                target.fireEvent("on" + eventName, evObj);
            }
        } else // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
        while(target && retVal !== false){
            var events = target.__events__;
            var eventRecords = events ? events[eventName] : null;
            if (eventRecords) {
                for(var id in eventRecords)if (eventRecords.hasOwnProperty(id)) {
                    var eventRecordList = eventRecords[id];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                    for(var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++){
                        var record = eventRecordList[listIndex];
                        if (record.objectCallback) retVal = record.objectCallback.call(record.parent, eventArgs);
                    }
                }
            }
            // If the target has a parent, bubble the event up.
            target = bubbleEvent ? target.parent : null;
        }
        return retVal;
    };
    EventGroup.isObserved = function(target, eventName) {
        var events = target && target.__events__;
        return !!events && !!events[eventName];
    };
    /** Check to see if the target has declared support of the given event. */ EventGroup.isDeclared = function(target, eventName) {
        var declaredEvents = target && target.__declaredEvents;
        return !!declaredEvents && !!declaredEvents[eventName];
    };
    EventGroup.stopPropagation = function(event) {
        if (event.stopPropagation) event.stopPropagation();
        else // IE8
        event.cancelBubble = true;
    };
    EventGroup._isElement = function(target) {
        return !!target && (!!target.addEventListener || typeof HTMLElement !== "undefined" && target instanceof HTMLElement);
    };
    EventGroup.prototype.dispose = function() {
        if (!this._isDisposed) {
            this._isDisposed = true;
            this.off();
            this._parent = null;
        }
    };
    /** On the target, attach a set of events, where the events object is a name to function mapping. */ EventGroup.prototype.onAll = function(target, events, useCapture) {
        for(var eventName in events)if (events.hasOwnProperty(eventName)) this.on(target, eventName, events[eventName], useCapture);
    };
    /**
     * On the target, attach an event whose handler will be called in the context of the parent
     * of this instance of EventGroup.
     */ EventGroup.prototype.on = function(target, eventName, callback, options) {
        var _this = this;
        if (eventName.indexOf(",") > -1) {
            var events = eventName.split(/[ ,]+/);
            for(var i = 0; i < events.length; i++)this.on(target, events[i], callback, options);
        } else {
            var parent_1 = this._parent;
            var eventRecord = {
                target: target,
                eventName: eventName,
                parent: parent_1,
                callback: callback,
                options: options
            };
            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
            var events = target.__events__ = target.__events__ || {};
            events[eventName] = events[eventName] || {
                count: 0
            };
            events[eventName][this._id] = events[eventName][this._id] || [];
            events[eventName][this._id].push(eventRecord);
            events[eventName].count++;
            if (EventGroup._isElement(target)) {
                var processElementEvent = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (_this._isDisposed) return;
                    var result;
                    try {
                        result = callback.apply(parent_1, args);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                        if (result === false && args[0]) {
                            var e = args[0];
                            if (e.preventDefault) e.preventDefault();
                            if (e.stopPropagation) e.stopPropagation();
                            e.cancelBubble = true;
                        }
                    } catch (e) {
                    // ignore
                    }
                    return result;
                };
                eventRecord.elementCallback = processElementEvent;
                if (target.addEventListener) target.addEventListener(eventName, processElementEvent, options);
                else if (target.attachEvent) // IE8
                target.attachEvent("on" + eventName, processElementEvent);
            } else {
                var processObjectEvent = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (_this._isDisposed) return;
                    return callback.apply(parent_1, args);
                };
                eventRecord.objectCallback = processObjectEvent;
            }
            // Remember the record locally, so that it can be removed.
            this._eventRecords.push(eventRecord);
        }
    };
    EventGroup.prototype.off = function(target, eventName, callback, options) {
        for(var i = 0; i < this._eventRecords.length; i++){
            var eventRecord = this._eventRecords[i];
            if ((!target || target === eventRecord.target) && (!eventName || eventName === eventRecord.eventName) && (!callback || callback === eventRecord.callback) && (typeof options !== "boolean" || options === eventRecord.options)) {
                var events = eventRecord.target.__events__;
                var targetArrayLookup = events[eventRecord.eventName];
                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
                // We may have already target's entries, so check for null.
                if (targetArray) {
                    if (targetArray.length === 1 || !callback) {
                        targetArrayLookup.count -= targetArray.length;
                        delete events[eventRecord.eventName][this._id];
                    } else {
                        targetArrayLookup.count--;
                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
                    }
                    if (!targetArrayLookup.count) delete events[eventRecord.eventName];
                }
                if (eventRecord.elementCallback) {
                    if (eventRecord.target.removeEventListener) eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.options);
                    else if (eventRecord.target.detachEvent) // IE8
                    eventRecord.target.detachEvent("on" + eventRecord.eventName, eventRecord.elementCallback);
                }
                this._eventRecords.splice(i--, 1);
            }
        }
    };
    /** Trigger the given event in the context of this instance of EventGroup. */ EventGroup.prototype.raise = function(eventName, eventArgs, bubbleEvent) {
        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
    };
    /** Declare an event as being supported by this instance of EventGroup. */ EventGroup.prototype.declare = function(event) {
        var declaredEvents = this._parent.__declaredEvents = this._parent.__declaredEvents || {};
        if (typeof event === "string") declaredEvents[event] = true;
        else for(var i = 0; i < event.length; i++)declaredEvents[event[i]] = true;
    };
    EventGroup._uniqueId = 0;
    return EventGroup;
}();

/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns a single function which will call each of the given functions in the context of the
 * parent.
 */ function $a2f876b5f5ff31f2$export$b8fb43c74a4e9be3(parent) {
    var functions = [];
    for(var _i = 1; _i < arguments.length; _i++)functions[_i - 1] = arguments[_i];
    if (functions.length < 2) return functions[0];
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        functions.forEach(function(f) {
            return f && f.apply(parent, args);
        });
    };
}


function $ee07c8e3227b2b42$export$ef567452699b6b33(parent, methods) {
    for(var name_1 in methods)if (methods.hasOwnProperty(name_1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parent[name_1] = (0, $a2f876b5f5ff31f2$export$b8fb43c74a4e9be3)(parent, parent[name_1], methods[name_1]);
}


function $e67df77dd079fd43$export$4e1ebb7d216e1f17(obj) {
    (0, $ee07c8e3227b2b42$export$ef567452699b6b33)(obj, {
        componentDidMount: $e67df77dd079fd43$var$_onMount,
        componentDidUpdate: $e67df77dd079fd43$var$_onUpdate,
        componentWillUnmount: $e67df77dd079fd43$var$_onUnmount
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onMount() {
    $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, this);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onUpdate(prevProps) {
    if (prevProps.componentRef !== this.props.componentRef) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e67df77dd079fd43$var$_setComponentRef(prevProps.componentRef, null);
        $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, this);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onUnmount() {
    $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, null);
}
function $e67df77dd079fd43$var$_setComponentRef(componentRef, value) {
    if (componentRef) {
        if (typeof componentRef === "object") componentRef.current = value;
        else if (typeof componentRef === "function") componentRef(value);
    }
}

/**
 * ARIA helper to concatenate attributes, returning undefined if all attributes
 * are undefined. (Empty strings are not a valid ARIA attribute value.)
 *
 * @param ariaAttributes - ARIA attributes to merge
 */ function $47ed660f7395a6aa$export$35013cdad9bb6ffa() {
    var ariaAttributes = [];
    for(var _i = 0; _i < arguments.length; _i++)ariaAttributes[_i] = arguments[_i];
    var mergedAttribute = ariaAttributes.filter(function(arg) {
        return arg;
    }).join(" ").trim();
    return mergedAttribute === "" ? undefined : mergedAttribute;
}



var $acw62 = parcelRequire("acw62");



function $35efe983fe3c9b91$export$864d02b07a04fe0f(componentName, props, requiredProps, conditionalPropName, condition) {
    var _i, requiredProps_1, requiredPropName;
}



function $8c9f8bb7c7ee0375$export$3dca6a71e81a1f03(componentName, props, exclusiveMap) {
    var propName, propInExclusiveMapValue;
}



/**
 * BaseComponent class, which provides basic helpers for all components.
 *
 * @public
 * {@docCategory BaseComponent}
 *
 * @deprecated Do not use. We are moving away from class component.
 */ var $12233c50b7efccdc$export$55ae5207ce896a6b = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseComponent, _super);
    /**
     * BaseComponent constructor
     * @param props - The props for the component.
     * @param context - The context for the component.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function BaseComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        // eslint-disable-next-line deprecation/deprecation
        $12233c50b7efccdc$var$_makeAllSafe(_this, BaseComponent.prototype, [
            "componentDidMount",
            "shouldComponentUpdate",
            "getSnapshotBeforeUpdate",
            "render",
            "componentDidUpdate",
            "componentWillUnmount"
        ]);
        return _this;
    }
    /**
     * When the component receives props, make sure the componentRef is updated.
     */ BaseComponent.prototype.componentDidUpdate = function(prevProps, prevState) {
        this._updateComponentRef(prevProps, this.props);
    };
    /**
     * When the component has mounted, update the componentRef.
     */ BaseComponent.prototype.componentDidMount = function() {
        this._setComponentRef(this.props.componentRef, this);
    };
    /**
     * If we have disposables, dispose them automatically on unmount.
     */ BaseComponent.prototype.componentWillUnmount = function() {
        this._setComponentRef(this.props.componentRef, null);
        if (this.__disposables) {
            for(var i = 0, len = this._disposables.length; i < len; i++){
                var disposable = this.__disposables[i];
                if (disposable.dispose) disposable.dispose();
            }
            this.__disposables = null;
        }
    };
    Object.defineProperty(BaseComponent.prototype, "className", {
        /**
         * Gets the object's class name.
         */ get: function() {
            if (!this.__className) {
                var funcNameRegex = /function (.{1,})\(/;
                var results = funcNameRegex.exec(this.constructor.toString());
                this.__className = results && results.length > 1 ? results[1] : "";
            }
            return this.__className;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_disposables", {
        /**
         * Allows subclasses to push things to this._disposables to be auto disposed.
         */ get: function() {
            if (!this.__disposables) this.__disposables = [];
            return this.__disposables;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_async", {
        /**
         * Gets the async instance associated with the component, created on demand. The async instance gives
         * subclasses a way to execute setTimeout/setInterval async calls safely, where the callbacks
         * will be cleared/ignored automatically after unmounting. The helpers within the async object also
         * preserve the this pointer so that you don't need to "bind" the callbacks.
         */ get: function() {
            if (!this.__async) {
                this.__async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(this);
                this._disposables.push(this.__async);
            }
            return this.__async;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_events", {
        /**
         * Gets the event group instance assocaited with the component, created on demand. The event instance
         * provides on/off methods for listening to DOM (or regular javascript object) events. The event callbacks
         * will be automatically disconnected after unmounting. The helpers within the events object also
         * preserve the this reference so that you don't need to "bind" the callbacks.
         */ get: function() {
            if (!this.__events) {
                this.__events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(this);
                this._disposables.push(this.__events);
            }
            return this.__events;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Helper to return a memoized ref resolver function.
     * @param refName - Name of the member to assign the ref to.
     * @returns A function instance keyed from the given refname.
     * @deprecated Use `createRef` from React.createRef.
     */ BaseComponent.prototype._resolveRef = function(refName) {
        var _this = this;
        if (!this.__resolves) this.__resolves = {};
        if (!this.__resolves[refName]) this.__resolves[refName] = function(ref) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return _this[refName] = ref;
        };
        return this.__resolves[refName];
    };
    /**
     * Updates the componentRef (by calling it with "this" when necessary.)
     */ BaseComponent.prototype._updateComponentRef = function(currentProps, newProps) {
        if (newProps === void 0) newProps = {};
        // currentProps *should* always be defined, but verify that just in case a subclass is manually
        // calling a lifecycle method with no parameters (which has happened) or other odd usage.
        if (currentProps && newProps && currentProps.componentRef !== newProps.componentRef) {
            this._setComponentRef(currentProps.componentRef, null);
            this._setComponentRef(newProps.componentRef, this);
        }
    };
    /**
     * Warns when a deprecated props are being used.
     *
     * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
     * either null or a replacement prop name.
     */ BaseComponent.prototype._warnDeprecations = function(deprecationMap) {
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)(this.className, this.props, deprecationMap);
    };
    /**
     * Warns when props which are mutually exclusive with each other are both used.
     *
     * @param mutuallyExclusiveMap - The map of mutually exclusive props.
     */ BaseComponent.prototype._warnMutuallyExclusive = function(mutuallyExclusiveMap) {
        (0, $8c9f8bb7c7ee0375$export$3dca6a71e81a1f03)(this.className, this.props, mutuallyExclusiveMap);
    };
    /**
     * Warns when props are required if a condition is met.
     *
     * @param requiredProps - The name of the props that are required when the condition is met.
     * @param conditionalPropName - The name of the prop that the condition is based on.
     * @param condition - Whether the condition is met.
     */ BaseComponent.prototype._warnConditionallyRequiredProps = function(requiredProps, conditionalPropName, condition) {
        (0, $35efe983fe3c9b91$export$864d02b07a04fe0f)(this.className, this.props, requiredProps, conditionalPropName, condition);
    };
    BaseComponent.prototype._setComponentRef = function(ref, value) {
        if (!this._skipComponentRefResolution && ref) {
            if (typeof ref === "function") ref(value);
            if (typeof ref === "object") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref.current = value;
        }
    };
    return BaseComponent;
}($acw62.Component);
/**
 * Helper to override a given method with a wrapper method that can try/catch the original, but also
 * ensures that the BaseComponent's methods are called before the subclass's. This ensures that
 * componentWillUnmount in the base is called and that things in the _disposables array are disposed.
 */ // eslint-disable-next-line deprecation/deprecation
function $12233c50b7efccdc$var$_makeAllSafe(obj, prototype, methodNames) {
    for(var i = 0, len = methodNames.length; i < len; i++)$12233c50b7efccdc$var$_makeSafe(obj, prototype, methodNames[i]);
}
// eslint-disable-next-line deprecation/deprecation
function $12233c50b7efccdc$var$_makeSafe(obj, prototype, methodName) {
    /* eslint-disable @typescript-eslint/no-explicit-any */ var classMethod = obj[methodName];
    var prototypeMethod = prototype[methodName];
    if (classMethod || prototypeMethod) obj[methodName] = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        /* eslint-enable @typescript-eslint/no-explicit-any */ var retVal;
        if (prototypeMethod) retVal = prototypeMethod.apply(this, args);
        if (classMethod !== prototypeMethod) retVal = classMethod.apply(this, args);
        return retVal;
    };
}
function $12233c50b7efccdc$export$c14f77b8570f3676() {
    return null;
}

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 *
 * @public
 */ function $62f1f04af4f10ed3$export$405b1af69064399d(element) {
    return element && !!element._virtual;
}


function $8e13e667a15b71d4$export$7a054da414775188(child) {
    var parent;
    if (child && (0, $62f1f04af4f10ed3$export$405b1af69064399d)(child)) parent = child._virtual.parent;
    return parent;
}


function $7ca0c55777f4d1e1$export$58081aedf094d85b(child, allowVirtualParents) {
    if (allowVirtualParents === void 0) allowVirtualParents = true;
    return child && (allowVirtualParents && (0, $8e13e667a15b71d4$export$7a054da414775188)(child) || child.parentNode && child.parentNode);
}


function $ac7720b658a51a62$export$52e9043fba4174a7(element, matchFunction) {
    if (!element || element === document.body) return null;
    return matchFunction(element) ? element : $ac7720b658a51a62$export$52e9043fba4174a7((0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element), matchFunction);
}


var $d38428ba3ade01f7$export$a2035272131f96ca = "data-portal-element";
function $d38428ba3ade01f7$export$c36b8a5db804ed10(element) {
    element.setAttribute($d38428ba3ade01f7$export$a2035272131f96ca, "true");
}


function $8eda1135a5ecf96f$export$ca66eda9f83446dd(target, parent) {
    var elementMatch = (0, $ac7720b658a51a62$export$52e9043fba4174a7)(target, function(testElement) {
        return parent === testElement || testElement.hasAttribute((0, $d38428ba3ade01f7$export$a2035272131f96ca));
    });
    return elementMatch !== null && elementMatch.hasAttribute((0, $d38428ba3ade01f7$export$a2035272131f96ca));
}




var $acw62 = parcelRequire("acw62");



var $98737100b97aa693$export$4a122bafaa48b23d = function(props) {
    var className = props.className, imageProps = props.imageProps;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40), [
        "aria-label",
        "aria-labelledby",
        "title",
        "aria-describedby"
    ]);
    var altText = imageProps.alt || props["aria-label"];
    var hasName = altText || props["aria-labelledby"] || props.title || imageProps["aria-label"] || imageProps["aria-labelledby"] || imageProps.title;
    // move naming or describing attributes from the container (where they are invalid) to the image
    var imageNameProps = {
        "aria-labelledby": props["aria-labelledby"],
        "aria-describedby": props["aria-describedby"],
        title: props.title
    };
    var containerProps = hasName ? {} : {
        "aria-hidden": true
    };
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, nativeProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $91cc3acbdc44edfa$export$5895f18d7dadc168), (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).root, (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).image, className)
    }), $acw62.createElement((0, $6023154631a54d52$export$3e431a229df88919), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageNameProps, imageProps, {
        alt: hasName ? altText : ""
    })));
};


var $e52f208cfc343b11$export$7bbc434a13063638 = {
    /**
     * Appear above the target element, with the left edges of the callout and target aligning.
     */ topLeftEdge: 0,
    /**
     * Appear above the target element, with the centers of the callout and target aligning.
     */ topCenter: 1,
    /**
     * Appear above the target element, with the right edges of the callout and target aligning.
     */ topRightEdge: 2,
    /**
     * Appear above the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */ topAutoEdge: 3,
    /**
     * Appear below the target element, with the left edges of the callout and target aligning.
     */ bottomLeftEdge: 4,
    /**
     * Appear below the target element, with the centers of the callout and target aligning.
     */ bottomCenter: 5,
    /**
     * Appear below the target element, with the right edges of the callout and target aligning.
     */ bottomRightEdge: 6,
    /**
     * Appear below the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */ bottomAutoEdge: 7,
    /**
     * Appear to the left of the target element, with the top edges of the callout and target aligning.
     */ leftTopEdge: 8,
    /**
     * Appear to the left of the target element, with the centers of the callout and target aligning.
     */ leftCenter: 9,
    /**
     * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
     */ leftBottomEdge: 10,
    /**
     * Appear to the right of the target element, with the top edges of the callout and target aligning.
     */ rightTopEdge: 11,
    /**
     * Appear to the right of the target element, with the centers of the callout and target aligning.
     */ rightCenter: 12,
    /**
     * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
     */ rightBottomEdge: 13
};




var $acw62 = parcelRequire("acw62");

function $dcded159bee91fac$var$createComposedRenderFunction(outer) {
    var outerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(inner) {
        var innerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(defaultRender) {
            return function(innerProps) {
                return inner(innerProps, defaultRender);
            };
        });
        return function(outerProps, defaultRender) {
            return outer(outerProps, defaultRender ? innerMemoizer(defaultRender) : inner);
        };
    });
    return outerMemoizer;
}
var $dcded159bee91fac$var$memoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)($dcded159bee91fac$var$createComposedRenderFunction);
function $dcded159bee91fac$export$6427897eb70b5e23(outer, inner) {
    return $dcded159bee91fac$var$memoizer(outer)(inner);
}




var $acw62 = parcelRequire("acw62");

var $406552f968f746a1$export$7dc3c01339ee6e7f;
(function(ContextualMenuItemType) {
    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})($406552f968f746a1$export$7dc3c01339ee6e7f || ($406552f968f746a1$export$7dc3c01339ee6e7f = {}));





var $acw62 = parcelRequire("acw62");
/**
 * {@docCategory FocusZone}
 */ var $13ca773bee6ceecf$export$269041a88986a933 = {
    /** Tabbing is not allowed */ none: 0,
    /** All tabbing action is allowed */ all: 1,
    /** Tabbing is allowed only on input elements */ inputOnly: 2
};
var $13ca773bee6ceecf$export$5764f9ffe1c23cd3;
(function(FocusZoneDirection) {
    /** Only react to up/down arrows. */ FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
    /** Only react to left/right arrows. */ FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
    /** React to all arrows. */ FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
    /**
     * React to all arrows. Navigate next item in DOM on right/down arrow keys and previous - left/up arrow keys.
     * Right and Left arrow keys are swapped in RTL mode.
     */ FocusZoneDirection[FocusZoneDirection["domOrder"] = 3] = "domOrder";
})($13ca773bee6ceecf$export$5764f9ffe1c23cd3 || ($13ca773bee6ceecf$export$5764f9ffe1c23cd3 = {}));



function $bd2f10be17e6ca27$export$12de49ec5e3dd0cd(parent, child, allowVirtualParents) {
    if (allowVirtualParents === void 0) allowVirtualParents = true;
    var isContained = false;
    if (parent && child) {
        if (allowVirtualParents) {
            if (parent === child) isContained = true;
            else {
                isContained = false;
                while(child){
                    var nextParent = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(child);
                    if (nextParent === parent) {
                        isContained = true;
                        break;
                    }
                    child = nextParent;
                }
            }
        } else if (parent.contains) isContained = parent.contains(child);
    }
    return isContained;
}




var $11f97b2a9a127629$var$_scrollbarWidth;
var $11f97b2a9a127629$var$_bodyScrollDisabledCount = 0;
var $11f97b2a9a127629$var$DisabledScrollClassName = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)({
    overflow: "hidden !important"
});
var $11f97b2a9a127629$export$5d74730bd625cf54 = "data-is-scrollable";
var $11f97b2a9a127629$export$f02f9101103a4939 = function(element, events) {
    if (!element) return;
    var _previousClientY = 0;
    var _element = null;
    // remember the clientY for future calls of _preventOverscrolling
    var _saveClientY = function(event) {
        if (event.targetTouches.length === 1) _previousClientY = event.targetTouches[0].clientY;
    };
    // prevent the body from scrolling when the user attempts
    // to scroll past the top or bottom of the element
    var _preventOverscrolling = function(event) {
        // only respond to a single-finger touch
        if (event.targetTouches.length !== 1) return;
        // prevent the body touchmove handler from firing
        // so that scrolling is allowed within the element
        event.stopPropagation();
        if (!_element) return;
        var clientY = event.targetTouches[0].clientY - _previousClientY;
        var scrollableParent = $11f97b2a9a127629$export$494fa69500a5872a(event.target);
        if (scrollableParent) _element = scrollableParent;
        // if the element is scrolled to the top,
        // prevent the user from scrolling up
        if (_element.scrollTop === 0 && clientY > 0) event.preventDefault();
        // if the element is scrolled to the bottom,
        // prevent the user from scrolling down
        if (_element.scrollHeight - Math.ceil(_element.scrollTop) <= _element.clientHeight && clientY < 0) event.preventDefault();
    };
    events.on(element, "touchstart", _saveClientY, {
        passive: false
    });
    events.on(element, "touchmove", _preventOverscrolling, {
        passive: false
    });
    _element = element;
};
var $11f97b2a9a127629$export$d4daebbd8ba7010c = function(element, events) {
    if (!element) return;
    var _allowElementScroll = function(event) {
        event.stopPropagation();
    };
    events.on(element, "touchmove", _allowElementScroll, {
        passive: false
    });
};
var $11f97b2a9a127629$var$_disableIosBodyScroll = function(event) {
    event.preventDefault();
};
function $11f97b2a9a127629$export$24fdf68abf432c44() {
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc && doc.body && !$11f97b2a9a127629$var$_bodyScrollDisabledCount) {
        doc.body.classList.add($11f97b2a9a127629$var$DisabledScrollClassName);
        doc.body.addEventListener("touchmove", $11f97b2a9a127629$var$_disableIosBodyScroll, {
            passive: false,
            capture: false
        });
    }
    $11f97b2a9a127629$var$_bodyScrollDisabledCount++;
}
function $11f97b2a9a127629$export$e5d0524c3725571e() {
    if ($11f97b2a9a127629$var$_bodyScrollDisabledCount > 0) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if (doc && doc.body && $11f97b2a9a127629$var$_bodyScrollDisabledCount === 1) {
            doc.body.classList.remove($11f97b2a9a127629$var$DisabledScrollClassName);
            doc.body.removeEventListener("touchmove", $11f97b2a9a127629$var$_disableIosBodyScroll);
        }
        $11f97b2a9a127629$var$_bodyScrollDisabledCount--;
    }
}
function $11f97b2a9a127629$export$ace028f8da1a6300() {
    if ($11f97b2a9a127629$var$_scrollbarWidth === undefined) {
        var scrollDiv = document.createElement("div");
        scrollDiv.style.setProperty("width", "100px");
        scrollDiv.style.setProperty("height", "100px");
        scrollDiv.style.setProperty("overflow", "scroll");
        scrollDiv.style.setProperty("position", "absolute");
        scrollDiv.style.setProperty("top", "-9999px");
        document.body.appendChild(scrollDiv);
        // Get the scrollbar width
        $11f97b2a9a127629$var$_scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        // Delete the DIV
        document.body.removeChild(scrollDiv);
    }
    return $11f97b2a9a127629$var$_scrollbarWidth;
}
function $11f97b2a9a127629$export$494fa69500a5872a(startingElement) {
    var el = startingElement;
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(startingElement);
    // First do a quick scan for the scrollable attribute.
    while(el && el !== doc.body){
        if (el.getAttribute($11f97b2a9a127629$export$5d74730bd625cf54) === "true") return el;
        el = el.parentElement;
    }
    // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.
    el = startingElement;
    while(el && el !== doc.body){
        if (el.getAttribute($11f97b2a9a127629$export$5d74730bd625cf54) !== "false") {
            var computedStyles = getComputedStyle(el);
            var overflowY = computedStyles ? computedStyles.getPropertyValue("overflow-y") : "";
            if (overflowY && (overflowY === "scroll" || overflowY === "auto")) return el;
        }
        el = el.parentElement;
    }
    // Fall back to window scroll.
    if (!el || el === doc.body) el = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(startingElement);
    return el;
}


function $9f024846b985abb6$export$c87fe71d3aea462(element, attribute) {
    var elementMatch = (0, $ac7720b658a51a62$export$52e9043fba4174a7)(element, function(testElement) {
        return testElement.hasAttribute(attribute);
    });
    return elementMatch && elementMatch.getAttribute(attribute);
}






var $94bdc1ebed789608$var$IS_FOCUSABLE_ATTRIBUTE = "data-is-focusable";
var $94bdc1ebed789608$var$IS_VISIBLE_ATTRIBUTE = "data-is-visible";
var $94bdc1ebed789608$var$FOCUSZONE_ID_ATTRIBUTE = "data-focuszone-id";
var $94bdc1ebed789608$var$FOCUSZONE_SUB_ATTRIBUTE = "data-is-sub-focuszone";
function $94bdc1ebed789608$export$748138f04a69bf21(rootElement, currentElement, includeElementsInFocusZones) {
    return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, true, false, false, includeElementsInFocusZones);
}
function $94bdc1ebed789608$export$73e81fa65335a75b(rootElement, currentElement, includeElementsInFocusZones) {
    return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, true, false, true, includeElementsInFocusZones);
}
function $94bdc1ebed789608$export$9beaf9bf6ff178ae(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
    if (checkNode === void 0) checkNode = true;
    return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, checkNode, false, false, includeElementsInFocusZones, false, true);
}
function $94bdc1ebed789608$export$73cc6e682b257cff(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
    if (checkNode === void 0) checkNode = true;
    return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, checkNode, false, true, includeElementsInFocusZones, false, true);
}
function $94bdc1ebed789608$export$8765806c2c274519(rootElement, bypassHiddenElements) {
    var element = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, rootElement, true, false, false, true, undefined, undefined, bypassHiddenElements);
    if (element) {
        $94bdc1ebed789608$export$b5a401136c35d08a(element);
        return true;
    }
    return false;
}
function $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable) {
    if (!currentElement || !allowFocusRoot && currentElement === rootElement) return null;
    var isCurrentElementVisible = $94bdc1ebed789608$export$e989c0fffaa6b27a(currentElement);
    // Check its children.
    if (traverseChildren && isCurrentElementVisible && (includeElementsInFocusZones || !($94bdc1ebed789608$export$1b55aa98f48e3915(currentElement) || $94bdc1ebed789608$export$7e6b7baad6f0187d(currentElement)))) {
        var childMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement.lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
        if (childMatch) {
            if (tabbable && $94bdc1ebed789608$export$5d5979bf640d1558(childMatch, true) || !tabbable) return childMatch;
            var childMatchSiblingMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
            if (childMatchSiblingMatch) return childMatchSiblingMatch;
            var childMatchParent = childMatch.parentElement;
            // At this point if we have not found any potential matches
            // start looking at the rest of the subtree under the currentParent.
            // NOTE: We do not want to recurse here because doing so could
            // cause elements to get skipped.
            while(childMatchParent && childMatchParent !== currentElement){
                var childMatchParentMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
                if (childMatchParentMatch) return childMatchParentMatch;
                childMatchParent = childMatchParent.parentElement;
            }
        }
    }
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && $94bdc1ebed789608$export$5d5979bf640d1558(currentElement, tabbable)) return currentElement;
    // Check its previous sibling.
    var siblingMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
    if (siblingMatch) return siblingMatch;
    // Check its parent.
    if (!suppressParentTraversal) return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
    return null;
}
function $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements) {
    if (!currentElement || currentElement === rootElement && suppressChildTraversal && !allowFocusRoot) return null;
    var checkElementVisibility = bypassHiddenElements ? $94bdc1ebed789608$export$5d127f54530ed28b : $94bdc1ebed789608$export$e989c0fffaa6b27a;
    var isCurrentElementVisible = checkElementVisibility(currentElement);
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && $94bdc1ebed789608$export$5d5979bf640d1558(currentElement, tabbable)) return currentElement;
    // Check its children.
    if (!suppressChildTraversal && isCurrentElementVisible && (includeElementsInFocusZones || !($94bdc1ebed789608$export$1b55aa98f48e3915(currentElement) || $94bdc1ebed789608$export$7e6b7baad6f0187d(currentElement)))) {
        var childMatch = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement.firstElementChild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements);
        if (childMatch) return childMatch;
    }
    if (currentElement === rootElement) return null;
    // Check its sibling.
    var siblingMatch = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements);
    if (siblingMatch) return siblingMatch;
    if (!suppressParentTraversal) return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements);
    return null;
}
function $94bdc1ebed789608$export$e989c0fffaa6b27a(element) {
    // If the element is not valid, return false.
    if (!element || !element.getAttribute) return false;
    var visibilityAttribute = element.getAttribute($94bdc1ebed789608$var$IS_VISIBLE_ATTRIBUTE);
    // If the element is explicitly marked with the visibility attribute, return that value as boolean.
    if (visibilityAttribute !== null && visibilityAttribute !== undefined) return visibilityAttribute === "true";
    // Fallback to other methods of determining actual visibility.
    return element.offsetHeight !== 0 || element.offsetParent !== null || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    element.isVisible === true; // used as a workaround for testing.
}
function $94bdc1ebed789608$export$5d127f54530ed28b(element) {
    return !!element && $94bdc1ebed789608$export$e989c0fffaa6b27a(element) && !element.hidden && window.getComputedStyle(element).visibility !== "hidden";
}
function $94bdc1ebed789608$export$5d5979bf640d1558(element, checkTabIndex) {
    // If this element is null or is disabled, it is not considered tabbable.
    if (!element || element.disabled) return false;
    var tabIndex = 0;
    var tabIndexAttributeValue = null;
    if (element && element.getAttribute) {
        tabIndexAttributeValue = element.getAttribute("tabIndex");
        if (tabIndexAttributeValue) tabIndex = parseInt(tabIndexAttributeValue, 10);
    }
    var isFocusableAttribute = element.getAttribute ? element.getAttribute($94bdc1ebed789608$var$IS_FOCUSABLE_ATTRIBUTE) : null;
    var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
    var result = !!element && isFocusableAttribute !== "false" && (element.tagName === "A" || element.tagName === "BUTTON" || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "SELECT" || isFocusableAttribute === "true" || isTabIndexSet);
    return checkTabIndex ? tabIndex !== -1 && result : result;
}
function $94bdc1ebed789608$export$1b55aa98f48e3915(element) {
    return !!(element && element.getAttribute && !!element.getAttribute($94bdc1ebed789608$var$FOCUSZONE_ID_ATTRIBUTE));
}
function $94bdc1ebed789608$export$7e6b7baad6f0187d(element) {
    return !!(element && element.getAttribute && element.getAttribute($94bdc1ebed789608$var$FOCUSZONE_SUB_ATTRIBUTE) === "true");
}
function $94bdc1ebed789608$export$597abdf7826dd64a(element) {
    var document = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(element);
    var currentActiveElement = document && document.activeElement;
    if (currentActiveElement && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(element, currentActiveElement)) return true;
    return false;
}
function $94bdc1ebed789608$export$841acbea7fb3b182(element, noWrapDataAttribute) {
    return (0, $9f024846b985abb6$export$c87fe71d3aea462)(element, noWrapDataAttribute) === "true" ? false : true;
}
var $94bdc1ebed789608$var$targetToFocusOnNextRepaint = undefined;
function $94bdc1ebed789608$export$b5a401136c35d08a(element) {
    if (element) {
        // An element was already queued to be focused, so replace that one with the new element
        if ($94bdc1ebed789608$var$targetToFocusOnNextRepaint) {
            $94bdc1ebed789608$var$targetToFocusOnNextRepaint = element;
            return;
        }
        $94bdc1ebed789608$var$targetToFocusOnNextRepaint = element;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(element);
        if (win) // element.focus() is a no-op if the element is no longer in the DOM, meaning this is always safe
        win.requestAnimationFrame(function() {
            $94bdc1ebed789608$var$targetToFocusOnNextRepaint && $94bdc1ebed789608$var$targetToFocusOnNextRepaint.focus();
            // We are done focusing for this frame, so reset the queued focus element
            $94bdc1ebed789608$var$targetToFocusOnNextRepaint = undefined;
        });
    }
}
function $94bdc1ebed789608$export$f41c042330addd91(parent, path) {
    var element = parent;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var index = path_1[_i];
        var nextChild = element.children[Math.min(index, element.children.length - 1)];
        if (!nextChild) break;
        element = nextChild;
    }
    element = $94bdc1ebed789608$export$5d5979bf640d1558(element) && $94bdc1ebed789608$export$e989c0fffaa6b27a(element) ? element : $94bdc1ebed789608$export$4109ed81edd7716d(parent, element, true) || $94bdc1ebed789608$export$42ed4d93850449f7(parent, element);
    return element;
}
function $94bdc1ebed789608$export$fe29704f84b976d2(fromElement, toElement) {
    var path = [];
    while(toElement && fromElement && toElement !== fromElement){
        var parent_1 = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(toElement, true);
        if (parent_1 === null) return [];
        path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
        toElement = parent_1;
    }
    return path;
}




var $8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE = "data-is-focusable";
var $8c4e0e7eaa58d986$var$IS_ENTER_DISABLED_ATTRIBUTE = "data-disable-click-on-enter";
var $8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE = "data-focuszone-id";
var $8c4e0e7eaa58d986$var$TABINDEX = "tabindex";
var $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP = "data-no-vertical-wrap";
var $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP = "data-no-horizontal-wrap";
var $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER = 999999999;
var $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
var $8c4e0e7eaa58d986$var$focusZoneStyles;
var $8c4e0e7eaa58d986$var$focusZoneClass = "ms-FocusZone";
/**
 * Raises a click on a target element based on a keyboard event.
 */ function $8c4e0e7eaa58d986$var$raiseClickFromKeyboardEvent(target, ev) {
    var event;
    if (typeof MouseEvent === "function") event = new MouseEvent("click", {
        ctrlKey: ev === null || ev === void 0 ? void 0 : ev.ctrlKey,
        metaKey: ev === null || ev === void 0 ? void 0 : ev.metaKey,
        shiftKey: ev === null || ev === void 0 ? void 0 : ev.shiftKey,
        altKey: ev === null || ev === void 0 ? void 0 : ev.altKey,
        bubbles: ev === null || ev === void 0 ? void 0 : ev.bubbles,
        cancelable: ev === null || ev === void 0 ? void 0 : ev.cancelable
    });
    else {
        event = document.createEvent("MouseEvents");
        // eslint-disable-next-line deprecation/deprecation
        event.initMouseEvent("click", ev ? ev.bubbles : false, ev ? ev.cancelable : false, window, 0, 0, 0, 0, 0, ev ? ev.ctrlKey : false, ev ? ev.altKey : false, ev ? ev.shiftKey : false, ev ? ev.metaKey : false, 0, null);
    }
    target.dispatchEvent(event);
}
// Helper function that will return a class for when the root is focused
function $8c4e0e7eaa58d986$var$getRootClass() {
    if (!$8c4e0e7eaa58d986$var$focusZoneStyles) $8c4e0e7eaa58d986$var$focusZoneStyles = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)({
        selectors: {
            ":focus": {
                outline: "none"
            }
        }
    }, $8c4e0e7eaa58d986$var$focusZoneClass);
    return $8c4e0e7eaa58d986$var$focusZoneStyles;
}
var $8c4e0e7eaa58d986$var$_allInstances = {};
var $8c4e0e7eaa58d986$var$_outerZones = new Set();
var $8c4e0e7eaa58d986$var$ALLOWED_INPUT_TYPES = [
    "text",
    "number",
    "password",
    "email",
    "tel",
    "url",
    "search",
    "textarea"
];
var $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS = false;
var $8c4e0e7eaa58d986$export$4949eceb002ae2e2 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FocusZone, _super);
    function FocusZone(props) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._mergedRef = (0, $ad53d15595d1f5d5$export$9f37a988498f0f9c)();
        _this._onFocus = function(ev) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            var _a = _this.props, onActiveElementChanged = _a.onActiveElementChanged, // eslint-disable-next-line deprecation/deprecation
            doNotAllowFocusEventToPropagate = _a.doNotAllowFocusEventToPropagate, stopFocusPropagation = _a.stopFocusPropagation, // eslint-disable-next-line deprecation/deprecation
            onFocusNotification = _a.onFocusNotification, onFocus = _a.onFocus, shouldFocusInnerElementWhenReceivedFocus = _a.shouldFocusInnerElementWhenReceivedFocus, defaultTabbableElement = _a.defaultTabbableElement;
            var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);
            var newActiveElement;
            if (isImmediateDescendant) newActiveElement = ev.target;
            else {
                var parentElement = ev.target;
                while(parentElement && parentElement !== _this._root.current){
                    if ((0, $94bdc1ebed789608$export$5d5979bf640d1558)(parentElement) && _this._isImmediateDescendantOfZone(parentElement)) {
                        newActiveElement = parentElement;
                        break;
                    }
                    parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
                }
            }
            // If an inner focusable element should be focused when FocusZone container receives focus
            if (shouldFocusInnerElementWhenReceivedFocus && ev.target === _this._root.current) {
                var maybeElementToFocus = defaultTabbableElement && typeof defaultTabbableElement === "function" && _this._root.current && defaultTabbableElement(_this._root.current);
                // try to focus defaultTabbable element
                if (maybeElementToFocus && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(maybeElementToFocus)) {
                    newActiveElement = maybeElementToFocus;
                    maybeElementToFocus.focus();
                } else {
                    // force focus on first focusable element
                    _this.focus(true);
                    if (_this._activeElement) // set to null as new active element was handled in method above
                    newActiveElement = null;
                }
            }
            var initialElementFocused = !_this._activeElement;
            // If the new active element is a child of this zone and received focus,
            // update alignment an immediate descendant
            if (newActiveElement && newActiveElement !== _this._activeElement) {
                if (isImmediateDescendant || initialElementFocused) _this._setFocusAlignment(newActiveElement, true, true);
                _this._activeElement = newActiveElement;
                if (initialElementFocused) _this._updateTabIndexes();
            }
            if (onActiveElementChanged) onActiveElementChanged(_this._activeElement, ev);
            if (stopFocusPropagation || doNotAllowFocusEventToPropagate) ev.stopPropagation();
            if (onFocus) onFocus(ev);
            else if (onFocusNotification) onFocusNotification();
        };
        _this._onBlur = function() {
            _this._setParkedFocus(false);
        };
        _this._onMouseDown = function(ev) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            var disabled = _this.props.disabled;
            if (disabled) return;
            var target = ev.target;
            var path = [];
            while(target && target !== _this._root.current){
                path.push(target);
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            }
            while(path.length){
                target = path.pop();
                if (target && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(target)) _this._setActiveElement(target, true);
                if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(target)) break;
            }
        };
        /**
         * Handle the keystrokes.
         */ _this._onKeyDown = function(ev, theme) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            // eslint-disable-next-line deprecation/deprecation
            var _a = _this.props, direction = _a.direction, disabled = _a.disabled, isInnerZoneKeystroke = _a.isInnerZoneKeystroke, pagingSupportDisabled = _a.pagingSupportDisabled, shouldEnterInnerZone = _a.shouldEnterInnerZone;
            if (disabled) return;
            if (_this.props.onKeyDown) _this.props.onKeyDown(ev);
            // If the default has been prevented, do not process keyboard events.
            if (ev.isDefaultPrevented()) return;
            if (_this._getDocument().activeElement === _this._root.current && _this._isInnerZone) // If this element has focus, it is being controlled by a parent.
            // Ignore the keystroke.
            return;
            if ((shouldEnterInnerZone && shouldEnterInnerZone(ev) || isInnerZoneKeystroke && isInnerZoneKeystroke(ev)) && _this._isImmediateDescendantOfZone(ev.target)) {
                // Try to focus
                var innerZone = _this._getFirstInnerZone();
                if (innerZone) {
                    if (!innerZone.focus(true)) return;
                } else if ((0, $94bdc1ebed789608$export$7e6b7baad6f0187d)(ev.target)) {
                    if (!_this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(ev.target, ev.target.firstChild, true))) return;
                } else return;
            } else if (ev.altKey) return;
            else // eslint-disable-next-line @fluentui/deprecated-keyboard-event-props, deprecation/deprecation
            switch(ev.which){
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).space:
                    if (_this._shouldRaiseClicksOnSpace && _this._tryInvokeClickForFocusable(ev.target, ev)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).left:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusLeft(theme)) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).right:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusRight(theme)) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).up:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusUp()) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).down:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusDown()) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).pageDown:
                    if (!pagingSupportDisabled && _this._moveFocusPaging(true)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).pageUp:
                    if (!pagingSupportDisabled && _this._moveFocusPaging(false)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).tab:
                    if (// eslint-disable-next-line deprecation/deprecation
                    _this.props.allowTabKey || _this.props.handleTabKey === (0, $13ca773bee6ceecf$export$269041a88986a933).all || _this.props.handleTabKey === (0, $13ca773bee6ceecf$export$269041a88986a933).inputOnly && _this._isElementInput(ev.target)) {
                        var focusChanged = false;
                        _this._processingTabKey = true;
                        if (direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical || !_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP)) focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
                        else {
                            var tabWithDirection = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? !ev.shiftKey : ev.shiftKey;
                            focusChanged = tabWithDirection ? _this._moveFocusLeft(theme) : _this._moveFocusRight(theme);
                        }
                        _this._processingTabKey = false;
                        if (focusChanged) break;
                        else if (_this.props.shouldResetActiveElementWhenTabFromZone) _this._activeElement = null;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).home:
                    if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) return false;
                    var firstChild = _this._root.current && _this._root.current.firstChild;
                    if (_this._root.current && firstChild && _this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(_this._root.current, firstChild, true))) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).end:
                    if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) return false;
                    var lastChild = _this._root.current && _this._root.current.lastChild;
                    if (_this._root.current && _this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(_this._root.current, lastChild, true, true, true))) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter:
                    if (_this._shouldRaiseClicksOnEnter && _this._tryInvokeClickForFocusable(ev.target, ev)) break;
                    return;
                default:
                    return;
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._getHorizontalDistanceFromCenter = function(isForward, // eslint-disable-next-line deprecation/deprecation
        activeRect, // eslint-disable-next-line deprecation/deprecation
        targetRect) {
            // eslint-disable-next-line deprecation/deprecation
            var leftAlignment = _this._focusAlignment.left || _this._focusAlignment.x || 0;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            var targetRectBottom = Math.floor(targetRect.bottom);
            var activeRectTop = Math.floor(activeRect.top);
            var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
            var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;
            if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) return 0;
                return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
        };
        // Manage componentRef resolution.
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("FocusZone");
        _this._focusAlignment = {
            left: 0,
            top: 0
        };
        _this._processingTabKey = false;
        var shouldRaiseClicksFallback = (_b = (_a = props.shouldRaiseClicks) !== null && _a !== void 0 ? _a : FocusZone.defaultProps.shouldRaiseClicks) !== null && _b !== void 0 ? _b : true;
        _this._shouldRaiseClicksOnEnter = (_c = props.shouldRaiseClicksOnEnter) !== null && _c !== void 0 ? _c : shouldRaiseClicksFallback;
        _this._shouldRaiseClicksOnSpace = (_d = props.shouldRaiseClicksOnSpace) !== null && _d !== void 0 ? _d : shouldRaiseClicksFallback;
        return _this;
    }
    /** Used for testing purposes only. */ FocusZone.getOuterZones = function() {
        return $8c4e0e7eaa58d986$var$_outerZones.size;
    };
    /**
     * Handle global tab presses so that we can patch tabindexes on the fly.
     * HEADS UP: This must not be an arrow function in order to be referentially equal among instances
     * for ref counting to work correctly!
     */ FocusZone._onKeyDownCapture = function(ev) {
        // eslint-disable-next-line deprecation/deprecation, @fluentui/deprecated-keyboard-event-props
        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).tab) $8c4e0e7eaa58d986$var$_outerZones.forEach(function(zone) {
            return zone._updateTabIndexes();
        });
    };
    FocusZone.prototype.componentDidMount = function() {
        var root = this._root.current;
        $8c4e0e7eaa58d986$var$_allInstances[this._id] = this;
        if (root) {
            var parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(root, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            while(parentElement && parentElement !== this._getDocument().body && parentElement.nodeType === 1){
                if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(parentElement)) {
                    this._isInnerZone = true;
                    break;
                }
                parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            }
            if (!this._isInnerZone) {
                $8c4e0e7eaa58d986$var$_outerZones.add(this);
                this._root.current && this._root.current.addEventListener("keydown", FocusZone._onKeyDownCapture, true);
            }
            this._root.current && this._root.current.addEventListener("blur", this._onBlur, true);
            // Assign initial tab indexes so that we can set initial focus as appropriate.
            this._updateTabIndexes();
            if (this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === "string") this._activeElement = this._getDocument().querySelector(this.props.defaultTabbableElement);
            else if (this.props.defaultActiveElement) // eslint-disable-next-line deprecation/deprecation
            this._activeElement = this._getDocument().querySelector(this.props.defaultActiveElement);
            if (this.props.shouldFocusOnMount) this.focus();
        }
    };
    FocusZone.prototype.componentDidUpdate = function() {
        var root = this._root.current;
        var doc = this._getDocument();
        // If either _activeElement or _defaultFocusElement are no longer contained by _root,
        // reset those variables (and update tab indexes) to avoid memory leaks
        if (this._activeElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._activeElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS) || this._defaultFocusElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._defaultFocusElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS)) {
            this._activeElement = null;
            this._defaultFocusElement = null;
            this._updateTabIndexes();
        }
        if (!this.props.preventFocusRestoration && doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === null || doc.activeElement === root)) {
            // The element has been removed after the render, attempt to restore focus.
            var elementToFocus = (0, $94bdc1ebed789608$export$f41c042330addd91)(root, this._lastIndexPath);
            if (elementToFocus) {
                this._setActiveElement(elementToFocus, true);
                elementToFocus.focus();
                this._setParkedFocus(false);
            } else // We had a focus path to restore, but now that path is unresolvable. Park focus
            // on the container until we can try again.
            this._setParkedFocus(true);
        }
    };
    FocusZone.prototype.componentWillUnmount = function() {
        delete $8c4e0e7eaa58d986$var$_allInstances[this._id];
        if (!this._isInnerZone) {
            $8c4e0e7eaa58d986$var$_outerZones.delete(this);
            this._root.current && this._root.current.removeEventListener("keydown", FocusZone._onKeyDownCapture, true);
        }
        if (this._root.current) this._root.current.removeEventListener("blur", this._onBlur, true);
        this._activeElement = null;
        this._defaultFocusElement = null;
    };
    FocusZone.prototype.render = function() {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        var _a = this.props, tag = _a.as, elementType = _a.elementType, rootProps = _a.rootProps, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className;
        var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
        var Tag = tag || elementType || "div";
        // Note, right before rendering/reconciling proceeds, we need to record if focus
        // was in the zone before the update. This helper will track this and, if focus
        // was actually in the zone, what the index path to the element is at this time.
        // Then, later in componentDidUpdate, we can evaluate if we need to restore it in
        // the case the element was removed.
        this._evaluateFocusBeforeRender();
        // Only support RTL defined in global theme, not contextual theme/RTL.
        var theme = (0, $756f0943cb677ee4$export$89cbf1a0881c8b9c)();
        return $acw62.createElement(Tag, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy
        }, divProps, rootProps, {
            // Once the getClassName correctly memoizes inputs this should
            // be replaced so that className is passed to getRootClass and is included there so
            // the class names will always be in the same order.
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)($8c4e0e7eaa58d986$var$getRootClass(), className),
            // eslint-disable-next-line deprecation/deprecation
            ref: this._mergedRef(this.props.elementRef, this._root),
            "data-focuszone-id": this._id,
            // eslint-disable-next-line react/jsx-no-bind
            onKeyDown: function(ev) {
                return _this._onKeyDown(ev, theme);
            },
            onFocus: this._onFocus,
            onMouseDownCapture: this._onMouseDown
        }), this.props.children);
    };
    /**
     * Sets focus to the first tabbable item in the zone.
     * @param forceIntoFirstElement - If true, focus will be forced into the first element, even
     * if focus is already in the focus zone.
     * @param bypassHiddenElements - If true, focus will be not be set on hidden elements.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focus = function(forceIntoFirstElement, bypassHiddenElements) {
        if (forceIntoFirstElement === void 0) forceIntoFirstElement = false;
        if (bypassHiddenElements === void 0) bypassHiddenElements = false;
        if (this._root.current) {
            if (!forceIntoFirstElement && this._root.current.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === "true" && this._isInnerZone) {
                var ownerZoneElement = this._getOwnerZone(this._root.current);
                if (ownerZoneElement !== this._root.current) {
                    var ownerZone = $8c4e0e7eaa58d986$var$_allInstances[ownerZoneElement.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
                    return !!ownerZone && ownerZone.focusElement(this._root.current);
                }
                return false;
            } else if (!forceIntoFirstElement && this._activeElement && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._activeElement) && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(this._activeElement) && (!bypassHiddenElements || (0, $94bdc1ebed789608$export$5d127f54530ed28b)(this._activeElement))) {
                this._activeElement.focus();
                return true;
            } else {
                var firstChild = this._root.current.firstChild;
                return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, firstChild, true, undefined, undefined, undefined, undefined, undefined, bypassHiddenElements));
            }
        }
        return false;
    };
    /**
     * Sets focus to the last tabbable item in the zone.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focusLast = function() {
        if (this._root.current) {
            var lastChild = this._root.current && this._root.current.lastChild;
            return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, lastChild, true, true, true));
        }
        return false;
    };
    /**
     * Sets focus to a specific child element within the zone. This can be used in conjunction with
     * shouldReceiveFocus to create delayed focus scenarios (like animate the scroll position to the correct
     * location and then focus.)
     * @param element - The child element within the zone to focus.
     * @param forceAlignment - If true, focus alignment will be set according to the element provided.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focusElement = function(element, forceAlignment) {
        // eslint-disable-next-line deprecation/deprecation
        var _a = this.props, onBeforeFocus = _a.onBeforeFocus, shouldReceiveFocus = _a.shouldReceiveFocus;
        if (shouldReceiveFocus && !shouldReceiveFocus(element) || onBeforeFocus && !onBeforeFocus(element)) return false;
        if (element) {
            // when we set focus to a specific child, we should recalculate the alignment depending on its position.
            this._setActiveElement(element, forceAlignment);
            if (this._activeElement) this._activeElement.focus();
            return true;
        }
        return false;
    };
    /**
     * Forces horizontal alignment in the context of vertical arrowing to use specific point as the reference,
     * rather than a center based on the last horizontal motion.
     * @param point - the new reference point.
     */ FocusZone.prototype.setFocusAlignment = function(point) {
        this._focusAlignment = point;
    };
    Object.defineProperty(FocusZone.prototype, "defaultFocusElement", {
        get: function() {
            return this._defaultFocusElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusZone.prototype, "activeElement", {
        get: function() {
            return this._activeElement;
        },
        enumerable: false,
        configurable: true
    });
    FocusZone.prototype._evaluateFocusBeforeRender = function() {
        var root = this._root.current;
        var doc = this._getDocument();
        if (doc) {
            var focusedElement = doc.activeElement;
            // Only update the index path if we are not parked on the root.
            if (focusedElement !== root) {
                var shouldRestoreFocus = (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root, focusedElement, false);
                this._lastIndexPath = shouldRestoreFocus ? (0, $94bdc1ebed789608$export$fe29704f84b976d2)(root, focusedElement) : undefined;
            }
        }
    };
    /**
     * When focus is in the zone at render time but then all focusable elements are removed,
     * we "park" focus temporarily on the root. Once we update with focusable children, we restore
     * focus to the closest path from previous. If the user tabs away from the parked container,
     * we restore focusability to the pre-parked state.
     */ FocusZone.prototype._setParkedFocus = function(isParked) {
        var root = this._root.current;
        if (root && this._isParked !== isParked) {
            this._isParked = isParked;
            if (isParked) {
                if (!this.props.allowFocusRoot) {
                    this._parkedTabIndex = root.getAttribute("tabindex");
                    root.setAttribute("tabindex", "-1");
                }
                root.focus();
            } else if (!this.props.allowFocusRoot) {
                if (this._parkedTabIndex) {
                    root.setAttribute("tabindex", this._parkedTabIndex);
                    this._parkedTabIndex = undefined;
                } else root.removeAttribute("tabindex");
            }
        }
    };
    FocusZone.prototype._setActiveElement = function(element, forceAlignment) {
        var previousActiveElement = this._activeElement;
        this._activeElement = element;
        if (previousActiveElement) {
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(previousActiveElement)) this._updateTabIndexes(previousActiveElement);
            previousActiveElement.tabIndex = -1;
        }
        if (this._activeElement) {
            if (!this._focusAlignment || forceAlignment) this._setFocusAlignment(element, true, true);
            this._activeElement.tabIndex = 0;
        }
    };
    FocusZone.prototype._preventDefaultWhenHandled = function(ev) {
        this.props.preventDefaultWhenHandled && ev.preventDefault();
    };
    /**
     * Walk up the dom try to find a focusable element.
     */ FocusZone.prototype._tryInvokeClickForFocusable = function(targetElement, ev) {
        var target = targetElement;
        if (target === this._root.current) return false;
        do {
            if (target.tagName === "BUTTON" || target.tagName === "A" || target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SUMMARY") return false;
            if (this._isImmediateDescendantOfZone(target) && target.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === "true" && target.getAttribute($8c4e0e7eaa58d986$var$IS_ENTER_DISABLED_ATTRIBUTE) !== "true") {
                $8c4e0e7eaa58d986$var$raiseClickFromKeyboardEvent(target, ev);
                return true;
            }
            target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        }while (target !== this._root.current);
        return false;
    };
    /**
     * Traverse to find first child zone.
     */ FocusZone.prototype._getFirstInnerZone = function(rootElement) {
        rootElement = rootElement || this._activeElement || this._root.current;
        if (!rootElement) return null;
        if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(rootElement)) return $8c4e0e7eaa58d986$var$_allInstances[rootElement.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
        var child = rootElement.firstElementChild;
        while(child){
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(child)) return $8c4e0e7eaa58d986$var$_allInstances[child.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
            var match = this._getFirstInnerZone(child);
            if (match) return match;
            child = child.nextElementSibling;
        }
        return null;
    };
    FocusZone.prototype._moveFocus = function(isForward, // eslint-disable-next-line deprecation/deprecation
    getDistanceFromCenter, ev, useDefaultWrap) {
        if (useDefaultWrap === void 0) useDefaultWrap = true;
        var element = this._activeElement;
        var candidateDistance = -1;
        var candidateElement = undefined;
        var changedFocus = false;
        var isBidirectional = this.props.direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional;
        if (!element || !this._root.current) return false;
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) return false;
        }
        var activeRect = isBidirectional ? element.getBoundingClientRect() : null;
        do {
            element = isForward ? (0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, element) : (0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, element);
            if (isBidirectional) {
                if (element) {
                    var targetRect = element.getBoundingClientRect();
                    // eslint-disable-next-line deprecation/deprecation
                    var elementDistance = getDistanceFromCenter(activeRect, targetRect);
                    if (elementDistance === -1 && candidateDistance === -1) {
                        candidateElement = element;
                        break;
                    }
                    if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                    if (candidateDistance >= 0 && elementDistance < 0) break;
                }
            } else {
                candidateElement = element;
                break;
            }
        }while (element);
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
        } else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, this._root.current.firstElementChild, true));
            else return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
        return changedFocus;
    };
    FocusZone.prototype._moveFocusDown = function() {
        var _this = this;
        var targetTop = -1;
        // eslint-disable-next-line deprecation/deprecation
        var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
        if (// eslint-disable-next-line deprecation/deprecation
        this._moveFocus(true, function(activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            if (targetRectTop < activeRectBottom) {
                if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
            }
            if (targetTop === -1 && targetRectTop >= activeRectBottom || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) distance = 0;
                else distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusUp = function() {
        var _this = this;
        var targetTop = -1;
        // eslint-disable-next-line deprecation/deprecation
        var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
        if (// eslint-disable-next-line deprecation/deprecation
        this._moveFocus(false, function(activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectBottom = Math.floor(targetRect.bottom);
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectTop = Math.floor(activeRect.top);
            if (targetRectBottom > activeRectTop) {
                if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
            }
            if (targetTop === -1 && targetRectBottom <= activeRectTop || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) distance = 0;
                else distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusLeft = function(theme) {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP);
        if (this._moveFocus((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme), // eslint-disable-next-line deprecation/deprecation
        function(activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if ((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)) // When in RTL, this comparison should be the same as the one in _moveFocusRight for LTR.
            // Going left at a leftmost rectangle will go down a line instead of up a line like in LTR.
            // This is important, because we want to be comparing the top of the target rect
            // with the bottom of the active rect.
            topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
            else topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
            if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) distance = activeRect.right - targetRect.right;
            else if (!shouldWrap) distance = $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return distance;
        }, undefined /*ev*/ , shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusRight = function(theme) {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP);
        if (this._moveFocus(!(0, $723d0744d8fe4fde$export$b2303637e9533380)(theme), // eslint-disable-next-line deprecation/deprecation
        function(activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if ((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)) // When in RTL, this comparison should be the same as the one in _moveFocusLeft for LTR.
            // Going right at a rightmost rectangle will go up a line instead of down a line like in LTR.
            // This is important, because we want to be comparing the bottom of the target rect
            // with the top of the active rect.
            topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
            else topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
            if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) distance = targetRect.left - activeRect.left;
            else if (!shouldWrap) distance = $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return distance;
        }, undefined /*ev*/ , shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusPaging = function(isForward, useDefaultWrap) {
        if (useDefaultWrap === void 0) useDefaultWrap = true;
        var element = this._activeElement;
        if (!element || !this._root.current) return false;
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) return false;
        }
        var scrollableParent = (0, $11f97b2a9a127629$export$494fa69500a5872a)(element);
        if (!scrollableParent) return false;
        var candidateDistance = -1;
        var candidateElement = undefined;
        var targetTop = -1;
        var targetBottom = -1;
        var pagesize = scrollableParent.clientHeight;
        var activeRect = element.getBoundingClientRect();
        do {
            element = isForward ? (0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, element) : (0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, element);
            if (element) {
                var targetRect = element.getBoundingClientRect();
                var targetRectTop = Math.floor(targetRect.top);
                var activeRectBottom = Math.floor(activeRect.bottom);
                var targetRectBottom = Math.floor(targetRect.bottom);
                var activeRectTop = Math.floor(activeRect.top);
                var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);
                var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
                var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;
                if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) break;
                if (elementDistance > -1) {
                    // for paging down
                    if (isForward && targetRectTop > targetTop) {
                        targetTop = targetRectTop;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    } else if (!isForward && targetRectBottom < targetBottom) {
                        // for paging up
                        targetBottom = targetRectBottom;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    } else if (candidateDistance === -1 || elementDistance <= candidateDistance) {
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                }
            }
        }while (element);
        var changedFocus = false;
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
            this._setFocusAlignment(candidateElement, false, true);
        } else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, this._root.current.firstElementChild, true));
            return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
        return changedFocus;
    };
    FocusZone.prototype._setFocusAlignment = function(element, isHorizontal, isVertical) {
        if (this.props.direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
            var rect = element.getBoundingClientRect();
            var left = rect.left + rect.width / 2;
            var top_1 = rect.top + rect.height / 2;
            if (!this._focusAlignment) this._focusAlignment = {
                left: left,
                top: top_1
            };
            if (isHorizontal) this._focusAlignment.left = left;
            if (isVertical) this._focusAlignment.top = top_1;
        }
    };
    FocusZone.prototype._isImmediateDescendantOfZone = function(element) {
        return this._getOwnerZone(element) === this._root.current;
    };
    FocusZone.prototype._getOwnerZone = function(element) {
        var parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        while(parentElement && parentElement !== this._root.current && parentElement !== this._getDocument().body){
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(parentElement)) return parentElement;
            parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        }
        return parentElement;
    };
    FocusZone.prototype._updateTabIndexes = function(element) {
        if (!this._activeElement && this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === "function") this._activeElement = this.props.defaultTabbableElement(this._root.current);
        if (!element && this._root.current) {
            this._defaultFocusElement = null;
            element = this._root.current;
            if (this._activeElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(element, this._activeElement)) this._activeElement = null;
        }
        // If active element changes state to disabled, set it to null.
        // Otherwise, we lose keyboard accessibility to other elements in focus zone.
        if (this._activeElement && !(0, $94bdc1ebed789608$export$5d5979bf640d1558)(this._activeElement)) this._activeElement = null;
        var childNodes = element && element.children;
        for(var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++){
            var child = childNodes[childIndex];
            if (!(0, $94bdc1ebed789608$export$1b55aa98f48e3915)(child)) {
                // If the item is explicitly set to not be focusable then TABINDEX needs to be set to -1.
                if (child.getAttribute && child.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === "false") child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "-1");
                if ((0, $94bdc1ebed789608$export$5d5979bf640d1558)(child)) {
                    if (this.props.disabled) child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "-1");
                    else if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
                        this._defaultFocusElement = child;
                        if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== "0") child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "0");
                    } else if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== "-1") child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "-1");
                } else if (child.tagName === "svg" && child.getAttribute("focusable") !== "false") // Disgusting IE hack. Sad face.
                child.setAttribute("focusable", "false");
            } else if (child.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === "true") {
                if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
                    this._defaultFocusElement = child;
                    if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== "0") child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "0");
                } else if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== "-1") child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, "-1");
            }
            this._updateTabIndexes(child);
        }
    };
    FocusZone.prototype._isContentEditableElement = function(element) {
        return element && element.getAttribute("contenteditable") === "true";
    };
    FocusZone.prototype._isElementInput = function(element) {
        if (element && element.tagName && (element.tagName.toLowerCase() === "input" || element.tagName.toLowerCase() === "textarea")) return true;
        return false;
    };
    FocusZone.prototype._shouldInputLoseFocus = function(element, isForward) {
        // If a tab was used, we want to focus on the next element.
        if (!this._processingTabKey && element && element.type && $8c4e0e7eaa58d986$var$ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
            var selectionStart = element.selectionStart;
            var selectionEnd = element.selectionEnd;
            var isRangeSelected = selectionStart !== selectionEnd;
            var inputValue = element.value;
            var isReadonly = element.readOnly;
            // We shouldn't lose focus in the following cases:
            // 1. There is range selected.
            // 2. When selection start is larger than 0 and it is backward and not readOnly.
            // 3. when selection start is not the end of length, it is forward and not readOnly.
            // 4. We press any of the arrow keys when our handleTabKey isn't none or undefined (only losing focus if we hit
            // tab) and if shouldInputLoseFocusOnArrowKey is defined, if scenario prefers to not loose the focus which is
            // determined by calling the callback shouldInputLoseFocusOnArrowKey
            if (isRangeSelected || selectionStart > 0 && !isForward && !isReadonly || selectionStart !== inputValue.length && isForward && !isReadonly || !!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element))) return false;
        }
        return true;
    };
    FocusZone.prototype._shouldWrapFocus = function(element, noWrapDataAttribute) {
        return this.props.checkForNoWrap ? (0, $94bdc1ebed789608$export$841acbea7fb3b182)(element, noWrapDataAttribute) : true;
    };
    /**
     * Returns true if the element is a descendant of the FocusZone through a React portal.
     */ FocusZone.prototype._portalContainsElement = function(element) {
        return element && !!this._root.current && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(element, this._root.current);
    };
    FocusZone.prototype._getDocument = function() {
        return (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(this._root.current);
    };
    FocusZone.defaultProps = {
        isCircularNavigation: false,
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional,
        shouldRaiseClicks: true
    };
    return FocusZone;
}($acw62.Component);



function $f3ff39ec82d473ae$export$36ffd6a0ea64902d(defaultProps, propsWithoutDefaults) {
    var props = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, propsWithoutDefaults);
    for(var _i = 0, _a = Object.keys(defaultProps); _i < _a.length; _i++){
        var key = _a[_i];
        if (props[key] === undefined) props[key] = defaultProps[key];
    }
    return props;
}

/**
 * Returns true if and only if the user is on a iOS device.
 * Used to determine whether iOS-specific behavior should be applied.
 */ var $865faf0b4151a9c6$export$fedb369cb70207f1 = function() {
    if (!window || !window.navigator || !window.navigator.userAgent) return false;
    return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
};


var $46def017ce9f8d16$var$isMacResult;
function $46def017ce9f8d16$export$9ac100e40613ea10(reset) {
    var _a;
    if (typeof $46def017ce9f8d16$var$isMacResult === "undefined" || reset) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        // In certain SSR frameworks, `window` will be defined even on the server but `navigator` will be undefined
        var userAgent = (_a = win === null || win === void 0 ? void 0 : win.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
        $46def017ce9f8d16$var$isMacResult = !!userAgent && userAgent.indexOf("Macintosh") !== -1;
    }
    return !!$46def017ce9f8d16$var$isMacResult;
}


/**
 * Determines the effective checked state of a menu item.
 *
 * @param item {IContextualMenuItem} to get the check state of.
 * @returns {true} if the item is checked.
 * @returns {false} if the item is unchecked.
 * @returns {null} if the item is not checkable.
 */ function $3250824b6f1d23dc$export$876e33b6ab5c0eaa(item) {
    if (item.canCheck) return !!(item.isChecked || item.checked);
    if (typeof item.isChecked === "boolean") return item.isChecked;
    if (typeof item.checked === "boolean") return item.checked;
    // Item is not checkable.
    return null;
}
function $3250824b6f1d23dc$export$bb9ab0e82942591e(item) {
    // eslint-disable-next-line deprecation/deprecation
    return !!(item.subMenuProps || item.items);
}
function $3250824b6f1d23dc$export$98e832630d6cf989(item) {
    return !!(item.isDisabled || item.disabled);
}
function $3250824b6f1d23dc$export$84bfff8e7c9de691(item) {
    var isChecked = $3250824b6f1d23dc$export$876e33b6ab5c0eaa(item);
    var canCheck = isChecked !== null;
    return canCheck ? "menuitemcheckbox" : "menuitem";
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $18e32c5a70ef0416$export$af631764ddc44097(element, eventName, callback, options) {
    element.addEventListener(eventName, callback, options);
    return function() {
        return element.removeEventListener(eventName, callback, options);
    };
}




/**
 * Rectangle helper class.
 *
 * @public
 * {@docCategory Rectangle}
 */ var $e6e58afbc62ca69b$export$4617fb02663045ef = /** @class */ function() {
    function Rectangle(left, right, top, bottom) {
        if (left === void 0) left = 0;
        if (right === void 0) right = 0;
        if (top === void 0) top = 0;
        if (bottom === void 0) bottom = 0;
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    Object.defineProperty(Rectangle.prototype, "width", {
        /**
         * Calculated automatically by subtracting the right from left
         */ get: function() {
            return this.right - this.left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "height", {
        /**
         * Calculated automatically by subtracting the bottom from top.
         */ get: function() {
            return this.bottom - this.top;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Tests if another rect is approximately equal to this rect (within 4 decimal places.)
     */ Rectangle.prototype.equals = function(rect) {
        // Fixing to 4 decimal places because it allows enough precision and will handle cases when something
        // should be rounded, like .999999 should round to 1.
        return parseFloat(this.top.toFixed(4)) === parseFloat(rect.top.toFixed(4)) && parseFloat(this.bottom.toFixed(4)) === parseFloat(rect.bottom.toFixed(4)) && parseFloat(this.left.toFixed(4)) === parseFloat(rect.left.toFixed(4)) && parseFloat(this.right.toFixed(4)) === parseFloat(rect.right.toFixed(4));
    };
    return Rectangle;
}();


var $915a71a5da79ffac$export$a121ec89eaa4231a;
(function(RectangleEdge) {
    RectangleEdge[RectangleEdge["top"] = 1] = "top";
    RectangleEdge[RectangleEdge["bottom"] = -1] = "bottom";
    RectangleEdge[RectangleEdge["left"] = 2] = "left";
    RectangleEdge[RectangleEdge["right"] = -2] = "right";
})($915a71a5da79ffac$export$a121ec89eaa4231a || ($915a71a5da79ffac$export$a121ec89eaa4231a = {}));
var $915a71a5da79ffac$export$13807d9ee5a34a42;
(function(Position) {
    Position[Position["top"] = 0] = "top";
    Position[Position["bottom"] = 1] = "bottom";
    Position[Position["start"] = 2] = "start";
    Position[Position["end"] = 3] = "end";
})($915a71a5da79ffac$export$13807d9ee5a34a42 || ($915a71a5da79ffac$export$13807d9ee5a34a42 = {}));


var $ce88cd5257e3ce57$var$_a;
function $ce88cd5257e3ce57$var$_createPositionData(targetEdge, alignmentEdge, isAuto) {
    return {
        targetEdge: targetEdge,
        alignmentEdge: alignmentEdge,
        isAuto: isAuto
    };
}
// Currently the beakPercent is set to 50 for all positions meaning that it should tend to the center of the target
var $ce88cd5257e3ce57$var$DirectionalDictionary = ($ce88cd5257e3ce57$var$_a = {}, $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topLeftEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topRightEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topAutoEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, undefined, true), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomLeftEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomRightEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, undefined, true), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftTopEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftBottomEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightTopEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightBottomEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a);
function $ce88cd5257e3ce57$var$_isRectangleWithinBounds(rect, boundingRect) {
    if (rect.top < boundingRect.top) return false;
    if (rect.bottom > boundingRect.bottom) return false;
    if (rect.left < boundingRect.left) return false;
    if (rect.right > boundingRect.right) return false;
    return true;
}
/**
 * Gets all of the edges of a rectangle that are outside of the given bounds.
 * If there are no out of bounds edges it returns an empty array.
 */ function $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(rect, boundingRect) {
    var outOfBounds = [];
    if (rect.top < boundingRect.top) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top);
    if (rect.bottom > boundingRect.bottom) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom);
    if (rect.left < boundingRect.left) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left);
    if (rect.right > boundingRect.right) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right);
    return outOfBounds;
}
function $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) {
    return rect[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[edge]];
}
function $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge, value) {
    rect[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[edge]] = value;
    return rect;
}
/**
 * Returns the middle value of an edge. Only returns 1 value rather than xy coordinates as
 * the itself already contains the other coordinate.
 * For instance, a bottom edge's current value is it's y coordinate, so the number returned is the x.
 */ function $ce88cd5257e3ce57$var$_getCenterValue(rect, edge) {
    var edges = $ce88cd5257e3ce57$var$_getFlankingEdges(edge);
    return ($ce88cd5257e3ce57$var$_getEdgeValue(rect, edges.positiveEdge) + $ce88cd5257e3ce57$var$_getEdgeValue(rect, edges.negativeEdge)) / 2;
}
/**
 * Flips the value depending on the edge.
 * If the edge is a "positive" edge, Top or Left, then the value should stay as it is.
 * If the edge is a "negative" edge, Bottom or Right, then the value should be flipped.
 * This is to account for the fact that the coordinates are effectively reserved in certain cases for the
 * "negative" edges.
 *
 * For example, when testing to see if a bottom edge 1 is within the bounds of another bottom edge 2:
 * If edge 1 is greater than edge 2 then it is out of bounds. This is reversed for top edge 1 and top edge 2.
 * If top edge 1 is less than edge 2 then it is out of bounds.
 */ function $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, value) {
    if (edge > 0) return value;
    else return value * -1;
}
function $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, rect) {
    return $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge));
}
function $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(rect, hostRect, edge) {
    var edgeDifference = $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) - $ce88cd5257e3ce57$var$_getEdgeValue(hostRect, edge);
    return $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, edgeDifference);
}
/**
 * Moves the edge of a rectangle to the value given. It only moves the edge in a linear direction based on that edge.
 * For example, if it's a bottom edge it will only change y coordinates.
 * if maintainSize is set to false, it will only adjust the specified edge value
 */ function $ce88cd5257e3ce57$var$_moveEdge(rect, edge, newValue, maintainSize) {
    if (maintainSize === void 0) maintainSize = true;
    var difference = $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) - newValue;
    var returnRect = $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge, newValue);
    if (maintainSize) returnRect = $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge * -1, $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge * -1) - difference);
    return returnRect;
}
/**
 * Aligns the edge on the passed in rect to the target. If there is a gap then it will have that space between the two.
 */ function $ce88cd5257e3ce57$var$_alignEdges(rect, target, edge, gap) {
    if (gap === void 0) gap = 0;
    return $ce88cd5257e3ce57$var$_moveEdge(rect, edge, $ce88cd5257e3ce57$var$_getEdgeValue(target, edge) + $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, gap));
}
/**
 * Aligns the targetEdge on the passed in target to the rects corresponding opposite edge.
 * For instance if targetEdge is bottom, then the rects top will be moved to match it.
 */ function $ce88cd5257e3ce57$var$_alignOppositeEdges(rect, target, targetEdge, gap) {
    if (gap === void 0) gap = 0;
    var oppositeEdge = targetEdge * -1;
    var adjustedGap = $ce88cd5257e3ce57$var$_getRelativeEdgeValue(oppositeEdge, gap);
    return $ce88cd5257e3ce57$var$_moveEdge(rect, targetEdge * -1, $ce88cd5257e3ce57$var$_getEdgeValue(target, targetEdge) + adjustedGap);
}
/**
 * Tests to see if the given edge is within the bounds of the given rectangle.
 */ function $ce88cd5257e3ce57$var$_isEdgeInBounds(rect, bounds, edge) {
    var adjustedRectValue = $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, rect);
    return adjustedRectValue > $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, bounds);
}
/**
 * Returns a measure of how much a rectangle is out of bounds for a given alignment;
 * this can be used to compare which rectangle is more or less out of bounds.
 * A value of 0 means the rectangle is entirely in bounds
 */ function $ce88cd5257e3ce57$var$_getOutOfBoundsDegree(rect, bounds) {
    var breakingEdges = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(rect, bounds);
    var total = 0;
    for(var _i = 0, breakingEdges_1 = breakingEdges; _i < breakingEdges_1.length; _i++){
        var edge = breakingEdges_1[_i];
        total += Math.pow($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(rect, bounds, edge), 2);
    }
    return total;
}
/**
 * Attempts to move the rectangle through various sides of the target to find a place to fit.
 * If no fit is found, the least bad option should be returned.
 */ function $ce88cd5257e3ce57$var$_flipToFit(rect, target, bounding, positionData, gap) {
    if (gap === void 0) gap = 0;
    var directions = [
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top
    ];
    // In RTL page, RectangleEdge.right has a higher priority than RectangleEdge.left, so the order should be updated.
    if ((0, $723d0744d8fe4fde$export$b2303637e9533380)()) {
        directions[0] *= -1;
        directions[1] *= -1;
    }
    var currentEstimate = rect;
    var currentEdge = positionData.targetEdge;
    var currentAlignment = positionData.alignmentEdge;
    // keep track of least bad option, in case no sides fit
    var oobDegree;
    var bestEdge = currentEdge;
    var bestAlignment = currentAlignment;
    // Keep switching sides until one is found with enough space.
    // If all sides don't fit then return the unmodified element.
    for(var i = 0; i < 4; i++){
        if (!$ce88cd5257e3ce57$var$_isEdgeInBounds(currentEstimate, bounding, currentEdge)) {
            // update least-bad edges
            var currentOOBDegree = $ce88cd5257e3ce57$var$_getOutOfBoundsDegree(currentEstimate, bounding);
            if (!oobDegree || currentOOBDegree < oobDegree) {
                oobDegree = currentOOBDegree;
                bestEdge = currentEdge;
                bestAlignment = currentAlignment;
            }
            directions.splice(directions.indexOf(currentEdge), 1);
            if (directions.length > 0) {
                if (directions.indexOf(currentEdge * -1) > -1) currentEdge = currentEdge * -1;
                else {
                    currentAlignment = currentEdge;
                    currentEdge = directions.slice(-1)[0];
                }
                currentEstimate = $ce88cd5257e3ce57$var$_estimatePosition(rect, target, {
                    targetEdge: currentEdge,
                    alignmentEdge: currentAlignment
                }, gap);
            }
        } else return {
            elementRectangle: currentEstimate,
            targetEdge: currentEdge,
            alignmentEdge: currentAlignment
        };
    }
    // nothing fits, use least-bad option
    currentEstimate = $ce88cd5257e3ce57$var$_estimatePosition(rect, target, {
        targetEdge: bestEdge,
        alignmentEdge: bestAlignment
    }, gap);
    return {
        elementRectangle: currentEstimate,
        targetEdge: bestEdge,
        alignmentEdge: bestAlignment
    };
}
/**
 * Flips only the alignment edge of an element rectangle. This is used instead of nudging the alignment edges
 * into position, when `alignTargetEdge` is specified.
 */ function $ce88cd5257e3ce57$var$_flipAlignmentEdge(elementEstimate, target, gap, coverTarget) {
    var alignmentEdge = elementEstimate.alignmentEdge, targetEdge = elementEstimate.targetEdge, elementRectangle = elementEstimate.elementRectangle;
    var oppositeEdge = alignmentEdge * -1;
    var newEstimate = $ce88cd5257e3ce57$var$_estimatePosition(elementRectangle, target, {
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge
    }, gap, coverTarget);
    return {
        elementRectangle: newEstimate,
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge
    };
}
/**
 * Adjusts a element rectangle to fit within the bounds given. If directionalHintFixed or covertarget is passed in
 * then the element will not flip sides on the target. They will, however, be nudged to fit within the bounds given.
 */ function $ce88cd5257e3ce57$var$_adjustFitWithinBounds(element, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
    if (gap === void 0) gap = 0;
    var alignmentEdge = positionData.alignmentEdge, alignTargetEdge = positionData.alignTargetEdge;
    var elementEstimate = {
        elementRectangle: element,
        targetEdge: positionData.targetEdge,
        alignmentEdge: alignmentEdge
    };
    if (!directionalHintFixed && !coverTarget) elementEstimate = $ce88cd5257e3ce57$var$_flipToFit(element, target, bounding, positionData, gap);
    var outOfBounds = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(elementEstimate.elementRectangle, bounding);
    // if directionalHintFixed is specified, we need to force the target edge to not change
    // we need *-1 because targetEdge refers to the target's edge; the callout edge is the opposite
    var fixedEdge = directionalHintFixed ? -elementEstimate.targetEdge : undefined;
    if (outOfBounds.length > 0) {
        if (alignTargetEdge) {
            // The edge opposite to the alignment edge might be out of bounds.
            // Flip alignment to see if we can get it within bounds.
            if (elementEstimate.alignmentEdge && outOfBounds.indexOf(elementEstimate.alignmentEdge * -1) > -1) {
                var flippedElementEstimate = $ce88cd5257e3ce57$var$_flipAlignmentEdge(elementEstimate, target, gap, coverTarget);
                if ($ce88cd5257e3ce57$var$_isRectangleWithinBounds(flippedElementEstimate.elementRectangle, bounding)) return flippedElementEstimate;
                else // If the flipped elements edges are still out of bounds, try nudging it.
                elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges($ce88cd5257e3ce57$var$_getOutOfBoundsEdges(flippedElementEstimate.elementRectangle, bounding), elementEstimate, bounding, fixedEdge);
            } else elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
        } else elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
    }
    return elementEstimate;
}
/**
 * Iterates through a list of out of bounds edges and tries to nudge and align them.
 * @param outOfBoundsEdges - Array of edges that are out of bounds
 * @param elementEstimate - The current element positioning estimate
 * @param bounding - The current bounds
 * @param preserveEdge - Specify an edge that should not be modified
 */ function $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBoundsEdges, elementEstimate, bounding, preserveEdge) {
    for(var _i = 0, outOfBoundsEdges_1 = outOfBoundsEdges; _i < outOfBoundsEdges_1.length; _i++){
        var direction = outOfBoundsEdges_1[_i];
        var edgeAttempt = void 0;
        // if preserveEdge is specified, do not call _alignEdges, skip directly to _moveEdge
        // this is because _alignEdges will move the opposite edge
        if (preserveEdge && preserveEdge === direction * -1) {
            edgeAttempt = $ce88cd5257e3ce57$var$_moveEdge(elementEstimate.elementRectangle, direction, $ce88cd5257e3ce57$var$_getEdgeValue(bounding, direction), false);
            elementEstimate.forcedInBounds = true;
        } else {
            edgeAttempt = $ce88cd5257e3ce57$var$_alignEdges(elementEstimate.elementRectangle, bounding, direction);
            var inBounds = $ce88cd5257e3ce57$var$_isEdgeInBounds(edgeAttempt, bounding, direction * -1);
            // only update estimate if the attempt didn't break out of the opposite bounding edge
            if (!inBounds) {
                edgeAttempt = $ce88cd5257e3ce57$var$_moveEdge(edgeAttempt, direction * -1, $ce88cd5257e3ce57$var$_getEdgeValue(bounding, direction * -1), false);
                elementEstimate.forcedInBounds = true;
            }
        }
        elementEstimate.elementRectangle = edgeAttempt;
    }
    return elementEstimate;
}
/**
 * Moves the middle point on an edge to the point given.
 * Only moves in one direction. For instance if a bottom edge is passed in, then
 * the bottom edge will be moved in the x axis to match the point.
 */ function $ce88cd5257e3ce57$var$_centerEdgeToPoint(rect, edge, point) {
    var positiveEdge = $ce88cd5257e3ce57$var$_getFlankingEdges(edge).positiveEdge;
    var elementMiddle = $ce88cd5257e3ce57$var$_getCenterValue(rect, edge);
    var distanceToMiddle = elementMiddle - $ce88cd5257e3ce57$var$_getEdgeValue(rect, positiveEdge);
    return $ce88cd5257e3ce57$var$_moveEdge(rect, positiveEdge, point - distanceToMiddle);
}
/**
 * Moves the element rectangle to be appropriately positioned relative to a given target.
 * Does not flip or adjust the element.
 */ function $ce88cd5257e3ce57$var$_estimatePosition(elementToPosition, target, positionData, gap, coverTarget) {
    if (gap === void 0) gap = 0;
    var estimatedElementPosition = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(elementToPosition.left, elementToPosition.right, elementToPosition.top, elementToPosition.bottom);
    var alignmentEdge = positionData.alignmentEdge, targetEdge = positionData.targetEdge;
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    estimatedElementPosition = coverTarget ? $ce88cd5257e3ce57$var$_alignEdges(estimatedElementPosition, target, targetEdge, gap) : $ce88cd5257e3ce57$var$_alignOppositeEdges(estimatedElementPosition, target, targetEdge, gap);
    // if no alignment edge is provided it's supposed to be centered.
    if (!alignmentEdge) {
        var targetMiddlePoint = $ce88cd5257e3ce57$var$_getCenterValue(target, targetEdge);
        estimatedElementPosition = $ce88cd5257e3ce57$var$_centerEdgeToPoint(estimatedElementPosition, elementEdge, targetMiddlePoint);
    } else estimatedElementPosition = $ce88cd5257e3ce57$var$_alignEdges(estimatedElementPosition, target, alignmentEdge);
    return estimatedElementPosition;
}
/**
 * Returns the non-opposite edges of the target edge.
 * For instance if bottom is passed in then left and right will be returned.
 */ function $ce88cd5257e3ce57$var$_getFlankingEdges(edge) {
    if (edge === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top || edge === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom) return {
        positiveEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left,
        negativeEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right
    };
    else return {
        positiveEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top,
        negativeEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom
    };
}
/**
 * Retrieve the final value for the return edge of `elementRectangle`. If the `elementRectangle` is closer to one side
 * of the bounds versus the other, the return edge is flipped to grow inward.
 */ function $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementRectangle, returnEdge, bounds) {
    if (bounds && Math.abs($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge)) > Math.abs($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge * -1))) return returnEdge * -1;
    return returnEdge;
}
/**
 * Whether or not the considered edge of the elementRectangle is lying on the edge of the bounds
 * @param elementRectangle The rectangle whose edge we are considering
 * @param bounds The rectangle marking the bounds
 * @param edge The target edge we're considering
 * @returns If the target edge of the elementRectangle is in the same location as that edge of the bounds
 */ function $ce88cd5257e3ce57$var$_isEdgeOnBounds(elementRectangle, edge, bounds) {
    return bounds !== undefined && $ce88cd5257e3ce57$var$_getEdgeValue(elementRectangle, edge) === $ce88cd5257e3ce57$var$_getEdgeValue(bounds, edge);
}
/**
 * Finalizes the element position based on the hostElement. Only returns the
 * rectangle values to position such that they are anchored to the target.
 * This helps prevent resizing from looking very strange.
 * For instance, if the target edge is top and aligned with the left side then
 * the bottom and left values are returned so as the Callout shrinks it shrinks towards that corner.
 */ function $ce88cd5257e3ce57$var$_finalizeElementPosition(elementRectangle, hostElement, targetEdge, bounds, alignmentEdge, coverTarget, doNotFinalizeReturnEdge, forceWithinBounds) {
    var returnValue = {};
    var hostRect = $ce88cd5257e3ce57$var$_getRectangleFromElement(hostElement);
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    var returnEdge = alignmentEdge ? alignmentEdge : $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge).positiveEdge;
    // If we are finalizing the return edge, choose the edge such that we grow away from the bounds
    // If we are not finalizing the return edge but the opposite edge is flush against the bounds,
    // choose that as the anchor edge so the element rect can grow away from the bounds' edge
    // In this case there will not be a visual difference because there is no more room for the elementRectangle to grow
    // in the usual direction
    if (!doNotFinalizeReturnEdge || $ce88cd5257e3ce57$var$_isEdgeOnBounds(elementRectangle, $ce88cd5257e3ce57$export$91aad4f6c09ebbeb(returnEdge), bounds)) returnEdge = $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementRectangle, returnEdge, bounds);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[elementEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge);
    // if the positioned element will still overflow, return all four edges with in-bounds values
    if (forceWithinBounds) {
        returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[elementEdge * -1]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge * -1);
        returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge * -1]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge * -1);
    }
    return returnValue;
}
// Since the beak is rotated 45 degrees the actual height/width is the length of the diagonal.
// We still want to position the beak based on it's midpoint which does not change. It will
// be at (beakwidth / 2, beakwidth / 2)
function $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels(beakWidth) {
    return Math.sqrt(beakWidth * beakWidth * 2);
}
/**
 * Returns the appropriate IPositionData based on the props altered for RTL.
 * If directionalHintForRTL is passed in that is used if the page is RTL.
 * If directionalHint is specified, no directionalHintForRTL is available, and the page is RTL, the hint will be
 * flipped (e.g. bottomLeftEdge would become bottomRightEdge).
 *
 * If there is no directionalHint passed in, bottomAutoEdge is chosen automatically.
 */ function $ce88cd5257e3ce57$var$_getPositionData(directionalHint, directionalHintForRTL, previousPositions) {
    if (directionalHint === void 0) directionalHint = (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge;
    if (previousPositions) return {
        alignmentEdge: previousPositions.alignmentEdge,
        isAuto: previousPositions.isAuto,
        targetEdge: previousPositions.targetEdge
    };
    var positionInformation = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ce88cd5257e3ce57$var$DirectionalDictionary[directionalHint]);
    if ((0, $723d0744d8fe4fde$export$b2303637e9533380)()) {
        // If alignment edge exists and that alignment edge is -2 or 2, right or left, then flip it.
        if (positionInformation.alignmentEdge && positionInformation.alignmentEdge % 2 === 0) positionInformation.alignmentEdge = positionInformation.alignmentEdge * -1;
        return directionalHintForRTL !== undefined ? $ce88cd5257e3ce57$var$DirectionalDictionary[directionalHintForRTL] : positionInformation;
    }
    return positionInformation;
}
/**
 * Gets the alignment data for the given information. This only really matters if the positioning is Auto.
 * If it is auto then the alignmentEdge should be chosen based on the target edge's position relative to
 * the center of the page.
 */ function $ce88cd5257e3ce57$var$_getAlignmentData(positionData, target, boundingRect, coverTarget, alignTargetEdge) {
    if (positionData.isAuto) positionData.alignmentEdge = $ce88cd5257e3ce57$var$getClosestEdge(positionData.targetEdge, target, boundingRect);
    positionData.alignTargetEdge = alignTargetEdge;
    return positionData;
}
function $ce88cd5257e3ce57$var$getClosestEdge(targetEdge, target, boundingRect) {
    var targetCenter = $ce88cd5257e3ce57$var$_getCenterValue(target, targetEdge);
    var boundingCenter = $ce88cd5257e3ce57$var$_getCenterValue(boundingRect, targetEdge);
    var _a = $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    if (targetCenter <= boundingCenter) return positiveEdge;
    else return negativeEdge;
}
function $ce88cd5257e3ce57$var$_positionElementWithinBounds(elementToPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
    var estimatedElementPosition = $ce88cd5257e3ce57$var$_estimatePosition(elementToPosition, target, positionData, gap, coverTarget);
    if ($ce88cd5257e3ce57$var$_isRectangleWithinBounds(estimatedElementPosition, bounding)) return {
        elementRectangle: estimatedElementPosition,
        targetEdge: positionData.targetEdge,
        alignmentEdge: positionData.alignmentEdge
    };
    else return $ce88cd5257e3ce57$var$_adjustFitWithinBounds(estimatedElementPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget);
}
function $ce88cd5257e3ce57$var$_finalizeBeakPosition(elementPosition, positionedBeak, bounds) {
    var targetEdge = elementPosition.targetEdge * -1;
    // The "host" element that we will use to help position the beak.
    var actualElement = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, elementPosition.elementRectangle.width, 0, elementPosition.elementRectangle.height);
    var returnValue = {};
    var returnEdge = $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementPosition.elementRectangle, elementPosition.alignmentEdge ? elementPosition.alignmentEdge : $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge).positiveEdge, bounds);
    // only show the beak if the callout is not fully covering the target
    var beakEdgeDifference = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementPosition.elementRectangle, elementPosition.targetRectangle, targetEdge);
    var showBeak = beakEdgeDifference > Math.abs($ce88cd5257e3ce57$var$_getEdgeValue(positionedBeak, targetEdge));
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[targetEdge]] = $ce88cd5257e3ce57$var$_getEdgeValue(positionedBeak, targetEdge);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(positionedBeak, actualElement, returnEdge);
    return {
        elementPosition: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, returnValue),
        closestEdge: $ce88cd5257e3ce57$var$getClosestEdge(elementPosition.targetEdge, positionedBeak, actualElement),
        targetEdge: targetEdge,
        hideBeak: !showBeak
    };
}
function $ce88cd5257e3ce57$var$_positionBeak(beakWidth, elementPosition) {
    var target = elementPosition.targetRectangle;
    /**
     * Note about beak positioning: The actual beak width only matters for getting the gap between the callout and
     * target, it does not impact the beak placement within the callout. For example example, if the beakWidth is 8,
     * then the actual beakWidth is sqrroot(8^2 + 8^2) = 11.31x11.31. So the callout will need to be an extra 3 pixels
     * away from its target. While the beak is being positioned in the callout it still acts as though it were 8x8.
     */ var _a = $ce88cd5257e3ce57$var$_getFlankingEdges(elementPosition.targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    var beakTargetPoint = $ce88cd5257e3ce57$var$_getCenterValue(target, elementPosition.targetEdge);
    var elementBounds = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(beakWidth / 2, elementPosition.elementRectangle.width - beakWidth / 2, beakWidth / 2, elementPosition.elementRectangle.height - beakWidth / 2);
    var beakPosition = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, beakWidth, 0, beakWidth);
    beakPosition = $ce88cd5257e3ce57$var$_moveEdge(beakPosition, elementPosition.targetEdge * -1, -beakWidth / 2);
    beakPosition = $ce88cd5257e3ce57$var$_centerEdgeToPoint(beakPosition, elementPosition.targetEdge * -1, beakTargetPoint - $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(positiveEdge, elementPosition.elementRectangle));
    if (!$ce88cd5257e3ce57$var$_isEdgeInBounds(beakPosition, elementBounds, positiveEdge)) beakPosition = $ce88cd5257e3ce57$var$_alignEdges(beakPosition, elementBounds, positiveEdge);
    else if (!$ce88cd5257e3ce57$var$_isEdgeInBounds(beakPosition, elementBounds, negativeEdge)) beakPosition = $ce88cd5257e3ce57$var$_alignEdges(beakPosition, elementBounds, negativeEdge);
    return beakPosition;
}
function $ce88cd5257e3ce57$var$_getRectangleFromElement(element) {
    // eslint-disable-next-line deprecation/deprecation
    var clientRect = element.getBoundingClientRect();
    return new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(clientRect.left, clientRect.right, clientRect.top, clientRect.bottom);
}
function $ce88cd5257e3ce57$var$_getRectangleFromIRect(rect) {
    return new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(rect.left, rect.right, rect.top, rect.bottom);
}
function $ce88cd5257e3ce57$var$_getTargetRect(bounds, target) {
    var targetRectangle;
    if (target) {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!target.preventDefault) {
            var ev = target;
            targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(ev.clientX, ev.clientX, ev.clientY, ev.clientY);
        // eslint-disable-next-line no-extra-boolean-cast
        } else if (!!target.getBoundingClientRect) targetRectangle = $ce88cd5257e3ce57$var$_getRectangleFromElement(target);
        else {
            var rectOrPoint = target;
            // eslint-disable-next-line deprecation/deprecation
            var left = rectOrPoint.left || rectOrPoint.x;
            // eslint-disable-next-line deprecation/deprecation
            var top_1 = rectOrPoint.top || rectOrPoint.y;
            var right = rectOrPoint.right || left;
            var bottom = rectOrPoint.bottom || top_1;
            targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(left, right, top_1, bottom);
        }
        if (!$ce88cd5257e3ce57$var$_isRectangleWithinBounds(targetRectangle, bounds)) {
            var outOfBounds = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(targetRectangle, bounds);
            for(var _i = 0, outOfBounds_1 = outOfBounds; _i < outOfBounds_1.length; _i++){
                var direction = outOfBounds_1[_i];
                targetRectangle[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[direction]] = bounds[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[direction]];
            }
        }
    } else targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, 0, 0, 0);
    return targetRectangle;
}
/**
 * If max height is less than zero it returns the bounds height instead.
 */ function $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle(targetRectangle, targetEdge, gapSpace, bounds, coverTarget) {
    var maxHeight = 0;
    var directionalHint = $ce88cd5257e3ce57$var$DirectionalDictionary[targetEdge];
    // If cover target is set, then the max height should be calculated using the opposite of the target edge since
    // that's the direction that the callout will expand in.
    // For instance, if the directionalhint is bottomLeftEdge then the callout will position so it's bottom edge
    // is aligned with the bottom of the target and expand up towards the top of the screen and the calculated max height
    // is (bottom of target) - (top of screen) - gapSpace.
    var target = coverTarget ? directionalHint.targetEdge * -1 : directionalHint.targetEdge;
    if (target === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top) maxHeight = $ce88cd5257e3ce57$var$_getEdgeValue(targetRectangle, directionalHint.targetEdge) - bounds.top - gapSpace;
    else if (target === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom) maxHeight = bounds.bottom - $ce88cd5257e3ce57$var$_getEdgeValue(targetRectangle, directionalHint.targetEdge) - gapSpace;
    else maxHeight = bounds.bottom - targetRectangle.top - gapSpace;
    return maxHeight > 0 ? maxHeight : bounds.height;
}
function $ce88cd5257e3ce57$var$_positionElementRelative(props, elementToPosition, boundingRect, previousPositions) {
    var gap = props.gapSpace ? props.gapSpace : 0;
    var targetRect = $ce88cd5257e3ce57$var$_getTargetRect(boundingRect, props.target);
    var positionData = $ce88cd5257e3ce57$var$_getAlignmentData($ce88cd5257e3ce57$var$_getPositionData(props.directionalHint, props.directionalHintForRTL, previousPositions), targetRect, boundingRect, props.coverTarget, props.alignTargetEdge);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementWithinBounds($ce88cd5257e3ce57$var$_getRectangleFromElement(elementToPosition), targetRect, boundingRect, positionData, gap, props.directionalHintFixed, props.coverTarget);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, positionedElement), {
        targetRectangle: targetRect
    });
}
function $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, bounds, coverTarget, doNotFinalizeReturnEdge) {
    var finalizedElement = $ce88cd5257e3ce57$var$_finalizeElementPosition(positionedElement.elementRectangle, hostElement, positionedElement.targetEdge, bounds, positionedElement.alignmentEdge, coverTarget, doNotFinalizeReturnEdge, positionedElement.forcedInBounds);
    return {
        elementPosition: finalizedElement,
        targetEdge: positionedElement.targetEdge,
        alignmentEdge: positionedElement.alignmentEdge
    };
}
function $ce88cd5257e3ce57$var$_positionElement(props, hostElement, elementToPosition, previousPositions) {
    var boundingRect = props.bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(props.bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, window.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, window.innerHeight);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementRelative(props, elementToPosition, boundingRect, previousPositions);
    return $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget);
}
function $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, callout, previousPositions, doNotFinalizeReturnEdge) {
    var beakWidth = props.isBeakVisible ? props.beakWidth || 0 : 0;
    var gap = $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels(beakWidth) / 2 + (props.gapSpace ? props.gapSpace : 0);
    var positionProps = props;
    positionProps.gapSpace = gap;
    var boundingRect = props.bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(props.bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, window.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, window.innerHeight);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementRelative(positionProps, callout, boundingRect, previousPositions);
    var beakPositioned = $ce88cd5257e3ce57$var$_positionBeak(beakWidth, positionedElement);
    var finalizedBeakPosition = $ce88cd5257e3ce57$var$_finalizeBeakPosition(positionedElement, beakPositioned, boundingRect);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget, doNotFinalizeReturnEdge)), {
        beakPosition: finalizedBeakPosition
    });
}
function $ce88cd5257e3ce57$var$_positionCard(props, hostElement, callout, previousPositions) {
    return $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, callout, previousPositions, true);
}
var $ce88cd5257e3ce57$export$6d761371ccc85c4 = {
    _finalizePositionData: $ce88cd5257e3ce57$var$_finalizePositionData,
    _finalizeBeakPosition: $ce88cd5257e3ce57$var$_finalizeBeakPosition,
    _calculateActualBeakWidthInPixels: $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels,
    _positionElementWithinBounds: $ce88cd5257e3ce57$var$_positionElementWithinBounds,
    _positionBeak: $ce88cd5257e3ce57$var$_positionBeak,
    _getPositionData: $ce88cd5257e3ce57$var$_getPositionData,
    _getMaxHeightFromTargetRectangle: $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle
};
function $ce88cd5257e3ce57$export$74054bd96b5eeef1(props, hostElement, elementToPosition, previousPositions) {
    return $ce88cd5257e3ce57$var$_positionElement(props, hostElement, elementToPosition, previousPositions);
}
function $ce88cd5257e3ce57$export$eb5e1ef38aa89e6e(props, hostElement, elementToPosition, previousPositions) {
    return $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, elementToPosition, previousPositions);
}
function $ce88cd5257e3ce57$export$9c27ad88a8f823dd(props, hostElement, elementToPosition, previousPositions) {
    return $ce88cd5257e3ce57$var$_positionCard(props, hostElement, elementToPosition, previousPositions);
}
function $ce88cd5257e3ce57$export$825c16631b262763(target, targetEdge, gapSpace, bounds, coverTarget) {
    if (gapSpace === void 0) gapSpace = 0;
    var mouseTarget = target;
    var elementTarget = target;
    var rectOrPointTarget = target;
    var targetRect;
    var boundingRectangle = bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, window.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, window.innerHeight);
    // eslint-disable-next-line deprecation/deprecation
    var left = rectOrPointTarget.left || rectOrPointTarget.x;
    // eslint-disable-next-line deprecation/deprecation
    var top = rectOrPointTarget.top || rectOrPointTarget.y;
    var right = rectOrPointTarget.right || left;
    var bottom = rectOrPointTarget.bottom || top;
    // eslint-disable-next-line no-extra-boolean-cast -- may not actually be a MouseEvent
    if (!!mouseTarget.stopPropagation) targetRect = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(mouseTarget.clientX, mouseTarget.clientX, mouseTarget.clientY, mouseTarget.clientY);
    else if (left !== undefined && top !== undefined) targetRect = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(left, right, top, bottom);
    else targetRect = $ce88cd5257e3ce57$var$_getRectangleFromElement(elementTarget);
    return $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle(targetRect, targetEdge, gapSpace, boundingRectangle, coverTarget);
}
function $ce88cd5257e3ce57$export$91aad4f6c09ebbeb(edge) {
    return edge * -1;
}
function $ce88cd5257e3ce57$var$_getBoundsFromTargetWindow(target, targetWindow) {
    var segments = undefined;
    if (targetWindow.getWindowSegments) segments = targetWindow.getWindowSegments();
    // Identify if we're dealing with single screen scenarios.
    if (segments === undefined || segments.length <= 1) return {
        top: 0,
        left: 0,
        right: targetWindow.innerWidth,
        bottom: targetWindow.innerHeight,
        width: targetWindow.innerWidth,
        height: targetWindow.innerHeight
    };
    // Logic for determining dual screen scenarios.
    var x = 0;
    var y = 0;
    // If the target is an Element get coordinates for its center.
    if (target !== null && !!target.getBoundingClientRect) {
        var clientRect = target.getBoundingClientRect();
        x = (clientRect.left + clientRect.right) / 2;
        y = (clientRect.top + clientRect.bottom) / 2;
    } else if (target !== null) {
        // eslint-disable-next-line deprecation/deprecation
        x = target.left || target.x;
        // eslint-disable-next-line deprecation/deprecation
        y = target.top || target.y;
    }
    var bounds = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: 0,
        height: 0
    };
    // Define which window segment are the coordinates in and calculate bounds based on that.
    for(var _i = 0, segments_1 = segments; _i < segments_1.length; _i++){
        var segment = segments_1[_i];
        if (x && segment.left <= x && segment.right >= x && y && segment.top <= y && segment.bottom >= y) bounds = {
            top: segment.top,
            left: segment.left,
            right: segment.right,
            bottom: segment.bottom,
            width: segment.width,
            height: segment.height
        };
    }
    return bounds;
}
function $ce88cd5257e3ce57$export$c09bf387c66666b4(target, targetWindow) {
    return $ce88cd5257e3ce57$var$_getBoundsFromTargetWindow(target, targetWindow);
}




var $acw62 = parcelRequire("acw62");
/**
 * The helper functions here will make the target element as modal to screen readers, by placing aria-hidden on elements
 * that are siblings to the target element and the target element's ancestors (because aria-hidden gets inherited).
 * That way, all other elements on the page are hidden to the screen reader.
 */ 
/** Tag names to ignore when modalizing */ var $4077fee6e96f12f4$var$tagsToIgnore = [
    "TEMPLATE",
    "STYLE",
    "SCRIPT"
];
function $4077fee6e96f12f4$export$6c6b3b5a8658bfc1(target) {
    var targetDocument = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(target);
    if (!targetDocument) // can't do this in SSR
    return function() {
        return undefined;
    };
    var affectedNodes = [];
    // start at target, then recurse and do the same for parent, until we reach <body>
    while(target !== targetDocument.body && target.parentElement){
        // grab all siblings of current element
        for(var _i = 0, _a = target.parentElement.children; _i < _a.length; _i++){
            var sibling = _a[_i];
            // but ignore elements that are already aria-hidden
            var ariaHidden = sibling.getAttribute("aria-hidden");
            if (sibling !== target && (ariaHidden === null || ariaHidden === void 0 ? void 0 : ariaHidden.toLowerCase()) !== "true" && $4077fee6e96f12f4$var$tagsToIgnore.indexOf(sibling.tagName) === -1) affectedNodes.push([
                sibling,
                ariaHidden
            ]);
        }
        target = target.parentElement;
    }
    // take all those elements and set aria-hidden=true on them
    affectedNodes.forEach(function(_a) {
        var node = _a[0];
        node.setAttribute("aria-hidden", "true");
    });
    return function() {
        $4077fee6e96f12f4$var$unmodalize(affectedNodes);
        affectedNodes = []; // dispose
    };
}
/**
 * Undoes the changes that modalize() did.
 */ function $4077fee6e96f12f4$var$unmodalize(affectedNodes) {
    affectedNodes.forEach(function(_a) {
        var node = _a[0], originalValue = _a[1];
        // Restore the original value (false or unset)
        if (originalValue) node.setAttribute("aria-hidden", originalValue);
        else node.removeAttribute("aria-hidden");
    });
}




var $acw62 = parcelRequire("acw62");
function $d1969548e570103f$export$cdf1dc76b55502e3() {
    var asyncRef = $acw62.useRef();
    if (!asyncRef.current) asyncRef.current = new (0, $64b4350fe064431c$export$4d3c597da532240f)();
    $acw62.useEffect(function() {
        return function() {
            var _a;
            (_a = asyncRef.current) === null || _a === void 0 || _a.dispose();
            asyncRef.current = undefined;
        };
    }, []);
    return asyncRef.current;
}



var $acw62 = parcelRequire("acw62");
function $5fe1a153d9a941d2$export$2bc3860deec8a08f(element, eventName, callback, useCapture) {
    // Use a ref for the callback to prevent repeatedly attaching/unattaching callbacks that are unstable across renders
    var callbackRef = $acw62.useRef(callback);
    callbackRef.current = callback;
    $acw62.useEffect(function() {
        var actualElement = element && "current" in element ? element.current : element;
        if (!actualElement) return;
        var dispose = (0, $18e32c5a70ef0416$export$af631764ddc44097)(actualElement, eventName, function(ev) {
            return callbackRef.current(ev);
        }, useCapture);
        return dispose;
    }, [
        element,
        eventName,
        useCapture
    ]);
}



var $acw62 = parcelRequire("acw62");
var $b139ba3b4431b53f$export$19f5fbe41bba757 = $acw62.createContext({
    window: typeof window === "object" ? window : undefined
});
var $b139ba3b4431b53f$export$24b8fbafc4b6a151 = function() {
    return $acw62.useContext($b139ba3b4431b53f$export$19f5fbe41bba757).window;
};
var $b139ba3b4431b53f$export$e71e2fb5c5c476d5 = function() {
    var _a;
    return (_a = $acw62.useContext($b139ba3b4431b53f$export$19f5fbe41bba757).window) === null || _a === void 0 ? void 0 : _a.document;
};
var $b139ba3b4431b53f$export$f7d306aeb1cf5fbc = function(props) {
    return $acw62.createElement($b139ba3b4431b53f$export$19f5fbe41bba757.Provider, {
        value: props
    }, props.children);
};


function $36276731e4f27f52$var$useScrollbarAsync(props, root) {
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var _a = $acw62.useState(false), needsVerticalScrollBarState = _a[0], setNeedsVerticalScrollBar = _a[1];
    $acw62.useEffect(function() {
        async.requestAnimationFrame(function() {
            var _a;
            // If overflowY is overridden, don't waste time calculating whether the scrollbar is necessary.
            if (props.style && props.style.overflowY) return;
            var needsVerticalScrollBar = false;
            if (root && root.current && ((_a = root.current) === null || _a === void 0 ? void 0 : _a.firstElementChild)) {
                // ClientHeight returns the client height of an element rounded to an
                // integer. On some browsers at different zoom levels this rounding
                // can generate different results for the root container and child even
                // though they are the same height. This causes us to show a scroll bar
                // when not needed. Ideally we would use BoundingClientRect().height
                // instead however seems that the API is 90% slower than using ClientHeight.
                // Therefore instead we will calculate the difference between heights and
                // allow for a 1px difference to still be considered ok and not show the
                // scroll bar.
                var rootHeight = root.current.clientHeight;
                var firstChildHeight = root.current.firstElementChild.clientHeight;
                if (rootHeight > 0 && firstChildHeight > rootHeight) needsVerticalScrollBar = firstChildHeight - rootHeight > 1;
            }
            if (needsVerticalScrollBarState !== needsVerticalScrollBar) setNeedsVerticalScrollBar(needsVerticalScrollBar);
        });
        return function() {
            return async.dispose();
        };
    });
    return needsVerticalScrollBarState;
}
function $36276731e4f27f52$var$defaultFocusRestorer(options) {
    var originalElement = options.originalElement, containsFocus = options.containsFocus;
    if (originalElement && containsFocus && originalElement !== (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) // Make sure that the focus method actually exists
    // In some cases the object might exist but not be a real element.
    // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
    // This is wrapped in a setTimeout because of a React 16 bug that is resolved in 17.
    // Once we move to 17, the setTimeout should be removed (ref: https://github.com/facebook/react/issues/17894#issuecomment-656094405)
    setTimeout(function() {
        var _a;
        (_a = originalElement.focus) === null || _a === void 0 || _a.call(originalElement);
    }, 0);
}
function $36276731e4f27f52$var$useRestoreFocus(props, root) {
    var _a = props.onRestoreFocus, onRestoreFocus = _a === void 0 ? $36276731e4f27f52$var$defaultFocusRestorer : _a;
    var originalFocusedElement = $acw62.useRef();
    var containsFocus = $acw62.useRef(false);
    $acw62.useEffect(function() {
        originalFocusedElement.current = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)().activeElement;
        if ((0, $94bdc1ebed789608$export$597abdf7826dd64a)(root.current)) containsFocus.current = true;
        return function() {
            var _a;
            onRestoreFocus === null || onRestoreFocus === void 0 || onRestoreFocus({
                originalElement: originalFocusedElement.current,
                containsFocus: containsFocus.current,
                documentContainsFocus: ((_a = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)()) === null || _a === void 0 ? void 0 : _a.hasFocus()) || false
            });
            // De-reference DOM Node to avoid retainment via transpiled closure of _onKeyDown
            originalFocusedElement.current = undefined;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []);
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(root, "focus", $acw62.useCallback(function() {
        containsFocus.current = true;
    }, []), true);
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(root, "blur", $acw62.useCallback(function(ev) {
        /** The popup should update this._containsFocus when:
         * relatedTarget exists AND
         * the relatedTarget is not contained within the popup.
         * If the relatedTarget is within the popup, that means the popup still has focus
         * and focused moved from one element to another within the popup.
         * If relatedTarget is undefined or null that usually means that a
         * keyboard event occurred and focus didn't change
         */ if (root.current && ev.relatedTarget && !root.current.contains(ev.relatedTarget)) containsFocus.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []), true);
}
function $36276731e4f27f52$var$useHideSiblingNodes(props, root) {
    // eslint-disable-next-line deprecation/deprecation
    var shouldHideSiblings = String(props["aria-modal"]).toLowerCase() === "true" && props.enableAriaHiddenSiblings;
    $acw62.useEffect(function() {
        if (!(shouldHideSiblings && root.current)) return;
        var unmodalize = (0, $4077fee6e96f12f4$export$6c6b3b5a8658bfc1)(root.current);
        return unmodalize;
    }, [
        root,
        shouldHideSiblings
    ]);
}
var $36276731e4f27f52$export$129a32eedafa97c5 = $acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)({
        shouldRestoreFocus: true,
        enableAriaHiddenSiblings: true
    }, propsWithoutDefaults);
    var root = $acw62.useRef();
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(root, forwardedRef);
    $36276731e4f27f52$var$useHideSiblingNodes(props, root);
    $36276731e4f27f52$var$useRestoreFocus(props, root);
    var role = props.role, className = props.className, ariaLabel = props.ariaLabel, ariaLabelledBy = props.ariaLabelledBy, ariaDescribedBy = props.ariaDescribedBy, style = props.style, children = props.children, onDismiss = props.onDismiss;
    var needsVerticalScrollBar = $36276731e4f27f52$var$useScrollbarAsync(props, root);
    var onKeyDown = $acw62.useCallback(function(ev) {
        // eslint-disable-next-line deprecation/deprecation
        switch(ev.which){
            case (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape:
                if (onDismiss) {
                    onDismiss(ev);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                break;
        }
    }, [
        onDismiss
    ]);
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(win, "keydown", onKeyDown);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: mergedRootRef
    }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
        className: className,
        role: role,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        onKeyDown: onKeyDown,
        style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            overflowY: needsVerticalScrollBar ? "scroll" : undefined,
            outline: "none"
        }, style)
    }), children);
});
$36276731e4f27f52$export$129a32eedafa97c5.displayName = "Popup";





var $acw62 = parcelRequire("acw62");

function $d39eb924c3e4805b$export$7df435cf7131d47a(target, hostElement) {
    var previousTargetProp = $acw62.useRef();
    var targetRef = $acw62.useRef(null);
    /**
     * Stores an instance of Window, used to check
     * for server side rendering and if focus was lost.
     */ var targetWindow = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    // If the target element changed, find the new one. If we are tracking
    // target with class name, always find element because we do not know if
    // fabric has rendered a new element and disposed the old element.
    if (!target || target !== previousTargetProp.current || typeof target === "string") {
        var currentElement = hostElement === null || hostElement === void 0 ? void 0 : hostElement.current;
        if (target) {
            if (typeof target === "string") {
                var currentDoc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(currentElement);
                targetRef.current = currentDoc ? currentDoc.querySelector(target) : null;
            } else if ("stopPropagation" in target) targetRef.current = target;
            else if ("getBoundingClientRect" in target) targetRef.current = target;
            else if ("current" in target) targetRef.current = target.current;
            else targetRef.current = target;
        }
        previousTargetProp.current = target;
    }
    return [
        targetRef,
        targetWindow
    ];
}


var $d44060969b90fc9c$var$_a;
var $d44060969b90fc9c$var$COMPONENT_NAME = "CalloutContentBase";
var $d44060969b90fc9c$var$ANIMATIONS = ($d44060969b90fc9c$var$_a = {}, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).top] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideUpIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideDownIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).left] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideLeftIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).right] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideRightIn10, $d44060969b90fc9c$var$_a);
var $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION = {
    top: 0,
    left: 0
};
// Microsoft Edge will overwrite inline styles if there is an animation pertaining to that style.
// To help ensure that edge will respect the offscreen style opacity
// filter needs to be added as an additional way to set opacity.
// Also set pointer-events: none so that the callout will not occlude the element it is
// going to be positioned against
var $d44060969b90fc9c$var$OFF_SCREEN_STYLE = {
    opacity: 0,
    filter: "opacity(0)",
    pointerEvents: "none"
};
// role and role description go hand-in-hand. Both would be included by spreading getNativeProps for a basic element
// This constant array can be used to filter these out of native props spread on callout root and apply them together on
// calloutMain (the Popup component within the callout)
var $d44060969b90fc9c$var$ARIA_ROLE_ATTRIBUTES = [
    "role",
    "aria-roledescription"
];
var $d44060969b90fc9c$var$DEFAULT_PROPS = {
    preventDismissOnLostFocus: false,
    preventDismissOnScroll: false,
    preventDismissOnResize: false,
    isBeakVisible: true,
    beakWidth: 16,
    gapSpace: 0,
    minPagePadding: 8,
    directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge
};
var $d44060969b90fc9c$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    disableCaching: true
});
/**
 * (Hook) to return a function to lazily fetch the bounds of the target element for the callout.
 */ function $d44060969b90fc9c$var$useBounds(_a, targetRef, targetWindow) {
    var bounds = _a.bounds, _b = _a.minPagePadding, minPagePadding = _b === void 0 ? $d44060969b90fc9c$var$DEFAULT_PROPS.minPagePadding : _b, target = _a.target;
    var _c = $acw62.useState(false), targetWindowResized = _c[0], setTargetWindowResized = _c[1];
    var cachedBounds = $acw62.useRef();
    var getBounds = $acw62.useCallback(function() {
        if (!cachedBounds.current || targetWindowResized) {
            var currentBounds = typeof bounds === "function" ? targetWindow ? bounds(target, targetWindow) : undefined : bounds;
            if (!currentBounds && targetWindow) {
                currentBounds = (0, $ce88cd5257e3ce57$export$c09bf387c66666b4)(targetRef.current, targetWindow);
                currentBounds = {
                    top: currentBounds.top + minPagePadding,
                    left: currentBounds.left + minPagePadding,
                    right: currentBounds.right - minPagePadding,
                    bottom: currentBounds.bottom - minPagePadding,
                    width: currentBounds.width - minPagePadding * 2,
                    height: currentBounds.height - minPagePadding * 2
                };
            }
            cachedBounds.current = currentBounds;
            targetWindowResized && setTargetWindowResized(false);
        }
        return cachedBounds.current;
    }, [
        bounds,
        minPagePadding,
        target,
        targetRef,
        targetWindow,
        targetWindowResized
    ]);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(targetWindow, "resize", async.debounce(function() {
        setTargetWindowResized(true);
    }, 500, {
        leading: true
    }));
    return getBounds;
}
/**
 * (Hook) to return the maximum available height for the Callout to render into.
 */ function $d44060969b90fc9c$var$useMaxHeight(_a, getBounds, positions) {
    var _b;
    var calloutMaxHeight = _a.calloutMaxHeight, finalHeight = _a.finalHeight, directionalHint = _a.directionalHint, directionalHintFixed = _a.directionalHintFixed, hidden = _a.hidden;
    var _c = $acw62.useState(), maxHeight = _c[0], setMaxHeight = _c[1];
    var _d = (_b = positions === null || positions === void 0 ? void 0 : positions.elementPosition) !== null && _b !== void 0 ? _b : {}, top = _d.top, bottom = _d.bottom;
    $acw62.useEffect(function() {
        var _a;
        var _b = (_a = getBounds()) !== null && _a !== void 0 ? _a : {}, topBounds = _b.top, bottomBounds = _b.bottom;
        var calculatedHeight;
        if (typeof top === "number" && bottomBounds) calculatedHeight = bottomBounds - top;
        else if (typeof bottom === "number" && typeof topBounds === "number" && bottomBounds) calculatedHeight = bottomBounds - topBounds - bottom;
        if (!calloutMaxHeight && !hidden || calloutMaxHeight && calculatedHeight && calloutMaxHeight > calculatedHeight) setMaxHeight(calculatedHeight);
        else if (calloutMaxHeight) setMaxHeight(calloutMaxHeight);
        else setMaxHeight(undefined);
    }, [
        bottom,
        calloutMaxHeight,
        finalHeight,
        directionalHint,
        directionalHintFixed,
        getBounds,
        hidden,
        positions,
        top
    ]);
    return maxHeight;
}
/**
 * (Hook) to find the current position of Callout. If Callout is resized then a new position is calculated.
 */ function $d44060969b90fc9c$var$usePositions(props, hostElement, calloutElement, targetRef, getBounds) {
    var _a = $acw62.useState(), positions = _a[0], setPositions = _a[1];
    var positionAttempts = $acw62.useRef(0);
    var previousTarget = $acw62.useRef();
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var hidden = props.hidden, target = props.target, finalHeight = props.finalHeight, calloutMaxHeight = props.calloutMaxHeight, onPositioned = props.onPositioned, directionalHint = props.directionalHint;
    $acw62.useEffect(function() {
        if (!hidden) {
            var timerId_1 = async.requestAnimationFrame(function() {
                var _a, _b;
                if (hostElement.current && calloutElement) {
                    var currentProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
                        target: targetRef.current,
                        bounds: getBounds()
                    });
                    // duplicate calloutElement & remove useMaxHeight's maxHeight for position calc
                    var dupeCalloutElement = calloutElement.cloneNode(true);
                    dupeCalloutElement.style.maxHeight = calloutMaxHeight ? "".concat(calloutMaxHeight) : "";
                    dupeCalloutElement.style.visibility = "hidden";
                    (_a = calloutElement.parentElement) === null || _a === void 0 || _a.appendChild(dupeCalloutElement);
                    var previousPositions = previousTarget.current === target ? positions : undefined;
                    // If there is a finalHeight given then we assume that the user knows and will handle
                    // additional positioning adjustments so we should call positionCard
                    var newPositions = finalHeight ? (0, $ce88cd5257e3ce57$export$9c27ad88a8f823dd)(currentProps, hostElement.current, dupeCalloutElement, previousPositions) : (0, $ce88cd5257e3ce57$export$eb5e1ef38aa89e6e)(currentProps, hostElement.current, dupeCalloutElement, previousPositions);
                    // clean up duplicate calloutElement
                    (_b = calloutElement.parentElement) === null || _b === void 0 || _b.removeChild(dupeCalloutElement);
                    // Set the new position only when the positions do not exist or one of the new callout positions
                    // is different. The position should not change if the position is within 2 decimal places.
                    if (!positions && newPositions || positions && newPositions && !$d44060969b90fc9c$var$arePositionsEqual(positions, newPositions) && positionAttempts.current < 5) {
                        // We should not reposition the callout more than a few times, if it is then the content is likely resizing
                        // and we should stop trying to reposition to prevent a stack overflow.
                        positionAttempts.current++;
                        setPositions(newPositions);
                    } else if (positionAttempts.current > 0) {
                        // Only call the onPositioned callback if the callout has been re-positioned at least once.
                        positionAttempts.current = 0;
                        onPositioned === null || onPositioned === void 0 || onPositioned(positions);
                    }
                }
            }, calloutElement);
            previousTarget.current = target;
            return function() {
                async.cancelAnimationFrame(timerId_1);
                previousTarget.current = undefined;
            };
        } else {
            // When the callout is hidden, clear position state so that it is not accidentally used next render.
            setPositions(undefined);
            positionAttempts.current = 0;
        }
    }, [
        hidden,
        directionalHint,
        async,
        calloutElement,
        calloutMaxHeight,
        hostElement,
        targetRef,
        finalHeight,
        getBounds,
        onPositioned,
        positions,
        props,
        target
    ]);
    return positions;
}
/**
 * (Hook) to set up behavior to automatically focus the callout when it appears, if indicated by props.
 */ function $d44060969b90fc9c$var$useAutoFocus(_a, positions, calloutElement) {
    var hidden = _a.hidden, setInitialFocus = _a.setInitialFocus;
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var hasPositions = !!positions;
    $acw62.useEffect(function() {
        if (!hidden && setInitialFocus && hasPositions && calloutElement) {
            var timerId_2 = async.requestAnimationFrame(function() {
                return (0, $94bdc1ebed789608$export$8765806c2c274519)(calloutElement);
            }, calloutElement);
            return function() {
                return async.cancelAnimationFrame(timerId_2);
            };
        }
    }, [
        hidden,
        hasPositions,
        async,
        calloutElement,
        setInitialFocus
    ]);
}
/**
 * (Hook) to set up various handlers to dismiss the popup when it loses focus or the window scrolls or similar cases.
 */ function $d44060969b90fc9c$var$useDismissHandlers(_a, positions, hostElement, targetRef, targetWindow) {
    var hidden = _a.hidden, onDismiss = _a.onDismiss, // eslint-disable-next-line deprecation/deprecation
    preventDismissOnScroll = _a.preventDismissOnScroll, // eslint-disable-next-line deprecation/deprecation
    preventDismissOnResize = _a.preventDismissOnResize, // eslint-disable-next-line deprecation/deprecation
    preventDismissOnLostFocus = _a.preventDismissOnLostFocus, dismissOnTargetClick = _a.dismissOnTargetClick, shouldDismissOnWindowFocus = _a.shouldDismissOnWindowFocus, preventDismissOnEvent = _a.preventDismissOnEvent;
    var isMouseDownOnPopup = $acw62.useRef(false);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var mouseDownHandlers = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)([
        function() {
            isMouseDownOnPopup.current = true;
        },
        function() {
            isMouseDownOnPopup.current = false;
        }
    ]);
    var positionsExists = !!positions;
    $acw62.useEffect(function() {
        var dismissOnScroll = function(ev) {
            if (positionsExists && !preventDismissOnScroll) dismissOnClickOrScroll(ev);
        };
        var dismissOnResize = function(ev) {
            if (!preventDismissOnResize && !(preventDismissOnEvent && preventDismissOnEvent(ev))) onDismiss === null || onDismiss === void 0 || onDismiss(ev);
        };
        var dismissOnLostFocus = function(ev) {
            if (!preventDismissOnLostFocus) dismissOnClickOrScroll(ev);
        };
        var dismissOnClickOrScroll = function(ev) {
            var eventPaths = ev.composedPath ? ev.composedPath() : [];
            var target = eventPaths.length > 0 ? eventPaths[0] : ev.target;
            var isEventTargetOutsideCallout = hostElement.current && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(hostElement.current, target);
            // If mouse is pressed down on callout but moved outside then released, don't dismiss the callout.
            if (isEventTargetOutsideCallout && isMouseDownOnPopup.current) {
                isMouseDownOnPopup.current = false;
                return;
            }
            if (!targetRef.current && isEventTargetOutsideCallout || ev.target !== targetWindow && isEventTargetOutsideCallout && (!targetRef.current || "stopPropagation" in targetRef.current || dismissOnTargetClick || target !== targetRef.current && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(targetRef.current, target))) {
                if (preventDismissOnEvent && preventDismissOnEvent(ev)) return;
                onDismiss === null || onDismiss === void 0 || onDismiss(ev);
            }
        };
        var dismissOnTargetWindowBlur = function(ev) {
            // Do nothing
            if (!shouldDismissOnWindowFocus) return;
            if ((preventDismissOnEvent && !preventDismissOnEvent(ev) || !preventDismissOnEvent && !preventDismissOnLostFocus) && !(targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.hasFocus()) && ev.relatedTarget === null) onDismiss === null || onDismiss === void 0 || onDismiss(ev);
        };
        // This is added so the callout will dismiss when the window is scrolled
        // but not when something inside the callout is scrolled. The delay seems
        // to be required to avoid React firing an async focus event in IE from
        // the target changing focus quickly prior to rendering the callout.
        var disposablesPromise = new Promise(function(resolve) {
            async.setTimeout(function() {
                if (!hidden && targetWindow) {
                    var disposables_1 = [
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, "scroll", dismissOnScroll, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, "resize", dismissOnResize, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow.document.documentElement, "focus", dismissOnLostFocus, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow.document.documentElement, "click", dismissOnLostFocus, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, "blur", dismissOnTargetWindowBlur, true)
                    ];
                    resolve(function() {
                        disposables_1.forEach(function(dispose) {
                            return dispose();
                        });
                    });
                }
            }, 0);
        });
        return function() {
            disposablesPromise.then(function(dispose) {
                return dispose();
            });
        };
    }, [
        hidden,
        async,
        hostElement,
        targetRef,
        targetWindow,
        onDismiss,
        shouldDismissOnWindowFocus,
        dismissOnTargetClick,
        preventDismissOnLostFocus,
        preventDismissOnResize,
        preventDismissOnScroll,
        positionsExists,
        preventDismissOnEvent
    ]);
    return mouseDownHandlers;
}
var $d44060969b90fc9c$export$9691c2c04b66dd88 = $acw62.memo($acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($d44060969b90fc9c$var$DEFAULT_PROPS, propsWithoutDefaults);
    var styles = props.styles, style = props.style, ariaLabel = props.ariaLabel, ariaDescribedBy = props.ariaDescribedBy, ariaLabelledBy = props.ariaLabelledBy, className = props.className, isBeakVisible = props.isBeakVisible, children = props.children, beakWidth = props.beakWidth, calloutWidth = props.calloutWidth, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer, finalHeight = props.finalHeight, _a = props.hideOverflow, hideOverflow = _a === void 0 ? !!finalHeight : _a, backgroundColor = props.backgroundColor, calloutMaxHeight = props.calloutMaxHeight, onScroll = props.onScroll, // eslint-disable-next-line deprecation/deprecation
    _b = props.shouldRestoreFocus, // eslint-disable-next-line deprecation/deprecation
    shouldRestoreFocus = _b === void 0 ? true : _b, target = props.target, hidden = props.hidden, onLayerMounted = props.onLayerMounted, popupProps = props.popupProps;
    var hostElement = $acw62.useRef(null);
    var _c = $acw62.useState(null), calloutElement = _c[0], setCalloutElement = _c[1];
    var calloutCallback = $acw62.useCallback(function(calloutEl) {
        setCalloutElement(calloutEl);
    }, []);
    var rootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(hostElement, forwardedRef);
    var _d = (0, $d39eb924c3e4805b$export$7df435cf7131d47a)(props.target, {
        current: calloutElement
    }), targetRef = _d[0], targetWindow = _d[1];
    var getBounds = $d44060969b90fc9c$var$useBounds(props, targetRef, targetWindow);
    var positions = $d44060969b90fc9c$var$usePositions(props, hostElement, calloutElement, targetRef, getBounds);
    var maxHeight = $d44060969b90fc9c$var$useMaxHeight(props, getBounds, positions);
    var _e = $d44060969b90fc9c$var$useDismissHandlers(props, positions, hostElement, targetRef, targetWindow), mouseDownOnPopup = _e[0], mouseUpOnPopup = _e[1];
    // do not set both top and bottom css props from positions
    // instead, use maxHeight
    var isForcedInBounds = (positions === null || positions === void 0 ? void 0 : positions.elementPosition.top) && (positions === null || positions === void 0 ? void 0 : positions.elementPosition.bottom);
    var cssPositions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, positions === null || positions === void 0 ? void 0 : positions.elementPosition), {
        maxHeight: maxHeight
    });
    if (isForcedInBounds) cssPositions.bottom = undefined;
    $d44060969b90fc9c$var$useAutoFocus(props, positions, calloutElement);
    $acw62.useEffect(function() {
        if (!hidden) onLayerMounted === null || onLayerMounted === void 0 || onLayerMounted();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run if hidden changes
    }, [
        hidden
    ]);
    // If there is no target window then we are likely in server side rendering and we should not render anything.
    if (!targetWindow) return null;
    var overflowYHidden = hideOverflow;
    var beakVisible = isBeakVisible && !!target;
    var classNames = $d44060969b90fc9c$var$getClassNames(styles, {
        theme: props.theme,
        className: className,
        overflowYHidden: overflowYHidden,
        calloutWidth: calloutWidth,
        positions: positions,
        beakWidth: beakWidth,
        backgroundColor: backgroundColor,
        calloutMaxWidth: calloutMaxWidth,
        calloutMinWidth: calloutMinWidth,
        doNotLayer: doNotLayer
    });
    var overflowStyle = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        maxHeight: calloutMaxHeight ? calloutMaxHeight : "100%"
    }, style), overflowYHidden && {
        overflowY: "hidden"
    });
    var visibilityStyle = props.hidden ? {
        visibility: "hidden"
    } : undefined;
    // React.CSSProperties does not understand IRawStyle, so the inline animations will need to be cast as any for now.
    return $acw62.createElement("div", {
        ref: rootRef,
        className: classNames.container,
        style: visibilityStyle
    }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), $d44060969b90fc9c$var$ARIA_ROLE_ATTRIBUTES), {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, positions && positions.targetEdge && $d44060969b90fc9c$var$ANIMATIONS[positions.targetEdge]),
        style: positions ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, cssPositions) : $d44060969b90fc9c$var$OFF_SCREEN_STYLE,
        // Safari and Firefox on Mac OS requires this to back-stop click events so focus remains in the Callout.
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        tabIndex: -1,
        ref: calloutCallback
    }), beakVisible && $acw62.createElement("div", {
        className: classNames.beak,
        style: $d44060969b90fc9c$var$getBeakPosition(positions)
    }), beakVisible && $acw62.createElement("div", {
        className: classNames.beakCurtain
    }), $acw62.createElement((0, $36276731e4f27f52$export$129a32eedafa97c5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        // don't use getNativeElementProps for role and roledescription because it will also
        // pass through data-* props (resulting in them being used in two places)
        role: props.role,
        "aria-roledescription": props["aria-roledescription"],
        ariaDescribedBy: ariaDescribedBy,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        className: classNames.calloutMain,
        onDismiss: props.onDismiss,
        onMouseDown: mouseDownOnPopup,
        onMouseUp: mouseUpOnPopup,
        onRestoreFocus: props.onRestoreFocus,
        onScroll: onScroll,
        shouldRestoreFocus: shouldRestoreFocus,
        style: overflowStyle
    }, popupProps), children)));
}), function(previousProps, nextProps) {
    if (!nextProps.shouldUpdateWhenHidden && previousProps.hidden && nextProps.hidden) // Do not update when hidden.
    return true;
    return (0, $f504d2279336999d$export$90e866afbd6b9f1a)(previousProps, nextProps);
});
/**
 * (Utility) to find and return the current `Callout` Beak position.
 *
 * @param positions
 */ function $d44060969b90fc9c$var$getBeakPosition(positions) {
    var _a, _b;
    var beakPositionStyle = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (_a = positions === null || positions === void 0 ? void 0 : positions.beakPosition) === null || _a === void 0 ? void 0 : _a.elementPosition), {
        display: ((_b = positions === null || positions === void 0 ? void 0 : positions.beakPosition) === null || _b === void 0 ? void 0 : _b.hideBeak) ? "none" : undefined
    });
    if (!beakPositionStyle.top && !beakPositionStyle.bottom && !beakPositionStyle.left && !beakPositionStyle.right) {
        beakPositionStyle.left = $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION.left;
        beakPositionStyle.top = $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION.top;
    }
    return beakPositionStyle;
}
/**
 * (Utility) used to compare two different elementPositions to determine whether they are equal.
 *
 * @param prevElementPositions
 * @param newElementPosition
 */ function $d44060969b90fc9c$var$arePositionsEqual(prevElementPositions, newElementPosition) {
    return $d44060969b90fc9c$var$comparePositions(prevElementPositions.elementPosition, newElementPosition.elementPosition) && $d44060969b90fc9c$var$comparePositions(prevElementPositions.beakPosition.elementPosition, newElementPosition.beakPosition.elementPosition);
}
/**
 * (Utility) used in **arePositionsEqual** to compare two different elementPositions.
 *
 * @param prevElementPositions
 * @param newElementPositions
 */ function $d44060969b90fc9c$var$comparePositions(prevElementPositions, newElementPositions) {
    for(var key in newElementPositions)if (newElementPositions.hasOwnProperty(key)) {
        var oldPositionEdge = prevElementPositions[key];
        var newPositionEdge = newElementPositions[key];
        if (oldPositionEdge !== undefined && newPositionEdge !== undefined) {
            if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) return false;
        } else return false;
    }
    return true;
}
$d44060969b90fc9c$export$9691c2c04b66dd88.displayName = $d44060969b90fc9c$var$COMPONENT_NAME;



function $beecb0dab32bf6f3$var$getBeakStyle(beakWidth) {
    return {
        height: beakWidth,
        width: beakWidth
    };
}
var $beecb0dab32bf6f3$var$GlobalClassNames = {
    container: "ms-Callout-container",
    root: "ms-Callout",
    beak: "ms-Callout-beak",
    beakCurtain: "ms-Callout-beakCurtain",
    calloutMain: "ms-Callout-main"
};
var $beecb0dab32bf6f3$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme, className = props.className, overflowYHidden = props.overflowYHidden, calloutWidth = props.calloutWidth, beakWidth = props.beakWidth, backgroundColor = props.backgroundColor, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($beecb0dab32bf6f3$var$GlobalClassNames, theme);
    var semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        container: [
            classNames.container,
            {
                position: "relative"
            }
        ],
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: "absolute",
                display: "flex",
                zIndex: doNotLayer ? (0, $e718b14ff8496161$export$ee30d3e11c8625f1).Layer : undefined,
                boxSizing: "border-box",
                borderRadius: effects.roundedCorner2,
                boxShadow: effects.elevation16,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "WindowText"
                }, _a)
            },
            (0, $3c8eab4e1d179dea$export$47933a1040be8871)(),
            className,
            !!calloutWidth && {
                width: calloutWidth
            },
            !!calloutMaxWidth && {
                maxWidth: calloutMaxWidth
            },
            !!calloutMinWidth && {
                minWidth: calloutMinWidth
            }
        ],
        beak: [
            classNames.beak,
            {
                position: "absolute",
                backgroundColor: semanticColors.menuBackground,
                boxShadow: "inherit",
                border: "inherit",
                boxSizing: "border-box",
                transform: "rotate(45deg)"
            },
            $beecb0dab32bf6f3$var$getBeakStyle(beakWidth),
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ],
        beakCurtain: [
            classNames.beakCurtain,
            {
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: semanticColors.menuBackground,
                borderRadius: effects.roundedCorner2
            }
        ],
        calloutMain: [
            classNames.calloutMain,
            {
                backgroundColor: semanticColors.menuBackground,
                overflowX: "hidden",
                overflowY: "auto",
                position: "relative",
                width: "100%",
                borderRadius: effects.roundedCorner2
            },
            overflowYHidden && {
                overflowY: "hidden"
            },
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ]
    };
};


var $57cf9e0ffad9e5e0$export$f6122ee2215f6f10 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $d44060969b90fc9c$export$9691c2c04b66dd88), (0, $beecb0dab32bf6f3$export$ffd58b7f6f099a57), undefined, {
    scope: "CalloutContent"
});





var $acw62 = parcelRequire("acw62");
const $a6dcfff088e996dd$var$PortalCompatContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $a6dcfff088e996dd$var$portalCompatContextDefaultValue = ()=>()=>undefined;
const $a6dcfff088e996dd$export$1abd643230d66e44 = $a6dcfff088e996dd$var$PortalCompatContext.Provider;
function $a6dcfff088e996dd$export$712a597a27357a15() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($a6dcfff088e996dd$var$PortalCompatContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $a6dcfff088e996dd$var$portalCompatContextDefaultValue;
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



function $e3f86a9c88cde7ae$export$953b8844777cd492(oldSettings, newSettings) {
    if (oldSettings === void 0) oldSettings = {};
    var mergeSettingsWith = $e3f86a9c88cde7ae$var$_isSettingsFunction(newSettings) ? newSettings : $e3f86a9c88cde7ae$var$_settingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function $e3f86a9c88cde7ae$export$23927a6086b44fac(oldSettings, newSettings) {
    if (oldSettings === void 0) oldSettings = {};
    var mergeSettingsWith = $e3f86a9c88cde7ae$var$_isSettingsFunction(newSettings) ? newSettings : $e3f86a9c88cde7ae$var$_scopedSettingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function $e3f86a9c88cde7ae$var$_isSettingsFunction(settings) {
    return typeof settings === "function";
}
function $e3f86a9c88cde7ae$var$_settingsMergeWith(newSettings) {
    return function(settings) {
        return newSettings ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, settings), newSettings) : settings;
    };
}
function $e3f86a9c88cde7ae$var$_scopedSettingsMergeWith(scopedSettingsFromProps) {
    if (scopedSettingsFromProps === void 0) scopedSettingsFromProps = {};
    return function(oldScopedSettings) {
        var newScopedSettings = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, oldScopedSettings);
        for(var scopeName in scopedSettingsFromProps)if (scopedSettingsFromProps.hasOwnProperty(scopeName)) newScopedSettings[scopeName] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, oldScopedSettings[scopeName]), scopedSettingsFromProps[scopeName]);
        return newScopedSettings;
    };
}


function $5c83a7f0b5d7529f$export$710b302555b5c18c(props, parentContext) {
    var _a = (parentContext || {}).customizations, customizations = _a === void 0 ? {
        settings: {},
        scopedSettings: {}
    } : _a;
    return {
        customizations: {
            settings: (0, $e3f86a9c88cde7ae$export$953b8844777cd492)(customizations.settings, props.settings),
            scopedSettings: (0, $e3f86a9c88cde7ae$export$23927a6086b44fac)(customizations.scopedSettings, props.scopedSettings),
            inCustomizerContext: true
        }
    };
}


/**
 * The Customizer component allows for default props to be mixed into components which
 * are decorated with the customizable() decorator, or use the styled HOC. This enables
 * injection scenarios like:
 *
 * 1. render svg icons instead of the icon font within all buttons
 * 2. inject a custom theme object into a component
 *
 * Props are provided via the settings prop which should be one of the following:
 * - A json map which contains 1 or more name/value pairs representing injectable props.
 * - A function that receives the current settings and returns the new ones that apply to the scope
 *
 * @public
 *
 * @deprecated This component is deprecated for purpose of applying theme to components
 * as of `@fluentui/react` version 8. Use `ThemeProvider` for applying theme instead.
 */ var $9997c9cf02ee2446$export$84d28c22644f2e3a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Customizer, _super);
    function Customizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onCustomizationChange = function() {
            return _this.forceUpdate();
        };
        return _this;
    }
    Customizer.prototype.componentDidMount = function() {
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(this._onCustomizationChange);
    };
    Customizer.prototype.componentWillUnmount = function() {
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(this._onCustomizationChange);
    };
    Customizer.prototype.render = function() {
        var _this = this;
        var contextTransform = this.props.contextTransform;
        return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Consumer, null, function(parentContext) {
            var newContext = (0, $5c83a7f0b5d7529f$export$710b302555b5c18c)(_this.props, parentContext);
            if (contextTransform) newContext = contextTransform(newContext);
            return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Provider, {
                value: newContext
            }, _this.props.children);
        });
    };
    return Customizer;
}($acw62.Component);


var $acw62 = parcelRequire("acw62");

var $0a0122a1daf8e02f$export$7f9071f49e01dae9 = function(props) {
    var providerRef = props.providerRef, layerRoot = props.layerRoot;
    var registeredProviders = $acw62.useState([])[0];
    var parentContext = $acw62.useContext((0, $872a30e3c6519016$export$683969f4bf72ffbd));
    // Inherit the parent context if it exists, unless this is a layer root.
    // This allows the topmost provider element in the DOM tree to handle the focus events.
    // Since layers are in a separate HTML tree from their parent, they shouldn't use the parent's providerRef.
    var inheritParentContext = parentContext !== undefined && !layerRoot;
    var context = $acw62.useMemo(function() {
        return inheritParentContext ? undefined : {
            providerRef: providerRef,
            registeredProviders: registeredProviders,
            registerProvider: function(ref) {
                // Register this child provider with the current context, and any parent contexts
                registeredProviders.push(ref);
                parentContext === null || parentContext === void 0 || parentContext.registerProvider(ref);
            },
            unregisterProvider: function(ref) {
                parentContext === null || parentContext === void 0 || parentContext.unregisterProvider(ref);
                var i = registeredProviders.indexOf(ref);
                if (i >= 0) registeredProviders.splice(i, 1);
            }
        };
    }, [
        providerRef,
        registeredProviders,
        parentContext,
        inheritParentContext
    ]);
    $acw62.useEffect(function() {
        if (context) {
            context.registerProvider(context.providerRef);
            return function() {
                return context.unregisterProvider(context.providerRef);
            };
        }
    }, [
        context
    ]);
    // Create a new context provider if this is not inheriting from the parent.
    if (context) return $acw62.createElement((0, $872a30e3c6519016$export$683969f4bf72ffbd).Provider, {
        value: context
    }, props.children);
    else return $acw62.createElement($acw62.Fragment, null, props.children);
};




var $f889493d4b981ec5$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $f889493d4b981ec5$var$getFabricTheme = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, isRTL) {
    return (0, $49b644eef671596b$export$25d302a5b900a763)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, theme), {
        rtl: isRTL
    }));
});
var $f889493d4b981ec5$var$getDir = function(_a) {
    var theme = _a.theme, dir = _a.dir;
    var contextDir = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? "rtl" : "ltr";
    var pageDir = (0, $723d0744d8fe4fde$export$b2303637e9533380)() ? "rtl" : "ltr";
    var componentDir = dir ? dir : contextDir;
    return {
        // If Fabric dir !== contextDir
        // Or If contextDir !== pageDir
        // Then we need to set dir of the Fabric root
        rootDir: componentDir !== contextDir || componentDir !== pageDir ? componentDir : dir,
        // If dir !== contextDir || pageDir
        // then set contextual theme around content
        needsTheme: componentDir !== contextDir
    };
};
var $f889493d4b981ec5$export$e4aae1774125dd2f = $acw62.forwardRef(function(props, ref) {
    var className = props.className, theme = props.theme, applyTheme = props.applyTheme, applyThemeToBody = props.applyThemeToBody, styles = props.styles;
    var classNames = $f889493d4b981ec5$var$getClassNames(styles, {
        theme: theme,
        applyTheme: applyTheme,
        className: className
    });
    var rootElement = $acw62.useRef(null);
    $f889493d4b981ec5$var$useApplyThemeToBody(applyThemeToBody, classNames, rootElement);
    return $acw62.createElement($acw62.Fragment, null, $f889493d4b981ec5$var$useRenderedContent(props, classNames, rootElement, ref));
});
$f889493d4b981ec5$export$e4aae1774125dd2f.displayName = "FabricBase";
function $f889493d4b981ec5$var$useRenderedContent(props, _a, rootElement, ref) {
    var root = _a.root;
    var _b = props.as, Root = _b === void 0 ? "div" : _b, dir = props.dir, theme = props.theme;
    var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
        "dir"
    ]);
    var _c = $f889493d4b981ec5$var$getDir(props), rootDir = _c.rootDir, needsTheme = _c.needsTheme;
    var renderedContent = $acw62.createElement((0, $0a0122a1daf8e02f$export$7f9071f49e01dae9), {
        providerRef: rootElement
    }, $acw62.createElement(Root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        dir: rootDir
    }, divProps, {
        className: root,
        ref: (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootElement, ref)
    })));
    // Create the contextual theme if component direction does not match parent direction.
    if (needsTheme) // Disabling ThemeProvider here because theme doesn't need to be re-provided by ThemeProvider if dir has changed.
    renderedContent = // eslint-disable-next-line deprecation/deprecation
    $acw62.createElement((0, $9997c9cf02ee2446$export$84d28c22644f2e3a), {
        settings: {
            theme: $f889493d4b981ec5$var$getFabricTheme(theme, dir === "rtl")
        }
    }, renderedContent);
    return renderedContent;
}
function $f889493d4b981ec5$var$useApplyThemeToBody(applyThemeToBody, _a, rootElement) {
    var bodyThemed = _a.bodyThemed;
    $acw62.useEffect(function() {
        if (applyThemeToBody) {
            var currentDoc_1 = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(rootElement.current);
            if (currentDoc_1) {
                currentDoc_1.body.classList.add(bodyThemed);
                return function() {
                    currentDoc_1.body.classList.remove(bodyThemed);
                };
            }
        }
    }, [
        bodyThemed,
        applyThemeToBody,
        rootElement
    ]);
    return rootElement;
}



var $578e9deb1e5673a4$var$inheritFont = {
    fontFamily: "inherit"
};
var $578e9deb1e5673a4$var$GlobalClassNames = {
    root: "ms-Fabric",
    bodyThemed: "ms-Fabric-bodyThemed"
};
var $578e9deb1e5673a4$export$ffd58b7f6f099a57 = function(props) {
    var applyTheme = props.applyTheme, className = props.className, preventBlanketFontInheritance = props.preventBlanketFontInheritance, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($578e9deb1e5673a4$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: theme.palette.neutralPrimary
            },
            !preventBlanketFontInheritance && {
                "& button": $578e9deb1e5673a4$var$inheritFont,
                "& input": $578e9deb1e5673a4$var$inheritFont,
                "& textarea": $578e9deb1e5673a4$var$inheritFont
            },
            // apply theme to only if applyTheme is true
            applyTheme && {
                color: theme.semanticColors.bodyText,
                backgroundColor: theme.semanticColors.bodyBackground
            },
            className
        ],
        bodyThemed: [
            {
                backgroundColor: theme.semanticColors.bodyBackground
            }
        ]
    };
};


var $be4e78d7f9eccc5a$export$9c88c10c19390bf2 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $f889493d4b981ec5$export$e4aae1774125dd2f), (0, $578e9deb1e5673a4$export$ffd58b7f6f099a57), undefined, {
    scope: "Fabric"
});


/**
 * Sets the virtual parent of an element.
 * Pass `undefined` as the `parent` to clear the virtual parent.
 *
 * @public
 */ function $e2a8102ee715fdfe$export$9bba5276a9c4d47(child, parent) {
    var virtualChild = child;
    var virtualParent = parent;
    if (!virtualChild._virtual) virtualChild._virtual = {
        children: []
    };
    var oldParent = virtualChild._virtual.parent;
    if (oldParent && oldParent !== parent) {
        // Remove the child from its old parent.
        var index = oldParent._virtual.children.indexOf(virtualChild);
        if (index > -1) oldParent._virtual.children.splice(index, 1);
    }
    virtualChild._virtual.parent = virtualParent || undefined;
    if (virtualParent) {
        if (!virtualParent._virtual) virtualParent._virtual = {
            children: []
        };
        virtualParent._virtual.children.push(virtualChild);
    }
}


var $7dfac6b046c9f384$var$_layersByHostId = {};
var $7dfac6b046c9f384$var$_layerHostsById = {};
var $7dfac6b046c9f384$var$defaultHostId = "fluent-default-layer-host";
var $7dfac6b046c9f384$var$_defaultHostSelector = "#".concat($7dfac6b046c9f384$var$defaultHostId);
function $7dfac6b046c9f384$export$1229b260902b7551(hostId, callback) {
    if (!$7dfac6b046c9f384$var$_layersByHostId[hostId]) $7dfac6b046c9f384$var$_layersByHostId[hostId] = [];
    $7dfac6b046c9f384$var$_layersByHostId[hostId].push(callback);
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) for(var _i = 0, layerHosts_1 = layerHosts; _i < layerHosts_1.length; _i++){
        var layerHost = layerHosts_1[_i];
        layerHost.notifyLayersChanged();
    }
}
function $7dfac6b046c9f384$export$99742cfcbbb7d974(hostId, callback) {
    var layers = $7dfac6b046c9f384$var$_layersByHostId[hostId];
    if (layers) {
        var idx = layers.indexOf(callback);
        if (idx >= 0) {
            layers.splice(idx, 1);
            if (layers.length === 0) delete $7dfac6b046c9f384$var$_layersByHostId[hostId];
        }
    }
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) for(var _i = 0, layerHosts_2 = layerHosts; _i < layerHosts_2.length; _i++){
        var layerHost = layerHosts_2[_i];
        layerHost.notifyLayersChanged();
    }
}
function $7dfac6b046c9f384$export$53fc4645c2516081(hostId) {
    var layers = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    return layers ? layers.length : 0;
}
function $7dfac6b046c9f384$export$5e1d5bc18f3e89d1(hostId) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    return layerHosts && layerHosts[0] || undefined;
}
function $7dfac6b046c9f384$export$f8f2368bc87a5ad4(hostId, layerHost) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId] || ($7dfac6b046c9f384$var$_layerHostsById[hostId] = []);
    // Insert this at the start of an array to avoid race conditions between mount and unmount.
    // If a LayerHost is re-mounted, and mount of the new instance may occur before the unmount of the old one.
    // Putting the new instance at the start of this array ensures that calls to `getLayerHost` will immediately
    // get the new one even if the old one is around briefly.
    layerHosts.unshift(layerHost);
}
function $7dfac6b046c9f384$export$fe3922105a2d30ad(hostId, layerHost) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) {
        var idx = layerHosts.indexOf(layerHost);
        if (idx >= 0) layerHosts.splice(idx, 1);
        if (layerHosts.length === 0) delete $7dfac6b046c9f384$var$_layerHostsById[hostId];
    }
}
function $7dfac6b046c9f384$export$69a1b8986fe349a3(doc) {
    var host = doc.createElement("div");
    host.setAttribute("id", $7dfac6b046c9f384$var$defaultHostId);
    host.style.cssText = "position:fixed;z-index:1000000";
    doc === null || doc === void 0 || doc.body.appendChild(host);
    return host;
}
function $7dfac6b046c9f384$export$ffd4678a99119173(doc) {
    var host = doc.querySelector("#".concat($7dfac6b046c9f384$var$defaultHostId));
    if (host) doc.removeChild(host);
}
function $7dfac6b046c9f384$export$c14456671080cd6f(id) {
    if ($7dfac6b046c9f384$var$_layersByHostId[id]) $7dfac6b046c9f384$var$_layersByHostId[id].forEach(function(callback) {
        return callback();
    });
}
function $7dfac6b046c9f384$export$46538688e1f98dc4(selector) {
    $7dfac6b046c9f384$var$_defaultHostSelector = selector;
}
function $7dfac6b046c9f384$export$a7e6e434b174d91d() {
    return $7dfac6b046c9f384$var$_defaultHostSelector;
}



var $f185cc45f08d011c$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $f185cc45f08d011c$var$getFocusVisibility = function(providerRef) {
    if (providerRef === null || providerRef === void 0 ? void 0 : providerRef.current) return providerRef.current.classList.contains((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf));
    return false;
};
var $f185cc45f08d011c$export$fce5e14267d0afbe = $acw62.forwardRef(function(props, ref) {
    var registerPortalEl = (0, $a6dcfff088e996dd$export$712a597a27357a15)();
    var rootRef = $acw62.useRef(null);
    var mergedRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, ref);
    var layerRef = $acw62.useRef();
    var fabricElementRef = $acw62.useRef(null);
    var focusContext = $acw62.useContext((0, $872a30e3c6519016$export$683969f4bf72ffbd));
    // Tracks if the layer mount events need to be raised.
    // Required to allow the DOM to render after the layer element is added.
    var _a = $acw62.useState(false), needRaiseLayerMount = _a[0], setNeedRaiseLayerMount = _a[1];
    // Sets the focus visible className when the FocusRectsProvider for the layer is rendered
    // This allows the current focus visibility style to be carried over to the layer content
    var focusRectsRef = $acw62.useCallback(function(el) {
        var isFocusVisible = $f185cc45f08d011c$var$getFocusVisibility(focusContext === null || focusContext === void 0 ? void 0 : focusContext.providerRef);
        if (el && isFocusVisible) el.classList.add((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf));
    }, [
        focusContext
    ]);
    var children = props.children, className = props.className, eventBubblingEnabled = props.eventBubblingEnabled, fabricProps = props.fabricProps, hostId = props.hostId, insertFirst = props.insertFirst, _b = props.onLayerDidMount, onLayerDidMount = _b === void 0 ? function() {
        return undefined;
    } : _b, // eslint-disable-next-line deprecation/deprecation
    _c = props.onLayerMounted, // eslint-disable-next-line deprecation/deprecation
    onLayerMounted = _c === void 0 ? function() {
        return undefined;
    } : _c, onLayerWillUnmount = props.onLayerWillUnmount, styles = props.styles, theme = props.theme;
    var fabricRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(fabricElementRef, fabricProps === null || fabricProps === void 0 ? void 0 : fabricProps.ref, focusRectsRef);
    var classNames = $f185cc45f08d011c$var$getClassNames(styles, {
        theme: theme,
        className: className,
        isNotHost: !hostId
    });
    // Returns the user provided hostId props element, the default target selector,
    // or undefined if document doesn't exist.
    var getHost = function(doc) {
        var _a, _b;
        if (hostId) {
            var layerHost = (0, $7dfac6b046c9f384$export$5e1d5bc18f3e89d1)(hostId);
            if (layerHost) return (_a = layerHost.rootRef.current) !== null && _a !== void 0 ? _a : null;
            return (_b = doc.getElementById(hostId)) !== null && _b !== void 0 ? _b : null;
        } else {
            var defaultHostSelector = (0, $7dfac6b046c9f384$export$a7e6e434b174d91d)();
            // Find the host.
            var host = defaultHostSelector ? doc.querySelector(defaultHostSelector) : null;
            // If no host is available, create a container for injecting layers in.
            // Having a container scopes layout computation.
            if (!host) host = (0, $7dfac6b046c9f384$export$69a1b8986fe349a3)(doc);
            return host;
        }
    };
    // Removes the current layer element's parentNode and runs onLayerWillUnmount prop if provided.
    var removeLayerElement = function() {
        onLayerWillUnmount === null || onLayerWillUnmount === void 0 || onLayerWillUnmount();
        var elem = layerRef.current;
        // Clear ref before removing from the DOM
        layerRef.current = undefined;
        if (elem && elem.parentNode) elem.parentNode.removeChild(elem);
    };
    // If a doc or host exists, it will remove and update layer parentNodes.
    var createLayerElement = function() {
        var _a;
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(rootRef.current);
        if (!doc) return;
        var host = getHost(doc);
        if (!host) return;
        // Remove and re-create any previous existing layer elements.
        removeLayerElement();
        var el = ((_a = host.ownerDocument) !== null && _a !== void 0 ? _a : doc).createElement("div");
        el.className = classNames.root;
        (0, $d38428ba3ade01f7$export$c36b8a5db804ed10)(el);
        (0, $e2a8102ee715fdfe$export$9bba5276a9c4d47)(el, rootRef.current);
        insertFirst ? host.insertBefore(el, host.firstChild) : host.appendChild(el);
        layerRef.current = el;
        setNeedRaiseLayerMount(true);
    };
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        createLayerElement();
        // Check if the user provided a hostId prop and register the layer with the ID.
        if (hostId) (0, $7dfac6b046c9f384$export$1229b260902b7551)(hostId, createLayerElement);
        var unregisterPortalEl = layerRef.current ? registerPortalEl(layerRef.current) : undefined;
        return function() {
            if (unregisterPortalEl) unregisterPortalEl();
            removeLayerElement();
            if (hostId) (0, $7dfac6b046c9f384$export$99742cfcbbb7d974)(hostId, createLayerElement);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should run if the hostId updates.
    }, [
        hostId
    ]);
    $acw62.useEffect(function() {
        if (layerRef.current && needRaiseLayerMount) {
            onLayerMounted === null || onLayerMounted === void 0 || onLayerMounted();
            onLayerDidMount === null || onLayerDidMount === void 0 || onLayerDidMount();
            setNeedRaiseLayerMount(false);
        }
    }, [
        needRaiseLayerMount,
        onLayerMounted,
        onLayerDidMount
    ]);
    $f185cc45f08d011c$var$useDebugWarnings(props);
    return $acw62.createElement("span", {
        className: "ms-layer",
        ref: mergedRef
    }, layerRef.current && $1u0KT.createPortal($acw62.createElement((0, $0a0122a1daf8e02f$export$7f9071f49e01dae9), {
        layerRoot: true,
        providerRef: fabricRef
    }, $acw62.createElement((0, $be4e78d7f9eccc5a$export$9c88c10c19390bf2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, !eventBubblingEnabled && $f185cc45f08d011c$var$getFilteredEvents(), fabricProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.content, fabricProps === null || fabricProps === void 0 ? void 0 : fabricProps.className),
        ref: fabricRef
    }), children)), layerRef.current));
});
$f185cc45f08d011c$export$fce5e14267d0afbe.displayName = "LayerBase";
var $f185cc45f08d011c$var$filteredEventProps;
var $f185cc45f08d011c$var$onFilterEvent = function(ev) {
    // We should just be able to check ev.bubble here and only stop events that are bubbling up. However, even though
    // mouseenter and mouseleave do NOT bubble up, they are showing up as bubbling. Therefore we stop events based on
    // event name rather than ev.bubble.
    if (ev.eventPhase === Event.BUBBLING_PHASE && ev.type !== "mouseenter" && ev.type !== "mouseleave" && ev.type !== "touchstart" && ev.type !== "touchend") ev.stopPropagation();
};
function $f185cc45f08d011c$var$getFilteredEvents() {
    if (!$f185cc45f08d011c$var$filteredEventProps) {
        $f185cc45f08d011c$var$filteredEventProps = {};
        [
            "onClick",
            "onContextMenu",
            "onDoubleClick",
            "onDrag",
            "onDragEnd",
            "onDragEnter",
            "onDragExit",
            "onDragLeave",
            "onDragOver",
            "onDragStart",
            "onDrop",
            "onMouseDown",
            "onMouseEnter",
            "onMouseLeave",
            "onMouseMove",
            "onMouseOver",
            "onMouseOut",
            "onMouseUp",
            "onTouchMove",
            "onTouchStart",
            "onTouchCancel",
            "onTouchEnd",
            "onKeyDown",
            "onKeyPress",
            "onKeyUp",
            "onFocus",
            "onBlur",
            "onChange",
            "onInput",
            "onInvalid",
            "onSubmit"
        ].forEach(function(name) {
            return $f185cc45f08d011c$var$filteredEventProps[name] = $f185cc45f08d011c$var$onFilterEvent;
        });
    }
    return $f185cc45f08d011c$var$filteredEventProps;
}
function $f185cc45f08d011c$var$useDebugWarnings(props) {}



var $9782235cb00753f1$var$GlobalClassNames = {
    root: "ms-Layer",
    rootNoHost: "ms-Layer--fixed",
    content: "ms-Layer-content"
};
var $9782235cb00753f1$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, isNotHost = props.isNotHost, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($9782235cb00753f1$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isNotHost && [
                classNames.rootNoHost,
                {
                    position: "fixed",
                    zIndex: (0, $e718b14ff8496161$export$ee30d3e11c8625f1).Layer,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    visibility: "hidden"
                }
            ],
            className
        ],
        content: [
            classNames.content,
            {
                visibility: "visible"
            }
        ]
    };
};


var $0644c419e4ac4578$export$936d0764594b6eb3 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $f185cc45f08d011c$export$fce5e14267d0afbe), (0, $9782235cb00753f1$export$ffd58b7f6f099a57), undefined, {
    scope: "Layer",
    fields: [
        "hostId",
        "theme",
        "styles"
    ]
});


var $bb8160ea11d5c986$export$97a5aca3dea8edc7 = $acw62.forwardRef(function(_a, forwardedRef) {
    var layerProps = _a.layerProps, doNotLayer = _a.doNotLayer, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "layerProps",
        "doNotLayer"
    ]);
    var content = $acw62.createElement((0, $57cf9e0ffad9e5e0$export$f6122ee2215f6f10), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest, {
        doNotLayer: doNotLayer,
        ref: forwardedRef
    }));
    return doNotLayer ? content : $acw62.createElement((0, $0644c419e4ac4578$export$936d0764594b6eb3), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, layerProps), content);
});
$bb8160ea11d5c986$export$97a5aca3dea8edc7.displayName = "Callout";





var $acw62 = parcelRequire("acw62");



var $840dfb0754982edd$var$defaultIconRenderer = function(props) {
    var item = props.item, classNames = props.classNames;
    var iconProps = item.iconProps;
    return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, iconProps, {
        className: classNames.icon
    }));
};
var $840dfb0754982edd$var$renderItemIcon = function(props) {
    var item = props.item, hasIcons = props.hasIcons;
    if (!hasIcons) return null;
    if (item.onRenderIcon) return item.onRenderIcon(props, $840dfb0754982edd$var$defaultIconRenderer);
    return $840dfb0754982edd$var$defaultIconRenderer(props);
};
var $840dfb0754982edd$var$renderCheckMarkIcon = function(_a) {
    var onCheckmarkClick = _a.onCheckmarkClick, item = _a.item, classNames = _a.classNames;
    var isItemChecked = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item);
    if (onCheckmarkClick) {
        // Ensures that the item is passed as the first argument to the checkmark click callback.
        var onClick = function(e) {
            return onCheckmarkClick(item, e);
        };
        return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            iconName: item.canCheck !== false && isItemChecked ? "CheckMark" : "",
            className: classNames.checkmarkIcon,
            // eslint-disable-next-line react/jsx-no-bind
            onClick: onClick
        });
    }
    return null;
};
var $840dfb0754982edd$var$renderItemName = function(_a) {
    var item = _a.item, classNames = _a.classNames;
    /* eslint-disable deprecation/deprecation */ if (item.text || item.name) return $acw62.createElement("span", {
        className: classNames.label
    }, item.text || item.name);
    /* eslint-enable deprecation/deprecation */ return null;
};
var $840dfb0754982edd$var$renderSecondaryText = function(_a) {
    var item = _a.item, classNames = _a.classNames;
    if (item.secondaryText) return $acw62.createElement("span", {
        className: classNames.secondaryText
    }, item.secondaryText);
    return null;
};
var $840dfb0754982edd$var$renderSubMenuIcon = function(_a) {
    var item = _a.item, classNames = _a.classNames, theme = _a.theme;
    if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        iconName: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? "ChevronLeft" : "ChevronRight"
    }, item.submenuIconProps, {
        className: classNames.subMenuIcon
    }));
    return null;
};
var $840dfb0754982edd$export$629e0691500c5c6a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuItemBase, _super);
    function ContextualMenuItemBase(props) {
        var _this = _super.call(this, props) || this;
        _this.openSubMenu = function() {
            var _a = _this.props, item = _a.item, openSubMenu = _a.openSubMenu, getSubmenuTarget = _a.getSubmenuTarget;
            if (getSubmenuTarget) {
                var submenuTarget = getSubmenuTarget();
                if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && openSubMenu && submenuTarget) openSubMenu(item, submenuTarget);
            }
        };
        _this.dismissSubMenu = function() {
            var _a = _this.props, item = _a.item, dismissSubMenu = _a.dismissSubMenu;
            if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && dismissSubMenu) dismissSubMenu();
        };
        _this.dismissMenu = function(dismissAll) {
            var dismissMenu = _this.props.dismissMenu;
            if (dismissMenu) dismissMenu(undefined /* ev */ , dismissAll);
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    ContextualMenuItemBase.prototype.render = function() {
        var _a = this.props, item = _a.item, classNames = _a.classNames;
        var renderContent = item.onRenderContent || this._renderLayout;
        return $acw62.createElement("div", {
            className: item.split ? classNames.linkContentMenu : classNames.linkContent
        }, renderContent(this.props, {
            renderCheckMarkIcon: $840dfb0754982edd$var$renderCheckMarkIcon,
            renderItemIcon: $840dfb0754982edd$var$renderItemIcon,
            renderItemName: $840dfb0754982edd$var$renderItemName,
            renderSecondaryText: $840dfb0754982edd$var$renderSecondaryText,
            renderSubMenuIcon: $840dfb0754982edd$var$renderSubMenuIcon
        }));
    };
    ContextualMenuItemBase.prototype._renderLayout = function(props, defaultRenders) {
        return $acw62.createElement($acw62.Fragment, null, defaultRenders.renderCheckMarkIcon(props), defaultRenders.renderItemIcon(props), defaultRenders.renderItemName(props), defaultRenders.renderSecondaryText(props), defaultRenders.renderSubMenuIcon(props));
    };
    return ContextualMenuItemBase;
}($acw62.Component);




var $3efc3c3b4ad2794c$export$ef1a4c000b9663fc = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(// eslint-disable-next-line deprecation/deprecation
function(theme) {
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
        wrapper: {
            display: "inline-flex",
            height: "100%",
            alignItems: "center"
        },
        divider: {
            width: 1,
            height: "100%",
            backgroundColor: theme.palette.neutralTertiaryAlt
        }
    });
});





var $194675c1c18101b9$export$f4ed060eaa49a3 = 36;
var $194675c1c18101b9$var$MediumScreenSelector = (0, $905fed6f1ccd845a$export$be136f2e7621e736)(0, (0, $905fed6f1ccd845a$export$af97800cf211974a));
var $194675c1c18101b9$export$adaad53e003c74d0 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme) {
    var _a, _b, _c, _d, _e;
    var semanticColors = theme.semanticColors, fonts = theme.fonts, palette = theme.palette;
    var ContextualMenuItemBackgroundHoverColor = semanticColors.menuItemBackgroundHovered;
    var ContextualMenuItemTextHoverColor = semanticColors.menuItemTextHovered;
    var ContextualMenuItemBackgroundSelectedColor = semanticColors.menuItemBackgroundPressed;
    var ContextualMenuItemDividerColor = semanticColors.bodyDivider;
    var menuItemStyles = {
        item: [
            fonts.medium,
            {
                color: semanticColors.bodyText,
                position: "relative",
                boxSizing: "border-box"
            }
        ],
        divider: {
            display: "block",
            height: "1px",
            backgroundColor: ContextualMenuItemDividerColor,
            position: "relative"
        },
        root: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            fonts.medium,
            {
                color: semanticColors.bodyText,
                backgroundColor: "transparent",
                border: "none",
                width: "100%",
                height: $194675c1c18101b9$export$f4ed060eaa49a3,
                lineHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
                display: "block",
                cursor: "pointer",
                padding: "0px 8px 0 4px",
                textAlign: "left"
            }
        ],
        rootDisabled: {
            color: semanticColors.disabledBodyText,
            cursor: "default",
            pointerEvents: "none",
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                // ensure disabled text looks different than enabled
                color: "GrayText",
                opacity: 1
            }, _a)
        },
        rootHovered: {
            backgroundColor: ContextualMenuItemBackgroundHoverColor,
            color: ContextualMenuItemTextHoverColor,
            selectors: {
                ".ms-ContextualMenu-icon": {
                    color: palette.themeDarkAlt
                },
                ".ms-ContextualMenu-submenuIcon": {
                    color: palette.neutralPrimary
                }
            }
        },
        rootFocused: {
            backgroundColor: palette.white
        },
        rootChecked: {
            selectors: {
                ".ms-ContextualMenu-checkmarkIcon": {
                    color: palette.neutralPrimary
                }
            }
        },
        rootPressed: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            selectors: {
                ".ms-ContextualMenu-icon": {
                    color: palette.themeDark
                },
                ".ms-ContextualMenu-submenuIcon": {
                    color: palette.neutralPrimary
                }
            }
        },
        rootExpanded: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            color: semanticColors.bodyTextChecked,
            selectors: (_b = {
                ".ms-ContextualMenu-submenuIcon": (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    // icons inside of anchor tags are not properly inheriting color in high contrast
                    color: "inherit"
                }, _c)
            }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _b)
        },
        linkContent: {
            whiteSpace: "nowrap",
            height: "inherit",
            display: "flex",
            alignItems: "center",
            maxWidth: "100%"
        },
        anchorLink: {
            padding: "0px 8px 0 4px",
            textRendering: "auto",
            color: "inherit",
            letterSpacing: "normal",
            wordSpacing: "normal",
            textTransform: "none",
            textIndent: "0px",
            textShadow: "none",
            textDecoration: "none",
            boxSizing: "border-box"
        },
        label: {
            margin: "0 4px",
            verticalAlign: "middle",
            display: "inline-block",
            flexGrow: "1",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        secondaryText: {
            color: theme.palette.neutralSecondary,
            paddingLeft: "20px",
            textAlign: "right"
        },
        icon: {
            display: "inline-block",
            minHeight: "1px",
            maxHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
            fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
            width: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
            margin: "0 4px",
            verticalAlign: "middle",
            flexShrink: "0",
            selectors: (_d = {}, _d[$194675c1c18101b9$var$MediumScreenSelector] = {
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large,
                width: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large
            }, _d)
        },
        iconColor: {
            color: semanticColors.menuIcon
        },
        iconDisabled: {
            color: semanticColors.disabledBodyText
        },
        checkmarkIcon: {
            color: semanticColors.bodySubtext
        },
        subMenuIcon: {
            height: $194675c1c18101b9$export$f4ed060eaa49a3,
            lineHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
            color: palette.neutralSecondary,
            textAlign: "center",
            display: "inline-block",
            verticalAlign: "middle",
            flexShrink: "0",
            fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).small,
            selectors: (_e = {
                ":hover": {
                    color: palette.neutralPrimary
                },
                ":active": {
                    color: palette.neutralPrimary
                }
            }, _e[$194675c1c18101b9$var$MediumScreenSelector] = {
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium
            }, _e)
        },
        splitButtonFlexContainer: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            {
                display: "flex",
                height: $194675c1c18101b9$export$f4ed060eaa49a3,
                flexWrap: "nowrap",
                justifyContent: "center",
                alignItems: "flex-start"
            }
        ]
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(menuItemStyles);
});




var $b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH = "28px";
var $b0ea91f2e2fa7180$var$MediumScreenSelector = (0, $905fed6f1ccd845a$export$be136f2e7621e736)(0, (0, $905fed6f1ccd845a$export$af97800cf211974a));
var $b0ea91f2e2fa7180$export$c554b00c240727fe = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(/* eslint-disable deprecation/deprecation */ function(theme) {
    var _a;
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)((0, $3efc3c3b4ad2794c$export$ef1a4c000b9663fc)(theme), {
        /* eslint-enable deprecation/deprecation */ wrapper: {
            position: "absolute",
            right: 28,
            selectors: (_a = {}, _a[$b0ea91f2e2fa7180$var$MediumScreenSelector] = {
                right: 32
            }, _a)
        },
        divider: {
            height: 16,
            width: 1
        }
    });
});
var $b0ea91f2e2fa7180$var$GlobalClassNames = {
    item: "ms-ContextualMenu-item",
    divider: "ms-ContextualMenu-divider",
    root: "ms-ContextualMenu-link",
    isChecked: "is-checked",
    isExpanded: "is-expanded",
    isDisabled: "is-disabled",
    linkContent: "ms-ContextualMenu-linkContent",
    linkContentMenu: "ms-ContextualMenu-linkContent",
    icon: "ms-ContextualMenu-icon",
    iconColor: "ms-ContextualMenu-iconColor",
    checkmarkIcon: "ms-ContextualMenu-checkmarkIcon",
    subMenuIcon: "ms-ContextualMenu-submenuIcon",
    label: "ms-ContextualMenu-itemText",
    secondaryText: "ms-ContextualMenu-secondaryText",
    splitMenu: "ms-ContextualMenu-splitMenu",
    screenReaderText: "ms-ContextualMenu-screenReaderText"
};
var $b0ea91f2e2fa7180$export$4e2f85cdf7cc1c08 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className) {
    var _a, _b, _c, _d;
    var styles = (0, $194675c1c18101b9$export$adaad53e003c74d0)(theme);
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($b0ea91f2e2fa7180$var$GlobalClassNames, theme);
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
        item: [
            classNames.item,
            styles.item,
            itemClassName
        ],
        divider: [
            classNames.divider,
            styles.divider,
            dividerClassName
        ],
        root: [
            classNames.root,
            styles.root,
            checked && [
                classNames.isChecked,
                styles.rootChecked
            ],
            isAnchorLink && styles.anchorLink,
            expanded && [
                classNames.isExpanded,
                styles.rootExpanded
            ],
            disabled && [
                classNames.isDisabled,
                styles.rootDisabled
            ],
            !disabled && !expanded && [
                {
                    selectors: (_a = {
                        ":hover": styles.rootHovered,
                        ":active": styles.rootPressed
                    }, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover")] = styles.rootFocused, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover")] = {
                        background: "inherit;"
                    }, _a)
                }
            ],
            className
        ],
        splitPrimary: [
            styles.root,
            {
                width: "calc(100% - ".concat($b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH, ")")
            },
            checked && [
                "is-checked",
                styles.rootChecked
            ],
            (disabled || primaryDisabled) && [
                "is-disabled",
                styles.rootDisabled
            ],
            !(disabled || primaryDisabled) && !checked && [
                {
                    selectors: (_b = {
                        ":hover": styles.rootHovered
                    }, // when hovering over the splitPrimary also affect the splitMenu
                    _b[":hover ~ .".concat(classNames.splitMenu)] = styles.rootHovered, _b[":active"] = styles.rootPressed, _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover")] = styles.rootFocused, _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover")] = {
                        background: "inherit;"
                    }, _b)
                }
            ]
        ],
        splitMenu: [
            classNames.splitMenu,
            styles.root,
            {
                flexBasis: "0",
                padding: "0 8px",
                minWidth: $b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH
            },
            expanded && [
                "is-expanded",
                styles.rootExpanded
            ],
            disabled && [
                "is-disabled",
                styles.rootDisabled
            ],
            !disabled && !expanded && [
                {
                    selectors: (_c = {
                        ":hover": styles.rootHovered,
                        ":active": styles.rootPressed
                    }, _c[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover")] = styles.rootFocused, _c[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover")] = {
                        background: "inherit;"
                    }, _c)
                }
            ]
        ],
        anchorLink: styles.anchorLink,
        linkContent: [
            classNames.linkContent,
            styles.linkContent
        ],
        linkContentMenu: [
            classNames.linkContentMenu,
            styles.linkContent,
            {
                justifyContent: "center"
            }
        ],
        icon: [
            classNames.icon,
            knownIcon && styles.iconColor,
            styles.icon,
            iconClassName,
            disabled && [
                classNames.isDisabled,
                styles.iconDisabled
            ]
        ],
        iconColor: styles.iconColor,
        checkmarkIcon: [
            classNames.checkmarkIcon,
            knownIcon && styles.checkmarkIcon,
            styles.icon,
            iconClassName
        ],
        subMenuIcon: [
            classNames.subMenuIcon,
            styles.subMenuIcon,
            subMenuClassName,
            expanded && {
                color: theme.palette.neutralPrimary
            },
            disabled && [
                styles.iconDisabled
            ]
        ],
        label: [
            classNames.label,
            styles.label
        ],
        secondaryText: [
            classNames.secondaryText,
            styles.secondaryText
        ],
        splitContainer: [
            styles.splitButtonFlexContainer,
            !disabled && !checked && [
                {
                    selectors: (_d = {}, _d[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover")] = styles.rootFocused, _d)
                }
            ]
        ],
        screenReaderText: [
            classNames.screenReaderText,
            styles.screenReaderText,
            (0, $34563ae103a23d08$export$35835471cbe77db4),
            {
                visibility: "hidden"
            }
        ]
    });
});
var $b0ea91f2e2fa7180$export$68f648f9dd4d8263 = function(props) {
    var theme = props.theme, disabled = props.disabled, expanded = props.expanded, checked = props.checked, isAnchorLink = props.isAnchorLink, knownIcon = props.knownIcon, itemClassName = props.itemClassName, dividerClassName = props.dividerClassName, iconClassName = props.iconClassName, subMenuClassName = props.subMenuClassName, primaryDisabled = props.primaryDisabled, className = props.className;
    // eslint-disable-next-line deprecation/deprecation
    return $b0ea91f2e2fa7180$export$4e2f85cdf7cc1c08(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className);
};


var $dbc0d5833638f24e$export$4267af6d9e6f3487 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $840dfb0754982edd$export$629e0691500c5c6a), (0, $b0ea91f2e2fa7180$export$68f648f9dd4d8263), undefined, {
    scope: "ContextualMenuItem"
});




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $91ba163d72302a3e$export$d3035c4985d1b359 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuItemWrapper, _super);
    function ContextualMenuItemWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._onItemMouseEnter = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter(item, ev, ev.currentTarget);
        };
        _this._onItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) onItemClickBase(item, ev, ev.currentTarget);
        };
        _this._onItemMouseLeave = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseLeave = _a.onItemMouseLeave;
            if (onItemMouseLeave) onItemMouseLeave(item, ev);
        };
        _this._onItemKeyDown = function(ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            if (onItemKeyDown) onItemKeyDown(item, ev);
        };
        _this._onItemMouseMove = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove(item, ev, ev.currentTarget);
        };
        _this._getSubmenuTarget = function() {
            return undefined;
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    ContextualMenuItemWrapper.prototype.shouldComponentUpdate = function(newProps) {
        return !(0, $f504d2279336999d$export$90e866afbd6b9f1a)(newProps, this.props);
    };
    return ContextualMenuItemWrapper;
}($acw62.Component);



var $b93318a7b1d1c2ef$export$728cf8667bd7c06f = "ktp";
var $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0 = "-";
var $b93318a7b1d1c2ef$export$4083e12f0f38721 = $b93318a7b1d1c2ef$export$728cf8667bd7c06f + $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0;
var $b93318a7b1d1c2ef$export$b075aa67ec3ce39b = "data-ktp-target";
var $b93318a7b1d1c2ef$export$4830628b0416058 = "data-ktp-execute-target";
var $b93318a7b1d1c2ef$export$8c7b9a821b7c114c = "data-ktp-aria-target";
var $b93318a7b1d1c2ef$export$787c3bee7e52cabf = "ktp-layer-id";
var $b93318a7b1d1c2ef$export$cf4a82ab5af0bf5a = ", ";
var $b93318a7b1d1c2ef$export$f121db0802a54d32;
(function(KeytipEvents) {
    KeytipEvents.KEYTIP_ADDED = "keytipAdded";
    KeytipEvents.KEYTIP_REMOVED = "keytipRemoved";
    KeytipEvents.KEYTIP_UPDATED = "keytipUpdated";
    KeytipEvents.PERSISTED_KEYTIP_ADDED = "persistedKeytipAdded";
    KeytipEvents.PERSISTED_KEYTIP_REMOVED = "persistedKeytipRemoved";
    KeytipEvents.PERSISTED_KEYTIP_EXECUTE = "persistedKeytipExecute";
    KeytipEvents.ENTER_KEYTIP_MODE = "enterKeytipMode";
    KeytipEvents.EXIT_KEYTIP_MODE = "exitKeytipMode";
})($b93318a7b1d1c2ef$export$f121db0802a54d32 || ($b93318a7b1d1c2ef$export$f121db0802a54d32 = {}));




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $3ae817ff5fe2ac83$export$5cae361ad82dce8b(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}






function $5da71d0b240ae24c$export$18be6da7299faebb(keySequences) {
    return keySequences.reduce(function(prevValue, keySequence) {
        return prevValue + (0, $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0) + keySequence.split("").join((0, $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0));
    }, (0, $b93318a7b1d1c2ef$export$728cf8667bd7c06f));
}
function $5da71d0b240ae24c$export$b1a802da09324058(keySequences, overflowKeySequences) {
    var overflowSequenceLen = overflowKeySequences.length;
    var overflowSequence = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], overflowKeySequences, true).pop();
    var newKeySequences = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], keySequences, true);
    return (0, $b9105dc723fd02ea$export$df2fbf469f510c97)(newKeySequences, overflowSequenceLen - 1, overflowSequence);
}
function $5da71d0b240ae24c$export$875c435dc78e881f(keySequences) {
    return "[" + (0, $b93318a7b1d1c2ef$export$b075aa67ec3ce39b) + '="' + $5da71d0b240ae24c$export$18be6da7299faebb(keySequences) + '"]';
}
function $5da71d0b240ae24c$export$f973355f195910f8(keytipId) {
    return "[" + (0, $b93318a7b1d1c2ef$export$4830628b0416058) + '="' + keytipId + '"]';
}
function $5da71d0b240ae24c$export$65ef0a02533e7bf7(keySequences) {
    var describedby = " " + (0, $b93318a7b1d1c2ef$export$787c3bee7e52cabf);
    if (!keySequences.length) // Return just the layer ID
    return describedby;
    return describedby + " " + $5da71d0b240ae24c$export$18be6da7299faebb(keySequences);
}




/**
 * This class is responsible for handling registering, updating, and unregistering of keytips
 */ var $3ce833705adf3bff$export$98a3eaa272c56420 = /** @class */ function() {
    function KeytipManager() {
        this.keytips = {};
        this.persistedKeytips = {};
        this.sequenceMapping = {};
        // This is (and should be) updated and kept in sync
        // with the inKeytipMode in KeytipLayer.
        this.inKeytipMode = false;
        // Boolean that gets checked before entering keytip mode by the KeytipLayer
        // Used for an override in special cases (e.g. Disable entering keytip mode when a modal is shown)
        this.shouldEnterKeytipMode = true;
        // Boolean to indicate whether to delay firing an event to update subscribers of
        // keytip data changed.
        this.delayUpdatingKeytipChange = false;
    }
    /**
     * Static function to get singleton KeytipManager instance
     *
     * @returns Singleton KeytipManager instance
     */ KeytipManager.getInstance = function() {
        return this._instance;
    };
    /**
     * Initialization code to set set parameters to define
     * how the KeytipManager handles keytip data.
     *
     * @param delayUpdatingKeytipChange - T/F if we should delay notifiying keytip subscribers
     * of keytip changes
     */ KeytipManager.prototype.init = function(delayUpdatingKeytipChange) {
        this.delayUpdatingKeytipChange = delayUpdatingKeytipChange;
    };
    /**
     * Registers a keytip
     *
     * @param keytipProps - Keytip to register
     * @param persisted - T/F if this keytip should be persisted, default is false
     * @returns Unique ID for this keytip
     */ KeytipManager.prototype.register = function(keytipProps, persisted) {
        if (persisted === void 0) persisted = false;
        var props = keytipProps;
        if (!persisted) {
            // Add the overflowSetSequence if necessary
            props = this.addParentOverflow(keytipProps);
            this.sequenceMapping[props.keySequences.toString()] = props;
        }
        // Create a unique keytip
        var uniqueKeytip = this._getUniqueKtp(props);
        // Add to dictionary
        persisted ? this.persistedKeytips[uniqueKeytip.uniqueID] = uniqueKeytip : this.keytips[uniqueKeytip.uniqueID] = uniqueKeytip;
        // We only want to add something new if we are currently showing keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) {
            var event_1 = persisted ? (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_ADDED : (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_ADDED;
            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, event_1, {
                keytip: props,
                uniqueID: uniqueKeytip.uniqueID
            });
        }
        return uniqueKeytip.uniqueID;
    };
    /**
     * Update a keytip
     *
     * @param keytipProps - Keytip to update
     * @param uniqueID - Unique ID of this keytip
     */ KeytipManager.prototype.update = function(keytipProps, uniqueID) {
        var newKeytipProps = this.addParentOverflow(keytipProps);
        var uniqueKeytip = this._getUniqueKtp(newKeytipProps, uniqueID);
        var oldKeyTip = this.keytips[uniqueID];
        if (oldKeyTip) {
            // Update everything except 'visible'
            uniqueKeytip.keytip.visible = oldKeyTip.keytip.visible;
            // Update keytip in this.keytips
            this.keytips[uniqueID] = uniqueKeytip;
            // Update the sequence to be up to date
            delete this.sequenceMapping[oldKeyTip.keytip.keySequences.toString()];
            this.sequenceMapping[uniqueKeytip.keytip.keySequences.toString()] = uniqueKeytip.keytip;
            // Raise event only if we are currently in keytip mode
            if (this.inKeytipMode || !this.delayUpdatingKeytipChange) (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_UPDATED, {
                keytip: uniqueKeytip.keytip,
                uniqueID: uniqueKeytip.uniqueID
            });
        }
    };
    /**
     * Unregisters a keytip
     *
     * @param keytipToRemove - IKeytipProps of the keytip to remove
     * @param uniqueID - Unique ID of this keytip
     * @param persisted - T/F if this keytip should be persisted, default is false
     */ KeytipManager.prototype.unregister = function(keytipToRemove, uniqueID, persisted) {
        if (persisted === void 0) persisted = false;
        persisted ? delete this.persistedKeytips[uniqueID] : delete this.keytips[uniqueID];
        !persisted && delete this.sequenceMapping[keytipToRemove.keySequences.toString()];
        var event = persisted ? (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_REMOVED : (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_REMOVED;
        // Update keytips only if we're in keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, event, {
            keytip: keytipToRemove,
            uniqueID: uniqueID
        });
    };
    /**
     * Manual call to enter keytip mode
     */ KeytipManager.prototype.enterKeytipMode = function() {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).ENTER_KEYTIP_MODE);
    };
    /**
     * Manual call to exit keytip mode
     */ KeytipManager.prototype.exitKeytipMode = function() {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).EXIT_KEYTIP_MODE);
    };
    /**
     * Gets all IKeytipProps from this.keytips
     *
     * @returns All keytips stored in the manager
     */ KeytipManager.prototype.getKeytips = function() {
        var _this = this;
        return Object.keys(this.keytips).map(function(key) {
            return _this.keytips[key].keytip;
        });
    };
    /**
     * Adds the overflowSetSequence to the keytipProps if its parent keytip also has it
     *
     * @param keytipProps - Keytip props to add overflowSetSequence to if necessary
     * @returns - Modified keytip props, if needed to be modified
     */ KeytipManager.prototype.addParentOverflow = function(keytipProps) {
        var fullSequence = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], keytipProps.keySequences, true);
        fullSequence.pop();
        if (fullSequence.length !== 0) {
            var parentKeytip = this.sequenceMapping[fullSequence.toString()];
            if (parentKeytip && parentKeytip.overflowSetSequence) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                overflowSetSequence: parentKeytip.overflowSetSequence
            });
        }
        return keytipProps;
    };
    /**
     * Public function to bind for overflow items that have a submenu
     */ KeytipManager.prototype.menuExecute = function(overflowButtonSequences, keytipSequences) {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_EXECUTE, {
            overflowButtonSequences: overflowButtonSequences,
            keytipSequences: keytipSequences
        });
    };
    /**
     * Creates an IUniqueKeytip object
     *
     * @param keytipProps - IKeytipProps
     * @param uniqueID - Unique ID, will default to the next unique ID if not passed
     * @returns IUniqueKeytip object
     */ KeytipManager.prototype._getUniqueKtp = function(keytipProps, uniqueID) {
        if (uniqueID === void 0) uniqueID = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        return {
            keytip: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps),
            uniqueID: uniqueID
        };
    };
    KeytipManager._instance = new KeytipManager();
    return KeytipManager;
}();


function $fdf98e2d5c990390$export$566fb23b8c51c119(options) {
    var uniqueId = $acw62.useRef();
    var keytipProps = options.keytipProps ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        disabled: options.disabled
    }, options.keytipProps) : undefined;
    var keytipManager = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)((0, $3ce833705adf3bff$export$98a3eaa272c56420).getInstance());
    var prevOptions = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(options);
    // useLayoutEffect used to strictly emulate didUpdate/didMount behavior
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        if (uniqueId.current && keytipProps && ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.keytipProps) !== options.keytipProps || (prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.disabled) !== options.disabled)) keytipManager.update(keytipProps, uniqueId.current);
    });
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        // Register Keytip in KeytipManager
        if (keytipProps) uniqueId.current = keytipManager.register(keytipProps);
        return function() {
            // Unregister Keytip in KeytipManager
            keytipProps && keytipManager.unregister(keytipProps, uniqueId.current);
        };
    // this is meant to run only at mount, and updates are handled separately
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var nativeKeytipProps = {
        ariaDescribedBy: undefined,
        keytipId: undefined
    };
    if (keytipProps) nativeKeytipProps = $fdf98e2d5c990390$var$getKeytipData(keytipManager, keytipProps, options.ariaDescribedBy);
    return nativeKeytipProps;
}
/**
 * Gets the aria- and data- attributes to attach to the component
 * @param keytipProps - options for Keytip
 * @param describedByPrepend - ariaDescribedBy value to prepend
 */ function $fdf98e2d5c990390$var$getKeytipData(keytipManager, keytipProps, describedByPrepend) {
    // Add the parent overflow sequence if necessary
    var newKeytipProps = keytipManager.addParentOverflow(keytipProps);
    // Construct aria-describedby and data-ktp-id attributes
    var ariaDescribedBy = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(describedByPrepend, (0, $5da71d0b240ae24c$export$65ef0a02533e7bf7)(newKeytipProps.keySequences));
    var keySequences = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], newKeytipProps.keySequences, true);
    if (newKeytipProps.overflowSetSequence) keySequences = (0, $5da71d0b240ae24c$export$b1a802da09324058)(keySequences, newKeytipProps.overflowSetSequence);
    var keytipId = (0, $5da71d0b240ae24c$export$18be6da7299faebb)(keySequences);
    return {
        ariaDescribedBy: ariaDescribedBy,
        keytipId: keytipId
    };
}


var $eb1de6218d550a90$export$fb9facd15f0137af = function(props) {
    var _a;
    var children = props.children, keytipDataProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "children"
    ]);
    var _b = (0, $fdf98e2d5c990390$export$566fb23b8c51c119)(keytipDataProps), keytipId = _b.keytipId, ariaDescribedBy = _b.ariaDescribedBy;
    return children((_a = {}, _a[0, $b93318a7b1d1c2ef$export$b075aa67ec3ce39b] = keytipId, _a[0, $b93318a7b1d1c2ef$export$4830628b0416058] = keytipId, _a["aria-describedby"] = ariaDescribedBy, _a));
};




var $4d34c28d37611dbf$export$53be548a9698e315 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuAnchor, _super);
    function ContextualMenuAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._anchor = $acw62.createRef();
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._getSubmenuTarget = function() {
            return _this._anchor.current ? _this._anchor.current : undefined;
        };
        _this._onItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClick = _a.onItemClick;
            if (onItemClick) onItemClick(item, ev);
        };
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        return _this;
    }
    ContextualMenuAnchor.prototype.render = function() {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var anchorRel = item.rel;
        if (item.target && item.target.toLowerCase() === "_blank") anchorRel = anchorRel ? anchorRel : "nofollow noopener noreferrer"; // Safe default to prevent tabjacking
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(item, (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8));
        var disabled = (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item);
        var itemProps = item.itemProps, ariaDescription = item.ariaDescription;
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaDescribedByIds = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, nativeProps["aria-describedby"]);
        var additionalItemProperties = {
            "aria-describedby": ariaDescribedByIds
        };
        return $acw62.createElement("div", null, $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: item.keytipProps,
            ariaDescribedBy: ariaDescribedByIds,
            disabled: disabled
        }, function(keytipAttributes) {
            return $acw62.createElement("a", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, additionalItemProperties, nativeProps, keytipAttributes, {
                ref: _this._anchor,
                href: item.href,
                target: item.target,
                rel: anchorRel,
                className: classNames.root,
                role: "menuitem",
                "aria-haspopup": itemHasSubmenu || undefined,
                "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
                "aria-posinset": focusableElementIndex + 1,
                "aria-setsize": totalItemCount,
                "aria-disabled": (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                // eslint-disable-next-line deprecation/deprecation
                style: item.style,
                onClick: _this._onItemClick,
                onMouseEnter: _this._onItemMouseEnter,
                onMouseLeave: _this._onItemMouseLeave,
                onMouseMove: _this._onItemMouseMove,
                onKeyDown: itemHasSubmenu ? _this._onItemKeyDown : undefined
            }), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                componentRef: item.componentRef,
                item: item,
                classNames: classNames,
                index: index,
                onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
                hasIcons: hasIcons,
                openSubMenu: openSubMenu,
                dismissSubMenu: dismissSubMenu,
                dismissMenu: dismissMenu,
                getSubmenuTarget: _this._getSubmenuTarget
            }, itemProps)), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        }));
    };
    return ContextualMenuAnchor;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));



var $acw62 = parcelRequire("acw62");





var $5b4ee16a3fe91ee4$export$77db5d9420e58cc5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuButton, _super);
    function ContextualMenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._btn = $acw62.createRef();
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        _this._getSubmenuTarget = function() {
            return _this._btn.current ? _this._btn.current : undefined;
        };
        return _this;
    }
    ContextualMenuButton.prototype.render = function() {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemMouseDown = _a.onItemMouseDown, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var isChecked = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item);
        var canCheck = isChecked !== null;
        var defaultRole = (0, $3250824b6f1d23dc$export$84bfff8e7c9de691)(item);
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var itemProps = item.itemProps, ariaLabel = item.ariaLabel, ariaDescription = item.ariaDescription;
        var buttonNativeProperties = (0, $076f236b4b7f2dc0$export$26fba481281db559)(item, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4));
        // Do not add the disabled attribute to the button so that it is focusable
        delete buttonNativeProperties.disabled;
        var itemRole = item.role || defaultRole;
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaDescribedByIds = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, buttonNativeProperties["aria-describedby"]);
        var itemButtonProperties = {
            className: classNames.root,
            onClick: this._onItemClick,
            onKeyDown: itemHasSubmenu ? this._onItemKeyDown : undefined,
            onMouseEnter: this._onItemMouseEnter,
            onMouseLeave: this._onItemMouseLeave,
            onMouseDown: function(ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMove,
            href: item.href,
            title: item.title,
            "aria-label": ariaLabel,
            "aria-describedby": ariaDescribedByIds,
            "aria-haspopup": itemHasSubmenu || undefined,
            "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
            "aria-posinset": focusableElementIndex + 1,
            "aria-setsize": totalItemCount,
            "aria-disabled": (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
            "aria-checked": (itemRole === "menuitemcheckbox" || itemRole === "menuitemradio") && canCheck ? !!isChecked : undefined,
            "aria-selected": itemRole === "menuitem" && canCheck ? !!isChecked : undefined,
            role: itemRole,
            // eslint-disable-next-line deprecation/deprecation
            style: item.style
        };
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        return $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            ariaDescribedBy: ariaDescribedByIds,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item)
        }, function(keytipAttributes) {
            return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: _this._btn
            }, buttonNativeProperties, itemButtonProperties, keytipAttributes), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                componentRef: item.componentRef,
                item: item,
                classNames: classNames,
                index: index,
                onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
                hasIcons: hasIcons,
                openSubMenu: openSubMenu,
                dismissSubMenu: dismissSubMenu,
                dismissMenu: dismissMenu,
                getSubmenuTarget: _this._getSubmenuTarget
            }, itemProps)), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        });
    };
    return ContextualMenuButton;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));



var $acw62 = parcelRequire("acw62");





var $27fd99f118e7d831$export$ffd58b7f6f099a57 = function(props) {
    // eslint-disable-next-line deprecation/deprecation
    var theme = props.theme, getClassNames = props.getClassNames, className = props.className;
    if (!theme) throw new Error("Theme is undefined or null.");
    if (getClassNames) {
        var names = getClassNames(theme);
        return {
            wrapper: [
                names.wrapper
            ],
            divider: [
                names.divider
            ]
        };
    }
    return {
        wrapper: [
            {
                display: "inline-flex",
                height: "100%",
                alignItems: "center"
            },
            className
        ],
        divider: [
            {
                width: 1,
                height: "100%",
                backgroundColor: theme.palette.neutralTertiaryAlt
            }
        ]
    };
};



var $acw62 = parcelRequire("acw62");

var $3429e7068f747a3b$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $3429e7068f747a3b$export$9f9dad71c8f84f23 = $acw62.forwardRef(function(props, ref) {
    // eslint-disable-next-line deprecation/deprecation
    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
    var classNames = $3429e7068f747a3b$var$getClassNames(styles, {
        theme: theme,
        getClassNames: deprecatedGetClassNames,
        className: className
    });
    return $acw62.createElement("span", {
        className: classNames.wrapper,
        ref: ref
    }, $acw62.createElement("span", {
        className: classNames.divider
    }));
});
$3429e7068f747a3b$export$9f9dad71c8f84f23.displayName = "VerticalDividerBase";



var $9a7e9b73556051a2$export$8da326e5389a0196 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $3429e7068f747a3b$export$9f9dad71c8f84f23), (0, $27fd99f118e7d831$export$ffd58b7f6f099a57), undefined, {
    scope: "VerticalDivider"
});



var $d0192128ae91cb03$var$TouchIdleDelay = 500; /* ms */ 
var $d0192128ae91cb03$export$6b814188c716a895 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuSplitButton, _super);
    function ContextualMenuSplitButton(props) {
        var _this = _super.call(this, props) || this;
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._onItemKeyDown = function(ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            // eslint-disable-next-line deprecation/deprecation
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
                _this._executeItemClick(ev);
                ev.preventDefault();
                ev.stopPropagation();
            } else if (onItemKeyDown) onItemKeyDown(item, ev);
        };
        _this._getSubmenuTarget = function() {
            return _this._splitButton;
        };
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        _this._onItemMouseEnterPrimary = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                subMenuProps: undefined,
                items: undefined
            }), ev, _this._splitButton);
        };
        _this._onItemMouseEnterIcon = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter(item, ev, _this._splitButton);
        };
        _this._onItemMouseMovePrimary = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                subMenuProps: undefined,
                items: undefined
            }), ev, _this._splitButton);
        };
        _this._onItemMouseMoveIcon = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove(item, ev, _this._splitButton);
        };
        _this._onIconItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) onItemClickBase(item, ev, _this._splitButton ? _this._splitButton : ev.currentTarget);
        };
        _this._executeItemClick = function(ev) {
            var _a = _this.props, item = _a.item, executeItemClick = _a.executeItemClick, onItemClick = _a.onItemClick;
            if (item.disabled || item.isDisabled) return;
            if (_this._processingTouch && !item.canCheck && onItemClick) return onItemClick(item, ev);
            if (executeItemClick) executeItemClick(item, ev);
        };
        _this._onTouchStart = function(ev) {
            if (_this._splitButton && !("onpointerdown" in _this._splitButton)) _this._handleTouchAndPointerEvent(ev);
        };
        _this._onPointerDown = function(ev) {
            if (ev.pointerType === "touch") {
                _this._handleTouchAndPointerEvent(ev);
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        };
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this._dismissLabelId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        return _this;
    }
    ContextualMenuSplitButton.prototype.componentDidMount = function() {
        if (this._splitButton && "onpointerdown" in this._splitButton) this._events.on(this._splitButton, "pointerdown", this._onPointerDown, true);
    };
    ContextualMenuSplitButton.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
    };
    ContextualMenuSplitButton.prototype.render = function() {
        var _this = this;
        var _a;
        var _b = this.props, item = _b.item, classNames = _b.classNames, index = _b.index, focusableElementIndex = _b.focusableElementIndex, totalItemCount = _b.totalItemCount, hasCheckmarks = _b.hasCheckmarks, hasIcons = _b.hasIcons, onItemMouseLeave = _b.onItemMouseLeave, expandedMenuItemKey = _b.expandedMenuItemKey;
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var keytipProps = item.keytipProps;
        if (keytipProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        var ariaDescription = item.ariaDescription;
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaChecked = (_a = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item)) !== null && _a !== void 0 ? _a : undefined;
        return $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item)
        }, function(keytipAttributes) {
            return $acw62.createElement("div", {
                "data-ktp-target": keytipAttributes["data-ktp-target"],
                ref: function(splitButton) {
                    return _this._splitButton = splitButton;
                },
                role: (0, $3250824b6f1d23dc$export$84bfff8e7c9de691)(item),
                "aria-label": item.ariaLabel,
                className: classNames.splitContainer,
                "aria-disabled": (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
                "aria-haspopup": true,
                "aria-describedby": (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? _this._ariaDescriptionId : undefined, keytipAttributes["aria-describedby"]),
                "aria-checked": ariaChecked,
                "aria-posinset": focusableElementIndex + 1,
                "aria-setsize": totalItemCount,
                onMouseEnter: _this._onItemMouseEnterPrimary,
                onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(_this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                    subMenuProps: null,
                    items: null
                })) : undefined,
                onMouseMove: _this._onItemMouseMovePrimary,
                onKeyDown: _this._onItemKeyDown,
                onClick: _this._executeItemClick,
                onTouchStart: _this._onTouchStart,
                tabIndex: 0,
                "data-is-focusable": true,
                "aria-roledescription": item["aria-roledescription"]
            }, _this._renderSplitPrimaryButton(item, classNames, index, hasCheckmarks, hasIcons), _this._renderSplitDivider(item), _this._renderSplitIconButton(item, classNames, index, keytipAttributes), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        });
    };
    ContextualMenuSplitButton.prototype._renderSplitPrimaryButton = function(item, // eslint-disable-next-line deprecation/deprecation
    classNames, index, hasCheckmarks, hasIcons) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _b, onItemClick = _a.onItemClick;
        var itemProps = {
            key: item.key,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item) || item.primaryDisabled,
            /* eslint-disable deprecation/deprecation */ name: item.name,
            text: item.text || item.name,
            secondaryText: item.secondaryText,
            /* eslint-enable deprecation/deprecation */ className: classNames.splitPrimary,
            canCheck: item.canCheck,
            isChecked: item.isChecked,
            checked: item.checked,
            iconProps: item.iconProps,
            id: this._dismissLabelId,
            onRenderIcon: item.onRenderIcon,
            data: item.data,
            "data-is-focusable": false
        };
        var itemComponentProps = item.itemProps;
        return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4))), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-is-focusable": false,
            item: itemProps,
            classNames: classNames,
            index: index,
            onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
            hasIcons: hasIcons
        }, itemComponentProps)));
    };
    ContextualMenuSplitButton.prototype._renderSplitDivider = function(item) {
        var getDividerClassNames = item.getSplitButtonVerticalDividerClassNames || (0, $b0ea91f2e2fa7180$export$c554b00c240727fe);
        return $acw62.createElement((0, $9a7e9b73556051a2$export$8da326e5389a0196), {
            getClassNames: getDividerClassNames
        });
    };
    ContextualMenuSplitButton.prototype._renderSplitIconButton = function(item, classNames, index, keytipAttributes) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _b, onItemMouseLeave = _a.onItemMouseLeave, onItemMouseDown = _a.onItemMouseDown, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var itemProps = {
            onClick: this._onIconItemClick,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
            className: classNames.splitMenu,
            subMenuProps: item.subMenuProps,
            submenuIconProps: item.submenuIconProps,
            split: true,
            key: item.key,
            "aria-labelledby": this._dismissLabelId
        };
        var buttonProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4))), {
            onMouseEnter: this._onItemMouseEnterIcon,
            onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(this, item) : undefined,
            onMouseDown: function(ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMoveIcon,
            "data-is-focusable": false,
            "data-ktp-execute-target": keytipAttributes["data-ktp-execute-target"],
            "aria-haspopup": true
        });
        var itemComponentProps = item.itemProps;
        return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, buttonProps), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            componentRef: item.componentRef,
            item: itemProps,
            classNames: classNames,
            index: index,
            hasIcons: false,
            openSubMenu: openSubMenu,
            dismissSubMenu: dismissSubMenu,
            dismissMenu: dismissMenu,
            getSubmenuTarget: this._getSubmenuTarget
        }, itemComponentProps)));
    };
    ContextualMenuSplitButton.prototype._handleTouchAndPointerEvent = function(ev) {
        var _this = this;
        var onTap = this.props.onTap;
        if (onTap) onTap(ev);
        // If we already have an existing timeout from a previous touch/pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function() {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, $d0192128ae91cb03$var$TouchIdleDelay);
    };
    return ContextualMenuSplitButton;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));





parcelRequire("acw62");



var $e896b2d9c1302e32$var$warningId = 0;
function $e896b2d9c1302e32$export$8aeb3a0795e619c9(options) {
    var name_1, props, _a, other, conditionallyRequired, deprecations, mutuallyExclusive, controlledUsage, hasWarnedRef, componentId, oldProps, _i, other_1, warning, _b, conditionallyRequired_1, req;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $0d6bc61d290491ae$var$REACT_LIFECYCLE_EXCLUSIONS = [
    "setState",
    "render",
    "componentWillMount",
    "UNSAFE_componentWillMount",
    "componentDidMount",
    "componentWillReceiveProps",
    "UNSAFE_componentWillReceiveProps",
    "shouldComponentUpdate",
    "componentWillUpdate",
    "getSnapshotBeforeUpdate",
    "UNSAFE_componentWillUpdate",
    "componentDidUpdate",
    "componentWillUnmount"
];
function $0d6bc61d290491ae$export$1cf09497260991e2(// eslint-disable-next-line @typescript-eslint/no-explicit-any
destination, // eslint-disable-next-line @typescript-eslint/no-explicit-any
source, exclusions) {
    if (exclusions === void 0) exclusions = $0d6bc61d290491ae$var$REACT_LIFECYCLE_EXCLUSIONS;
    var hoisted = [];
    var _loop_1 = function(methodName) {
        if (typeof source[methodName] === "function" && destination[methodName] === undefined && (!exclusions || exclusions.indexOf(methodName) === -1)) {
            hoisted.push(methodName);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            destination[methodName] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                source[methodName].apply(source, args);
            };
        }
    };
    for(var methodName in source)_loop_1(methodName);
    return hoisted;
}
function $0d6bc61d290491ae$export$25de49fa50223d1(source, methodNames) {
    methodNames.forEach(function(methodName) {
        return delete source[methodName];
    });
}


var $e763806f79fb847c$export$949383f3ea84aa97 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseDecorator, _super);
    function BaseDecorator(props) {
        var _this = _super.call(this, props) || this;
        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
        return _this;
    }
    /**
     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
     * (and unhoisting as appropriate) methods from said component.
     *
     * Pass this method as the argument to the 'ref' property of the composed component.
     */ BaseDecorator.prototype._updateComposedComponentRef = function(composedComponentInstance) {
        this._composedComponentInstance = composedComponentInstance;
        if (composedComponentInstance) this._hoisted = (0, $0d6bc61d290491ae$export$1cf09497260991e2)(this, composedComponentInstance);
        else if (this._hoisted) (0, $0d6bc61d290491ae$export$25de49fa50223d1)(this, this._hoisted);
    };
    return BaseDecorator;
}($acw62.Component);


/**
 * Allows you to hoist static functions in components.
 * Created for the purpose of fixing broken static functions in classes
 * that utilize decorators.
 *
 * @public
 * @param source - The object where the methods are hoisted from.
 * @param dest - The object to hoist the methods onto.
 * @returns The dest object with methods added
 */ function $05b03fe0c0fe3377$export$e2ba2733092cef57(source, dest) {
    for(var name_1 in source)if (source.hasOwnProperty(name_1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[name_1] = source[name_1];
    return dest;
}



var $d2efee541c4fc734$export$73c2705cb2da08ab;
(function(ResponsiveMode) {
    /** Width \<= 479px */ ResponsiveMode[ResponsiveMode["small"] = 0] = "small";
    /** Width \> 479px and \<= 639px */ ResponsiveMode[ResponsiveMode["medium"] = 1] = "medium";
    /** Width \> 639px and \<= 1023px */ ResponsiveMode[ResponsiveMode["large"] = 2] = "large";
    /** Width \> 1023px and \<= 1365px */ ResponsiveMode[ResponsiveMode["xLarge"] = 3] = "xLarge";
    /** Width \> 1365px and \<= 1919px */ ResponsiveMode[ResponsiveMode["xxLarge"] = 4] = "xxLarge";
    /** Width \> 1919px */ ResponsiveMode[ResponsiveMode["xxxLarge"] = 5] = "xxxLarge";
    ResponsiveMode[ResponsiveMode["unknown"] = 999] = "unknown";
})($d2efee541c4fc734$export$73c2705cb2da08ab || ($d2efee541c4fc734$export$73c2705cb2da08ab = {}));
var $d2efee541c4fc734$var$RESPONSIVE_MAX_CONSTRAINT = [
    479,
    639,
    1023,
    1365,
    1919,
    99999999
];
/**
 * User specified mode to default to, useful for server side rendering scenarios.
 */ var $d2efee541c4fc734$var$_defaultMode;
/**
 * Tracking the last mode we successfully rendered, which allows us to
 * paint initial renders with the correct size.
 */ var $d2efee541c4fc734$var$_lastMode;
function $d2efee541c4fc734$export$1a7882a876dfdc7d(responsiveMode) {
    $d2efee541c4fc734$var$_defaultMode = responsiveMode;
}
function $d2efee541c4fc734$export$8eb25712ef612ed1(element) {
    var currentWindow = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(element);
    if (currentWindow) $d2efee541c4fc734$export$26286068bf03da16(currentWindow);
}
function $d2efee541c4fc734$export$71e9890600a902c8() {
    var _a;
    return (_a = $d2efee541c4fc734$var$_defaultMode !== null && $d2efee541c4fc734$var$_defaultMode !== void 0 ? $d2efee541c4fc734$var$_defaultMode : $d2efee541c4fc734$var$_lastMode) !== null && _a !== void 0 ? _a : $d2efee541c4fc734$export$73c2705cb2da08ab.large;
}
function $d2efee541c4fc734$export$a0079cc4280057ef(ComposedComponent) {
    var _a;
    // eslint-disable-next-line deprecation/deprecation
    var resultClass = (_a = /** @class */ function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(WithResponsiveMode, _super);
        function WithResponsiveMode(props) {
            var _this = _super.call(this, props) || this;
            _this._onResize = function() {
                var responsiveMode = $d2efee541c4fc734$export$26286068bf03da16(_this.context.window);
                if (responsiveMode !== _this.state.responsiveMode) _this.setState({
                    responsiveMode: responsiveMode
                });
            };
            _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
            _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
            _this.state = {
                responsiveMode: $d2efee541c4fc734$export$71e9890600a902c8()
            };
            return _this;
        }
        WithResponsiveMode.prototype.componentDidMount = function() {
            this._events.on(this.context.window, "resize", this._onResize);
            this._onResize();
        };
        WithResponsiveMode.prototype.componentWillUnmount = function() {
            this._events.dispose();
        };
        WithResponsiveMode.prototype.render = function() {
            var responsiveMode = this.state.responsiveMode;
            return responsiveMode === $d2efee541c4fc734$export$73c2705cb2da08ab.unknown ? null : $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: this._updateComposedComponentRef,
                responsiveMode: responsiveMode
            }, this.props));
        };
        return WithResponsiveMode;
    }((0, $e763806f79fb847c$export$949383f3ea84aa97)), _a.contextType = (0, $b139ba3b4431b53f$export$19f5fbe41bba757), _a);
    return (0, $05b03fe0c0fe3377$export$e2ba2733092cef57)(ComposedComponent, resultClass);
}
function $d2efee541c4fc734$var$getWidthOfCurrentWindow(currentWindow) {
    try {
        return currentWindow.document.documentElement.clientWidth;
    } catch (e) {
        return currentWindow.innerWidth;
    }
}
function $d2efee541c4fc734$export$26286068bf03da16(currentWindow) {
    var responsiveMode = $d2efee541c4fc734$export$73c2705cb2da08ab.small;
    if (currentWindow) {
        try {
            while($d2efee541c4fc734$var$getWidthOfCurrentWindow(currentWindow) > $d2efee541c4fc734$var$RESPONSIVE_MAX_CONSTRAINT[responsiveMode])responsiveMode++;
        } catch (e) {
            // Return a best effort result in cases where we're in the browser but it throws on getting innerWidth.
            responsiveMode = $d2efee541c4fc734$export$71e9890600a902c8();
        }
        // Tracking last mode just gives us a better default in future renders,
        // which avoids starting with the wrong value if we've measured once.
        $d2efee541c4fc734$var$_lastMode = responsiveMode;
    } else {
        if ($d2efee541c4fc734$var$_defaultMode !== undefined) responsiveMode = $d2efee541c4fc734$var$_defaultMode;
        else throw new Error("Content was rendered in a server environment without providing a default responsive mode. Call setResponsiveMode to define what the responsive mode is.");
    }
    return responsiveMode;
}


var $acw62 = parcelRequire("acw62");




var $6124a3d3c764767c$export$551dad37f2b289e2 = function(elementRef, overrideResponsiveMode) {
    var _a = $acw62.useState((0, $d2efee541c4fc734$export$71e9890600a902c8)()), lastResponsiveMode = _a[0], setLastResponsiveMode = _a[1];
    var onResize = $acw62.useCallback(function() {
        var newResponsiveMode = (0, $d2efee541c4fc734$export$26286068bf03da16)((0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(elementRef.current));
        // Setting the same value should not cause a re-render.
        if (lastResponsiveMode !== newResponsiveMode) setLastResponsiveMode(newResponsiveMode);
    }, [
        elementRef,
        lastResponsiveMode
    ]);
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(win, "resize", onResize);
    // Call resize function initially on mount, or if the override changes from defined to undefined
    // (the effect will run on all override changes, but onResize will only be called if it changed to undefined)
    $acw62.useEffect(function() {
        if (overrideResponsiveMode === undefined) onResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only meant to run on mount or when override changes
    }, [
        overrideResponsiveMode
    ]);
    return overrideResponsiveMode !== null && overrideResponsiveMode !== void 0 ? overrideResponsiveMode : lastResponsiveMode;
};



var $acw62 = parcelRequire("acw62");
var $247bbbbcfb0b71e2$export$c7e742effb1c51e2 = $acw62.createContext({});
var $247bbbbcfb0b71e2$export$21c7ab35b39f78ec = function() {
    return $acw62.useContext($247bbbbcfb0b71e2$export$c7e742effb1c51e2);
};


var $1f9efb1806e6b3c0$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $1f9efb1806e6b3c0$var$getContextualMenuItemClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
// The default ContextualMenu properties have no items and beak, the default submenu direction is right and top.
var $1f9efb1806e6b3c0$var$DEFAULT_PROPS = {
    items: [],
    shouldFocusOnMount: true,
    gapSpace: 0,
    directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge,
    beakWidth: 16
};
/* return number of menu items, excluding headers and dividers */ function $1f9efb1806e6b3c0$var$getItemCount(items) {
    var totalItemCount = 0;
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        if (item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
            var itemCount = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
            totalItemCount += itemCount;
        }
    }
    return totalItemCount;
}
function $1f9efb1806e6b3c0$export$291de058395e0a1c(item, options) {
    var target = options === null || options === void 0 ? void 0 : options.target;
    // eslint-disable-next-line deprecation/deprecation
    var items = item.subMenuProps ? item.subMenuProps.items : item.items;
    if (items) {
        var overrideItems = [];
        for(var _i = 0, items_2 = items; _i < items_2.length; _i++){
            var subItem = items_2[_i];
            if (subItem.preferMenuTargetAsEventTarget) {
                // For sub-items which need an overridden target, intercept `onClick`
                var onClick = subItem.onClick, contextItem = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(subItem, [
                    "onClick"
                ]);
                overrideItems.push((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, contextItem), {
                    onClick: $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onClick, target)
                }));
            } else overrideItems.push(subItem);
        }
        return overrideItems;
    }
}
function $1f9efb1806e6b3c0$export$2a1d7a07e590a159(items) {
    return items.some(function(item) {
        if (item.canCheck) return true;
        // If the item is a section, check if any of the items in the section can check.
        if (item.sectionProps && item.sectionProps.items.some(function(submenuItem) {
            return submenuItem.canCheck === true;
        })) return true;
        return false;
    });
}
var $1f9efb1806e6b3c0$var$NavigationIdleDelay = 250; /* ms */ 
var $1f9efb1806e6b3c0$var$COMPONENT_NAME = "ContextualMenu";
var $1f9efb1806e6b3c0$var$_getMenuItemStylesFunction = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function() {
    var styles = [];
    for(var _i = 0; _i < arguments.length; _i++)styles[_i] = arguments[_i];
    return function(styleProps) {
        return (0, $386ae5a2cd0e8632$export$5136bfd779f95982).apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            styleProps,
            (0, $b0ea91f2e2fa7180$export$68f648f9dd4d8263)
        ], styles, false));
    };
});
//#region Custom hooks
function $1f9efb1806e6b3c0$var$useVisibility(props, targetWindow) {
    var _a = props.hidden, hidden = _a === void 0 ? false : _a, onMenuDismissed = props.onMenuDismissed, onMenuOpened = props.onMenuOpened;
    var previousHidden = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(hidden);
    var onMenuOpenedRef = $acw62.useRef(onMenuOpened);
    var onMenuClosedRef = $acw62.useRef(onMenuDismissed);
    var propsRef = $acw62.useRef(props);
    onMenuOpenedRef.current = onMenuOpened;
    onMenuClosedRef.current = onMenuDismissed;
    propsRef.current = props;
    $acw62.useEffect(function() {
        var _a, _b;
        // Don't issue dismissed callbacks on initial mount
        if (hidden && previousHidden === false) (_a = onMenuClosedRef.current) === null || _a === void 0 || _a.call(onMenuClosedRef, propsRef.current);
        else if (!hidden && previousHidden !== false) (_b = onMenuOpenedRef.current) === null || _b === void 0 || _b.call(onMenuOpenedRef, propsRef.current);
    }, [
        hidden,
        previousHidden
    ]);
    // Issue onDismissedCallback on unmount
    $acw62.useEffect(function() {
        return function() {
            var _a;
            return (_a = onMenuClosedRef.current) === null || _a === void 0 ? void 0 : _a.call(onMenuClosedRef, propsRef.current);
        };
    }, []);
}
function $1f9efb1806e6b3c0$var$useSubMenuState(_a, dismiss) {
    var hidden = _a.hidden, items = _a.items, theme = _a.theme, className = _a.className, id = _a.id, menuTarget = _a.target;
    var _b = $acw62.useState(), expandedMenuItemKey = _b[0], setExpandedMenuItemKey = _b[1];
    var _c = $acw62.useState(), submenuTarget = _c[0], setSubmenuTarget = _c[1];
    /** True if the menu was expanded by mouse click OR hover (as opposed to by keyboard) */ var _d = $acw62.useState(), shouldFocusOnContainer = _d[0], setShouldFocusOnContainer = _d[1];
    var subMenuId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)($1f9efb1806e6b3c0$var$COMPONENT_NAME, id);
    var closeSubMenu = $acw62.useCallback(function() {
        setShouldFocusOnContainer(undefined);
        setExpandedMenuItemKey(undefined);
        setSubmenuTarget(undefined);
    }, []);
    var openSubMenu = $acw62.useCallback(function(_a, target, focusContainer) {
        var submenuItemKey = _a.key;
        if (expandedMenuItemKey === submenuItemKey) return;
        target.focus();
        setShouldFocusOnContainer(focusContainer);
        setExpandedMenuItemKey(submenuItemKey);
        setSubmenuTarget(target);
    }, [
        expandedMenuItemKey
    ]);
    $acw62.useEffect(function() {
        if (hidden) closeSubMenu();
    }, [
        hidden,
        closeSubMenu
    ]);
    var onSubMenuDismiss = $1f9efb1806e6b3c0$var$useOnSubmenuDismiss(dismiss, closeSubMenu);
    var getSubmenuProps = function() {
        var item = $1f9efb1806e6b3c0$var$findItemByKeyFromItems(expandedMenuItemKey, items);
        var submenuProps = null;
        if (item) {
            submenuProps = {
                items: $1f9efb1806e6b3c0$export$291de058395e0a1c(item, {
                    target: menuTarget
                }),
                target: submenuTarget,
                onDismiss: onSubMenuDismiss,
                isSubMenu: true,
                id: subMenuId,
                shouldFocusOnMount: true,
                shouldFocusOnContainer: shouldFocusOnContainer,
                directionalHint: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $e52f208cfc343b11$export$7bbc434a13063638).leftTopEdge : (0, $e52f208cfc343b11$export$7bbc434a13063638).rightTopEdge,
                className: className,
                gapSpace: 0,
                isBeakVisible: false
            };
            if (item.subMenuProps) (0, $f504d2279336999d$export$e6e34fd1f2686227)(submenuProps, item.subMenuProps);
            if (item.preferMenuTargetAsEventTarget) {
                var onItemClick = item.onItemClick;
                submenuProps.onItemClick = $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onItemClick, menuTarget);
            }
        }
        return submenuProps;
    };
    return [
        expandedMenuItemKey,
        openSubMenu,
        getSubmenuProps,
        onSubMenuDismiss
    ];
}
function $1f9efb1806e6b3c0$var$useShouldUpdateFocusOnMouseMove(_a) {
    var delayUpdateFocusOnHover = _a.delayUpdateFocusOnHover, hidden = _a.hidden;
    var shouldUpdateFocusOnMouseEvent = $acw62.useRef(!delayUpdateFocusOnHover);
    var gotMouseMove = $acw62.useRef(false);
    $acw62.useEffect(function() {
        shouldUpdateFocusOnMouseEvent.current = !delayUpdateFocusOnHover;
        gotMouseMove.current = hidden ? false : !delayUpdateFocusOnHover && gotMouseMove.current;
    }, [
        delayUpdateFocusOnHover,
        hidden
    ]);
    var onMenuFocusCapture = $acw62.useCallback(function() {
        if (delayUpdateFocusOnHover) shouldUpdateFocusOnMouseEvent.current = false;
    }, [
        delayUpdateFocusOnHover
    ]);
    return [
        shouldUpdateFocusOnMouseEvent,
        gotMouseMove,
        onMenuFocusCapture
    ];
}
function $1f9efb1806e6b3c0$var$usePreviousActiveElement(_a, targetWindow, hostElement) {
    var hidden = _a.hidden, onRestoreFocus = _a.onRestoreFocus;
    var previousActiveElement = $acw62.useRef();
    var tryFocusPreviousActiveElement = $acw62.useCallback(function(options) {
        var _a, _b;
        if (onRestoreFocus) onRestoreFocus(options);
        else if (options === null || options === void 0 ? void 0 : options.documentContainsFocus) // Make sure that the focus method actually exists
        // In some cases the object might exist but not be a real element.
        // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
        (_b = (_a = previousActiveElement.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
    }, [
        onRestoreFocus
    ]);
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        var _a, _b;
        if (!hidden) {
            var newElement = targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement;
            if (!((_a = hostElement.current) === null || _a === void 0 ? void 0 : _a.contains(newElement)) && newElement.tagName !== "BODY") previousActiveElement.current = newElement;
        } else if (previousActiveElement.current) {
            tryFocusPreviousActiveElement({
                originalElement: previousActiveElement.current,
                containsFocus: true,
                documentContainsFocus: ((_b = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)()) === null || _b === void 0 ? void 0 : _b.hasFocus()) || false
            });
            previousActiveElement.current = undefined;
        }
    }, [
        hidden,
        targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement,
        tryFocusPreviousActiveElement,
        hostElement
    ]);
    return [
        tryFocusPreviousActiveElement
    ];
}
function $1f9efb1806e6b3c0$var$useKeyHandlers(_a, dismiss, hostElement, openSubMenu) {
    var theme = _a.theme, isSubMenu = _a.isSubMenu, _b = _a.focusZoneProps, _c = _b === void 0 ? {} : _b, checkForNoWrap = _c.checkForNoWrap, _d = _c.direction, focusZoneDirection = _d === void 0 ? (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical : _d;
    /** True if the most recent keydown event was for alt (option) or meta (command). */ var lastKeyDownWasAltOrMeta = $acw62.useRef();
    /**
     * Calls `shouldHandleKey` to determine whether the keyboard event should be handled;
     * if so, stops event propagation and dismisses menu(s).
     * @param ev - The keyboard event.
     * @param shouldHandleKey - Returns whether we should handle this keyboard event.
     * @param dismissAllMenus - If true, dismiss all menus. Otherwise, dismiss only the current menu.
     * Only does anything if `shouldHandleKey` returns true.
     * @returns Whether the event was handled.
     */ var keyHandler = function(ev, shouldHandleKey, dismissAllMenus) {
        var handled = false;
        if (shouldHandleKey(ev)) {
            dismiss(ev, dismissAllMenus);
            ev.preventDefault();
            ev.stopPropagation();
            handled = true;
        }
        return handled;
    };
    /**
     * Checks if the submenu should be closed
     */ var shouldCloseSubMenu = function(ev) {
        var submenuCloseKey = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $c011a102064f82ea$export$ec835b702d42f3f0).right : (0, $c011a102064f82ea$export$ec835b702d42f3f0).left;
        // eslint-disable-next-line deprecation/deprecation
        if (ev.which !== submenuCloseKey || !isSubMenu) return false;
        return !!(focusZoneDirection === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical || checkForNoWrap && !(0, $94bdc1ebed789608$export$841acbea7fb3b182)(ev.target, "data-no-horizontal-wrap"));
    };
    var shouldHandleKeyDown = function(ev) {
        return(// eslint-disable-next-line deprecation/deprecation
        ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape || shouldCloseSubMenu(ev) || // eslint-disable-next-line deprecation/deprecation
        ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up && (ev.altKey || ev.metaKey));
    };
    var onKeyDown = function(ev) {
        // Take note if we are processing an alt (option) or meta (command) keydown.
        // See comment in shouldHandleKeyUp for reasoning.
        lastKeyDownWasAltOrMeta.current = $1f9efb1806e6b3c0$var$isAltOrMeta(ev);
        // On Mac, pressing escape dismisses all levels of native context menus
        // eslint-disable-next-line deprecation/deprecation
        var dismissAllMenus = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape && ((0, $46def017ce9f8d16$export$9ac100e40613ea10)() || (0, $865faf0b4151a9c6$export$fedb369cb70207f1)());
        return keyHandler(ev, shouldHandleKeyDown, dismissAllMenus);
    };
    /**
     * We close the menu on key up only if ALL of the following are true:
     * - Most recent key down was alt or meta (command)
     * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
     *   expand/collapse the menu)
     * - We're not on a Mac (or iOS)
     *
     * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
     * closing any open context menus. There is not a similar behavior on Macs.
     */ var shouldHandleKeyUp = function(ev) {
        var keyPressIsAltOrMetaAlone = lastKeyDownWasAltOrMeta.current && $1f9efb1806e6b3c0$var$isAltOrMeta(ev);
        lastKeyDownWasAltOrMeta.current = false;
        return !!keyPressIsAltOrMetaAlone && !((0, $865faf0b4151a9c6$export$fedb369cb70207f1)() || (0, $46def017ce9f8d16$export$9ac100e40613ea10)());
    };
    var onKeyUp = function(ev) {
        return keyHandler(ev, shouldHandleKeyUp, true);
    };
    var onMenuKeyDown = function(ev) {
        // Mark as handled if onKeyDown returns true (for handling collapse cases)
        // or if we are attempting to expand a submenu
        var handled = onKeyDown(ev);
        if (handled || !hostElement.current) return;
        // If we have a modifier key being pressed, we do not want to move focus.
        // Otherwise, handle up and down keys.
        var hasModifier = !!(ev.altKey || ev.metaKey);
        // eslint-disable-next-line deprecation/deprecation
        var isUp = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up;
        // eslint-disable-next-line deprecation/deprecation
        var isDown = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down;
        if (!hasModifier && (isUp || isDown)) {
            var elementToFocus = isUp ? (0, $94bdc1ebed789608$export$73e81fa65335a75b)(hostElement.current, hostElement.current.lastChild, true) : (0, $94bdc1ebed789608$export$748138f04a69bf21)(hostElement.current, hostElement.current.firstChild, true);
            if (elementToFocus) {
                elementToFocus.focus();
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    };
    var onItemKeyDown = function(item, ev) {
        var openKey = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $c011a102064f82ea$export$ec835b702d42f3f0).left : (0, $c011a102064f82ea$export$ec835b702d42f3f0).right;
        if (!item.disabled && // eslint-disable-next-line deprecation/deprecation
        (ev.which === openKey || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down && (ev.altKey || ev.metaKey))) {
            openSubMenu(item, ev.currentTarget);
            ev.preventDefault();
        }
    };
    return [
        onKeyDown,
        onKeyUp,
        onMenuKeyDown,
        onItemKeyDown
    ];
}
function $1f9efb1806e6b3c0$var$useScrollHandler(asyncTracker) {
    var isScrollIdle = $acw62.useRef(true);
    var scrollIdleTimeoutId = $acw62.useRef();
    /**
     * Scroll handler for the callout to make sure the mouse events
     * for updating focus are not interacting during scroll
     */ var onScroll = function() {
        if (!isScrollIdle.current && scrollIdleTimeoutId.current !== undefined) {
            asyncTracker.clearTimeout(scrollIdleTimeoutId.current);
            scrollIdleTimeoutId.current = undefined;
        } else isScrollIdle.current = false;
        scrollIdleTimeoutId.current = asyncTracker.setTimeout(function() {
            isScrollIdle.current = true;
        }, $1f9efb1806e6b3c0$var$NavigationIdleDelay);
    };
    return [
        onScroll,
        isScrollIdle
    ];
}
function $1f9efb1806e6b3c0$var$useOnSubmenuDismiss(dismiss, closeSubMenu) {
    var isMountedRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    /**
     * This function is called ASYNCHRONOUSLY, and so there is a chance it is called
     * after the component is unmounted. The isMountedRef is added to prevent
     * from calling setState() after unmount. Do NOT copy this pattern in synchronous
     * code.
     */ var onSubMenuDismiss = function(ev, dismissAll) {
        if (dismissAll) dismiss(ev, dismissAll);
        else if (isMountedRef.current) closeSubMenu();
    };
    return onSubMenuDismiss;
}
function $1f9efb1806e6b3c0$var$useSubmenuEnterTimer(_a, asyncTracker) {
    var _b = _a.subMenuHoverDelay, subMenuHoverDelay = _b === void 0 ? $1f9efb1806e6b3c0$var$NavigationIdleDelay : _b;
    var enterTimerRef = $acw62.useRef(undefined);
    var cancelSubMenuTimer = function() {
        if (enterTimerRef.current !== undefined) {
            asyncTracker.clearTimeout(enterTimerRef.current);
            enterTimerRef.current = undefined;
        }
    };
    var startSubmenuTimer = function(onTimerExpired) {
        enterTimerRef.current = asyncTracker.setTimeout(function() {
            onTimerExpired();
            cancelSubMenuTimer();
        }, subMenuHoverDelay);
    };
    return [
        cancelSubMenuTimer,
        startSubmenuTimer,
        enterTimerRef
    ];
}
function $1f9efb1806e6b3c0$var$useMouseHandlers(props, isScrollIdle, subMenuEntryTimer, targetWindow, shouldUpdateFocusOnMouseEvent, gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss) {
    var menuTarget = props.target;
    var onItemMouseEnterBase = function(item, ev, target) {
        if (shouldUpdateFocusOnMouseEvent.current) gotMouseMove.current = true;
        if (shouldIgnoreMouseEvent()) return;
        updateFocusOnMouseEvent(item, ev, target);
    };
    var onItemMouseMoveBase = function(item, ev, target) {
        var targetElement = ev.currentTarget;
        // Always do this check to make sure we record a mouseMove if needed (even if we are timed out)
        if (shouldUpdateFocusOnMouseEvent.current) gotMouseMove.current = true;
        else return;
        if (!isScrollIdle.current || subMenuEntryTimer.current !== undefined || targetElement === (targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement)) return;
        updateFocusOnMouseEvent(item, ev, target);
    };
    var shouldIgnoreMouseEvent = function() {
        return !isScrollIdle.current || !gotMouseMove.current;
    };
    var onMouseItemLeave = function(item, ev) {
        var _a;
        if (shouldIgnoreMouseEvent()) return;
        cancelSubMenuTimer();
        if (expandedMenuItemKey !== undefined) return;
        /**
         * IE11 focus() method forces parents to scroll to top of element.
         * Edge and IE expose a setActive() function for focusable divs that
         * sets the page focus but does not scroll the parent element.
         */ if (hostElement.current.setActive) try {
            hostElement.current.setActive();
        } catch (e) {
        /* no-op */ }
        else (_a = hostElement.current) === null || _a === void 0 || _a.focus();
    };
    /**
     * Handles updating focus when mouseEnter or mouseMove fire.
     * As part of updating focus, This function will also update
     * the expand/collapse state accordingly.
     */ var updateFocusOnMouseEvent = function(item, ev, target) {
        var targetElement = target ? target : ev.currentTarget;
        if (item.key === expandedMenuItemKey) return;
        cancelSubMenuTimer();
        // If the menu is not expanded we can update focus without any delay
        if (expandedMenuItemKey === undefined) targetElement.focus();
        // Delay updating expanding/dismissing the submenu
        // and only set focus if we have not already done so
        if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) {
            ev.stopPropagation();
            startSubmenuTimer(function() {
                targetElement.focus();
                openSubMenu(item, targetElement, true);
            });
        } else startSubmenuTimer(function() {
            onSubMenuDismiss(ev);
            targetElement.focus();
        });
    };
    var onItemClick = function(item, ev) {
        onItemClickBase(item, ev, ev.currentTarget);
    };
    var onItemClickBase = function(item, ev, target) {
        var items = $1f9efb1806e6b3c0$export$291de058395e0a1c(item, {
            target: menuTarget
        });
        // Cancel an async menu item hover timeout action from being taken and instead
        // just trigger the click event instead.
        cancelSubMenuTimer();
        if (!(0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && (!items || !items.length)) // This is an item without a menu. Click it.
        executeItemClick(item, ev);
        else if (item.key !== expandedMenuItemKey) {
            // This has a collapsed sub menu. Expand it.
            // focus on the container by default when the menu is opened with a click event
            // this differentiates from a keyboard interaction triggering the click event
            var shouldFocusOnContainer = typeof props.shouldFocusOnContainer === "boolean" ? props.shouldFocusOnContainer : ev.nativeEvent.pointerType === "mouse";
            openSubMenu(item, target, shouldFocusOnContainer);
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    var onAnchorClick = function(item, ev) {
        executeItemClick(item, ev);
        ev.stopPropagation();
    };
    var executeItemClick = function(item, ev) {
        if (item.disabled || item.isDisabled) return;
        if (item.preferMenuTargetAsEventTarget) $1f9efb1806e6b3c0$var$overrideTarget(ev, menuTarget);
        var shouldDismiss = false;
        if (item.onClick) shouldDismiss = !!item.onClick(ev, item);
        else if (props.onItemClick) shouldDismiss = !!props.onItemClick(ev, item);
        if (shouldDismiss || !ev.defaultPrevented) dismiss(ev, true);
    };
    return [
        onItemMouseEnterBase,
        onItemMouseMoveBase,
        onMouseItemLeave,
        onItemClick,
        onAnchorClick,
        executeItemClick,
        onItemClickBase
    ];
}
var $1f9efb1806e6b3c0$export$6a869745b5bc3200 = $acw62.memo($acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var _a;
    var _b = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($1f9efb1806e6b3c0$var$DEFAULT_PROPS, propsWithoutDefaults), ref = _b.ref, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "ref"
    ]);
    var hostElement = $acw62.useRef(null);
    var asyncTracker = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var menuId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)($1f9efb1806e6b3c0$var$COMPONENT_NAME, props.id);
    (0, $e896b2d9c1302e32$export$8aeb3a0795e619c9)({
        name: $1f9efb1806e6b3c0$var$COMPONENT_NAME,
        props: props,
        deprecations: {
            getMenuClassNames: "styles"
        }
    });
    var dismiss = function(ev, dismissAll) {
        var _a;
        return (_a = props.onDismiss) === null || _a === void 0 ? void 0 : _a.call(props, ev, dismissAll);
    };
    var _c = (0, $d39eb924c3e4805b$export$7df435cf7131d47a)(props.target, hostElement), targetRef = _c[0], targetWindow = _c[1];
    var tryFocusPreviousActiveElement = $1f9efb1806e6b3c0$var$usePreviousActiveElement(props, targetWindow, hostElement)[0];
    var _d = $1f9efb1806e6b3c0$var$useSubMenuState(props, dismiss), expandedMenuItemKey = _d[0], openSubMenu = _d[1], getSubmenuProps = _d[2], onSubMenuDismiss = _d[3];
    var _e = $1f9efb1806e6b3c0$var$useShouldUpdateFocusOnMouseMove(props), shouldUpdateFocusOnMouseEvent = _e[0], gotMouseMove = _e[1], onMenuFocusCapture = _e[2];
    var _f = $1f9efb1806e6b3c0$var$useScrollHandler(asyncTracker), onScroll = _f[0], isScrollIdle = _f[1];
    var _g = $1f9efb1806e6b3c0$var$useSubmenuEnterTimer(props, asyncTracker), cancelSubMenuTimer = _g[0], startSubmenuTimer = _g[1], subMenuEntryTimer = _g[2];
    var responsiveMode = (0, $6124a3d3c764767c$export$551dad37f2b289e2)(hostElement, props.responsiveMode);
    $1f9efb1806e6b3c0$var$useVisibility(props, targetWindow);
    var _h = $1f9efb1806e6b3c0$var$useKeyHandlers(props, dismiss, hostElement, openSubMenu), onKeyDown = _h[0], onKeyUp = _h[1], onMenuKeyDown = _h[2], onItemKeyDown = _h[3];
    var _j = $1f9efb1806e6b3c0$var$useMouseHandlers(props, isScrollIdle, subMenuEntryTimer, targetWindow, shouldUpdateFocusOnMouseEvent, gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss), onItemMouseEnterBase = _j[0], onItemMouseMoveBase = _j[1], onMouseItemLeave = _j[2], onItemClick = _j[3], onAnchorClick = _j[4], executeItemClick = _j[5], onItemClickBase = _j[6];
    //#region Render helpers
    var onDefaultRenderMenuList = function(menuListProps, // eslint-disable-next-line deprecation/deprecation
    menuClassNames, defaultRender) {
        var indexCorrection = 0;
        var items = menuListProps.items, totalItemCount = menuListProps.totalItemCount, hasCheckmarks = menuListProps.hasCheckmarks, hasIcons = menuListProps.hasIcons;
        return $acw62.createElement("ul", {
            className: menuClassNames.list,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            role: "presentation"
        }, items.map(function(item, index) {
            var menuItem = renderMenuItem(item, index, indexCorrection, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
            if (item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
                var indexIncrease = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
                indexCorrection += indexIncrease;
            }
            return menuItem;
        }));
    };
    var renderFocusZone = function(children, adjustedFocusZoneProps) {
        var _a = props.focusZoneAs, ChildrenRenderer = _a === void 0 ? (0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2) : _a;
        return $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, adjustedFocusZoneProps), children);
    };
    /**
     * !!!IMPORTANT!!! Avoid mutating `item: IContextualMenuItem` argument. It will
     * cause the menu items to always re-render because the component update is based on shallow comparison.
     */ var renderMenuItem = function(item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, // eslint-disable-next-line deprecation/deprecation
    menuClassNames) {
        var _a;
        var renderedItems = [];
        var iconProps = item.iconProps || {
            iconName: "None"
        };
        var getItemClassNames = item.getItemClassNames, itemProps = item.itemProps;
        var styles = itemProps ? itemProps.styles : undefined;
        // We only send a dividerClassName when the item to be rendered is a divider.
        // For all other cases, the default divider style is used.
        var dividerClassName = item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider ? item.className : undefined;
        var subMenuIconClassName = item.submenuIconProps ? item.submenuIconProps.className : "";
        // eslint-disable-next-line deprecation/deprecation
        var itemClassNames;
        // IContextualMenuItem#getItemClassNames for backwards compatibility
        // otherwise uses mergeStyles for class names.
        if (getItemClassNames) itemClassNames = getItemClassNames(props.theme, (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item), expandedMenuItemKey === item.key, !!(0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item), !!item.href, iconProps.iconName !== "None", item.className, dividerClassName, iconProps.className, subMenuIconClassName, item.primaryDisabled);
        else {
            var itemStyleProps = {
                theme: props.theme,
                disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                expanded: expandedMenuItemKey === item.key,
                checked: !!(0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item),
                isAnchorLink: !!item.href,
                knownIcon: iconProps.iconName !== "None",
                itemClassName: item.className,
                dividerClassName: dividerClassName,
                iconClassName: iconProps.className,
                subMenuClassName: subMenuIconClassName,
                primaryDisabled: item.primaryDisabled
            };
            // We need to generate default styles then override if styles are provided
            // since the ContextualMenu currently handles item classNames.
            itemClassNames = $1f9efb1806e6b3c0$var$getContextualMenuItemClassNames($1f9efb1806e6b3c0$var$_getMenuItemStylesFunction((_a = menuClassNames.subComponentStyles) === null || _a === void 0 ? void 0 : _a.menuItem, styles), itemStyleProps);
        }
        // eslint-disable-next-line deprecation/deprecation
        if (item.text === "-" || item.name === "-") item.itemType = (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider;
        switch(item.itemType){
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider:
                renderedItems.push(renderSeparator(index, itemClassNames));
                break;
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header:
                renderedItems.push(renderSeparator(index, itemClassNames));
                var headerItem = renderHeaderMenuItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
                renderedItems.push(renderListItem(headerItem, item.key || index, itemClassNames, item.title));
                break;
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section:
                renderedItems.push(renderSectionItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons));
                break;
            default:
                var defaultRenderNormalItem = function() {
                    return renderNormalItem(item, itemClassNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
                };
                var menuItem = props.onRenderContextualMenuItem ? props.onRenderContextualMenuItem(item, defaultRenderNormalItem) : defaultRenderNormalItem();
                renderedItems.push(renderListItem(menuItem, item.key || index, itemClassNames, item.title));
                break;
        }
        // Since multiple nodes *could* be rendered, wrap them all in a fragment with this item's key.
        // This ensures the reconciler handles multi-item output per-node correctly and does not re-mount content.
        return $acw62.createElement($acw62.Fragment, {
            key: item.key
        }, renderedItems);
    };
    var defaultMenuItemRenderer = function(item, // eslint-disable-next-line deprecation/deprecation
    menuClassNames) {
        var index = item.index, focusableElementIndex = item.focusableElementIndex, totalItemCount = item.totalItemCount, hasCheckmarks = item.hasCheckmarks, hasIcons = item.hasIcons;
        return renderMenuItem(item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
    };
    var renderSectionItem = function(sectionItem, // eslint-disable-next-line deprecation/deprecation
    itemClassNames, // eslint-disable-next-line deprecation/deprecation
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var sectionProps = sectionItem.sectionProps;
        if (!sectionProps) return;
        var headerItem;
        var groupProps;
        if (sectionProps.title) {
            var headerContextualMenuItem = undefined;
            var ariaLabelledby = "";
            if (typeof sectionProps.title === "string") {
                // Since title is a user-facing string, it needs to be stripped
                // of whitespace in order to build a valid element ID
                var id_1 = menuId + sectionProps.title.replace(/\s/g, "");
                headerContextualMenuItem = {
                    key: "section-".concat(sectionProps.title, "-title"),
                    itemType: (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header,
                    text: sectionProps.title,
                    id: id_1
                };
                ariaLabelledby = id_1;
            } else {
                var id_2 = sectionProps.title.id || menuId + sectionProps.title.key.replace(/\s/g, "");
                headerContextualMenuItem = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, sectionProps.title), {
                    id: id_2
                });
                ariaLabelledby = id_2;
            }
            if (headerContextualMenuItem) {
                groupProps = {
                    role: "group",
                    "aria-labelledby": ariaLabelledby
                };
                headerItem = renderHeaderMenuItem(headerContextualMenuItem, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
            }
        }
        if (sectionProps.items && sectionProps.items.length > 0) {
            var correctedIndex_1 = 0;
            return $acw62.createElement("li", {
                role: "presentation",
                key: sectionProps.key || sectionItem.key || "section-".concat(index)
            }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps), $acw62.createElement("ul", {
                className: menuClassNames.list,
                role: "presentation"
            }, sectionProps.topDivider && renderSeparator(index, itemClassNames, true, true), headerItem && renderListItem(headerItem, sectionItem.key || index, itemClassNames, sectionItem.title), sectionProps.items.map(function(contextualMenuItem, itemsIndex) {
                var menuItem = renderMenuItem(contextualMenuItem, itemsIndex, correctedIndex_1, $1f9efb1806e6b3c0$var$getItemCount(sectionProps.items), hasCheckmarks, hasIcons, menuClassNames);
                if (contextualMenuItem.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && contextualMenuItem.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
                    var indexIncrease = contextualMenuItem.customOnRenderListLength ? contextualMenuItem.customOnRenderListLength : 1;
                    correctedIndex_1 += indexIncrease;
                }
                return menuItem;
            }), sectionProps.bottomDivider && renderSeparator(index, itemClassNames, false, true))));
        }
    };
    var renderListItem = function(content, key, classNames, title) {
        return $acw62.createElement("li", {
            role: "presentation",
            title: title,
            key: key,
            className: classNames.item
        }, content);
    };
    var renderSeparator = function(index, classNames, top, fromSection) {
        if (fromSection || index > 0) return $acw62.createElement("li", {
            role: "separator",
            key: "separator-" + index + (top === undefined ? "" : top ? "-top" : "-bottom"),
            className: classNames.divider,
            "aria-hidden": "true"
        });
        return null;
    };
    var renderNormalItem = function(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        if (item.onRender) return item.onRender((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "aria-posinset": focusableElementIndex + 1,
            "aria-setsize": totalItemCount
        }, item), dismiss);
        var contextualMenuItemAs = props.contextualMenuItemAs;
        var commonProps = {
            item: item,
            classNames: classNames,
            index: index,
            focusableElementIndex: focusableElementIndex,
            totalItemCount: totalItemCount,
            hasCheckmarks: hasCheckmarks,
            hasIcons: hasIcons,
            contextualMenuItemAs: contextualMenuItemAs,
            onItemMouseEnter: onItemMouseEnterBase,
            onItemMouseLeave: onMouseItemLeave,
            onItemMouseMove: onItemMouseMoveBase,
            onItemMouseDown: $1f9efb1806e6b3c0$var$onItemMouseDown,
            executeItemClick: executeItemClick,
            onItemKeyDown: onItemKeyDown,
            expandedMenuItemKey: expandedMenuItemKey,
            openSubMenu: openSubMenu,
            dismissSubMenu: onSubMenuDismiss,
            dismissMenu: dismiss
        };
        if (item.href) return $acw62.createElement((0, $4d34c28d37611dbf$export$53be548a9698e315), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
            onItemClick: onAnchorClick
        }));
        if (item.split && (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) return $acw62.createElement((0, $d0192128ae91cb03$export$6b814188c716a895), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
            onItemClick: onItemClick,
            onItemClickBase: onItemClickBase,
            onTap: cancelSubMenuTimer
        }));
        return $acw62.createElement((0, $5b4ee16a3fe91ee4$export$77db5d9420e58cc5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
            onItemClick: onItemClick,
            onItemClickBase: onItemClickBase
        }));
    };
    var renderHeaderMenuItem = function(item, // eslint-disable-next-line deprecation/deprecation
    itemClassNames, // eslint-disable-next-line deprecation/deprecation
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var _a = props.contextualMenuItemAs, ChildrenRenderer = _a === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _a;
        var itemProps = item.itemProps, id = item.id;
        var divHtmlProperties = itemProps && (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        return(// eslint-disable-next-line deprecation/deprecation
        $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: id,
            className: menuClassNames.header
        }, divHtmlProperties, {
            style: item.style
        }), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            item: item,
            classNames: itemClassNames,
            index: index,
            onCheckmarkClick: hasCheckmarks ? onItemClick : undefined,
            hasIcons: hasIcons
        }, itemProps))));
    };
    //#endregion
    //#region Main render
    var isBeakVisible = props.isBeakVisible;
    var items = props.items, labelElementId = props.labelElementId, id = props.id, className = props.className, beakWidth = props.beakWidth, directionalHint = props.directionalHint, directionalHintForRTL = props.directionalHintForRTL, alignTargetEdge = props.alignTargetEdge, gapSpace = props.gapSpace, coverTarget = props.coverTarget, ariaLabel = props.ariaLabel, doNotLayer = props.doNotLayer, target = props.target, bounds = props.bounds, useTargetWidth = props.useTargetWidth, useTargetAsMinWidth = props.useTargetAsMinWidth, directionalHintFixed = props.directionalHintFixed, shouldFocusOnMount = props.shouldFocusOnMount, shouldFocusOnContainer = props.shouldFocusOnContainer, title = props.title, styles = props.styles, theme = props.theme, calloutProps = props.calloutProps, _k = props.onRenderSubMenu, onRenderSubMenu = _k === void 0 ? $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu : _k, _l = props.onRenderMenuList, onRenderMenuList = _l === void 0 ? function(menuListProps, defaultRender) {
        return onDefaultRenderMenuList(menuListProps, classNames, defaultRender);
    } : _l, focusZoneProps = props.focusZoneProps, // eslint-disable-next-line deprecation/deprecation
    getMenuClassNames = props.getMenuClassNames;
    var classNames = getMenuClassNames ? getMenuClassNames(theme, className) : $1f9efb1806e6b3c0$var$getClassNames(styles, {
        theme: theme,
        className: className
    });
    var hasIcons = itemsHaveIcons(items);
    function itemsHaveIcons(contextualMenuItems) {
        for(var _i = 0, contextualMenuItems_1 = contextualMenuItems; _i < contextualMenuItems_1.length; _i++){
            var item = contextualMenuItems_1[_i];
            if (item.iconProps) return true;
            if (item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section && item.sectionProps && itemsHaveIcons(item.sectionProps.items)) return true;
        }
        return false;
    }
    var adjustedFocusZoneProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical,
        handleTabKey: (0, $13ca773bee6ceecf$export$269041a88986a933).all,
        isCircularNavigation: true
    }, focusZoneProps), {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, (_a = props.focusZoneProps) === null || _a === void 0 ? void 0 : _a.className)
    });
    var hasCheckmarks = $1f9efb1806e6b3c0$export$2a1d7a07e590a159(items);
    var submenuProps = expandedMenuItemKey && props.hidden !== true ? getSubmenuProps() : null;
    isBeakVisible = isBeakVisible === undefined ? responsiveMode <= (0, $d2efee541c4fc734$export$73c2705cb2da08ab).medium : isBeakVisible;
    /**
     * When useTargetWidth is true, get the width of the target element and apply it for the context menu container
     */ var contextMenuStyle;
    var targetAsHtmlElement = targetRef.current;
    if ((useTargetWidth || useTargetAsMinWidth) && targetAsHtmlElement && targetAsHtmlElement.offsetWidth) {
        var targetBoundingRect = targetAsHtmlElement.getBoundingClientRect();
        var targetWidth = targetBoundingRect.width - 2; /* Accounts for 1px border */ 
        if (useTargetWidth) contextMenuStyle = {
            width: targetWidth
        };
        else if (useTargetAsMinWidth) contextMenuStyle = {
            minWidth: targetWidth
        };
    }
    // The menu should only return if items were provided, if no items were provided then it should not appear.
    if (items && items.length > 0) {
        var totalItemCount_1 = $1f9efb1806e6b3c0$var$getItemCount(items);
        var calloutStyles_1 = classNames.subComponentStyles ? classNames.subComponentStyles.callout : undefined;
        return $acw62.createElement((0, $247bbbbcfb0b71e2$export$c7e742effb1c51e2).Consumer, null, function(menuContext) {
            return $acw62.createElement((0, $bb8160ea11d5c986$export$97a5aca3dea8edc7), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                styles: calloutStyles_1,
                onRestoreFocus: tryFocusPreviousActiveElement
            }, calloutProps, {
                target: target || menuContext.target,
                isBeakVisible: isBeakVisible,
                beakWidth: beakWidth,
                directionalHint: directionalHint,
                directionalHintForRTL: directionalHintForRTL,
                gapSpace: gapSpace,
                coverTarget: coverTarget,
                doNotLayer: doNotLayer,
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-ContextualMenu-Callout", calloutProps && calloutProps.className),
                setInitialFocus: shouldFocusOnMount,
                onDismiss: props.onDismiss || menuContext.onDismiss,
                onScroll: onScroll,
                bounds: bounds,
                directionalHintFixed: directionalHintFixed,
                alignTargetEdge: alignTargetEdge,
                hidden: props.hidden || menuContext.hidden,
                ref: forwardedRef
            }), $acw62.createElement("div", {
                style: contextMenuStyle,
                ref: hostElement,
                id: id,
                className: classNames.container,
                tabIndex: shouldFocusOnContainer ? 0 : -1,
                onKeyDown: onMenuKeyDown,
                onKeyUp: onKeyUp,
                onFocusCapture: onMenuFocusCapture,
                "aria-label": ariaLabel,
                "aria-labelledby": labelElementId,
                role: "menu"
            }, title && $acw62.createElement("div", {
                className: classNames.title
            }, " ", title, " "), items && items.length ? renderFocusZone(onRenderMenuList({
                ariaLabel: ariaLabel,
                items: items,
                totalItemCount: totalItemCount_1,
                hasCheckmarks: hasCheckmarks,
                hasIcons: hasIcons,
                defaultMenuItemRenderer: function(item) {
                    return defaultMenuItemRenderer(item, classNames);
                },
                labelElementId: labelElementId
            }, function(menuListProps, defaultRender) {
                return onDefaultRenderMenuList(menuListProps, classNames, defaultRender);
            }), adjustedFocusZoneProps) : null, submenuProps && onRenderSubMenu(submenuProps, $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu)), $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null));
        });
    } else return null;
//#endregion
}), function(prevProps, newProps) {
    if (!newProps.shouldUpdateWhenHidden && prevProps.hidden && newProps.hidden) // Do not update when hidden.
    return true;
    return (0, $f504d2279336999d$export$90e866afbd6b9f1a)(prevProps, newProps);
});
$1f9efb1806e6b3c0$export$6a869745b5bc3200.displayName = "ContextualMenuBase";
/**
 * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
 */ function $1f9efb1806e6b3c0$var$isAltOrMeta(ev) {
    // eslint-disable-next-line deprecation/deprecation
    return ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).alt || ev.key === "Meta";
}
function $1f9efb1806e6b3c0$var$onItemMouseDown(item, ev) {
    var _a;
    (_a = item.onMouseDown) === null || _a === void 0 || _a.call(item, item, ev);
}
function $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu(subMenuProps, defaultRender) {
    throw Error("ContextualMenuBase: onRenderSubMenu callback is null or undefined. Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.");
}
/**
 * Returns the item that matches a given key if any.
 * @param key - The key of the item to match
 * @param items - The items to look for the key
 */ function $1f9efb1806e6b3c0$var$findItemByKeyFromItems(key, items) {
    for(var _i = 0, items_3 = items; _i < items_3.length; _i++){
        var item = items_3[_i];
        if (item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section && item.sectionProps) {
            var match = $1f9efb1806e6b3c0$var$findItemByKeyFromItems(key, item.sectionProps.items);
            if (match) return match;
        } else if (item.key && item.key === key) return item;
    }
}
function $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onClick, target) {
    return onClick ? function(ev, item) {
        $1f9efb1806e6b3c0$var$overrideTarget(ev, target);
        return onClick(ev, item);
    } : onClick;
}
function $1f9efb1806e6b3c0$var$overrideTarget(ev, target) {
    if (ev && target) {
        ev.persist();
        if (target instanceof Event) ev.target = target.target;
        else if (target instanceof Element) ev.target = target;
    }
}




var $3bfe12eac3fc7683$var$GlobalClassNames = {
    root: "ms-ContextualMenu",
    container: "ms-ContextualMenu-container",
    list: "ms-ContextualMenu-list",
    header: "ms-ContextualMenu-header",
    title: "ms-ContextualMenu-title",
    isopen: "is-open"
};
var $3bfe12eac3fc7683$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($3bfe12eac3fc7683$var$GlobalClassNames, theme);
    var fonts = theme.fonts, semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            classNames.isopen,
            {
                backgroundColor: semanticColors.menuBackground,
                minWidth: "180px"
            },
            className
        ],
        container: [
            classNames.container,
            {
                selectors: {
                    ":focus": {
                        outline: 0
                    }
                }
            }
        ],
        list: [
            classNames.list,
            classNames.isopen,
            {
                listStyleType: "none",
                margin: "0",
                padding: "0"
            }
        ],
        header: [
            classNames.header,
            fonts.small,
            {
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                color: semanticColors.menuHeader,
                background: "none",
                backgroundColor: "transparent",
                border: "none",
                height: (0, $194675c1c18101b9$export$f4ed060eaa49a3),
                lineHeight: (0, $194675c1c18101b9$export$f4ed060eaa49a3),
                cursor: "default",
                padding: "0px 6px",
                userSelect: "none",
                textAlign: "left"
            }
        ],
        title: [
            classNames.title,
            {
                fontSize: fonts.mediumPlus.fontSize,
                paddingRight: "14px",
                paddingLeft: "14px",
                paddingBottom: "5px",
                paddingTop: "5px",
                backgroundColor: semanticColors.menuItemBackgroundPressed
            }
        ],
        subComponentStyles: {
            callout: {
                root: {
                    boxShadow: effects.elevation8
                }
            },
            menuItem: {}
        }
    };
};


function $ce0e54155b3ccf1a$var$onRenderSubMenu(subMenuProps) {
    return $acw62.createElement($ce0e54155b3ccf1a$var$LocalContextualMenu, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, subMenuProps));
}
// This is to prevent cyclic import with ContextualMenu.base.tsx.
var $ce0e54155b3ccf1a$var$LocalContextualMenu = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $1f9efb1806e6b3c0$export$6a869745b5bc3200), (0, $3bfe12eac3fc7683$export$ffd58b7f6f099a57), function(props) {
    return {
        onRenderSubMenu: props.onRenderSubMenu ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(props.onRenderSubMenu, $ce0e54155b3ccf1a$var$onRenderSubMenu) : $ce0e54155b3ccf1a$var$onRenderSubMenu
    };
}, {
    scope: "ContextualMenu"
});
var $ce0e54155b3ccf1a$export$f55c8e309b1cad66 = $ce0e54155b3ccf1a$var$LocalContextualMenu;
$ce0e54155b3ccf1a$export$f55c8e309b1cad66.displayName = "ContextualMenu";




var $4fe39bc207aa6e6b$export$78e5756b1cbe9c85 = {
    msButton: "ms-Button",
    msButtonHasMenu: "ms-Button--hasMenu",
    msButtonIcon: "ms-Button-icon",
    msButtonMenuIcon: "ms-Button-menuIcon",
    msButtonLabel: "ms-Button-label",
    msButtonDescription: "ms-Button-description",
    msButtonScreenReaderText: "ms-Button-screenReaderText",
    msButtonFlexContainer: "ms-Button-flexContainer",
    msButtonTextContainer: "ms-Button-textContainer"
};
var $4fe39bc207aa6e6b$export$c856ccb8b0de330d = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, styles, className, variantClassName, iconClassName, menuIconClassName, disabled, hasMenu, checked, expanded, isSplit) {
    var _a, _b;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($4fe39bc207aa6e6b$export$78e5756b1cbe9c85, theme || {});
    var isExpanded = expanded && !isSplit;
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
        root: [
            classNames.msButton,
            styles.root,
            variantClassName,
            checked && [
                "is-checked",
                styles.rootChecked
            ],
            isExpanded && [
                "is-expanded",
                styles.rootExpanded,
                {
                    selectors: (_a = {}, _a[":hover .".concat(classNames.msButtonIcon)] = styles.iconExpandedHovered, // menuIcon falls back to rootExpandedHovered to support original behavior
                    _a[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconExpandedHovered || styles.rootExpandedHovered, _a[":hover"] = styles.rootExpandedHovered, _a)
                }
            ],
            hasMenu && [
                $4fe39bc207aa6e6b$export$78e5756b1cbe9c85.msButtonHasMenu,
                styles.rootHasMenu
            ],
            disabled && [
                "is-disabled",
                styles.rootDisabled
            ],
            !disabled && !isExpanded && !checked && {
                selectors: (_b = {
                    ":hover": styles.rootHovered
                }, _b[":hover .".concat(classNames.msButtonLabel)] = styles.labelHovered, _b[":hover .".concat(classNames.msButtonIcon)] = styles.iconHovered, _b[":hover .".concat(classNames.msButtonDescription)] = styles.descriptionHovered, _b[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconHovered, _b[":focus"] = styles.rootFocused, _b[":active"] = styles.rootPressed, _b[":active .".concat(classNames.msButtonIcon)] = styles.iconPressed, _b[":active .".concat(classNames.msButtonDescription)] = styles.descriptionPressed, _b[":active .".concat(classNames.msButtonMenuIcon)] = styles.menuIconPressed, _b)
            },
            disabled && checked && [
                styles.rootCheckedDisabled
            ],
            !disabled && checked && {
                selectors: {
                    ":hover": styles.rootCheckedHovered,
                    ":active": styles.rootCheckedPressed
                }
            },
            className
        ],
        flexContainer: [
            classNames.msButtonFlexContainer,
            styles.flexContainer
        ],
        textContainer: [
            classNames.msButtonTextContainer,
            styles.textContainer
        ],
        icon: [
            classNames.msButtonIcon,
            iconClassName,
            styles.icon,
            isExpanded && styles.iconExpanded,
            checked && styles.iconChecked,
            disabled && styles.iconDisabled
        ],
        label: [
            classNames.msButtonLabel,
            styles.label,
            checked && styles.labelChecked,
            disabled && styles.labelDisabled
        ],
        menuIcon: [
            classNames.msButtonMenuIcon,
            menuIconClassName,
            styles.menuIcon,
            checked && styles.menuIconChecked,
            disabled && !isSplit && styles.menuIconDisabled,
            !disabled && !isExpanded && !checked && {
                selectors: {
                    ":hover": styles.menuIconHovered,
                    ":active": styles.menuIconPressed
                }
            },
            isExpanded && [
                "is-expanded",
                styles.menuIconExpanded
            ]
        ],
        description: [
            classNames.msButtonDescription,
            styles.description,
            checked && styles.descriptionChecked,
            disabled && styles.descriptionDisabled
        ],
        screenReaderText: [
            classNames.msButtonScreenReaderText,
            styles.screenReaderText
        ]
    });
});




var $69f0f54fd3cb91aa$export$f5956e741d4621bd = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(styles, disabled, expanded, checked, primaryDisabled) {
    return {
        root: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonMenuButton, expanded && [
            styles.splitButtonMenuButtonExpanded
        ], disabled && [
            styles.splitButtonMenuButtonDisabled
        ], checked && !disabled && [
            styles.splitButtonMenuButtonChecked
        ], primaryDisabled && !disabled && [
            {
                selectors: {
                    ":focus": styles.splitButtonMenuFocused
                }
            }
        ]),
        splitButtonContainer: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonContainer, !disabled && checked && [
            styles.splitButtonContainerChecked,
            {
                selectors: {
                    ":hover": styles.splitButtonContainerCheckedHovered
                }
            }
        ], !disabled && !checked && [
            {
                selectors: {
                    ":hover": styles.splitButtonContainerHovered,
                    ":focus": styles.splitButtonContainerFocused
                }
            }
        ], disabled && styles.splitButtonContainerDisabled),
        icon: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonMenuIcon, disabled && styles.splitButtonMenuIconDisabled, !disabled && primaryDisabled && styles.splitButtonMenuIcon),
        flexContainer: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonFlexContainer),
        divider: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonDivider, (primaryDisabled || disabled) && styles.splitButtonDividerDisabled)
    };
});



var $108f802e6afba9ea$var$TouchIdleDelay = 500; /* ms */ 
var $108f802e6afba9ea$var$COMPONENT_NAME = "BaseButton";
/**
 * {@docCategory Button}
 */ var $108f802e6afba9ea$export$e30f1d91ae9a4bf9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseButton, _super);
    function BaseButton(props) {
        var _this = _super.call(this, props) || this;
        _this._buttonElement = $acw62.createRef();
        _this._splitButtonContainer = $acw62.createRef();
        _this._mergedRef = (0, $ad53d15595d1f5d5$export$9f37a988498f0f9c)();
        _this._renderedVisibleMenu = false;
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._onRenderIcon = function(buttonProps, defaultRender) {
            var iconProps = _this.props.iconProps;
            if (iconProps && (iconProps.iconName !== undefined || iconProps.imageProps)) {
                var className = iconProps.className, imageProps = iconProps.imageProps, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(iconProps, [
                    "className",
                    "imageProps"
                ]);
                // If the styles prop is specified as part of iconProps, fall back to regular Icon as FontIcon and ImageIcon
                // do not have this prop.
                if (iconProps.styles) return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className),
                    imageProps: imageProps
                }, rest));
                if (iconProps.iconName) return $acw62.createElement((0, $eec83b0087c5fe87$export$f56ea46797033f60), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className)
                }, rest));
                if (imageProps) return $acw62.createElement((0, $98737100b97aa693$export$4a122bafaa48b23d), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className),
                    imageProps: imageProps
                }, rest));
            }
            return null;
        };
        _this._onRenderTextContents = function() {
            var _a = _this.props, text = _a.text, children = _a.children, // eslint-disable-next-line deprecation/deprecation
            _b = _a.secondaryText, // eslint-disable-next-line deprecation/deprecation
            secondaryText = _b === void 0 ? _this.props.description : _b, _c = _a.onRenderText, onRenderText = _c === void 0 ? _this._onRenderText : _c, _d = _a.onRenderDescription, onRenderDescription = _d === void 0 ? _this._onRenderDescription : _d;
            if (text || typeof children === "string" || secondaryText) return $acw62.createElement("span", {
                className: _this._classNames.textContainer
            }, onRenderText(_this.props, _this._onRenderText), onRenderDescription(_this.props, _this._onRenderDescription));
            return [
                onRenderText(_this.props, _this._onRenderText),
                onRenderDescription(_this.props, _this._onRenderDescription)
            ];
        };
        _this._onRenderText = function() {
            var text = _this.props.text;
            var children = _this.props.children;
            // For backwards compat, we should continue to take in the text content from children.
            if (text === undefined && typeof children === "string") text = children;
            if (_this._hasText()) return $acw62.createElement("span", {
                key: _this._labelId,
                className: _this._classNames.label,
                id: _this._labelId
            }, text);
            return null;
        };
        _this._onRenderChildren = function() {
            var children = _this.props.children;
            // If children is just a string, either it or the text will be rendered via onRenderLabel
            // If children is another component, it will be rendered after text
            if (typeof children === "string") return null;
            return children;
        };
        _this._onRenderDescription = function(props) {
            // eslint-disable-next-line deprecation/deprecation
            var _a = props.secondaryText, secondaryText = _a === void 0 ? _this.props.description : _a;
            // ms-Button-description is only shown when the button type is compound.
            // In other cases it will not be displayed.
            return secondaryText ? $acw62.createElement("span", {
                key: _this._descriptionId,
                className: _this._classNames.description,
                id: _this._descriptionId
            }, secondaryText) : null;
        };
        _this._onRenderAriaDescription = function() {
            var ariaDescription = _this.props.ariaDescription;
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
            // otherwise it will be assigned to descriptionSpan.
            return ariaDescription ? $acw62.createElement("span", {
                className: _this._classNames.screenReaderText,
                id: _this._ariaDescriptionId
            }, ariaDescription) : null;
        };
        _this._onRenderMenuIcon = function(props) {
            var menuIconProps = _this.props.menuIconProps;
            return $acw62.createElement((0, $eec83b0087c5fe87$export$f56ea46797033f60), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                iconName: "ChevronDown"
            }, menuIconProps, {
                className: _this._classNames.menuIcon
            }));
        };
        _this._onRenderMenu = function(menuProps) {
            var MenuType = _this.props.menuAs ? (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(_this.props.menuAs, (0, $ce0e54155b3ccf1a$export$f55c8e309b1cad66)) : (0, $ce0e54155b3ccf1a$export$f55c8e309b1cad66);
            return $acw62.createElement(MenuType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuProps));
        };
        _this._onDismissMenu = function(ev) {
            var menuProps = _this.props.menuProps;
            if (menuProps && menuProps.onDismiss) menuProps.onDismiss(ev);
            if (!ev || !ev.defaultPrevented) _this._dismissMenu();
        };
        _this._dismissMenu = function() {
            _this._menuShouldFocusOnMount = undefined;
            _this._menuShouldFocusOnContainer = undefined;
            _this.setState({
                menuHidden: true
            });
        };
        _this._openMenu = function(shouldFocusOnContainer, shouldFocusOnMount) {
            if (shouldFocusOnMount === void 0) shouldFocusOnMount = true;
            if (_this.props.menuProps) {
                _this._menuShouldFocusOnContainer = shouldFocusOnContainer;
                _this._menuShouldFocusOnMount = shouldFocusOnMount;
                _this._renderedVisibleMenu = true;
                _this.setState({
                    menuHidden: false
                });
            }
        };
        _this._onToggleMenu = function(shouldFocusOnContainer) {
            var shouldFocusOnMount = true;
            if (_this.props.menuProps && _this.props.menuProps.shouldFocusOnMount === false) shouldFocusOnMount = false;
            _this.state.menuHidden ? _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount) : _this._dismissMenu();
        };
        _this._onSplitContainerFocusCapture = function(ev) {
            var container = _this._splitButtonContainer.current;
            // If the target is coming from the portal we do not need to set focus on the container.
            if (!container || ev.target && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(ev.target, container)) return;
            // We should never be able to focus the individual buttons in a split button. Focus
            // should always remain on the container.
            container.focus();
        };
        _this._onSplitButtonPrimaryClick = function(ev) {
            if (!_this.state.menuHidden) _this._dismissMenu();
            // toggle split buttons need two separate targets, even for touch
            var singleTouchTarget = _this._processingTouch && !_this.props.toggle;
            if (!singleTouchTarget && _this.props.onClick) _this.props.onClick(ev);
            else if (singleTouchTarget) _this._onMenuClick(ev);
        };
        _this._onKeyDown = function(ev) {
            // explicity cancelling event so click won't fire after this
            // eslint-disable-next-line deprecation/deprecation
            if (_this.props.disabled && (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space)) {
                ev.preventDefault();
                ev.stopPropagation();
            } else if (!_this.props.disabled) {
                if (_this.props.menuProps) _this._onMenuKeyDown(ev);
                else if (_this.props.onKeyDown !== undefined) _this.props.onKeyDown(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onKeyUp = function(ev) {
            if (!_this.props.disabled && _this.props.onKeyUp !== undefined) _this.props.onKeyUp(ev); // not cancelling event because it's not disabled
        };
        _this._onKeyPress = function(ev) {
            // eslint-disable-next-line deprecation/deprecation
            if (!_this.props.disabled && _this.props.onKeyPress !== undefined) // eslint-disable-next-line deprecation/deprecation
            _this.props.onKeyPress(ev); // not cancelling event because it's not disabled
        };
        _this._onMouseUp = function(ev) {
            if (!_this.props.disabled && _this.props.onMouseUp !== undefined) _this.props.onMouseUp(ev); // not cancelling event because it's not disabled
        };
        _this._onMouseDown = function(ev) {
            if (!_this.props.disabled && _this.props.onMouseDown !== undefined) _this.props.onMouseDown(ev); // not cancelling event because it's not disabled
        };
        _this._onClick = function(ev) {
            if (!_this.props.disabled) {
                if (_this.props.menuProps) _this._onMenuClick(ev);
                else if (_this.props.onClick !== undefined) _this.props.onClick(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onSplitButtonContainerKeyDown = function(ev) {
            // eslint-disable-next-line deprecation/deprecation
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) {
                if (_this._buttonElement.current) {
                    _this._buttonElement.current.click();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else _this._onMenuKeyDown(ev);
        };
        _this._onMenuKeyDown = function(ev) {
            var _a;
            if (_this.props.disabled) return;
            if (_this.props.onKeyDown) _this.props.onKeyDown(ev);
            // eslint-disable-next-line deprecation/deprecation
            var isUp = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up;
            // eslint-disable-next-line deprecation/deprecation
            var isDown = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down;
            if (!ev.defaultPrevented && _this._isValidMenuOpenKey(ev)) {
                var onMenuClick = _this.props.onMenuClick;
                if (onMenuClick) onMenuClick(ev, _this.props);
                _this._onToggleMenu(false);
                ev.preventDefault();
                ev.stopPropagation();
            }
            // eslint-disable-next-line deprecation/deprecation
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) // We manually set the focus visibility to true if opening via Enter or Space to account for the scenario where
            // a user clicks on the button, closes the menu and then opens it via keyboard. In this scenario our default logic
            // for setting focus visibility is not triggered since there is no keyboard navigation present beforehand.
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, (_a = _this.context) === null || _a === void 0 ? void 0 : _a.registeredProviders);
            if (!(ev.altKey || ev.metaKey) && (isUp || isDown)) // Suppose a menu, with shouldFocusOnMount: false, is open, and user wants to keyboard to the menu items
            // We need to re-render the menu with shouldFocusOnMount as true.
            {
                if (!_this.state.menuHidden && _this.props.menuProps) {
                    var currentShouldFocusOnMount = _this._menuShouldFocusOnMount !== undefined ? _this._menuShouldFocusOnMount : _this.props.menuProps.shouldFocusOnMount;
                    if (!currentShouldFocusOnMount) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        _this._menuShouldFocusOnMount = true;
                        _this.forceUpdate();
                    }
                }
            }
        };
        _this._onTouchStart = function() {
            if (_this._isSplitButton && _this._splitButtonContainer.current && !("onpointerdown" in _this._splitButtonContainer.current)) _this._handleTouchAndPointerEvent();
        };
        _this._onMenuClick = function(ev) {
            var _a = _this.props, onMenuClick = _a.onMenuClick, menuProps = _a.menuProps;
            if (onMenuClick) onMenuClick(ev, _this.props);
            // focus on the container by default when the menu is opened with a click event
            // this differentiates from a keyboard interaction triggering the click event
            var shouldFocusOnContainer = typeof (menuProps === null || menuProps === void 0 ? void 0 : menuProps.shouldFocusOnContainer) === "boolean" ? menuProps.shouldFocusOnContainer : ev.nativeEvent.pointerType === "mouse";
            if (!ev.defaultPrevented) {
                _this._onToggleMenu(shouldFocusOnContainer);
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        (0, $35efe983fe3c9b91$export$864d02b07a04fe0f)($108f802e6afba9ea$var$COMPONENT_NAME, props, [
            "menuProps",
            "onClick"
        ], "split", _this.props.split);
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)($108f802e6afba9ea$var$COMPONENT_NAME, props, {
            rootProps: undefined,
            description: "secondaryText",
            toggled: "checked"
        });
        _this._labelId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this._descriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this.state = {
            menuHidden: true
        };
        return _this;
    }
    Object.defineProperty(BaseButton.prototype, "_isSplitButton", {
        get: function() {
            return !!this.props.menuProps && !!this.props.onClick && this.props.split === true;
        },
        enumerable: false,
        configurable: true
    });
    BaseButton.prototype.render = function() {
        var _a;
        var _b = this.props, ariaDescription = _b.ariaDescription, ariaLabel = _b.ariaLabel, ariaHidden = _b.ariaHidden, className = _b.className, disabled = _b.disabled, allowDisabledFocus = _b.allowDisabledFocus, primaryDisabled = _b.primaryDisabled, // eslint-disable-next-line deprecation/deprecation
        _c = _b.secondaryText, // eslint-disable-next-line deprecation/deprecation
        secondaryText = _c === void 0 ? this.props.description : _c, href = _b.href, iconProps = _b.iconProps, menuIconProps = _b.menuIconProps, styles = _b.styles, checked = _b.checked, variantClassName = _b.variantClassName, theme = _b.theme, toggle = _b.toggle, getClassNames = _b.getClassNames, role = _b.role;
        var menuHidden = this.state.menuHidden;
        // Button is disabled if the whole button (in case of splitButton is disabled) or if the primary action is disabled
        var isPrimaryButtonDisabled = disabled || primaryDisabled;
        this._classNames = getClassNames ? getClassNames(theme, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, !menuHidden, !!this.props.menuProps, this.props.split, !!allowDisabledFocus) : (0, $4fe39bc207aa6e6b$export$c856ccb8b0de330d)(theme, styles, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, !!this.props.menuProps, checked, !menuHidden, this.props.split);
        var _d = this, _ariaDescriptionId = _d._ariaDescriptionId, _labelId = _d._labelId, _descriptionId = _d._descriptionId;
        // Anchor tag cannot be disabled hence in disabled state rendering
        // anchor button as normal button
        var renderAsAnchor = !isPrimaryButtonDisabled && !!href;
        var tag = renderAsAnchor ? "a" : "button";
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(// eslint-disable-next-line deprecation/deprecation
        (0, $f504d2279336999d$export$e6e34fd1f2686227)(renderAsAnchor ? {} : {
            type: "button"
        }, this.props.rootProps, this.props), renderAsAnchor ? (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8) : (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4), [
            "disabled"
        ]);
        // Check for ariaLabel passed in via Button props, and fall back to aria-label passed in via native props
        var resolvedAriaLabel = ariaLabel || nativeProps["aria-label"];
        // Check for ariaDescription, secondaryText or aria-describedby in the native props to determine source of
        // aria-describedby. Otherwise default to undefined so property does not appear in output.
        var ariaDescribedBy = undefined;
        if (ariaDescription) ariaDescribedBy = _ariaDescriptionId;
        else if (secondaryText && this.props.onRenderDescription !== (0, $12233c50b7efccdc$export$c14f77b8570f3676)) // for buttons like CompoundButton with a valid onRenderDescription, we need to set an ariaDescribedBy
        // for buttons that do not render anything (via nullRender), we should not set an ariaDescribedBy
        ariaDescribedBy = _descriptionId;
        else if (nativeProps["aria-describedby"]) ariaDescribedBy = nativeProps["aria-describedby"];
        // If an explicit aria-labelledby is given, use that and we're done.
        // If any kind of description is given (which will end up as an aria-describedby attribute)
        // and no ariaLabel is specified, set the labelledby element.
        // Otherwise, the button is labeled implicitly by the descendent text on the button (if it exists).
        var ariaLabelledBy = undefined;
        if (nativeProps["aria-labelledby"]) ariaLabelledBy = nativeProps["aria-labelledby"];
        else if (ariaDescribedBy && !resolvedAriaLabel) ariaLabelledBy = this._hasText() ? _labelId : undefined;
        var dataIsFocusable = this.props["data-is-focusable"] === false || disabled && !allowDisabledFocus || this._isSplitButton ? false : true;
        var isCheckboxTypeRole = role === "menuitemcheckbox" || role === "checkbox";
        // if isCheckboxTypeRole, always return a checked value.
        // Otherwise only return checked value if toggle is set to true.
        // This is because role="checkbox" always needs to have an aria-checked value
        // but our checked prop only sets aria-pressed if we mark the button as a toggle="true"
        var checkedOrPressedValue = isCheckboxTypeRole ? !!checked : toggle === true ? !!checked : undefined;
        var buttonProps = (0, $f504d2279336999d$export$e6e34fd1f2686227)(nativeProps, (_a = {
            className: this._classNames.root,
            // eslint-disable-next-line deprecation/deprecation
            ref: this._mergedRef(this.props.elementRef, this._buttonElement),
            disabled: isPrimaryButtonDisabled && !allowDisabledFocus,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onClick: this._onClick,
            "aria-label": resolvedAriaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isPrimaryButtonDisabled,
            "data-is-focusable": dataIsFocusable
        }, // aria-pressed attribute should only be present for toggle buttons
        // aria-checked attribute should only be present for toggle buttons with checkbox type role
        _a[isCheckboxTypeRole ? "aria-checked" : "aria-pressed"] = checkedOrPressedValue, _a));
        if (ariaHidden) buttonProps["aria-hidden"] = true;
        if (this._isSplitButton) return this._onRenderSplitButtonContent(tag, buttonProps);
        else if (this.props.menuProps) {
            var _e = this.props.menuProps.id, id = _e === void 0 ? "".concat(this._labelId, "-menu") : _e;
            (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, {
                "aria-expanded": !menuHidden,
                "aria-controls": !menuHidden ? id : null,
                "aria-haspopup": true
            });
        }
        return this._onRenderContent(tag, buttonProps);
    };
    BaseButton.prototype.componentDidMount = function() {
        // For split buttons, touching anywhere in the button should drop the dropdown, which should contain the
        // primary action. This gives more hit target space for touch environments. We're setting the onpointerdown here,
        // because React does not support Pointer events yet.
        if (this._isSplitButton && this._splitButtonContainer.current) {
            if ("onpointerdown" in this._splitButtonContainer.current) this._events.on(this._splitButtonContainer.current, "pointerdown", this._onPointerDown, true);
            if ("onpointerup" in this._splitButtonContainer.current && this.props.onPointerUp) this._events.on(this._splitButtonContainer.current, "pointerup", this.props.onPointerUp, true);
        }
    };
    BaseButton.prototype.componentDidUpdate = function(prevProps, prevState) {
        // If Button's menu was closed, run onAfterMenuDismiss.
        if (this.props.onAfterMenuDismiss && !prevState.menuHidden && this.state.menuHidden) this.props.onAfterMenuDismiss();
    };
    BaseButton.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
    };
    BaseButton.prototype.focus = function() {
        var _a, _b;
        if (this._isSplitButton && this._splitButtonContainer.current) {
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, undefined, (_a = this.context) === null || _a === void 0 ? void 0 : _a.registeredProviders);
            this._splitButtonContainer.current.focus();
        } else if (this._buttonElement.current) {
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, undefined, (_b = this.context) === null || _b === void 0 ? void 0 : _b.registeredProviders);
            this._buttonElement.current.focus();
        }
    };
    BaseButton.prototype.dismissMenu = function() {
        this._dismissMenu();
    };
    BaseButton.prototype.openMenu = function(shouldFocusOnContainer, shouldFocusOnMount) {
        this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
    };
    BaseButton.prototype._onRenderContent = function(tag, buttonProps) {
        var _this = this;
        var props = this.props;
        var Tag = tag;
        var menuIconProps = props.menuIconProps, menuProps = props.menuProps, _a = props.onRenderIcon, onRenderIcon = _a === void 0 ? this._onRenderIcon : _a, _b = props.onRenderAriaDescription, onRenderAriaDescription = _b === void 0 ? this._onRenderAriaDescription : _b, _c = props.onRenderChildren, onRenderChildren = _c === void 0 ? this._onRenderChildren : _c, // eslint-disable-next-line deprecation/deprecation
        _d = props.onRenderMenu, // eslint-disable-next-line deprecation/deprecation
        onRenderMenu = _d === void 0 ? this._onRenderMenu : _d, _e = props.onRenderMenuIcon, onRenderMenuIcon = _e === void 0 ? this._onRenderMenuIcon : _e, disabled = props.disabled;
        var keytipProps = props.keytipProps;
        if (keytipProps && menuProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        var Button = function(keytipAttributes) {
            return $acw62.createElement(Tag, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, buttonProps, keytipAttributes), $acw62.createElement("span", {
                className: _this._classNames.flexContainer,
                "data-automationid": "splitbuttonprimary"
            }, onRenderIcon(props, _this._onRenderIcon), _this._onRenderTextContents(), onRenderAriaDescription(props, _this._onRenderAriaDescription), onRenderChildren(props, _this._onRenderChildren), !_this._isSplitButton && (menuProps || menuIconProps || _this.props.onRenderMenuIcon) && onRenderMenuIcon(_this.props, _this._onRenderMenuIcon), menuProps && !menuProps.doNotLayer && _this._shouldRenderMenu() && onRenderMenu(_this._getMenuProps(menuProps), _this._onRenderMenu)));
        };
        var Content = keytipProps ? // If we're making a split button, we won't put the keytip here
        $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: !this._isSplitButton ? keytipProps : undefined,
            ariaDescribedBy: buttonProps["aria-describedby"],
            disabled: disabled
        }, function(keytipAttributes) {
            return Button(keytipAttributes);
        }) : Button();
        if (menuProps && menuProps.doNotLayer) return $acw62.createElement($acw62.Fragment, null, Content, this._shouldRenderMenu() && onRenderMenu(this._getMenuProps(menuProps), this._onRenderMenu));
        return $acw62.createElement($acw62.Fragment, null, Content, $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null));
    };
    /**
     * Method to help determine if the menu's component tree should
     * be rendered. It takes into account whether the menu is expanded,
     * whether it is a persisted menu and whether it has been shown to the user.
     */ BaseButton.prototype._shouldRenderMenu = function() {
        var menuHidden = this.state.menuHidden;
        // eslint-disable-next-line deprecation/deprecation
        var _a = this.props, persistMenu = _a.persistMenu, renderPersistedMenuHiddenOnMount = _a.renderPersistedMenuHiddenOnMount;
        if (!menuHidden) // Always should render a menu when it is expanded
        return true;
        else if (persistMenu && (this._renderedVisibleMenu || renderPersistedMenuHiddenOnMount)) // _renderedVisibleMenu ensures that the first rendering of
        // the menu happens on-screen, as edge's scrollbar calculations are off if done while hidden.
        return true;
        return false;
    };
    BaseButton.prototype._hasText = function() {
        // _onRenderTextContents and _onRenderText do not perform the same checks. Below is parity with what _onRenderText
        // used to have before the refactor that introduced this function. _onRenderTextContents does not require props.
        // text to be undefined in order for props.children to be used as a fallback.
        // Purely a code maintainability/reuse issue, but logged as Issue #4979.
        return this.props.text !== null && (this.props.text !== undefined || typeof this.props.children === "string");
    };
    BaseButton.prototype._getMenuProps = function(menuProps) {
        var persistMenu = this.props.persistMenu;
        var menuHidden = this.state.menuHidden;
        // the accessible menu label (accessible name) has a relationship to the button.
        // If the menu props do not specify an explicit value for aria-label or aria-labelledBy,
        // AND the button has text, we'll set the menu aria-labelledBy to the text element id.
        if (!menuProps.ariaLabel && !menuProps.labelElementId && this._hasText()) menuProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuProps), {
            labelElementId: this._labelId
        });
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: this._labelId + "-menu",
            directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomLeftEdge
        }, menuProps), {
            shouldFocusOnContainer: this._menuShouldFocusOnContainer,
            shouldFocusOnMount: this._menuShouldFocusOnMount,
            hidden: persistMenu ? menuHidden : undefined,
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-BaseButton-menuhost", menuProps.className),
            target: this._isSplitButton ? this._splitButtonContainer.current : this._buttonElement.current,
            onDismiss: this._onDismissMenu
        });
    };
    BaseButton.prototype._onRenderSplitButtonContent = function(tag, buttonProps) {
        var _this = this;
        var _a = this.props, _b = _a.styles, styles = _b === void 0 ? {} : _b, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, getSplitButtonClassNames = _a.getSplitButtonClassNames, primaryDisabled = _a.primaryDisabled, menuProps = _a.menuProps, toggle = _a.toggle, role = _a.role, primaryActionButtonProps = _a.primaryActionButtonProps;
        var keytipProps = this.props.keytipProps;
        var menuHidden = this.state.menuHidden;
        var classNames = getSplitButtonClassNames ? getSplitButtonClassNames(!!disabled, !menuHidden, !!checked, !!allowDisabledFocus) : styles && (0, $69f0f54fd3cb91aa$export$f5956e741d4621bd)(styles, !!disabled, !menuHidden, !!checked, !!primaryDisabled);
        (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, {
            onClick: undefined,
            onPointerDown: undefined,
            onPointerUp: undefined,
            tabIndex: -1,
            "data-is-focusable": false
        });
        if (keytipProps && menuProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        var containerProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(buttonProps, [], [
            "disabled"
        ]);
        // Add additional props to apply on primary action button
        if (primaryActionButtonProps) (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, primaryActionButtonProps);
        var SplitButton = function(keytipAttributes) {
            return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
                "data-ktp-target": keytipAttributes ? keytipAttributes["data-ktp-target"] : undefined,
                role: role ? role : "button",
                "aria-disabled": disabled,
                "aria-haspopup": true,
                "aria-expanded": !menuHidden,
                "aria-pressed": toggle ? !!checked : undefined,
                "aria-describedby": (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(buttonProps["aria-describedby"], keytipAttributes ? keytipAttributes["aria-describedby"] : undefined),
                className: classNames && classNames.splitButtonContainer,
                onKeyDown: _this._onSplitButtonContainerKeyDown,
                onTouchStart: _this._onTouchStart,
                ref: _this._splitButtonContainer,
                "data-is-focusable": true,
                onClick: !disabled && !primaryDisabled ? _this._onSplitButtonPrimaryClick : undefined,
                tabIndex: !disabled && !primaryDisabled || allowDisabledFocus ? 0 : undefined,
                "aria-roledescription": buttonProps["aria-roledescription"],
                onFocusCapture: _this._onSplitContainerFocusCapture
            }), $acw62.createElement("span", {
                style: {
                    display: "flex",
                    width: "100%"
                }
            }, _this._onRenderContent(tag, buttonProps), _this._onRenderSplitButtonMenuButton(classNames, keytipAttributes), _this._onRenderSplitButtonDivider(classNames)));
        };
        return keytipProps ? $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            disabled: disabled
        }, function(keytipAttributes) {
            return SplitButton(keytipAttributes);
        }) : SplitButton();
    };
    BaseButton.prototype._onRenderSplitButtonDivider = function(classNames) {
        if (classNames && classNames.divider) {
            var onClick = function(ev) {
                ev.stopPropagation();
            };
            return $acw62.createElement("span", {
                className: classNames.divider,
                "aria-hidden": true,
                onClick: onClick
            });
        }
        return null;
    };
    BaseButton.prototype._onRenderSplitButtonMenuButton = function(classNames, keytipAttributes) {
        var _a = this.props, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, disabled = _a.disabled, splitButtonMenuProps = _a.splitButtonMenuProps, splitButtonAriaLabel = _a.splitButtonAriaLabel, primaryDisabled = _a.primaryDisabled;
        var menuHidden = this.state.menuHidden;
        var menuIconProps = this.props.menuIconProps;
        if (menuIconProps === undefined) menuIconProps = {
            iconName: "ChevronDown"
        };
        var splitButtonProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonMenuProps), {
            styles: classNames,
            checked: checked,
            disabled: disabled,
            allowDisabledFocus: allowDisabledFocus,
            onClick: this._onMenuClick,
            menuProps: undefined,
            iconProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuIconProps), {
                className: this._classNames.menuIcon
            }),
            ariaLabel: splitButtonAriaLabel,
            "aria-haspopup": true,
            "aria-expanded": !menuHidden,
            "data-is-focusable": false
        });
        // Add data-ktp-execute-target to the split button if the keytip is defined
        return $acw62.createElement(BaseButton, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonProps, {
            "data-ktp-execute-target": keytipAttributes ? keytipAttributes["data-ktp-execute-target"] : keytipAttributes,
            onMouseDown: this._onMouseDown,
            tabIndex: primaryDisabled && !allowDisabledFocus ? 0 : -1
        }));
    };
    BaseButton.prototype._onPointerDown = function(ev) {
        var onPointerDown = this.props.onPointerDown;
        if (onPointerDown) onPointerDown(ev);
        if (ev.pointerType === "touch") {
            this._handleTouchAndPointerEvent();
            ev.preventDefault();
            ev.stopImmediatePropagation();
        }
    };
    BaseButton.prototype._handleTouchAndPointerEvent = function() {
        var _this = this;
        // If we already have an existing timeout from a previous touch and pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function() {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
            // Touch and pointer events don't focus the button naturally,
            // so adding an imperative focus call to guarantee this behavior.
            // Only focus the button if a splitbutton menu is not open
            if (_this.state.menuHidden) _this.focus();
        }, $108f802e6afba9ea$var$TouchIdleDelay);
    };
    /**
     * Returns if the user hits a valid keyboard key to open the menu
     * @param ev - the keyboard event
     * @returns True if user clicks on custom trigger key if enabled or alt + down arrow if not. False otherwise.
     */ BaseButton.prototype._isValidMenuOpenKey = function(ev) {
        if (this.props.menuTriggerKeyCode) // eslint-disable-next-line deprecation/deprecation
        return ev.which === this.props.menuTriggerKeyCode;
        else if (this.props.menuProps) // eslint-disable-next-line deprecation/deprecation
        return ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down && (ev.altKey || ev.metaKey);
        // Note: When enter is pressed, we will let the event continue to propagate
        // to trigger the onClick event on the button
        return false;
    };
    BaseButton.defaultProps = {
        baseClassName: "ms-Button",
        styles: {},
        split: false
    };
    // needed to access registeredProviders when manually setting focus visibility
    BaseButton.contextType = (0, $872a30e3c6519016$export$683969f4bf72ffbd);
    return BaseButton;
}($acw62.Component);




var $acw62 = parcelRequire("acw62");




function $037d9c48a7aea5ed$export$3693d3f92db27e78(scope, fields, concatStyles) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function customizableFactory(ComposedComponent) {
        var _a;
        var resultClass = (_a = /** @class */ function(_super) {
            (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ComponentWithInjectedProps, _super);
            function ComponentWithInjectedProps(props) {
                var _this = _super.call(this, props) || this;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                _this._styleCache = {};
                _this._onSettingChanged = _this._onSettingChanged.bind(_this);
                return _this;
            }
            ComponentWithInjectedProps.prototype.componentDidMount = function() {
                (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(this._onSettingChanged);
            };
            ComponentWithInjectedProps.prototype.componentWillUnmount = function() {
                (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(this._onSettingChanged);
            };
            ComponentWithInjectedProps.prototype.render = function() {
                var _this = this;
                return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Consumer, null, function(context) {
                    var defaultProps = (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(fields, scope, context.customizations);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var componentProps = _this.props;
                    // If defaultProps.styles is a function, evaluate it before calling concatStyleSets
                    if (defaultProps.styles && typeof defaultProps.styles === "function") defaultProps.styles = defaultProps.styles((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps), componentProps));
                    // If concatStyles is true and custom styles have been defined compute those styles
                    if (concatStyles && defaultProps.styles) {
                        if (_this._styleCache.default !== defaultProps.styles || _this._styleCache.component !== componentProps.styles) {
                            var mergedStyles = (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(defaultProps.styles, componentProps.styles);
                            _this._styleCache.default = defaultProps.styles;
                            _this._styleCache.component = componentProps.styles;
                            _this._styleCache.merged = mergedStyles;
                        }
                        return $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps, componentProps, {
                            styles: _this._styleCache.merged
                        }));
                    }
                    return $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps, componentProps));
                });
            };
            ComponentWithInjectedProps.prototype._onSettingChanged = function() {
                this.forceUpdate();
            };
            return ComponentWithInjectedProps;
        }($acw62.Component), _a.displayName = "Customized" + scope, _a);
        return (0, $05b03fe0c0fe3377$export$e2ba2733092cef57)(ComposedComponent, resultClass);
    };
}






var $daa9adaf0cdc8fd1$var$noOutline = {
    outline: 0
};
var $daa9adaf0cdc8fd1$var$iconStyle = function(fontSize) {
    return {
        fontSize: fontSize,
        margin: "0 4px",
        height: "16px",
        lineHeight: "16px",
        textAlign: "center",
        flexShrink: 0
    };
};
var $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme) {
    var _a, _b;
    var semanticColors = theme.semanticColors, effects = theme.effects, fonts = theme.fonts;
    var border = semanticColors.buttonBorder;
    var disabledBackground = semanticColors.disabledBackground;
    var disabledText = semanticColors.disabledText;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        outlineColor: "ButtonText"
    };
    return {
        root: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 1,
                highContrastStyle: buttonHighContrastFocus,
                borderColor: "transparent"
            }),
            theme.fonts.medium,
            {
                border: "1px solid " + border,
                borderRadius: effects.roundedCorner2,
                boxSizing: "border-box",
                cursor: "pointer",
                display: "inline-block",
                padding: "0 16px",
                textDecoration: "none",
                textAlign: "center",
                userSelect: "none",
                selectors: {
                    // IE11 workaround for preventing shift of child elements of a button when active.
                    ":active > span": {
                        position: "relative",
                        left: 0,
                        top: 0
                    }
                }
            }
        ],
        rootDisabled: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 1,
                highContrastStyle: buttonHighContrastFocus,
                borderColor: "transparent"
            }),
            {
                backgroundColor: disabledBackground,
                borderColor: disabledBackground,
                color: disabledText,
                cursor: "default",
                selectors: {
                    ":hover": $daa9adaf0cdc8fd1$var$noOutline,
                    ":focus": $daa9adaf0cdc8fd1$var$noOutline
                }
            }
        ],
        iconDisabled: {
            color: disabledText,
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText"
            }, _a)
        },
        menuIconDisabled: {
            color: disabledText,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText"
            }, _b)
        },
        flexContainer: {
            display: "flex",
            height: "100%",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center"
        },
        description: {
            display: "block"
        },
        textContainer: {
            flexGrow: 1,
            display: "block"
        },
        icon: $daa9adaf0cdc8fd1$var$iconStyle(fonts.mediumPlus.fontSize),
        menuIcon: $daa9adaf0cdc8fd1$var$iconStyle(fonts.small.fontSize),
        label: {
            margin: "0 4px",
            lineHeight: "100%",
            display: "block"
        },
        screenReaderText: (0, $34563ae103a23d08$export$35835471cbe77db4)
    };
});





var $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var effects = theme.effects, palette = theme.palette, semanticColors = theme.semanticColors;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: "none"
    };
    var splitButtonDividerBaseStyles = {
        position: "absolute",
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
    var splitButtonStyles = {
        splitButtonContainer: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                highContrastStyle: buttonHighContrastFocus,
                inset: 2,
                pointerEvents: "none"
            }),
            {
                display: "inline-flex",
                selectors: {
                    ".ms-Button--default": {
                        borderTopRightRadius: "0",
                        borderBottomRightRadius: "0",
                        borderRight: "none",
                        flexGrow: "1"
                    },
                    ".ms-Button--primary": {
                        borderTopRightRadius: "0",
                        borderBottomRightRadius: "0",
                        border: "none",
                        flexGrow: "1",
                        selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                            color: "WindowText",
                            backgroundColor: "Window",
                            border: "1px solid WindowText",
                            borderRightWidth: "0"
                        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a[":hover"] = {
                            border: "none"
                        }, _a[":active"] = {
                            border: "none"
                        }, _a)
                    },
                    ".ms-Button--primary + .ms-Button": {
                        border: "none",
                        selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            border: "1px solid WindowText",
                            borderLeftWidth: "0"
                        }, _b)
                    }
                }
            }
        ],
        splitButtonContainerHovered: {
            selectors: {
                ".ms-Button--primary": {
                    selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "Window",
                        backgroundColor: "Highlight"
                    }, _c)
                },
                ".ms-Button.is-disabled": {
                    color: semanticColors.buttonTextDisabled,
                    selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "GrayText",
                        borderColor: "GrayText",
                        backgroundColor: "Window"
                    }, _d)
                }
            }
        },
        splitButtonContainerChecked: {
            selectors: {
                ".ms-Button--primary": {
                    selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        color: "Window",
                        backgroundColor: "WindowText"
                    }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _e)
                }
            }
        },
        splitButtonContainerCheckedHovered: {
            selectors: {
                ".ms-Button--primary": {
                    selectors: (_f = {}, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        color: "Window",
                        backgroundColor: "WindowText"
                    }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _f)
                }
            }
        },
        splitButtonContainerFocused: {
            outline: "none!important"
        },
        splitButtonMenuButton: (_g = {
            padding: 6,
            height: "auto",
            boxSizing: "border-box",
            borderRadius: 0,
            borderTopRightRadius: effects.roundedCorner2,
            borderBottomRightRadius: effects.roundedCorner2,
            border: "1px solid ".concat(palette.neutralSecondaryAlt),
            borderLeft: "none",
            outline: "transparent",
            userSelect: "none",
            display: "inline-block",
            textDecoration: "none",
            textAlign: "center",
            cursor: "pointer",
            verticalAlign: "top",
            width: 32,
            marginLeft: -1,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0
        }, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            ".ms-Button-menuIcon": {
                color: "WindowText"
            }
        }, _g),
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonDividerBaseStyles), {
            selectors: (_h = {}, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "WindowText"
            }, _h)
        }),
        splitButtonDividerDisabled: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonDividerBaseStyles), {
            selectors: (_j = {}, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "GrayText"
            }, _j)
        }),
        splitButtonMenuButtonDisabled: {
            pointerEvents: "none",
            border: "none",
            selectors: (_k = {
                ":hover": {
                    cursor: "default"
                },
                ".ms-Button--primary": {
                    selectors: (_l = {}, _l[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "GrayText",
                        borderColor: "GrayText",
                        backgroundColor: "Window"
                    }, _l)
                },
                ".ms-Button-menuIcon": {
                    selectors: (_m = {}, _m[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "GrayText"
                    }, _m)
                }
            }, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText",
                border: "1px solid GrayText",
                backgroundColor: "Window"
            }, _k)
        },
        splitButtonFlexContainer: {
            display: "flex",
            height: "100%",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center"
        },
        splitButtonContainerDisabled: {
            outline: "none",
            border: "none",
            selectors: (_o = {}, _o[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: "GrayText",
                borderColor: "GrayText",
                backgroundColor: "Window"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _o)
        },
        splitButtonMenuFocused: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
            highContrastStyle: buttonHighContrastFocus,
            inset: 2
        }))
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(splitButtonStyles, customStyles);
});





var $f2de76bf8443ae94$var$splitButtonDividerBaseStyles = function() {
    return {
        position: "absolute",
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
};
function $f2de76bf8443ae94$export$d3b979120f04e53e(theme) {
    var _a, _b, _c, _d, _e;
    var s = theme.semanticColors, p = theme.palette;
    var buttonBackground = s.buttonBackground;
    var buttonBackgroundPressed = s.buttonBackgroundPressed;
    var buttonBackgroundHovered = s.buttonBackgroundHovered;
    var buttonBackgroundDisabled = s.buttonBackgroundDisabled;
    var buttonText = s.buttonText;
    var buttonTextHovered = s.buttonTextHovered;
    var buttonTextDisabled = s.buttonTextDisabled;
    var buttonTextChecked = s.buttonTextChecked;
    var buttonTextCheckedHovered = s.buttonTextCheckedHovered;
    return {
        root: {
            backgroundColor: buttonBackground,
            color: buttonText
        },
        rootHovered: {
            backgroundColor: buttonBackgroundHovered,
            color: buttonTextHovered,
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                borderColor: "Highlight",
                color: "Highlight"
            }, _a)
        },
        rootPressed: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootExpanded: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootChecked: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootCheckedHovered: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextCheckedHovered
        },
        rootDisabled: {
            color: buttonTextDisabled,
            backgroundColor: buttonBackgroundDisabled,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText",
                borderColor: "GrayText",
                backgroundColor: "Window"
            }, _b)
        },
        // Split button styles
        splitButtonContainer: {
            selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                border: "none"
            }, _c)
        },
        splitButtonMenuButton: {
            color: p.white,
            backgroundColor: "transparent",
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralLight,
                    selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "Highlight"
                    }, _d)
                }
            }
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.buttonBackgroundDisabled,
            selectors: {
                ":hover": {
                    backgroundColor: s.buttonBackgroundDisabled
                }
            }
        },
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f2de76bf8443ae94$var$splitButtonDividerBaseStyles()), {
            backgroundColor: p.neutralTertiaryAlt,
            selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "WindowText"
            }, _e)
        }),
        splitButtonDividerDisabled: {
            backgroundColor: theme.palette.neutralTertiaryAlt
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: p.neutralQuaternaryAlt,
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: p.neutralQuaternaryAlt,
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuIcon: {
            color: s.buttonText
        },
        splitButtonMenuIconDisabled: {
            color: s.buttonTextDisabled
        }
    };
}
function $f2de76bf8443ae94$export$7e75853538f28122(theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var p = theme.palette, s = theme.semanticColors;
    return {
        root: {
            backgroundColor: s.primaryButtonBackground,
            border: "1px solid ".concat(s.primaryButtonBackground),
            color: s.primaryButtonText,
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: "Window",
                backgroundColor: "WindowText",
                borderColor: "WindowText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus")] = {
                selectors: {
                    ":after": {
                        border: "none",
                        outlineColor: p.white
                    }
                }
            }, _a)
        },
        rootHovered: {
            backgroundColor: s.primaryButtonBackgroundHovered,
            border: "1px solid ".concat(s.primaryButtonBackgroundHovered),
            color: s.primaryButtonTextHovered,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "Window",
                backgroundColor: "Highlight",
                borderColor: "Highlight"
            }, _b)
        },
        rootPressed: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            border: "1px solid ".concat(s.primaryButtonBackgroundPressed),
            color: s.primaryButtonTextPressed,
            selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: "Window",
                backgroundColor: "WindowText",
                borderColor: "WindowText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _c)
        },
        rootExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootCheckedHovered: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootDisabled: {
            color: s.primaryButtonTextDisabled,
            backgroundColor: s.primaryButtonBackgroundDisabled,
            selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText",
                borderColor: "GrayText",
                backgroundColor: "Window"
            }, _d)
        },
        // Split button styles
        splitButtonContainer: {
            selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                border: "none"
            }, _e)
        },
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f2de76bf8443ae94$var$splitButtonDividerBaseStyles()), {
            backgroundColor: p.white,
            selectors: (_f = {}, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "Window"
            }, _f)
        }),
        splitButtonMenuButton: {
            backgroundColor: s.primaryButtonBackground,
            color: s.primaryButtonText,
            selectors: (_g = {}, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "Canvas"
            }, _g[":hover"] = {
                backgroundColor: s.primaryButtonBackgroundHovered,
                selectors: (_h = {}, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "Highlight"
                }, _h)
            }, _g)
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.primaryButtonBackgroundDisabled,
            selectors: {
                ":hover": {
                    backgroundColor: s.primaryButtonBackgroundDisabled
                }
            }
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            selectors: {
                ":hover": {
                    backgroundColor: s.primaryButtonBackgroundPressed
                }
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            selectors: {
                ":hover": {
                    backgroundColor: s.primaryButtonBackgroundPressed
                }
            }
        },
        splitButtonMenuIcon: {
            color: s.primaryButtonText
        },
        splitButtonMenuIconDisabled: {
            color: p.neutralTertiary,
            selectors: (_j = {}, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText"
            }, _j)
        }
    };
}


var $3bc66d69c75dee3c$var$DEFAULT_BUTTON_HEIGHT = "32px";
var $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_WIDTH = "80px";
var $3bc66d69c75dee3c$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles, primary) {
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var splitButtonStyles = (0, $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57)(theme);
    var defaultButtonStyles = {
        root: {
            minWidth: $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_WIDTH,
            height: $3bc66d69c75dee3c$var$DEFAULT_BUTTON_HEIGHT
        },
        label: {
            fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold
        }
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, defaultButtonStyles, primary ? (0, $f2de76bf8443ae94$export$7e75853538f28122)(theme) : (0, $f2de76bf8443ae94$export$d3b979120f04e53e)(theme), splitButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $82fb36076cfcc62a$export$b7c3a2f69225ecf = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DefaultButton, _super);
    function DefaultButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultButton.prototype.render = function() {
        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: primary ? "ms-Button--primary" : "ms-Button--default",
            styles: (0, $3bc66d69c75dee3c$export$ffd58b7f6f099a57)(theme, styles, primary),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    DefaultButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)("DefaultButton", [
            "theme",
            "styles"
        ], true)
    ], DefaultButton);
    return DefaultButton;
}($acw62.Component);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $bc562438b0465191$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $bc562438b0465191$export$dcf14c9974fe2767 = function(props, forwardedRef) {
    var as = props.as, className = props.className, disabled = props.disabled, href = props.href, onClick = props.onClick, styles = props.styles, theme = props.theme, underline = props.underline;
    var rootRef = $acw62.useRef(null);
    var mergedRootRefs = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, forwardedRef);
    $bc562438b0465191$var$useComponentRef(props, rootRef);
    (0, $872a30e3c6519016$export$471b875afaf1c0a9)(rootRef);
    var classNames = $bc562438b0465191$var$getClassNames(styles, {
        className: className,
        isButton: !href,
        isDisabled: disabled,
        isUnderlined: underline,
        theme: theme
    });
    var _onClick = function(ev) {
        if (disabled) ev.preventDefault();
        else if (onClick) onClick(ev);
    };
    var rootType = as ? as : href ? "a" : "button";
    var state = {};
    var slots = {
        root: rootType
    };
    var slotProps = {
        root: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $bc562438b0465191$var$adjustPropsForRootType(rootType, props)), {
            "aria-disabled": disabled,
            className: classNames.root,
            onClick: _onClick,
            ref: mergedRootRefs
        })
    };
    return {
        state: state,
        slots: slots,
        slotProps: slotProps
    };
};
var $bc562438b0465191$var$useComponentRef = function(props, link) {
    $acw62.useImperativeHandle(props.componentRef, function() {
        return {
            focus: function() {
                if (link.current) link.current.focus();
            }
        };
    }, [
        link
    ]);
};
var $bc562438b0465191$var$adjustPropsForRootType = function(RootType, props) {
    // Deconstruct the props so we remove props like `as`, `theme` and `styles`
    // as those will always be removed. We also take some props that are optional
    // based on the RootType.
    var as = props.as, disabled = props.disabled, target = props.target, href = props.href, theme = props.theme, getStyles = props.getStyles, styles = props.styles, componentRef = props.componentRef, underline = props.underline, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "as",
        "disabled",
        "target",
        "href",
        "theme",
        "getStyles",
        "styles",
        "componentRef",
        "underline"
    ]);
    // RootType will be a string if we're dealing with an html component
    if (typeof RootType === "string") {
        // Remove the disabled prop for anchor elements
        if (RootType === "a") return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            target: target,
            href: disabled ? undefined : href
        }, restProps);
        // Add the type='button' prop for button elements
        if (RootType === "button") return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            type: "button",
            disabled: disabled
        }, restProps);
        // Remove the target and href props for all other non anchor elements
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, restProps), {
            disabled: disabled
        });
    }
    // Retain all props except 'as' for ReactComponents
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        target: target,
        href: href,
        disabled: disabled
    }, restProps);
};


var $6e57777c3b04fd0f$export$f0ade4d041c8bbad = $acw62.forwardRef(function(props, ref) {
    var _a = (0, $bc562438b0465191$export$dcf14c9974fe2767)(props, ref), slots = _a.slots, slotProps = _a.slotProps;
    return $acw62.createElement(slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, slotProps.root));
});
$6e57777c3b04fd0f$export$f0ade4d041c8bbad.displayName = "LinkBase";



var $ad7f833f6d38f25a$export$2ecde6259cbd2585 = {
    root: "ms-Link"
};
var $ad7f833f6d38f25a$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var className = props.className, isButton = props.isButton, isDisabled = props.isDisabled, isUnderlined = props.isUnderlined, theme = props.theme;
    var semanticColors = theme.semanticColors;
    // Tokens
    var linkColor = semanticColors.link;
    var linkInteractedColor = semanticColors.linkHovered;
    var linkDisabledColor = semanticColors.disabledText;
    var focusBorderColor = semanticColors.focusBorder;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($ad7f833f6d38f25a$export$2ecde6259cbd2585, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: linkColor,
                outline: "none",
                fontSize: "inherit",
                fontWeight: "inherit",
                textDecoration: isUnderlined ? "underline" : "none",
                selectors: (_a = {
                    ".ms-Fabric--isFocusVisible &:focus": {
                        // Can't use getFocusStyle because it doesn't support wrapping links
                        // https://github.com/microsoft/fluentui/issues/4883#issuecomment-406743543
                        // Using box-shadow and outline allows the focus rect to wrap links that span multiple lines
                        // and helps the focus rect avoid getting clipped.
                        boxShadow: "0 0 0 1px ".concat(focusBorderColor, " inset"),
                        outline: "1px auto ".concat(focusBorderColor),
                        selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            outline: "1px solid WindowText"
                        }, _b)
                    }
                }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    // For IE high contrast mode
                    borderBottom: "none"
                }, _a)
            },
            isButton && {
                background: "none",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                display: "inline",
                margin: 0,
                overflow: "inherit",
                padding: 0,
                textAlign: "left",
                textOverflow: "inherit",
                userSelect: "text",
                borderBottom: "1px solid transparent",
                selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "LinkText",
                    forcedColorAdjust: "none"
                }, _c)
            },
            !isButton && {
                selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    // This is mainly for MessageBar, which sets MsHighContrastAdjust: none by default
                    MsHighContrastAdjust: "auto",
                    forcedColorAdjust: "auto"
                }, _d)
            },
            isDisabled && [
                "is-disabled",
                {
                    color: linkDisabledColor,
                    cursor: "default"
                },
                {
                    selectors: (_e = {
                        "&:link, &:visited": {
                            pointerEvents: "none"
                        }
                    }, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        // We need to specify the color in High Contrast because of the case of Links rendering as buttons.
                        color: "GrayText"
                    }, _e)
                }
            ],
            !isDisabled && {
                selectors: {
                    "&:active, &:hover, &:active:hover": {
                        color: linkInteractedColor,
                        textDecoration: "underline",
                        selectors: (_f = {}, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            color: "LinkText"
                        }, _f)
                    },
                    "&:focus": {
                        color: linkColor,
                        selectors: (_g = {}, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            color: "LinkText"
                        }, _g)
                    }
                }
            },
            classNames.root,
            className
        ]
    };
};


var $60ef620c1429fb92$export$a6c7ac8248d6e38a = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $6e57777c3b04fd0f$export$f0ade4d041c8bbad), (0, $ad7f833f6d38f25a$export$ffd58b7f6f099a57), undefined, {
    scope: "Link"
});



var $acw62 = parcelRequire("acw62");


/**
 * {@docCategory Button}
 */ var $bf3792db3fad6664$export$ac16a6a04d9b7c84 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PrimaryButton, _super);
    function PrimaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrimaryButton.prototype.render = function() {
        return $acw62.createElement((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            primary: true,
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    PrimaryButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)("PrimaryButton", [
            "theme",
            "styles"
        ], true)
    ], PrimaryButton);
    return PrimaryButton;
}($acw62.Component);





var $c5e1b3c4dc63601c$export$cd63654593e982b8 = function(props) {
    // eslint-disable-next-line eqeqeq
    if (props.children == null) return null;
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? "span" : _a, variant = props.variant, nowrap = props.nowrap, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "block",
        "className",
        "as",
        "variant",
        "nowrap"
    ]);
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: RootType
    });
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(rest, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40))));
};


var $4862b3c0e20b96d3$export$3b0f27c60c314f21 = function(props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts, semanticColors = theme.semanticColors;
    var variantObject = fonts[variant || "medium"];
    return {
        root: [
            variantObject,
            {
                color: variantObject.color || semanticColors.bodyText,
                display: block ? as === "td" ? "table-cell" : "block" : "inline",
                mozOsxFontSmoothing: variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject.WebkitFontSmoothing
            },
            nowrap && {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            },
            className
        ]
    };
};


var $33ce6250cbba555f$export$5f1af8db9871e1d6 = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)((0, $c5e1b3c4dc63601c$export$cd63654593e982b8), {
    displayName: "Text",
    styles: (0, $4862b3c0e20b96d3$export$3b0f27c60c314f21)
});
var $33ce6250cbba555f$export$2e2bcd8739ae039 = $33ce6250cbba555f$export$5f1af8db9871e1d6;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $bffbc12413005587$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    // Label is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Label.
    // Therefore setting a larger cache size.
    cacheSize: 100
});
var $bffbc12413005587$export$31008ffe97c96a49 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LabelBase, _super);
    function LabelBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelBase.prototype.render = function() {
        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? "label" : _b, children = _a.children, className = _a.className, disabled = _a.disabled, styles = _a.styles, required = _a.required, theme = _a.theme;
        var classNames = $bffbc12413005587$var$getClassNames(styles, {
            className: className,
            disabled: disabled,
            required: required,
            theme: theme
        });
        return $acw62.createElement(RootType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
            className: classNames.root
        }), children);
    };
    return LabelBase;
}($acw62.Component);




var $3e06d26ec4cbb954$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme, className = props.className, disabled = props.disabled, required = props.required;
    var semanticColors = theme.semanticColors;
    // Tokens
    var labelFontWeight = (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold;
    var labelColor = semanticColors.bodyText;
    var labelDisabledColor = semanticColors.disabledBodyText;
    var labelRequiredStarColor = semanticColors.errorText;
    return {
        root: [
            "ms-Label",
            theme.fonts.medium,
            {
                fontWeight: labelFontWeight,
                color: labelColor,
                boxSizing: "border-box",
                boxShadow: "none",
                margin: 0,
                display: "block",
                padding: "5px 0",
                wordWrap: "break-word",
                overflowWrap: "break-word"
            },
            disabled && {
                color: labelDisabledColor,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    color: "GrayText"
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a)
            },
            required && {
                selectors: {
                    "::after": {
                        content: "' *'",
                        color: labelRequiredStarColor,
                        paddingRight: 12
                    }
                }
            },
            className
        ]
    };
};


var $dd965dd4d4e16b95$export$b04be29aa201d4f5 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $bffbc12413005587$export$31008ffe97c96a49), (0, $3e06d26ec4cbb954$export$ffd58b7f6f099a57), undefined, {
    scope: "Label"
});





var $acw62 = parcelRequire("acw62");

/**
 * Utility component for delaying the render of a child component after a given delay. This component
 * requires a single child component; don't pass in many components. Wrap multiple components in a DIV
 * if necessary.
 *
 * @public
 * {@docCategory DelayedRender}
 */ var $9e351c993b799a2b$export$fd40b834a3906fa8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DelayedRender, _super);
    function DelayedRender(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isRendered: (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)() === undefined
        };
        return _this;
    }
    DelayedRender.prototype.componentDidMount = function() {
        var _this = this;
        var delay = this.props.delay;
        this._timeoutId = window.setTimeout(function() {
            _this.setState({
                isRendered: true
            });
        }, delay);
    };
    DelayedRender.prototype.componentWillUnmount = function() {
        if (this._timeoutId) clearTimeout(this._timeoutId);
    };
    DelayedRender.prototype.render = function() {
        return this.state.isRendered ? $acw62.Children.only(this.props.children) : null;
    };
    DelayedRender.defaultProps = {
        delay: 0
    };
    return DelayedRender;
}($acw62.Component);

/**
 * Determines whether a component is controlled.
 * @param props - Component props
 * @param valueProp - Prop containing the controlled value
 * @returns true if controlled, false if uncontrolled
 */ function $7d38805171b70f70$export$3143a5795bbdc9f5(props, valueProp) {
    // React's built-in <input> considers a prop to be provided if its value is non-null/undefined.
    // Mirror that behavior here (rather than checking for just undefined).
    return props[valueProp] !== undefined && props[valueProp] !== null;
}


var $71ee415ed46cf931$export$f7bad96d83325a34 = function() {
    var _a;
    var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    if (!((_a = win === null || win === void 0 ? void 0 : win.navigator) === null || _a === void 0 ? void 0 : _a.userAgent)) return false;
    return win.navigator.userAgent.indexOf("rv:11.0") > -1;
};



var $2e5ba4df412d2d61$var$warningsMap;
function $2e5ba4df412d2d61$export$2b2209978b1d1fd1() {}
function $2e5ba4df412d2d61$export$c90ebe9a438620bb(params) {
    var componentId, componentName, defaultValueProp, props, oldProps, onChangeProp, readOnlyProp, valueProp, oldIsControlled, newIsControlled, hasOnChange, isReadOnly, defaultValue, oldType, newType, warnMap;
}


var $da88bf0c83fd9803$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $da88bf0c83fd9803$var$DEFAULT_STATE_VALUE = "";
var $da88bf0c83fd9803$var$COMPONENT_NAME = "TextField";
var $da88bf0c83fd9803$var$REVEAL_ICON_NAME = "RedEye";
var $da88bf0c83fd9803$var$HIDE_ICON_NAME = "Hide";
var $da88bf0c83fd9803$export$d22444a338b6e3c2 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TextFieldBase, _super);
    function TextFieldBase(props) {
        var _this = _super.call(this, props) || this;
        _this._textElement = $acw62.createRef();
        _this._onFocus = function(ev) {
            if (_this.props.onFocus) _this.props.onFocus(ev);
            _this.setState({
                isFocused: true
            }, function() {
                if (_this.props.validateOnFocusIn) _this._validate(_this.value);
            });
        };
        _this._onBlur = function(ev) {
            if (_this.props.onBlur) _this.props.onBlur(ev);
            _this.setState({
                isFocused: false
            }, function() {
                if (_this.props.validateOnFocusOut) _this._validate(_this.value);
            });
        };
        _this._onRenderLabel = function(props) {
            var label = props.label, required = props.required;
            // IProcessedStyleSet definition requires casting for what Label expects as its styles prop
            var labelStyles = _this._classNames.subComponentStyles ? _this._classNames.subComponentStyles.label : undefined;
            if (label) return $acw62.createElement((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), {
                required: required,
                htmlFor: _this._id,
                styles: labelStyles,
                disabled: props.disabled,
                id: _this._labelId
            }, props.label);
            return null;
        };
        _this._onRenderDescription = function(props) {
            if (props.description) return $acw62.createElement("span", {
                className: _this._classNames.description
            }, props.description);
            return null;
        };
        _this._onRevealButtonClick = function(event) {
            _this.setState(function(prevState) {
                return {
                    isRevealingPassword: !prevState.isRevealingPassword
                };
            });
        };
        _this._onInputChange = function(event) {
            // Previously, we needed to call both onInput and onChange due to some weird IE/React issues,
            // which have *probably* been fixed now:
            // - https://github.com/microsoft/fluentui/issues/744 (likely fixed)
            // - https://github.com/microsoft/fluentui/issues/824 (confirmed fixed)
            var _a, _b;
            // TODO (Fabric 8?) - Switch to calling only onChange. This switch is pretty disruptive for
            // tests (ours and maybe consumers' too), so it seemed best to do the switch in a major bump.
            var element = event.target;
            var value = element.value;
            // Ignore this event if any of the following are true:
            // - the value is undefined (in case one of the IE bugs comes back)
            // - it's a duplicate event (important since onInputChange is called twice per actual user event)
            // - it's the same as the previous value
            var previousValue = $da88bf0c83fd9803$var$_getValue(_this.props, _this.state) || "";
            if (value === undefined || value === _this._lastChangeValue || value === previousValue) {
                _this._lastChangeValue = undefined;
                return;
            }
            _this._lastChangeValue = value;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, event, value);
            if (!_this._isControlled) // ONLY if this is an uncontrolled component, update the displayed value.
            // (Controlled components must update the `value` prop from `onChange`.)
            _this.setState({
                uncontrolledValue: value
            });
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._fallbackId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)($da88bf0c83fd9803$var$COMPONENT_NAME);
        _this._descriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)($da88bf0c83fd9803$var$COMPONENT_NAME + "Description");
        _this._labelId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)($da88bf0c83fd9803$var$COMPONENT_NAME + "Label");
        _this._prefixId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)($da88bf0c83fd9803$var$COMPONENT_NAME + "Prefix");
        _this._suffixId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)($da88bf0c83fd9803$var$COMPONENT_NAME + "Suffix");
        _this._warnControlledUsage();
        var _a = props.defaultValue, defaultValue = _a === void 0 ? $da88bf0c83fd9803$var$DEFAULT_STATE_VALUE : _a;
        if (typeof defaultValue === "number") // This isn't allowed per the props, but happens anyway.
        defaultValue = String(defaultValue);
        _this.state = {
            uncontrolledValue: _this._isControlled ? undefined : defaultValue,
            isFocused: false,
            errorMessage: ""
        };
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        return _this;
    }
    Object.defineProperty(TextFieldBase.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */ get: function() {
            return $da88bf0c83fd9803$var$_getValue(this.props, this.state);
        },
        enumerable: false,
        configurable: true
    });
    TextFieldBase.prototype.componentDidMount = function() {
        this._adjustInputHeight();
        if (this.props.validateOnLoad) this._validate(this.value);
    };
    TextFieldBase.prototype.componentWillUnmount = function() {
        this._async.dispose();
    };
    TextFieldBase.prototype.getSnapshotBeforeUpdate = function(prevProps, prevState) {
        return {
            selection: [
                this.selectionStart,
                this.selectionEnd
            ]
        };
    };
    TextFieldBase.prototype.componentDidUpdate = function(prevProps, prevState, snapshot) {
        var props = this.props;
        var _a = (snapshot || {}).selection, selection = _a === void 0 ? [
            null,
            null
        ] : _a;
        var start = selection[0], end = selection[1];
        if (!!prevProps.multiline !== !!props.multiline && prevState.isFocused) {
            // The text field has just changed between single- and multi-line, so we need to reset focus
            // and selection/cursor.
            this.focus();
            if (start !== null && end !== null && start >= 0 && end >= 0) this.setSelectionRange(start, end);
        }
        if (prevProps.value !== props.value) // Only if the value in props changed, reset the record of the last value seen by a
        // change/input event (don't do this if the value in state changed, since at least in tests
        // the state update may happen before the second event in a series)
        this._lastChangeValue = undefined;
        var prevValue = $da88bf0c83fd9803$var$_getValue(prevProps, prevState);
        var value = this.value;
        if (prevValue !== value) {
            // Handle controlled/uncontrolled warnings and status
            this._warnControlledUsage(prevProps);
            // Clear error message if needed
            // TODO: is there any way to do this without an extra render?
            if (this.state.errorMessage && !props.errorMessage) this.setState({
                errorMessage: ""
            });
            // Adjust height if needed based on new value
            this._adjustInputHeight();
            // TODO: #5875 added logic to trigger validation in componentWillReceiveProps and other places.
            // This seems a bit odd and hard to integrate with the new approach.
            // (Starting to think we should just put the validation logic in a separate wrapper component...?)
            if ($da88bf0c83fd9803$var$_shouldValidateAllChanges(props)) this._delayedValidate(value);
        }
    };
    TextFieldBase.prototype.render = function() {
        var _a = this.props, borderless = _a.borderless, className = _a.className, disabled = _a.disabled, invalid = _a.invalid, iconProps = _a.iconProps, inputClassName = _a.inputClassName, label = _a.label, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, prefix = _a.prefix, resizable = _a.resizable, suffix = _a.suffix, theme = _a.theme, styles = _a.styles, autoAdjustHeight = _a.autoAdjustHeight, canRevealPassword = _a.canRevealPassword, revealPasswordAriaLabel = _a.revealPasswordAriaLabel, type = _a.type, _b = _a.onRenderPrefix, onRenderPrefix = _b === void 0 ? this._onRenderPrefix : _b, _c = _a.onRenderSuffix, onRenderSuffix = _c === void 0 ? this._onRenderSuffix : _c, _d = _a.onRenderLabel, onRenderLabel = _d === void 0 ? this._onRenderLabel : _d, _e = _a.onRenderDescription, onRenderDescription = _e === void 0 ? this._onRenderDescription : _e;
        var _f = this.state, isFocused = _f.isFocused, isRevealingPassword = _f.isRevealingPassword;
        var errorMessage = this._errorMessage;
        var isInvalid = typeof invalid === "boolean" ? invalid : !!errorMessage;
        var hasRevealButton = !!canRevealPassword && type === "password" && $da88bf0c83fd9803$var$_browserNeedsRevealButton();
        var classNames = this._classNames = $da88bf0c83fd9803$var$getClassNames(styles, {
            theme: theme,
            className: className,
            disabled: disabled,
            focused: isFocused,
            required: required,
            multiline: multiline,
            hasLabel: !!label,
            hasErrorMessage: isInvalid,
            borderless: borderless,
            resizable: resizable,
            hasIcon: !!iconProps,
            underlined: underlined,
            inputClassName: inputClassName,
            autoAdjustHeight: autoAdjustHeight,
            hasRevealButton: hasRevealButton
        });
        return(// eslint-disable-next-line deprecation/deprecation
        $acw62.createElement("div", {
            ref: this.props.elementRef,
            className: classNames.root
        }, $acw62.createElement("div", {
            className: classNames.wrapper
        }, onRenderLabel(this.props, this._onRenderLabel), $acw62.createElement("div", {
            className: classNames.fieldGroup
        }, (prefix !== undefined || this.props.onRenderPrefix) && $acw62.createElement("div", {
            className: classNames.prefix,
            id: this._prefixId
        }, onRenderPrefix(this.props, this._onRenderPrefix)), multiline ? this._renderTextArea() : this._renderInput(), iconProps && $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            className: classNames.icon
        }, iconProps)), hasRevealButton && // Explicitly set type="button" since the default button type within a form is "submit"
        $acw62.createElement("button", {
            "aria-label": revealPasswordAriaLabel,
            className: classNames.revealButton,
            onClick: this._onRevealButtonClick,
            "aria-pressed": !!isRevealingPassword,
            type: "button"
        }, $acw62.createElement("span", {
            className: classNames.revealSpan
        }, $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            className: classNames.revealIcon,
            iconName: isRevealingPassword ? $da88bf0c83fd9803$var$HIDE_ICON_NAME : $da88bf0c83fd9803$var$REVEAL_ICON_NAME
        }))), (suffix !== undefined || this.props.onRenderSuffix) && $acw62.createElement("div", {
            className: classNames.suffix,
            id: this._suffixId
        }, onRenderSuffix(this.props, this._onRenderSuffix)))), this._isDescriptionAvailable && $acw62.createElement("span", {
            id: this._descriptionId
        }, onRenderDescription(this.props, this._onRenderDescription), errorMessage && $acw62.createElement("div", {
            role: "alert"
        }, $acw62.createElement((0, $9e351c993b799a2b$export$fd40b834a3906fa8), null, this._renderErrorMessage())))));
    };
    /**
     * Sets focus on the text field
     */ TextFieldBase.prototype.focus = function() {
        if (this._textElement.current) this._textElement.current.focus();
    };
    /**
     * Blurs the text field.
     */ TextFieldBase.prototype.blur = function() {
        if (this._textElement.current) this._textElement.current.blur();
    };
    /**
     * Selects the text field
     */ TextFieldBase.prototype.select = function() {
        if (this._textElement.current) this._textElement.current.select();
    };
    /**
     * Sets the selection start of the text field to a specified value
     */ TextFieldBase.prototype.setSelectionStart = function(value) {
        if (this._textElement.current) this._textElement.current.selectionStart = value;
    };
    /**
     * Sets the selection end of the text field to a specified value
     */ TextFieldBase.prototype.setSelectionEnd = function(value) {
        if (this._textElement.current) this._textElement.current.selectionEnd = value;
    };
    Object.defineProperty(TextFieldBase.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */ get: function() {
            return this._textElement.current ? this._textElement.current.selectionStart : -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextFieldBase.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */ get: function() {
            return this._textElement.current ? this._textElement.current.selectionEnd : -1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start - Index of the start of the selection.
     * @param end - Index of the end of the selection.
     */ TextFieldBase.prototype.setSelectionRange = function(start, end) {
        if (this._textElement.current) this._textElement.current.setSelectionRange(start, end);
    };
    TextFieldBase.prototype._warnControlledUsage = function(prevProps) {
        // Show warnings if props are being used in an invalid way
        (0, $2e5ba4df412d2d61$export$c90ebe9a438620bb)({
            componentId: this._id,
            componentName: $da88bf0c83fd9803$var$COMPONENT_NAME,
            props: this.props,
            oldProps: prevProps,
            valueProp: "value",
            defaultValueProp: "defaultValue",
            onChangeProp: "onChange",
            readOnlyProp: "readOnly"
        });
        if (this.props.value === null && !this._hasWarnedNullValue) {
            this._hasWarnedNullValue = true;
            (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)("Warning: 'value' prop on '".concat($da88bf0c83fd9803$var$COMPONENT_NAME, "' should not be null. Consider using an ") + "empty string to clear the component or undefined to indicate an uncontrolled component.");
        }
    };
    Object.defineProperty(TextFieldBase.prototype, "_id", {
        /** Returns `props.id` if available, or a fallback if not. */ get: function() {
            return this.props.id || this._fallbackId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextFieldBase.prototype, "_isControlled", {
        get: function() {
            return (0, $7d38805171b70f70$export$3143a5795bbdc9f5)(this.props, "value");
        },
        enumerable: false,
        configurable: true
    });
    TextFieldBase.prototype._onRenderPrefix = function(props) {
        var prefix = props.prefix;
        return $acw62.createElement("span", {
            style: {
                paddingBottom: "1px"
            }
        }, prefix);
    };
    TextFieldBase.prototype._onRenderSuffix = function(props) {
        var suffix = props.suffix;
        return $acw62.createElement("span", {
            style: {
                paddingBottom: "1px"
            }
        }, suffix);
    };
    Object.defineProperty(TextFieldBase.prototype, "_errorMessage", {
        /**
         * Current error message from either `props.errorMessage` or the result of `props.onGetErrorMessage`.
         *
         * - If there is no validation error or we have not validated the input value, errorMessage is an empty string.
         * - If we have done the validation and there is validation error, errorMessage is the validation error message.
         */ get: function() {
            var _a = this.props.errorMessage, errorMessage = _a === void 0 ? this.state.errorMessage : _a;
            return errorMessage || "";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Renders error message based on the type of the message.
     *
     * - If error message is string, it will render using the built in styles.
     * - If error message is an element, user has full control over how it's rendered.
     */ TextFieldBase.prototype._renderErrorMessage = function() {
        var errorMessage = this._errorMessage;
        return errorMessage ? typeof errorMessage === "string" ? $acw62.createElement("p", {
            className: this._classNames.errorMessage
        }, $acw62.createElement("span", {
            "data-automation-id": "error-message"
        }, errorMessage)) : $acw62.createElement("div", {
            className: this._classNames.errorMessage,
            "data-automation-id": "error-message"
        }, errorMessage) : null;
    };
    Object.defineProperty(TextFieldBase.prototype, "_isDescriptionAvailable", {
        /**
         * If a custom description render function is supplied then treat description as always available.
         * Otherwise defer to the presence of description or error message text.
         */ get: function() {
            var props = this.props;
            return !!(props.onRenderDescription || props.description || this._errorMessage);
        },
        enumerable: false,
        configurable: true
    });
    TextFieldBase.prototype._renderTextArea = function() {
        var _a = this.props.invalid, invalid = _a === void 0 ? !!this._errorMessage : _a;
        var textAreaProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$699534499318873d), [
            "defaultValue"
        ]);
        var ariaLabelledBy = this.props["aria-labelledby"] || (this.props.label ? this._labelId : undefined);
        return $acw62.createElement("textarea", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: this._id
        }, textAreaProps, {
            ref: this._textElement,
            value: this.value || "",
            onInput: this._onInputChange,
            onChange: this._onInputChange,
            className: this._classNames.field,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props["aria-describedby"],
            "aria-invalid": invalid,
            "aria-label": this.props.ariaLabel,
            readOnly: this.props.readOnly,
            onFocus: this._onFocus,
            onBlur: this._onBlur
        }));
    };
    TextFieldBase.prototype._renderInput = function() {
        var _a = this.props, ariaLabel = _a.ariaLabel, _b = _a.invalid, invalid = _b === void 0 ? !!this._errorMessage : _b, onRenderPrefix = _a.onRenderPrefix, onRenderSuffix = _a.onRenderSuffix, prefix = _a.prefix, suffix = _a.suffix, _c = _a.type, type = _c === void 0 ? "text" : _c, label = _a.label;
        // build aria-labelledby list from label, prefix, and suffix
        var labelIds = [];
        label && labelIds.push(this._labelId);
        (prefix !== undefined || onRenderPrefix) && labelIds.push(this._prefixId);
        (suffix !== undefined || onRenderSuffix) && labelIds.push(this._suffixId);
        var inputProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            type: this.state.isRevealingPassword ? "text" : type,
            id: this._id
        }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$33c6815a27d08ce5), [
            "defaultValue",
            "type"
        ])), {
            "aria-labelledby": this.props["aria-labelledby"] || (labelIds.length > 0 ? labelIds.join(" ") : undefined),
            ref: this._textElement,
            value: this.value || "",
            onInput: this._onInputChange,
            onChange: this._onInputChange,
            className: this._classNames.field,
            "aria-label": ariaLabel,
            "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props["aria-describedby"],
            "aria-invalid": invalid,
            onFocus: this._onFocus,
            onBlur: this._onBlur
        });
        var defaultRender = function(updatedInputProps) {
            return $acw62.createElement("input", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, updatedInputProps));
        };
        var onRenderInput = this.props.onRenderInput || defaultRender;
        return onRenderInput(inputProps, defaultRender);
    };
    TextFieldBase.prototype._validate = function(value) {
        var _this = this;
        // In case _validate is called again while validation promise is executing
        if (this._latestValidateValue === value && $da88bf0c83fd9803$var$_shouldValidateAllChanges(this.props)) return;
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage && onGetErrorMessage(value || "");
        if (result !== undefined) {
            if (typeof result === "string" || !("then" in result)) {
                this.setState({
                    errorMessage: result
                });
                this._notifyAfterValidate(value, result);
            } else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function(errorMessage) {
                    if (currentValidation_1 === _this._lastValidation) _this.setState({
                        errorMessage: errorMessage
                    });
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        } else this._notifyAfterValidate(value, "");
    };
    TextFieldBase.prototype._notifyAfterValidate = function(value, errorMessage) {
        if (value === this.value && this.props.onNotifyValidationResult) this.props.onNotifyValidationResult(errorMessage, value);
    };
    TextFieldBase.prototype._adjustInputHeight = function() {
        if (this._textElement.current && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement.current;
            textField.style.height = "";
            textField.style.height = textField.scrollHeight + "px";
        }
    };
    TextFieldBase.defaultProps = {
        resizable: true,
        deferredValidationTime: 200,
        validateOnLoad: true
    };
    return TextFieldBase;
}($acw62.Component);
/** Get the value from the given state and props (converting from number to string if needed) */ function $da88bf0c83fd9803$var$_getValue(props, state) {
    var _a = props.value, value = _a === void 0 ? state.uncontrolledValue : _a;
    if (typeof value === "number") // not allowed per typings, but happens anyway
    return String(value);
    return value;
}
/**
 * If `validateOnFocusIn` or `validateOnFocusOut` is true, validation should run **only** on that event.
 * Otherwise, validation should run on every change.
 */ function $da88bf0c83fd9803$var$_shouldValidateAllChanges(props) {
    return !(props.validateOnFocusIn || props.validateOnFocusOut);
}
// Only calculate this once across all TextFields, since will stay the same
var $da88bf0c83fd9803$var$__browserNeedsRevealButton;
function $da88bf0c83fd9803$var$_browserNeedsRevealButton() {
    if (typeof $da88bf0c83fd9803$var$__browserNeedsRevealButton !== "boolean") {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        if (win === null || win === void 0 ? void 0 : win.navigator) {
            // Edge, Chromium Edge
            var isEdge = /Edg/.test(win.navigator.userAgent || "");
            $da88bf0c83fd9803$var$__browserNeedsRevealButton = !((0, $71ee415ed46cf931$export$f7bad96d83325a34)() || isEdge);
        } else $da88bf0c83fd9803$var$__browserNeedsRevealButton = true;
    }
    return $da88bf0c83fd9803$var$__browserNeedsRevealButton;
}




var $10db48f15021a11b$var$globalClassNames = {
    root: "ms-TextField",
    description: "ms-TextField-description",
    errorMessage: "ms-TextField-errorMessage",
    field: "ms-TextField-field",
    fieldGroup: "ms-TextField-fieldGroup",
    prefix: "ms-TextField-prefix",
    suffix: "ms-TextField-suffix",
    wrapper: "ms-TextField-wrapper",
    revealButton: "ms-TextField-reveal",
    multiline: "ms-TextField--multiline",
    borderless: "ms-TextField--borderless",
    underlined: "ms-TextField--underlined",
    unresizable: "ms-TextField--unresizable",
    required: "is-required",
    disabled: "is-disabled",
    active: "is-active"
};
function $10db48f15021a11b$var$getLabelStyles(props) {
    var underlined = props.underlined, disabled = props.disabled, focused = props.focused, theme = props.theme;
    var palette = theme.palette, fonts = theme.fonts;
    return function() {
        var _a;
        return {
            root: [
                underlined && disabled && {
                    color: palette.neutralTertiary
                },
                underlined && {
                    fontSize: fonts.medium.fontSize,
                    marginRight: 8,
                    paddingLeft: 12,
                    paddingRight: 0,
                    lineHeight: "22px",
                    height: 32
                },
                underlined && focused && {
                    selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        height: 31
                    }, _a)
                }
            ]
        };
    };
}
function $10db48f15021a11b$export$ffd58b7f6f099a57(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var theme = props.theme, className = props.className, disabled = props.disabled, focused = props.focused, required = props.required, multiline = props.multiline, hasLabel = props.hasLabel, borderless = props.borderless, underlined = props.underlined, hasIcon = props.hasIcon, resizable = props.resizable, hasErrorMessage = props.hasErrorMessage, inputClassName = props.inputClassName, autoAdjustHeight = props.autoAdjustHeight, hasRevealButton = props.hasRevealButton;
    var semanticColors = theme.semanticColors, effects = theme.effects, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($10db48f15021a11b$var$globalClassNames, theme);
    var fieldPrefixSuffix = {
        // Suffix/Prefix are not editable so the disabled slot perfectly fits.
        background: semanticColors.disabledBackground,
        color: !disabled ? semanticColors.inputPlaceholderText : semanticColors.disabledText,
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        lineHeight: 1,
        whiteSpace: "nowrap",
        flexShrink: 0,
        selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            background: "Window",
            color: disabled ? "GrayText" : "WindowText"
        }, _a)
    };
    // placeholder style constants
    var placeholderStyles = [
        {
            color: semanticColors.inputPlaceholderText,
            opacity: 1,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "GrayText"
            }, _b)
        }
    ];
    var disabledPlaceholderStyles = {
        color: semanticColors.disabledText,
        selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: "GrayText"
        }, _c)
    };
    return {
        root: [
            classNames.root,
            fonts.medium,
            required && classNames.required,
            disabled && classNames.disabled,
            focused && classNames.active,
            multiline && classNames.multiline,
            borderless && classNames.borderless,
            underlined && classNames.underlined,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            {
                position: "relative"
            },
            className
        ],
        wrapper: [
            classNames.wrapper,
            underlined && [
                {
                    display: "flex",
                    borderBottom: "1px solid ".concat(!hasErrorMessage ? semanticColors.inputBorder : semanticColors.errorText),
                    width: "100%"
                },
                disabled && {
                    borderBottomColor: semanticColors.disabledBackground,
                    selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        borderColor: "GrayText"
                    }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _d)
                },
                !disabled && {
                    selectors: {
                        ":hover": {
                            borderBottomColor: !hasErrorMessage ? semanticColors.inputBorderHovered : semanticColors.errorText,
                            selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                                borderBottomColor: "Highlight"
                            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _e)
                        }
                    }
                },
                focused && [
                    {
                        position: "relative"
                    },
                    (0, $3c8eab4e1d179dea$export$47ad9ea05ccc047b)(!hasErrorMessage ? semanticColors.inputFocusBorderAlt : semanticColors.errorText, 0, "borderBottom")
                ]
            ]
        ],
        fieldGroup: [
            classNames.fieldGroup,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            {
                border: "1px solid ".concat(semanticColors.inputBorder),
                borderRadius: effects.roundedCorner2,
                background: semanticColors.inputBackground,
                cursor: "text",
                height: 32,
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                position: "relative"
            },
            multiline && {
                minHeight: "60px",
                height: "auto",
                display: "flex"
            },
            !focused && !disabled && {
                selectors: {
                    ":hover": {
                        borderColor: semanticColors.inputBorderHovered,
                        selectors: (_f = {}, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                            borderColor: "Highlight"
                        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _f)
                    }
                }
            },
            focused && !underlined && (0, $3c8eab4e1d179dea$export$47ad9ea05ccc047b)(!hasErrorMessage ? semanticColors.inputFocusBorderAlt : semanticColors.errorText, effects.roundedCorner2),
            disabled && {
                borderColor: semanticColors.disabledBackground,
                selectors: (_g = {}, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    borderColor: "GrayText"
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _g),
                cursor: "default"
            },
            borderless && {
                border: "none"
            },
            borderless && focused && {
                border: "none",
                selectors: {
                    ":after": {
                        border: "none"
                    }
                }
            },
            underlined && {
                flex: "1 1 0px",
                border: "none",
                textAlign: "left"
            },
            underlined && disabled && {
                backgroundColor: "transparent"
            },
            hasErrorMessage && !underlined && {
                borderColor: semanticColors.errorText,
                selectors: {
                    "&:hover": {
                        borderColor: semanticColors.errorText
                    }
                }
            },
            !hasLabel && required && {
                selectors: (_h = {
                    ":before": {
                        content: "'*'",
                        color: semanticColors.errorText,
                        position: "absolute",
                        top: -5,
                        right: -10
                    }
                }, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    selectors: {
                        ":before": {
                            color: "WindowText",
                            right: -14
                        }
                    }
                }, _h)
            }
        ],
        field: [
            fonts.medium,
            classNames.field,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            {
                borderRadius: 0,
                border: "none",
                background: "none",
                backgroundColor: "transparent",
                color: semanticColors.inputText,
                padding: "0 8px",
                width: "100%",
                minWidth: 0,
                textOverflow: "ellipsis",
                outline: 0,
                selectors: (_j = {
                    "&:active, &:focus, &:hover": {
                        outline: 0
                    },
                    "::-ms-clear": {
                        display: "none"
                    }
                }, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    background: "Window",
                    color: disabled ? "GrayText" : "WindowText"
                }, _j)
            },
            (0, $0f1b07507d939466$export$be3d79419dd9c4a2)(placeholderStyles),
            multiline && !resizable && [
                classNames.unresizable,
                {
                    resize: "none"
                }
            ],
            multiline && {
                minHeight: "inherit",
                lineHeight: 17,
                flexGrow: 1,
                paddingTop: 6,
                paddingBottom: 6,
                overflow: "auto",
                width: "100%"
            },
            multiline && autoAdjustHeight && {
                overflow: "hidden"
            },
            hasIcon && !hasRevealButton && {
                paddingRight: 24
            },
            multiline && hasIcon && {
                paddingRight: 40
            },
            disabled && [
                {
                    backgroundColor: semanticColors.disabledBackground,
                    color: semanticColors.disabledText,
                    borderColor: semanticColors.disabledBackground
                },
                (0, $0f1b07507d939466$export$be3d79419dd9c4a2)(disabledPlaceholderStyles)
            ],
            underlined && {
                textAlign: "left"
            },
            focused && !borderless && {
                selectors: (_k = {}, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    paddingLeft: 11,
                    paddingRight: 11
                }, _k)
            },
            focused && multiline && !borderless && {
                selectors: (_l = {}, _l[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    paddingTop: 4
                }, _l)
            },
            inputClassName
        ],
        icon: [
            multiline && {
                paddingRight: 24,
                alignItems: "flex-end"
            },
            {
                pointerEvents: "none",
                position: "absolute",
                bottom: 6,
                right: 8,
                top: "auto",
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
                lineHeight: 18
            },
            disabled && {
                color: semanticColors.disabledText
            }
        ],
        description: [
            classNames.description,
            {
                color: semanticColors.bodySubtext,
                fontSize: fonts.xSmall.fontSize
            }
        ],
        errorMessage: [
            classNames.errorMessage,
            (0, $e2629e8d47c94809$export$a386448ab9904275).slideDownIn20,
            fonts.small,
            {
                color: semanticColors.errorText,
                margin: 0,
                paddingTop: 5,
                display: "flex",
                alignItems: "center"
            }
        ],
        prefix: [
            classNames.prefix,
            fieldPrefixSuffix
        ],
        suffix: [
            classNames.suffix,
            fieldPrefixSuffix
        ],
        revealButton: [
            classNames.revealButton,
            "ms-Button",
            "ms-Button--icon",
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 1
            }),
            {
                height: 30,
                width: 32,
                border: "none",
                padding: "0px 4px",
                backgroundColor: "transparent",
                color: semanticColors.link,
                selectors: {
                    ":hover": {
                        outline: 0,
                        color: semanticColors.primaryButtonBackgroundHovered,
                        backgroundColor: semanticColors.buttonBackgroundHovered,
                        selectors: (_m = {}, _m[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            borderColor: "Highlight",
                            color: "Highlight"
                        }, _m)
                    },
                    ":focus": {
                        outline: 0
                    }
                }
            },
            hasIcon && {
                marginRight: 28
            }
        ],
        revealSpan: {
            display: "flex",
            height: "100%",
            alignItems: "center"
        },
        revealIcon: {
            margin: "0px 4px",
            pointerEvents: "none",
            bottom: 6,
            right: 8,
            top: "auto",
            fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
            lineHeight: 18
        },
        subComponentStyles: {
            label: $10db48f15021a11b$var$getLabelStyles(props)
        }
    };
}


var $90af54869168591e$export$2c73285ae9390cec = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $da88bf0c83fd9803$export$d22444a338b6e3c2), (0, $10db48f15021a11b$export$ffd58b7f6f099a57), undefined, {
    scope: "TextField"
});



var $acw62 = parcelRequire("acw62");
var $4134536fed3901fa$var$getCookie = function(key) {
    var cookies = document.cookie.split(";").map(function(x) {
        return x.trim();
    });
    for(var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++){
        var cookie = cookies_1[_i];
        var cookieParts = cookie.split("=");
        if (cookieParts[0] === key) return cookieParts[1];
    }
    return "";
};
var $4134536fed3901fa$export$bc4ac5c7b57c369a = function(key, defaultValue) {
    var _a = $acw62.useState(defaultValue || ""), value = _a[0], setValue = _a[1];
    var storeValue = $acw62.useMemo(function() {
        return function(newValue) {
            try {
                var textValue = newValue ? typeof newValue !== "string" ? JSON.stringify(newValue) : newValue : "";
                document.cookie = "".concat(key, "=").concat(btoa(textValue));
            } catch (err) {
                console.log("Error writing the cookie '".concat(key, "'."), err);
            }
            setValue(newValue);
        };
    }, [
        key
    ]);
    $acw62.useEffect(function() {
        try {
            var value_1;
            var text = atob($4134536fed3901fa$var$getCookie(key) || "");
            try {
                value_1 = JSON.parse(text);
            } catch (_a) {
                value_1 = text;
            }
            setValue(value_1);
        } catch (err) {
            console.log("Error reading the cookie '".concat(key, "'."), err);
        }
    }, [
        key
    ]);
    return [
        value,
        storeValue
    ];
};





var $acw62 = parcelRequire("acw62");
var $2da54d2112afb05d$var$__assign = undefined && undefined.__assign || function() {
    $2da54d2112afb05d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2da54d2112afb05d$var$__assign.apply(this, arguments);
};
var $2da54d2112afb05d$var$theme = (0, $756f0943cb677ee4$export$89cbf1a0881c8b9c)();
var $2da54d2112afb05d$var$login = function(memberId, name, email) {
    return fetch("/api/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            memberId: memberId,
            name: name,
            email: email
        })
    }).then(function(r) {
        return r.json();
    }).then(function(d) {
        return d.company;
    }).catch(function(err) {
        return console.log("Error logging in.", err);
    });
};
var $2da54d2112afb05d$var$NumberPattern = new RegExp("^\\d*$");
var $2da54d2112afb05d$var$EmailPattern = new RegExp('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
var $2da54d2112afb05d$var$isDefined = function() {
    var errors = [];
    for(var _i = 0; _i < arguments.length; _i++)errors[_i] = arguments[_i];
    return Array.isArray(errors) && errors.some(function(error) {
        return typeof error === "string" && error.trim().length > 0;
    });
};
function $2da54d2112afb05d$export$21a94553ffa41578(props) {
    var _a = (0, $4134536fed3901fa$export$bc4ac5c7b57c369a)("login"), info = _a[0], setInfo = _a[1];
    var _b = (0, $4134536fed3901fa$export$bc4ac5c7b57c369a)("confirmed"), hasEntered = _b[0], setHasEntered = _b[1];
    var _c = (0, $acw62.useState)(""), memberId = _c[0], setMemberId = _c[1];
    var _d = (0, $acw62.useState)(""), memberIdError = _d[0], setMemberIdError = _d[1];
    var _e = (0, $acw62.useState)(""), name = _e[0], setName = _e[1];
    var _f = (0, $acw62.useState)(""), nameError = _f[0], setNameError = _f[1];
    var _g = (0, $acw62.useState)(""), email = _g[0], setEmail = _g[1];
    var _h = (0, $acw62.useState)(""), emailError = _h[0], setEmailError = _h[1];
    var _j = (0, $acw62.useState)(false), checkboxSelected = _j[0], setCheckboxSelected = _j[1];
    var onLoginClicked = function() {
        $2da54d2112afb05d$var$login(memberId.trim(), name.trim(), email.trim()).then(function(company) {
            setInfo({
                memberId: memberId,
                companyName: company
            });
        });
    };
    var getErrorMessage = function(field, value) {
        var errorMessage = "";
        var testValue = (value === null || value === void 0 ? void 0 : value.trim()) || "";
        if (testValue.length > 0) {
            if (field === "Full Name" && !testValue.includes(" ")) errorMessage = "Enter first and last name.";
            if (field === "Email" && !$2da54d2112afb05d$var$EmailPattern.test(testValue)) errorMessage = "Enter a valid email address.";
            if (field === "Member ID" && !$2da54d2112afb05d$var$NumberPattern.test(testValue)) errorMessage = "Enter a valid member id.";
        } else errorMessage = "".concat(field, " is required.");
        return errorMessage;
    };
    var onEnterClicked = function() {
        var now = new Date();
        now.setDate(now.getDate() + 1);
        setHasEntered(now.toISOString());
        props.onLogin(info.companyName);
    };
    var onLeaveClicked = function() {
        setInfo(undefined);
        setHasEntered("");
        setMemberId("");
        setCheckboxSelected(false);
    };
    (0, $acw62.useEffect)(function() {
        props.onLogin((info === null || info === void 0 ? void 0 : info.companyName) || "");
    }, [
        info
    ]);
    props.logOut(onLeaveClicked);
    if (!info) return (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
        tokens: {
            childrenGap: 16,
            padding: 24
        },
        horizontalAlign: "center",
        style: {
            boxShadow: $2da54d2112afb05d$var$theme.effects.elevation8,
            width: "50%"
        }
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "This database contains Yellow employee profile information and is accessible to ATA Members only."
                    }, void 0),
                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "If you are a former yellow employee looking for the job seeker submission form, click here: ",
                            (0, $7b02d682eb115277$exports.jsx)((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), $2da54d2112afb05d$var$__assign({
                                href: "https://www.trucking.org/jobseeker"
                            }, {
                                children: "www.trucking.org/jobseeker"
                            }), void 0),
                            "."
                        ]
                    }, void 0),
                    (0, $7b02d682eb115277$exports.jsx)("p", $2da54d2112afb05d$var$__assign({
                        style: {
                            textAlign: "center"
                        }
                    }, {
                        children: "Please enter your ATA Member Company ID:"
                    }), void 0)
                ]
            }, void 0),
            (0, $7b02d682eb115277$exports.jsx)((0, $90af54869168591e$export$2c73285ae9390cec), {
                required: true,
                maxLength: 8,
                inputMode: "numeric",
                label: "Member ID",
                errorMessage: memberIdError,
                onBlur: function() {
                    return setMemberIdError(getErrorMessage("Member ID", memberId));
                },
                onChange: function(_, v) {
                    return setMemberId(v);
                },
                styles: {
                    root: {
                        maxWidth: 250
                    }
                }
            }, void 0),
            (0, $7b02d682eb115277$exports.jsx)((0, $90af54869168591e$export$2c73285ae9390cec), {
                required: true,
                label: "Full Name",
                title: "Enter your first name and last name",
                inputMode: "text",
                errorMessage: nameError,
                onBlur: function() {
                    return setNameError(getErrorMessage("Full Name", name));
                },
                onChange: function(_, v) {
                    return setName(v);
                },
                styles: {
                    root: {
                        maxWidth: 250
                    }
                }
            }, void 0),
            (0, $7b02d682eb115277$exports.jsx)((0, $90af54869168591e$export$2c73285ae9390cec), {
                required: true,
                label: "Email",
                title: "Enter your company email address",
                inputMode: "email",
                errorMessage: emailError,
                onBlur: function() {
                    return setEmailError(getErrorMessage("Email", email));
                },
                onChange: function(_, v) {
                    return setEmail(v);
                },
                styles: {
                    root: {
                        maxWidth: 250
                    }
                }
            }, void 0),
            (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
                horizontal: true
            }, {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), {
                    text: "Login",
                    disabled: $2da54d2112afb05d$var$isDefined(memberIdError, nameError, emailError),
                    onClick: onLoginClicked
                }, void 0)
            }), void 0)
        ]
    }), void 0);
    if (!info.companyName) return (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
        tokens: {
            childrenGap: 16,
            padding: 24
        },
        horizontalAlign: "center",
        style: {
            boxShadow: $2da54d2112afb05d$var$theme.effects.elevation8,
            width: "50%"
        }
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                children: "Unable to find an active subscription for the current member id. Click below to request access."
            }, void 0),
            (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
                horizontal: true,
                tokens: {
                    childrenGap: 8
                }
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), {
                        text: "Request access",
                        "data-interceptor": "off",
                        target: "_blank",
                        href: "mailto:atamembership@trucking.org?subject=Access%20To%20ATA%20Job%20Seeker%20Database"
                    }, void 0),
                    (0, $7b02d682eb115277$exports.jsx)((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), {
                        text: "Go back",
                        onClick: onLeaveClicked
                    }, void 0)
                ]
            }), void 0)
        ]
    }), void 0);
    if (!hasEntered || new Date(hasEntered) < new Date()) return (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
        tokens: {
            childrenGap: 16,
            padding: 24
        },
        horizontalAlign: "center",
        style: {
            boxShadow: $2da54d2112afb05d$var$theme.effects.elevation8,
            width: "50%"
        }
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                children: [
                    "You are logging into the job seeker database on behalf of ",
                    (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: info.companyName
                    }, void 0),
                    "."
                ]
            }, void 0),
            (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                children: [
                    "By accessing the ATA Jobseeker Database (the Database), you agree that you have read and acknowledge the terms of the American Trucking Associations (ATA) Privacy Policy, available at ",
                    (0, $7b02d682eb115277$exports.jsx)((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), $2da54d2112afb05d$var$__assign({
                        href: "https://trucking.org/privacy-policy"
                    }, {
                        children: "https://trucking.org/privacy-policy"
                    }), void 0),
                    ", and that you will use any information collected from the Database for the sole and exclusive purpose of identifying and contacting potential candidates for jobs at your company or its subsidiaries or affiliates. You further agree not to sell or share with any third party any information obtained from the Database, and to delete and destroy any and all copies of such information within 30 days of obtaining it."
                ]
            }, void 0),
            (0, $7b02d682eb115277$exports.jsx)((0, $53962458d2f2f182$export$48513f6b9f8ce62d), {
                label: "I agree to the above and the terms & conditions.",
                onChange: function(_, checked) {
                    return setCheckboxSelected(checked);
                }
            }, void 0),
            (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $2da54d2112afb05d$var$__assign({
                horizontal: true,
                tokens: {
                    childrenGap: 8
                }
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), {
                        text: "Continue",
                        disabled: !checkboxSelected,
                        onClick: onEnterClicked
                    }, void 0),
                    (0, $7b02d682eb115277$exports.jsx)((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), {
                        text: "Cancel",
                        onClick: onLeaveClicked
                    }, void 0)
                ]
            }), void 0)
        ]
    }), void 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    }, void 0);
}


var $dad8c4ad44cfb8f1$exports = {};

$parcel$export($dad8c4ad44cfb8f1$exports, "JobSeekers", () => $dad8c4ad44cfb8f1$export$b1a2a875e9576fd);

/**
 * Enum to describe how a particular column header behaves.
 * This is used to to specify the property `IColumn.columnActionsMode`.
 * If `IColumn.columnActionsMode` is undefined, it's equivalent to `ColumnActionsMode.clickable`.
 * {@docCategory DetailsList}
 */ var $5103473855f147d2$export$e393753d4e31e51;
(function(ColumnActionsMode) {
    /** Renders the column header as disabled. */ ColumnActionsMode[ColumnActionsMode["disabled"] = 0] = "disabled";
    /** Renders the column header as clickable. Default value. */ ColumnActionsMode[ColumnActionsMode["clickable"] = 1] = "clickable";
    /** Renders the column header as clickable and displays the dropdown chevron. */ ColumnActionsMode[ColumnActionsMode["hasDropdown"] = 2] = "hasDropdown";
})($5103473855f147d2$export$e393753d4e31e51 || ($5103473855f147d2$export$e393753d4e31e51 = {}));
var $5103473855f147d2$export$ff960e2d30f8d80b;
(function(ConstrainMode) {
    /** Lets the content grow which allows the page to manage scrolling. */ ConstrainMode[ConstrainMode["unconstrained"] = 0] = "unconstrained";
    /** Constrains the list to the given layout space. */ ConstrainMode[ConstrainMode["horizontalConstrained"] = 1] = "horizontalConstrained";
})($5103473855f147d2$export$ff960e2d30f8d80b || ($5103473855f147d2$export$ff960e2d30f8d80b = {}));
var $5103473855f147d2$export$24c0b55ababe9a64;
(function(ColumnDragEndLocation) {
    /** Drag ended outside of current list */ ColumnDragEndLocation[ColumnDragEndLocation["outside"] = 0] = "outside";
    /** Drag ended within current list */ ColumnDragEndLocation[ColumnDragEndLocation["surface"] = 1] = "surface";
    /** Drag ended on header */ ColumnDragEndLocation[ColumnDragEndLocation["header"] = 2] = "header";
})($5103473855f147d2$export$24c0b55ababe9a64 || ($5103473855f147d2$export$24c0b55ababe9a64 = {}));
var $5103473855f147d2$export$2499c0b3a09a8cda;
(function(DetailsListLayoutMode) {
    /**
     * Lets the user resize columns and makes not attempt to fit them.
     */ DetailsListLayoutMode[DetailsListLayoutMode["fixedColumns"] = 0] = "fixedColumns";
    /**
     * Manages which columns are visible, tries to size them according to their min/max rules and drops
     * off columns that can't fit and have isCollapsible set.
     */ DetailsListLayoutMode[DetailsListLayoutMode["justified"] = 1] = "justified";
})($5103473855f147d2$export$2499c0b3a09a8cda || ($5103473855f147d2$export$2499c0b3a09a8cda = {}));
var $5103473855f147d2$export$752592320202052a;
(function(CheckboxVisibility) {
    /** Visible on hover. */ CheckboxVisibility[CheckboxVisibility["onHover"] = 0] = "onHover";
    /** Visible always. */ CheckboxVisibility[CheckboxVisibility["always"] = 1] = "always";
    /** Hide checkboxes. */ CheckboxVisibility[CheckboxVisibility["hidden"] = 2] = "hidden";
})($5103473855f147d2$export$752592320202052a || ($5103473855f147d2$export$752592320202052a = {}));




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $44f39e3df8831eca$var$registerPersistedKeytips = function(keytipsToRegister, keytipManager, registeredPersistedKeytips) {
    for(var _i = 0, keytipsToRegister_1 = keytipsToRegister; _i < keytipsToRegister_1.length; _i++){
        var keytip = keytipsToRegister_1[_i];
        var uniqueID = keytipManager.register(keytip, true);
        // Update map
        registeredPersistedKeytips[uniqueID] = keytip;
    }
};
var $44f39e3df8831eca$var$unregisterPersistedKeytips = function(keytipManager, registeredPersistedKeytips) {
    for(var _i = 0, _a = Object.keys(registeredPersistedKeytips); _i < _a.length; _i++){
        var uniqueID = _a[_i];
        keytipManager.unregister(registeredPersistedKeytips[uniqueID], uniqueID, true);
        delete registeredPersistedKeytips[uniqueID];
    }
};
var $44f39e3df8831eca$var$useKeytipRegistrations = function(registeredPersistedKeytips, keytipsToRegister, keytipManager) {
    var prevPersistedKeytips = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(registeredPersistedKeytips);
    // Update
    $acw62.useEffect(function() {
        if (prevPersistedKeytips) {
            // Unregister old keytips
            $44f39e3df8831eca$var$unregisterPersistedKeytips(keytipManager, prevPersistedKeytips);
            // Register new keytips
            $44f39e3df8831eca$var$registerPersistedKeytips(keytipsToRegister, keytipManager, registeredPersistedKeytips);
        }
    });
    // Mount/Unmount
    $acw62.useEffect(function() {
        // Register on mount
        $44f39e3df8831eca$var$registerPersistedKeytips(keytipsToRegister, keytipManager, registeredPersistedKeytips);
        return function() {
            // Unregister on unmount
            $44f39e3df8831eca$var$unregisterPersistedKeytips(keytipManager, registeredPersistedKeytips);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var $44f39e3df8831eca$export$ad9695dcc4206534 = function(props) {
    var keytipManager = (0, $3ce833705adf3bff$export$98a3eaa272c56420).getInstance();
    var className = props.className, overflowItems = props.overflowItems, keytipSequences = props.keytipSequences, itemSubMenuProvider = props.itemSubMenuProvider, onRenderOverflowButton = props.onRenderOverflowButton;
    var persistedKeytips = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)({});
    // Gets the subMenu for an overflow item
    var getSubMenuForItem = $acw62.useCallback(function(item) {
        // Checks if itemSubMenuProvider has been defined, if not defaults to subMenuProps
        if (itemSubMenuProvider) return itemSubMenuProvider(item);
        if (item.subMenuProps) return item.subMenuProps.items;
        return undefined;
    }, [
        itemSubMenuProvider
    ]);
    var _a = $acw62.useMemo(function() {
        var newKeytipsToRegister = [];
        var newOverflowItems = [];
        if (keytipSequences) overflowItems === null || overflowItems === void 0 || overflowItems.forEach(function(overflowItem) {
            var _a;
            var keytip = overflowItem.keytipProps;
            if (keytip) {
                // Create persisted keytip
                var persistedKeytip = {
                    content: keytip.content,
                    keySequences: keytip.keySequences,
                    disabled: keytip.disabled || !!(overflowItem.disabled || overflowItem.isDisabled),
                    hasDynamicChildren: keytip.hasDynamicChildren,
                    hasMenu: keytip.hasMenu
                };
                if (keytip.hasDynamicChildren || getSubMenuForItem(overflowItem)) {
                    // If the keytip has a submenu or children nodes, change onExecute to persistedKeytipExecute
                    persistedKeytip.onExecute = keytipManager.menuExecute.bind(keytipManager, keytipSequences, (_a = overflowItem === null || overflowItem === void 0 ? void 0 : overflowItem.keytipProps) === null || _a === void 0 ? void 0 : _a.keySequences);
                    persistedKeytip.hasOverflowSubMenu = true;
                } else // If the keytip doesn't have a submenu, just execute the original function
                persistedKeytip.onExecute = keytip.onExecute;
                newKeytipsToRegister.push(persistedKeytip);
                // Add the overflow sequence to this item
                var newOverflowItem = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, overflowItem), {
                    keytipProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytip), {
                        overflowSetSequence: keytipSequences
                    })
                });
                newOverflowItems === null || newOverflowItems === void 0 || newOverflowItems.push(newOverflowItem);
            } else // Nothing to change, add overflowItem to list
            newOverflowItems === null || newOverflowItems === void 0 || newOverflowItems.push(overflowItem);
        });
        else newOverflowItems = overflowItems;
        return {
            modifiedOverflowItems: newOverflowItems,
            keytipsToRegister: newKeytipsToRegister
        };
    }, [
        overflowItems,
        getSubMenuForItem,
        keytipManager,
        keytipSequences
    ]), modifiedOverflowItems = _a.modifiedOverflowItems, keytipsToRegister = _a.keytipsToRegister;
    $44f39e3df8831eca$var$useKeytipRegistrations(persistedKeytips, keytipsToRegister, keytipManager);
    return $acw62.createElement("div", {
        className: className
    }, onRenderOverflowButton(modifiedOverflowItems));
};


var $72baccb7f0bb6ad7$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $72baccb7f0bb6ad7$var$COMPONENT_NAME = "OverflowSet";
var $72baccb7f0bb6ad7$var$useComponentRef = function(props, divContainer) {
    $acw62.useImperativeHandle(props.componentRef, function() {
        return {
            focus: function(_forceIntoFirstElement, bypassHiddenElements) {
                var focusSucceeded = false;
                if (divContainer.current) focusSucceeded = (0, $94bdc1ebed789608$export$8765806c2c274519)(divContainer.current, bypassHiddenElements);
                return focusSucceeded;
            },
            focusElement: function(childElement) {
                var focusSucceeded = false;
                if (!childElement) return false;
                if (divContainer.current && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(divContainer.current, childElement)) {
                    childElement.focus();
                    focusSucceeded = document.activeElement === childElement;
                }
                return focusSucceeded;
            }
        };
    }, [
        divContainer
    ]);
};
var $72baccb7f0bb6ad7$export$34919c6f3be0cd52 = $acw62.forwardRef(function(props, forwardedRef) {
    var divContainer = $acw62.useRef(null);
    var mergedRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(divContainer, forwardedRef);
    $72baccb7f0bb6ad7$var$useComponentRef(props, divContainer);
    var items = props.items, overflowItems = props.overflowItems, className = props.className, styles = props.styles, vertical = props.vertical, role = props.role, _a = props.overflowSide, overflowSide = _a === void 0 ? "end" : _a, onRenderItem = props.onRenderItem;
    var classNames = $72baccb7f0bb6ad7$var$getClassNames(styles, {
        className: className,
        vertical: vertical
    });
    var showOverflow = !!overflowItems && overflowItems.length > 0;
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
        role: role || "group",
        "aria-orientation": role === "menubar" ? vertical === true ? "vertical" : "horizontal" : undefined,
        className: classNames.root,
        ref: mergedRef
    }), overflowSide === "start" && showOverflow && $acw62.createElement((0, $44f39e3df8831eca$export$ad9695dcc4206534), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        className: classNames.overflowButton
    })), items && items.map(function(item, i) {
        return $acw62.createElement("div", {
            className: classNames.item,
            key: item.key,
            role: "none"
        }, onRenderItem(item));
    }), overflowSide === "end" && showOverflow && $acw62.createElement((0, $44f39e3df8831eca$export$ad9695dcc4206534), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        className: classNames.overflowButton
    })));
});
$72baccb7f0bb6ad7$export$34919c6f3be0cd52.displayName = $72baccb7f0bb6ad7$var$COMPONENT_NAME;


var $3e278539753ee6be$var$overflowItemStyle = {
    flexShrink: 0,
    display: "inherit"
};
var $3e278539753ee6be$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, vertical = props.vertical;
    return {
        root: [
            "ms-OverflowSet",
            {
                position: "relative",
                display: "flex",
                flexWrap: "nowrap"
            },
            vertical && {
                flexDirection: "column"
            },
            className
        ],
        item: [
            "ms-OverflowSet-item",
            $3e278539753ee6be$var$overflowItemStyle
        ],
        overflowButton: [
            "ms-OverflowSet-overflowButton",
            $3e278539753ee6be$var$overflowItemStyle
        ]
    };
};


var $cb2ad77bd682e4c3$export$b30d95aaae729214 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $72baccb7f0bb6ad7$export$34919c6f3be0cd52), (0, $3e278539753ee6be$export$ffd58b7f6f099a57), undefined, {
    scope: "OverflowSet"
});




var $acw62 = parcelRequire("acw62");

/**
 * {@docCategory ResizeGroup}
 */ var $35d64c663257a049$export$e9f3d0df702166da;
(function(ResizeGroupDirection) {
    ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
    ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
})($35d64c663257a049$export$e9f3d0df702166da || ($35d64c663257a049$export$e9f3d0df702166da = {}));




var $7f7ebeac53a91fd4$var$RESIZE_DELAY = 16;
var $7f7ebeac53a91fd4$export$eada5b57934f1ca = function() {
    var measurementsCache = {};
    return {
        /**
         * Checks if the provided data has a cacheKey. If it has a cacheKey and there is a
         * corresponding entry in the measurementsCache, then it will return that value.
         * Returns undefined otherwise.
         */ getCachedMeasurement: function(data) {
            if (data && data.cacheKey && measurementsCache.hasOwnProperty(data.cacheKey)) return measurementsCache[data.cacheKey];
            return undefined;
        },
        /**
         * Should be called whenever there is a new measurement associated with a given data object.
         * If the data has a cacheKey, store that measurement in the measurementsCache.
         */ addMeasurementToCache: function(data, measurement) {
            if (data.cacheKey) measurementsCache[data.cacheKey] = measurement;
        }
    };
};
var $7f7ebeac53a91fd4$export$8d5747fa10fd4fcd = function(measurementCache) {
    if (measurementCache === void 0) measurementCache = $7f7ebeac53a91fd4$export$eada5b57934f1ca();
    var _measurementCache = measurementCache;
    var _containerDimension;
    /**
     * Gets the width/height of the data rendered in a hidden div.
     * @param measuredData - The data corresponding to the measurement we wish to take.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data.
     * Only called when the measurement is not in the cache.
     */ function _getMeasuredDimension(measuredData, getElementToMeasureDimension) {
        var cachedDimension = _measurementCache.getCachedMeasurement(measuredData);
        if (cachedDimension !== undefined) return cachedDimension;
        var measuredDimension = getElementToMeasureDimension();
        _measurementCache.addMeasurementToCache(measuredData, measuredDimension);
        return measuredDimension;
    }
    /**
     * Will get the next IResizeGroupState based on the current data while trying to shrink contents
     * to fit in the container.
     * @param data - The initial data point to start measuring.
     * @param onReduceData - Function that transforms the data into something that should render with less width/height.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data.
     * Only called when the measurement is not in the cache.
     */ function _shrinkContentsUntilTheyFit(data, onReduceData, getElementToMeasureDimension) {
        var dataToMeasure = data;
        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
        while(measuredDimension > _containerDimension){
            var nextMeasuredData = onReduceData(dataToMeasure);
            // We don't want to get stuck in an infinite render loop when there are no more
            // scaling steps, so implementations of onReduceData should return undefined when
            // there are no more scaling states to apply.
            if (nextMeasuredData === undefined) return {
                renderedData: dataToMeasure,
                resizeDirection: undefined,
                dataToMeasure: undefined
            };
            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
            // If the measurement isn't in the cache, we need to re-render with some data in a hidden div
            if (measuredDimension === undefined) return {
                dataToMeasure: nextMeasuredData,
                resizeDirection: "shrink"
            };
            dataToMeasure = nextMeasuredData;
        }
        return {
            renderedData: dataToMeasure,
            resizeDirection: undefined,
            dataToMeasure: undefined
        };
    }
    /**
     * This function should be called when the state changes in a manner that might allow for more content to fit
     * on the screen, such as the window width/height growing.
     * @param data - The initial data point to start measuring.
     * @param onGrowData - Function that transforms the data into something that may take up more space when rendering.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data.
     * Only called when the measurement is not in the cache.
     */ function _growDataUntilItDoesNotFit(data, onGrowData, getElementToMeasureDimension, onReduceData) {
        var dataToMeasure = data;
        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
        while(measuredDimension < _containerDimension){
            var nextMeasuredData = onGrowData(dataToMeasure);
            // We don't want to get stuck in an infinite render loop when there are no more
            // scaling steps, so implementations of onGrowData should return undefined when
            // there are no more scaling states to apply.
            if (nextMeasuredData === undefined) return {
                renderedData: dataToMeasure,
                resizeDirection: undefined,
                dataToMeasure: undefined
            };
            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
            // If the measurement isn't in the cache, we need to re-render with some data in a hidden div
            if (measuredDimension === undefined) return {
                dataToMeasure: nextMeasuredData
            };
            dataToMeasure = nextMeasuredData;
        }
        // Once the loop is done, we should now shrink until the contents fit.
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            resizeDirection: "shrink"
        }, _shrinkContentsUntilTheyFit(dataToMeasure, onReduceData, getElementToMeasureDimension));
    }
    /**
     * Handles an update to the container width/height.
     * Should only be called when we knew the previous container width/height.
     * @param newDimension - The new width/height of the container.
     * @param fullDimensionData - The initial data passed in as a prop to resizeGroup.
     * @param renderedData - The data that was rendered prior to the container size changing.
     * @param onGrowData - Set to true if the Resize group has an onGrowData function.
     */ function _updateContainerDimension(newDimension, fullDimensionData, renderedData, onGrowData) {
        var nextState;
        if (newDimension > _containerDimension) {
            if (onGrowData) nextState = {
                resizeDirection: "grow",
                dataToMeasure: onGrowData(renderedData)
            };
            else nextState = {
                resizeDirection: "shrink",
                dataToMeasure: fullDimensionData
            };
        } else nextState = {
            resizeDirection: "shrink",
            dataToMeasure: renderedData
        };
        _containerDimension = newDimension;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), {
            measureContainer: false
        });
    }
    function getNextState(props, currentState, getElementToMeasureDimension, newContainerDimension) {
        // If there is no new container width/height or data to measure, there is no need for a new state update
        if (newContainerDimension === undefined && currentState.dataToMeasure === undefined) return undefined;
        if (newContainerDimension) {
            // If we know the last container size and we rendered data at that width/height, we can do an optimized render
            if (_containerDimension && currentState.renderedData && !currentState.dataToMeasure) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, currentState), _updateContainerDimension(newContainerDimension, props.data, currentState.renderedData, props.onGrowData));
            // If we are just setting the container width/height for the first time, we can't do any optimizations
            _containerDimension = newContainerDimension;
        }
        var nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, currentState), {
            measureContainer: false
        });
        if (currentState.dataToMeasure) {
            if (currentState.resizeDirection === "grow" && props.onGrowData) nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), _growDataUntilItDoesNotFit(currentState.dataToMeasure, props.onGrowData, getElementToMeasureDimension, props.onReduceData));
            else nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), _shrinkContentsUntilTheyFit(currentState.dataToMeasure, props.onReduceData, getElementToMeasureDimension));
        }
        return nextState;
    }
    /** Function that determines if we need to render content for measurement based on the measurement cache contents. */ function shouldRenderDataForMeasurement(dataToMeasure) {
        if (!dataToMeasure || _measurementCache.getCachedMeasurement(dataToMeasure) !== undefined) return false;
        return true;
    }
    function getInitialResizeGroupState(data) {
        return {
            dataToMeasure: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, data),
            resizeDirection: "grow",
            measureContainer: true
        };
    }
    return {
        getNextState: getNextState,
        shouldRenderDataForMeasurement: shouldRenderDataForMeasurement,
        getInitialResizeGroupState: getInitialResizeGroupState
    };
};
var $7f7ebeac53a91fd4$export$259cf17d6928d8e2 = $acw62.createContext({
    isMeasured: false
});
// Styles for the hidden div used for measurement
var $7f7ebeac53a91fd4$var$hiddenDivStyles = {
    position: "fixed",
    visibility: "hidden"
};
var $7f7ebeac53a91fd4$var$hiddenParentStyles = {
    position: "relative"
};
var $7f7ebeac53a91fd4$var$COMPONENT_NAME = "ResizeGroup";
/**
 * Use useReducer instead of userState because React is not batching the state updates
 * when state is set in callbacks of setTimeout or requestAnimationFrame.
 * See issue: https://github.com/facebook/react/issues/14259
 */ function $7f7ebeac53a91fd4$var$resizeDataReducer(state, action) {
    var _a;
    switch(action.type){
        case "resizeData":
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, action.value);
        case "dataToMeasure":
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, state), {
                dataToMeasure: action.value,
                resizeDirection: "grow",
                measureContainer: true
            });
        default:
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, state), (_a = {}, _a[action.type] = action.value, _a));
    }
}
function $7f7ebeac53a91fd4$var$useResizeState(props, nextResizeGroupStateProvider, rootRef) {
    var initialStateData = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return nextResizeGroupStateProvider.getInitialResizeGroupState(props.data);
    });
    var _a = $acw62.useReducer($7f7ebeac53a91fd4$var$resizeDataReducer, initialStateData), resizeData = _a[0], dispatchResizeDataAction = _a[1];
    // Reset state when new data is provided
    $acw62.useEffect(function() {
        dispatchResizeDataAction({
            type: "dataToMeasure",
            value: props.data
        });
    }, [
        props.data
    ]);
    // Because it's possible that we may force more than one re-render per animation frame, we
    // want to make sure that the RAF request is using the most recent data.
    var stateRef = $acw62.useRef(initialStateData);
    stateRef.current = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, resizeData);
    var updateResizeState = $acw62.useCallback(function(nextState) {
        if (nextState) dispatchResizeDataAction({
            type: "resizeData",
            value: nextState
        });
    }, []);
    var remeasure = $acw62.useCallback(function() {
        if (rootRef.current) dispatchResizeDataAction({
            type: "measureContainer",
            value: true
        });
    }, [
        rootRef
    ]);
    return [
        stateRef,
        updateResizeState,
        remeasure
    ];
}
function $7f7ebeac53a91fd4$var$useResizingBehavior(props, rootRef) {
    var nextResizeGroupStateProvider = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)($7f7ebeac53a91fd4$export$8d5747fa10fd4fcd);
    // A div that can be used for the initial measurement so that we can avoid mounting a second instance
    // of the component being measured for the initial render.
    var initialHiddenDiv = $acw62.useRef(null);
    // A hidden div that is used for mounting a new instance of the component for measurement in a hidden
    // div without unmounting the currently visible content.
    var updateHiddenDiv = $acw62.useRef(null);
    // Tracks if any content has been rendered to the user. This enables us to do some performance optimizations
    // for the initial render.
    var hasRenderedContent = $acw62.useRef(false);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var _a = $7f7ebeac53a91fd4$var$useResizeState(props, nextResizeGroupStateProvider, rootRef), stateRef = _a[0], updateResizeState = _a[1], remeasure = _a[2];
    $acw62.useEffect(function() {
        var _a;
        if (stateRef.current.renderedData) {
            hasRenderedContent.current = true;
            (_a = props.dataDidRender) === null || _a === void 0 || _a.call(props, stateRef.current.renderedData);
        }
    });
    $acw62.useEffect(function() {
        async.requestAnimationFrame(function() {
            var containerDimension = undefined;
            if (stateRef.current.measureContainer && rootRef.current) {
                var boundingRect = rootRef.current.getBoundingClientRect();
                containerDimension = props.direction === (0, $35d64c663257a049$export$e9f3d0df702166da).vertical ? boundingRect.height : boundingRect.width;
            }
            var nextState = nextResizeGroupStateProvider.getNextState(props, stateRef.current, function() {
                var refToMeasure = !hasRenderedContent.current ? initialHiddenDiv : updateHiddenDiv;
                if (!refToMeasure.current) return 0;
                var measuredBoundingRect = refToMeasure.current.getBoundingClientRect();
                return props.direction === (0, $35d64c663257a049$export$e9f3d0df702166da).vertical ? measuredBoundingRect.height : measuredBoundingRect.width;
            }, containerDimension);
            updateResizeState(nextState);
        }, rootRef.current);
    });
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(win, "resize", async.debounce(remeasure, $7f7ebeac53a91fd4$var$RESIZE_DELAY, {
        leading: true
    }));
    var dataNeedsMeasuring = nextResizeGroupStateProvider.shouldRenderDataForMeasurement(stateRef.current.dataToMeasure);
    var isInitialMeasure = !hasRenderedContent.current && dataNeedsMeasuring;
    return [
        stateRef.current.dataToMeasure,
        stateRef.current.renderedData,
        remeasure,
        initialHiddenDiv,
        updateHiddenDiv,
        dataNeedsMeasuring,
        isInitialMeasure
    ];
}
function $7f7ebeac53a91fd4$var$useDebugWarnings(props) {}
var $7f7ebeac53a91fd4$var$measuredContextValue = {
    isMeasured: true
};
var $7f7ebeac53a91fd4$export$9fc81a01ce4792db = $acw62.forwardRef(function(props, forwardedRef) {
    var rootRef = $acw62.useRef(null);
    // The root div which is the container inside of which we are trying to fit content.
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, forwardedRef);
    var _a = $7f7ebeac53a91fd4$var$useResizingBehavior(props, rootRef), dataToMeasure = _a[0], renderedData = _a[1], remeasure = _a[2], initialHiddenDiv = _a[3], updateHiddenDiv = _a[4], dataNeedsMeasuring = _a[5], isInitialMeasure = _a[6];
    $acw62.useImperativeHandle(props.componentRef, function() {
        return {
            remeasure: remeasure
        };
    }, [
        remeasure
    ]);
    $7f7ebeac53a91fd4$var$useDebugWarnings(props);
    var className = props.className, onRenderData = props.onRenderData;
    var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
        "data"
    ]);
    // We only ever render the final content to the user. All measurements are done in a hidden div.
    // For the initial render, we want this to be as fast as possible, so we need to make sure that we only mount one
    // version of the component for measurement and the final render. For renders that update what is on screen, we
    // want to make sure that there are no jarring effects such as the screen flashing as we apply scaling steps for
    // measurement. In the update case, we mount a second version of the component just for measurement purposes and
    // leave the rendered content untouched until we know the next state to show to the user.
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps, {
        className: className,
        ref: mergedRootRef
    }), $acw62.createElement("div", {
        style: $7f7ebeac53a91fd4$var$hiddenParentStyles
    }, dataNeedsMeasuring && !isInitialMeasure && $acw62.createElement("div", {
        style: $7f7ebeac53a91fd4$var$hiddenDivStyles,
        ref: updateHiddenDiv
    }, $acw62.createElement($7f7ebeac53a91fd4$export$259cf17d6928d8e2.Provider, {
        value: $7f7ebeac53a91fd4$var$measuredContextValue
    }, onRenderData(dataToMeasure))), $acw62.createElement("div", {
        ref: initialHiddenDiv,
        style: isInitialMeasure ? $7f7ebeac53a91fd4$var$hiddenDivStyles : undefined,
        "data-automation-id": "visibleContent"
    }, isInitialMeasure ? onRenderData(dataToMeasure) : renderedData && onRenderData(renderedData))));
});
$7f7ebeac53a91fd4$export$9fc81a01ce4792db.displayName = "ResizeGroupBase";


var $4499ee6d6eb5e73d$export$b09b360202d361b4 = (0, $7f7ebeac53a91fd4$export$9fc81a01ce4792db);





var $acw62 = parcelRequire("acw62");








var $c67f778577ce7d5e$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles, focusInset, focusColor) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var baseSplitButtonStyles = (0, $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57)(theme);
    var p = theme.palette, semanticColors = theme.semanticColors;
    var commandButtonHighContrastFocus = {
        left: 4,
        top: 4,
        bottom: 4,
        right: 4,
        border: "none"
    };
    var commandButtonStyles = {
        root: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 2,
                highContrastStyle: commandButtonHighContrastFocus,
                borderColor: "transparent"
            }),
            theme.fonts.medium,
            {
                minWidth: "40px",
                backgroundColor: p.white,
                color: p.neutralPrimary,
                padding: "0 4px",
                border: "none",
                borderRadius: 0,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: "none"
                }, _a)
            }
        ],
        rootHovered: {
            backgroundColor: p.neutralLighter,
            color: p.neutralDark,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: "Highlight"
            }, _b[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: p.themeDarkAlt
            }, _b[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonMenuIcon)] = {
                color: p.neutralPrimary
            }, _b)
        },
        rootPressed: {
            backgroundColor: p.neutralLight,
            color: p.neutralDark,
            selectors: (_c = {}, _c[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: p.themeDark
            }, _c[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonMenuIcon)] = {
                color: p.neutralPrimary
            }, _c)
        },
        rootChecked: {
            backgroundColor: p.neutralLight,
            color: p.neutralDark,
            selectors: (_d = {}, _d[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: p.themeDark
            }, _d[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonMenuIcon)] = {
                color: p.neutralPrimary
            }, _d)
        },
        rootCheckedHovered: {
            backgroundColor: p.neutralQuaternaryAlt,
            selectors: (_e = {}, _e[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: p.themeDark
            }, _e[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonMenuIcon)] = {
                color: p.neutralPrimary
            }, _e)
        },
        rootExpanded: {
            backgroundColor: p.neutralLight,
            color: p.neutralDark,
            selectors: (_f = {}, _f[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: p.themeDark
            }, _f[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonMenuIcon)] = {
                color: p.neutralPrimary
            }, _f)
        },
        rootExpandedHovered: {
            backgroundColor: p.neutralQuaternaryAlt
        },
        rootDisabled: {
            backgroundColor: p.white,
            selectors: (_g = {}, _g[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                color: semanticColors.disabledBodySubtext,
                selectors: (_h = {}, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    color: "GrayText"
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _h)
            }, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: "GrayText",
                backgroundColor: "Window"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _g)
        },
        // Split button styles
        splitButtonContainer: {
            height: "100%",
            selectors: (_j = {}, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                border: "none"
            }, _j)
        },
        splitButtonDividerDisabled: {
            selectors: (_k = {}, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                backgroundColor: "Window"
            }, _k)
        },
        splitButtonDivider: {
            backgroundColor: p.neutralTertiaryAlt
        },
        splitButtonMenuButton: {
            backgroundColor: p.white,
            border: "none",
            borderTopRightRadius: "0",
            borderBottomRightRadius: "0",
            color: p.neutralSecondary,
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralLighter,
                    color: p.neutralDark,
                    selectors: (_l = {}, _l[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "Highlight"
                    }, _l[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                        color: p.neutralPrimary
                    }, _l)
                },
                ":active": {
                    backgroundColor: p.neutralLight,
                    selectors: (_m = {}, _m[".".concat((0, $4fe39bc207aa6e6b$export$78e5756b1cbe9c85).msButtonIcon)] = {
                        color: p.neutralPrimary
                    }, _m)
                }
            }
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: p.white,
            selectors: (_o = {}, _o[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: "GrayText",
                border: "none",
                backgroundColor: "Window"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _o)
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: p.neutralLight,
            color: p.neutralDark,
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: p.neutralLight,
            color: p.black,
            selectors: {
                ":hover": {
                    backgroundColor: p.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuIcon: {
            color: p.neutralPrimary
        },
        splitButtonMenuIconDisabled: {
            color: p.neutralTertiary
        },
        label: {
            fontWeight: "normal"
        },
        icon: {
            color: p.themePrimary
        },
        menuIcon: (_p = {
            color: p.neutralSecondary
        }, _p[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: "GrayText"
        }, _p)
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, baseSplitButtonStyles, commandButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $212d6a64e3fb5918$export$ae6efefb61c9c34a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CommandBarButton, _super);
    function CommandBarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommandBarButton.prototype.render = function() {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: "ms-Button--commandBar",
            styles: (0, $c67f778577ce7d5e$export$ffd58b7f6f099a57)(theme, styles),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    CommandBarButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)("CommandBarButton", [
            "theme",
            "styles"
        ], true)
    ], CommandBarButton);
    return CommandBarButton;
}($acw62.Component);





var $acw62 = parcelRequire("acw62");

/**
 * Detects whether an element's content has horizontal overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */ function $83b45cbc07988a90$export$6593e8d7c1045101(element) {
    return element.clientWidth < element.scrollWidth;
}
function $83b45cbc07988a90$export$960f7fa58164ce36(element) {
    return element.clientHeight < element.scrollHeight;
}
function $83b45cbc07988a90$export$874b45e6fa959b42(element) {
    return $83b45cbc07988a90$export$6593e8d7c1045101(element) || $83b45cbc07988a90$export$960f7fa58164ce36(element);
}


/**
 * {@docCategory Tooltip}
 */ var $3d3718168950b1e5$export$f3ea1a1b02389dd0;
(function(TooltipOverflowMode) {
    /** Only show tooltip if parent DOM element is overflowing */ TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
    /**
     * Only show tooltip if tooltip host's content is overflowing.
     * Note that this does not check the children for overflow, only the TooltipHost root.
     */ TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})($3d3718168950b1e5$export$f3ea1a1b02389dd0 || ($3d3718168950b1e5$export$f3ea1a1b02389dd0 = {}));





var $acw62 = parcelRequire("acw62");



var $9ce6ed99c0b7b0f9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $9ce6ed99c0b7b0f9$export$663e8f4fc1276cb8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipBase, _super);
    function TooltipBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderContent = function(props) {
            if (typeof props.content === "string") return $acw62.createElement("p", {
                className: _this._classNames.subText
            }, props.content);
            else return $acw62.createElement("div", {
                className: _this._classNames.subText
            }, props.content);
        };
        return _this;
    }
    TooltipBase.prototype.render = function() {
        var _a = this.props, className = _a.className, calloutProps = _a.calloutProps, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, styles = _a.styles, id = _a.id, maxWidth = _a.maxWidth, _b = _a.onRenderContent, onRenderContent = _b === void 0 ? this._onRenderContent : _b, targetElement = _a.targetElement, theme = _a.theme;
        this._classNames = $9ce6ed99c0b7b0f9$var$getClassNames(styles, {
            theme: theme,
            className: className || calloutProps && calloutProps.className,
            beakWidth: calloutProps && calloutProps.isBeakVisible ? calloutProps.beakWidth : 0,
            gapSpace: calloutProps && calloutProps.gapSpace,
            maxWidth: maxWidth
        });
        return $acw62.createElement((0, $bb8160ea11d5c986$export$97a5aca3dea8edc7), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            target: targetElement,
            directionalHint: directionalHint,
            directionalHintForRTL: directionalHintForRTL
        }, calloutProps, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
            "id"
        ]), {
            className: this._classNames.root
        }), $acw62.createElement("div", {
            className: this._classNames.content,
            id: id,
            onFocus: this.props.onFocus,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave
        }, onRenderContent(this.props, this._onRenderContent)));
    };
    // Specify default props values
    TooltipBase.defaultProps = {
        directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).topCenter,
        maxWidth: "364px",
        calloutProps: {
            isBeakVisible: true,
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false
        }
    };
    return TooltipBase;
}($acw62.Component);



var $bdd05a51f6142723$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, _a = props.beakWidth, beakWidth = _a === void 0 ? 16 : _a, _b = props.gapSpace, gapSpace = _b === void 0 ? 0 : _b, maxWidth = props.maxWidth, theme = props.theme;
    var semanticColors = theme.semanticColors, fonts = theme.fonts, effects = theme.effects;
    // The math here is done to account for the 45 degree rotation of the beak
    // and sub-pixel rounding that differs across browsers, which is more noticeable when
    // the device pixel ratio is larger
    var tooltipGapSpace = -(Math.sqrt(beakWidth * beakWidth / 2) + gapSpace) + 1 / window.devicePixelRatio;
    return {
        root: [
            "ms-Tooltip",
            theme.fonts.medium,
            (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn200,
            {
                background: semanticColors.menuBackground,
                boxShadow: effects.elevation8,
                padding: "8px",
                maxWidth: maxWidth,
                selectors: {
                    ":after": {
                        content: "''",
                        position: "absolute",
                        bottom: tooltipGapSpace,
                        left: tooltipGapSpace,
                        right: tooltipGapSpace,
                        top: tooltipGapSpace,
                        zIndex: 0
                    }
                }
            },
            className
        ],
        content: [
            "ms-Tooltip-content",
            fonts.small,
            {
                position: "relative",
                zIndex: 1,
                color: semanticColors.menuItemText,
                wordWrap: "break-word",
                overflowWrap: "break-word",
                overflow: "hidden"
            }
        ],
        subText: [
            "ms-Tooltip-subtext",
            {
                // Using inherit here to avoid unintentional global overrides of the <p> tag.
                fontSize: "inherit",
                fontWeight: "inherit",
                color: "inherit",
                margin: 0
            }
        ]
    };
};


var $c8281ca0c7c3178d$export$28c660c63b792dea = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $9ce6ed99c0b7b0f9$export$663e8f4fc1276cb8), (0, $bdd05a51f6142723$export$ffd58b7f6f099a57), undefined, {
    scope: "Tooltip"
});


/**
 * {@docCategory Tooltip}
 */ var $d05bac3956229c41$export$2c246ae0aa41b345;
(function(TooltipDelay) {
    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
    /** 300 ms delay before showing the tooltip */ TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
    /** 500 ms delay before showing the tooltip */ TooltipDelay[TooltipDelay["long"] = 2] = "long";
})($d05bac3956229c41$export$2c246ae0aa41b345 || ($d05bac3956229c41$export$2c246ae0aa41b345 = {}));


var $bb56338254948c40$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $bb56338254948c40$export$e7418f645cab4023 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipHostBase, _super);
    // Constructor
    function TooltipHostBase(props) {
        var _this = _super.call(this, props) || this;
        // The wrapping div that gets the hover events
        _this._tooltipHost = $acw62.createRef();
        _this._defaultTooltipId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("tooltip");
        _this.show = function() {
            _this._toggleTooltip(true);
        };
        _this.dismiss = function() {
            _this._hideTooltip();
        };
        _this._getTargetElement = function() {
            if (!_this._tooltipHost.current) return undefined;
            var overflowMode = _this.props.overflowMode;
            // Select target element based on overflow mode. For parent mode, you want to position the tooltip relative
            // to the parent element, otherwise it might look off.
            if (overflowMode !== undefined) switch(overflowMode){
                case (0, $3d3718168950b1e5$export$f3ea1a1b02389dd0).Parent:
                    return _this._tooltipHost.current.parentElement;
                case (0, $3d3718168950b1e5$export$f3ea1a1b02389dd0).Self:
                    return _this._tooltipHost.current;
            }
            return _this._tooltipHost.current;
        };
        _this._onTooltipFocus = function(ev) {
            if (_this._ignoreNextFocusEvent) {
                _this._ignoreNextFocusEvent = false;
                return;
            }
            _this._onTooltipMouseEnter(ev);
        };
        _this._onTooltipContentFocus = function(ev) {
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) TooltipHostBase._currentVisibleTooltip.dismiss();
            TooltipHostBase._currentVisibleTooltip = _this;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
        };
        _this._onTooltipBlur = function(ev) {
            // The focused element gets a blur event when the document loses focus
            // (e.g. switching tabs in the browser), but we don't want to show the
            // tooltip again when the document gets focus back. Handle this case by
            // checking if the blurred element is still the document's activeElement,
            // and ignoring when it next gets focus back.
            // See https://github.com/microsoft/fluentui/issues/13541
            _this._ignoreNextFocusEvent = (document === null || document === void 0 ? void 0 : document.activeElement) === ev.target;
            _this._dismissTimerId = _this._async.setTimeout(function() {
                _this._hideTooltip();
            }, 0);
        };
        // Show Tooltip
        _this._onTooltipMouseEnter = function(ev) {
            var _a = _this.props, overflowMode = _a.overflowMode, delay = _a.delay;
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) TooltipHostBase._currentVisibleTooltip.dismiss();
            TooltipHostBase._currentVisibleTooltip = _this;
            if (overflowMode !== undefined) {
                var overflowElement = _this._getTargetElement();
                if (overflowElement && !(0, $83b45cbc07988a90$export$874b45e6fa959b42)(overflowElement)) return;
            }
            if (ev.target && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(ev.target, _this._getTargetElement())) // Do not show tooltip when target is inside a portal relative to TooltipHost.
            return;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (delay !== (0, $d05bac3956229c41$export$2c246ae0aa41b345).zero) {
                var delayTime = _this._getDelayTime(delay); // non-null assertion because we set it in `defaultProps`
                _this._openTimerId = _this._async.setTimeout(function() {
                    _this._toggleTooltip(true);
                }, delayTime);
            } else _this._toggleTooltip(true);
        };
        // Hide Tooltip
        _this._onTooltipMouseLeave = function(ev) {
            var closeDelay = _this.props.closeDelay;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (closeDelay) _this._dismissTimerId = _this._async.setTimeout(function() {
                _this._toggleTooltip(false);
            }, closeDelay);
            else _this._toggleTooltip(false);
            if (TooltipHostBase._currentVisibleTooltip === _this) TooltipHostBase._currentVisibleTooltip = undefined;
        };
        _this._onTooltipKeyDown = function(ev) {
            // eslint-disable-next-line deprecation/deprecation
            if ((ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape || ev.ctrlKey) && _this.state.isTooltipVisible) {
                _this._hideTooltip();
                ev.stopPropagation();
            }
        };
        _this._clearDismissTimer = function() {
            _this._async.clearTimeout(_this._dismissTimerId);
        };
        _this._clearOpenTimer = function() {
            _this._async.clearTimeout(_this._openTimerId);
        };
        // Hide Tooltip
        _this._hideTooltip = function() {
            _this._clearOpenTimer();
            _this._clearDismissTimer();
            _this._toggleTooltip(false);
        };
        _this._toggleTooltip = function(isTooltipVisible) {
            if (_this.state.isTooltipVisible !== isTooltipVisible) _this.setState({
                isTooltipVisible: isTooltipVisible
            }, function() {
                return _this.props.onTooltipToggle && _this.props.onTooltipToggle(isTooltipVisible);
            });
        };
        _this._getDelayTime = function(delay) {
            switch(delay){
                case (0, $d05bac3956229c41$export$2c246ae0aa41b345).medium:
                    return 300;
                case (0, $d05bac3956229c41$export$2c246ae0aa41b345).long:
                    return 500;
                default:
                    return 0;
            }
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this.state = {
            isAriaPlaceholderRendered: false,
            isTooltipVisible: false
        };
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        return _this;
    }
    // Render
    TooltipHostBase.prototype.render = function() {
        var _a = this.props, calloutProps = _a.calloutProps, children = _a.children, content = _a.content, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, className = _a.hostClassName, id = _a.id, // eslint-disable-next-line deprecation/deprecation
        _b = _a.setAriaDescribedBy, // eslint-disable-next-line deprecation/deprecation
        setAriaDescribedBy = _b === void 0 ? true : _b, tooltipProps = _a.tooltipProps, styles = _a.styles, theme = _a.theme;
        this._classNames = $bb56338254948c40$var$getClassNames(styles, {
            theme: theme,
            className: className
        });
        var isTooltipVisible = this.state.isTooltipVisible;
        var tooltipId = id || this._defaultTooltipId;
        var tooltipRenderProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: "".concat(tooltipId, "--tooltip"),
            content: content,
            targetElement: this._getTargetElement(),
            directionalHint: directionalHint,
            directionalHintForRTL: directionalHintForRTL,
            calloutProps: (0, $f504d2279336999d$export$e6e34fd1f2686227)({}, calloutProps, {
                onDismiss: this._hideTooltip,
                onFocus: this._onTooltipContentFocus,
                onMouseEnter: this._onTooltipMouseEnter,
                onMouseLeave: this._onTooltipMouseLeave
            }),
            onMouseEnter: this._onTooltipMouseEnter,
            onMouseLeave: this._onTooltipMouseLeave
        }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
            "id"
        ])), tooltipProps);
        // Get the content of the tooltip for use in the hidden div used for screen readers
        var tooltipContent = (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.onRenderContent) ? tooltipProps.onRenderContent(tooltipRenderProps, function(props) {
            return (props === null || props === void 0 ? void 0 : props.content) ? $acw62.createElement($acw62.Fragment, null, props.content) : null;
        }) : content;
        var showTooltip = isTooltipVisible && !!tooltipContent;
        var ariaDescribedBy = setAriaDescribedBy && isTooltipVisible && !!tooltipContent ? tooltipId : undefined;
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            className: this._classNames.root,
            ref: this._tooltipHost
        }, {
            onFocusCapture: this._onTooltipFocus
        }, {
            onBlurCapture: this._onTooltipBlur
        }, {
            onMouseEnter: this._onTooltipMouseEnter,
            onMouseLeave: this._onTooltipMouseLeave,
            onKeyDown: this._onTooltipKeyDown,
            role: "none",
            "aria-describedby": ariaDescribedBy
        }), children, showTooltip && $acw62.createElement((0, $c8281ca0c7c3178d$export$28c660c63b792dea), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, tooltipRenderProps)), $acw62.createElement("div", {
            hidden: true,
            id: tooltipId,
            style: (0, $34563ae103a23d08$export$35835471cbe77db4)
        }, tooltipContent));
    };
    TooltipHostBase.prototype.componentWillUnmount = function() {
        if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip === this) TooltipHostBase._currentVisibleTooltip = undefined;
        this._async.dispose();
    };
    TooltipHostBase.defaultProps = {
        delay: (0, $d05bac3956229c41$export$2c246ae0aa41b345).medium
    };
    return TooltipHostBase;
}($acw62.Component);



var $267d2068da95c27f$var$GlobalClassNames = {
    root: "ms-TooltipHost",
    ariaPlaceholder: "ms-TooltipHost-aria-placeholder"
};
var $267d2068da95c27f$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($267d2068da95c27f$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: "inline"
            },
            className
        ]
    };
};


var $81fe081095f59877$export$ebbf8986cf9b8de1 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $bb56338254948c40$export$e7418f645cab4023), (0, $267d2068da95c27f$export$ffd58b7f6f099a57), undefined, {
    scope: "TooltipHost"
});




var $148a4d0388f0f588$var$COMMAND_BAR_HEIGHT = 44;
var $148a4d0388f0f588$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var semanticColors = theme.semanticColors;
    return {
        root: [
            theme.fonts.medium,
            "ms-CommandBar",
            {
                display: "flex",
                backgroundColor: semanticColors.bodyBackground,
                padding: "0 14px 0 24px",
                height: $148a4d0388f0f588$var$COMMAND_BAR_HEIGHT
            },
            className
        ],
        primarySet: [
            "ms-CommandBar-primaryCommand",
            {
                flexGrow: "1",
                display: "flex",
                alignItems: "stretch"
            }
        ],
        secondarySet: [
            "ms-CommandBar-secondaryCommand",
            {
                flexShrink: "0",
                display: "flex",
                alignItems: "stretch"
            }
        ]
    };
};
var $148a4d0388f0f588$export$5d27c9ec00c6966d = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(customStyles) {
    var rootStyles = {
        height: "100%"
    };
    var labelStyles = {
        whiteSpace: "nowrap"
    };
    var _a = customStyles || {}, root = _a.root, label = _a.label, restCustomStyles = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "root",
        "label"
    ]);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, restCustomStyles), {
        root: root ? [
            rootStyles,
            root
        ] : rootStyles,
        label: label ? [
            labelStyles,
            label
        ] : labelStyles
    });
});


var $9e1c8b68663bd45b$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $9e1c8b68663bd45b$export$9e2ec46af8d44dc = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CommandBarBase, _super);
    function CommandBarBase(props) {
        var _this = _super.call(this, props) || this;
        _this._overflowSet = $acw62.createRef();
        _this._resizeGroup = $acw62.createRef();
        _this._onRenderData = function(data) {
            var _a = _this.props, ariaLabel = _a.ariaLabel, primaryGroupAriaLabel = _a.primaryGroupAriaLabel, farItemsGroupAriaLabel = _a.farItemsGroupAriaLabel;
            var hasSecondSet = data.farItems && data.farItems.length > 0;
            return $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), {
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.root),
                direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal,
                role: "menubar",
                "aria-label": ariaLabel
            }, $acw62.createElement((0, $cb2ad77bd682e4c3$export$b30d95aaae729214), {
                role: hasSecondSet ? "group" : "none",
                "aria-label": hasSecondSet ? primaryGroupAriaLabel : undefined,
                componentRef: _this._overflowSet,
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.primarySet),
                items: data.primaryItems,
                overflowItems: data.overflowItems.length ? data.overflowItems : undefined,
                onRenderItem: _this._onRenderItem,
                onRenderOverflowButton: _this._onRenderOverflowButton
            }), hasSecondSet && $acw62.createElement((0, $cb2ad77bd682e4c3$export$b30d95aaae729214), {
                role: "group",
                "aria-label": farItemsGroupAriaLabel,
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.secondarySet),
                items: data.farItems,
                onRenderItem: _this._onRenderItem,
                onRenderOverflowButton: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
            }));
        };
        _this._onRenderItem = function(item) {
            if (item.onRender) // These are the top level items, there is no relevant menu dismissing function to
            // provide for the IContextualMenuItem onRender function. Pass in a no op function instead.
            return item.onRender(item, function() {
                return undefined;
            });
            // eslint-disable-next-line deprecation/deprecation
            var itemText = item.text || item.name;
            var commandButtonProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                allowDisabledFocus: true,
                role: "menuitem"
            }, item), {
                styles: (0, $148a4d0388f0f588$export$5d27c9ec00c6966d)(item.buttonStyles),
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-CommandBarItem-link", item.className),
                text: !item.iconOnly ? itemText : undefined,
                menuProps: item.subMenuProps,
                onClick: _this._onButtonClick(item)
            });
            if (item.iconOnly && (itemText !== undefined || item.tooltipHostProps)) return $acw62.createElement((0, $81fe081095f59877$export$ebbf8986cf9b8de1), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                role: "none",
                content: itemText,
                setAriaDescribedBy: false
            }, item.tooltipHostProps), _this._commandButton(item, commandButtonProps));
            return _this._commandButton(item, commandButtonProps);
        };
        _this._commandButton = function(item, props) {
            var ButtonAs = _this.props.buttonAs;
            var CommandBarButtonAs = item.commandBarButtonAs;
            var DefaultButtonAs = (0, $212d6a64e3fb5918$export$ae6efefb61c9c34a);
            // The prop types between these three possible implementations overlap enough that a force-cast is safe.
            var Type = DefaultButtonAs;
            if (CommandBarButtonAs) Type = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(CommandBarButtonAs, Type);
            if (ButtonAs) Type = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(ButtonAs, Type);
            // Always pass the default implementation to the override so it may be composed.
            return $acw62.createElement(Type, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
        };
        _this._onRenderOverflowButton = function(overflowItems) {
            var _a = _this.props.overflowButtonProps, overflowButtonProps = _a === void 0 ? {} : _a;
            var combinedOverflowItems = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], overflowButtonProps.menuProps ? overflowButtonProps.menuProps.items : [], true), overflowItems, true);
            var overflowProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                role: "menuitem"
            }, overflowButtonProps), {
                styles: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    menuIcon: {
                        fontSize: "17px"
                    }
                }, overflowButtonProps.styles),
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-CommandBar-overflowButton", overflowButtonProps.className),
                menuProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, overflowButtonProps.menuProps), {
                    items: combinedOverflowItems
                }),
                menuIconProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    iconName: "More"
                }, overflowButtonProps.menuIconProps)
            });
            var OverflowButtonType = _this.props.overflowButtonAs ? (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(_this.props.overflowButtonAs, (0, $212d6a64e3fb5918$export$ae6efefb61c9c34a)) : (0, $212d6a64e3fb5918$export$ae6efefb61c9c34a);
            return $acw62.createElement(OverflowButtonType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, overflowProps));
        };
        _this._onReduceData = function(data) {
            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataReduced = _a.onDataReduced;
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
            var farItems = data.farItems;
            // Use first item if shiftOnReduce, otherwise use last item
            var movedItem = primaryItems[shiftOnReduce ? 0 : primaryItems.length - 1];
            if (movedItem !== undefined) {
                movedItem.renderedInOverflow = true;
                overflowItems = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                    movedItem
                ], overflowItems, true);
                primaryItems = shiftOnReduce ? primaryItems.slice(1) : primaryItems.slice(0, -1);
                var newData = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, data), {
                    primaryItems: primaryItems,
                    overflowItems: overflowItems
                });
                cacheKey = _this._computeCacheKey({
                    primaryItems: primaryItems,
                    overflow: overflowItems.length > 0,
                    farItems: farItems
                });
                if (onDataReduced) onDataReduced(movedItem);
                newData.cacheKey = cacheKey;
                return newData;
            }
            return undefined;
        };
        _this._onGrowData = function(data) {
            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataGrown = _a.onDataGrown;
            var minimumOverflowItems = data.minimumOverflowItems;
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
            var farItems = data.farItems;
            var movedItem = overflowItems[0];
            // Make sure that moved item exists and is not one of the original overflow items
            if (movedItem !== undefined && overflowItems.length > minimumOverflowItems) {
                movedItem.renderedInOverflow = false;
                overflowItems = overflowItems.slice(1);
                // if shiftOnReduce, movedItem goes first, otherwise, last.
                primaryItems = shiftOnReduce ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                    movedItem
                ], primaryItems, true) : (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], primaryItems, true), [
                    movedItem
                ], false);
                var newData = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, data), {
                    primaryItems: primaryItems,
                    overflowItems: overflowItems
                });
                cacheKey = _this._computeCacheKey({
                    primaryItems: primaryItems,
                    overflow: overflowItems.length > 0,
                    farItems: farItems
                });
                if (onDataGrown) onDataGrown(movedItem);
                newData.cacheKey = cacheKey;
                return newData;
            }
            return undefined;
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    CommandBarBase.prototype.render = function() {
        var _a = this.props, items = _a.items, overflowItems = _a.overflowItems, farItems = _a.farItems, styles = _a.styles, theme = _a.theme, dataDidRender = _a.dataDidRender, _b = _a.onReduceData, onReduceData = _b === void 0 ? this._onReduceData : _b, _c = _a.onGrowData, onGrowData = _c === void 0 ? this._onGrowData : _c, _d = _a.resizeGroupAs, ResizeGroupAs = _d === void 0 ? (0, $4499ee6d6eb5e73d$export$b09b360202d361b4) : _d;
        var commandBarData = {
            primaryItems: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], items, true),
            overflowItems: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], overflowItems, true),
            minimumOverflowItems: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], overflowItems, true).length,
            farItems: farItems,
            cacheKey: this._computeCacheKey({
                primaryItems: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], items, true),
                overflow: overflowItems && overflowItems.length > 0,
                farItems: farItems
            })
        };
        this._classNames = $9e1c8b68663bd45b$var$getClassNames(styles, {
            theme: theme
        });
        // ResizeGroup will render these attributes to the root <div>.
        // TODO We may need to elevate classNames from <FocusZone> into <ResizeGroup> ?
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        return $acw62.createElement(ResizeGroupAs, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps, {
            componentRef: this._resizeGroup,
            data: commandBarData,
            onReduceData: onReduceData,
            onGrowData: onGrowData,
            onRenderData: this._onRenderData,
            dataDidRender: dataDidRender
        }));
    };
    CommandBarBase.prototype.focus = function() {
        var overflowSet = this._overflowSet.current;
        overflowSet && overflowSet.focus();
    };
    CommandBarBase.prototype.remeasure = function() {
        this._resizeGroup.current && this._resizeGroup.current.remeasure();
    };
    CommandBarBase.prototype._onButtonClick = function(item) {
        return function(ev) {
            // inactive is deprecated. remove check in 7.0
            // eslint-disable-next-line deprecation/deprecation
            if (item.inactive) return;
            if (item.onClick) item.onClick(ev, item);
        };
    };
    CommandBarBase.prototype._computeCacheKey = function(data) {
        var primaryItems = data.primaryItems, overflow = data.overflow, farItems = data.farItems;
        var returnKey = function(acc, current) {
            var _a = current.cacheKey, cacheKey = _a === void 0 ? current.key : _a;
            return acc + cacheKey;
        };
        var primaryKey = primaryItems && primaryItems.reduce(returnKey, "");
        var overflowKey = overflow ? "overflow" : "";
        var farKey = farItems && farItems.reduce(returnKey, "");
        return [
            primaryKey,
            overflowKey,
            farKey
        ].join("");
    };
    CommandBarBase.defaultProps = {
        items: [],
        overflowItems: []
    };
    return CommandBarBase;
}($acw62.Component);



var $ac117d5d91b8c14b$export$afe2359305e787af = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $9e1c8b68663bd45b$export$9e2ec46af8d44dc), (0, $148a4d0388f0f588$export$ffd58b7f6f099a57), undefined, {
    scope: "CommandBar"
});




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
var $ec688b1a3baef560$export$13d8a2eff4c445cd = 36;
var $ec688b1a3baef560$export$a271488defeee3de = function(props) {
    var count = props.count, _a = props.indentWidth, indentWidth = _a === void 0 ? $ec688b1a3baef560$export$13d8a2eff4c445cd : _a, _b = props.role, role = _b === void 0 ? "presentation" : _b;
    var width = count * indentWidth;
    return count > 0 ? $acw62.createElement("span", {
        className: "ms-GroupSpacer",
        style: {
            display: "inline-block",
            width: width
        },
        role: role
    }) : null;
};


var $9bab5a9100d38ae5$exports = {};
$parcel$export($9bab5a9100d38ae5$exports, "GroupedList", () => $a8210fb15a0e100c$export$7b9037ad46f5f6b2);
$parcel$export($9bab5a9100d38ae5$exports, "CollapseAllVisibility", () => $983645f52845fc75$export$64fc9da778a9842);


var $170fa6de102a1824$var$GlobalClassNames = {
    root: "ms-GroupedList",
    compact: "ms-GroupedList--Compact",
    group: "ms-GroupedList-group",
    link: "ms-Link",
    listCell: "ms-List-cell"
};
var $170fa6de102a1824$var$beziers = {
    easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)"
};
var $170fa6de102a1824$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b;
    var theme = props.theme, className = props.className, compact = props.compact;
    var palette = theme.palette;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($170fa6de102a1824$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.small,
            {
                position: "relative",
                selectors: (_a = {}, _a[".".concat(classNames.listCell)] = {
                    minHeight: 38
                }, _a)
            },
            compact && [
                classNames.compact,
                {
                    selectors: (_b = {}, _b[".".concat(classNames.listCell)] = {
                        minHeight: 32
                    }, _b)
                }
            ],
            className
        ],
        group: [
            classNames.group,
            {
                transition: "background-color ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue2, " ").concat($170fa6de102a1824$var$beziers.easeInOutSine)
            }
        ],
        groupIsDropping: {
            backgroundColor: palette.neutralLight
        }
    };
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $eb906a1fe3c7a837$export$40138a1437c71ca4 = "change";
var $eb906a1fe3c7a837$export$4ab6bac19c220899 = "items-change";
var $eb906a1fe3c7a837$export$91484609d16ec765;
(function(SelectionMode) {
    SelectionMode[SelectionMode["none"] = 0] = "none";
    SelectionMode[SelectionMode["single"] = 1] = "single";
    SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
})($eb906a1fe3c7a837$export$91484609d16ec765 || ($eb906a1fe3c7a837$export$91484609d16ec765 = {}));
var $eb906a1fe3c7a837$export$5c80dd1df5708938;
(function(SelectionDirection) {
    SelectionDirection[SelectionDirection["horizontal"] = 0] = "horizontal";
    SelectionDirection[SelectionDirection["vertical"] = 1] = "vertical";
})($eb906a1fe3c7a837$export$5c80dd1df5708938 || ($eb906a1fe3c7a837$export$5c80dd1df5708938 = {}));









var $ee27f738f928d431$export$2a01ff9a94e7a27 = {
    root: "ms-DetailsRow",
    // TODO: in Fabric 7.0 lowercase the 'Compact' for consistency across other components.
    compact: "ms-DetailsList--Compact",
    cell: "ms-DetailsRow-cell",
    cellAnimation: "ms-DetailsRow-cellAnimation",
    cellCheck: "ms-DetailsRow-cellCheck",
    check: "ms-DetailsRow-check",
    cellMeasurer: "ms-DetailsRow-cellMeasurer",
    listCellFirstChild: "ms-List-cell:first-child",
    isContentUnselectable: "is-contentUnselectable",
    isSelected: "is-selected",
    isCheckVisible: "is-check-visible",
    isRowHeader: "is-row-header",
    fields: "ms-DetailsRow-fields"
};
var $ee27f738f928d431$var$IsFocusableSelector = "[data-is-focusable='true']";
var $ee27f738f928d431$export$8d1af5f7ea824b8d = {
    cellLeftPadding: 12,
    cellRightPadding: 8,
    cellExtraRightPadding: 24
};
var $ee27f738f928d431$export$6a8eeb94a4d816cb = {
    rowHeight: 42,
    compactRowHeight: 32
};
// Constant values
var $ee27f738f928d431$var$values = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ee27f738f928d431$export$6a8eeb94a4d816cb), {
    rowVerticalPadding: 11,
    compactRowVerticalPadding: 6
});
var $ee27f738f928d431$export$5fec9c780926aedb = function(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var theme = props.theme, isSelected = props.isSelected, canSelect = props.canSelect, droppingClassName = props.droppingClassName, isCheckVisible = props.isCheckVisible, checkboxCellClassName = props.checkboxCellClassName, compact = props.compact, className = props.className, _q = props.cellStyleProps, cellStyleProps = _q === void 0 ? $ee27f738f928d431$export$8d1af5f7ea824b8d : _q, enableUpdateAnimations = props.enableUpdateAnimations, disabled = props.disabled;
    var palette = theme.palette, fonts = theme.fonts;
    var neutralPrimary = palette.neutralPrimary, white = palette.white, neutralSecondary = palette.neutralSecondary, neutralLighter = palette.neutralLighter, neutralLight = palette.neutralLight, neutralDark = palette.neutralDark, neutralQuaternaryAlt = palette.neutralQuaternaryAlt;
    var _r = theme.semanticColors, focusBorder = _r.focusBorder, focusedLinkColor = _r.linkHovered;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($ee27f738f928d431$export$2a01ff9a94e7a27, theme);
    var colors = {
        // Default
        defaultHeaderText: neutralPrimary,
        defaultMetaText: neutralSecondary,
        defaultBackground: white,
        // Default Hover
        defaultHoverHeaderText: neutralDark,
        defaultHoverMetaText: neutralPrimary,
        defaultHoverBackground: neutralLighter,
        // Selected
        selectedHeaderText: neutralDark,
        selectedMetaText: neutralPrimary,
        selectedBackground: neutralLight,
        // Selected Hover
        selectedHoverHeaderText: neutralDark,
        selectedHoverMetaText: neutralPrimary,
        selectedHoverBackground: neutralQuaternaryAlt,
        // Focus
        focusHeaderText: neutralDark,
        focusMetaText: neutralPrimary,
        focusBackground: neutralLight,
        focusHoverBackground: neutralQuaternaryAlt
    };
    var rowHighContrastFocus = {
        top: 2,
        right: 2,
        bottom: 2,
        left: 2
    };
    // Selected row styles
    var selectedStyles = [
        (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
            inset: -1,
            borderColor: focusBorder,
            outlineColor: white,
            highContrastStyle: rowHighContrastFocus
        }),
        classNames.isSelected,
        {
            color: colors.selectedMetaText,
            background: colors.selectedBackground,
            borderBottom: "1px solid ".concat(white),
            selectors: (_a = {
                "&:before": {
                    position: "absolute",
                    display: "block",
                    top: -1,
                    height: 1,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    content: "",
                    borderTop: "1px solid ".concat(white)
                }
            }, _a[".".concat(classNames.cell, " > .").concat((0, $ad7f833f6d38f25a$export$2ecde6259cbd2585).root)] = {
                color: focusedLinkColor,
                selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "HighlightText"
                }, _b)
            }, // Selected State hover
            _a["&:hover"] = {
                background: colors.selectedHoverBackground,
                color: colors.selectedHoverMetaText,
                selectors: (_c = {}, // Selected State hover meta cell
                _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    background: "Highlight",
                    selectors: (_d = {}, _d[".".concat(classNames.cell)] = {
                        color: "HighlightText"
                    }, _d[".".concat(classNames.cell, " > .").concat((0, $ad7f833f6d38f25a$export$2ecde6259cbd2585).root)] = {
                        forcedColorAdjust: "none",
                        color: "HighlightText"
                    }, _d)
                }, // Selected State hover Header cell
                _c[".".concat(classNames.isRowHeader)] = {
                    color: colors.selectedHoverHeaderText,
                    selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "HighlightText"
                    }, _e)
                }, _c)
            }, // Focus state
            _a["&:focus"] = {
                background: colors.focusBackground,
                selectors: (_f = {}, // Selected State hover meta cell
                _f[".".concat(classNames.cell)] = {
                    color: colors.focusMetaText,
                    selectors: (_g = {}, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "HighlightText",
                        selectors: {
                            "> a": {
                                color: "HighlightText"
                            }
                        }
                    }, _g)
                }, // Row header cell
                _f[".".concat(classNames.isRowHeader)] = {
                    color: colors.focusHeaderText,
                    selectors: (_h = {}, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        color: "HighlightText"
                    }, _h)
                }, // Ensure high-contrast mode overrides default focus background
                _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    background: "Highlight"
                }, _f)
            }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                background: "Highlight",
                color: "HighlightText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                selectors: {
                    a: {
                        color: "HighlightText"
                    }
                }
            }), // Focus and hover state
            _a["&:focus:hover"] = {
                background: colors.focusHoverBackground
            }, _a)
        }
    ];
    var cannotSelectStyles = [
        classNames.isContentUnselectable,
        {
            userSelect: "none",
            cursor: "default"
        }
    ];
    var rootCompactStyles = {
        minHeight: $ee27f738f928d431$var$values.compactRowHeight,
        border: 0
    };
    var cellCompactStyles = {
        minHeight: $ee27f738f928d431$var$values.compactRowHeight,
        paddingTop: $ee27f738f928d431$var$values.compactRowVerticalPadding,
        paddingBottom: $ee27f738f928d431$var$values.compactRowVerticalPadding,
        paddingLeft: "".concat(cellStyleProps.cellLeftPadding, "px")
    };
    var defaultCellStyles = [
        (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
            inset: -1
        }),
        classNames.cell,
        {
            display: "inline-block",
            position: "relative",
            boxSizing: "border-box",
            minHeight: $ee27f738f928d431$var$values.rowHeight,
            verticalAlign: "top",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingTop: $ee27f738f928d431$var$values.rowVerticalPadding,
            paddingBottom: $ee27f738f928d431$var$values.rowVerticalPadding,
            paddingLeft: "".concat(cellStyleProps.cellLeftPadding, "px"),
            selectors: (_j = {
                "& > button": {
                    maxWidth: "100%"
                }
            }, _j[$ee27f738f928d431$var$IsFocusableSelector] = (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: -1,
                borderColor: neutralSecondary,
                outlineColor: white
            }), _j)
        },
        isSelected && {
            selectors: (_k = {}, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                background: "Highlight",
                color: "HighlightText"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _k)
        },
        compact && cellCompactStyles,
        disabled && {
            opacity: 0.5
        }
    ];
    return {
        root: [
            classNames.root,
            (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn400,
            droppingClassName,
            theme.fonts.small,
            isCheckVisible && classNames.isCheckVisible,
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                borderColor: focusBorder,
                outlineColor: white
            }),
            {
                borderBottom: "1px solid ".concat(neutralLighter),
                background: colors.defaultBackground,
                color: colors.defaultMetaText,
                // This ensures that the row always tries to consume is minimum width and does not compress.
                display: "inline-flex",
                minWidth: "100%",
                minHeight: $ee27f738f928d431$var$values.rowHeight,
                whiteSpace: "nowrap",
                padding: 0,
                boxSizing: "border-box",
                verticalAlign: "top",
                textAlign: "left",
                selectors: (_l = {}, _l[".".concat(classNames.listCellFirstChild, " &:before")] = {
                    display: "none"
                }, _l["&:hover"] = {
                    background: colors.defaultHoverBackground,
                    color: colors.defaultHoverMetaText,
                    selectors: (_m = {}, _m[".".concat(classNames.isRowHeader)] = {
                        color: colors.defaultHoverHeaderText
                    }, _m[".".concat(classNames.cell, " > .").concat((0, $ad7f833f6d38f25a$export$2ecde6259cbd2585).root)] = {
                        color: focusedLinkColor
                    }, _m)
                }, _l["&:hover .".concat(classNames.check)] = {
                    opacity: 1
                }, _l[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus .").concat(classNames.check)] = {
                    opacity: 1
                }, _l[".ms-GroupSpacer"] = {
                    flexShrink: 0,
                    flexGrow: 0
                }, _l)
            },
            isSelected && selectedStyles,
            !canSelect && cannotSelectStyles,
            compact && rootCompactStyles,
            className
        ],
        cellUnpadded: {
            paddingRight: "".concat(cellStyleProps.cellRightPadding, "px")
        },
        cellPadded: {
            paddingRight: "".concat(cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding, "px"),
            selectors: (_o = {}, _o["&.".concat(classNames.cellCheck)] = {
                paddingRight: 0
            }, _o)
        },
        cell: defaultCellStyles,
        cellAnimation: enableUpdateAnimations && (0, $ca17ef8e897e1cc4$export$30948f134ffb9e45).slideLeftIn40,
        cellMeasurer: [
            classNames.cellMeasurer,
            {
                overflow: "visible",
                whiteSpace: "nowrap"
            }
        ],
        checkCell: [
            defaultCellStyles,
            classNames.cellCheck,
            checkboxCellClassName,
            {
                padding: 0,
                // Ensure that the check cell covers the top border of the cell.
                // This ensures the click target does not leave a spot which would
                // cause other items to be deselected.
                paddingTop: 1,
                marginTop: -1,
                flexShrink: 0
            }
        ],
        fields: [
            classNames.fields,
            {
                display: "flex",
                alignItems: "stretch"
            }
        ],
        isRowHeader: [
            classNames.isRowHeader,
            {
                color: colors.defaultHeaderText,
                fontSize: fonts.medium.fontSize
            },
            isSelected && {
                color: colors.selectedHeaderText,
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                selectors: (_p = {}, _p[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "HighlightText"
                }, _p)
            }
        ],
        isMultiline: [
            defaultCellStyles,
            {
                whiteSpace: "normal",
                wordBreak: "break-word",
                textOverflow: "clip"
            }
        ],
        check: [
            classNames.check
        ]
    };
};









var $640dfc589ffc2fb9$var$GlobalClassNames = {
    tooltipHost: "ms-TooltipHost",
    root: "ms-DetailsHeader",
    cell: "ms-DetailsHeader-cell",
    cellIsCheck: "ms-DetailsHeader-cellIsCheck",
    collapseButton: "ms-DetailsHeader-collapseButton",
    isCollapsed: "is-collapsed",
    isAllSelected: "is-allSelected",
    isSelectAllHidden: "is-selectAllHidden",
    isResizingColumn: "is-resizingColumn",
    cellSizer: "ms-DetailsHeader-cellSizer",
    isResizing: "is-resizing",
    dropHintCircleStyle: "ms-DetailsHeader-dropHintCircleStyle",
    dropHintCaretStyle: "ms-DetailsHeader-dropHintCaretStyle",
    dropHintLineStyle: "ms-DetailsHeader-dropHintLineStyle",
    cellTitle: "ms-DetailsHeader-cellTitle",
    cellName: "ms-DetailsHeader-cellName",
    filterChevron: "ms-DetailsHeader-filterChevron",
    gripperBarVertical: "ms-DetailsColumn-gripperBarVertical",
    checkTooltip: "ms-DetailsHeader-checkTooltip",
    check: "ms-DetailsHeader-check"
};
var $640dfc589ffc2fb9$export$cdb7fd9d999c7168 = 42;
var $640dfc589ffc2fb9$export$cbecc5fa687c7fad = function(props) {
    var theme = props.theme, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _a;
    var semanticColors = theme.semanticColors;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($640dfc589ffc2fb9$var$GlobalClassNames, theme);
    return [
        classNames.cell,
        (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
        {
            color: semanticColors.bodyText,
            position: "relative",
            display: "inline-block",
            boxSizing: "border-box",
            padding: "0 ".concat(cellStyleProps.cellRightPadding, "px 0 ").concat(cellStyleProps.cellLeftPadding, "px"),
            lineHeight: "inherit",
            margin: "0",
            height: $640dfc589ffc2fb9$export$cdb7fd9d999c7168,
            verticalAlign: "top",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "left"
        }
    ];
};
var $640dfc589ffc2fb9$export$8ef77cbfb1c9df49 = function(props) {
    var _a, _b, _c, _d;
    var theme = props.theme, className = props.className, isAllSelected = props.isAllSelected, isResizingColumn = props.isResizingColumn, isSizing = props.isSizing, isAllCollapsed = props.isAllCollapsed, _e = props.cellStyleProps, cellStyleProps = _e === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _e;
    var semanticColors = theme.semanticColors, palette = theme.palette, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($640dfc589ffc2fb9$var$GlobalClassNames, theme);
    var colors = {
        iconForegroundColor: semanticColors.bodySubtext,
        headerForegroundColor: semanticColors.bodyText,
        headerBackgroundColor: semanticColors.bodyBackground,
        resizerColor: palette.neutralTertiaryAlt
    };
    var cellSizerFadeInStyles = {
        opacity: 1,
        transition: "opacity 0.3s linear"
    };
    var cellStyles = $640dfc589ffc2fb9$export$cbecc5fa687c7fad(props);
    return {
        root: [
            classNames.root,
            fonts.small,
            {
                display: "inline-block",
                background: colors.headerBackgroundColor,
                position: "relative",
                minWidth: "100%",
                verticalAlign: "top",
                height: $640dfc589ffc2fb9$export$cdb7fd9d999c7168,
                lineHeight: $640dfc589ffc2fb9$export$cdb7fd9d999c7168,
                whiteSpace: "nowrap",
                boxSizing: "content-box",
                paddingBottom: "1px",
                paddingTop: "16px",
                borderBottom: "1px solid ".concat(semanticColors.bodyDivider),
                cursor: "default",
                userSelect: "none",
                selectors: (_a = {}, _a["&:hover .".concat(classNames.check)] = {
                    opacity: 1
                }, _a["& .".concat(classNames.tooltipHost, " .").concat(classNames.checkTooltip)] = {
                    display: "block"
                }, _a)
            },
            isAllSelected && classNames.isAllSelected,
            isResizingColumn && classNames.isResizingColumn,
            className
        ],
        check: [
            classNames.check,
            {
                height: $640dfc589ffc2fb9$export$cdb7fd9d999c7168
            },
            {
                selectors: (_b = {}, _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus")] = {
                    opacity: 1
                }, _b)
            }
        ],
        cellWrapperPadded: {
            paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
        },
        cellIsCheck: [
            cellStyles,
            classNames.cellIsCheck,
            {
                position: "relative",
                padding: 0,
                margin: 0,
                display: "inline-flex",
                alignItems: "center",
                border: "none"
            },
            isAllSelected && {
                opacity: 1
            }
        ],
        cellIsGroupExpander: [
            cellStyles,
            {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: fonts.small.fontSize,
                padding: 0,
                border: "none",
                width: (0, $ec688b1a3baef560$export$13d8a2eff4c445cd),
                color: palette.neutralSecondary,
                selectors: {
                    ":hover": {
                        backgroundColor: palette.neutralLighter
                    },
                    ":active": {
                        backgroundColor: palette.neutralLight
                    }
                }
            }
        ],
        cellIsActionable: {
            selectors: {
                ":hover": {
                    color: semanticColors.bodyText,
                    background: semanticColors.listHeaderBackgroundHovered
                },
                ":active": {
                    background: semanticColors.listHeaderBackgroundPressed
                }
            }
        },
        cellIsEmpty: {
            textOverflow: "clip"
        },
        cellSizer: [
            classNames.cellSizer,
            (0, $3c8eab4e1d179dea$export$47933a1040be8871)(),
            {
                display: "inline-block",
                position: "relative",
                cursor: "ew-resize",
                bottom: 0,
                top: 0,
                overflow: "hidden",
                height: "inherit",
                background: "transparent",
                zIndex: 1,
                width: 16,
                selectors: (_c = {
                    ":after": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        width: 1,
                        background: colors.resizerColor,
                        opacity: 0,
                        left: "50%"
                    },
                    ":focus:after": cellSizerFadeInStyles,
                    ":hover:after": cellSizerFadeInStyles
                }, _c["&.".concat(classNames.isResizing, ":after")] = [
                    cellSizerFadeInStyles,
                    {
                        boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.4)"
                    }
                ], _c)
            }
        ],
        cellIsResizing: classNames.isResizing,
        cellSizerStart: {
            margin: "0 -8px"
        },
        cellSizerEnd: {
            margin: 0,
            marginLeft: -16
        },
        collapseButton: [
            classNames.collapseButton,
            {
                transformOrigin: "50% 50%",
                transition: "transform .1s linear"
            },
            isAllCollapsed ? [
                classNames.isCollapsed,
                {
                    transform: "rotate(0deg)"
                }
            ] : {
                transform: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? "rotate(-90deg)" : "rotate(90deg)"
            }
        ],
        checkTooltip: classNames.checkTooltip,
        sizingOverlay: isSizing && {
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            cursor: "ew-resize",
            background: "rgba(255, 255, 255, 0)",
            selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                background: "transparent"
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _d)
        },
        accessibleLabel: (0, $34563ae103a23d08$export$35835471cbe77db4),
        dropHintCircleStyle: [
            classNames.dropHintCircleStyle,
            {
                display: "inline-block",
                visibility: "hidden",
                position: "absolute",
                bottom: 0,
                height: 9,
                width: 9,
                borderRadius: "50%",
                marginLeft: -5,
                top: 34,
                overflow: "visible",
                zIndex: 10,
                border: "1px solid ".concat(palette.themePrimary),
                background: palette.white
            }
        ],
        dropHintCaretStyle: [
            classNames.dropHintCaretStyle,
            {
                display: "none",
                position: "absolute",
                top: -28,
                left: -6.5,
                fontSize: fonts.medium.fontSize,
                color: palette.themePrimary,
                overflow: "visible",
                zIndex: 10
            }
        ],
        dropHintLineStyle: [
            classNames.dropHintLineStyle,
            {
                display: "none",
                position: "absolute",
                bottom: 0,
                top: 0,
                overflow: "hidden",
                height: 42,
                width: 1,
                background: palette.themePrimary,
                zIndex: 10
            }
        ],
        dropHintStyle: {
            display: "inline-block",
            position: "absolute"
        }
    };
};





var $62703744849b637e$export$3243e825d12e323a = {
    root: "ms-Check",
    circle: "ms-Check-circle",
    check: "ms-Check-check",
    /** Must be manually applied to the parent element of the check. */ checkHost: "ms-Check-checkHost"
};
var $62703744849b637e$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d, _e;
    // eslint-disable-next-line deprecation/deprecation
    var _f = props.height, height = _f === void 0 ? props.checkBoxHeight || "18px" : _f, checked = props.checked, className = props.className, theme = props.theme;
    var palette = theme.palette, semanticColors = theme.semanticColors, fonts = theme.fonts;
    var isRTL = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme);
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($62703744849b637e$export$3243e825d12e323a, theme);
    var sharedCircleCheck = {
        fontSize: height,
        position: "absolute",
        left: 0,
        top: 0,
        width: height,
        height: height,
        textAlign: "center",
        // inline-flex prevents the check from shifting with custom line height styles
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle"
    };
    return {
        root: [
            classNames.root,
            fonts.medium,
            {
                // lineHeight currently needs to be a string to output without 'px'
                lineHeight: "1",
                width: height,
                height: height,
                verticalAlign: "top",
                position: "relative",
                userSelect: "none",
                selectors: (_a = {
                    ":before": {
                        content: '""',
                        position: "absolute",
                        top: "1px",
                        right: "1px",
                        bottom: "1px",
                        left: "1px",
                        borderRadius: "50%",
                        opacity: 1,
                        background: semanticColors.bodyBackground
                    }
                }, _a[".".concat(classNames.checkHost, ":hover &, .").concat(classNames.checkHost, ":focus &, &:hover, &:focus")] = {
                    opacity: 1
                }, _a)
            },
            checked && [
                "is-checked",
                {
                    selectors: {
                        ":before": {
                            background: palette.themePrimary,
                            opacity: 1,
                            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                                background: "Window"
                            }, _b)
                        }
                    }
                }
            ],
            className
        ],
        circle: [
            classNames.circle,
            sharedCircleCheck,
            {
                color: palette.neutralSecondary,
                selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: "WindowText"
                }, _c)
            },
            checked && {
                color: palette.white
            }
        ],
        check: [
            classNames.check,
            sharedCircleCheck,
            {
                opacity: 0,
                color: palette.neutralSecondary,
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
                left: isRTL ? "-0.5px" : ".5px",
                top: "-1px",
                selectors: (_d = {
                    ":hover": {
                        opacity: 1
                    }
                }, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _d)
            },
            checked && {
                opacity: 1,
                color: palette.white,
                fontWeight: 900,
                selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: "none",
                    color: "WindowText"
                }, _e)
            }
        ],
        checkHost: classNames.checkHost
    };
};


var $939930e28b7e2661$var$GlobalClassNames = {
    root: "ms-DetailsRow-check",
    isDisabled: "ms-DetailsRow-check--isDisabled",
    isHeader: "ms-DetailsRow-check--isHeader"
};
var $939930e28b7e2661$export$80b16cf2baff1e7d = 48;
var $939930e28b7e2661$export$5fe9f1bb52448e88 = function(props) {
    var theme = props.theme, className = props.className, isHeader = props.isHeader, selected = props.selected, anySelected = props.anySelected, canSelect = props.canSelect, compact = props.compact, isVisible = props.isVisible;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($939930e28b7e2661$var$GlobalClassNames, theme);
    var rowHeight = (0, $ee27f738f928d431$export$6a8eeb94a4d816cb).rowHeight, compactRowHeight = (0, $ee27f738f928d431$export$6a8eeb94a4d816cb).compactRowHeight;
    var height = isHeader ? (0, $640dfc589ffc2fb9$export$cdb7fd9d999c7168) : compact ? compactRowHeight : rowHeight;
    var isCheckVisible = isVisible || selected || anySelected;
    return {
        root: [
            classNames.root,
            className
        ],
        check: [
            !canSelect && classNames.isDisabled,
            isHeader && classNames.isHeader,
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            theme.fonts.small,
            (0, $62703744849b637e$export$3243e825d12e323a).checkHost,
            {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "default",
                boxSizing: "border-box",
                verticalAlign: "top",
                background: "none",
                backgroundColor: "transparent",
                border: "none",
                opacity: isCheckVisible ? 1 : 0,
                height: height,
                width: $939930e28b7e2661$export$80b16cf2baff1e7d,
                padding: 0,
                margin: 0
            }
        ],
        isDisabled: []
    };
};



var $49811d9a89973977$var$GlobalClassNames = {
    root: "ms-GroupHeader",
    compact: "ms-GroupHeader--compact",
    check: "ms-GroupHeader-check",
    dropIcon: "ms-GroupHeader-dropIcon",
    expand: "ms-GroupHeader-expand",
    isCollapsed: "is-collapsed",
    title: "ms-GroupHeader-title",
    isSelected: "is-selected",
    iconTag: "ms-Icon--Tag",
    group: "ms-GroupedList-group",
    isDropping: "is-dropping"
};
var $49811d9a89973977$var$beziers = {
    easeOutCirc: "cubic-bezier(0.075, 0.820, 0.165, 1.000)",
    easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
    easeInBack: "cubic-bezier(0.600, -0.280, 0.735, 0.045)"
};
var $49811d9a89973977$var$DEFAULT_GROUP_HEADER_HEIGHT = 48;
var $49811d9a89973977$var$COMPACT_GROUP_HEADER_HEIGHT = 40;
var $49811d9a89973977$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d, _e;
    var theme = props.theme, className = props.className, selected = props.selected, isCollapsed = props.isCollapsed, compact = props.compact;
    // padding from the source to align GroupHeader title with DetailsRow's first cell.
    var cellLeftPadding = (0, $ee27f738f928d431$export$8d1af5f7ea824b8d).cellLeftPadding;
    var finalRowHeight = compact ? $49811d9a89973977$var$COMPACT_GROUP_HEADER_HEIGHT : $49811d9a89973977$var$DEFAULT_GROUP_HEADER_HEIGHT;
    var semanticColors = theme.semanticColors, palette = theme.palette, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($49811d9a89973977$var$GlobalClassNames, theme);
    var checkExpandResetStyles = [
        (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
        {
            cursor: "default",
            background: "none",
            backgroundColor: "transparent",
            border: "none",
            padding: 0
        }
    ];
    return {
        root: [
            classNames.root,
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            theme.fonts.medium,
            {
                // keep the border for height but color it so it's invisible.
                borderBottom: "1px solid ".concat(semanticColors.listBackground),
                cursor: "default",
                userSelect: "none",
                selectors: (_a = {
                    ":hover": {
                        background: semanticColors.listItemBackgroundHovered,
                        color: semanticColors.actionLinkHovered
                    }
                }, _a["&:hover .".concat(classNames.check)] = {
                    opacity: 1
                }, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus .").concat(classNames.check)] = {
                    opacity: 1
                }, _a[":global(.".concat(classNames.group, ".").concat(classNames.isDropping, ")")] = {
                    selectors: (_b = {}, _b["& > .".concat(classNames.root, " .").concat(classNames.dropIcon)] = {
                        transition: "transform ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue4, " ").concat($49811d9a89973977$var$beziers.easeOutCirc, " ") + "opacity ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue1, " ").concat($49811d9a89973977$var$beziers.easeOutSine),
                        transitionDelay: (0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue3,
                        opacity: 1,
                        transform: "rotate(0.2deg) scale(1);"
                    }, _b[".".concat(classNames.check)] = {
                        opacity: 0
                    }, _b)
                }, _a)
            },
            selected && [
                classNames.isSelected,
                {
                    background: semanticColors.listItemBackgroundChecked,
                    selectors: (_c = {
                        ":hover": {
                            background: semanticColors.listItemBackgroundCheckedHovered
                        }
                    }, _c["".concat(classNames.check)] = {
                        opacity: 1
                    }, _c)
                }
            ],
            compact && [
                classNames.compact,
                {
                    border: "none"
                }
            ],
            className
        ],
        groupHeaderContainer: [
            {
                display: "flex",
                alignItems: "center",
                height: finalRowHeight
            }
        ],
        headerCount: [
            {
                padding: "0px 4px"
            }
        ],
        check: [
            classNames.check,
            checkExpandResetStyles,
            {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // paddingTop and marginTop brought from the DetailsRow.styles.ts with explanation below.
                // Ensure that the check cell covers the top border of the cell.
                // This ensures the click target does not leave a spot which would
                // cause other items to be deselected.
                paddingTop: 1,
                marginTop: -1,
                opacity: 0,
                width: (0, $939930e28b7e2661$export$80b16cf2baff1e7d),
                height: finalRowHeight,
                selectors: (_d = {}, _d[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus")] = {
                    opacity: 1
                }, _d)
            }
        ],
        expand: [
            classNames.expand,
            checkExpandResetStyles,
            {
                display: "flex",
                flexShrink: 0,
                alignItems: "center",
                justifyContent: "center",
                fontSize: fonts.small.fontSize,
                width: (0, $ec688b1a3baef560$export$13d8a2eff4c445cd),
                height: finalRowHeight,
                color: selected ? palette.neutralPrimary : palette.neutralSecondary,
                selectors: {
                    ":hover": {
                        backgroundColor: selected ? palette.neutralQuaternary : palette.neutralLight
                    },
                    ":active": {
                        backgroundColor: selected ? palette.neutralTertiaryAlt : palette.neutralQuaternaryAlt
                    }
                }
            }
        ],
        expandIsCollapsed: [
            isCollapsed ? [
                classNames.isCollapsed,
                {
                    transform: "rotate(0deg)",
                    transformOrigin: "50% 50%",
                    transition: "transform .1s linear"
                }
            ] : {
                transform: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? "rotate(-90deg)" : "rotate(90deg)",
                transformOrigin: "50% 50%",
                transition: "transform .1s linear"
            }
        ],
        title: [
            classNames.title,
            {
                paddingLeft: cellLeftPadding,
                fontSize: compact ? fonts.medium.fontSize : fonts.mediumPlus.fontSize,
                fontWeight: isCollapsed ? (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular : (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                cursor: "pointer",
                outline: 0,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden"
            }
        ],
        dropIcon: [
            classNames.dropIcon,
            {
                position: "absolute",
                left: -26,
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large,
                color: palette.neutralSecondary,
                transition: "transform ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue2, " ").concat($49811d9a89973977$var$beziers.easeInBack, ", ") + "opacity ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue4, " ").concat($49811d9a89973977$var$beziers.easeOutSine),
                opacity: 0,
                transform: "rotate(0.2deg) scale(0.65)",
                transformOrigin: "10px 10px",
                selectors: (_e = {}, _e[":global(.".concat(classNames.iconTag, ")")] = {
                    position: "absolute"
                }, _e)
            }
        ]
    };
};




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $cfee4b2f6b15daaa$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $cfee4b2f6b15daaa$export$5654f43f01c20c5c = $acw62.forwardRef(function(props, ref) {
    var _a = props.checked, checked = _a === void 0 ? false : _a, className = props.className, theme = props.theme, styles = props.styles, _b = props.useFastIcons, useFastIcons = _b === void 0 ? true : _b;
    var classNames = $cfee4b2f6b15daaa$var$getClassNames(styles, {
        theme: theme,
        className: className,
        checked: checked
    });
    var IconComponent = useFastIcons ? (0, $eec83b0087c5fe87$export$f56ea46797033f60) : (0, $4b3e235077c5b552$export$f04a61298a47a40f);
    return $acw62.createElement("div", {
        className: classNames.root,
        ref: ref
    }, $acw62.createElement(IconComponent, {
        iconName: "CircleRing",
        className: classNames.circle
    }), $acw62.createElement(IconComponent, {
        iconName: "StatusCircleCheckmark",
        className: classNames.check
    }));
});
$cfee4b2f6b15daaa$export$5654f43f01c20c5c.displayName = "CheckBase";



var $591e1f0616d591da$export$60bffc6e2a50e7f9 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $cfee4b2f6b15daaa$export$5654f43f01c20c5c), (0, $62703744849b637e$export$ffd58b7f6f099a57), undefined, {
    scope: "Check"
}, true);







var $acw62 = parcelRequire("acw62");
/**
 * Possible variations of the spinner circle size.
 * {@docCategory Spinner}
 */ var $671fc9e4e4fd2e99$export$11e6017846e949;
(function(SpinnerSize) {
    /**
     * 12px Spinner diameter
     */ SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
    /**
     * 16px Spinner diameter
     */ SpinnerSize[SpinnerSize["small"] = 1] = "small";
    /**
     * 20px Spinner diameter
     */ SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
    /**
     * 28px Spinner diameter
     */ SpinnerSize[SpinnerSize["large"] = 3] = "large";
})($671fc9e4e4fd2e99$export$11e6017846e949 || ($671fc9e4e4fd2e99$export$11e6017846e949 = {}));
var $671fc9e4e4fd2e99$export$e0cf1f7a435f3825;
(function(SpinnerType) {
    /**
     * @deprecated Use `SpinnerSize.medium` instead. Will be removed at \>= 2.0.0.
     */ SpinnerType[SpinnerType["normal"] = 0] = "normal";
    /**
     * @deprecated Use `SpinnerSize.large` instead. Will be removed at \>= 2.0.0.
     */ SpinnerType[SpinnerType["large"] = 1] = "large";
})($671fc9e4e4fd2e99$export$e0cf1f7a435f3825 || ($671fc9e4e4fd2e99$export$e0cf1f7a435f3825 = {}));



var $dbc71e4bfcac0ed9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $dbc71e4bfcac0ed9$export$8c7b82d9dc8565da = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SpinnerBase, _super);
    function SpinnerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerBase.prototype.render = function() {
        // eslint-disable-next-line deprecation/deprecation
        var _a = this.props, type = _a.type, size = _a.size, ariaLabel = _a.ariaLabel, ariaLive = _a.ariaLive, styles = _a.styles, label = _a.label, theme = _a.theme, className = _a.className, labelPosition = _a.labelPosition;
        var statusMessage = ariaLabel;
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
            "size"
        ]);
        // SpinnerType is deprecated. If someone is still using this property, rather than putting the SpinnerType into the
        // ISpinnerStyleProps, we'll map SpinnerType to its equivalent SpinnerSize and pass that in. Once SpinnerType
        // finally goes away we should delete this.
        var styleSize = size;
        if (styleSize === undefined && type !== undefined) // eslint-disable-next-line deprecation/deprecation
        styleSize = type === (0, $671fc9e4e4fd2e99$export$e0cf1f7a435f3825).large ? (0, $671fc9e4e4fd2e99$export$11e6017846e949).large : (0, $671fc9e4e4fd2e99$export$11e6017846e949).medium;
        var classNames = $dbc71e4bfcac0ed9$var$getClassNames(styles, {
            theme: theme,
            size: styleSize,
            className: className,
            labelPosition: labelPosition
        });
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps, {
            className: classNames.root
        }), $acw62.createElement("div", {
            className: classNames.circle
        }), label && $acw62.createElement("div", {
            className: classNames.label
        }, label), statusMessage && $acw62.createElement("div", {
            role: "status",
            "aria-live": ariaLive
        }, $acw62.createElement((0, $9e351c993b799a2b$export$fd40b834a3906fa8), null, $acw62.createElement("div", {
            className: classNames.screenReaderText
        }, statusMessage))));
    };
    SpinnerBase.defaultProps = {
        size: (0, $671fc9e4e4fd2e99$export$11e6017846e949).medium,
        ariaLive: "polite",
        labelPosition: "bottom"
    };
    return SpinnerBase;
}($acw62.Component);






var $b943c17b2c863d1f$var$GlobalClassNames = {
    root: "ms-Spinner",
    circle: "ms-Spinner-circle",
    label: "ms-Spinner-label"
};
var $b943c17b2c863d1f$var$spinAnimation = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function() {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    });
});
var $b943c17b2c863d1f$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme, size = props.size, className = props.className, labelPosition = props.labelPosition;
    var palette = theme.palette;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($b943c17b2c863d1f$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            labelPosition === "top" && {
                flexDirection: "column-reverse"
            },
            labelPosition === "right" && {
                flexDirection: "row"
            },
            labelPosition === "left" && {
                flexDirection: "row-reverse"
            },
            className
        ],
        circle: [
            classNames.circle,
            {
                boxSizing: "border-box",
                borderRadius: "50%",
                border: "1.5px solid " + palette.themeLight,
                borderTopColor: palette.themePrimary,
                animationName: $b943c17b2c863d1f$var$spinAnimation(),
                animationDuration: "1.3s",
                animationIterationCount: "infinite",
                animationTimingFunction: "cubic-bezier(.53,.21,.29,.67)",
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    borderTopColor: "Highlight"
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a)
            },
            size === (0, $671fc9e4e4fd2e99$export$11e6017846e949).xSmall && [
                "ms-Spinner--xSmall",
                {
                    width: 12,
                    height: 12
                }
            ],
            size === (0, $671fc9e4e4fd2e99$export$11e6017846e949).small && [
                "ms-Spinner--small",
                {
                    width: 16,
                    height: 16
                }
            ],
            size === (0, $671fc9e4e4fd2e99$export$11e6017846e949).medium && [
                "ms-Spinner--medium",
                {
                    width: 20,
                    height: 20
                }
            ],
            size === (0, $671fc9e4e4fd2e99$export$11e6017846e949).large && [
                "ms-Spinner--large",
                {
                    width: 28,
                    height: 28
                }
            ]
        ],
        label: [
            classNames.label,
            theme.fonts.small,
            {
                color: palette.themePrimary,
                margin: "8px 0 0",
                textAlign: "center"
            },
            labelPosition === "top" && {
                margin: "0 0 8px"
            },
            labelPosition === "right" && {
                margin: "0 0 0 8px"
            },
            labelPosition === "left" && {
                margin: "0 8px 0 0"
            }
        ],
        screenReaderText: (0, $34563ae103a23d08$export$35835471cbe77db4)
    };
};


var $dfbe92c8a9cbb066$export$7f7cbe89f1eacd2 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $dbc71e4bfcac0ed9$export$8c7b82d9dc8565da), (0, $b943c17b2c863d1f$export$ffd58b7f6f099a57), undefined, {
    scope: "Spinner"
});



var $09eafa8c558b340a$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $09eafa8c558b340a$export$f14cc17007daf53c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GroupHeaderBase, _super);
    function GroupHeaderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._toggleCollapse = function() {
            var _a = _this.props, group = _a.group, onToggleCollapse = _a.onToggleCollapse, isGroupLoading = _a.isGroupLoading;
            var isCollapsed = _this.state.isCollapsed;
            var newCollapsed = !isCollapsed;
            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(group);
            _this.setState({
                isCollapsed: newCollapsed,
                isLoadingVisible: newLoadingVisible
            });
            if (onToggleCollapse) onToggleCollapse(group);
        };
        _this._onKeyUp = function(ev) {
            var _a = _this.props, group = _a.group, onGroupHeaderKeyUp = _a.onGroupHeaderKeyUp;
            if (onGroupHeaderKeyUp) onGroupHeaderKeyUp(ev, group);
            if (!ev.defaultPrevented) {
                // eslint-disable-next-line deprecation/deprecation
                var shouldOpen = _this.state.isCollapsed && ev.which === (0, $723d0744d8fe4fde$export$404175034cd47507)((0, $c011a102064f82ea$export$ec835b702d42f3f0).right, _this.props.theme);
                // eslint-disable-next-line deprecation/deprecation
                var shouldClose = !_this.state.isCollapsed && ev.which === (0, $723d0744d8fe4fde$export$404175034cd47507)((0, $c011a102064f82ea$export$ec835b702d42f3f0).left, _this.props.theme);
                if (shouldClose || shouldOpen) {
                    _this._toggleCollapse();
                    ev.stopPropagation();
                    ev.preventDefault();
                }
            }
        };
        _this._onToggleClick = function(ev) {
            _this._toggleCollapse();
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onHeaderClick = function() {
            var _a = _this.props, group = _a.group, onGroupHeaderClick = _a.onGroupHeaderClick;
            if (onGroupHeaderClick) onGroupHeaderClick(group);
        };
        _this._onRenderTitle = function(props) {
            var group = props.group;
            if (!group) return null;
            var onRenderName = props.onRenderName ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(props.onRenderName, _this._onRenderName) : _this._onRenderName;
            return $acw62.createElement("div", {
                className: _this._classNames.title,
                id: _this._id,
                onClick: _this._onHeaderClick,
                role: "gridcell",
                "aria-colspan": _this.props.ariaColSpan,
                "data-selection-invoke": true
            }, onRenderName(props));
        };
        _this._onRenderName = function(props) {
            var group = props.group;
            if (!group) return null;
            return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("span", null, group.name), $acw62.createElement("span", {
                className: _this._classNames.headerCount
            }, "(", group.count, group.hasMoreData && "+", ")"));
        };
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("GroupHeader");
        _this.state = {
            isCollapsed: _this.props.group && _this.props.group.isCollapsed,
            isLoadingVisible: false
        };
        return _this;
    }
    GroupHeaderBase.getDerivedStateFromProps = function(nextProps, previousState) {
        if (nextProps.group) {
            var newCollapsed = nextProps.group.isCollapsed;
            var isGroupLoading = nextProps.isGroupLoading;
            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(nextProps.group);
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), {
                isCollapsed: newCollapsed || false,
                isLoadingVisible: newLoadingVisible || false
            });
        }
        return previousState;
    };
    GroupHeaderBase.prototype.render = function() {
        var _a = this.props, group = _a.group, _b = _a.groupLevel, groupLevel = _b === void 0 ? 0 : _b, viewport = _a.viewport, selectionMode = _a.selectionMode, loadingText = _a.loadingText, // eslint-disable-next-line deprecation/deprecation
        _c = _a.isSelected, // eslint-disable-next-line deprecation/deprecation
        isSelected = _c === void 0 ? false : _c, _d = _a.selected, selected = _d === void 0 ? false : _d, indentWidth = _a.indentWidth, onRenderGroupHeaderCheckbox = _a.onRenderGroupHeaderCheckbox, _e = _a.isCollapsedGroupSelectVisible, isCollapsedGroupSelectVisible = _e === void 0 ? true : _e, expandButtonProps = _a.expandButtonProps, expandButtonIcon = _a.expandButtonIcon, selectAllButtonProps = _a.selectAllButtonProps, theme = _a.theme, styles = _a.styles, className = _a.className, compact = _a.compact, ariaLevel = _a.ariaLevel, ariaPosInSet = _a.ariaPosInSet, ariaSetSize = _a.ariaSetSize, ariaRowIndex = _a.ariaRowIndex, useFastIcons = _a.useFastIcons;
        var onRenderTitle = this.props.onRenderTitle ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(this.props.onRenderTitle, this._onRenderTitle) : this._onRenderTitle;
        var defaultCheckboxRender = useFastIcons ? this._fastDefaultCheckboxRender : this._defaultCheckboxRender;
        var onRenderCheckbox = onRenderGroupHeaderCheckbox ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(onRenderGroupHeaderCheckbox, defaultCheckboxRender) : defaultCheckboxRender;
        var _f = this.state, isCollapsed = _f.isCollapsed, isLoadingVisible = _f.isLoadingVisible;
        var canSelectGroup = selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple;
        var isSelectionCheckVisible = canSelectGroup && (isCollapsedGroupSelectVisible || !(group && group.isCollapsed));
        var currentlySelected = selected || isSelected;
        var isRTL = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme);
        this._classNames = $09eafa8c558b340a$var$getClassNames(styles, {
            theme: theme,
            className: className,
            selected: currentlySelected,
            isCollapsed: isCollapsed,
            compact: compact
        });
        if (!group) return null;
        return $acw62.createElement("div", {
            className: this._classNames.root,
            style: viewport ? {
                minWidth: viewport.width
            } : {},
            role: "row",
            "aria-level": ariaLevel,
            "aria-setsize": ariaSetSize,
            "aria-posinset": ariaPosInSet,
            "aria-rowindex": ariaRowIndex,
            "data-is-focusable": true,
            onKeyUp: this._onKeyUp,
            "aria-label": group.ariaLabel,
            "aria-labelledby": group.ariaLabel ? undefined : this._id,
            "aria-expanded": !this.state.isCollapsed,
            "aria-selected": canSelectGroup ? currentlySelected : undefined,
            "data-selection-index": group.startIndex,
            "data-selection-span": group.count
        }, $acw62.createElement("div", {
            className: this._classNames.groupHeaderContainer,
            role: "presentation"
        }, isSelectionCheckVisible ? $acw62.createElement("div", {
            role: "gridcell"
        }, $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-is-focusable": false,
            type: "button",
            className: this._classNames.check,
            role: "checkbox",
            id: "".concat(this._id, "-check"),
            "aria-checked": currentlySelected,
            "aria-labelledby": "".concat(this._id, "-check ").concat(this._id),
            "data-selection-toggle": true
        }, selectAllButtonProps), onRenderCheckbox({
            checked: currentlySelected,
            theme: theme
        }, onRenderCheckbox))) : // To make the group header align properly with the column headers, this spacer
        // needs to be the same width as the check cell in the column header.
        selectionMode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).none && $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
            indentWidth: (0, $939930e28b7e2661$export$80b16cf2baff1e7d),
            count: 1
        }), $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
            indentWidth: indentWidth,
            count: groupLevel
        }), $acw62.createElement("div", {
            className: this._classNames.dropIcon,
            role: "presentation"
        }, $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            iconName: "Tag"
        })), $acw62.createElement("div", {
            role: "gridcell"
        }, $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-is-focusable": false,
            "data-selection-disabled": true,
            type: "button",
            className: this._classNames.expand,
            onClick: this._onToggleClick,
            "aria-expanded": !this.state.isCollapsed
        }, expandButtonProps), $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            className: this._classNames.expandIsCollapsed,
            iconName: expandButtonIcon || (isRTL ? "ChevronLeftMed" : "ChevronRightMed")
        }))), onRenderTitle(this.props), isLoadingVisible && $acw62.createElement((0, $dfbe92c8a9cbb066$export$7f7cbe89f1eacd2), {
            label: loadingText
        })));
    };
    GroupHeaderBase.prototype._defaultCheckboxRender = function(checkboxProps) {
        return $acw62.createElement((0, $591e1f0616d591da$export$60bffc6e2a50e7f9), {
            checked: checkboxProps.checked
        });
    };
    GroupHeaderBase.prototype._fastDefaultCheckboxRender = function(checkboxProps) {
        return $acw62.createElement($09eafa8c558b340a$var$FastCheck, {
            theme: checkboxProps.theme,
            checked: checkboxProps.checked
        });
    };
    GroupHeaderBase.defaultProps = {
        expandButtonProps: {
            "aria-label": "expand collapse group"
        }
    };
    return GroupHeaderBase;
}($acw62.Component);
var $09eafa8c558b340a$var$FastCheck = $acw62.memo(function(props) {
    return $acw62.createElement((0, $591e1f0616d591da$export$60bffc6e2a50e7f9), {
        theme: props.theme,
        checked: props.checked,
        className: props.className,
        useFastIcons: true
    });
});


var $8be27e613a0d78d7$export$58d63a2875c58fc8 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $09eafa8c558b340a$export$f14cc17007daf53c), (0, $49811d9a89973977$export$ffd58b7f6f099a57), undefined, {
    scope: "GroupHeader"
});




var $d3be23f745e2ef10$var$GlobalClassNames = {
    root: "ms-GroupShowAll",
    link: "ms-Link"
};
var $d3be23f745e2ef10$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme;
    var fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($d3be23f745e2ef10$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                position: "relative",
                padding: "10px 84px",
                cursor: "pointer",
                selectors: (_a = {}, _a[".".concat(classNames.link)] = {
                    fontSize: fonts.small.fontSize
                }, _a)
            }
        ]
    };
};



var $acw62 = parcelRequire("acw62");



var $c6ef64bc6de2681f$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $c6ef64bc6de2681f$export$f4ac6c6ff0d1dc68 = function(props) {
    var group = props.group, groupLevel = props.groupLevel, _a = props.showAllLinkText, showAllLinkText = _a === void 0 ? "Show All" : _a, styles = props.styles, theme = props.theme, onToggleSummarize = props.onToggleSummarize;
    var classNames = $c6ef64bc6de2681f$var$getClassNames(styles, {
        theme: theme
    });
    var memoizedOnClick = (0, $acw62.useCallback)(function(ev) {
        onToggleSummarize(group);
        ev.stopPropagation();
        ev.preventDefault();
    }, [
        onToggleSummarize,
        group
    ]);
    if (group) return $acw62.createElement("div", {
        className: classNames.root
    }, $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
        count: groupLevel
    }), $acw62.createElement((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), {
        onClick: memoizedOnClick
    }, showAllLinkText));
    return null;
};


var $557fce40b0901437$export$7ac06991e625915c = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $c6ef64bc6de2681f$export$f4ac6c6ff0d1dc68), (0, $d3be23f745e2ef10$export$ffd58b7f6f099a57), undefined, {
    scope: "GroupShowAll"
});




var $32f1948d4e7ed940$var$GlobalClassNames = {
    root: "ms-groupFooter"
};
var $32f1948d4e7ed940$export$ffd58b7f6f099a57 = function(props) {
    var theme = props.theme, className = props.className;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($32f1948d4e7ed940$var$GlobalClassNames, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                position: "relative",
                padding: "5px 38px"
            },
            className
        ]
    };
};



var $acw62 = parcelRequire("acw62");


var $17aec8de7951f681$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $17aec8de7951f681$export$65de4c91de5bc4ac = function(props) {
    var group = props.group, groupLevel = props.groupLevel, footerText = props.footerText, indentWidth = props.indentWidth, styles = props.styles, theme = props.theme;
    var classNames = $17aec8de7951f681$var$getClassNames(styles, {
        theme: theme
    });
    if (group && footerText) return $acw62.createElement("div", {
        className: classNames.root
    }, $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
        indentWidth: indentWidth,
        count: groupLevel
    }), footerText);
    return null;
};


var $435c421c46d618de$export$53886534ee378908 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $17aec8de7951f681$export$65de4c91de5bc4ac), (0, $32f1948d4e7ed940$export$ffd58b7f6f099a57), undefined, {
    scope: "GroupFooter"
});




var $acw62 = parcelRequire("acw62");

/**
 * {@docCategory List}
 */ var $a55c12e2f75e45dc$export$b439352070f9f42 = {
    /**
     * Does not make any consideration to where in the viewport the item should align to.
     */ auto: 0,
    /**
     * Attempts to scroll the list so the top of the desired item is aligned with the top of the viewport.
     */ top: 1,
    /**
     * Attempts to scroll the list so the bottom of the desired item is aligned with the bottom of the viewport.
     */ bottom: 2,
    /**
     * Attempts to scroll the list so the desired item is in the exact center of the viewport.
     */ center: 3
};


var $7f2850cc742e5404$export$9002ed06e448de20 = function(el) {
    if (el === undefined) return 0;
    var scrollHeight = 0;
    if ("scrollHeight" in el) scrollHeight = el.scrollHeight;
    else if ("document" in el) scrollHeight = el.document.documentElement.scrollHeight;
    // No need to round as scrollHeight is already rounded for us.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight
    return scrollHeight;
};
var $7f2850cc742e5404$export$700323197032770f = function(el) {
    if (el === undefined) return 0;
    var scrollPos = 0;
    if ("scrollTop" in el) scrollPos = el.scrollTop;
    else if ("scrollY" in el) scrollPos = el.scrollY;
    // Round this value to an integer as it may be fractional.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTop
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
    return Math.ceil(scrollPos);
};
var $7f2850cc742e5404$export$651f513956c21aeb = function(el, pos) {
    if ("scrollTop" in el) el.scrollTop = pos;
    else if ("scrollY" in el) el.scrollTo(el.scrollX, pos);
};


var $eba311a0e1ed503e$var$RESIZE_DELAY = 16;
var $eba311a0e1ed503e$var$MIN_SCROLL_UPDATE_DELAY = 100;
var $eba311a0e1ed503e$var$MAX_SCROLL_UPDATE_DELAY = 500;
var $eba311a0e1ed503e$var$IDLE_DEBOUNCE_DELAY = 200;
// The amount of time to wait before declaring that the list isn't scrolling
var $eba311a0e1ed503e$var$DONE_SCROLLING_WAIT = 500;
var $eba311a0e1ed503e$var$DEFAULT_ITEMS_PER_PAGE = 10;
var $eba311a0e1ed503e$var$DEFAULT_PAGE_HEIGHT = 30;
var $eba311a0e1ed503e$var$DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var $eba311a0e1ed503e$var$DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var $eba311a0e1ed503e$var$PAGE_KEY_PREFIX = "page-";
var $eba311a0e1ed503e$var$SPACER_KEY_PREFIX = "spacer-";
var $eba311a0e1ed503e$var$EMPTY_RECT = {
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    width: 0,
    height: 0
};
// Naming expensive measures so that they're named in profiles.
var $eba311a0e1ed503e$var$_measurePageRect = function(element) {
    return element.getBoundingClientRect();
};
var $eba311a0e1ed503e$var$_measureSurfaceRect = $eba311a0e1ed503e$var$_measurePageRect;
var $eba311a0e1ed503e$var$_measureScrollRect = $eba311a0e1ed503e$var$_measurePageRect;
/**
 * The List renders virtualized pages of items. Each page's item count is determined by the getItemCountForPage callback
 * if provided by the caller, or 10 as default. Each page's height is determined by the getPageHeight callback if
 * provided by the caller, or by cached measurements if available, or by a running average, or a default fallback.
 *
 * The algorithm for rendering pages works like this:
 *
 * 1. Predict visible pages based on "current measure data" (page heights, surface position, visible window)
 * 2. If changes are necessary, apply changes (add/remove pages)
 * 3. For pages that are added, measure the page heights if we need to using getBoundingClientRect
 * 4. If measurements don't match predictions, update measure data and goto step 1 asynchronously
 *
 * Measuring too frequently can pull performance down significantly. To compensate, we cache measured values so that
 * we can avoid re-measuring during operations that should not alter heights, like scrolling.
 *
 * To optimize glass rendering performance, onShouldVirtualize can be set. When onShouldVirtualize return false,
 * List will run in fast mode (not virtualized) to render all items without any measurements to improve page load time.
 * And we start doing measurements and rendering in virtualized mode when items grows larger than this threshold.
 *
 * However, certain operations can make measure data stale. For example, resizing the list, or passing in new props,
 * or forcing an update change cause pages to shrink/grow. When these operations occur, we increment a measureVersion
 * number, which we associate with cached measurements and use to determine if a remeasure should occur.
 */ var $eba311a0e1ed503e$export$54c2e3dc7acea9f5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._surface = $acw62.createRef();
        _this._pageRefs = {};
        _this._getDerivedStateFromProps = function(nextProps, previousState) {
            if (nextProps.items !== _this.props.items || nextProps.renderCount !== _this.props.renderCount || nextProps.startIndex !== _this.props.startIndex || nextProps.version !== _this.props.version || !previousState.hasMounted && _this.props.renderEarly && (0, $18aa0efffa2a3752$export$71594e8a50f746f4)()) {
                // We have received new items so we want to make sure that initially we only render a single window to
                // fill the currently visible rect, and then later render additional windows.
                _this._resetRequiredWindows();
                _this._requiredRect = null;
                _this._measureVersion++;
                _this._invalidatePageCache();
                return _this._updatePages(nextProps, previousState);
            }
            return previousState;
        };
        _this._onRenderRoot = function(props) {
            var rootRef = props.rootRef, surfaceElement = props.surfaceElement, divProps = props.divProps;
            return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: rootRef
            }, divProps), surfaceElement);
        };
        _this._onRenderSurface = function(props) {
            var surfaceRef = props.surfaceRef, pageElements = props.pageElements, divProps = props.divProps;
            return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: surfaceRef
            }, divProps), pageElements);
        };
        _this._onRenderPage = function(pageProps, defaultRender) {
            var _a;
            var _b = _this.props, onRenderCell = _b.onRenderCell, onRenderCellConditional = _b.onRenderCellConditional, role = _b.role;
            var _c = pageProps.page, _d = _c.items, items = _d === void 0 ? [] : _d, startIndex = _c.startIndex, divProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(pageProps, [
                "page"
            ]);
            // only assign list item role if no role is assigned
            var cellRole = role === undefined ? "listitem" : "presentation";
            var cells = [];
            for(var i = 0; i < items.length; i++){
                var index = startIndex + i;
                var item = items[i];
                var itemKey = _this.props.getKey ? _this.props.getKey(item, index) : item && item.key;
                if (itemKey === null || itemKey === undefined) itemKey = index;
                var renderCell = onRenderCellConditional !== null && onRenderCellConditional !== void 0 ? onRenderCellConditional : onRenderCell;
                var cell = (_a = renderCell === null || renderCell === void 0 ? void 0 : renderCell(item, index, !_this.props.ignoreScrollingState ? _this.state.isScrolling : undefined)) !== null && _a !== void 0 ? _a : null;
                if (!onRenderCellConditional || cell) cells.push($acw62.createElement("div", {
                    role: cellRole,
                    className: "ms-List-cell",
                    key: itemKey,
                    "data-list-index": index,
                    "data-automationid": "ListCell"
                }, cell));
            }
            return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps), cells);
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this.state = {
            pages: [],
            isScrolling: false,
            getDerivedStateFromProps: _this._getDerivedStateFromProps,
            hasMounted: false
        };
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this._estimatedPageHeight = 0;
        _this._totalEstimates = 0;
        _this._requiredWindowsAhead = 0;
        _this._requiredWindowsBehind = 0;
        // Track the measure version for everything.
        _this._measureVersion = 0;
        // Ensure that scrolls are lazy updated.
        _this._onAsyncScroll = _this._async.debounce(_this._onAsyncScroll, $eba311a0e1ed503e$var$MIN_SCROLL_UPDATE_DELAY, {
            leading: false,
            maxWait: $eba311a0e1ed503e$var$MAX_SCROLL_UPDATE_DELAY
        });
        _this._onAsyncIdle = _this._async.debounce(_this._onAsyncIdle, $eba311a0e1ed503e$var$IDLE_DEBOUNCE_DELAY, {
            leading: false
        });
        _this._onAsyncResize = _this._async.debounce(_this._onAsyncResize, $eba311a0e1ed503e$var$RESIZE_DELAY, {
            leading: false
        });
        _this._onScrollingDone = _this._async.debounce(_this._onScrollingDone, $eba311a0e1ed503e$var$DONE_SCROLLING_WAIT, {
            leading: false
        });
        _this._cachedPageHeights = {};
        _this._estimatedPageHeight = 0;
        _this._focusedIndex = -1;
        _this._pageCache = {};
        return _this;
    }
    List.getDerivedStateFromProps = function(nextProps, previousState) {
        return previousState.getDerivedStateFromProps(nextProps, previousState);
    };
    Object.defineProperty(List.prototype, "pageRefs", {
        get: function() {
            return this._pageRefs;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Scroll to the given index. By default will bring the page the specified item is on into the view. If a callback
     * to measure the height of an individual item is specified, will only scroll to bring the specific item into view.
     *
     * Note: with items of variable height and no passed in `getPageHeight` method, the list might jump after scrolling
     * when windows before/ahead are being rendered, and the estimated height is replaced using actual elements.
     *
     * @param index - Index of item to scroll to
     * @param measureItem - Optional callback to measure the height of an individual item
     * @param scrollToMode - Optional defines where in the window the item should be positioned to when scrolling
     */ List.prototype.scrollToIndex = function(index, measureItem, scrollToMode) {
        if (scrollToMode === void 0) scrollToMode = (0, $a55c12e2f75e45dc$export$b439352070f9f42).auto;
        var startIndex = this.props.startIndex;
        var renderCount = this._getRenderCount();
        var endIndex = startIndex + renderCount;
        var allowedRect = this._allowedRect;
        var scrollTop = 0;
        var itemsPerPage = 1;
        for(var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage){
            var pageSpecification = this._getPageSpecification(this.props, itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            itemsPerPage = pageSpecification.itemCount;
            var requestedIndexIsInPage = itemIndex <= index && itemIndex + itemsPerPage > index;
            if (requestedIndexIsInPage) {
                // We have found the page. If the user provided a way to measure an individual item, we will try to scroll in
                // just the given item, otherwise we'll only bring the page into view
                if (measureItem && this._scrollElement) {
                    var scrollRect = $eba311a0e1ed503e$var$_measureScrollRect(this._scrollElement);
                    var scrollPosition = (0, $7f2850cc742e5404$export$700323197032770f)(this._scrollElement);
                    var scrollWindow = {
                        top: scrollPosition,
                        bottom: scrollPosition + scrollRect.height
                    };
                    // Adjust for actual item position within page
                    var itemPositionWithinPage = index - itemIndex;
                    for(var itemIndexInPage = 0; itemIndexInPage < itemPositionWithinPage; ++itemIndexInPage)scrollTop += measureItem(itemIndex + itemIndexInPage);
                    var scrollBottom = scrollTop + measureItem(index);
                    // If scrollToMode is set to something other than auto, we always want to
                    // scroll the item into a specific position on the page.
                    switch(scrollToMode){
                        case (0, $a55c12e2f75e45dc$export$b439352070f9f42).top:
                            (0, $7f2850cc742e5404$export$651f513956c21aeb)(this._scrollElement, scrollTop);
                            return;
                        case (0, $a55c12e2f75e45dc$export$b439352070f9f42).bottom:
                            (0, $7f2850cc742e5404$export$651f513956c21aeb)(this._scrollElement, scrollBottom - scrollRect.height);
                            return;
                        case (0, $a55c12e2f75e45dc$export$b439352070f9f42).center:
                            (0, $7f2850cc742e5404$export$651f513956c21aeb)(this._scrollElement, (scrollTop + scrollBottom - scrollRect.height) / 2);
                            return;
                        case (0, $a55c12e2f75e45dc$export$b439352070f9f42).auto:
                        default:
                            break;
                    }
                    var itemIsFullyVisible = scrollTop >= scrollWindow.top && scrollBottom <= scrollWindow.bottom;
                    if (itemIsFullyVisible) // Item is already visible, do nothing.
                    return;
                    var itemIsPartiallyAbove = scrollTop < scrollWindow.top;
                    var itemIsPartiallyBelow = scrollBottom > scrollWindow.bottom;
                    if (itemIsPartiallyAbove) ;
                    else if (itemIsPartiallyBelow) //  Adjust scrollTop position to just bring in the element
                    // .------.  - scrollTop
                    // |      |
                    // | .------.
                    // '-|----' | - scrollWindow.bottom
                    //   | Item |
                    //   '------' - scrollBottom
                    scrollTop = scrollBottom - scrollRect.height;
                }
                if (this._scrollElement) (0, $7f2850cc742e5404$export$651f513956c21aeb)(this._scrollElement, scrollTop);
                return;
            }
            scrollTop += pageHeight;
        }
    };
    List.prototype.getStartItemIndexInView = function(measureItem) {
        var pages = this.state.pages || [];
        for(var _i = 0, pages_1 = pages; _i < pages_1.length; _i++){
            var page = pages_1[_i];
            var isPageVisible = !page.isSpacer && (this._scrollTop || 0) >= page.top && (this._scrollTop || 0) <= page.top + page.height;
            if (isPageVisible) {
                if (!measureItem) {
                    var rowHeight = Math.floor(page.height / page.itemCount);
                    return page.startIndex + Math.floor((this._scrollTop - page.top) / rowHeight);
                } else {
                    var totalRowHeight = 0;
                    for(var itemIndex = page.startIndex; itemIndex < page.startIndex + page.itemCount; itemIndex++){
                        var rowHeight = measureItem(itemIndex);
                        if (page.top + totalRowHeight <= this._scrollTop && this._scrollTop < page.top + totalRowHeight + rowHeight) return itemIndex;
                        else totalRowHeight += rowHeight;
                    }
                }
            }
        }
        return 0;
    };
    List.prototype.componentDidMount = function() {
        this._scrollElement = (0, $11f97b2a9a127629$export$494fa69500a5872a)(this._root.current);
        this._scrollTop = 0;
        this.setState((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this._updatePages(this.props, this.state)), {
            hasMounted: true
        }));
        this._measureVersion++;
        this._events.on(window, "resize", this._onAsyncResize);
        if (this._root.current) this._events.on(this._root.current, "focus", this._onFocus, true);
        if (this._scrollElement) {
            this._events.on(this._scrollElement, "scroll", this._onScroll);
            this._events.on(this._scrollElement, "scroll", this._onAsyncScroll);
        }
    };
    List.prototype.componentDidUpdate = function(previousProps, previousState) {
        // Multiple updates may have been queued, so the callback will reflect all of them.
        // Re-fetch the current props and states to avoid using a stale props or state captured in the closure.
        var finalProps = this.props;
        var finalState = this.state;
        if (this.state.pagesVersion !== previousState.pagesVersion) {
            // If we weren't provided with the page height, measure the pages
            if (!finalProps.getPageHeight) {
                // If measured version is invalid since we've updated the DOM
                var heightsChanged = this._updatePageMeasurements(finalState.pages);
                // On first render, we should re-measure so that we don't get a visual glitch.
                if (heightsChanged) {
                    this._materializedRect = null;
                    if (!this._hasCompletedFirstRender) {
                        this._hasCompletedFirstRender = true;
                        this.setState(this._updatePages(finalProps, finalState));
                    } else this._onAsyncScroll();
                } else // Enqueue an idle bump.
                this._onAsyncIdle();
            } else // Enqueue an idle bump
            this._onAsyncIdle();
            // Notify the caller that rendering the new pages has completed
            if (finalProps.onPagesUpdated) finalProps.onPagesUpdated(finalState.pages);
        }
    };
    List.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
        delete this._scrollElement;
    };
    List.prototype.shouldComponentUpdate = function(newProps, newState) {
        var oldPages = this.state.pages;
        var newPages = newState.pages;
        var shouldComponentUpdate = false;
        // Update if the page stops scrolling
        if (!newState.isScrolling && this.state.isScrolling) return true;
        if (newProps.version !== this.props.version) return true;
        if (newProps.className !== this.props.className) return true;
        if (newProps.items === this.props.items && oldPages.length === newPages.length) for(var i = 0; i < oldPages.length; i++){
            var oldPage = oldPages[i];
            var newPage = newPages[i];
            if (oldPage.key !== newPage.key || oldPage.itemCount !== newPage.itemCount) {
                shouldComponentUpdate = true;
                break;
            }
        }
        else shouldComponentUpdate = true;
        return shouldComponentUpdate;
    };
    List.prototype.forceUpdate = function() {
        this._invalidatePageCache();
        // Ensure that when the list is force updated we update the pages first before render.
        this._updateRenderRects(this.props, this.state, true);
        this.setState(this._updatePages(this.props, this.state));
        this._measureVersion++;
        _super.prototype.forceUpdate.call(this);
    };
    /**
     * Get the current height the list and it's pages.
     */ List.prototype.getTotalListHeight = function() {
        return this._surfaceRect.height;
    };
    List.prototype.render = function() {
        var _a = this.props, className = _a.className, _b = _a.role, role = _b === void 0 ? "list" : _b, onRenderSurface = _a.onRenderSurface, onRenderRoot = _a.onRenderRoot;
        var _c = this.state.pages, pages = _c === void 0 ? [] : _c;
        var pageElements = [];
        var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        for(var _i = 0, pages_2 = pages; _i < pages_2.length; _i++){
            var page = pages_2[_i];
            pageElements.push(this._renderPage(page));
        }
        var finalOnRenderSurface = onRenderSurface ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(onRenderSurface, this._onRenderSurface) : this._onRenderSurface;
        var finalOnRenderRoot = onRenderRoot ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(onRenderRoot, this._onRenderRoot) : this._onRenderRoot;
        return finalOnRenderRoot({
            rootRef: this._root,
            pages: pages,
            surfaceElement: finalOnRenderSurface({
                surfaceRef: this._surface,
                pages: pages,
                pageElements: pageElements,
                divProps: {
                    role: "presentation",
                    className: "ms-List-surface"
                }
            }),
            divProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps), {
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-List", className),
                role: pageElements.length > 0 ? role : undefined,
                "aria-label": pageElements.length > 0 ? divProps["aria-label"] : undefined
            })
        });
    };
    List.prototype._shouldVirtualize = function(props) {
        if (props === void 0) props = this.props;
        var onShouldVirtualize = props.onShouldVirtualize;
        return !onShouldVirtualize || onShouldVirtualize(props);
    };
    /**
     * when props.items change or forceUpdate called, throw away cached pages
     */ List.prototype._invalidatePageCache = function() {
        this._pageCache = {};
    };
    List.prototype._renderPage = function(page) {
        var _this = this;
        var usePageCache = this.props.usePageCache;
        var cachedPage;
        // if usePageCache is set and cached page element can be found, just return cached page
        if (usePageCache) {
            cachedPage = this._pageCache[page.key];
            if (cachedPage && cachedPage.pageElement) return cachedPage.pageElement;
        }
        var pageStyle = this._getPageStyle(page);
        var _a = this.props.onRenderPage, onRenderPage = _a === void 0 ? this._onRenderPage : _a;
        var pageElement = onRenderPage({
            page: page,
            className: "ms-List-page",
            key: page.key,
            ref: function(newRef) {
                _this._pageRefs[page.key] = newRef;
            },
            style: pageStyle,
            role: "presentation"
        }, this._onRenderPage);
        // cache the first page for now since it is re-rendered a lot times unnecessarily.
        // todo: a more aggresive caching mechanism is to cache pages constaining the items not changed.
        // now we re-render pages too frequently, for example, props.items increased from 30 to 60, although the
        // first 30 items did not change, we still re-rendered all of them in this props.items change.
        if (usePageCache && page.startIndex === 0) this._pageCache[page.key] = {
            page: page,
            pageElement: pageElement
        };
        return pageElement;
    };
    /** Generate the style object for the page. */ List.prototype._getPageStyle = function(page) {
        var getPageStyle = this.props.getPageStyle;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, getPageStyle ? getPageStyle(page) : {}), !page.items ? {
            height: page.height
        } : {});
    };
    /** Track the last item index focused so that we ensure we keep it rendered. */ List.prototype._onFocus = function(ev) {
        var target = ev.target;
        while(target !== this._surface.current){
            var indexString = target.getAttribute("data-list-index");
            if (indexString) {
                this._focusedIndex = Number(indexString);
                break;
            }
            target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
        }
    };
    /**
     * Called synchronously to reset the required render range to 0 on scrolling. After async scroll has executed,
     * we will call onAsyncIdle which will reset it back to it's correct value.
     */ List.prototype._onScroll = function() {
        if (!this.state.isScrolling && !this.props.ignoreScrollingState) this.setState({
            isScrolling: true
        });
        this._resetRequiredWindows();
        this._onScrollingDone();
    };
    List.prototype._resetRequiredWindows = function() {
        this._requiredWindowsAhead = 0;
        this._requiredWindowsBehind = 0;
    };
    /**
     * Debounced method to asynchronously update the visible region on a scroll event.
     */ List.prototype._onAsyncScroll = function() {
        this._updateRenderRects(this.props, this.state);
        // Only update pages when the visible rect falls outside of the materialized rect.
        if (!this._materializedRect || !$eba311a0e1ed503e$var$_isContainedWithin(this._requiredRect, this._materializedRect)) this.setState(this._updatePages(this.props, this.state));
    };
    /**
     * This is an async debounced method that will try and increment the windows we render. If we can increment
     * either, we increase the amount we render and re-evaluate.
     */ List.prototype._onAsyncIdle = function() {
        var _a = this.props, renderedWindowsAhead = _a.renderedWindowsAhead, renderedWindowsBehind = _a.renderedWindowsBehind;
        var _b = this, requiredWindowsAhead = _b._requiredWindowsAhead, requiredWindowsBehind = _b._requiredWindowsBehind;
        var windowsAhead = Math.min(renderedWindowsAhead, requiredWindowsAhead + 1);
        var windowsBehind = Math.min(renderedWindowsBehind, requiredWindowsBehind + 1);
        if (windowsAhead !== requiredWindowsAhead || windowsBehind !== requiredWindowsBehind) {
            // console.log('idling', windowsBehind, windowsAhead);
            this._requiredWindowsAhead = windowsAhead;
            this._requiredWindowsBehind = windowsBehind;
            this._updateRenderRects(this.props, this.state);
            this.setState(this._updatePages(this.props, this.state));
        }
        if (renderedWindowsAhead > windowsAhead || renderedWindowsBehind > windowsBehind) // Async increment on next tick.
        this._onAsyncIdle();
    };
    /**
     * Function to call when the list is done scrolling.
     * This function is debounced.
     */ List.prototype._onScrollingDone = function() {
        if (!this.props.ignoreScrollingState) this.setState({
            isScrolling: false
        });
    };
    List.prototype._onAsyncResize = function() {
        this.forceUpdate();
    };
    List.prototype._updatePages = function(nextProps, previousState) {
        // console.log('updating pages');
        if (!this._requiredRect) this._updateRenderRects(nextProps, previousState);
        var newListState = this._buildPages(nextProps, previousState);
        var oldListPages = previousState.pages;
        this._notifyPageChanges(oldListPages, newListState.pages, this.props);
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), newListState), {
            pagesVersion: {}
        });
    };
    /**
     * Notify consumers that the rendered pages have changed
     * @param oldPages - The old pages
     * @param newPages - The new pages
     * @param props - The props to use
     */ List.prototype._notifyPageChanges = function(oldPages, newPages, props) {
        var onPageAdded = props.onPageAdded, onPageRemoved = props.onPageRemoved;
        if (onPageAdded || onPageRemoved) {
            var renderedIndexes = {};
            for(var _i = 0, oldPages_1 = oldPages; _i < oldPages_1.length; _i++){
                var page = oldPages_1[_i];
                if (page.items) renderedIndexes[page.startIndex] = page;
            }
            for(var _a = 0, newPages_1 = newPages; _a < newPages_1.length; _a++){
                var page = newPages_1[_a];
                if (page.items) {
                    if (!renderedIndexes[page.startIndex]) this._onPageAdded(page);
                    else delete renderedIndexes[page.startIndex];
                }
            }
            for(var index in renderedIndexes)if (renderedIndexes.hasOwnProperty(index)) this._onPageRemoved(renderedIndexes[index]);
        }
    };
    List.prototype._updatePageMeasurements = function(pages) {
        var heightChanged = false;
        // when not in virtualize mode, we render all the items without page measurement
        if (!this._shouldVirtualize()) return heightChanged;
        for(var i = 0; i < pages.length; i++){
            var page = pages[i];
            if (page.items) heightChanged = this._measurePage(page) || heightChanged;
        }
        return heightChanged;
    };
    /**
     * Given a page, measure its dimensions, update cache.
     * @returns True if the height has changed.
     */ List.prototype._measurePage = function(page) {
        var hasChangedHeight = false;
        var pageElement = this._pageRefs[page.key];
        var cachedHeight = this._cachedPageHeights[page.startIndex];
        // console.log('   * measure attempt', page.startIndex, cachedHeight);
        if (pageElement && this._shouldVirtualize() && (!cachedHeight || cachedHeight.measureVersion !== this._measureVersion)) {
            var newClientRect = {
                width: pageElement.clientWidth,
                height: pageElement.clientHeight
            };
            if (newClientRect.height || newClientRect.width) {
                hasChangedHeight = page.height !== newClientRect.height;
                // console.warn(' *** expensive page measure', page.startIndex, page.height, newClientRect.height);
                page.height = newClientRect.height;
                this._cachedPageHeights[page.startIndex] = {
                    height: newClientRect.height,
                    measureVersion: this._measureVersion
                };
                this._estimatedPageHeight = Math.round((this._estimatedPageHeight * this._totalEstimates + newClientRect.height) / (this._totalEstimates + 1));
                this._totalEstimates++;
            }
        }
        return hasChangedHeight;
    };
    /** Called when a page has been added to the DOM. */ List.prototype._onPageAdded = function(page) {
        var onPageAdded = this.props.onPageAdded;
        // console.log('page added', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageAdded) onPageAdded(page);
    };
    /** Called when a page has been removed from the DOM. */ List.prototype._onPageRemoved = function(page) {
        var onPageRemoved = this.props.onPageRemoved;
        // console.log('  --- page removed', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageRemoved) onPageRemoved(page);
    };
    /** Build up the pages that should be rendered. */ List.prototype._buildPages = function(props, state) {
        var renderCount = props.renderCount;
        var items = props.items, startIndex = props.startIndex, getPageHeight = props.getPageHeight;
        renderCount = this._getRenderCount(props);
        var materializedRect = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $eba311a0e1ed503e$var$EMPTY_RECT);
        var pages = [];
        var itemsPerPage = 1;
        var pageTop = 0;
        var currentSpacer = null;
        var focusedIndex = this._focusedIndex;
        var endIndex = startIndex + renderCount;
        var shouldVirtualize = this._shouldVirtualize(props);
        // First render is very important to track; when we render cells, we have no idea of estimated page height.
        // So we should default to rendering only the first page so that we can get information.
        // However if the user provides a measure function, let's just assume they know the right heights.
        var isFirstRender = this._estimatedPageHeight === 0 && !getPageHeight;
        var allowedRect = this._allowedRect;
        var _loop_1 = function(itemIndex) {
            var pageSpecification = this_1._getPageSpecification(props, itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            var pageData = pageSpecification.data;
            var key = pageSpecification.key;
            itemsPerPage = pageSpecification.itemCount;
            var pageBottom = pageTop + pageHeight - 1;
            var isPageRendered = (0, $b9105dc723fd02ea$export$de3a4d4a0d731119)(state.pages, function(page) {
                return !!page.items && page.startIndex === itemIndex;
            }) > -1;
            var isPageInAllowedRange = !allowedRect || pageBottom >= allowedRect.top && pageTop <= allowedRect.bottom;
            var isPageInRequiredRange = !this_1._requiredRect || pageBottom >= this_1._requiredRect.top && pageTop <= this_1._requiredRect.bottom;
            var isPageVisible = !isFirstRender && (isPageInRequiredRange || isPageInAllowedRange && isPageRendered) || !shouldVirtualize;
            var isPageFocused = focusedIndex >= itemIndex && focusedIndex < itemIndex + itemsPerPage;
            var isFirstPage = itemIndex === startIndex;
            // console.log('building page', itemIndex, 'pageTop: ' + pageTop, 'inAllowed: ' +
            // isPageInAllowedRange, 'inRequired: ' + isPageInRequiredRange);
            // Only render whats visible, focused, or first page,
            // or when running in fast rendering mode (not in virtualized mode), we render all current items in pages
            if (isPageVisible || isPageFocused || isFirstPage) {
                if (currentSpacer) {
                    pages.push(currentSpacer);
                    currentSpacer = null;
                }
                var itemsInPage = Math.min(itemsPerPage, endIndex - itemIndex);
                var newPage = this_1._createPage(key, items.slice(itemIndex, itemIndex + itemsInPage), itemIndex, undefined, undefined, pageData);
                newPage.top = pageTop;
                newPage.height = pageHeight;
                if (this_1._visibleRect && this_1._visibleRect.bottom) newPage.isVisible = pageBottom >= this_1._visibleRect.top && pageTop <= this_1._visibleRect.bottom;
                pages.push(newPage);
                if (isPageInRequiredRange && this_1._allowedRect) $eba311a0e1ed503e$var$_mergeRect(materializedRect, {
                    top: pageTop,
                    bottom: pageBottom,
                    height: pageHeight,
                    left: allowedRect.left,
                    right: allowedRect.right,
                    width: allowedRect.width
                });
            } else {
                if (!currentSpacer) currentSpacer = this_1._createPage($eba311a0e1ed503e$var$SPACER_KEY_PREFIX + itemIndex, undefined, itemIndex, 0, undefined, pageData, true);
                currentSpacer.height = (currentSpacer.height || 0) + (pageBottom - pageTop) + 1;
                currentSpacer.itemCount += itemsPerPage;
            }
            pageTop += pageBottom - pageTop + 1;
            // in virtualized mode, we render need to render first page then break and measure,
            // otherwise, we render all items without measurement to make rendering fast
            if (isFirstRender && shouldVirtualize) return "break";
        };
        var this_1 = this;
        for(var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage){
            var state_1 = _loop_1(itemIndex);
            if (state_1 === "break") break;
        }
        if (currentSpacer) {
            currentSpacer.key = $eba311a0e1ed503e$var$SPACER_KEY_PREFIX + "end";
            pages.push(currentSpacer);
        }
        this._materializedRect = materializedRect;
        // console.log('materialized: ', materializedRect);
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, state), {
            pages: pages,
            measureVersion: this._measureVersion
        });
    };
    List.prototype._getPageSpecification = function(props, itemIndex, visibleRect) {
        var getPageSpecification = props.getPageSpecification;
        if (getPageSpecification) {
            var pageData = getPageSpecification(itemIndex, visibleRect);
            var _a = pageData.itemCount, itemCount = _a === void 0 ? this._getItemCountForPage(itemIndex, visibleRect) : _a;
            var _b = pageData.height, height = _b === void 0 ? this._getPageHeight(itemIndex, visibleRect, itemCount) : _b;
            return {
                itemCount: itemCount,
                height: height,
                data: pageData.data,
                key: pageData.key
            };
        } else {
            var itemCount = this._getItemCountForPage(itemIndex, visibleRect);
            return {
                itemCount: itemCount,
                height: this._getPageHeight(itemIndex, visibleRect, itemCount)
            };
        }
    };
    /**
     * Get the pixel height of a give page. Will use the props getPageHeight first, and if not provided, fallback to
     * cached height, or estimated page height, or default page height.
     */ List.prototype._getPageHeight = function(itemIndex, visibleRect, itemsPerPage) {
        if (this.props.getPageHeight) return this.props.getPageHeight(itemIndex, visibleRect, itemsPerPage);
        else {
            var cachedHeight = this._cachedPageHeights[itemIndex];
            return cachedHeight ? cachedHeight.height : this._estimatedPageHeight || $eba311a0e1ed503e$var$DEFAULT_PAGE_HEIGHT;
        }
    };
    List.prototype._getItemCountForPage = function(itemIndex, visibileRect) {
        var itemsPerPage = this.props.getItemCountForPage ? this.props.getItemCountForPage(itemIndex, visibileRect) : $eba311a0e1ed503e$var$DEFAULT_ITEMS_PER_PAGE;
        return itemsPerPage ? itemsPerPage : $eba311a0e1ed503e$var$DEFAULT_ITEMS_PER_PAGE;
    };
    List.prototype._createPage = function(pageKey, items, startIndex, count, style, data, isSpacer) {
        if (startIndex === void 0) startIndex = -1;
        if (count === void 0) count = items ? items.length : 0;
        if (style === void 0) style = {};
        pageKey = pageKey || $eba311a0e1ed503e$var$PAGE_KEY_PREFIX + startIndex;
        var cachedPage = this._pageCache[pageKey];
        if (cachedPage && cachedPage.page) return cachedPage.page;
        return {
            key: pageKey,
            startIndex: startIndex,
            itemCount: count,
            items: items,
            style: style,
            top: 0,
            height: 0,
            data: data,
            isSpacer: isSpacer || false
        };
    };
    List.prototype._getRenderCount = function(props) {
        var _a = props || this.props, items = _a.items, startIndex = _a.startIndex, renderCount = _a.renderCount;
        return renderCount === undefined ? items ? items.length - startIndex : 0 : renderCount;
    };
    /** Calculate the visible rect within the list where top: 0 and left: 0 is the top/left of the list. */ List.prototype._updateRenderRects = function(props, state, forceUpdate) {
        var renderedWindowsAhead = props.renderedWindowsAhead, renderedWindowsBehind = props.renderedWindowsBehind;
        var pages = state.pages;
        // when not in virtualize mode, we render all items without measurement to optimize page rendering perf
        if (!this._shouldVirtualize(props)) return;
        var surfaceRect = this._surfaceRect || (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $eba311a0e1ed503e$var$EMPTY_RECT);
        var scrollHeight = (0, $7f2850cc742e5404$export$9002ed06e448de20)(this._scrollElement);
        var scrollTop = (0, $7f2850cc742e5404$export$700323197032770f)(this._scrollElement);
        // WARNING: EXPENSIVE CALL! We need to know the surface top relative to the window.
        // This needs to be called to recalculate when new pages should be loaded.
        // We check to see how far we've scrolled and if it's further than a third of a page we run it again.
        if (this._surface.current && (forceUpdate || !pages || !this._surfaceRect || !scrollHeight || scrollHeight !== this._scrollHeight || Math.abs(this._scrollTop - scrollTop) > this._estimatedPageHeight / 3)) {
            surfaceRect = this._surfaceRect = $eba311a0e1ed503e$var$_measureSurfaceRect(this._surface.current);
            this._scrollTop = scrollTop;
        }
        // If the scroll height has changed, something in the container likely resized and
        // we should redo the page heights incase their content resized.
        if (forceUpdate || !scrollHeight || scrollHeight !== this._scrollHeight) this._measureVersion++;
        this._scrollHeight = scrollHeight || 0;
        // If the surface is above the container top or below the container bottom, or if this is not the first
        // render return empty rect.
        // The first time the list gets rendered we need to calculate the rectangle. The width of the list is
        // used to calculate the width of the list items.
        var visibleTop = Math.max(0, -surfaceRect.top);
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(this._root.current);
        var visibleRect = {
            top: visibleTop,
            left: surfaceRect.left,
            bottom: visibleTop + win.innerHeight,
            right: surfaceRect.right,
            width: surfaceRect.width,
            height: win.innerHeight
        };
        // The required/allowed rects are adjusted versions of the visible rect.
        this._requiredRect = $eba311a0e1ed503e$var$_expandRect(visibleRect, this._requiredWindowsBehind, this._requiredWindowsAhead);
        this._allowedRect = $eba311a0e1ed503e$var$_expandRect(visibleRect, renderedWindowsBehind, renderedWindowsAhead);
        // store the visible rect for later use.
        this._visibleRect = visibleRect;
    };
    List.defaultProps = {
        startIndex: 0,
        onRenderCell: function(item, index, containsFocus) {
            return $acw62.createElement($acw62.Fragment, null, item && item.name || "");
        },
        onRenderCellConditional: undefined,
        renderedWindowsAhead: $eba311a0e1ed503e$var$DEFAULT_RENDERED_WINDOWS_AHEAD,
        renderedWindowsBehind: $eba311a0e1ed503e$var$DEFAULT_RENDERED_WINDOWS_BEHIND
    };
    return List;
}($acw62.Component);
function $eba311a0e1ed503e$var$_expandRect(rect, pagesBefore, pagesAfter) {
    var top = rect.top - pagesBefore * rect.height;
    var height = rect.height + (pagesBefore + pagesAfter) * rect.height;
    return {
        top: top,
        bottom: top + height,
        height: height,
        left: rect.left,
        right: rect.right,
        width: rect.width
    };
}
function $eba311a0e1ed503e$var$_isContainedWithin(innerRect, outerRect) {
    return innerRect.top >= outerRect.top && innerRect.left >= outerRect.left && innerRect.bottom <= outerRect.bottom && innerRect.right <= outerRect.right;
}
function $eba311a0e1ed503e$var$_mergeRect(targetRect, newRect) {
    targetRect.top = newRect.top < targetRect.top || targetRect.top === -1 ? newRect.top : targetRect.top;
    targetRect.left = newRect.left < targetRect.left || targetRect.left === -1 ? newRect.left : targetRect.left;
    targetRect.bottom = newRect.bottom > targetRect.bottom || targetRect.bottom === -1 ? newRect.bottom : targetRect.bottom;
    targetRect.right = newRect.right > targetRect.right || targetRect.right === -1 ? newRect.right : targetRect.right;
    targetRect.width = targetRect.right - targetRect.left + 1;
    targetRect.height = targetRect.bottom - targetRect.top + 1;
    return targetRect;
}


var $501d9aa0f23f669c$var$DEFAULT_DROPPING_CSS_CLASS = "is-dropping";
var $501d9aa0f23f669c$export$a11203b926b3bcf9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GroupedListSection, _super);
    function GroupedListSection(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._list = $acw62.createRef();
        _this._subGroupRefs = {};
        _this._droppingClassName = "";
        _this._onRenderGroupHeader = function(props) {
            return $acw62.createElement((0, $8be27e613a0d78d7$export$58d63a2875c58fc8), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
        };
        _this._onRenderGroupShowAll = function(props) {
            return $acw62.createElement((0, $557fce40b0901437$export$7ac06991e625915c), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
        };
        _this._onRenderGroupFooter = function(props) {
            return $acw62.createElement((0, $435c421c46d618de$export$53886534ee378908), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
        };
        _this._renderSubGroup = function(subGroup, subGroupIndex) {
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, getGroupItemLimit = _a.getGroupItemLimit, groupNestingDepth = _a.groupNestingDepth, groupProps = _a.groupProps, items = _a.items, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selection = _a.selection, selectionMode = _a.selectionMode, viewport = _a.viewport, onRenderGroupHeader = _a.onRenderGroupHeader, onRenderGroupShowAll = _a.onRenderGroupShowAll, onRenderGroupFooter = _a.onRenderGroupFooter, onShouldVirtualize = _a.onShouldVirtualize, group = _a.group, compact = _a.compact;
            var nestingDepth = subGroup.level ? subGroup.level + 1 : groupNestingDepth;
            return !subGroup || subGroup.count > 0 || groupProps && groupProps.showEmptyGroups ? $acw62.createElement(GroupedListSection, {
                ref: function(ref) {
                    return _this._subGroupRefs["subGroup_" + subGroupIndex] = ref;
                },
                key: _this._getGroupKey(subGroup, subGroupIndex),
                dragDropEvents: dragDropEvents,
                dragDropHelper: dragDropHelper,
                eventsToRegister: eventsToRegister,
                footerProps: footerProps,
                getGroupItemLimit: getGroupItemLimit,
                group: subGroup,
                groupIndex: subGroupIndex,
                groupNestingDepth: nestingDepth,
                groupProps: groupProps,
                headerProps: headerProps,
                items: items,
                listProps: listProps,
                onRenderCell: onRenderCell,
                selection: selection,
                selectionMode: selectionMode,
                showAllProps: showAllProps,
                viewport: viewport,
                onRenderGroupHeader: onRenderGroupHeader,
                onRenderGroupShowAll: onRenderGroupShowAll,
                onRenderGroupFooter: onRenderGroupFooter,
                onShouldVirtualize: onShouldVirtualize,
                groups: group ? group.children : [],
                compact: compact
            }) : null;
        };
        /**
         * collect all the data we need to enable drag/drop for a group
         */ _this._getGroupDragDropOptions = function() {
            var _a = _this.props, group = _a.group, groupIndex = _a.groupIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
            var options = {
                eventMap: eventsToRegister,
                selectionIndex: -1,
                context: {
                    data: group,
                    index: groupIndex,
                    isGroup: true
                },
                updateDropState: _this._updateDroppingState,
                canDrag: dragDropEvents.canDrag,
                canDrop: dragDropEvents.canDrop,
                onDrop: dragDropEvents.onDrop,
                onDragStart: dragDropEvents.onDragStart,
                onDragEnter: dragDropEvents.onDragEnter,
                onDragLeave: dragDropEvents.onDragLeave,
                onDragEnd: dragDropEvents.onDragEnd,
                onDragOver: dragDropEvents.onDragOver
            };
            return options;
        };
        /**
         * update groupIsDropping state based on the input value, which is used to change style during drag and drop
         *
         * @param newValue - new isDropping state value
         * @param event - the event trigger dropping state change which can be dragenter, dragleave etc
         */ _this._updateDroppingState = function(newIsDropping, event) {
            var isDropping = _this.state.isDropping;
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, group = _a.group;
            if (isDropping !== newIsDropping) {
                if (isDropping) {
                    if (dragDropEvents && dragDropEvents.onDragLeave) dragDropEvents.onDragLeave(group, event);
                } else if (dragDropEvents && dragDropEvents.onDragEnter) _this._droppingClassName = dragDropEvents.onDragEnter(group, event);
                _this.setState({
                    isDropping: newIsDropping
                });
            }
        };
        var selection = props.selection, group = props.group;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("GroupedListSection");
        _this.state = {
            isDropping: false,
            isSelected: selection && group ? selection.isRangeSelected(group.startIndex, group.count) : false
        };
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        return _this;
    }
    GroupedListSection.prototype.componentDidMount = function() {
        var _a = this.props, dragDropHelper = _a.dragDropHelper, selection = _a.selection;
        if (dragDropHelper && this._root.current) this._dragDropSubscription = dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
        if (selection) this._events.on(selection, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4), this._onSelectionChange);
    };
    GroupedListSection.prototype.componentWillUnmount = function() {
        this._events.dispose();
        if (this._dragDropSubscription) this._dragDropSubscription.dispose();
    };
    GroupedListSection.prototype.componentDidUpdate = function(previousProps) {
        if (this.props.group !== previousProps.group || this.props.groupIndex !== previousProps.groupIndex || this.props.dragDropHelper !== previousProps.dragDropHelper) {
            if (this._dragDropSubscription) {
                this._dragDropSubscription.dispose();
                delete this._dragDropSubscription;
            }
            if (this.props.dragDropHelper && this._root.current) this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
        }
    };
    GroupedListSection.prototype.render = function() {
        var _a = this.props, getGroupItemLimit = _a.getGroupItemLimit, group = _a.group, groupIndex = _a.groupIndex, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, viewport = _a.viewport, selectionMode = _a.selectionMode, _b = _a.onRenderGroupHeader, onRenderGroupHeader = _b === void 0 ? this._onRenderGroupHeader : _b, _c = _a.onRenderGroupShowAll, onRenderGroupShowAll = _c === void 0 ? this._onRenderGroupShowAll : _c, _d = _a.onRenderGroupFooter, onRenderGroupFooter = _d === void 0 ? this._onRenderGroupFooter : _d, onShouldVirtualize = _a.onShouldVirtualize, groupedListClassNames = _a.groupedListClassNames, groups = _a.groups, compact = _a.compact, _e = _a.listProps, listProps = _e === void 0 ? {} : _e;
        var isSelected = this.state.isSelected;
        var renderCount = group && getGroupItemLimit ? getGroupItemLimit(group) : Infinity;
        var isShowAllVisible = group && !group.children && !group.isCollapsed && !group.isShowingAll && (group.count > renderCount || group.hasMoreData);
        var hasNestedGroups = group && group.children && group.children.length > 0;
        var version = listProps.version;
        var dividerProps = {
            group: group,
            groupIndex: groupIndex,
            groupLevel: group ? group.level : 0,
            isSelected: isSelected,
            selected: isSelected,
            viewport: viewport,
            selectionMode: selectionMode,
            groups: groups,
            compact: compact
        };
        var ariaControlsProps = {
            groupedListId: this._id,
            ariaLevel: (group === null || group === void 0 ? void 0 : group.level) ? group.level + 1 : 1,
            ariaSetSize: groups ? groups.length : undefined,
            ariaPosInSet: groupIndex !== undefined ? groupIndex + 1 : undefined
        };
        var groupHeaderProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, headerProps), dividerProps), ariaControlsProps);
        var groupShowAllProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, showAllProps), dividerProps);
        var groupFooterProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, footerProps), dividerProps);
        var isDraggable = !!this.props.dragDropHelper && this._getGroupDragDropOptions().canDrag(group) && !!this.props.dragDropEvents.canDragGroups;
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            ref: this._root
        }, isDraggable && {
            draggable: true
        }, {
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(groupedListClassNames && groupedListClassNames.group, this._getDroppingClassName()),
            role: "presentation"
        }), onRenderGroupHeader(groupHeaderProps, this._onRenderGroupHeader), group && group.isCollapsed ? null : hasNestedGroups ? $acw62.createElement((0, $eba311a0e1ed503e$export$54c2e3dc7acea9f5), {
            role: "presentation",
            ref: this._list,
            items: group ? group.children : [],
            onRenderCell: this._renderSubGroup,
            getItemCountForPage: this._returnOne,
            onShouldVirtualize: onShouldVirtualize,
            version: version,
            id: this._id
        }) : this._onRenderGroup(renderCount), group && group.isCollapsed ? null : isShowAllVisible && onRenderGroupShowAll(groupShowAllProps, this._onRenderGroupShowAll), onRenderGroupFooter(groupFooterProps, this._onRenderGroupFooter));
    };
    GroupedListSection.prototype.forceUpdate = function() {
        _super.prototype.forceUpdate.call(this);
        this.forceListUpdate();
    };
    GroupedListSection.prototype.forceListUpdate = function() {
        var group = this.props.group;
        if (this._list.current) {
            this._list.current.forceUpdate();
            if (group && group.children && group.children.length > 0) {
                var subGroupCount = group.children.length;
                for(var i = 0; i < subGroupCount; i++){
                    var subGroup = this._list.current.pageRefs["subGroup_" + String(i)];
                    if (subGroup) subGroup.forceListUpdate();
                }
            }
        } else {
            var subGroup = this._subGroupRefs["subGroup_" + String(0)];
            if (subGroup) subGroup.forceListUpdate();
        }
    };
    GroupedListSection.prototype._onSelectionChange = function() {
        var _a = this.props, group = _a.group, selection = _a.selection;
        if (selection && group) {
            var isSelected = selection.isRangeSelected(group.startIndex, group.count);
            if (isSelected !== this.state.isSelected) this.setState({
                isSelected: isSelected
            });
        }
    };
    GroupedListSection.prototype._onRenderGroupCell = function(onRenderCell, groupNestingDepth, group) {
        return function(item, itemIndex) {
            return onRenderCell(groupNestingDepth, item, itemIndex, group);
        };
    };
    GroupedListSection.prototype._onRenderGroup = function(renderCount) {
        var _a = this.props, group = _a.group, items = _a.items, onRenderCell = _a.onRenderCell, listProps = _a.listProps, groupNestingDepth = _a.groupNestingDepth, onShouldVirtualize = _a.onShouldVirtualize, groupProps = _a.groupProps;
        var count = group && !group.isShowingAll ? group.count : items.length;
        var startIndex = group ? group.startIndex : 0;
        return $acw62.createElement((0, $eba311a0e1ed503e$export$54c2e3dc7acea9f5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            role: groupProps && groupProps.role ? groupProps.role : "rowgroup",
            "aria-label": group === null || group === void 0 ? void 0 : group.name,
            items: items,
            onRenderCell: this._onRenderGroupCell(onRenderCell, groupNestingDepth, group),
            ref: this._list,
            renderCount: Math.min(count, renderCount),
            startIndex: startIndex,
            onShouldVirtualize: onShouldVirtualize,
            id: this._id
        }, listProps));
    };
    GroupedListSection.prototype._returnOne = function() {
        return 1;
    };
    GroupedListSection.prototype._getGroupKey = function(group, index) {
        return "group-" + (group && group.key ? group.key : String(group.level) + String(index));
    };
    /**
     * get the correct css class to reflect the dropping state for a given group
     *
     * If the group is the current drop target, return the default dropping class name
     * Otherwise, return '';
     *
     */ GroupedListSection.prototype._getDroppingClassName = function() {
        var isDropping = this.state.isDropping;
        var _a = this.props, group = _a.group, groupedListClassNames = _a.groupedListClassNames;
        isDropping = !!(group && isDropping);
        return (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(isDropping && this._droppingClassName, isDropping && $501d9aa0f23f669c$var$DEFAULT_DROPPING_CSS_CLASS, isDropping && groupedListClassNames && groupedListClassNames.groupIsDropping);
    };
    return GroupedListSection;
}($acw62.Component);






var $5c8aef800f8985ce$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $5c8aef800f8985ce$var$ROW_HEIGHT = (0, $ee27f738f928d431$export$6a8eeb94a4d816cb).rowHeight, $5c8aef800f8985ce$var$COMPACT_ROW_HEIGHT = (0, $ee27f738f928d431$export$6a8eeb94a4d816cb).compactRowHeight;
var $5c8aef800f8985ce$export$452d58de88892439 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GroupedListBase, _super);
    function GroupedListBase(props) {
        var _this = _super.call(this, props) || this;
        _this._list = $acw62.createRef();
        _this._renderGroup = function(group, groupIndex) {
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, groupProps = _a.groupProps, items = _a.items, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selectionMode = _a.selectionMode, selection = _a.selection, viewport = _a.viewport, onShouldVirtualize = _a.onShouldVirtualize, groups = _a.groups, compact = _a.compact;
            // override group header/footer props as needed
            var dividerProps = {
                onToggleSelectGroup: _this._onToggleSelectGroup,
                onToggleCollapse: _this._onToggleCollapse,
                onToggleSummarize: _this._onToggleSummarize
            };
            var headerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.headerProps), dividerProps);
            var showAllProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.showAllProps), dividerProps);
            var footerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.footerProps), dividerProps);
            var groupNestingDepth = _this._getGroupNestingDepth();
            if (!groupProps.showEmptyGroups && group && group.count === 0) return null;
            var finalListProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, listProps || {}), {
                version: _this.state.version
            });
            return $acw62.createElement((0, $501d9aa0f23f669c$export$a11203b926b3bcf9), {
                key: _this._getGroupKey(group, groupIndex),
                dragDropEvents: dragDropEvents,
                dragDropHelper: dragDropHelper,
                eventsToRegister: eventsToRegister,
                footerProps: footerProps,
                getGroupItemLimit: groupProps && groupProps.getGroupItemLimit,
                group: group,
                groupIndex: groupIndex,
                groupNestingDepth: groupNestingDepth,
                groupProps: groupProps,
                headerProps: headerProps,
                listProps: finalListProps,
                items: items,
                onRenderCell: onRenderCell,
                onRenderGroupHeader: groupProps.onRenderHeader,
                onRenderGroupShowAll: groupProps.onRenderShowAll,
                onRenderGroupFooter: groupProps.onRenderFooter,
                selectionMode: selectionMode,
                selection: selection,
                showAllProps: showAllProps,
                viewport: viewport,
                onShouldVirtualize: onShouldVirtualize,
                groupedListClassNames: _this._classNames,
                groups: groups,
                compact: compact
            });
        };
        _this._getDefaultGroupItemLimit = function(group) {
            return group.children && group.children.length > 0 ? group.children.length : group.count;
        };
        _this._getGroupItemLimit = function(group) {
            var groupProps = _this.props.groupProps;
            var getGroupItemLimit = groupProps && groupProps.getGroupItemLimit ? groupProps.getGroupItemLimit : _this._getDefaultGroupItemLimit;
            return getGroupItemLimit(group);
        };
        _this._getGroupHeight = function(group) {
            var rowHeight = _this.props.compact ? $5c8aef800f8985ce$var$COMPACT_ROW_HEIGHT : $5c8aef800f8985ce$var$ROW_HEIGHT;
            return rowHeight + (group.isCollapsed ? 0 : rowHeight * _this._getGroupItemLimit(group));
        };
        _this._getPageHeight = function(itemIndex) {
            var groups = _this.state.groups;
            var _a = _this.props.getGroupHeight, getGroupHeight = _a === void 0 ? _this._getGroupHeight : _a;
            var pageGroup = groups && groups[itemIndex];
            if (pageGroup) return getGroupHeight(pageGroup, itemIndex);
            else return 0;
        };
        _this._onToggleCollapse = function(group) {
            var groupProps = _this.props.groupProps;
            var onToggleCollapse = groupProps && groupProps.headerProps && groupProps.headerProps.onToggleCollapse;
            if (group) {
                if (onToggleCollapse) onToggleCollapse(group);
                group.isCollapsed = !group.isCollapsed;
                _this._updateIsSomeGroupExpanded();
                _this.forceUpdate();
            }
        };
        _this._onToggleSelectGroup = function(group) {
            var _a = _this.props, selection = _a.selection, selectionMode = _a.selectionMode;
            if (group && selection && selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) selection.toggleRangeSelected(group.startIndex, group.count);
        };
        _this._isInnerZoneKeystroke = function(ev) {
            // eslint-disable-next-line deprecation/deprecation
            return ev.which === (0, $723d0744d8fe4fde$export$404175034cd47507)((0, $c011a102064f82ea$export$ec835b702d42f3f0).right);
        };
        _this._onToggleSummarize = function(group) {
            var groupProps = _this.props.groupProps;
            var onToggleSummarize = groupProps && groupProps.showAllProps && groupProps.showAllProps.onToggleSummarize;
            if (onToggleSummarize) onToggleSummarize(group);
            else {
                if (group) group.isShowingAll = !group.isShowingAll;
                _this.forceUpdate();
            }
        };
        _this._getPageSpecification = function(itemIndex) {
            var groups = _this.state.groups;
            var pageGroup = groups && groups[itemIndex];
            return {
                key: pageGroup && pageGroup.key
            };
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._isSomeGroupExpanded = _this._computeIsSomeGroupExpanded(props.groups);
        var _a = props.listProps, _b = _a === void 0 ? {} : _a, _c = _b.version, version = _c === void 0 ? {} : _c;
        _this.state = {
            groups: props.groups,
            items: props.items,
            listProps: props.listProps,
            version: version
        };
        return _this;
    }
    GroupedListBase.getDerivedStateFromProps = function(nextProps, previousState) {
        var groups = nextProps.groups, selectionMode = nextProps.selectionMode, compact = nextProps.compact, items = nextProps.items, listProps = nextProps.listProps;
        var listVersion = listProps && listProps.version;
        var nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), {
            selectionMode: selectionMode,
            compact: compact,
            groups: groups,
            listProps: listProps,
            items: items
        });
        var shouldForceUpdates = false;
        var previousListVersion = previousState.listProps && previousState.listProps.version;
        if (listVersion !== previousListVersion || items !== previousState.items || groups !== previousState.groups || selectionMode !== previousState.selectionMode || compact !== previousState.compact) // If there are any props not passed explicitly to `List` which have an impact on the behavior of `onRenderCell`,
        // these need to 'force-update' this component by revving the version. Otherwise, the List might render with stale
        // data.
        shouldForceUpdates = true;
        if (shouldForceUpdates) nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), {
            version: {}
        });
        return nextState;
    };
    GroupedListBase.prototype.scrollToIndex = function(index, measureItem, scrollToMode) {
        if (this._list.current) this._list.current.scrollToIndex(index, measureItem, scrollToMode);
    };
    GroupedListBase.prototype.getStartItemIndexInView = function() {
        return this._list.current.getStartItemIndexInView() || 0;
    };
    GroupedListBase.prototype.componentDidMount = function() {
        var _a = this.props, groupProps = _a.groupProps, _b = _a.groups, groups = _b === void 0 ? [] : _b;
        if (groupProps && groupProps.isAllGroupsCollapsed) this._setGroupsCollapsedState(groups, groupProps.isAllGroupsCollapsed);
    };
    GroupedListBase.prototype.render = function() {
        var _a = this.props, className = _a.className, usePageCache = _a.usePageCache, onShouldVirtualize = _a.onShouldVirtualize, theme = _a.theme, _b = _a.role, role = _b === void 0 ? "treegrid" : _b, styles = _a.styles, compact = _a.compact, _c = _a.focusZoneProps, focusZoneProps = _c === void 0 ? {} : _c, _d = _a.rootListProps, rootListProps = _d === void 0 ? {} : _d;
        var _e = this.state, groups = _e.groups, version = _e.version;
        this._classNames = $5c8aef800f8985ce$var$getClassNames(styles, {
            theme: theme,
            className: className,
            compact: compact
        });
        var _f = focusZoneProps.shouldEnterInnerZone, shouldEnterInnerZone = _f === void 0 ? this._isInnerZoneKeystroke : _f;
        return $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical,
            "data-automationid": "GroupedList",
            "data-is-scrollable": "false",
            role: "presentation"
        }, focusZoneProps, {
            shouldEnterInnerZone: shouldEnterInnerZone,
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(this._classNames.root, focusZoneProps.className)
        }), !groups ? this._renderGroup(undefined, 0) : $acw62.createElement((0, $eba311a0e1ed503e$export$54c2e3dc7acea9f5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            ref: this._list,
            role: role,
            items: groups,
            onRenderCell: this._renderGroup,
            getItemCountForPage: this._returnOne,
            getPageHeight: this._getPageHeight,
            getPageSpecification: this._getPageSpecification,
            usePageCache: usePageCache,
            onShouldVirtualize: onShouldVirtualize,
            version: version
        }, rootListProps)));
    };
    GroupedListBase.prototype.forceUpdate = function() {
        _super.prototype.forceUpdate.call(this);
        this._forceListUpdates();
    };
    GroupedListBase.prototype.toggleCollapseAll = function(allCollapsed) {
        var _a = this.state.groups, groups = _a === void 0 ? [] : _a;
        var groupProps = this.props.groupProps;
        var onToggleCollapseAll = groupProps && groupProps.onToggleCollapseAll;
        if (groups.length > 0) {
            if (onToggleCollapseAll) onToggleCollapseAll(allCollapsed);
            this._setGroupsCollapsedState(groups, allCollapsed);
            this._updateIsSomeGroupExpanded();
            this.forceUpdate();
        }
    };
    GroupedListBase.prototype._setGroupsCollapsedState = function(groups, isCollapsed) {
        for(var groupIndex = 0; groupIndex < groups.length; groupIndex++)groups[groupIndex].isCollapsed = isCollapsed;
    };
    GroupedListBase.prototype._returnOne = function() {
        return 1;
    };
    GroupedListBase.prototype._getGroupKey = function(group, index) {
        return "group-" + (group && group.key ? group.key : String(index));
    };
    GroupedListBase.prototype._getGroupNestingDepth = function() {
        var groups = this.state.groups;
        var level = 0;
        var groupsInLevel = groups;
        while(groupsInLevel && groupsInLevel.length > 0){
            level++;
            groupsInLevel = groupsInLevel[0].children;
        }
        return level;
    };
    GroupedListBase.prototype._forceListUpdates = function(groups) {
        this.setState({
            version: {}
        });
    };
    GroupedListBase.prototype._computeIsSomeGroupExpanded = function(groups) {
        var _this = this;
        return !!(groups && groups.some(function(group) {
            return group.children ? _this._computeIsSomeGroupExpanded(group.children) : !group.isCollapsed;
        }));
    };
    GroupedListBase.prototype._updateIsSomeGroupExpanded = function() {
        var groups = this.state.groups;
        var onGroupExpandStateChanged = this.props.onGroupExpandStateChanged;
        var newIsSomeGroupExpanded = this._computeIsSomeGroupExpanded(groups);
        if (this._isSomeGroupExpanded !== newIsSomeGroupExpanded) {
            if (onGroupExpandStateChanged) onGroupExpandStateChanged(newIsSomeGroupExpanded);
            this._isSomeGroupExpanded = newIsSomeGroupExpanded;
        }
    };
    GroupedListBase.defaultProps = {
        selectionMode: (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple,
        isHeaderVisible: true,
        groupProps: {},
        compact: false
    };
    return GroupedListBase;
}($acw62.Component);


var $a8210fb15a0e100c$export$7b9037ad46f5f6b2 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $5c8aef800f8985ce$export$452d58de88892439), (0, $170fa6de102a1824$export$ffd58b7f6f099a57), undefined, {
    scope: "GroupedList"
});



/**
 * {@docCategory GroupedList}
 */ var $983645f52845fc75$export$64fc9da778a9842;
(function(CollapseAllVisibility) {
    CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
    CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
})($983645f52845fc75$export$64fc9da778a9842 || ($983645f52845fc75$export$64fc9da778a9842 = {}));









var $cd022211c714728e$exports = {};


var $acw62 = parcelRequire("acw62");







var $cd022211c714728e$var$_this = undefined;
var $cd022211c714728e$var$flattenItems = function(groups, items, memoItems, getGroupItemLimit) {
    if (!groups) return items;
    if (memoItems.length < 1) // Not the exact final size but gets us in the ballpark.
    // This helps avoid trashing memory when building
    // the flattened list.
    memoItems = new Array(items.length);
    var index = 0;
    // const stack: IGroup[] = [];
    var stack = [];
    var j = groups.length - 1;
    while(j >= 0){
        stack.push({
            group: groups[j],
            groupIndex: j + 1
        });
        j--;
    }
    while(stack.length > 0){
        // eslint-disable-next-line prefer-const
        var _a = stack.pop(), group = _a.group, groupIndex = _a.groupIndex;
        memoItems[index] = {
            group: group,
            groupId: (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("GroupedListSection"),
            type: "header",
            groupIndex: groupIndex
        };
        index++;
        while(group.isCollapsed !== true && (group === null || group === void 0 ? void 0 : group.children) && group.children.length > 0){
            j = group.children.length - 1;
            while(j > 0){
                stack.push({
                    group: group.children[j],
                    groupIndex: j + 1
                });
                j--;
            }
            group = group.children[0];
            memoItems[index] = {
                group: group,
                groupId: (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("GroupedListSection"),
                type: "header",
                groupIndex: 1
            };
            index++;
        }
        if (group.isCollapsed !== true) {
            var itemIndex = group.startIndex;
            var renderCount = getGroupItemLimit ? getGroupItemLimit(group) : Infinity;
            var count = !group.isShowingAll ? group.count : items.length;
            var itemEnd = itemIndex + Math.min(count, renderCount);
            while(itemIndex < itemEnd){
                memoItems[index] = {
                    group: group,
                    item: items[itemIndex],
                    itemIndex: itemIndex,
                    type: "item"
                };
                itemIndex++;
                index++;
            }
            var isShowAllVisible = !group.children && !group.isCollapsed && !group.isShowingAll && (group.count > renderCount || group.hasMoreData);
            if (isShowAllVisible) {
                memoItems[index] = {
                    group: group,
                    type: "showAll"
                };
                index++;
            }
        }
        // Placeholder for a potential footer.
        // Whether or not a footer is displayed is resolved
        // by the footer render function so this is just a marker
        // for where a footer may go.
        memoItems[index] = {
            group: group,
            type: "footer"
        };
        index++;
    }
    memoItems.length = index;
    // console.log('MEMO ITEMS', memoItems);
    return memoItems;
};
var $cd022211c714728e$var$useIsGroupSelected = function(startIndex, count, selection, eventGroup) {
    var _a = $acw62.useState(function() {
        var _a;
        return (_a = selection === null || selection === void 0 ? void 0 : selection.isRangeSelected(startIndex, count)) !== null && _a !== void 0 ? _a : false;
    }), isSelected = _a[0], setIsSelected = _a[1];
    $acw62.useEffect(function() {
        if (selection && eventGroup) {
            var changeHandler_1 = function() {
                var _a;
                setIsSelected((_a = selection === null || selection === void 0 ? void 0 : selection.isRangeSelected(startIndex, count)) !== null && _a !== void 0 ? _a : false);
            };
            eventGroup.on(selection, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4), changeHandler_1);
            return function() {
                eventGroup === null || eventGroup === void 0 || eventGroup.off(selection, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4), changeHandler_1);
            };
        }
    }, [
        startIndex,
        count,
        selection,
        eventGroup
    ]);
    return isSelected;
};
var $cd022211c714728e$var$computeIsSomeGroupExpanded = function(groups) {
    return !!(groups && groups.some(function(group) {
        return group.children ? $cd022211c714728e$var$computeIsSomeGroupExpanded(group.children) : !group.isCollapsed;
    }));
};
var $cd022211c714728e$var$setGroupsCollapsedState = function(groups, isCollapsed) {
    if (groups === undefined) return;
    for(var groupIndex = 0; groupIndex < groups.length; groupIndex++)groups[groupIndex].isCollapsed = isCollapsed;
};
var $cd022211c714728e$var$isInnerZoneKeystroke = function(ev) {
    // eslint-disable-next-line deprecation/deprecation
    return ev.which === (0, $723d0744d8fe4fde$export$404175034cd47507)((0, $c011a102064f82ea$export$ec835b702d42f3f0).right);
};
var $cd022211c714728e$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $cd022211c714728e$var$getKey = function(item, _index) {
    var _a, _b;
    switch(item.type){
        case "item":
            return (_b = (_a = item.item) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : null;
        case "header":
            return item.group.key;
        case "footer":
            return "".concat(item.group.key, "-footer");
        case "showAll":
            return "".concat(item.group.key, "-showAll");
    }
    return null;
};
var $cd022211c714728e$var$renderGroupHeader = function(props) {
    return $acw62.createElement((0, $8be27e613a0d78d7$export$58d63a2875c58fc8), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
};
var $cd022211c714728e$var$renderGroupShowAll = function(props) {
    return $acw62.createElement((0, $557fce40b0901437$export$7ac06991e625915c), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
};
var $cd022211c714728e$var$renderGroupFooter = function(props) {
    if (props.group && props.footerText) return $acw62.createElement((0, $435c421c46d618de$export$53886534ee378908), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
    return null;
};
var $cd022211c714728e$export$531ac0fe9565dbbd = function(props) {
    var selection = props.selection, _a = props.selectionMode, selectionMode = _a === void 0 ? (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple : _a, _b = props.groupProps, groupProps = _b === void 0 ? {} : _b, _c = props.compact, compact = _c === void 0 ? false : _c, _d = props.items, items = _d === void 0 ? [] : _d, groups = props.groups, onGroupExpandStateChanged = props.onGroupExpandStateChanged, className = props.className, usePageCache = props.usePageCache, onShouldVirtualize = props.onShouldVirtualize, theme = props.theme, _e = props.role, role = _e === void 0 ? "treegrid" : _e, styles = props.styles, _f = props.focusZoneProps, focusZoneProps = _f === void 0 ? {} : _f, _g = props.rootListProps, rootListProps = _g === void 0 ? {} : _g, onRenderCell = props.onRenderCell, viewport = props.viewport, listRef = props.listRef, groupExpandedVersion = props.groupExpandedVersion, versionFromProps = props.version;
    var _h = groupProps.onRenderHeader, onRenderHeader = _h === void 0 ? $cd022211c714728e$var$renderGroupHeader : _h, _j = groupProps.onRenderFooter, onRenderFooter = _j === void 0 ? $cd022211c714728e$var$renderGroupFooter : _j, _k = groupProps.onRenderShowAll, onRenderShowAll = _k === void 0 ? $cd022211c714728e$var$renderGroupShowAll : _k;
    var classNames = $cd022211c714728e$var$getClassNames(styles, {
        theme: theme,
        className: className,
        compact: compact
    });
    var events = $acw62.useRef();
    var flatList = $acw62.useRef([]);
    var isSomeGroupExpanded = $acw62.useRef($cd022211c714728e$var$computeIsSomeGroupExpanded(groups));
    var _l = $acw62.useState({}), version = _l[0], setVersion = _l[1];
    var _m = $acw62.useState({}), toggleVersion = _m[0], setToggleVersion = _m[1];
    // eslint-disable-next-line deprecation/deprecation
    var _o = focusZoneProps.shouldEnterInnerZone, shouldEnterInnerZone = _o === void 0 ? $cd022211c714728e$var$isInnerZoneKeystroke : _o;
    var listView = $acw62.useMemo(function() {
        return $cd022211c714728e$var$flattenItems(groups, items, flatList.current, groupProps === null || groupProps === void 0 ? void 0 : groupProps.getGroupItemLimit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        groups,
        groupProps === null || groupProps === void 0 ? void 0 : groupProps.getGroupItemLimit,
        items,
        toggleVersion,
        flatList,
        groupExpandedVersion
    ]);
    var getPageSpecification = $acw62.useCallback(function(flattenedIndex) {
        var pageGroup = listView[flattenedIndex];
        return {
            key: pageGroup.type === "header" ? pageGroup.group.key : undefined
        };
    }, [
        listView
    ]);
    $acw62.useEffect(function() {
        if (groupProps === null || groupProps === void 0 ? void 0 : groupProps.isAllGroupsCollapsed) $cd022211c714728e$var$setGroupsCollapsedState(groups, groupProps.isAllGroupsCollapsed);
        events.current = new (0, $7e392406ee2126b8$export$7af5106782f53286)($cd022211c714728e$var$_this);
        return function() {
            var _a;
            (_a = events.current) === null || _a === void 0 || _a.dispose();
            events.current = undefined;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(function() {
        setVersion({});
    }, [
        versionFromProps
    ]);
    $acw62.useEffect(function() {
        var newIsSomeGroupExpanded = $cd022211c714728e$var$computeIsSomeGroupExpanded(groups);
        if (newIsSomeGroupExpanded !== isSomeGroupExpanded.current) {
            isSomeGroupExpanded.current = newIsSomeGroupExpanded;
            onGroupExpandStateChanged === null || onGroupExpandStateChanged === void 0 || onGroupExpandStateChanged(newIsSomeGroupExpanded);
        }
    }, [
        groups,
        toggleVersion,
        onGroupExpandStateChanged,
        groupExpandedVersion
    ]);
    var onToggleCollapse = $acw62.useCallback(function(group) {
        var _a;
        var onToggleCollapseFn = (_a = groupProps === null || groupProps === void 0 ? void 0 : groupProps.headerProps) === null || _a === void 0 ? void 0 : _a.onToggleCollapse;
        if (group) {
            onToggleCollapseFn === null || onToggleCollapseFn === void 0 || onToggleCollapseFn(group);
            group.isCollapsed = !group.isCollapsed;
            setToggleVersion({});
            setVersion({});
        }
    }, [
        setToggleVersion,
        groupProps
    ]);
    var onToggleSelectGroup = function(group) {
        if (group && selection && selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) selection.toggleRangeSelected(group.startIndex, group.count);
    };
    var onToggleSummarize = function(group) {
        var _a;
        var onToggleSummarizeFn = (_a = groupProps === null || groupProps === void 0 ? void 0 : groupProps.showAllProps) === null || _a === void 0 ? void 0 : _a.onToggleSummarize;
        if (onToggleSummarizeFn) onToggleSummarizeFn(group);
        else {
            if (group) group.isShowingAll = !group.isShowingAll;
            setVersion({});
            setToggleVersion({});
        }
    };
    var getDividerProps = function(group, flattenedIndex) {
        var _a;
        var dividerProps = {
            group: group,
            groupIndex: flattenedIndex,
            groupLevel: (_a = group.level) !== null && _a !== void 0 ? _a : 0,
            viewport: viewport,
            selectionMode: selectionMode,
            groups: groups,
            compact: compact,
            onToggleSelectGroup: onToggleSelectGroup,
            onToggleCollapse: onToggleCollapse,
            onToggleSummarize: onToggleSummarize
        };
        return dividerProps;
    };
    var renderHeader = function(item, flattenedIndex) {
        var group = item.group;
        var ariaProps;
        if (role === "treegrid") // GroupedList default role
        ariaProps = {
            ariaLevel: group.level ? group.level + 1 : 1,
            ariaSetSize: groups ? groups.length : undefined,
            ariaPosInSet: item.groupIndex
        };
        else // Grouped DetailsList
        ariaProps = {
            ariaRowIndex: flattenedIndex
        };
        var headerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.headerProps), getDividerProps(item.group, flattenedIndex)), {
            key: group.key,
            groupedListId: item.groupId
        }), ariaProps);
        return $acw62.createElement($cd022211c714728e$var$GroupItem, {
            render: onRenderHeader,
            defaultRender: $cd022211c714728e$var$renderGroupHeader,
            item: item,
            selection: selection,
            eventGroup: events.current,
            props: headerProps
        });
    };
    var renderShowAll = function(item, flattenedIndex) {
        var group = item.group;
        var groupShowAllProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.showAllProps), getDividerProps(group, flattenedIndex)), {
            key: group.key ? "".concat(group.key, "-show-all") : undefined
        });
        return onRenderShowAll(groupShowAllProps, $cd022211c714728e$var$renderGroupShowAll);
    };
    var renderFooter = function(item, flattenedIndex) {
        var group = item.group;
        var groupFooterProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps.footerProps), getDividerProps(group, flattenedIndex)), {
            key: group.key ? "".concat(group.key, "-footer") : undefined
        });
        return onRenderFooter(groupFooterProps, $cd022211c714728e$var$renderGroupFooter);
    };
    var renderItem = function(item, flattenedIndex) {
        var _a;
        if (item.type === "header") return renderHeader(item, flattenedIndex);
        else if (item.type === "showAll") return renderShowAll(item, flattenedIndex);
        else if (item.type === "footer") return renderFooter(item, flattenedIndex);
        else {
            var level = item.group.level ? item.group.level + 1 : 1;
            return onRenderCell(level, item.item, (_a = item.itemIndex) !== null && _a !== void 0 ? _a : flattenedIndex, item.group);
        }
    };
    return $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical,
        "data-automationid": "GroupedList",
        "data-is-scrollable": "false",
        role: "presentation"
    }, focusZoneProps, {
        shouldEnterInnerZone: shouldEnterInnerZone,
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, focusZoneProps.className)
    }), $acw62.createElement((0, $eba311a0e1ed503e$export$54c2e3dc7acea9f5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: listRef,
        role: role,
        items: listView,
        // eslint-disable-next-line
        onRenderCellConditional: renderItem,
        usePageCache: usePageCache,
        onShouldVirtualize: onShouldVirtualize,
        getPageSpecification: getPageSpecification,
        version: version,
        getKey: $cd022211c714728e$var$getKey
    }, rootListProps)));
};
var $cd022211c714728e$var$GroupItem = function(_a) {
    var render = _a.render, defaultRender = _a.defaultRender, item = _a.item, selection = _a.selection, eventGroup = _a.eventGroup, props = _a.props;
    var group = item.group;
    var isSelected = $cd022211c714728e$var$useIsGroupSelected(group.startIndex, group.count, selection, eventGroup);
    var mergedProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
        isSelected: isSelected,
        selected: isSelected
    });
    return render(mergedProps, defaultRender);
};
var $cd022211c714728e$export$23382e58ad16ea8a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GroupedListV2Wrapper, _super);
    function GroupedListV2Wrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._list = $acw62.createRef();
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        var _a = props.listProps, _b = _a === void 0 ? {} : _a, _c = _b.version, version = _c === void 0 ? {} : _c, groups = props.groups;
        _this.state = {
            version: version,
            groupExpandedVersion: {},
            groups: groups
        };
        return _this;
    }
    GroupedListV2Wrapper.getDerivedStateFromProps = function(nextProps, previousState) {
        var groups = nextProps.groups, selectionMode = nextProps.selectionMode, compact = nextProps.compact, items = nextProps.items, listProps = nextProps.listProps;
        var nextListVersion = listProps && listProps.version;
        var nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), {
            groups: groups
        });
        if (nextListVersion !== previousState.version || items !== previousState.items || groups !== previousState.groups || selectionMode !== previousState.selectionMode || compact !== previousState.compact) nextState.version = {};
        return nextState;
    };
    GroupedListV2Wrapper.prototype.scrollToIndex = function(index, measureItem, scrollToMode) {
        if (this._list.current) this._list.current.scrollToIndex(index, measureItem, scrollToMode);
    };
    GroupedListV2Wrapper.prototype.getStartItemIndexInView = function() {
        var _a;
        return ((_a = this._list.current) === null || _a === void 0 ? void 0 : _a.getStartItemIndexInView()) || 0;
    };
    GroupedListV2Wrapper.prototype.render = function() {
        return $acw62.createElement($cd022211c714728e$export$531ac0fe9565dbbd, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, this.state, {
            listRef: this._list
        }));
    };
    GroupedListV2Wrapper.prototype.forceUpdate = function() {
        _super.prototype.forceUpdate.call(this);
        this._forceListUpdate();
    };
    GroupedListV2Wrapper.prototype.toggleCollapseAll = function(allCollapsed) {
        var _a;
        var groups = this.state.groups;
        var groupProps = this.props.groupProps;
        if (groups && groups.length > 0) {
            (_a = groupProps === null || groupProps === void 0 ? void 0 : groupProps.onToggleCollapseAll) === null || _a === void 0 || _a.call(groupProps, allCollapsed);
            $cd022211c714728e$var$setGroupsCollapsedState(groups, allCollapsed);
            this.setState({
                groupExpandedVersion: {}
            });
            this.forceUpdate();
        }
    };
    GroupedListV2Wrapper.prototype._forceListUpdate = function() {
        this.setState({
            version: {}
        });
    };
    GroupedListV2Wrapper.displayName = "GroupedListV2";
    return GroupedListV2Wrapper;
}($acw62.Component);



$parcel$exportWildcard($9bab5a9100d38ae5$exports, $cd022211c714728e$exports);




var $acw62 = parcelRequire("acw62");

var $cc901e5460d835ce$var$nativeElementMap = {
    label: (0, $076f236b4b7f2dc0$export$ec8d81a3d8f61d0f),
    audio: (0, $076f236b4b7f2dc0$export$55af9cf105a52547),
    video: (0, $076f236b4b7f2dc0$export$cd2126b486be823e),
    ol: (0, $076f236b4b7f2dc0$export$9e755727cea4fd1f),
    li: (0, $076f236b4b7f2dc0$export$8703767c2ecb797b),
    a: (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8),
    button: (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4),
    input: (0, $076f236b4b7f2dc0$export$33c6815a27d08ce5),
    textarea: (0, $076f236b4b7f2dc0$export$699534499318873d),
    select: (0, $076f236b4b7f2dc0$export$9475341421ea2846),
    option: (0, $076f236b4b7f2dc0$export$9004c3828878727f),
    table: (0, $076f236b4b7f2dc0$export$2f53f8cf7eb86ae5),
    tr: (0, $076f236b4b7f2dc0$export$3ab2f4f445c2eb24),
    th: (0, $076f236b4b7f2dc0$export$2b115a026f474c83),
    td: (0, $076f236b4b7f2dc0$export$b5d753b2279d22cc),
    colGroup: (0, $076f236b4b7f2dc0$export$d526cc4b9c261b42),
    col: (0, $076f236b4b7f2dc0$export$e487baa138d06e98),
    form: (0, $076f236b4b7f2dc0$export$477a3a6d251d97a7),
    iframe: (0, $076f236b4b7f2dc0$export$727a7f82229b450f),
    img: (0, $076f236b4b7f2dc0$export$91f8cc2b546c057d)
};
function $cc901e5460d835ce$export$eca624771caa6078(tagName, props, excludedPropNames) {
    var allowedPropNames = tagName && $cc901e5460d835ce$var$nativeElementMap[tagName] || (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40);
    return (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, allowedPropNames, excludedPropNames);
}





var $17354d7eb7914059$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $17354d7eb7914059$var$DetailsRowCheckBase = function(props) {
    var _a = props.isVisible, isVisible = _a === void 0 ? false : _a, _b = props.canSelect, canSelect = _b === void 0 ? false : _b, _c = props.anySelected, anySelected = _c === void 0 ? false : _c, _d = props.selected, selected = _d === void 0 ? false : _d, selectionMode = props.selectionMode, _e = props.isHeader, isHeader = _e === void 0 ? false : _e, className = props.className, checkClassName = props.checkClassName, styles = props.styles, theme = props.theme, compact = props.compact, onRenderDetailsCheckbox = props.onRenderDetailsCheckbox, _f = props.useFastIcons, useFastIcons = _f === void 0 ? true : _f, buttonProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "isVisible",
        "canSelect",
        "anySelected",
        "selected",
        "selectionMode",
        "isHeader",
        "className",
        "checkClassName",
        "styles",
        "theme",
        "compact",
        "onRenderDetailsCheckbox",
        "useFastIcons"
    ]);
    var defaultCheckboxRender = useFastIcons ? $17354d7eb7914059$var$_fastDefaultCheckboxRender : $17354d7eb7914059$var$_defaultCheckboxRender;
    var onRenderCheckbox = onRenderDetailsCheckbox ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(onRenderDetailsCheckbox, defaultCheckboxRender) : defaultCheckboxRender;
    var classNames = $17354d7eb7914059$var$getClassNames(styles, {
        theme: theme,
        canSelect: canSelect,
        selected: selected,
        anySelected: anySelected,
        className: className,
        isHeader: isHeader,
        isVisible: isVisible,
        compact: compact
    });
    var detailsCheckboxProps = {
        checked: selected,
        theme: theme
    };
    var divProps = (0, $cc901e5460d835ce$export$eca624771caa6078)("div", buttonProps, [
        "aria-label",
        "aria-labelledby",
        "aria-describedby"
    ]);
    var checkRole = selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single ? "radio" : "checkbox";
    return canSelect ? $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, buttonProps, {
        role: checkRole,
        // eslint-disable-next-line deprecation/deprecation
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, classNames.check),
        "aria-checked": selected,
        "data-selection-toggle": true,
        "data-automationid": "DetailsRowCheck",
        tabIndex: -1
    }), onRenderCheckbox(detailsCheckboxProps)) : // eslint-disable-next-line deprecation/deprecation
    $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, classNames.check)
    }));
};
var $17354d7eb7914059$var$FastCheck = $acw62.memo(function(props) {
    return $acw62.createElement((0, $591e1f0616d591da$export$60bffc6e2a50e7f9), {
        theme: props.theme,
        checked: props.checked,
        className: props.className,
        useFastIcons: true
    });
});
function $17354d7eb7914059$var$_defaultCheckboxRender(checkboxProps) {
    return $acw62.createElement((0, $591e1f0616d591da$export$60bffc6e2a50e7f9), {
        checked: checkboxProps.checked
    });
}
function $17354d7eb7914059$var$_fastDefaultCheckboxRender(checkboxProps) {
    return $acw62.createElement($17354d7eb7914059$var$FastCheck, {
        theme: checkboxProps.theme,
        checked: checkboxProps.checked
    });
}
var $17354d7eb7914059$export$4b1070532488c9c6 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)($17354d7eb7914059$var$DetailsRowCheckBase, (0, $939930e28b7e2661$export$5fe9f1bb52448e88), undefined, {
    scope: "DetailsRowCheck"
}, true);




var $5492b08e38be5f64$var$MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var $5492b08e38be5f64$var$MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
var $5492b08e38be5f64$export$5bf245762bac788e = /** @class */ function() {
    function DragDropHelper(params) {
        this._selection = params.selection;
        this._dragEnterCounts = {};
        this._activeTargets = {};
        this._lastId = 0;
        // To make this class cheap to create, which allows simplifying some logic elsewhere,
        // only initialize the event group and global event handlers as needed.
        this._initialized = false;
    }
    DragDropHelper.prototype.dispose = function() {
        if (this._events) this._events.dispose();
    };
    DragDropHelper.prototype.subscribe = function(root, events, dragDropOptions) {
        var _this = this;
        if (!this._initialized) {
            this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(this);
            var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
            // clear drag data when mouse up, use capture event to ensure it will be run
            if (doc) {
                this._events.on(doc.body, "mouseup", this._onMouseUp.bind(this), true);
                this._events.on(doc, "mouseup", this._onDocumentMouseUp.bind(this), true);
            }
            this._initialized = true;
        }
        var _a = dragDropOptions.key, key = _a === void 0 ? "".concat(++this._lastId) : _a;
        var handlers = [];
        var onDragStart;
        var onDragLeave;
        var onDragEnter;
        var onDragEnd;
        var onDrop;
        var onDragOver;
        var onMouseDown;
        var isDraggable;
        var isDroppable;
        var activeTarget;
        if (dragDropOptions && root) {
            var eventMap = dragDropOptions.eventMap, context = dragDropOptions.context, updateDropState_1 = dragDropOptions.updateDropState;
            var dragDropTarget = {
                root: root,
                options: dragDropOptions,
                key: key
            };
            isDraggable = this._isDraggable(dragDropTarget);
            isDroppable = this._isDroppable(dragDropTarget);
            if (isDraggable || isDroppable) {
                if (eventMap) for(var _i = 0, eventMap_1 = eventMap; _i < eventMap_1.length; _i++){
                    var event_1 = eventMap_1[_i];
                    var handler = {
                        callback: event_1.callback.bind(null, context),
                        eventName: event_1.eventName
                    };
                    handlers.push(handler);
                    this._events.on(root, handler.eventName, handler.callback);
                }
            }
            if (isDroppable) {
                // If the target is droppable, wire up global event listeners to track drop-related events.
                onDragLeave = function(event) {
                    if (!event.isHandled) {
                        event.isHandled = true;
                        _this._dragEnterCounts[key]--;
                        if (_this._dragEnterCounts[key] === 0) updateDropState_1(false, event);
                    }
                };
                onDragEnter = function(event) {
                    event.preventDefault(); // needed for IE
                    if (!event.isHandled) {
                        event.isHandled = true;
                        _this._dragEnterCounts[key]++;
                        if (_this._dragEnterCounts[key] === 1) updateDropState_1(true, event);
                    }
                };
                onDragEnd = function(event) {
                    _this._dragEnterCounts[key] = 0;
                    updateDropState_1(false, event);
                };
                onDrop = function(event) {
                    _this._dragEnterCounts[key] = 0;
                    updateDropState_1(false, event);
                    if (dragDropOptions.onDrop) dragDropOptions.onDrop(dragDropOptions.context.data, event);
                };
                onDragOver = function(event) {
                    event.preventDefault();
                    if (dragDropOptions.onDragOver) dragDropOptions.onDragOver(dragDropOptions.context.data, event);
                };
                this._dragEnterCounts[key] = 0;
                // dragenter and dragleave will be fired when hover to the child element
                // but we only want to change state when enter or leave the current element
                // use the count to ensure it.
                events.on(root, "dragenter", onDragEnter);
                events.on(root, "dragleave", onDragLeave);
                events.on(root, "dragend", onDragEnd);
                events.on(root, "drop", onDrop);
                events.on(root, "dragover", onDragOver);
            }
            if (isDraggable) {
                // If the target is draggable, wire up local event listeners for mouse events.
                onMouseDown = this._onMouseDown.bind(this, dragDropTarget);
                onDragEnd = this._onDragEnd.bind(this, dragDropTarget);
                // We need to add in data so that on Firefox we show the ghost element when dragging
                onDragStart = function(event) {
                    var options = dragDropOptions;
                    if (options && options.onDragStart) options.onDragStart(options.context.data, options.context.index, _this._selection.getSelection(), event);
                    _this._isDragging = true;
                    if (event.dataTransfer) event.dataTransfer.setData("id", root.id);
                };
                events.on(root, "dragstart", onDragStart);
                events.on(root, "mousedown", onMouseDown);
                events.on(root, "dragend", onDragEnd);
            }
            activeTarget = {
                target: dragDropTarget,
                dispose: function() {
                    if (_this._activeTargets[key] === activeTarget) delete _this._activeTargets[key];
                    if (root) {
                        for(var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++){
                            var handler = handlers_1[_i];
                            _this._events.off(root, handler.eventName, handler.callback);
                        }
                        if (isDroppable) {
                            events.off(root, "dragenter", onDragEnter);
                            events.off(root, "dragleave", onDragLeave);
                            events.off(root, "dragend", onDragEnd);
                            events.off(root, "dragover", onDragOver);
                            events.off(root, "drop", onDrop);
                        }
                        if (isDraggable) {
                            events.off(root, "dragstart", onDragStart);
                            events.off(root, "mousedown", onMouseDown);
                            events.off(root, "dragend", onDragEnd);
                        }
                    }
                }
            };
            this._activeTargets[key] = activeTarget;
        }
        return {
            key: key,
            dispose: function() {
                if (activeTarget) activeTarget.dispose();
            }
        };
    };
    DragDropHelper.prototype.unsubscribe = function(root, key) {
        var activeTarget = this._activeTargets[key];
        if (activeTarget) activeTarget.dispose();
    };
    DragDropHelper.prototype._onDragEnd = function(target, event) {
        var options = target.options;
        if (options.onDragEnd) options.onDragEnd(options.context.data, event);
    };
    /**
     * clear drag data when mouse up on body
     */ DragDropHelper.prototype._onMouseUp = function(event) {
        this._isDragging = false;
        if (this._dragData) {
            for(var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++){
                var key = _a[_i];
                var activeTarget = this._activeTargets[key];
                if (activeTarget.target.root) {
                    this._events.off(activeTarget.target.root, "mousemove");
                    this._events.off(activeTarget.target.root, "mouseleave");
                }
            }
            if (this._dragData.dropTarget) {
                // raise dragleave event to let dropTarget know it need to remove dropping style
                (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this._dragData.dropTarget.root, "dragleave");
                (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this._dragData.dropTarget.root, "drop");
            }
        }
        this._dragData = null;
    };
    /**
     * clear drag data when mouse up outside of the document
     */ DragDropHelper.prototype._onDocumentMouseUp = function(event) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if (doc && event.target === doc.documentElement) this._onMouseUp(event);
    };
    /**
     * when mouse move over a new drop target while dragging some items,
     * fire dragleave on the old target and fire dragenter to the new target
     * The target will handle style change on dragenter and dragleave events.
     */ DragDropHelper.prototype._onMouseMove = function(target, event) {
        var // use buttons property here since ev.button in some edge case is not updating well during the move.
        // but firefox doesn't support it, so we set the default value when it is not defined.
        _a = event.buttons, // use buttons property here since ev.button in some edge case is not updating well during the move.
        // but firefox doesn't support it, so we set the default value when it is not defined.
        buttons = _a === void 0 ? $5492b08e38be5f64$var$MOUSEMOVE_PRIMARY_BUTTON : _a;
        if (this._dragData && buttons !== $5492b08e38be5f64$var$MOUSEMOVE_PRIMARY_BUTTON) {
            // cancel mouse down event and return early when the primary button is not pressed
            this._onMouseUp(event);
            return;
        }
        var root = target.root, key = target.key;
        if (this._isDragging) {
            if (this._isDroppable(target)) // we can have nested drop targets in the DOM, like a folder inside a group. In that case, when we drag into
            // the inner target (folder), we first set dropTarget to the inner element. But the same event is bubbled to the
            // outer target too, and we need to prevent the outer one from taking over.
            // So, check if the last dropTarget is not a child of the current.
            {
                if (this._dragData) {
                    if (this._dragData.dropTarget && this._dragData.dropTarget.key !== key && !this._isChild(root, this._dragData.dropTarget.root)) {
                        if (this._dragEnterCounts[this._dragData.dropTarget.key] > 0) {
                            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this._dragData.dropTarget.root, "dragleave");
                            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(root, "dragenter");
                            this._dragData.dropTarget = target;
                        }
                    }
                }
            }
        }
    };
    /**
     * when mouse leave a target while dragging some items, fire dragleave to the target
     */ DragDropHelper.prototype._onMouseLeave = function(target, event) {
        if (this._isDragging) {
            if (this._dragData && this._dragData.dropTarget && this._dragData.dropTarget.key === target.key) {
                (0, $7e392406ee2126b8$export$7af5106782f53286).raise(target.root, "dragleave");
                this._dragData.dropTarget = undefined;
            }
        }
    };
    /**
     * when mouse down on a draggable item, we start to track dragdata.
     */ DragDropHelper.prototype._onMouseDown = function(target, event) {
        if (event.button !== $5492b08e38be5f64$var$MOUSEDOWN_PRIMARY_BUTTON) // Ignore anything except the primary button.
        return;
        if (this._isDraggable(target)) {
            this._dragData = {
                clientX: event.clientX,
                clientY: event.clientY,
                eventTarget: event.target,
                dragTarget: target
            };
            for(var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++){
                var key = _a[_i];
                var activeTarget = this._activeTargets[key];
                if (activeTarget.target.root) {
                    this._events.on(activeTarget.target.root, "mousemove", this._onMouseMove.bind(this, activeTarget.target));
                    this._events.on(activeTarget.target.root, "mouseleave", this._onMouseLeave.bind(this, activeTarget.target));
                }
            }
        } else this._dragData = null;
    };
    /**
     * determine whether the child target is a descendant of the parent
     */ DragDropHelper.prototype._isChild = function(parentElement, childElement) {
        while(childElement && childElement.parentElement){
            if (childElement.parentElement === parentElement) return true;
            childElement = childElement.parentElement;
        }
        return false;
    };
    DragDropHelper.prototype._isDraggable = function(target) {
        var options = target.options;
        return !!(options.canDrag && options.canDrag(options.context.data));
    };
    DragDropHelper.prototype._isDroppable = function(target) {
        // TODO: take the drag item into consideration to prevent dragging an item into the same group
        var options = target.options;
        var dragContext = this._dragData && this._dragData.dragTarget ? this._dragData.dragTarget.options.context : undefined;
        return !!(options.canDrop && options.canDrop(options.context, dragContext));
    };
    return DragDropHelper;
}();





var $acw62 = parcelRequire("acw62");




var $33bf610c4b4a7f8c$var$MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var $33bf610c4b4a7f8c$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $33bf610c4b4a7f8c$var$TRANSITION_DURATION_DRAG = 200; // ms
var $33bf610c4b4a7f8c$var$TRANSITION_DURATION_DROP = 1500; // ms
var $33bf610c4b4a7f8c$var$CLASSNAME_ADD_INTERVAL = 20; // ms
var $33bf610c4b4a7f8c$var$defaultOnRenderHeader = function(classNames) {
    return function(props) {
        if (!props) return null;
        if (props.column.isIconOnly) return $acw62.createElement("span", {
            className: classNames.accessibleLabel
        }, props.column.name);
        return $acw62.createElement($acw62.Fragment, null, props.column.name);
    };
};
/**
 * Component for rendering columns in a `DetailsList`.
 *
 * {@docCategory DetailsList}
 */ var $33bf610c4b4a7f8c$export$da3fd0a68adbb840 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DetailsColumnBase, _super);
    function DetailsColumnBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._tooltipRef = $acw62.createRef();
        _this._onRenderFilterIcon = function(classNames) {
            return function(props) {
                var columnProps = props.columnProps, iconProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
                    "columnProps"
                ]);
                var IconComponent = (columnProps === null || columnProps === void 0 ? void 0 : columnProps.useFastIcons) ? (0, $eec83b0087c5fe87$export$f56ea46797033f60) : (0, $4b3e235077c5b552$export$f04a61298a47a40f);
                return $acw62.createElement(IconComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, iconProps));
            };
        };
        _this._onRenderColumnHeaderTooltip = function(tooltipHostProps) {
            return $acw62.createElement("span", {
                className: tooltipHostProps.hostClassName
            }, tooltipHostProps.children);
        };
        _this._onColumnClick = function(ev) {
            var _a = _this.props, onColumnClick = _a.onColumnClick, column = _a.column;
            if (column.columnActionsMode === (0, $5103473855f147d2$export$e393753d4e31e51).disabled) return;
            if (column.onColumnClick) column.onColumnClick(ev, column);
            if (onColumnClick) onColumnClick(ev, column);
        };
        _this._onColumnBlur = function() {
            _this._tooltipRef.current && _this._tooltipRef.current.dismiss();
        };
        _this._onColumnFocus = function() {
            _this._tooltipRef.current && _this._tooltipRef.current.show();
        };
        _this._onDragStart = function(item, itemIndex, selectedItems, event) {
            var classNames = _this._classNames;
            if (itemIndex) {
                _this._updateHeaderDragInfo(itemIndex);
                _this._root.current.classList.add(classNames.borderWhileDragging);
                _this._async.setTimeout(function() {
                    if (_this._root.current) _this._root.current.classList.add(classNames.noBorderWhileDragging);
                }, $33bf610c4b4a7f8c$var$CLASSNAME_ADD_INTERVAL);
            }
        };
        _this._onDragEnd = function(item, event) {
            var classNames = _this._classNames;
            if (event) _this._updateHeaderDragInfo(-1, event);
            _this._root.current.classList.remove(classNames.borderWhileDragging);
            _this._root.current.classList.remove(classNames.noBorderWhileDragging);
        };
        _this._updateHeaderDragInfo = function(itemIndex, event) {
            /* eslint-disable deprecation/deprecation */ if (_this.props.setDraggedItemIndex) _this.props.setDraggedItemIndex(itemIndex);
            /* eslint-enable deprecation/deprecation */ if (_this.props.updateDragInfo) _this.props.updateDragInfo({
                itemIndex: itemIndex
            }, event);
        };
        _this._onColumnContextMenu = function(ev) {
            var _a = _this.props, onColumnContextMenu = _a.onColumnContextMenu, column = _a.column;
            if (column.onColumnContextMenu) {
                column.onColumnContextMenu(column, ev);
                ev.preventDefault();
            }
            if (onColumnContextMenu) {
                onColumnContextMenu(column, ev);
                ev.preventDefault();
            }
        };
        _this._onRootMouseDown = function(ev) {
            var isDraggable = _this.props.isDraggable;
            // Ignore anything except the primary button.
            if (isDraggable && ev.button === $33bf610c4b4a7f8c$var$MOUSEDOWN_PRIMARY_BUTTON) ev.stopPropagation();
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        return _this;
    }
    DetailsColumnBase.prototype.render = function() {
        var _a = this.props, column = _a.column, parentId = _a.parentId, isDraggable = _a.isDraggable, styles = _a.styles, theme = _a.theme, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _b, _c = _a.useFastIcons, useFastIcons = _c === void 0 ? true : _c;
        var _d = this.props.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _d === void 0 ? this._onRenderColumnHeaderTooltip : _d;
        this._classNames = $33bf610c4b4a7f8c$var$getClassNames(styles, {
            theme: theme,
            headerClassName: column.headerClassName,
            iconClassName: column.iconClassName,
            isActionable: column.columnActionsMode !== (0, $5103473855f147d2$export$e393753d4e31e51).disabled,
            isEmpty: !column.name,
            isIconVisible: column.isSorted || column.isGrouped || column.isFiltered,
            isPadded: column.isPadded,
            isIconOnly: column.isIconOnly,
            cellStyleProps: cellStyleProps,
            transitionDurationDrag: $33bf610c4b4a7f8c$var$TRANSITION_DURATION_DRAG,
            transitionDurationDrop: $33bf610c4b4a7f8c$var$TRANSITION_DURATION_DROP
        });
        var classNames = this._classNames;
        var IconComponent = useFastIcons ? (0, $eec83b0087c5fe87$export$f56ea46797033f60) : (0, $4b3e235077c5b552$export$f04a61298a47a40f);
        var onRenderFilterIcon = column.onRenderFilterIcon ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(column.onRenderFilterIcon, this._onRenderFilterIcon(this._classNames)) : this._onRenderFilterIcon(this._classNames);
        var onRenderHeader = column.onRenderHeader ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(column.onRenderHeader, $33bf610c4b4a7f8c$var$defaultOnRenderHeader(this._classNames)) : $33bf610c4b4a7f8c$var$defaultOnRenderHeader(this._classNames);
        var hasInnerButton = column.columnActionsMode !== (0, $5103473855f147d2$export$e393753d4e31e51).disabled && (column.onColumnClick !== undefined || this.props.onColumnClick !== undefined);
        // use aria-describedby to point to the tooltip if the tooltip is not using the ariaLabel string
        var shouldAssociateTooltip = this.props.onRenderColumnHeaderTooltip ? !column.ariaLabel : this._hasAccessibleDescription();
        var accNameDescription = {
            "aria-label": column.ariaLabel ? column.ariaLabel : column.isIconOnly ? column.name : undefined,
            "aria-labelledby": column.ariaLabel || column.isIconOnly ? undefined : "".concat(parentId, "-").concat(column.key, "-name"),
            "aria-describedby": shouldAssociateTooltip ? "".concat(parentId, "-").concat(column.key, "-tooltip") : undefined
        };
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            key: column.key,
            ref: this._root,
            role: "columnheader"
        }, !hasInnerButton && accNameDescription, {
            "aria-sort": column.isSorted ? column.isSortedDescending ? "descending" : "ascending" : "none",
            "data-is-focusable": !hasInnerButton && column.columnActionsMode !== (0, $5103473855f147d2$export$e393753d4e31e51).disabled ? "true" : undefined,
            className: classNames.root,
            "data-is-draggable": isDraggable,
            draggable: isDraggable,
            style: {
                width: column.calculatedWidth + cellStyleProps.cellLeftPadding + cellStyleProps.cellRightPadding + (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0)
            },
            "data-automationid": "ColumnsHeaderColumn",
            "data-item-key": column.key,
            onBlur: this._onColumnBlur,
            onFocus: this._onColumnFocus
        }), isDraggable && $acw62.createElement(IconComponent, {
            iconName: "GripperBarVertical",
            className: classNames.gripperBarVerticalStyle
        }), onRenderColumnHeaderTooltip({
            hostClassName: classNames.cellTooltip,
            id: "".concat(parentId, "-").concat(column.key, "-tooltip"),
            setAriaDescribedBy: false,
            column: column,
            componentRef: this._tooltipRef,
            content: column.columnActionsMode !== (0, $5103473855f147d2$export$e393753d4e31e51).disabled ? column.ariaLabel : "",
            children: $acw62.createElement("span", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                id: "".concat(parentId, "-").concat(column.key),
                className: classNames.cellTitle,
                "data-is-focusable": hasInnerButton && column.columnActionsMode !== (0, $5103473855f147d2$export$e393753d4e31e51).disabled ? "true" : undefined,
                role: hasInnerButton ? "button" : undefined
            }, hasInnerButton && accNameDescription, {
                onContextMenu: this._onColumnContextMenu,
                onClick: this._onColumnClick,
                "aria-haspopup": column.columnActionsMode === (0, $5103473855f147d2$export$e393753d4e31e51).hasDropdown ? "menu" : undefined,
                "aria-expanded": column.columnActionsMode === (0, $5103473855f147d2$export$e393753d4e31e51).hasDropdown ? !!column.isMenuOpen : undefined
            }), $acw62.createElement("span", {
                id: "".concat(parentId, "-").concat(column.key, "-name"),
                className: classNames.cellName
            }, (column.iconName || column.iconClassName) && $acw62.createElement(IconComponent, {
                className: classNames.iconClassName,
                iconName: column.iconName
            }), onRenderHeader(this.props)), column.isFiltered && $acw62.createElement(IconComponent, {
                className: classNames.nearIcon,
                iconName: "Filter"
            }), (column.isSorted || column.showSortIconWhenUnsorted) && $acw62.createElement(IconComponent, {
                className: classNames.sortIcon,
                iconName: column.isSorted ? column.isSortedDescending ? "SortDown" : "SortUp" : "Sort"
            }), column.isGrouped && $acw62.createElement(IconComponent, {
                className: classNames.nearIcon,
                iconName: "GroupedDescending"
            }), column.columnActionsMode === (0, $5103473855f147d2$export$e393753d4e31e51).hasDropdown && !column.isIconOnly && onRenderFilterIcon({
                "aria-hidden": true,
                columnProps: this.props,
                className: classNames.filterChevron,
                iconName: "ChevronDown"
            }))
        }, this._onRenderColumnHeaderTooltip)), !this.props.onRenderColumnHeaderTooltip ? this._renderAccessibleDescription() : null);
    };
    DetailsColumnBase.prototype.componentDidMount = function() {
        var _this = this;
        if (this.props.dragDropHelper && this.props.isDraggable) this._addDragDropHandling();
        var classNames = this._classNames;
        if (this.props.isDropped) {
            if (this._root.current) {
                this._root.current.classList.add(classNames.borderAfterDropping);
                this._async.setTimeout(function() {
                    if (_this._root.current) _this._root.current.classList.add(classNames.noBorderAfterDropping);
                }, $33bf610c4b4a7f8c$var$CLASSNAME_ADD_INTERVAL);
            }
            this._async.setTimeout(function() {
                if (_this._root.current) {
                    _this._root.current.classList.remove(classNames.borderAfterDropping);
                    _this._root.current.classList.remove(classNames.noBorderAfterDropping);
                }
            }, $33bf610c4b4a7f8c$var$TRANSITION_DURATION_DROP + $33bf610c4b4a7f8c$var$CLASSNAME_ADD_INTERVAL);
        }
    };
    DetailsColumnBase.prototype.componentWillUnmount = function() {
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
            delete this._dragDropSubscription;
        }
        this._async.dispose();
        this._events.dispose();
    };
    DetailsColumnBase.prototype.componentDidUpdate = function() {
        if (!this._dragDropSubscription && this.props.dragDropHelper && this.props.isDraggable) this._addDragDropHandling();
        if (this._dragDropSubscription && !this.props.isDraggable) {
            this._dragDropSubscription.dispose();
            this._events.off(this._root.current, "mousedown");
            delete this._dragDropSubscription;
        }
    };
    DetailsColumnBase.prototype._getColumnDragDropOptions = function() {
        var _this = this;
        var columnIndex = this.props.columnIndex;
        var options = {
            selectionIndex: columnIndex,
            context: {
                data: columnIndex,
                index: columnIndex
            },
            canDrag: function() {
                return _this.props.isDraggable;
            },
            canDrop: function() {
                return false;
            },
            onDragStart: this._onDragStart,
            updateDropState: function() {
                return undefined;
            },
            onDrop: function() {
                return undefined;
            },
            onDragEnd: this._onDragEnd
        };
        return options;
    };
    DetailsColumnBase.prototype._hasAccessibleDescription = function() {
        var column = this.props.column;
        return !!(column.filterAriaLabel || column.sortAscendingAriaLabel || column.sortDescendingAriaLabel || column.groupAriaLabel || column.sortableAriaLabel);
    };
    DetailsColumnBase.prototype._renderAccessibleDescription = function() {
        var _a = this.props, column = _a.column, parentId = _a.parentId;
        var classNames = this._classNames;
        return this._hasAccessibleDescription() && !this.props.onRenderColumnHeaderTooltip ? $acw62.createElement("label", {
            key: "".concat(column.key, "_label"),
            id: "".concat(parentId, "-").concat(column.key, "-tooltip"),
            className: classNames.accessibleLabel,
            hidden: true
        }, column.isFiltered && column.filterAriaLabel || null, (column.isSorted || column.showSortIconWhenUnsorted) && (column.isSorted ? column.isSortedDescending ? column.sortDescendingAriaLabel : column.sortAscendingAriaLabel : column.sortableAriaLabel) || null, column.isGrouped && column.groupAriaLabel || null) : null;
    };
    DetailsColumnBase.prototype._addDragDropHandling = function() {
        this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getColumnDragDropOptions());
        // We need to use native on this to prevent MarqueeSelection from handling the event before us.
        this._events.on(this._root.current, "mousedown", this._onRootMouseDown);
    };
    return DetailsColumnBase;
}($acw62.Component);






var $43bd98c75ddf9bc1$var$GlobalClassNames = {
    isActionable: "is-actionable",
    cellIsCheck: "ms-DetailsHeader-cellIsCheck",
    collapseButton: "ms-DetailsHeader-collapseButton",
    isCollapsed: "is-collapsed",
    isAllSelected: "is-allSelected",
    isSelectAllHidden: "is-selectAllHidden",
    isResizingColumn: "is-resizingColumn",
    isEmpty: "is-empty",
    isIconVisible: "is-icon-visible",
    cellSizer: "ms-DetailsHeader-cellSizer",
    isResizing: "is-resizing",
    dropHintCircleStyle: "ms-DetailsHeader-dropHintCircleStyle",
    dropHintLineStyle: "ms-DetailsHeader-dropHintLineStyle",
    cellTitle: "ms-DetailsHeader-cellTitle",
    cellName: "ms-DetailsHeader-cellName",
    filterChevron: "ms-DetailsHeader-filterChevron",
    gripperBarVerticalStyle: "ms-DetailsColumn-gripperBar",
    nearIcon: "ms-DetailsColumn-nearIcon"
};
var $43bd98c75ddf9bc1$export$c60205c6d8d0f1c1 = function(props) {
    var _a;
    var theme = props.theme, headerClassName = props.headerClassName, iconClassName = props.iconClassName, isActionable = props.isActionable, isEmpty = props.isEmpty, isIconVisible = props.isIconVisible, isPadded = props.isPadded, isIconOnly = props.isIconOnly, _b = props.cellStyleProps, cellStyleProps = _b === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _b, transitionDurationDrag = props.transitionDurationDrag, transitionDurationDrop = props.transitionDurationDrop;
    var semanticColors = theme.semanticColors, palette = theme.palette, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($43bd98c75ddf9bc1$var$GlobalClassNames, theme);
    var colors = {
        iconForegroundColor: semanticColors.bodySubtext,
        headerForegroundColor: semanticColors.bodyText,
        headerBackgroundColor: semanticColors.bodyBackground,
        dropdownChevronForegroundColor: palette.neutralSecondary,
        resizerColor: palette.neutralTertiaryAlt
    };
    var nearIconStyle = {
        color: colors.iconForegroundColor,
        opacity: 1,
        paddingLeft: 8
    };
    var borderWhileDragging = {
        outline: "1px solid ".concat(palette.themePrimary)
    };
    var borderAfterDragOrDrop = {
        outlineColor: "transparent"
    };
    return {
        root: [
            (0, $640dfc589ffc2fb9$export$cbecc5fa687c7fad)(props),
            fonts.small,
            isActionable && [
                classNames.isActionable,
                {
                    selectors: {
                        ":hover": {
                            color: semanticColors.bodyText,
                            background: semanticColors.listHeaderBackgroundHovered
                        },
                        ":active": {
                            background: semanticColors.listHeaderBackgroundPressed
                        }
                    }
                }
            ],
            isEmpty && [
                classNames.isEmpty,
                {
                    textOverflow: "clip"
                }
            ],
            isIconVisible && classNames.isIconVisible,
            isPadded && {
                paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
            },
            {
                selectors: {
                    ':hover i[data-icon-name="GripperBarVertical"]': {
                        display: "block"
                    }
                }
            },
            headerClassName
        ],
        gripperBarVerticalStyle: {
            display: "none",
            position: "absolute",
            textAlign: "left",
            color: palette.neutralTertiary,
            left: 1
        },
        nearIcon: [
            classNames.nearIcon,
            nearIconStyle
        ],
        sortIcon: [
            nearIconStyle,
            {
                paddingLeft: 4,
                position: "relative",
                top: 1
            }
        ],
        iconClassName: [
            {
                color: colors.iconForegroundColor,
                opacity: 1
            },
            iconClassName
        ],
        filterChevron: [
            classNames.filterChevron,
            {
                color: colors.dropdownChevronForegroundColor,
                paddingLeft: 6,
                verticalAlign: "middle",
                fontSize: fonts.small.fontSize
            }
        ],
        cellTitle: [
            classNames.cellTitle,
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "stretch",
                boxSizing: "border-box",
                overflow: "hidden",
                padding: "0 ".concat(cellStyleProps.cellRightPadding, "px 0 ").concat(cellStyleProps.cellLeftPadding, "px")
            }, isIconOnly ? {
                alignContent: "flex-end",
                maxHeight: "100%",
                flexWrap: "wrap-reverse"
            } : {})
        ],
        cellName: [
            classNames.cellName,
            {
                flex: "0 1 auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                fontSize: fonts.medium.fontSize
            },
            isIconOnly && {
                selectors: (_a = {}, _a[".".concat(classNames.nearIcon)] = {
                    paddingLeft: 0
                }, _a)
            }
        ],
        cellTooltip: {
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        },
        accessibleLabel: (0, $34563ae103a23d08$export$35835471cbe77db4),
        borderWhileDragging: borderWhileDragging,
        noBorderWhileDragging: [
            borderAfterDragOrDrop,
            {
                transition: "outline ".concat(transitionDurationDrag, "ms ease")
            }
        ],
        borderAfterDropping: borderWhileDragging,
        noBorderAfterDropping: [
            borderAfterDragOrDrop,
            {
                transition: "outline  ".concat(transitionDurationDrop, "ms ease")
            }
        ]
    };
};


var $296c4509d6c09677$export$ce3f8189a0f5d6ca = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $33bf610c4b4a7f8c$export$da3fd0a68adbb840), (0, $43bd98c75ddf9bc1$export$c60205c6d8d0f1c1), undefined, {
    scope: "DetailsColumn"
});


/**
 * {@docCategory DetailsList}
 */ var $96493c0d430c7ced$export$3befb9acac112094;
(function(SelectAllVisibility) {
    SelectAllVisibility[SelectAllVisibility["none"] = 0] = "none";
    SelectAllVisibility[SelectAllVisibility["hidden"] = 1] = "hidden";
    SelectAllVisibility[SelectAllVisibility["visible"] = 2] = "visible";
})($96493c0d430c7ced$export$3befb9acac112094 || ($96493c0d430c7ced$export$3befb9acac112094 = {}));


var $dec2eb00d1b353a8$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $dec2eb00d1b353a8$var$MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var $dec2eb00d1b353a8$var$MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
var $dec2eb00d1b353a8$var$NO_COLUMNS = [];
var $dec2eb00d1b353a8$export$cd37f9e445db4800 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DetailsHeaderBase, _super);
    function DetailsHeaderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootElement = $acw62.createRef();
        _this._rootComponent = $acw62.createRef();
        _this._draggedColumnIndex = -1;
        _this._dropHintDetails = {};
        _this._updateDroppingState = function(newValue, event) {
            if (_this._draggedColumnIndex >= 0 && event.type !== "drop" && !newValue) _this._resetDropHints();
        };
        _this._onDragOver = function(item, event) {
            if (_this._draggedColumnIndex >= 0) {
                event.stopPropagation();
                _this._computeDropHintToBeShown(event.clientX);
            }
        };
        _this._onDrop = function(item, event) {
            // Safe to assume this is defined since we're handling a drop event
            var columnReorderProps = _this._getColumnReorderProps();
            // Target index will not get changed if draggeditem is after target item.
            if (_this._draggedColumnIndex >= 0 && event) {
                var targetIndex = _this._draggedColumnIndex > _this._currentDropHintIndex ? _this._currentDropHintIndex : _this._currentDropHintIndex - 1;
                var isValidDrop = _this._isValidCurrentDropHintIndex();
                event.stopPropagation();
                if (isValidDrop) {
                    _this._onDropIndexInfo.sourceIndex = _this._draggedColumnIndex;
                    _this._onDropIndexInfo.targetIndex = targetIndex;
                    if (columnReorderProps.onColumnDrop) {
                        var dragDropDetails = {
                            draggedIndex: _this._draggedColumnIndex,
                            targetIndex: targetIndex
                        };
                        columnReorderProps.onColumnDrop(dragDropDetails);
                    /* eslint-disable deprecation/deprecation */ } else if (columnReorderProps.handleColumnReorder) columnReorderProps.handleColumnReorder(_this._draggedColumnIndex, targetIndex);
                }
            }
            _this._resetDropHints();
            _this._dropHintDetails = {};
            _this._draggedColumnIndex = -1;
        };
        _this._computeColumnIndexOffset = function(showCheckbox) {
            var hasGroupExpander = _this.props.groupNestingDepth && _this.props.groupNestingDepth > 0;
            var offset = 1;
            if (showCheckbox) offset += 1;
            if (hasGroupExpander) offset += 1;
            return offset;
        };
        _this._updateDragInfo = function(props, event) {
            // Safe to assume this is defined since we're handling a drag event
            var columnReorderProps = _this._getColumnReorderProps();
            var itemIndex = props.itemIndex;
            if (itemIndex >= 0) {
                // Column index is set based on the checkbox
                _this._draggedColumnIndex = itemIndex - _this._computeColumnIndexOffset(!_this._isCheckboxColumnHidden());
                _this._getDropHintPositions();
                if (columnReorderProps.onColumnDragStart) columnReorderProps.onColumnDragStart(true);
            } else if (event && _this._draggedColumnIndex >= 0) {
                _this._resetDropHints();
                _this._draggedColumnIndex = -1;
                _this._dropHintDetails = {};
                if (columnReorderProps.onColumnDragEnd) {
                    var columnDragEndLocation = _this._isEventOnHeader(event);
                    columnReorderProps.onColumnDragEnd({
                        dropLocation: columnDragEndLocation
                    }, event);
                }
            }
        };
        _this._getDropHintPositions = function() {
            var _a = _this.props.columns, columns = _a === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _a;
            // Safe to assume this is defined since we're handling a drag/drop event
            var columnReorderProps = _this._getColumnReorderProps();
            var prevX = 0;
            var prevMid = 0;
            var prevRef;
            var frozenColumnCountFromStart = columnReorderProps.frozenColumnCountFromStart || 0;
            var frozenColumnCountFromEnd = columnReorderProps.frozenColumnCountFromEnd || 0;
            for(var i = frozenColumnCountFromStart; i < columns.length - frozenColumnCountFromEnd + 1; i++)if (_this._rootElement.current) {
                var dropHintElement = _this._rootElement.current.querySelectorAll("#columnDropHint_" + i)[0];
                if (dropHintElement) {
                    if (i === frozenColumnCountFromStart) {
                        prevX = dropHintElement.offsetLeft;
                        prevMid = dropHintElement.offsetLeft;
                        prevRef = dropHintElement;
                    } else {
                        var newMid = (dropHintElement.offsetLeft + prevX) / 2;
                        _this._dropHintDetails[i - 1] = {
                            originX: prevX,
                            startX: prevMid,
                            endX: newMid,
                            dropHintElementRef: prevRef
                        };
                        prevMid = newMid;
                        prevRef = dropHintElement;
                        prevX = dropHintElement.offsetLeft;
                        if (i === columns.length - frozenColumnCountFromEnd) _this._dropHintDetails[i] = {
                            originX: prevX,
                            startX: prevMid,
                            endX: dropHintElement.offsetLeft,
                            dropHintElementRef: prevRef
                        };
                    }
                }
            }
        };
        /**
         * Based on the given cursor position, finds the nearest drop hint and updates the state to make it visible
         */ _this._computeDropHintToBeShown = function(clientX) {
            var isRtl = (0, $723d0744d8fe4fde$export$b2303637e9533380)(_this.props.theme);
            if (_this._rootElement.current) {
                var clientRect = _this._rootElement.current.getBoundingClientRect();
                var headerOriginX = clientRect.left;
                var eventXRelativePosition = clientX - headerOriginX;
                var currentDropHintIndex = _this._currentDropHintIndex;
                if (_this._isValidCurrentDropHintIndex()) {
                    if ($dec2eb00d1b353a8$var$_liesBetween(isRtl, eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex].startX, _this._dropHintDetails[currentDropHintIndex].endX)) return;
                }
                var _a = _this.props.columns, columns = _a === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _a;
                // Safe to assume this is defined since we're handling a drag/drop event
                var columnReorderProps = _this._getColumnReorderProps();
                var frozenColumnCountFromStart = columnReorderProps.frozenColumnCountFromStart || 0;
                var frozenColumnCountFromEnd = columnReorderProps.frozenColumnCountFromEnd || 0;
                var currentIndex = frozenColumnCountFromStart;
                var lastValidColumn = columns.length - frozenColumnCountFromEnd;
                var indexToUpdate = -1;
                if ($dec2eb00d1b353a8$var$_isBefore(isRtl, eventXRelativePosition, _this._dropHintDetails[currentIndex].endX)) indexToUpdate = currentIndex;
                else if ($dec2eb00d1b353a8$var$_isAfter(isRtl, eventXRelativePosition, _this._dropHintDetails[lastValidColumn].startX)) indexToUpdate = lastValidColumn;
                else if (_this._isValidCurrentDropHintIndex()) {
                    if (_this._dropHintDetails[currentDropHintIndex + 1] && $dec2eb00d1b353a8$var$_liesBetween(isRtl, eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex + 1].startX, _this._dropHintDetails[currentDropHintIndex + 1].endX)) indexToUpdate = currentDropHintIndex + 1;
                    else if (_this._dropHintDetails[currentDropHintIndex - 1] && $dec2eb00d1b353a8$var$_liesBetween(isRtl, eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex - 1].startX, _this._dropHintDetails[currentDropHintIndex - 1].endX)) indexToUpdate = currentDropHintIndex - 1;
                }
                if (indexToUpdate === -1) {
                    var startIndex = frozenColumnCountFromStart;
                    var endIndex = lastValidColumn;
                    while(startIndex < endIndex){
                        var middleIndex = Math.ceil((endIndex + startIndex) / 2);
                        if ($dec2eb00d1b353a8$var$_liesBetween(isRtl, eventXRelativePosition, _this._dropHintDetails[middleIndex].startX, _this._dropHintDetails[middleIndex].endX)) {
                            indexToUpdate = middleIndex;
                            break;
                        } else if ($dec2eb00d1b353a8$var$_isBefore(isRtl, eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) endIndex = middleIndex;
                        else if ($dec2eb00d1b353a8$var$_isAfter(isRtl, eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) startIndex = middleIndex;
                    }
                }
                if (indexToUpdate === _this._draggedColumnIndex || indexToUpdate === _this._draggedColumnIndex + 1) {
                    if (_this._isValidCurrentDropHintIndex()) _this._resetDropHints();
                } else if (currentDropHintIndex !== indexToUpdate && indexToUpdate >= 0) {
                    _this._resetDropHints();
                    _this._updateDropHintElement(_this._dropHintDetails[indexToUpdate].dropHintElementRef, "inline-block");
                    _this._currentDropHintIndex = indexToUpdate;
                }
            }
        };
        _this._renderColumnSizer = function(_a) {
            var _b;
            var columnIndex = _a.columnIndex;
            var _c = _this.props.columns, columns = _c === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _c;
            var column = columns[columnIndex];
            var columnResizeDetails = _this.state.columnResizeDetails;
            var classNames = _this._classNames;
            return column.isResizable ? $acw62.createElement("div", {
                key: "".concat(column.key, "_sizer"),
                "aria-hidden": true,
                role: "button",
                "data-is-focusable": false,
                onClick: $dec2eb00d1b353a8$var$_stopPropagation,
                "data-sizer-index": columnIndex,
                onBlur: _this._onSizerBlur,
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.cellSizer, columnIndex < columns.length - 1 ? classNames.cellSizerStart : classNames.cellSizerEnd, (_b = {}, _b[classNames.cellIsResizing] = columnResizeDetails && columnResizeDetails.columnIndex === columnIndex, _b)),
                onDoubleClick: _this._onSizerDoubleClick.bind(_this, columnIndex)
            }) : null;
        };
        _this._onRenderColumnHeaderTooltip = function(tooltipHostProps) {
            return $acw62.createElement("span", {
                className: tooltipHostProps.hostClassName
            }, tooltipHostProps.children);
        };
        /**
         * Called when the select all toggle is clicked.
         */ _this._onSelectAllClicked = function() {
            var selection = _this.props.selection;
            if (selection) selection.toggleAllSelected();
        };
        _this._onRootMouseDown = function(ev) {
            var columnIndexAttr = ev.target.getAttribute("data-sizer-index");
            var columnIndex = Number(columnIndexAttr);
            var _a = _this.props.columns, columns = _a === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _a;
            if (columnIndexAttr === null || ev.button !== $dec2eb00d1b353a8$var$MOUSEDOWN_PRIMARY_BUTTON) // Ignore anything except the primary button.
            return;
            _this.setState({
                columnResizeDetails: {
                    columnIndex: columnIndex,
                    columnMinWidth: columns[columnIndex].calculatedWidth,
                    originX: ev.clientX
                }
            });
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._onRootMouseMove = function(ev) {
            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
            if (columnResizeDetails && !isSizing && ev.clientX !== columnResizeDetails.originX) _this.setState({
                isSizing: true
            });
        };
        _this._onRootKeyDown = function(ev) {
            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
            var _b = _this.props, _c = _b.columns, columns = _c === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _c, onColumnResized = _b.onColumnResized;
            var columnIndexAttr = ev.target.getAttribute("data-sizer-index");
            if (!columnIndexAttr || isSizing) return;
            var columnIndex = Number(columnIndexAttr);
            if (!columnResizeDetails) // eslint-disable-next-line deprecation/deprecation
            {
                if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
                    _this.setState({
                        columnResizeDetails: {
                            columnIndex: columnIndex,
                            columnMinWidth: columns[columnIndex].calculatedWidth
                        }
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else {
                var increment = void 0;
                // eslint-disable-next-line deprecation/deprecation
                if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
                    _this.setState({
                        columnResizeDetails: undefined
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                // eslint-disable-next-line deprecation/deprecation
                } else if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).left) increment = (0, $723d0744d8fe4fde$export$b2303637e9533380)(_this.props.theme) ? 1 : -1;
                else if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).right) increment = (0, $723d0744d8fe4fde$export$b2303637e9533380)(_this.props.theme) ? -1 : 1;
                if (increment) {
                    if (!ev.shiftKey) increment *= 10;
                    _this.setState({
                        columnResizeDetails: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, columnResizeDetails), {
                            columnMinWidth: columnResizeDetails.columnMinWidth + increment
                        })
                    });
                    if (onColumnResized) onColumnResized(columns[columnIndex], columnResizeDetails.columnMinWidth + increment, columnIndex);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        /**
         * mouse move event handler in the header
         * it will set isSizing state to true when user clicked on the sizer and move the mouse.
         *
         * @param ev - mouse move event
         */ _this._onSizerMouseMove = function(ev) {
            var // use buttons property here since ev.button in some edge case is not upding well during the move.
            // but firefox doesn't support it, so we set the default value when it is not defined.
            buttons = ev.buttons;
            var _a = _this.props, onColumnIsSizingChanged = _a.onColumnIsSizingChanged, onColumnResized = _a.onColumnResized, _b = _a.columns, columns = _b === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _b;
            var columnResizeDetails = _this.state.columnResizeDetails;
            if (buttons !== undefined && buttons !== $dec2eb00d1b353a8$var$MOUSEMOVE_PRIMARY_BUTTON) {
                // cancel mouse down event and return early when the primary button is not pressed
                _this._onSizerMouseUp(ev);
                return;
            }
            if (ev.clientX !== columnResizeDetails.originX) {
                if (onColumnIsSizingChanged) onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], true);
            }
            if (onColumnResized) {
                var movement = ev.clientX - columnResizeDetails.originX;
                if ((0, $723d0744d8fe4fde$export$b2303637e9533380)(_this.props.theme)) movement = -movement;
                onColumnResized(columns[columnResizeDetails.columnIndex], columnResizeDetails.columnMinWidth + movement, columnResizeDetails.columnIndex);
            }
        };
        _this._onSizerBlur = function(ev) {
            var columnResizeDetails = _this.state.columnResizeDetails;
            if (columnResizeDetails) _this.setState({
                columnResizeDetails: undefined,
                isSizing: false
            });
        };
        /**
         * mouse up event handler in the header
         * clear the resize related state.
         * This is to ensure we can catch double click event
         *
         * @param ev - mouse up event
         */ _this._onSizerMouseUp = function(ev) {
            var _a = _this.props, _b = _a.columns, columns = _b === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _b, onColumnIsSizingChanged = _a.onColumnIsSizingChanged;
            var columnResizeDetails = _this.state.columnResizeDetails;
            _this.setState({
                columnResizeDetails: undefined,
                isSizing: false
            });
            if (onColumnIsSizingChanged) onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], false);
        };
        _this._onToggleCollapseAll = function() {
            var onToggleCollapseAll = _this.props.onToggleCollapseAll;
            var newCollapsed = !_this.state.isAllCollapsed;
            _this.setState({
                isAllCollapsed: newCollapsed
            });
            if (onToggleCollapseAll) onToggleCollapseAll(newCollapsed);
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this.state = {
            columnResizeDetails: undefined,
            isAllCollapsed: _this.props.isAllCollapsed,
            isAllSelected: !!_this.props.selection && _this.props.selection.isAllSelected()
        };
        _this._onDropIndexInfo = {
            sourceIndex: -1,
            targetIndex: -1
        };
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("header");
        _this._currentDropHintIndex = -1;
        // The drag drop handler won't do any work until subscribe() is called,
        // so always set it up for convenience
        _this._dragDropHelper = new (0, $5492b08e38be5f64$export$5bf245762bac788e)({
            selection: {
                getSelection: function() {
                    return;
                }
            },
            minimumPixelsForDrag: _this.props.minimumPixelsForDrag
        });
        return _this;
    }
    DetailsHeaderBase.prototype.componentDidMount = function() {
        var selection = this.props.selection;
        this._events.on(selection, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4), this._onSelectionChanged);
        // this._rootElement.current will be null in tests using react-test-renderer
        if (this._rootElement.current) {
            // We need to use native on this to prevent MarqueeSelection from handling the event before us.
            this._events.on(this._rootElement.current, "mousedown", this._onRootMouseDown);
            this._events.on(this._rootElement.current, "keydown", this._onRootKeyDown);
            if (this._getColumnReorderProps()) this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement.current, this._events, this._getHeaderDragDropOptions());
        }
    };
    DetailsHeaderBase.prototype.componentDidUpdate = function(prevProps) {
        if (this._getColumnReorderProps()) {
            if (!this._subscriptionObject && this._rootElement.current) this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement.current, this._events, this._getHeaderDragDropOptions());
        } else if (this._subscriptionObject) {
            this._subscriptionObject.dispose();
            delete this._subscriptionObject;
        }
        if (this.props !== prevProps && this._onDropIndexInfo.sourceIndex >= 0 && this._onDropIndexInfo.targetIndex >= 0) {
            var _a = prevProps.columns, previousColumns = _a === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _a;
            var _b = this.props.columns, columns = _b === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _b;
            if (previousColumns[this._onDropIndexInfo.sourceIndex].key === columns[this._onDropIndexInfo.targetIndex].key) this._onDropIndexInfo = {
                sourceIndex: -1,
                targetIndex: -1
            };
        }
        if (this.props.isAllCollapsed !== prevProps.isAllCollapsed) this.setState({
            isAllCollapsed: this.props.isAllCollapsed
        });
    };
    DetailsHeaderBase.prototype.componentWillUnmount = function() {
        if (this._subscriptionObject) {
            this._subscriptionObject.dispose();
            delete this._subscriptionObject;
        }
        this._dragDropHelper.dispose();
        this._events.dispose();
    };
    DetailsHeaderBase.prototype.render = function() {
        var _this = this;
        var _a = this.props, _b = _a.columns, columns = _b === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _b, ariaLabel = _a.ariaLabel, ariaLabelForToggleAllGroupsButton = _a.ariaLabelForToggleAllGroupsButton, ariaLabelForSelectAllCheckbox = _a.ariaLabelForSelectAllCheckbox, selectAllVisibility = _a.selectAllVisibility, ariaLabelForSelectionColumn = _a.ariaLabelForSelectionColumn, indentWidth = _a.indentWidth, onColumnClick = _a.onColumnClick, onColumnContextMenu = _a.onColumnContextMenu, _c = _a.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _c === void 0 ? this._onRenderColumnHeaderTooltip : _c, styles = _a.styles, selectionMode = _a.selectionMode, theme = _a.theme, onRenderDetailsCheckbox = _a.onRenderDetailsCheckbox, groupNestingDepth = _a.groupNestingDepth, useFastIcons = _a.useFastIcons, checkboxVisibility = _a.checkboxVisibility, className = _a.className;
        var _d = this.state, isAllSelected = _d.isAllSelected, columnResizeDetails = _d.columnResizeDetails, isSizing = _d.isSizing, isAllCollapsed = _d.isAllCollapsed;
        var showCheckbox = selectAllVisibility !== (0, $96493c0d430c7ced$export$3befb9acac112094).none;
        var isCheckboxHidden = selectAllVisibility === (0, $96493c0d430c7ced$export$3befb9acac112094).hidden;
        var isCheckboxAlwaysVisible = checkboxVisibility === (0, $5103473855f147d2$export$752592320202052a).always;
        var columnReorderProps = this._getColumnReorderProps();
        var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
        var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
        this._classNames = $dec2eb00d1b353a8$var$getClassNames(styles, {
            theme: theme,
            isAllSelected: isAllSelected,
            isSelectAllHidden: selectAllVisibility === (0, $96493c0d430c7ced$export$3befb9acac112094).hidden,
            isResizingColumn: !!columnResizeDetails && isSizing,
            isSizing: isSizing,
            isAllCollapsed: isAllCollapsed,
            isCheckboxHidden: isCheckboxHidden,
            className: className
        });
        var classNames = this._classNames;
        var IconComponent = useFastIcons ? (0, $eec83b0087c5fe87$export$f56ea46797033f60) : (0, $4b3e235077c5b552$export$f04a61298a47a40f);
        var hasGroupExpander = groupNestingDepth > 0;
        var showGroupExpander = hasGroupExpander && this.props.collapseAllVisibility === (0, $983645f52845fc75$export$64fc9da778a9842).visible;
        var columnIndexOffset = this._computeColumnIndexOffset(showCheckbox);
        var isRTL = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme);
        return $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), {
            role: "row",
            "aria-label": ariaLabel,
            className: classNames.root,
            componentRef: this._rootComponent,
            elementRef: this._rootElement,
            onMouseMove: this._onRootMouseMove,
            "data-automationid": "DetailsHeader",
            direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal
        }, showCheckbox ? [
            $acw62.createElement("div", {
                key: "__checkbox",
                className: classNames.cellIsCheck,
                "aria-labelledby": "".concat(this._id, "-checkTooltip"),
                onClick: !isCheckboxHidden ? this._onSelectAllClicked : undefined,
                role: "columnheader"
            }, onRenderColumnHeaderTooltip({
                hostClassName: classNames.checkTooltip,
                id: "".concat(this._id, "-checkTooltip"),
                setAriaDescribedBy: false,
                content: ariaLabelForSelectAllCheckbox,
                children: $acw62.createElement((0, $17354d7eb7914059$export$4b1070532488c9c6), {
                    id: "".concat(this._id, "-check"),
                    "aria-label": selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple ? ariaLabelForSelectAllCheckbox : ariaLabelForSelectionColumn,
                    "data-is-focusable": !isCheckboxHidden || undefined,
                    isHeader: true,
                    selected: isAllSelected,
                    anySelected: false,
                    canSelect: !isCheckboxHidden,
                    className: classNames.check,
                    onRenderDetailsCheckbox: onRenderDetailsCheckbox,
                    useFastIcons: useFastIcons,
                    isVisible: isCheckboxAlwaysVisible
                })
            }, this._onRenderColumnHeaderTooltip)),
            !this.props.onRenderColumnHeaderTooltip ? ariaLabelForSelectAllCheckbox && !isCheckboxHidden ? $acw62.createElement("label", {
                key: "__checkboxLabel",
                id: "".concat(this._id, "-checkTooltip"),
                className: classNames.accessibleLabel,
                "aria-hidden": true
            }, ariaLabelForSelectAllCheckbox) : ariaLabelForSelectionColumn && isCheckboxHidden ? $acw62.createElement("label", {
                key: "__checkboxLabel",
                id: "".concat(this._id, "-checkTooltip"),
                className: classNames.accessibleLabel,
                "aria-hidden": true
            }, ariaLabelForSelectionColumn) : null : null
        ] : null, showGroupExpander ? $acw62.createElement("div", {
            className: classNames.cellIsGroupExpander,
            onClick: this._onToggleCollapseAll,
            "data-is-focusable": true,
            "aria-label": ariaLabelForToggleAllGroupsButton,
            "aria-expanded": !isAllCollapsed,
            role: "columnheader"
        }, $acw62.createElement(IconComponent, {
            className: classNames.collapseButton,
            iconName: isRTL ? "ChevronLeftMed" : "ChevronRightMed"
        }), $acw62.createElement("span", {
            className: classNames.accessibleLabel
        }, ariaLabelForToggleAllGroupsButton)) : hasGroupExpander ? $acw62.createElement("div", {
            className: classNames.cellIsGroupExpander,
            "data-is-focusable": false,
            role: "columnheader"
        }) : null, $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
            indentWidth: indentWidth,
            role: "gridcell",
            count: groupNestingDepth - 1
        }), columns.map(function(column, columnIndex) {
            var _isDraggable = columnReorderProps ? columnIndex >= frozenColumnCountFromStart && columnIndex < columns.length - frozenColumnCountFromEnd : false;
            return [
                columnReorderProps && (_isDraggable || columnIndex === columns.length - frozenColumnCountFromEnd) && _this._renderDropHint(columnIndex),
                $acw62.createElement((0, $296c4509d6c09677$export$ce3f8189a0f5d6ca), {
                    column: column,
                    styles: column.styles,
                    key: column.key,
                    columnIndex: columnIndexOffset + columnIndex,
                    parentId: _this._id,
                    isDraggable: _isDraggable,
                    updateDragInfo: _this._updateDragInfo,
                    dragDropHelper: _this._dragDropHelper,
                    onColumnClick: onColumnClick,
                    onColumnContextMenu: onColumnContextMenu,
                    // Do not render tooltips by default, but allow for override via props.
                    onRenderColumnHeaderTooltip: _this.props.onRenderColumnHeaderTooltip,
                    isDropped: _this._onDropIndexInfo.targetIndex === columnIndex,
                    cellStyleProps: _this.props.cellStyleProps,
                    useFastIcons: useFastIcons
                }),
                _this._renderColumnDivider(columnIndex)
            ];
        }), columnReorderProps && frozenColumnCountFromEnd === 0 && this._renderDropHint(columns.length), isSizing && $acw62.createElement((0, $0644c419e4ac4578$export$936d0764594b6eb3), null, $acw62.createElement("div", {
            className: classNames.sizingOverlay,
            onMouseMove: this._onSizerMouseMove,
            onMouseUp: this._onSizerMouseUp
        })));
    };
    /** Set focus to the active thing in the focus area. */ DetailsHeaderBase.prototype.focus = function() {
        var _a;
        return !!((_a = this._rootComponent.current) === null || _a === void 0 ? void 0 : _a.focus());
    };
    /**
     * Gets column reorder props from this.props. If the calling code is part of setting up or
     * handling drag/drop events, it's safe to assume that this method's return value is defined
     * (because drag/drop handling will only be set up if reorder props are given).
     */ DetailsHeaderBase.prototype._getColumnReorderProps = function() {
        var _a = this.props, columnReorderOptions = _a.columnReorderOptions, columnReorderProps = _a.columnReorderProps;
        return columnReorderProps || columnReorderOptions && (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, columnReorderOptions), {
            onColumnDragEnd: undefined
        });
    };
    DetailsHeaderBase.prototype._getHeaderDragDropOptions = function() {
        var options = {
            selectionIndex: 1,
            context: {
                data: this,
                index: 0
            },
            canDrag: function() {
                return false;
            },
            canDrop: function() {
                return true;
            },
            onDragStart: function() {
                return undefined;
            },
            updateDropState: this._updateDroppingState,
            onDrop: this._onDrop,
            onDragEnd: function() {
                return undefined;
            },
            onDragOver: this._onDragOver
        };
        return options;
    };
    DetailsHeaderBase.prototype._isValidCurrentDropHintIndex = function() {
        return this._currentDropHintIndex >= 0;
    };
    /**
     * @returns whether or not the "Select All" checkbox column is hidden.
     */ DetailsHeaderBase.prototype._isCheckboxColumnHidden = function() {
        var _a = this.props, selectionMode = _a.selectionMode, checkboxVisibility = _a.checkboxVisibility;
        return selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none || checkboxVisibility === (0, $5103473855f147d2$export$752592320202052a).hidden;
    };
    DetailsHeaderBase.prototype._resetDropHints = function() {
        if (this._currentDropHintIndex >= 0) {
            this._updateDropHintElement(this._dropHintDetails[this._currentDropHintIndex].dropHintElementRef, "none");
            this._currentDropHintIndex = -1;
        }
    };
    DetailsHeaderBase.prototype._updateDropHintElement = function(element, displayProperty) {
        element.childNodes[1].style.display = displayProperty;
        element.childNodes[0].style.display = displayProperty;
    };
    DetailsHeaderBase.prototype._isEventOnHeader = function(event) {
        if (this._rootElement.current) {
            var clientRect = this._rootElement.current.getBoundingClientRect();
            if (event.clientX > clientRect.left && event.clientX < clientRect.right && event.clientY > clientRect.top && event.clientY < clientRect.bottom) return (0, $5103473855f147d2$export$24c0b55ababe9a64).header;
        }
    };
    DetailsHeaderBase.prototype._renderColumnDivider = function(columnIndex) {
        var _a = this.props.columns, columns = _a === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _a;
        var column = columns[columnIndex];
        var onRenderDivider = column.onRenderDivider;
        return onRenderDivider ? onRenderDivider({
            column: column,
            columnIndex: columnIndex
        }, this._renderColumnSizer) : this._renderColumnSizer({
            column: column,
            columnIndex: columnIndex
        });
    };
    DetailsHeaderBase.prototype._renderDropHint = function(dropHintIndex) {
        var classNames = this._classNames;
        var IconComponent = this.props.useFastIcons ? (0, $eec83b0087c5fe87$export$f56ea46797033f60) : (0, $4b3e235077c5b552$export$f04a61298a47a40f);
        return $acw62.createElement("div", {
            key: "dropHintKey",
            className: classNames.dropHintStyle,
            id: "columnDropHint_".concat(dropHintIndex)
        }, $acw62.createElement("div", {
            role: "presentation",
            key: "dropHintCircleKey",
            className: classNames.dropHintCaretStyle,
            "data-is-focusable": false,
            "data-sizer-index": dropHintIndex,
            "aria-hidden": true
        }, $acw62.createElement(IconComponent, {
            iconName: "CircleShapeSolid"
        })), $acw62.createElement("div", {
            key: "dropHintLineKey",
            "aria-hidden": true,
            "data-is-focusable": false,
            "data-sizer-index": dropHintIndex,
            className: classNames.dropHintLineStyle
        }));
    };
    /**
     * double click on the column sizer will auto ajust column width
     * to fit the longest content among current rendered rows.
     *
     * @param columnIndex - index of the column user double clicked
     * @param ev - mouse double click event
     */ DetailsHeaderBase.prototype._onSizerDoubleClick = function(columnIndex, ev) {
        var _a = this.props, onColumnAutoResized = _a.onColumnAutoResized, _b = _a.columns, columns = _b === void 0 ? $dec2eb00d1b353a8$var$NO_COLUMNS : _b;
        if (onColumnAutoResized) onColumnAutoResized(columns[columnIndex], columnIndex);
    };
    DetailsHeaderBase.prototype._onSelectionChanged = function() {
        var isAllSelected = !!this.props.selection && this.props.selection.isAllSelected();
        if (this.state.isAllSelected !== isAllSelected) this.setState({
            isAllSelected: isAllSelected
        });
    };
    DetailsHeaderBase.defaultProps = {
        selectAllVisibility: (0, $96493c0d430c7ced$export$3befb9acac112094).visible,
        collapseAllVisibility: (0, $983645f52845fc75$export$64fc9da778a9842).visible,
        useFastIcons: true
    };
    return DetailsHeaderBase;
}($acw62.Component);
function $dec2eb00d1b353a8$var$_liesBetween(rtl, target, left, right) {
    return rtl ? target <= left && target >= right : target >= left && target <= right;
}
function $dec2eb00d1b353a8$var$_isBefore(rtl, a, b) {
    return rtl ? a >= b : a <= b;
}
function $dec2eb00d1b353a8$var$_isAfter(rtl, a, b) {
    return rtl ? a <= b : a >= b;
}
function $dec2eb00d1b353a8$var$_stopPropagation(ev) {
    ev.stopPropagation();
}



var $5e9a87924c8945e7$export$56e2352e63353d99 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $dec2eb00d1b353a8$export$cd37f9e445db4800), (0, $640dfc589ffc2fb9$export$8ef77cbfb1c9df49), undefined, {
    scope: "DetailsHeader"
});






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $e0c441c4dc707c1e$var$getCellText = function(item, column) {
    var value = item && column && column.fieldName ? item[column.fieldName] : "";
    if (value === null || value === undefined) value = "";
    if (typeof value === "boolean") return value.toString();
    return value;
};
var $e0c441c4dc707c1e$export$d6a37fbf812b7307 = function(props) {
    var columns = props.columns, rowClassNames = props.rowClassNames, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _a, item = props.item, itemIndex = props.itemIndex, isSelected = props.isSelected, onRenderItemColumn = props.onRenderItemColumn, getCellValueKey = props.getCellValueKey, propsOnRenderField = props.onRenderField, cellsByColumn = props.cellsByColumn, enableUpdateAnimations = props.enableUpdateAnimations, rowHeaderId = props.rowHeaderId;
    var cellValueKeysRef = $acw62.useRef();
    var cellValueKeys = cellValueKeysRef.current || (cellValueKeysRef.current = {});
    var defaultOnRenderField = $acw62.useCallback(function(fieldProps) {
        var column = fieldProps.column, cellValueKey = fieldProps.cellValueKey, className = fieldProps.className, onRender = fieldProps.onRender, fieldItem = fieldProps.item, fieldItemIndex = fieldProps.itemIndex;
        var width = typeof column.calculatedWidth === "undefined" ? "auto" : column.calculatedWidth + cellStyleProps.cellLeftPadding + cellStyleProps.cellRightPadding + (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
        var key = "".concat(column.key).concat(cellValueKey !== undefined ? "-".concat(cellValueKey) : "");
        return $acw62.createElement("div", {
            key: key,
            id: column.isRowHeader ? rowHeaderId : undefined,
            role: column.isRowHeader ? "rowheader" : "gridcell",
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(column.className, column.isMultiline && rowClassNames.isMultiline, column.isRowHeader && rowClassNames.isRowHeader, rowClassNames.cell, column.isPadded ? rowClassNames.cellPadded : rowClassNames.cellUnpadded, className),
            style: {
                width: width
            },
            "data-automationid": "DetailsRowCell",
            "data-automation-key": column.key
        }, onRender(fieldItem, fieldItemIndex, column));
    }, [
        rowClassNames,
        cellStyleProps,
        rowHeaderId
    ]);
    return $acw62.createElement("div", {
        className: rowClassNames.fields,
        "data-automationid": "DetailsRowFields",
        role: "presentation"
    }, columns.map(function(column) {
        var _a = column.getValueKey, getValueKey = _a === void 0 ? getCellValueKey : _a;
        var onRender = cellsByColumn && column.key in cellsByColumn && function() {
            return cellsByColumn[column.key];
        } || column.onRender || onRenderItemColumn || $e0c441c4dc707c1e$var$defaultOnRender;
        var onRenderField = defaultOnRenderField;
        if (column.onRenderField) onRenderField = (0, $dcded159bee91fac$export$6427897eb70b5e23)(column.onRenderField, onRenderField);
        if (propsOnRenderField) onRenderField = (0, $dcded159bee91fac$export$6427897eb70b5e23)(propsOnRenderField, onRenderField);
        var previousValueKey = cellValueKeys[column.key];
        var cellValueKey = enableUpdateAnimations && getValueKey ? getValueKey(item, itemIndex, column) : undefined;
        var showAnimation = false;
        if (cellValueKey !== undefined && previousValueKey !== undefined && cellValueKey !== previousValueKey) showAnimation = true;
        cellValueKeys[column.key] = cellValueKey;
        return onRenderField({
            item: item,
            itemIndex: itemIndex,
            isSelected: isSelected,
            column: column,
            cellValueKey: cellValueKey,
            className: showAnimation ? rowClassNames.cellAnimation : undefined,
            onRender: onRender
        });
    }));
};
function $e0c441c4dc707c1e$var$defaultOnRender(item, index, column) {
    if (!item || !column) return null;
    return $e0c441c4dc707c1e$var$getCellText(item, column);
}




var $e2cc802734e98e56$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $e2cc802734e98e56$var$DEFAULT_DROPPING_CSS_CLASS = "is-dropping";
var $e2cc802734e98e56$var$NO_COLUMNS = [];
var $e2cc802734e98e56$export$36bfebd08eea8eed = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DetailsRowBase, _super);
    function DetailsRowBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._cellMeasurer = $acw62.createRef();
        _this._focusZone = $acw62.createRef();
        _this._onSelectionChanged = function() {
            var selectionState = $e2cc802734e98e56$var$getSelectionState(_this.props);
            if (!(0, $f504d2279336999d$export$90e866afbd6b9f1a)(selectionState, _this.state.selectionState)) _this.setState({
                selectionState: selectionState
            });
        };
        /**
         * update isDropping state based on the input value, which is used to change style during drag and drop
         *
         * when change to true, that means drag enter. we will add default dropping class name
         * or the custom dropping class name (return result from onDragEnter) to the root elemet.
         *
         * when change to false, that means drag leave. we will remove the dropping class name from root element.
         *
         * @param newValue - New isDropping state value
         * @param event - The event trigger dropping state change which can be dragenter, dragleave etc
         */ _this._updateDroppingState = function(newValue, event) {
            var isDropping = _this.state.isDropping;
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, item = _a.item;
            if (!newValue) {
                if (dragDropEvents.onDragLeave) dragDropEvents.onDragLeave(item, event);
            } else if (dragDropEvents.onDragEnter) _this._droppingClassNames = dragDropEvents.onDragEnter(item, event);
            if (isDropping !== newValue) _this.setState({
                isDropping: newValue
            });
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this.state = {
            selectionState: $e2cc802734e98e56$var$getSelectionState(props),
            columnMeasureInfo: undefined,
            isDropping: false
        };
        _this._droppingClassNames = "";
        return _this;
    }
    DetailsRowBase.getDerivedStateFromProps = function(nextProps, previousState) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), {
            selectionState: $e2cc802734e98e56$var$getSelectionState(nextProps)
        });
    };
    DetailsRowBase.prototype.componentDidMount = function() {
        var _a = this.props, dragDropHelper = _a.dragDropHelper, selection = _a.selection, item = _a.item, onDidMount = _a.onDidMount;
        if (dragDropHelper && this._root.current) this._dragDropSubscription = dragDropHelper.subscribe(this._root.current, this._events, this._getRowDragDropOptions());
        if (selection) this._events.on(selection, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4), this._onSelectionChanged);
        if (onDidMount && item) {
            // If the item appears later, we should wait for it before calling this method.
            this._onDidMountCalled = true;
            onDidMount(this);
        }
    };
    DetailsRowBase.prototype.componentDidUpdate = function(previousProps) {
        var state = this.state;
        var _a = this.props, item = _a.item, onDidMount = _a.onDidMount;
        var columnMeasureInfo = state.columnMeasureInfo;
        if (this.props.itemIndex !== previousProps.itemIndex || this.props.item !== previousProps.item || this.props.dragDropHelper !== previousProps.dragDropHelper) {
            if (this._dragDropSubscription) {
                this._dragDropSubscription.dispose();
                delete this._dragDropSubscription;
            }
            if (this.props.dragDropHelper && this._root.current) this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getRowDragDropOptions());
        }
        if (columnMeasureInfo && columnMeasureInfo.index >= 0 && this._cellMeasurer.current) {
            var newWidth = this._cellMeasurer.current.getBoundingClientRect().width;
            columnMeasureInfo.onMeasureDone(newWidth);
            this.setState({
                columnMeasureInfo: undefined
            });
        }
        if (item && onDidMount && !this._onDidMountCalled) {
            this._onDidMountCalled = true;
            onDidMount(this);
        }
    };
    DetailsRowBase.prototype.componentWillUnmount = function() {
        var _a = this.props, item = _a.item, onWillUnmount = _a.onWillUnmount;
        // Only call the onWillUnmount callback if we have an item.
        if (onWillUnmount && item) onWillUnmount(this);
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
            delete this._dragDropSubscription;
        }
        this._events.dispose();
    };
    DetailsRowBase.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        if (this.props.useReducedRowRenderer) {
            var newSelectionState = $e2cc802734e98e56$var$getSelectionState(nextProps);
            if (this.state.selectionState.isSelected !== newSelectionState.isSelected) return true;
            return !(0, $f504d2279336999d$export$90e866afbd6b9f1a)(this.props, nextProps);
        } else return true;
    };
    DetailsRowBase.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, _c = _b.columns, columns = _c === void 0 ? $e2cc802734e98e56$var$NO_COLUMNS : _c, dragDropEvents = _b.dragDropEvents, item = _b.item, itemIndex = _b.itemIndex, id = _b.id, _d = _b.flatIndexOffset, flatIndexOffset = _d === void 0 ? 2 : _d, _e = _b.onRenderCheck, onRenderCheck = _e === void 0 ? this._onRenderCheck : _e, onRenderDetailsCheckbox = _b.onRenderDetailsCheckbox, onRenderItemColumn = _b.onRenderItemColumn, onRenderField = _b.onRenderField, getCellValueKey = _b.getCellValueKey, selectionMode = _b.selectionMode, checkboxVisibility = _b.checkboxVisibility, getRowAriaLabel = _b.getRowAriaLabel, getRowAriaDescription = _b.getRowAriaDescription, getRowAriaDescribedBy = _b.getRowAriaDescribedBy, isGridRow = _b.isGridRow, checkButtonAriaLabel = _b.checkButtonAriaLabel, checkboxCellClassName = _b.checkboxCellClassName, /** Alias rowFieldsAs as RowFields and default to DetailsRowFields if rowFieldsAs does not exist */ rowFieldsAs = _b.rowFieldsAs, selection = _b.selection, indentWidth = _b.indentWidth, enableUpdateAnimations = _b.enableUpdateAnimations, compact = _b.compact, theme = _b.theme, styles = _b.styles, cellsByColumn = _b.cellsByColumn, groupNestingDepth = _b.groupNestingDepth, _f = _b.useFastIcons, useFastIcons = _f === void 0 ? true : _f, cellStyleProps = _b.cellStyleProps, group = _b.group, focusZoneProps = _b.focusZoneProps, _g = _b.disabled, disabled = _g === void 0 ? false : _g;
        var _h = this.state, columnMeasureInfo = _h.columnMeasureInfo, isDropping = _h.isDropping;
        var _j = this.state.selectionState, _k = _j.isSelected, isSelected = _k === void 0 ? false : _k, _l = _j.isSelectionModal, isSelectionModal = _l === void 0 ? false : _l;
        var isDraggable = dragDropEvents ? !!(dragDropEvents.canDrag && dragDropEvents.canDrag(item)) : undefined;
        var droppingClassName = isDropping ? this._droppingClassNames || $e2cc802734e98e56$var$DEFAULT_DROPPING_CSS_CLASS : "";
        var ariaLabel = getRowAriaLabel ? getRowAriaLabel(item) : undefined;
        var ariaRowDescription = getRowAriaDescription ? getRowAriaDescription(item) : undefined;
        var ariaDescribedBy = getRowAriaDescribedBy ? getRowAriaDescribedBy(item) : undefined;
        var canSelect = !!selection && selection.canSelectItem(item, itemIndex) && !disabled;
        var isContentUnselectable = selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple;
        var showCheckbox = selectionMode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).none && checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden;
        var ariaSelected = selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none ? undefined : isSelected;
        var ariaPositionInSet = group ? itemIndex - group.startIndex + 1 : undefined;
        var ariaSetSize = group ? group.count : undefined;
        var focusZoneDirection = focusZoneProps ? focusZoneProps.direction : (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal;
        this._classNames = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this._classNames), $e2cc802734e98e56$var$getClassNames(styles, {
            theme: theme,
            isSelected: isSelected,
            canSelect: !isContentUnselectable,
            anySelected: isSelectionModal,
            checkboxCellClassName: checkboxCellClassName,
            droppingClassName: droppingClassName,
            className: className,
            compact: compact,
            enableUpdateAnimations: enableUpdateAnimations,
            cellStyleProps: cellStyleProps,
            disabled: disabled
        }));
        var rowClassNames = {
            isMultiline: this._classNames.isMultiline,
            isRowHeader: this._classNames.isRowHeader,
            cell: this._classNames.cell,
            cellAnimation: this._classNames.cellAnimation,
            cellPadded: this._classNames.cellPadded,
            cellUnpadded: this._classNames.cellUnpadded,
            fields: this._classNames.fields
        };
        // Only re-assign rowClassNames when classNames have changed.
        // Otherwise, they will cause DetailsRowFields to unnecessarily
        // re-render, see https://github.com/microsoft/fluentui/pull/8799.
        // Refactor DetailsRowFields to generate own styles to remove need for this.
        if (!(0, $f504d2279336999d$export$90e866afbd6b9f1a)(this._rowClassNames || {}, rowClassNames)) this._rowClassNames = rowClassNames;
        var RowFields = rowFieldsAs ? (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(rowFieldsAs, (0, $e0c441c4dc707c1e$export$d6a37fbf812b7307)) : (0, $e0c441c4dc707c1e$export$d6a37fbf812b7307);
        var rowFields = $acw62.createElement(RowFields, {
            rowClassNames: this._rowClassNames,
            rowHeaderId: "".concat(id, "-header"),
            cellsByColumn: cellsByColumn,
            columns: columns,
            item: item,
            itemIndex: itemIndex,
            isSelected: isSelected,
            columnStartIndex: (showCheckbox ? 1 : 0) + (groupNestingDepth ? 1 : 0),
            onRenderItemColumn: onRenderItemColumn,
            onRenderField: onRenderField,
            getCellValueKey: getCellValueKey,
            enableUpdateAnimations: enableUpdateAnimations,
            cellStyleProps: cellStyleProps
        });
        var defaultRole = "row";
        var role = this.props.role ? this.props.role : defaultRole;
        this._ariaRowDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("DetailsRow-description");
        // When the user does not specify any column is a row-header in the columns props,
        // The aria-labelledby of the checkbox does not specify {id}-header.
        var hasRowHeader = columns.some(function(column) {
            return !!column.isRowHeader;
        });
        var ariaLabelledby = "".concat(id, "-checkbox") + (hasRowHeader ? " ".concat(id, "-header") : "");
        // additional props for rows within a GroupedList
        // these are needed for treegrid row semantics, but not grid row semantics
        var groupedListRowProps = isGridRow ? {} : {
            "aria-level": groupNestingDepth && groupNestingDepth + 1 || undefined,
            "aria-posinset": ariaPositionInSet,
            "aria-setsize": ariaSetSize
        };
        return $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-is-focusable": true
        }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), typeof isDraggable === "boolean" ? {
            "data-is-draggable": isDraggable,
            draggable: isDraggable
        } : {}, focusZoneProps, groupedListRowProps, {
            direction: focusZoneDirection,
            elementRef: this._root,
            componentRef: this._focusZone,
            role: role,
            "aria-label": ariaLabel,
            "aria-disabled": disabled || undefined,
            "aria-describedby": ariaRowDescription ? this._ariaRowDescriptionId : ariaDescribedBy,
            className: this._classNames.root,
            "data-selection-index": itemIndex,
            "data-selection-touch-invoke": true,
            "data-selection-disabled": (_a = this.props["data-selection-disabled"]) !== null && _a !== void 0 ? _a : disabled || undefined,
            "data-item-index": itemIndex,
            "aria-rowindex": ariaPositionInSet === undefined ? itemIndex + flatIndexOffset : undefined,
            "data-automationid": "DetailsRow",
            "aria-selected": ariaSelected,
            allowFocusRoot: true
        }), ariaRowDescription ? $acw62.createElement("span", {
            key: "description",
            role: "presentation",
            hidden: true,
            id: this._ariaRowDescriptionId
        }, ariaRowDescription) : null, showCheckbox && $acw62.createElement("div", {
            role: "gridcell",
            "data-selection-toggle": true,
            className: this._classNames.checkCell
        }, onRenderCheck({
            id: id ? "".concat(id, "-checkbox") : undefined,
            selected: isSelected,
            selectionMode: selectionMode,
            anySelected: isSelectionModal,
            "aria-label": checkButtonAriaLabel,
            "aria-labelledby": id ? ariaLabelledby : undefined,
            canSelect: canSelect,
            compact: compact,
            className: this._classNames.check,
            theme: theme,
            isVisible: checkboxVisibility === (0, $5103473855f147d2$export$752592320202052a).always,
            onRenderDetailsCheckbox: onRenderDetailsCheckbox,
            useFastIcons: useFastIcons
        })), $acw62.createElement((0, $ec688b1a3baef560$export$a271488defeee3de), {
            indentWidth: indentWidth,
            role: "gridcell",
            count: groupNestingDepth === 0 ? -1 : groupNestingDepth
        }), item && rowFields, columnMeasureInfo && $acw62.createElement("span", {
            role: "presentation",
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(this._classNames.cellMeasurer, this._classNames.cell),
            ref: this._cellMeasurer
        }, $acw62.createElement(RowFields, {
            rowClassNames: this._rowClassNames,
            rowHeaderId: "".concat(id, "-header"),
            columns: [
                columnMeasureInfo.column
            ],
            item: item,
            itemIndex: itemIndex,
            columnStartIndex: (showCheckbox ? 1 : 0) + (groupNestingDepth ? 1 : 0) + columns.length,
            onRenderItemColumn: onRenderItemColumn,
            getCellValueKey: getCellValueKey
        })));
    };
    /**
     * measure cell at index. and call the call back with the measured cell width when finish measure
     *
     * @param index - The cell index
     * @param onMeasureDone - The call back function when finish measure
     */ DetailsRowBase.prototype.measureCell = function(index, onMeasureDone) {
        var _a = this.props.columns, columns = _a === void 0 ? $e2cc802734e98e56$var$NO_COLUMNS : _a;
        var column = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, columns[index]);
        column.minWidth = 0;
        column.maxWidth = 999999;
        delete column.calculatedWidth;
        this.setState({
            columnMeasureInfo: {
                index: index,
                column: column,
                onMeasureDone: onMeasureDone
            }
        });
    };
    DetailsRowBase.prototype.focus = function(forceIntoFirstElement) {
        var _a;
        if (forceIntoFirstElement === void 0) forceIntoFirstElement = false;
        return !!((_a = this._focusZone.current) === null || _a === void 0 ? void 0 : _a.focus(forceIntoFirstElement));
    };
    DetailsRowBase.prototype._onRenderCheck = function(props) {
        return $acw62.createElement((0, $17354d7eb7914059$export$4b1070532488c9c6), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
    };
    DetailsRowBase.prototype._getRowDragDropOptions = function() {
        var _a = this.props, item = _a.item, itemIndex = _a.itemIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
        var options = {
            eventMap: eventsToRegister,
            selectionIndex: itemIndex,
            context: {
                data: item,
                index: itemIndex
            },
            canDrag: dragDropEvents.canDrag,
            canDrop: dragDropEvents.canDrop,
            onDragStart: dragDropEvents.onDragStart,
            updateDropState: this._updateDroppingState,
            onDrop: dragDropEvents.onDrop,
            onDragEnd: dragDropEvents.onDragEnd,
            onDragOver: dragDropEvents.onDragOver
        };
        return options;
    };
    return DetailsRowBase;
}($acw62.Component);
function $e2cc802734e98e56$var$getSelectionState(props) {
    var _a;
    var itemIndex = props.itemIndex, selection = props.selection;
    return {
        isSelected: !!(selection === null || selection === void 0 ? void 0 : selection.isIndexSelected(itemIndex)),
        isSelectionModal: !!((_a = selection === null || selection === void 0 ? void 0 : selection.isModal) === null || _a === void 0 ? void 0 : _a.call(selection))
    };
}



var $20c9ff4eb9fa4d75$export$cc11f0bd89960b80 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $e2cc802734e98e56$export$36bfebd08eea8eed), (0, $ee27f738f928d431$export$5fec9c780926aedb), undefined, {
    scope: "DetailsRow"
});





/**
 * {@docCategory Selection}
 */ var $35d588b46eba7c6b$export$52baac22726c72bf = /** @class */ function() {
    /**
     * Create a new Selection. If `TItem` does not have a `key` property, you must provide an options
     * object with a `getKey` implementation. Providing options is optional otherwise.
     * (At most one `options` object is accepted.)
     */ function Selection() {
        var options = []; // Otherwise, arguments require options with `getKey`.
        for(var _i = 0 // Otherwise, arguments require options with `getKey`.
        ; _i < arguments.length // Otherwise, arguments require options with `getKey`.
        ; _i++ // Otherwise, arguments require options with `getKey`.
        )options[_i] = arguments[_i]; // Otherwise, arguments require options with `getKey`.
        var _a = options[0] || {}, onSelectionChanged = _a.onSelectionChanged, onItemsChanged = _a.onItemsChanged, getKey = _a.getKey, _b = _a.canSelectItem, canSelectItem = _b === void 0 ? function() {
            return true;
        } : _b, items = _a.items, _c = _a.selectionMode, selectionMode = _c === void 0 ? (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple : _c;
        this.mode = selectionMode;
        this._getKey = getKey || $35d588b46eba7c6b$var$defaultGetKey;
        this._changeEventSuppressionCount = 0;
        this._exemptedCount = 0;
        this._anchoredIndex = 0;
        this._unselectableCount = 0;
        this._onSelectionChanged = onSelectionChanged;
        this._onItemsChanged = onItemsChanged;
        this._canSelectItem = canSelectItem;
        this._keyToIndexMap = {};
        this._isModal = false;
        this.setItems(items || [], true);
        this.count = this.getSelectedCount();
    }
    Selection.prototype.canSelectItem = function(item, index) {
        if (typeof index === "number" && index < 0) return false;
        return this._canSelectItem(item, index);
    };
    Selection.prototype.getKey = function(item, index) {
        var key = this._getKey(item, index);
        return typeof key === "number" || key ? "".concat(key) : "";
    };
    Selection.prototype.setChangeEvents = function(isEnabled, suppressChange) {
        this._changeEventSuppressionCount += isEnabled ? -1 : 1;
        if (this._changeEventSuppressionCount === 0 && this._hasChanged) {
            this._hasChanged = false;
            if (!suppressChange) this._change();
        }
    };
    Selection.prototype.isModal = function() {
        return this._isModal;
    };
    Selection.prototype.setModal = function(isModal) {
        if (this._isModal !== isModal) {
            this.setChangeEvents(false);
            this._isModal = isModal;
            if (!isModal) this.setAllSelected(false);
            this._change();
            this.setChangeEvents(true);
        }
    };
    /**
     * Selection needs the items, call this method to set them. If the set
     * of items is the same, this will re-evaluate selection and index maps.
     * Otherwise, shouldClear should be set to true, so that selection is
     * cleared.
     */ Selection.prototype.setItems = function(items, shouldClear) {
        if (shouldClear === void 0) shouldClear = true;
        var newKeyToIndexMap = {};
        var newUnselectableIndices = {};
        var hasSelectionChanged = false;
        this.setChangeEvents(false);
        // Reset the unselectable count.
        this._unselectableCount = 0;
        var haveItemsChanged = false;
        // Build lookup table for quick selection evaluation.
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            if (item) {
                var key = this.getKey(item, i);
                if (key) {
                    if (!haveItemsChanged && (!(key in this._keyToIndexMap) || this._keyToIndexMap[key] !== i)) haveItemsChanged = true;
                    newKeyToIndexMap[key] = i;
                }
            }
            newUnselectableIndices[i] = item && !this.canSelectItem(item);
            if (newUnselectableIndices[i]) this._unselectableCount++;
        }
        if (shouldClear || items.length === 0) this._setAllSelected(false, true);
        // Check the exemption list for discrepencies.
        var newExemptedIndicies = {};
        var newExemptedCount = 0;
        for(var indexProperty in this._exemptedIndices)if (this._exemptedIndices.hasOwnProperty(indexProperty)) {
            var index = Number(indexProperty);
            var item = this._items[index];
            var exemptKey = item ? this.getKey(item, Number(index)) : undefined;
            var newIndex = exemptKey ? newKeyToIndexMap[exemptKey] : index;
            if (newIndex === undefined) // The item has likely been replaced or removed.
            hasSelectionChanged = true;
            else {
                // We know the new index of the item. update the existing exemption table.
                newExemptedIndicies[newIndex] = true;
                newExemptedCount++;
                hasSelectionChanged = hasSelectionChanged || newIndex !== index;
            }
        }
        if (this._items && this._exemptedCount === 0 && items.length !== this._items.length && this._isAllSelected) // If everything was selected but the number of items has changed, selection has changed.
        hasSelectionChanged = true;
        if (!haveItemsChanged) for(var _i = 0, _a = Object.keys(this._keyToIndexMap); _i < _a.length; _i++){
            var key = _a[_i];
            if (!(key in newKeyToIndexMap)) {
                haveItemsChanged = true;
                break;
            }
        }
        this._exemptedIndices = newExemptedIndicies;
        this._exemptedCount = newExemptedCount;
        this._keyToIndexMap = newKeyToIndexMap;
        this._unselectableIndices = newUnselectableIndices;
        this._items = items;
        this._selectedItems = null;
        if (hasSelectionChanged) this._updateCount();
        if (haveItemsChanged) {
            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $eb906a1fe3c7a837$export$4ab6bac19c220899));
            if (this._onItemsChanged) this._onItemsChanged();
        }
        if (hasSelectionChanged) this._change();
        this.setChangeEvents(true);
    };
    Selection.prototype.getItems = function() {
        return this._items;
    };
    Selection.prototype.getSelection = function() {
        if (!this._selectedItems) {
            this._selectedItems = [];
            var items = this._items;
            if (items) {
                for(var i = 0; i < items.length; i++)if (this.isIndexSelected(i)) this._selectedItems.push(items[i]);
            }
        }
        return this._selectedItems;
    };
    Selection.prototype.getSelectedCount = function() {
        return this._isAllSelected ? this._items.length - this._exemptedCount - this._unselectableCount : this._exemptedCount;
    };
    Selection.prototype.getSelectedIndices = function() {
        if (!this._selectedIndices) {
            this._selectedIndices = [];
            var items = this._items;
            if (items) {
                for(var i = 0; i < items.length; i++)if (this.isIndexSelected(i)) this._selectedIndices.push(i);
            }
        }
        return this._selectedIndices;
    };
    Selection.prototype.getItemIndex = function(key) {
        var index = this._keyToIndexMap[key];
        return index !== null && index !== void 0 ? index : -1;
    };
    Selection.prototype.isRangeSelected = function(fromIndex, count) {
        if (count === 0) return false;
        var endIndex = fromIndex + count;
        for(var i = fromIndex; i < endIndex; i++){
            if (!this.isIndexSelected(i)) return false;
        }
        return true;
    };
    Selection.prototype.isAllSelected = function() {
        var selectableCount = this._items.length - this._unselectableCount;
        // In single mode, we can only have a max of 1 item.
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) selectableCount = Math.min(selectableCount, 1);
        return this.count > 0 && this._isAllSelected && this._exemptedCount === 0 || !this._isAllSelected && this._exemptedCount === selectableCount && selectableCount > 0;
    };
    Selection.prototype.isKeySelected = function(key) {
        var index = this._keyToIndexMap[key];
        return this.isIndexSelected(index);
    };
    Selection.prototype.isIndexSelected = function(index) {
        return !!(this.count > 0 && this._isAllSelected && !this._exemptedIndices[index] && !this._unselectableIndices[index] || !this._isAllSelected && this._exemptedIndices[index]);
    };
    Selection.prototype.setAllSelected = function(isAllSelected) {
        if (isAllSelected && this.mode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) return;
        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
        this.setChangeEvents(false);
        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
            this._exemptedIndices = {};
            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
                this._exemptedCount = 0;
                this._isAllSelected = isAllSelected;
                this._change();
            }
            this._updateCount();
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.setKeySelected = function(key, isSelected, shouldAnchor) {
        var index = this._keyToIndexMap[key];
        if (index >= 0) this.setIndexSelected(index, isSelected, shouldAnchor);
    };
    Selection.prototype.setIndexSelected = function(index, isSelected, shouldAnchor) {
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return;
        // Clamp the index.
        index = Math.min(Math.max(0, index), this._items.length - 1);
        // No-op on out of bounds selections.
        if (index < 0 || index >= this._items.length) return;
        this.setChangeEvents(false);
        var isExempt = this._exemptedIndices[index];
        var canSelect = !this._unselectableIndices[index];
        if (canSelect) {
            if (isSelected && this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) // If this is single-select, the previous selection should be removed.
            this._setAllSelected(false, true);
            // Determine if we need to remove the exemption.
            if (isExempt && (isSelected && this._isAllSelected || !isSelected && !this._isAllSelected)) {
                delete this._exemptedIndices[index];
                this._exemptedCount--;
            }
            // Determine if we need to add the exemption.
            if (!isExempt && (isSelected && !this._isAllSelected || !isSelected && this._isAllSelected)) {
                this._exemptedIndices[index] = true;
                this._exemptedCount++;
            }
            if (shouldAnchor) this._anchoredIndex = index;
        }
        this._updateCount();
        this.setChangeEvents(true);
    };
    Selection.prototype.setRangeSelected = function(fromIndex, count, isSelected, shouldAnchor) {
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return;
        // Clamp the index.
        fromIndex = Math.min(Math.max(0, fromIndex), this._items.length - 1);
        // Clamp the range.
        count = Math.min(Math.max(0, count), this._items.length - fromIndex);
        // No-op on out of bounds selections.
        if (fromIndex < 0 || fromIndex >= this._items.length || count === 0) return;
        this.setChangeEvents(false);
        var anchorIndex = this._anchoredIndex || 0;
        var startIndex = fromIndex;
        var endIndex = fromIndex + count - 1;
        var newAnchorIndex = anchorIndex >= endIndex ? startIndex : endIndex;
        for(; startIndex <= endIndex; startIndex++)this.setIndexSelected(startIndex, isSelected, shouldAnchor ? startIndex === newAnchorIndex : false);
        this.setChangeEvents(true);
    };
    Selection.prototype.selectToKey = function(key, clearSelection) {
        this.selectToIndex(this._keyToIndexMap[key], clearSelection);
    };
    Selection.prototype.selectToRange = function(fromIndex, count, clearSelection) {
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return;
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) {
            if (count === 1) this.setIndexSelected(fromIndex, true, true);
            return;
        }
        var anchorIndex = this._anchoredIndex || 0;
        var startIndex = Math.min(fromIndex, anchorIndex);
        var endIndex = Math.max(fromIndex + count - 1, anchorIndex);
        this.setChangeEvents(false);
        if (clearSelection) this._setAllSelected(false, true);
        for(; startIndex <= endIndex; startIndex++)this.setIndexSelected(startIndex, true, false);
        this.setChangeEvents(true);
    };
    Selection.prototype.selectToIndex = function(index, clearSelection) {
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return;
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) {
            this.setIndexSelected(index, true, true);
            return;
        }
        var anchorIndex = this._anchoredIndex || 0;
        var startIndex = Math.min(index, anchorIndex);
        var endIndex = Math.max(index, anchorIndex);
        this.setChangeEvents(false);
        if (clearSelection) this._setAllSelected(false, true);
        for(; startIndex <= endIndex; startIndex++)this.setIndexSelected(startIndex, true, false);
        this.setChangeEvents(true);
    };
    Selection.prototype.toggleAllSelected = function() {
        this.setAllSelected(!this.isAllSelected());
    };
    Selection.prototype.toggleKeySelected = function(key) {
        this.setKeySelected(key, !this.isKeySelected(key), true);
    };
    Selection.prototype.toggleIndexSelected = function(index) {
        this.setIndexSelected(index, !this.isIndexSelected(index), true);
    };
    Selection.prototype.toggleRangeSelected = function(fromIndex, count) {
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return;
        var isRangeSelected = this.isRangeSelected(fromIndex, count);
        var endIndex = fromIndex + count;
        if (this.mode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single && count > 1) return;
        this.setChangeEvents(false);
        for(var i = fromIndex; i < endIndex; i++)this.setIndexSelected(i, !isRangeSelected, false);
        this.setChangeEvents(true);
    };
    Selection.prototype._updateCount = function(preserveModalState) {
        if (preserveModalState === void 0) preserveModalState = false;
        var count = this.getSelectedCount();
        if (count !== this.count) {
            this.count = count;
            this._change();
        }
        if (!this.count && !preserveModalState) this.setModal(false);
    };
    Selection.prototype._setAllSelected = function(isAllSelected, preserveModalState) {
        if (preserveModalState === void 0) preserveModalState = false;
        if (isAllSelected && this.mode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) return;
        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
        this.setChangeEvents(false);
        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
            this._exemptedIndices = {};
            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
                this._exemptedCount = 0;
                this._isAllSelected = isAllSelected;
                this._change();
            }
            this._updateCount(preserveModalState);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype._change = function() {
        if (this._changeEventSuppressionCount === 0) {
            this._selectedItems = null;
            this._selectedIndices = undefined;
            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $eb906a1fe3c7a837$export$40138a1437c71ca4));
            if (this._onSelectionChanged) this._onSelectionChanged();
        } else this._hasChanged = true;
    };
    return Selection;
}();
function $35d588b46eba7c6b$var$defaultGetKey(item, index) {
    // 0 may be used as a key
    var _a = (item || {}).key, key = _a === void 0 ? "".concat(index) : _a;
    return key;
}



var $acw62 = parcelRequire("acw62");


// Selection definitions:
//
// Anchor index: the point from which a range selection starts.
// Focus index: the point from which layout movement originates from.
//
// These two can differ. Tests:
//
// If you start at index 5
// Shift click to index 10
//    The focus is 10, the anchor is 5.
// If you shift click at index 0
//    The anchor remains at 5, the items between 0 and 5 are selected and everything else is cleared.
// If you click index 8
//    The anchor and focus are set to 8.
var $64c1598924895467$var$SELECTION_DISABLED_ATTRIBUTE_NAME = "data-selection-disabled";
var $64c1598924895467$var$SELECTION_INDEX_ATTRIBUTE_NAME = "data-selection-index";
var $64c1598924895467$var$SELECTION_SPAN_ATTRIBUTE_NAME = "data-selection-span";
var $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME = "data-selection-toggle";
var $64c1598924895467$var$SELECTION_INVOKE_ATTRIBUTE_NAME = "data-selection-invoke";
var $64c1598924895467$var$SELECTION_INVOKE_TOUCH_ATTRIBUTE_NAME = "data-selection-touch-invoke";
var $64c1598924895467$var$SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME = "data-selection-all-toggle";
var $64c1598924895467$var$SELECTION_SELECT_ATTRIBUTE_NAME = "data-selection-select";
/**
 * {@docCategory Selection}
 */ var $64c1598924895467$export$f4ca2ebb342e809c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SelectionZone, _super);
    function SelectionZone(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        /**
         * In some cases, the consuming scenario requires to set focus on a row without having SelectionZone
         * react to the event. Note that focus events in IE \<= 11 will occur asynchronously after .focus() has
         * been called on an element, so we need a flag to store the idea that we will bypass the "next"
         * focus event that occurs. This method does that.
         */ _this.ignoreNextFocus = function() {
            _this._handleNextFocus(false);
        };
        _this._onSelectionChange = function() {
            var selection = _this.props.selection;
            var isModal = selection.isModal && selection.isModal();
            _this.setState({
                isModal: isModal
            });
        };
        _this._onMouseDownCapture = function(ev) {
            var target = ev.target;
            if (document.activeElement !== target && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(document.activeElement, target)) {
                _this.ignoreNextFocus();
                return;
            }
            if (!(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(target, _this._root.current)) return;
            while(target !== _this._root.current){
                if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                    _this.ignoreNextFocus();
                    break;
                }
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
            }
        };
        /**
         * When we focus an item, for single/multi select scenarios, we should try to select it immediately
         * as long as the focus did not originate from a mouse down/touch event. For those cases, we handle them
         * specially.
         */ _this._onFocus = function(ev) {
            var target = ev.target;
            var selection = _this.props.selection;
            var isToggleModifierPressed = _this._isCtrlPressed || _this._isMetaPressed;
            var selectionMode = _this._getSelectionMode();
            if (_this._shouldHandleFocus && selectionMode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) {
                var isToggle = _this._hasAttribute(target, $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME);
                var itemRoot = _this._findItemRoot(target);
                if (!isToggle && itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    var span = _this._getItemSpan(itemRoot);
                    if (span === undefined) {
                        if (isToggleModifierPressed) {
                            // set anchor only.
                            selection.setIndexSelected(index, selection.isIndexSelected(index), true);
                            if (_this.props.enterModalOnTouch && _this._isTouch && selection.setModal) {
                                selection.setModal(true);
                                _this._setIsTouch(false);
                            }
                        } else if (_this.props.isSelectedOnFocus) _this._onItemSurfaceClick("focus", index);
                    }
                }
            }
            _this._handleNextFocus(false);
        };
        _this._onMouseDown = function(ev) {
            _this._updateModifiers(ev);
            var toggleWithoutModifierPressed = _this.props.toggleWithoutModifierPressed;
            var target = ev.target;
            var itemRoot = _this._findItemRoot(target);
            // No-op if selection is disabled
            if (_this._isSelectionDisabled(target)) return;
            while(target !== _this._root.current){
                if (_this._hasAttribute(target, $64c1598924895467$var$SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) break;
                else if (itemRoot) {
                    if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME)) break;
                    else if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_INVOKE_ATTRIBUTE_NAME)) break;
                    else if ((target === itemRoot || _this._shouldAutoSelect(target)) && !_this._isShiftPressed && !_this._isCtrlPressed && !_this._isMetaPressed && !toggleWithoutModifierPressed) {
                        _this._onInvokeMouseDown(ev, _this._getItemIndex(itemRoot), _this._getItemSpan(itemRoot));
                        break;
                    } else if (_this.props.disableAutoSelectOnInputElements && (target.tagName === "A" || target.tagName === "BUTTON" || target.tagName === "INPUT")) return;
                }
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
            }
        };
        _this._onTouchStartCapture = function(ev) {
            _this._setIsTouch(true);
        };
        _this._onClick = function(ev) {
            var _a = _this.props.enableTouchInvocationTarget, enableTouchInvocationTarget = _a === void 0 ? false : _a;
            _this._updateModifiers(ev);
            var target = ev.target;
            var itemRoot = _this._findItemRoot(target);
            var isSelectionDisabled = _this._isSelectionDisabled(target);
            while(target !== _this._root.current){
                if (_this._hasAttribute(target, $64c1598924895467$var$SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
                    if (!isSelectionDisabled) _this._onToggleAllClick(ev);
                    break;
                } else if (itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    var span = _this._getItemSpan(itemRoot);
                    if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                        if (!isSelectionDisabled) {
                            if (_this._isShiftPressed) _this._onItemSurfaceClick("click", index, span);
                            else _this._onToggleClick(ev, index, span);
                        }
                        break;
                    } else if (_this._isTouch && enableTouchInvocationTarget && _this._hasAttribute(target, $64c1598924895467$var$SELECTION_INVOKE_TOUCH_ATTRIBUTE_NAME) || _this._hasAttribute(target, $64c1598924895467$var$SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                        if (span === undefined) // Items should be invokable even if selection is disabled.
                        _this._onInvokeClick(ev, index);
                        break;
                    } else if (target === itemRoot) {
                        if (!isSelectionDisabled) _this._onItemSurfaceClick("click", index, span);
                        break;
                    } else if (target.tagName === "A" || target.tagName === "BUTTON" || target.tagName === "INPUT") return;
                }
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
            }
        };
        _this._onContextMenu = function(ev) {
            var target = ev.target;
            var _a = _this.props, onItemContextMenu = _a.onItemContextMenu, selection = _a.selection;
            if (onItemContextMenu) {
                var itemRoot = _this._findItemRoot(target);
                if (itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    _this._onInvokeMouseDown(ev, index);
                    var skipPreventDefault = onItemContextMenu(selection.getItems()[index], index, ev.nativeEvent);
                    // In order to keep back compat, if the value here is undefined, then we should still
                    // call preventDefault(). Only in the case where true is explicitly returned should
                    // the call be skipped.
                    if (!skipPreventDefault) ev.preventDefault();
                }
            }
        };
        /**
         * In multi selection, if you double click within an item's root (but not within the invoke element or
         * input elements), we should execute the invoke handler.
         */ _this._onDoubleClick = function(ev) {
            var target = ev.target;
            var onItemInvoked = _this.props.onItemInvoked;
            var itemRoot = _this._findItemRoot(target);
            if (itemRoot && onItemInvoked && !_this._isInputElement(target)) {
                var index = _this._getItemIndex(itemRoot);
                while(target !== _this._root.current){
                    if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME) || _this._hasAttribute(target, $64c1598924895467$var$SELECTION_INVOKE_ATTRIBUTE_NAME)) break;
                    else if (target === itemRoot) {
                        _this._onInvokeClick(ev, index);
                        break;
                    }
                    target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
                }
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
            }
        };
        _this._onKeyDownCapture = function(ev) {
            _this._updateModifiers(ev);
            _this._handleNextFocus(true);
        };
        _this._onKeyDown = function(ev) {
            _this._updateModifiers(ev);
            var target = ev.target;
            var isSelectionDisabled = _this._isSelectionDisabled(target);
            var _a = _this.props, selection = _a.selection, selectionClearedOnEscapePress = _a.selectionClearedOnEscapePress;
            // eslint-disable-next-line deprecation/deprecation
            var isSelectAllKey = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).a && (_this._isCtrlPressed || _this._isMetaPressed);
            // eslint-disable-next-line deprecation/deprecation
            var isClearSelectionKey = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape;
            // Ignore key downs from input elements.
            if (_this._isInputElement(target)) // A key was pressed while an item in this zone was focused.
            return;
            var selectionMode = _this._getSelectionMode();
            // If ctrl-a is pressed, select all (if all are not already selected.)
            if (isSelectAllKey && selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple && !selection.isAllSelected()) {
                if (!isSelectionDisabled) selection.setAllSelected(true);
                ev.stopPropagation();
                ev.preventDefault();
                return;
            }
            // If escape is pressed and the component is configured to clear on escape press,
            // clear selection (if any are selected.)
            if (selectionClearedOnEscapePress && isClearSelectionKey && selection.getSelectedCount() > 0) {
                if (!isSelectionDisabled) selection.setAllSelected(false);
                ev.stopPropagation();
                ev.preventDefault();
                return;
            }
            var itemRoot = _this._findItemRoot(target);
            // If a key was pressed within an item, we should treat "enters" as invokes and "space" as toggle
            if (itemRoot) {
                var index = _this._getItemIndex(itemRoot);
                var span = _this._getItemSpan(itemRoot);
                while(target !== _this._root.current){
                    if (_this._hasAttribute(target, $64c1598924895467$var$SELECTION_TOGGLE_ATTRIBUTE_NAME)) break;
                    else if (_this._shouldAutoSelect(target)) {
                        if (!isSelectionDisabled && span === undefined) // If the event went to an element which should trigger auto-select, select it and then let
                        // the default behavior kick in.
                        _this._onInvokeMouseDown(ev, index, span);
                        break;
                    } else if (// eslint-disable-next-line deprecation/deprecation
                    (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) && (target.tagName === "BUTTON" || target.tagName === "A" || target.tagName === "INPUT" || target.tagName === "SUMMARY")) return false;
                    else if (target === itemRoot) {
                        // eslint-disable-next-line deprecation/deprecation
                        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
                            if (span === undefined) {
                                // Items should be invokable even if selection is disabled.
                                _this._onInvokeClick(ev, index);
                                ev.preventDefault();
                            }
                            return;
                        // eslint-disable-next-line deprecation/deprecation
                        } else if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) {
                            if (!isSelectionDisabled) _this._onToggleClick(ev, index, span);
                            ev.preventDefault();
                            return;
                        }
                        break;
                    }
                    target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
                }
            }
        };
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        var selection = _this.props.selection;
        // Reflect the initial modal state of selection into the state.
        var isModal = selection.isModal && selection.isModal();
        _this.state = {
            isModal: isModal
        };
        return _this;
    }
    SelectionZone.getDerivedStateFromProps = function(nextProps, prevState) {
        var isModal = nextProps.selection.isModal && nextProps.selection.isModal();
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, prevState), {
            isModal: isModal
        });
    };
    SelectionZone.prototype.componentDidMount = function() {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(this._root.current);
        // Track the latest modifier keys globally.
        this._events.on(win, "keydown, keyup", this._updateModifiers, true);
        this._events.on(document, "click", this._findScrollParentAndTryClearOnEmptyClick);
        this._events.on(document.body, "touchstart", this._onTouchStartCapture, true);
        this._events.on(document.body, "touchend", this._onTouchStartCapture, true);
        // Subscribe to the selection to keep modal state updated.
        this._events.on(this.props.selection, "change", this._onSelectionChange);
    };
    SelectionZone.prototype.render = function() {
        var isModal = this.state.isModal;
        return $acw62.createElement("div", {
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)("ms-SelectionZone", this.props.className, {
                "ms-SelectionZone--modal": !!isModal
            }),
            ref: this._root,
            onKeyDown: this._onKeyDown,
            onMouseDown: this._onMouseDown,
            onKeyDownCapture: this._onKeyDownCapture,
            onClick: this._onClick,
            role: "presentation",
            onDoubleClick: this._onDoubleClick,
            onContextMenu: this._onContextMenu,
            onMouseDownCapture: this._onMouseDownCapture,
            onFocusCapture: this._onFocus,
            "data-selection-is-modal": isModal ? true : undefined
        }, this.props.children, $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null));
    };
    SelectionZone.prototype.componentDidUpdate = function(previousProps) {
        var selection = this.props.selection;
        if (selection !== previousProps.selection) {
            // Whenever selection changes, update the subscripton to keep modal state updated.
            this._events.off(previousProps.selection);
            this._events.on(selection, "change", this._onSelectionChange);
        }
    };
    SelectionZone.prototype.componentWillUnmount = function() {
        this._events.dispose();
        this._async.dispose();
    };
    SelectionZone.prototype._isSelectionDisabled = function(target) {
        if (this._getSelectionMode() === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none) return true;
        while(target !== this._root.current){
            if (this._hasAttribute(target, $64c1598924895467$var$SELECTION_DISABLED_ATTRIBUTE_NAME)) return true;
            target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
        }
        return false;
    };
    SelectionZone.prototype._onToggleAllClick = function(ev) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) {
            selection.toggleAllSelected();
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    SelectionZone.prototype._onToggleClick = function(ev, index, span) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        selection.setChangeEvents(false);
        if (this.props.enterModalOnTouch && this._isTouch && (span !== undefined ? !selection.isRangeSelected(index, span) : !selection.isIndexSelected(index)) && selection.setModal) {
            selection.setModal(true);
            this._setIsTouch(false);
        }
        if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) {
            if (span !== undefined) selection.toggleRangeSelected(index, span);
            else selection.toggleIndexSelected(index);
        } else if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) {
            if (span === undefined || span === 1) {
                var isSelected = selection.isIndexSelected(index);
                var isModal = selection.isModal && selection.isModal();
                selection.setAllSelected(false);
                selection.setIndexSelected(index, !isSelected, true);
                if (isModal && selection.setModal) // Since the above call to setAllSelected(false) clears modal state,
                // restore it. This occurs because the SelectionMode of the Selection
                // may differ from the SelectionZone.
                selection.setModal(true);
            }
        } else {
            selection.setChangeEvents(true);
            return;
        }
        selection.setChangeEvents(true);
        ev.stopPropagation();
    // NOTE: ev.preventDefault is not called for toggle clicks, because this will kill the browser behavior
    // for checkboxes if you use a checkbox for the toggle.
    };
    SelectionZone.prototype._onInvokeClick = function(ev, index) {
        var _a = this.props, selection = _a.selection, onItemInvoked = _a.onItemInvoked;
        if (onItemInvoked) {
            onItemInvoked(selection.getItems()[index], index, ev.nativeEvent);
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    SelectionZone.prototype._onItemSurfaceClick = function(type, index, span) {
        var _a;
        var _b = this.props, selection = _b.selection, toggleWithoutModifierPressed = _b.toggleWithoutModifierPressed;
        var isToggleModifierPressed = this._isCtrlPressed || this._isMetaPressed;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) {
            if (this._isShiftPressed && !this._isTabPressed) {
                if (span !== undefined) (_a = selection.selectToRange) === null || _a === void 0 || _a.call(selection, index, span, !isToggleModifierPressed);
                else selection.selectToIndex(index, !isToggleModifierPressed);
            } else if (type === "click" && (isToggleModifierPressed || toggleWithoutModifierPressed)) {
                if (span !== undefined) selection.toggleRangeSelected(index, span);
                else selection.toggleIndexSelected(index);
            } else this._clearAndSelectIndex(index, span);
        } else if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) this._clearAndSelectIndex(index, span);
    };
    SelectionZone.prototype._onInvokeMouseDown = function(ev, index, span) {
        var selection = this.props.selection;
        if (span !== undefined) {
            if (selection.isRangeSelected(index, span)) return;
        } else {
            // Only do work if item is not selected.
            if (selection.isIndexSelected(index)) return;
        }
        this._clearAndSelectIndex(index, span);
    };
    /**
     * To avoid high startup cost of traversing the DOM on component mount,
     * defer finding the scrollable parent until a click interaction.
     *
     * The styles will probably already calculated since we're running in a click handler,
     * so this is less likely to cause layout thrashing then doing it in mount.
     */ SelectionZone.prototype._findScrollParentAndTryClearOnEmptyClick = function(ev) {
        var scrollParent = (0, $11f97b2a9a127629$export$494fa69500a5872a)(this._root.current);
        // unbind this handler and replace binding with a binding on the actual scrollable parent
        this._events.off(document, "click", this._findScrollParentAndTryClearOnEmptyClick);
        this._events.on(scrollParent, "click", this._tryClearOnEmptyClick);
        // If we clicked inside the scrollable parent, call through to the handler on this click.
        if (scrollParent && ev.target instanceof Node && scrollParent.contains(ev.target) || scrollParent === ev.target) this._tryClearOnEmptyClick(ev);
    };
    SelectionZone.prototype._tryClearOnEmptyClick = function(ev) {
        if (!this.props.selectionPreservedOnEmptyClick && this._isNonHandledClick(ev.target)) this.props.selection.setAllSelected(false);
    };
    SelectionZone.prototype._clearAndSelectIndex = function(index, span) {
        var _a;
        var _b = this.props, selection = _b.selection, _c = _b.selectionClearedOnSurfaceClick, selectionClearedOnSurfaceClick = _c === void 0 ? true : _c;
        var isAlreadySingleSelected = (span === undefined || span === 1) && selection.getSelectedCount() === 1 && selection.isIndexSelected(index);
        if (!isAlreadySingleSelected && selectionClearedOnSurfaceClick) {
            var isModal = selection.isModal && selection.isModal();
            selection.setChangeEvents(false);
            selection.setAllSelected(false);
            if (span !== undefined) (_a = selection.setRangeSelected) === null || _a === void 0 || _a.call(selection, index, span, true, true);
            else selection.setIndexSelected(index, true, true);
            if (isModal || this.props.enterModalOnTouch && this._isTouch) {
                if (selection.setModal) selection.setModal(true);
                if (this._isTouch) this._setIsTouch(false);
            }
            selection.setChangeEvents(true);
        }
    };
    /**
     * We need to track the modifier key states so that when focus events occur, which do not contain
     * modifier states in the Event object, we know how to behave.
     */ SelectionZone.prototype._updateModifiers = function(ev) {
        this._isShiftPressed = ev.shiftKey;
        this._isCtrlPressed = ev.ctrlKey;
        this._isMetaPressed = ev.metaKey;
        // eslint-disable-next-line deprecation/deprecation
        var keyCode = ev.keyCode;
        this._isTabPressed = keyCode ? keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).tab : false;
    };
    SelectionZone.prototype._findItemRoot = function(target) {
        var selection = this.props.selection;
        while(target !== this._root.current){
            var indexValue = target.getAttribute($64c1598924895467$var$SELECTION_INDEX_ATTRIBUTE_NAME);
            var index = Number(indexValue);
            if (indexValue !== null && index >= 0 && index < selection.getItems().length) break;
            target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target);
        }
        if (target === this._root.current) return undefined;
        return target;
    };
    SelectionZone.prototype._getItemIndex = function(itemRoot) {
        var _a;
        var indexValue = parseInt((_a = itemRoot.getAttribute($64c1598924895467$var$SELECTION_INDEX_ATTRIBUTE_NAME)) !== null && _a !== void 0 ? _a : "", 10);
        return isNaN(indexValue) ? -1 : indexValue;
    };
    SelectionZone.prototype._getItemSpan = function(itemRoot) {
        var _a;
        var spanValue = parseInt((_a = itemRoot.getAttribute($64c1598924895467$var$SELECTION_SPAN_ATTRIBUTE_NAME)) !== null && _a !== void 0 ? _a : "", 10);
        return isNaN(spanValue) ? undefined : spanValue;
    };
    SelectionZone.prototype._shouldAutoSelect = function(element) {
        return this._hasAttribute(element, $64c1598924895467$var$SELECTION_SELECT_ATTRIBUTE_NAME);
    };
    SelectionZone.prototype._hasAttribute = function(element, attributeName) {
        var isToggle = false;
        while(!isToggle && element !== this._root.current){
            var value = element.getAttribute(attributeName);
            if (value === "false") {
                isToggle = false;
                break;
            }
            isToggle = value === "true";
            element = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element);
        }
        return isToggle;
    };
    SelectionZone.prototype._isInputElement = function(element) {
        return element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.getAttribute("contenteditable") === "true" || element.getAttribute("contenteditable") === "";
    };
    SelectionZone.prototype._isNonHandledClick = function(element) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if (doc && element) while(element && element !== doc.documentElement){
            if ((0, $94bdc1ebed789608$export$5d5979bf640d1558)(element) || element.hasAttribute("data-selection-index")) return false;
            element = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element);
        }
        return true;
    };
    SelectionZone.prototype._handleNextFocus = function(handleFocus) {
        var _this = this;
        if (this._shouldHandleFocusTimeoutId) {
            this._async.clearTimeout(this._shouldHandleFocusTimeoutId);
            this._shouldHandleFocusTimeoutId = undefined;
        }
        this._shouldHandleFocus = handleFocus;
        if (handleFocus) this._async.setTimeout(function() {
            _this._shouldHandleFocus = false;
        }, 100);
    };
    SelectionZone.prototype._setIsTouch = function(isTouch) {
        var _this = this;
        if (this._isTouchTimeoutId) {
            this._async.clearTimeout(this._isTouchTimeoutId);
            this._isTouchTimeoutId = undefined;
        }
        this._isTouch = true;
        if (isTouch) this._async.setTimeout(function() {
            _this._isTouch = false;
        }, 300);
    };
    SelectionZone.prototype._getSelectionMode = function() {
        var selection = this.props.selection;
        var _a = this.props.selectionMode, selectionMode = _a === void 0 ? selection ? selection.mode : (0, $eb906a1fe3c7a837$export$91484609d16ec765).none : _a;
        return selectionMode;
    };
    SelectionZone.defaultProps = {
        isSelectedOnFocus: true,
        toggleWithoutModifierPressed: false,
        selectionMode: (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple,
        selectionClearedOnEscapePress: true
    };
    return SelectionZone;
}($acw62.Component);







var $acw62 = parcelRequire("acw62");

/**
 * Helper to get bounding client rect. Passing in window will get the window size.
 *
 * @public
 */ function $dba86ee0d80a4147$export$4b834cebd9e5cebe(element) {
    var rect;
    if (element) {
        if (element === window) rect = {
            left: 0,
            top: 0,
            width: window.innerWidth,
            height: window.innerHeight,
            right: window.innerWidth,
            bottom: window.innerHeight
        };
        else if (element.getBoundingClientRect) rect = element.getBoundingClientRect();
    }
    return rect;
}


var $f3b90d67e812c3a1$var$RESIZE_DELAY = 500;
var $f3b90d67e812c3a1$var$MAX_RESIZE_ATTEMPTS = 3;
function $f3b90d67e812c3a1$export$1ba62c68904e2fde(ComposedComponent) {
    return /** @class */ function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(WithViewportComponent, _super);
        function WithViewportComponent(props) {
            var _this = _super.call(this, props) || this;
            _this._root = $acw62.createRef();
            _this._registerResizeObserver = function() {
                var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(_this._root.current);
                _this._viewportResizeObserver = new win.ResizeObserver(_this._onAsyncResize);
                _this._viewportResizeObserver.observe(_this._root.current);
            };
            _this._unregisterResizeObserver = function() {
                if (_this._viewportResizeObserver) {
                    _this._viewportResizeObserver.disconnect();
                    delete _this._viewportResizeObserver;
                }
            };
            /* Note: using lambda here because decorators don't seem to work in decorators. */ _this._updateViewport = function(withForceUpdate) {
                var viewport = _this.state.viewport;
                var viewportElement = _this._root.current;
                var scrollElement = (0, $11f97b2a9a127629$export$494fa69500a5872a)(viewportElement);
                var scrollRect = (0, $dba86ee0d80a4147$export$4b834cebd9e5cebe)(scrollElement);
                var clientRect = (0, $dba86ee0d80a4147$export$4b834cebd9e5cebe)(viewportElement);
                var updateComponent = function() {
                    if (withForceUpdate && _this._composedComponentInstance) _this._composedComponentInstance.forceUpdate();
                };
                var isSizeChanged = (clientRect && clientRect.width) !== viewport.width || (scrollRect && scrollRect.height) !== viewport.height;
                if (isSizeChanged && _this._resizeAttempts < $f3b90d67e812c3a1$var$MAX_RESIZE_ATTEMPTS && clientRect && scrollRect) {
                    _this._resizeAttempts++;
                    _this.setState({
                        viewport: {
                            width: clientRect.width,
                            height: scrollRect.height
                        }
                    }, function() {
                        _this._updateViewport(withForceUpdate);
                    });
                } else {
                    _this._resizeAttempts = 0;
                    updateComponent();
                }
            };
            _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
            _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
            _this._resizeAttempts = 0;
            _this.state = {
                viewport: {
                    width: 0,
                    height: 0
                }
            };
            return _this;
        }
        WithViewportComponent.prototype.componentDidMount = function() {
            var _this = this;
            var _a = this.props, delayFirstMeasure = _a.delayFirstMeasure, disableResizeObserver = _a.disableResizeObserver, skipViewportMeasures = _a.skipViewportMeasures;
            var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(this._root.current);
            this._onAsyncResize = this._async.debounce(this._onAsyncResize, $f3b90d67e812c3a1$var$RESIZE_DELAY, {
                leading: false
            });
            if (!skipViewportMeasures) {
                if (!disableResizeObserver && this._isResizeObserverAvailable()) this._registerResizeObserver();
                else this._events.on(win, "resize", this._onAsyncResize);
                if (delayFirstMeasure) this._async.setTimeout(function() {
                    _this._updateViewport();
                }, $f3b90d67e812c3a1$var$RESIZE_DELAY);
                else this._updateViewport();
            }
        };
        WithViewportComponent.prototype.componentDidUpdate = function(previousProps) {
            var previousSkipViewportMeasures = previousProps.skipViewportMeasures;
            var _a = this.props, disableResizeObserver = _a.disableResizeObserver, skipViewportMeasures = _a.skipViewportMeasures;
            var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(this._root.current);
            if (skipViewportMeasures !== previousSkipViewportMeasures) {
                if (!skipViewportMeasures) {
                    if (!disableResizeObserver && this._isResizeObserverAvailable()) {
                        if (!this._viewportResizeObserver) this._registerResizeObserver();
                    } else this._events.on(win, "resize", this._onAsyncResize);
                    this._updateViewport();
                } else {
                    this._unregisterResizeObserver();
                    this._events.off(win, "resize", this._onAsyncResize);
                }
            }
        };
        WithViewportComponent.prototype.componentWillUnmount = function() {
            this._events.dispose();
            this._async.dispose();
            this._unregisterResizeObserver();
        };
        WithViewportComponent.prototype.render = function() {
            var viewport = this.state.viewport;
            var newViewport = viewport.width > 0 && viewport.height > 0 ? viewport : undefined;
            return $acw62.createElement("div", {
                className: "ms-Viewport",
                ref: this._root,
                style: {
                    minWidth: 1,
                    minHeight: 1
                }
            }, $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: this._updateComposedComponentRef,
                viewport: newViewport
            }, this.props)));
        };
        WithViewportComponent.prototype.forceUpdate = function() {
            this._updateViewport(true);
        };
        WithViewportComponent.prototype._onAsyncResize = function() {
            this._updateViewport();
        };
        WithViewportComponent.prototype._isResizeObserverAvailable = function() {
            var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(this._root.current);
            return win && win.ResizeObserver;
        };
        return WithViewportComponent;
    }((0, $e763806f79fb847c$export$949383f3ea84aa97));
}



var $447dba424a845d0e$export$8a474f6d1d690904 = function(groups) {
    var total = 0;
    if (groups) {
        var remainingGroups = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], groups, true);
        var currentGroup = void 0;
        while(remainingGroups && remainingGroups.length > 0){
            ++total;
            currentGroup = remainingGroups.pop();
            if (currentGroup && currentGroup.children) remainingGroups.push.apply(remainingGroups, currentGroup.children);
        }
    }
    return total;
};







var $3428c95b3b311ff3$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $3428c95b3b311ff3$var$COMPONENT_NAME = "DetailsList";
var $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH = 100; // this is the global min width
var $3428c95b3b311ff3$var$DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var $3428c95b3b311ff3$var$DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var $3428c95b3b311ff3$var$rowFocusZoneAddTabIndexProps = {
    tabIndex: 0
};
var $3428c95b3b311ff3$var$rowFocusZoneNoTabIndexProps = {};
/**
 * Hooks-based implementation of DetailsList.
 * Since many existing consumers of DetailsList expect `ref` to return a `DetailsList`,
 * this inner component handles rendering while the outer maintains compatibility.
 */ var $3428c95b3b311ff3$var$DetailsListInner = function(props) {
    var selection = props.selection;
    var ariaLabelForListHeader = props.ariaLabelForListHeader, ariaLabelForSelectAllCheckbox = props.ariaLabelForSelectAllCheckbox, ariaLabelForSelectionColumn = props.ariaLabelForSelectionColumn, className = props.className, checkboxVisibility = props.checkboxVisibility, compact = props.compact, constrainMode = props.constrainMode, dragDropEvents = props.dragDropEvents, groups = props.groups, groupProps = props.groupProps, indentWidth = props.indentWidth, items = props.items, isPlaceholderData = props.isPlaceholderData, isHeaderVisible = props.isHeaderVisible, layoutMode = props.layoutMode, onItemInvoked = props.onItemInvoked, onItemContextMenu = props.onItemContextMenu, onColumnHeaderClick = props.onColumnHeaderClick, onColumnHeaderContextMenu = props.onColumnHeaderContextMenu, _a = props.selectionMode, selectionMode = _a === void 0 ? selection.mode : _a, selectionPreservedOnEmptyClick = props.selectionPreservedOnEmptyClick, selectionZoneProps = props.selectionZoneProps, // eslint-disable-next-line deprecation/deprecation
    ariaLabel = props.ariaLabel, ariaLabelForGrid = props.ariaLabelForGrid, rowElementEventMap = props.rowElementEventMap, // eslint-disable-next-line deprecation/deprecation
    _b = props.shouldApplyApplicationRole, // eslint-disable-next-line deprecation/deprecation
    shouldApplyApplicationRole = _b === void 0 ? false : _b, getKey = props.getKey, listProps = props.listProps, usePageCache = props.usePageCache, onShouldVirtualize = props.onShouldVirtualize, viewport = props.viewport, minimumPixelsForDrag = props.minimumPixelsForDrag, getGroupHeight = props.getGroupHeight, styles = props.styles, theme = props.theme, _c = props.cellStyleProps, cellStyleProps = _c === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _c, onRenderCheckbox = props.onRenderCheckbox, useFastIcons = props.useFastIcons, dragDropHelper = props.dragDropHelper, adjustedColumns = props.adjustedColumns, isCollapsed = props.isCollapsed, isSizing = props.isSizing, isSomeGroupExpanded = props.isSomeGroupExpanded, version = props.version, rootRef = props.rootRef, listRef = props.listRef, focusZoneRef = props.focusZoneRef, columnReorderOptions = props.columnReorderOptions, groupedListRef = props.groupedListRef, headerRef = props.headerRef, onGroupExpandStateChanged = props.onGroupExpandStateChanged, onColumnIsSizingChanged = props.onColumnIsSizingChanged, onRowDidMount = props.onRowDidMount, onRowWillUnmount = props.onRowWillUnmount, disableSelectionZone = props.disableSelectionZone, _d = props.isSelectedOnFocus, isSelectedOnFocus = _d === void 0 ? true : _d, onColumnResized = props.onColumnResized, onColumnAutoResized = props.onColumnAutoResized, onToggleCollapse = props.onToggleCollapse, onActiveRowChanged = props.onActiveRowChanged, onBlur = props.onBlur, eventsToRegister = props.rowElementEventMap, onRenderMissingItem = props.onRenderMissingItem, onRenderItemColumn = props.onRenderItemColumn, onRenderField = props.onRenderField, getCellValueKey = props.getCellValueKey, getRowAriaLabel = props.getRowAriaLabel, getRowAriaDescribedBy = props.getRowAriaDescribedBy, checkButtonAriaLabel = props.checkButtonAriaLabel, checkButtonGroupAriaLabel = props.checkButtonGroupAriaLabel, checkboxCellClassName = props.checkboxCellClassName, useReducedRowRenderer = props.useReducedRowRenderer, enableUpdateAnimations = props.enableUpdateAnimations, enterModalSelectionOnTouch = props.enterModalSelectionOnTouch, onRenderDefaultRow = props.onRenderDefaultRow, selectionZoneRef = props.selectionZoneRef, focusZoneProps = props.focusZoneProps;
    var defaultRole = "grid";
    var role = props.role ? props.role : defaultRole;
    var rowId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("row");
    var groupNestingDepth = $3428c95b3b311ff3$var$getGroupNestingDepth(groups);
    var groupedDetailsListIndexMap = $3428c95b3b311ff3$var$useGroupedDetailsListIndexMap(groups);
    var additionalListProps = $acw62.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            renderedWindowsAhead: isSizing ? 0 : $3428c95b3b311ff3$var$DEFAULT_RENDERED_WINDOWS_AHEAD,
            renderedWindowsBehind: isSizing ? 0 : $3428c95b3b311ff3$var$DEFAULT_RENDERED_WINDOWS_BEHIND,
            getKey: getKey,
            version: version
        }, listProps);
    }, [
        isSizing,
        getKey,
        version,
        listProps
    ]);
    var selectAllVisibility = (0, $96493c0d430c7ced$export$3befb9acac112094).none; // for SelectionMode.none
    if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).single) selectAllVisibility = (0, $96493c0d430c7ced$export$3befb9acac112094).hidden;
    if (selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple) {
        // if isCollapsedGroupSelectVisible is false, disable select all when the list has all collapsed groups
        var isCollapsedGroupSelectVisible = groupProps && groupProps.headerProps && groupProps.headerProps.isCollapsedGroupSelectVisible;
        if (isCollapsedGroupSelectVisible === undefined) isCollapsedGroupSelectVisible = true;
        var isSelectAllVisible = isCollapsedGroupSelectVisible || !groups || isSomeGroupExpanded;
        selectAllVisibility = isSelectAllVisible ? (0, $96493c0d430c7ced$export$3befb9acac112094).visible : (0, $96493c0d430c7ced$export$3befb9acac112094).hidden;
    }
    if (checkboxVisibility === (0, $5103473855f147d2$export$752592320202052a).hidden) selectAllVisibility = (0, $96493c0d430c7ced$export$3befb9acac112094).none;
    var defaultOnRenderDetailsHeader = $acw62.useCallback(function(detailsHeaderProps) {
        return $acw62.createElement((0, $5e9a87924c8945e7$export$56e2352e63353d99), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, detailsHeaderProps));
    }, []);
    var defaultOnRenderDetailsFooter = $acw62.useCallback(function() {
        return null;
    }, []);
    var propsOnRenderDetailsHeader = props.onRenderDetailsHeader;
    var onRenderDetailsHeader = $acw62.useMemo(function() {
        return propsOnRenderDetailsHeader ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(propsOnRenderDetailsHeader, defaultOnRenderDetailsHeader) : defaultOnRenderDetailsHeader;
    }, [
        propsOnRenderDetailsHeader,
        defaultOnRenderDetailsHeader
    ]);
    var propsOnRenderDetailsFooter = props.onRenderDetailsFooter;
    var onRenderDetailsFooter = $acw62.useMemo(function() {
        return propsOnRenderDetailsFooter ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(propsOnRenderDetailsFooter, defaultOnRenderDetailsFooter) : defaultOnRenderDetailsFooter;
    }, [
        propsOnRenderDetailsFooter,
        defaultOnRenderDetailsFooter
    ]);
    var detailsFooterProps = $acw62.useMemo(function() {
        return {
            columns: adjustedColumns,
            groupNestingDepth: groupNestingDepth,
            selection: selection,
            selectionMode: selectionMode,
            viewport: viewport,
            checkboxVisibility: checkboxVisibility,
            indentWidth: indentWidth,
            cellStyleProps: cellStyleProps
        };
    }, [
        adjustedColumns,
        groupNestingDepth,
        selection,
        selectionMode,
        viewport,
        checkboxVisibility,
        indentWidth,
        cellStyleProps
    ]);
    var columnReorderOnDragEnd = columnReorderOptions && columnReorderOptions.onDragEnd;
    var onColumnDragEnd = $acw62.useCallback(function(_a, event) {
        var dropLocation = _a.dropLocation;
        var finalDropLocation = (0, $5103473855f147d2$export$24c0b55ababe9a64).outside;
        if (columnReorderOnDragEnd) {
            if (dropLocation && dropLocation !== (0, $5103473855f147d2$export$24c0b55ababe9a64).header) finalDropLocation = dropLocation;
            else if (rootRef.current) {
                var clientRect = rootRef.current.getBoundingClientRect();
                if (event.clientX > clientRect.left && event.clientX < clientRect.right && event.clientY > clientRect.top && event.clientY < clientRect.bottom) finalDropLocation = (0, $5103473855f147d2$export$24c0b55ababe9a64).surface;
            }
            columnReorderOnDragEnd(finalDropLocation);
        }
    }, [
        columnReorderOnDragEnd,
        rootRef
    ]);
    var columnReorderProps = $acw62.useMemo(function() {
        if (columnReorderOptions) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, columnReorderOptions), {
            onColumnDragEnd: onColumnDragEnd
        });
    }, [
        columnReorderOptions,
        onColumnDragEnd
    ]);
    var rowCount = (isHeaderVisible ? 1 : 0) + (props.onRenderDetailsFooter ? 1 : 0) + (0, $447dba424a845d0e$export$8a474f6d1d690904)(groups) + (items ? items.length : 0);
    var colCount = (selectAllVisibility !== (0, $96493c0d430c7ced$export$3befb9acac112094).none ? 1 : 0) + (adjustedColumns ? adjustedColumns.length : 0) + (groups ? 1 : 0);
    var classNames = $acw62.useMemo(function() {
        return $3428c95b3b311ff3$var$getClassNames(styles, {
            theme: theme,
            compact: compact,
            isFixed: layoutMode === (0, $5103473855f147d2$export$2499c0b3a09a8cda).fixedColumns,
            isHorizontalConstrained: constrainMode === (0, $5103473855f147d2$export$ff960e2d30f8d80b).horizontalConstrained,
            className: className
        });
    }, [
        styles,
        theme,
        compact,
        layoutMode,
        constrainMode,
        className
    ]);
    var onRenderDetailsGroupFooter = groupProps && groupProps.onRenderFooter;
    var finalOnRenderDetailsGroupFooter = $acw62.useMemo(function() {
        return onRenderDetailsGroupFooter ? function(groupFooterProps, defaultRender) {
            return onRenderDetailsGroupFooter((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupFooterProps), {
                columns: adjustedColumns,
                groupNestingDepth: groupNestingDepth,
                indentWidth: indentWidth,
                selection: selection,
                selectionMode: selectionMode,
                viewport: viewport,
                checkboxVisibility: checkboxVisibility,
                cellStyleProps: cellStyleProps
            }), defaultRender);
        } : undefined;
    }, [
        onRenderDetailsGroupFooter,
        adjustedColumns,
        groupNestingDepth,
        indentWidth,
        selection,
        selectionMode,
        viewport,
        checkboxVisibility,
        cellStyleProps
    ]);
    var onRenderDetailsGroupHeader = groupProps && groupProps.onRenderHeader;
    var finalOnRenderDetailsGroupHeader = $acw62.useMemo(function() {
        return onRenderDetailsGroupHeader ? function(groupHeaderProps, defaultRender) {
            var _a, _b;
            var groupIndex = groupHeaderProps.groupIndex;
            var groupKey = groupIndex !== undefined ? (_b = (_a = groupHeaderProps.groups) === null || _a === void 0 ? void 0 : _a[groupIndex]) === null || _b === void 0 ? void 0 : _b.key : undefined;
            var totalRowCount = groupKey !== undefined && groupedDetailsListIndexMap[groupKey] ? groupedDetailsListIndexMap[groupKey].totalRowCount : 0;
            return onRenderDetailsGroupHeader((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupHeaderProps), {
                columns: adjustedColumns,
                groupNestingDepth: groupNestingDepth,
                indentWidth: indentWidth,
                selection: selection,
                selectionMode: checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden ? selectionMode : (0, $eb906a1fe3c7a837$export$91484609d16ec765).none,
                viewport: viewport,
                checkboxVisibility: checkboxVisibility,
                cellStyleProps: cellStyleProps,
                ariaColSpan: adjustedColumns.length,
                ariaLevel: undefined,
                ariaPosInSet: undefined,
                ariaSetSize: undefined,
                ariaRowCount: undefined,
                ariaRowIndex: groupIndex !== undefined ? totalRowCount + (isHeaderVisible ? 1 : 0) : undefined
            }), defaultRender);
        } : function(groupHeaderProps, defaultRender) {
            var _a, _b;
            var groupIndex = groupHeaderProps.groupIndex;
            var groupKey = groupIndex !== undefined ? (_b = (_a = groupHeaderProps.groups) === null || _a === void 0 ? void 0 : _a[groupIndex]) === null || _b === void 0 ? void 0 : _b.key : undefined;
            var totalRowCount = groupKey !== undefined && groupedDetailsListIndexMap[groupKey] ? groupedDetailsListIndexMap[groupKey].totalRowCount : 0;
            return defaultRender((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupHeaderProps), {
                ariaColSpan: adjustedColumns.length,
                ariaLevel: undefined,
                ariaPosInSet: undefined,
                ariaSetSize: undefined,
                ariaRowCount: undefined,
                ariaRowIndex: groupIndex !== undefined ? totalRowCount + (isHeaderVisible ? 1 : 0) : undefined
            }));
        };
    }, [
        onRenderDetailsGroupHeader,
        adjustedColumns,
        groupNestingDepth,
        indentWidth,
        isHeaderVisible,
        selection,
        selectionMode,
        viewport,
        checkboxVisibility,
        cellStyleProps,
        groupedDetailsListIndexMap
    ]);
    var finalGroupProps = $acw62.useMemo(function() {
        var _a;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps), {
            role: role === defaultRole ? "rowgroup" : "presentation",
            onRenderFooter: finalOnRenderDetailsGroupFooter,
            onRenderHeader: finalOnRenderDetailsGroupHeader,
            // pass through custom group header checkbox label
            headerProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps === null || groupProps === void 0 ? void 0 : groupProps.headerProps), {
                selectAllButtonProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    "aria-label": checkButtonGroupAriaLabel
                }, (_a = groupProps === null || groupProps === void 0 ? void 0 : groupProps.headerProps) === null || _a === void 0 ? void 0 : _a.selectAllButtonProps)
            })
        });
    }, [
        groupProps,
        finalOnRenderDetailsGroupFooter,
        finalOnRenderDetailsGroupHeader,
        checkButtonGroupAriaLabel,
        role
    ]);
    var sumColumnWidths = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(columns) {
            var totalWidth = 0;
            columns.forEach(function(column) {
                return totalWidth += column.calculatedWidth || column.minWidth;
            });
            return totalWidth;
        });
    });
    var collapseAllVisibility = groupProps && groupProps.collapseAllVisibility;
    var rowWidth = $acw62.useMemo(function() {
        return sumColumnWidths(adjustedColumns);
    }, [
        adjustedColumns,
        sumColumnWidths
    ]);
    var onRenderCell = $acw62.useCallback(function(nestingDepth, item, index, group) {
        var finalOnRenderRow = props.onRenderRow ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(props.onRenderRow, onRenderDefaultRow) : onRenderDefaultRow;
        var groupKey = group ? group.key : undefined;
        var numOfGroupHeadersBeforeItem = groupKey && groupedDetailsListIndexMap[groupKey] ? groupedDetailsListIndexMap[groupKey].numOfGroupHeadersBeforeItem : 0;
        var rowRole = role === defaultRole ? undefined : "presentation";
        // add tabindex="0" to first row if no header exists, to ensure the focuszone is in the tab order
        var rowFocusZoneProps = isHeaderVisible || index > 0 ? $3428c95b3b311ff3$var$rowFocusZoneNoTabIndexProps : $3428c95b3b311ff3$var$rowFocusZoneAddTabIndexProps;
        var rowProps = {
            item: item,
            itemIndex: index,
            flatIndexOffset: (isHeaderVisible ? 2 : 1) + numOfGroupHeadersBeforeItem,
            compact: compact,
            columns: adjustedColumns,
            groupNestingDepth: nestingDepth,
            id: "".concat(rowId, "-").concat(index),
            selectionMode: selectionMode,
            selection: selection,
            onDidMount: onRowDidMount,
            onWillUnmount: onRowWillUnmount,
            onRenderItemColumn: onRenderItemColumn,
            onRenderField: onRenderField,
            getCellValueKey: getCellValueKey,
            eventsToRegister: eventsToRegister,
            dragDropEvents: dragDropEvents,
            dragDropHelper: dragDropHelper,
            viewport: viewport,
            checkboxVisibility: checkboxVisibility,
            collapseAllVisibility: collapseAllVisibility,
            getRowAriaLabel: getRowAriaLabel,
            getRowAriaDescribedBy: getRowAriaDescribedBy,
            checkButtonAriaLabel: checkButtonAriaLabel,
            checkboxCellClassName: checkboxCellClassName,
            useReducedRowRenderer: useReducedRowRenderer,
            indentWidth: indentWidth,
            cellStyleProps: cellStyleProps,
            onRenderDetailsCheckbox: onRenderCheckbox,
            enableUpdateAnimations: enableUpdateAnimations,
            rowWidth: rowWidth,
            useFastIcons: useFastIcons,
            role: rowRole,
            isGridRow: true,
            focusZoneProps: rowFocusZoneProps
        };
        if (!item) {
            if (onRenderMissingItem) return onRenderMissingItem(index, rowProps);
            return null;
        }
        return finalOnRenderRow(rowProps);
    }, [
        compact,
        adjustedColumns,
        selectionMode,
        selection,
        rowId,
        onRowDidMount,
        onRowWillUnmount,
        onRenderItemColumn,
        onRenderField,
        getCellValueKey,
        eventsToRegister,
        dragDropEvents,
        dragDropHelper,
        viewport,
        checkboxVisibility,
        collapseAllVisibility,
        getRowAriaLabel,
        getRowAriaDescribedBy,
        isHeaderVisible,
        checkButtonAriaLabel,
        checkboxCellClassName,
        useReducedRowRenderer,
        indentWidth,
        cellStyleProps,
        onRenderCheckbox,
        enableUpdateAnimations,
        useFastIcons,
        onRenderDefaultRow,
        onRenderMissingItem,
        props.onRenderRow,
        rowWidth,
        role,
        groupedDetailsListIndexMap
    ]);
    var onRenderListCell = $acw62.useCallback(function(nestingDepth) {
        return function(item, itemIndex) {
            return onRenderCell(nestingDepth, item, itemIndex);
        };
    }, [
        onRenderCell
    ]);
    var isRightArrow = $acw62.useCallback(function(event) {
        // eslint-disable-next-line deprecation/deprecation
        return event.which === (0, $723d0744d8fe4fde$export$404175034cd47507)((0, $c011a102064f82ea$export$ec835b702d42f3f0).right, theme);
    }, [
        theme
    ]);
    var focusZoneInnerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, focusZoneProps), {
        componentRef: focusZoneProps && focusZoneProps.componentRef ? focusZoneProps.componentRef : focusZoneRef,
        className: focusZoneProps && focusZoneProps.className ? (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.focusZone, focusZoneProps.className) : classNames.focusZone,
        direction: focusZoneProps ? focusZoneProps.direction : (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical,
        shouldEnterInnerZone: focusZoneProps && focusZoneProps.shouldEnterInnerZone ? focusZoneProps.shouldEnterInnerZone : isRightArrow,
        onActiveElementChanged: focusZoneProps && focusZoneProps.onActiveElementChanged ? focusZoneProps.onActiveElementChanged : onActiveRowChanged,
        shouldRaiseClicksOnEnter: false,
        onBlur: focusZoneProps && focusZoneProps.onBlur ? focusZoneProps.onBlur : onBlur
    });
    var FinalGroupedList = groups && (groupProps === null || groupProps === void 0 ? void 0 : groupProps.groupedListAs) ? (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(groupProps.groupedListAs, (0, $a8210fb15a0e100c$export$7b9037ad46f5f6b2)) : (0, $a8210fb15a0e100c$export$7b9037ad46f5f6b2);
    var list = groups ? $acw62.createElement(FinalGroupedList, {
        focusZoneProps: focusZoneInnerProps,
        componentRef: groupedListRef,
        groups: groups,
        groupProps: finalGroupProps,
        items: items,
        onRenderCell: onRenderCell,
        role: "presentation",
        selection: selection,
        selectionMode: checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden ? selectionMode : (0, $eb906a1fe3c7a837$export$91484609d16ec765).none,
        dragDropEvents: dragDropEvents,
        dragDropHelper: dragDropHelper,
        eventsToRegister: rowElementEventMap,
        listProps: additionalListProps,
        onGroupExpandStateChanged: onGroupExpandStateChanged,
        usePageCache: usePageCache,
        onShouldVirtualize: onShouldVirtualize,
        getGroupHeight: getGroupHeight,
        compact: compact
    }) : $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, focusZoneInnerProps), $acw62.createElement((0, $eba311a0e1ed503e$export$54c2e3dc7acea9f5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: listRef,
        role: "presentation",
        items: items,
        onRenderCell: onRenderListCell(0),
        usePageCache: usePageCache,
        onShouldVirtualize: onShouldVirtualize
    }, additionalListProps)));
    var onHeaderKeyDown = $acw62.useCallback(function(ev) {
        // eslint-disable-next-line deprecation/deprecation
        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down) {
            if (focusZoneRef.current && focusZoneRef.current.focus()) {
                // select the first item in list after down arrow key event
                // only if nothing was selected; otherwise start with the already-selected item
                if (isSelectedOnFocus && selection.getSelectedIndices().length === 0) selection.setIndexSelected(0, true, false);
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    }, [
        selection,
        focusZoneRef,
        isSelectedOnFocus
    ]);
    var onContentKeyDown = $acw62.useCallback(function(ev) {
        // eslint-disable-next-line deprecation/deprecation
        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up && !ev.altKey) {
            if (headerRef.current && headerRef.current.focus()) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    }, [
        headerRef
    ]);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: rootRef,
        className: classNames.root,
        "data-automationid": "DetailsList",
        "data-is-scrollable": "false"
    }, shouldApplyApplicationRole ? {
        role: "application"
    } : {}), $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null), $acw62.createElement("div", {
        role: role,
        "aria-label": ariaLabelForGrid || ariaLabel,
        "aria-rowcount": isPlaceholderData ? 0 : rowCount,
        "aria-colcount": colCount,
        "aria-busy": isPlaceholderData
    }, $acw62.createElement("div", {
        onKeyDown: onHeaderKeyDown,
        role: "presentation",
        className: classNames.headerWrapper
    }, isHeaderVisible && onRenderDetailsHeader({
        componentRef: headerRef,
        selectionMode: selectionMode,
        layoutMode: layoutMode,
        selection: selection,
        columns: adjustedColumns,
        onColumnClick: onColumnHeaderClick,
        onColumnContextMenu: onColumnHeaderContextMenu,
        onColumnResized: onColumnResized,
        onColumnIsSizingChanged: onColumnIsSizingChanged,
        onColumnAutoResized: onColumnAutoResized,
        groupNestingDepth: groupNestingDepth,
        isAllCollapsed: isCollapsed,
        onToggleCollapseAll: onToggleCollapse,
        ariaLabel: ariaLabelForListHeader,
        ariaLabelForSelectAllCheckbox: ariaLabelForSelectAllCheckbox,
        ariaLabelForSelectionColumn: ariaLabelForSelectionColumn,
        selectAllVisibility: selectAllVisibility,
        collapseAllVisibility: groupProps && groupProps.collapseAllVisibility,
        viewport: viewport,
        columnReorderProps: columnReorderProps,
        minimumPixelsForDrag: minimumPixelsForDrag,
        cellStyleProps: cellStyleProps,
        checkboxVisibility: checkboxVisibility,
        indentWidth: indentWidth,
        onRenderDetailsCheckbox: onRenderCheckbox,
        rowWidth: sumColumnWidths(adjustedColumns),
        useFastIcons: useFastIcons
    }, onRenderDetailsHeader)), $acw62.createElement("div", {
        onKeyDown: onContentKeyDown,
        role: "presentation",
        className: classNames.contentWrapper
    }, !disableSelectionZone ? $acw62.createElement((0, $64c1598924895467$export$f4ca2ebb342e809c), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: selectionZoneRef,
        selection: selection,
        selectionPreservedOnEmptyClick: selectionPreservedOnEmptyClick,
        selectionMode: selectionMode,
        isSelectedOnFocus: isSelectedOnFocus,
        selectionClearedOnEscapePress: isSelectedOnFocus,
        toggleWithoutModifierPressed: !isSelectedOnFocus,
        onItemInvoked: onItemInvoked,
        onItemContextMenu: onItemContextMenu,
        enterModalOnTouch: enterModalSelectionOnTouch
    }, selectionZoneProps || {}), list) : list), onRenderDetailsFooter((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, detailsFooterProps))));
};
var $3428c95b3b311ff3$export$ee031b1d952aaa80 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DetailsListBase, _super);
    function DetailsListBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._header = $acw62.createRef();
        _this._groupedList = $acw62.createRef();
        _this._list = $acw62.createRef();
        _this._focusZone = $acw62.createRef();
        _this._selectionZone = $acw62.createRef();
        _this._onRenderRow = function(props, defaultRender) {
            return $acw62.createElement((0, $20c9ff4eb9fa4d75$export$cc11f0bd89960b80), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props));
        };
        _this._getDerivedStateFromProps = function(nextProps, previousState) {
            var _a = _this.props, checkboxVisibility = _a.checkboxVisibility, items = _a.items, setKey = _a.setKey, _b = _a.selectionMode, selectionMode = _b === void 0 ? _this._selection.mode : _b, columns = _a.columns, viewport = _a.viewport, compact = _a.compact, dragDropEvents = _a.dragDropEvents;
            var _c = (_this.props.groupProps || {}).isAllGroupsCollapsed, isAllGroupsCollapsed = _c === void 0 ? undefined : _c;
            var newViewportWidth = nextProps.viewport && nextProps.viewport.width || 0;
            var oldViewportWidth = viewport && viewport.width || 0;
            var shouldResetSelection = nextProps.setKey !== setKey || nextProps.setKey === undefined;
            var shouldForceUpdates = false;
            if (nextProps.layoutMode !== _this.props.layoutMode) shouldForceUpdates = true;
            var nextState = previousState;
            if (shouldResetSelection) {
                _this._initialFocusedIndex = nextProps.initialFocusedIndex;
                // reset focusedItemIndex when setKey changes
                nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), {
                    focusedItemIndex: _this._initialFocusedIndex !== undefined ? _this._initialFocusedIndex : -1
                });
            }
            if (!_this.props.disableSelectionZone && nextProps.items !== items) _this._selection.setItems(nextProps.items, shouldResetSelection);
            if (nextProps.checkboxVisibility !== checkboxVisibility || nextProps.columns !== columns || newViewportWidth !== oldViewportWidth || nextProps.compact !== compact) shouldForceUpdates = true;
            nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), _this._adjustColumns(nextProps, nextState, true));
            if (nextProps.selectionMode !== selectionMode) shouldForceUpdates = true;
            if (isAllGroupsCollapsed === undefined && nextProps.groupProps && nextProps.groupProps.isAllGroupsCollapsed !== undefined) nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), {
                isCollapsed: nextProps.groupProps.isAllGroupsCollapsed,
                isSomeGroupExpanded: !nextProps.groupProps.isAllGroupsCollapsed
            });
            if (nextProps.dragDropEvents !== dragDropEvents) {
                _this._dragDropHelper && _this._dragDropHelper.dispose();
                _this._dragDropHelper = nextProps.dragDropEvents ? new (0, $5492b08e38be5f64$export$5bf245762bac788e)({
                    selection: _this._selection,
                    minimumPixelsForDrag: nextProps.minimumPixelsForDrag
                }) : undefined;
                shouldForceUpdates = true;
            }
            if (shouldForceUpdates) nextState = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nextState), {
                version: {}
            });
            return nextState;
        };
        _this._onGroupExpandStateChanged = function(isSomeGroupExpanded) {
            _this.setState({
                isSomeGroupExpanded: isSomeGroupExpanded
            });
        };
        _this._onColumnIsSizingChanged = function(column, isSizing) {
            _this.setState({
                isSizing: isSizing
            });
        };
        _this._onRowDidMount = function(row) {
            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
            var itemKey = _this._getItemKey(item, itemIndex);
            _this._activeRows[itemKey] = row; // this is used for column auto resize
            _this._setFocusToRowIfPending(row);
            var onRowDidMount = _this.props.onRowDidMount;
            if (onRowDidMount) onRowDidMount(item, itemIndex);
        };
        _this._onRowWillUnmount = function(row) {
            var onRowWillUnmount = _this.props.onRowWillUnmount;
            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
            var itemKey = _this._getItemKey(item, itemIndex);
            delete _this._activeRows[itemKey];
            if (onRowWillUnmount) onRowWillUnmount(item, itemIndex);
        };
        _this._onToggleCollapse = function(collapsed) {
            _this.setState({
                isCollapsed: collapsed
            });
            if (_this._groupedList.current) _this._groupedList.current.toggleCollapseAll(collapsed);
        };
        _this._onColumnResized = function(resizingColumn, newWidth, resizingColumnIndex) {
            var newCalculatedWidth = Math.max(resizingColumn.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH, newWidth);
            if (_this.props.onColumnResize) _this.props.onColumnResize(resizingColumn, newCalculatedWidth, resizingColumnIndex);
            _this._rememberCalculatedWidth(resizingColumn, newCalculatedWidth);
            _this.setState((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, _this._adjustColumns(_this.props, _this.state, true, resizingColumnIndex)), {
                version: {}
            }));
        };
        /**
         * Callback function when double clicked on the details header column resizer
         * which will measure the column cells of all the active rows and resize the
         * column to the max cell width.
         *
         * @param column - double clicked column definition
         * @param columnIndex - double clicked column index
         * TODO: min width 100 should be changed to const value and should be consistent with the
         * value used on _onSizerMove method in DetailsHeader
         */ _this._onColumnAutoResized = function(column, columnIndex) {
            var max = 0;
            var count = 0;
            var totalCount = Object.keys(_this._activeRows).length;
            for(var key in _this._activeRows)if (_this._activeRows.hasOwnProperty(key)) {
                var currentRow = _this._activeRows[key];
                currentRow.measureCell(columnIndex, function(width) {
                    max = Math.max(max, width);
                    count++;
                    if (count === totalCount) _this._onColumnResized(column, max, columnIndex);
                });
            }
        };
        /**
         * Call back function when an element in FocusZone becomes active. It will translate it into item
         * and call onActiveItemChanged callback if specified.
         *
         * @param row - element that became active in Focus Zone
         * @param focus - event from Focus Zone
         */ _this._onActiveRowChanged = function(el, ev) {
            var _a = _this.props, items = _a.items, onActiveItemChanged = _a.onActiveItemChanged;
            if (!el) return;
            // Check and assign index only if the event was raised from any DetailsRow element
            if (el.getAttribute("data-item-index")) {
                var index = Number(el.getAttribute("data-item-index"));
                if (index >= 0) {
                    if (onActiveItemChanged) onActiveItemChanged(items[index], index, ev);
                    _this.setState({
                        focusedItemIndex: index
                    });
                }
            }
        };
        _this._onBlur = function(event) {
            _this.setState({
                focusedItemIndex: -1
            });
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._activeRows = {};
        _this._columnOverrides = {};
        _this.state = {
            focusedItemIndex: -1,
            lastWidth: 0,
            adjustedColumns: _this._getAdjustedColumns(props, undefined),
            isSizing: false,
            isCollapsed: props.groupProps && props.groupProps.isAllGroupsCollapsed,
            isSomeGroupExpanded: props.groupProps && !props.groupProps.isAllGroupsCollapsed,
            version: {},
            getDerivedStateFromProps: _this._getDerivedStateFromProps
        };
        (0, $8c9f8bb7c7ee0375$export$3dca6a71e81a1f03)($3428c95b3b311ff3$var$COMPONENT_NAME, props, {
            selection: "getKey"
        });
        _this._selection = props.selection || new (0, $35d588b46eba7c6b$export$52baac22726c72bf)({
            onSelectionChanged: undefined,
            getKey: props.getKey,
            selectionMode: props.selectionMode
        });
        if (!_this.props.disableSelectionZone) _this._selection.setItems(props.items, false);
        _this._dragDropHelper = props.dragDropEvents ? new (0, $5492b08e38be5f64$export$5bf245762bac788e)({
            selection: _this._selection,
            minimumPixelsForDrag: props.minimumPixelsForDrag
        }) : undefined;
        _this._initialFocusedIndex = props.initialFocusedIndex;
        return _this;
    }
    DetailsListBase.getDerivedStateFromProps = function(nextProps, previousState) {
        return previousState.getDerivedStateFromProps(nextProps, previousState);
    };
    DetailsListBase.prototype.scrollToIndex = function(index, measureItem, scrollToMode) {
        this._list.current && this._list.current.scrollToIndex(index, measureItem, scrollToMode);
        this._groupedList.current && this._groupedList.current.scrollToIndex(index, measureItem, scrollToMode);
    };
    DetailsListBase.prototype.focusIndex = function(index, forceIntoFirstElement, measureItem, scrollToMode) {
        if (forceIntoFirstElement === void 0) forceIntoFirstElement = false;
        var item = this.props.items[index];
        if (item) {
            this.scrollToIndex(index, measureItem, scrollToMode);
            var itemKey = this._getItemKey(item, index);
            var row = this._activeRows[itemKey];
            if (row) this._setFocusToRow(row, forceIntoFirstElement);
        }
    };
    DetailsListBase.prototype.getStartItemIndexInView = function() {
        if (this._list && this._list.current) return this._list.current.getStartItemIndexInView();
        else if (this._groupedList && this._groupedList.current) return this._groupedList.current.getStartItemIndexInView();
        return 0;
    };
    DetailsListBase.prototype.updateColumn = function(column, options) {
        var _a, _b;
        var NO_COLUMNS = [];
        var _c = this.props, _d = _c.columns, columns = _d === void 0 ? NO_COLUMNS : _d, selectionMode = _c.selectionMode, checkboxVisibility = _c.checkboxVisibility, columnReorderOptions = _c.columnReorderOptions;
        var width = options.width, newColumnIndex = options.newColumnIndex;
        var index = columns.findIndex(function(col) {
            return col.key === column.key;
        });
        if (width) this._onColumnResized(column, width, index);
        if (newColumnIndex !== undefined && columnReorderOptions) {
            var isCheckboxColumnHidden = selectionMode === (0, $eb906a1fe3c7a837$export$91484609d16ec765).none || checkboxVisibility === (0, $5103473855f147d2$export$752592320202052a).hidden;
            var showCheckbox = checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden;
            var columnIndex = (showCheckbox ? 2 : 1) + index;
            var draggedIndex = isCheckboxColumnHidden ? columnIndex - 1 : columnIndex - 2;
            var targetIndex = isCheckboxColumnHidden ? newColumnIndex - 1 : newColumnIndex - 2;
            var frozenColumnCountFromStart = (_a = columnReorderOptions.frozenColumnCountFromStart) !== null && _a !== void 0 ? _a : 0;
            var frozenColumnCountFromEnd = (_b = columnReorderOptions.frozenColumnCountFromEnd) !== null && _b !== void 0 ? _b : 0;
            var isValidTargetIndex = targetIndex >= frozenColumnCountFromStart && targetIndex < columns.length - frozenColumnCountFromEnd;
            if (isValidTargetIndex) {
                if (columnReorderOptions.onColumnDrop) {
                    var dragDropDetails = {
                        draggedIndex: draggedIndex,
                        targetIndex: targetIndex
                    };
                    columnReorderOptions.onColumnDrop(dragDropDetails);
                /* eslint-disable deprecation/deprecation */ } else if (columnReorderOptions.handleColumnReorder) columnReorderOptions.handleColumnReorder(draggedIndex, targetIndex);
            }
        }
    };
    DetailsListBase.prototype.componentWillUnmount = function() {
        if (this._dragDropHelper) // TODO If the DragDropHelper was passed via props, this will dispose it, which is incorrect behavior.
        this._dragDropHelper.dispose();
        this._async.dispose();
    };
    DetailsListBase.prototype.componentDidUpdate = function(prevProps, prevState) {
        this._notifyColumnsResized();
        if (this._initialFocusedIndex !== undefined) {
            var item = this.props.items[this._initialFocusedIndex];
            if (item) {
                var itemKey = this._getItemKey(item, this._initialFocusedIndex);
                var row = this._activeRows[itemKey];
                if (row) this._setFocusToRowIfPending(row);
            }
        }
        if (this.props.items !== prevProps.items && this.props.items.length > 0 && this.state.focusedItemIndex !== -1 && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, document.activeElement, false)) {
            // Item set has changed and previously-focused item is gone.
            // Set focus to item at index of previously-focused item if it is in range,
            // else set focus to the last item.
            var index = this.state.focusedItemIndex < this.props.items.length ? this.state.focusedItemIndex : this.props.items.length - 1;
            var item = this.props.items[index];
            var itemKey = this._getItemKey(item, this.state.focusedItemIndex);
            var row = this._activeRows[itemKey];
            if (row) this._setFocusToRow(row);
            else this._initialFocusedIndex = index;
        }
        if (this.props.onDidUpdate) this.props.onDidUpdate(this);
    };
    DetailsListBase.prototype.render = function() {
        return $acw62.createElement($3428c95b3b311ff3$var$DetailsListInner, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, this.state, {
            selection: this._selection,
            dragDropHelper: this._dragDropHelper,
            rootRef: this._root,
            listRef: this._list,
            groupedListRef: this._groupedList,
            focusZoneRef: this._focusZone,
            headerRef: this._header,
            selectionZoneRef: this._selectionZone,
            onGroupExpandStateChanged: this._onGroupExpandStateChanged,
            onColumnIsSizingChanged: this._onColumnIsSizingChanged,
            onRowDidMount: this._onRowDidMount,
            onRowWillUnmount: this._onRowWillUnmount,
            onColumnResized: this._onColumnResized,
            onColumnAutoResized: this._onColumnAutoResized,
            onToggleCollapse: this._onToggleCollapse,
            onActiveRowChanged: this._onActiveRowChanged,
            onBlur: this._onBlur,
            onRenderDefaultRow: this._onRenderRow
        }));
    };
    DetailsListBase.prototype.forceUpdate = function() {
        _super.prototype.forceUpdate.call(this);
        this._forceListUpdates();
    };
    DetailsListBase.prototype._getGroupNestingDepth = function() {
        var groups = this.props.groups;
        var level = 0;
        var groupsInLevel = groups;
        while(groupsInLevel && groupsInLevel.length > 0){
            level++;
            groupsInLevel = groupsInLevel[0].children;
        }
        return level;
    };
    DetailsListBase.prototype._setFocusToRowIfPending = function(row) {
        var itemIndex = row.props.itemIndex;
        if (this._initialFocusedIndex !== undefined && itemIndex === this._initialFocusedIndex) {
            this._setFocusToRow(row);
            delete this._initialFocusedIndex;
        }
    };
    DetailsListBase.prototype._setFocusToRow = function(row, forceIntoFirstElement) {
        if (forceIntoFirstElement === void 0) forceIntoFirstElement = false;
        if (this._selectionZone.current) this._selectionZone.current.ignoreNextFocus();
        this._async.setTimeout(function() {
            row.focus(forceIntoFirstElement);
        }, 0);
    };
    DetailsListBase.prototype._forceListUpdates = function() {
        if (this._groupedList.current) this._groupedList.current.forceUpdate();
        if (this._list.current) this._list.current.forceUpdate();
    };
    DetailsListBase.prototype._notifyColumnsResized = function() {
        this.state.adjustedColumns.forEach(function(column) {
            if (column.onColumnResize) column.onColumnResize(column.currentWidth);
        });
    };
    DetailsListBase.prototype._adjustColumns = function(newProps, previousState, forceUpdate, resizingColumnIndex) {
        var adjustedColumns = this._getAdjustedColumns(newProps, previousState, forceUpdate, resizingColumnIndex);
        var viewport = this.props.viewport;
        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, previousState), {
            adjustedColumns: adjustedColumns,
            lastWidth: viewportWidth
        });
    };
    /** Returns adjusted columns, given the viewport size and layout mode. */ DetailsListBase.prototype._getAdjustedColumns = function(newProps, previousState, forceUpdate, resizingColumnIndex) {
        var _this = this;
        var newItems = newProps.items, layoutMode = newProps.layoutMode, selectionMode = newProps.selectionMode, viewport = newProps.viewport;
        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
        var newColumns = newProps.columns;
        var columns = this.props ? this.props.columns : [];
        var lastWidth = previousState ? previousState.lastWidth : -1;
        var lastSelectionMode = previousState ? previousState.lastSelectionMode : undefined;
        if (!forceUpdate && lastWidth === viewportWidth && lastSelectionMode === selectionMode && (!columns || newColumns === columns)) return newColumns || [];
        newColumns = newColumns || $3428c95b3b311ff3$export$822a894be8d35e7(newItems, true);
        var adjustedColumns;
        if (layoutMode === (0, $5103473855f147d2$export$2499c0b3a09a8cda).fixedColumns) {
            adjustedColumns = this._getFixedColumns(newColumns, viewportWidth, newProps);
            // Preserve adjusted column calculated widths.
            adjustedColumns.forEach(function(column) {
                _this._rememberCalculatedWidth(column, column.calculatedWidth);
            });
        } else {
            adjustedColumns = this._getJustifiedColumns(newColumns, viewportWidth, newProps);
            adjustedColumns.forEach(function(column) {
                _this._getColumnOverride(column.key).currentWidth = column.calculatedWidth;
            });
        }
        return adjustedColumns;
    };
    /** Builds a set of columns based on the given columns mixed with the current overrides. */ DetailsListBase.prototype._getFixedColumns = function(newColumns, viewportWidth, props) {
        var _this = this;
        var _a = this.props, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, checkboxVisibility = _a.checkboxVisibility, flexMargin = _a.flexMargin, skipViewportMeasures = _a.skipViewportMeasures;
        var remainingWidth = viewportWidth - (flexMargin || 0);
        var sumProportionalWidth = 0;
        newColumns.forEach(function(col) {
            if (skipViewportMeasures || !col.flexGrow) remainingWidth -= col.maxWidth || col.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH;
            else {
                remainingWidth -= col.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH;
                sumProportionalWidth += col.flexGrow;
            }
            remainingWidth -= $3428c95b3b311ff3$var$getPaddedWidth(col, props, true);
        });
        var rowCheckWidth = selectionMode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).none && checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden ? (0, $939930e28b7e2661$export$80b16cf2baff1e7d) : 0;
        var groupExpandWidth = this._getGroupNestingDepth() * (0, $ec688b1a3baef560$export$13d8a2eff4c445cd);
        remainingWidth -= rowCheckWidth + groupExpandWidth;
        var widthFraction = remainingWidth / sumProportionalWidth;
        // Shrinks proportional columns to their max width and adds the remaining width to distribute to other columns.
        if (!skipViewportMeasures) newColumns.forEach(function(column) {
            var newColumn = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, column), _this._columnOverrides[column.key]);
            if (newColumn.flexGrow && newColumn.maxWidth) {
                var fullWidth = newColumn.flexGrow * widthFraction + newColumn.minWidth;
                var shrinkWidth = fullWidth - newColumn.maxWidth;
                if (shrinkWidth > 0) {
                    remainingWidth += shrinkWidth;
                    sumProportionalWidth -= shrinkWidth / (fullWidth - newColumn.minWidth) * newColumn.flexGrow;
                }
            }
        });
        widthFraction = remainingWidth > 0 ? remainingWidth / sumProportionalWidth : 0;
        return newColumns.map(function(column) {
            var newColumn = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, column), _this._columnOverrides[column.key]);
            // Delay computation until viewport width is available.
            if (!skipViewportMeasures && newColumn.flexGrow && remainingWidth <= 0) return newColumn;
            if (!newColumn.calculatedWidth) {
                if (!skipViewportMeasures && newColumn.flexGrow) {
                    // Assigns the proportion of the remaining extra width after all columns have met minimum widths.
                    newColumn.calculatedWidth = newColumn.minWidth + newColumn.flexGrow * widthFraction;
                    newColumn.calculatedWidth = Math.min(newColumn.calculatedWidth, newColumn.maxWidth || Number.MAX_VALUE);
                } else newColumn.calculatedWidth = newColumn.maxWidth || newColumn.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH;
            }
            return newColumn;
        });
    };
    /** Builds a set of columns to fix within the viewport width. */ DetailsListBase.prototype._getJustifiedColumns = function(newColumns, viewportWidth, props) {
        var _this = this;
        var _a = props.selectionMode, selectionMode = _a === void 0 ? this._selection.mode : _a, checkboxVisibility = props.checkboxVisibility, skipViewportMeasures = props.skipViewportMeasures;
        var rowCheckWidth = selectionMode !== (0, $eb906a1fe3c7a837$export$91484609d16ec765).none && checkboxVisibility !== (0, $5103473855f147d2$export$752592320202052a).hidden ? (0, $939930e28b7e2661$export$80b16cf2baff1e7d) : 0;
        var groupExpandWidth = this._getGroupNestingDepth() * (0, $ec688b1a3baef560$export$13d8a2eff4c445cd);
        var totalWidth = 0; // offset because we have one less inner padding.
        var minimumWidth = 0;
        var availableWidth = viewportWidth - (rowCheckWidth + groupExpandWidth);
        var adjustedColumns = newColumns.map(function(column, i) {
            var baseColumn = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, column), {
                calculatedWidth: column.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH
            });
            var newColumn = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, baseColumn), _this._columnOverrides[column.key]);
            // eslint-disable-next-line deprecation/deprecation
            if (!(baseColumn.isCollapsible || baseColumn.isCollapsable)) minimumWidth += $3428c95b3b311ff3$var$getPaddedWidth(baseColumn, props);
            totalWidth += $3428c95b3b311ff3$var$getPaddedWidth(newColumn, props);
            return newColumn;
        });
        if (skipViewportMeasures) return adjustedColumns;
        var lastIndex = adjustedColumns.length - 1;
        // Shrink or remove collapsable columns.
        while(lastIndex >= 0 && totalWidth > availableWidth){
            var column = adjustedColumns[lastIndex];
            var minWidth = column.minWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH;
            var overflowWidth = totalWidth - availableWidth;
            // eslint-disable-next-line deprecation/deprecation
            if (column.calculatedWidth - minWidth >= overflowWidth || !(column.isCollapsible || column.isCollapsable)) {
                var originalWidth = column.calculatedWidth;
                if (minimumWidth < availableWidth) // Only adjust in cases where all the columns fit within the viewport
                column.calculatedWidth = Math.max(column.calculatedWidth - overflowWidth, minWidth);
                totalWidth -= originalWidth - column.calculatedWidth;
            } else {
                totalWidth -= $3428c95b3b311ff3$var$getPaddedWidth(column, props);
                adjustedColumns.splice(lastIndex, 1);
            }
            lastIndex--;
        }
        // Then expand columns starting at the beginning, until we've filled the width.
        for(var i = 0; i < adjustedColumns.length && totalWidth < availableWidth; i++){
            var column = adjustedColumns[i];
            var isLast = i === adjustedColumns.length - 1;
            var overrides = this._columnOverrides[column.key];
            if (overrides && overrides.calculatedWidth && !isLast) continue;
            var spaceLeft = availableWidth - totalWidth;
            var increment = void 0;
            if (isLast) increment = spaceLeft;
            else {
                var maxWidth = column.maxWidth;
                var minWidth = column.minWidth || maxWidth || $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH;
                increment = maxWidth ? Math.min(spaceLeft, maxWidth - minWidth) : spaceLeft;
            }
            column.calculatedWidth = column.calculatedWidth + increment;
            totalWidth += increment;
        }
        return adjustedColumns;
    };
    DetailsListBase.prototype._rememberCalculatedWidth = function(column, newCalculatedWidth) {
        var overrides = this._getColumnOverride(column.key);
        overrides.calculatedWidth = newCalculatedWidth;
        overrides.currentWidth = newCalculatedWidth;
    };
    DetailsListBase.prototype._getColumnOverride = function(key) {
        return this._columnOverrides[key] = this._columnOverrides[key] || {};
    };
    DetailsListBase.prototype._getItemKey = function(item, itemIndex) {
        var getKey = this.props.getKey;
        var itemKey = undefined;
        if (item) itemKey = item.key;
        if (getKey) itemKey = getKey(item, itemIndex);
        if (!itemKey) itemKey = itemIndex;
        return itemKey;
    };
    DetailsListBase.defaultProps = {
        layoutMode: (0, $5103473855f147d2$export$2499c0b3a09a8cda).justified,
        selectionMode: (0, $eb906a1fe3c7a837$export$91484609d16ec765).multiple,
        constrainMode: (0, $5103473855f147d2$export$ff960e2d30f8d80b).horizontalConstrained,
        checkboxVisibility: (0, $5103473855f147d2$export$752592320202052a).onHover,
        isHeaderVisible: true,
        compact: false,
        useFastIcons: true
    };
    DetailsListBase = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $f3b90d67e812c3a1$export$1ba62c68904e2fde)
    ], DetailsListBase);
    return DetailsListBase;
}($acw62.Component);
function $3428c95b3b311ff3$export$822a894be8d35e7(items, canResizeColumns, onColumnClick, sortedColumnKey, isSortedDescending, groupedColumnKey, isMultiline, columnActionsMode) {
    var columns = [];
    if (items && items.length) {
        var firstItem = items[0];
        for(var propName in firstItem)if (firstItem.hasOwnProperty(propName)) columns.push({
            key: propName,
            name: propName,
            fieldName: propName,
            minWidth: $3428c95b3b311ff3$var$MIN_COLUMN_WIDTH,
            maxWidth: 300,
            isCollapsible: !!columns.length,
            isMultiline: isMultiline === undefined ? false : isMultiline,
            isSorted: sortedColumnKey === propName,
            isSortedDescending: !!isSortedDescending,
            isRowHeader: false,
            columnActionsMode: columnActionsMode !== null && columnActionsMode !== void 0 ? columnActionsMode : (0, $5103473855f147d2$export$e393753d4e31e51).clickable,
            isResizable: canResizeColumns,
            onColumnClick: onColumnClick,
            isGrouped: groupedColumnKey === propName
        });
    }
    return columns;
}
function $3428c95b3b311ff3$var$getPaddedWidth(column, props, paddingOnly) {
    var _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? (0, $ee27f738f928d431$export$8d1af5f7ea824b8d) : _a;
    return (paddingOnly ? 0 : column.calculatedWidth) + cellStyleProps.cellLeftPadding + cellStyleProps.cellRightPadding + (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
}
function $3428c95b3b311ff3$var$getGroupNestingDepth(groups) {
    var level = 0;
    var groupsInLevel = groups;
    while(groupsInLevel && groupsInLevel.length > 0){
        level++;
        groupsInLevel = groupsInLevel[0].children;
    }
    return level;
}
function $3428c95b3b311ff3$var$useGroupedDetailsListIndexMap(groups) {
    return $acw62.useMemo(function() {
        var indexMap = {};
        if (groups) {
            var rowCount = 1;
            var numGroupHeaders = 1;
            for(var _i = 0, groups_1 = groups; _i < groups_1.length; _i++){
                var group = groups_1[_i];
                var key = group.key;
                indexMap[key] = {
                    numOfGroupHeadersBeforeItem: numGroupHeaders,
                    totalRowCount: rowCount
                };
                numGroupHeaders++;
                rowCount += group.count + 1;
            }
        }
        return indexMap;
    }, [
        groups
    ]);
}



var $aec20402ee43aacb$var$GlobalClassNames = {
    root: "ms-DetailsList",
    compact: "ms-DetailsList--Compact",
    contentWrapper: "ms-DetailsList-contentWrapper",
    headerWrapper: "ms-DetailsList-headerWrapper",
    isFixed: "is-fixed",
    isHorizontalConstrained: "is-horizontalConstrained",
    listCell: "ms-List-cell"
};
var $aec20402ee43aacb$export$5942ef8c8f0f5aaf = function(props) {
    var _a, _b;
    var theme = props.theme, className = props.className, isHorizontalConstrained = props.isHorizontalConstrained, compact = props.compact, isFixed = props.isFixed;
    var semanticColors = theme.semanticColors;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($aec20402ee43aacb$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.small,
            {
                position: "relative",
                color: semanticColors.listText,
                selectors: (_a = {}, _a["& .".concat(classNames.listCell)] = {
                    minHeight: 38,
                    wordBreak: "break-word"
                }, _a)
            },
            isFixed && classNames.isFixed,
            compact && [
                classNames.compact,
                {
                    selectors: (_b = {}, _b[".".concat(classNames.listCell)] = {
                        minHeight: 32
                    }, _b)
                }
            ],
            isHorizontalConstrained && [
                classNames.isHorizontalConstrained,
                {
                    overflowX: "auto",
                    overflowY: "visible",
                    WebkitOverflowScrolling: "touch"
                }
            ],
            className
        ],
        focusZone: [
            {
                display: "inline-block",
                minWidth: "100%",
                minHeight: 1
            }
        ],
        headerWrapper: classNames.headerWrapper,
        contentWrapper: classNames.contentWrapper
    };
};


var $ff260a7ce3c550d8$export$bdef74da83342439 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $3428c95b3b311ff3$export$ee031b1d952aaa80), (0, $aec20402ee43aacb$export$5942ef8c8f0f5aaf), undefined, {
    scope: "DetailsList"
});




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






var $d5c452a0e6fe6545$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles) {
    var _a;
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var splitButtonStyles = (0, $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57)(theme);
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var iconButtonStyles = {
        root: {
            padding: "0 4px",
            width: "32px",
            height: "32px",
            backgroundColor: "transparent",
            border: "none",
            color: semanticColors.link
        },
        rootHovered: {
            color: palette.themeDarkAlt,
            backgroundColor: palette.neutralLighter,
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                borderColor: "Highlight",
                color: "Highlight"
            }, _a)
        },
        rootHasMenu: {
            width: "auto"
        },
        rootPressed: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootExpanded: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootChecked: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootCheckedHovered: {
            color: palette.themeDark,
            backgroundColor: palette.neutralQuaternaryAlt
        },
        rootDisabled: {
            color: palette.neutralTertiaryAlt
        }
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, iconButtonStyles, splitButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $e1e2a5c29caeedea$export$c25acd513dcc8062 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function() {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: "ms-Button--icon",
            styles: (0, $d5c452a0e6fe6545$export$ffd58b7f6f099a57)(theme, styles),
            onRenderText: (0, $12233c50b7efccdc$export$c14f77b8570f3676),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    IconButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)("IconButton", [
            "theme",
            "styles"
        ], true)
    ], IconButton);
    return IconButton;
}($acw62.Component);



/**
 * {@docCategory MessageBar}
 */ var $d2ca2ffbf75eeb82$export$4e445f5154412478;
(function(MessageBarType) {
    /** Info styled MessageBar */ MessageBarType[MessageBarType["info"] = 0] = "info";
    /** Error styled MessageBar */ MessageBarType[MessageBarType["error"] = 1] = "error";
    /** Blocked styled MessageBar */ MessageBarType[MessageBarType["blocked"] = 2] = "blocked";
    /** SevereWarning styled MessageBar */ MessageBarType[MessageBarType["severeWarning"] = 3] = "severeWarning";
    /** Success styled MessageBar */ MessageBarType[MessageBarType["success"] = 4] = "success";
    /** Warning styled MessageBar */ MessageBarType[MessageBarType["warning"] = 5] = "warning";
})($d2ca2ffbf75eeb82$export$4e445f5154412478 || ($d2ca2ffbf75eeb82$export$4e445f5154412478 = {}));



var $acw62 = parcelRequire("acw62");

function $4e47a037286114d5$export$c32275ecbd12948f(initialState) {
    var _a = $acw62.useState(initialState), value = _a[0], setValue = _a[1];
    var setTrue = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(true);
        };
    });
    var setFalse = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(false);
        };
    });
    var toggle = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(function(currentValue) {
                return !currentValue;
            });
        };
    });
    return [
        value,
        {
            setTrue: setTrue,
            setFalse: setFalse,
            toggle: toggle
        }
    ];
}


var $3f0d55d859c8c343$var$_a;
var $3f0d55d859c8c343$var$ICON_MAP = ($3f0d55d859c8c343$var$_a = {}, $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info] = "Info", $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning] = "Info", $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error] = "ErrorBadge", $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked] = "Blocked2", $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning] = "Warning", $3f0d55d859c8c343$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success] = "Completed", $3f0d55d859c8c343$var$_a);
var $3f0d55d859c8c343$var$COMPONENT_NAME = "MessageBar";
var $3f0d55d859c8c343$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $3f0d55d859c8c343$var$getAnnouncementPriority = function(messageBarType) {
    switch(messageBarType){
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked:
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error:
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning:
            return "assertive";
    }
    return "polite";
};
var $3f0d55d859c8c343$var$getRole = function(messageBarType) {
    switch(messageBarType){
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked:
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error:
        case (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning:
            return "alert";
    }
    return "status";
};
var $3f0d55d859c8c343$export$f4349fb374ccc811 = $acw62.forwardRef(function(props, ref) {
    var _a = (0, $4e47a037286114d5$export$c32275ecbd12948f)(false), expandSingleLine = _a[0], toggleExpandSingleLine = _a[1].toggle;
    var labelId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)("MessageBar");
    var actions = props.actions, className = props.className, children = props.children, // eslint-disable-next-line deprecation/deprecation
    overflowButtonAriaLabel = props.overflowButtonAriaLabel, dismissIconProps = props.dismissIconProps, styles = props.styles, theme = props.theme, _b = props.messageBarType, messageBarType = _b === void 0 ? (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info : _b, _c = props.onDismiss, onDismiss = _c === void 0 ? undefined : _c, _d = props.isMultiline, isMultiline = _d === void 0 ? true : _d, truncated = props.truncated, dismissButtonAriaLabel = props.dismissButtonAriaLabel, messageBarIconProps = props.messageBarIconProps, role = props.role, _e = props.delayedRender, delayedRender = _e === void 0 ? true : _e, expandButtonProps = props.expandButtonProps;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40), [
        "className",
        "role"
    ]);
    var classNames = $3f0d55d859c8c343$var$getClassNames(styles, {
        theme: theme,
        messageBarType: messageBarType || (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info,
        onDismiss: onDismiss !== undefined,
        actions: actions !== undefined,
        truncated: truncated,
        isMultiline: isMultiline,
        expandSingleLine: expandSingleLine,
        className: className
    });
    var expandIconProps = {
        iconName: expandSingleLine ? "DoubleChevronUp" : "DoubleChevronDown"
    };
    var regionProps = actions || onDismiss ? {
        "aria-describedby": labelId,
        role: "region"
    } : {};
    var actionsDiv = actions ? $acw62.createElement("div", {
        className: classNames.actions
    }, actions) : null;
    var dismissButton = onDismiss ? $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), {
        disabled: false,
        className: classNames.dismissal,
        onClick: onDismiss,
        iconProps: dismissIconProps ? dismissIconProps : {
            iconName: "Clear"
        },
        title: dismissButtonAriaLabel,
        ariaLabel: dismissButtonAriaLabel
    }) : null;
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: ref,
        className: classNames.root
    }, regionProps), $acw62.createElement("div", {
        className: classNames.content
    }, $acw62.createElement("div", {
        className: classNames.iconContainer,
        "aria-hidden": true
    }, messageBarIconProps ? $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, messageBarIconProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.icon, messageBarIconProps.className)
    })) : $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
        iconName: $3f0d55d859c8c343$var$ICON_MAP[messageBarType],
        className: classNames.icon
    })), $acw62.createElement("div", {
        className: classNames.text,
        id: labelId,
        role: role || $3f0d55d859c8c343$var$getRole(messageBarType),
        "aria-live": $3f0d55d859c8c343$var$getAnnouncementPriority(messageBarType)
    }, $acw62.createElement("span", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        className: classNames.innerText
    }, nativeProps), delayedRender ? $acw62.createElement((0, $9e351c993b799a2b$export$fd40b834a3906fa8), null, $acw62.createElement("span", null, children)) : // this span is probably not necessary, but preserving it for now in case anyone
    // has styling that expects it to be present
    $acw62.createElement("span", null, children))), /* singleline expand/collapse button */ !isMultiline && !actionsDiv && truncated && $acw62.createElement("div", {
        className: classNames.expandSingleLine
    }, $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        disabled: false,
        className: classNames.expand,
        onClick: toggleExpandSingleLine,
        iconProps: expandIconProps,
        ariaLabel: overflowButtonAriaLabel,
        "aria-expanded": expandSingleLine
    }, expandButtonProps))), !isMultiline && actionsDiv, /* singleline dismiss */ !isMultiline && dismissButton && $acw62.createElement("div", {
        className: classNames.dismissSingleLine
    }, dismissButton), isMultiline && dismissButton), isMultiline && actionsDiv);
});
$3f0d55d859c8c343$export$f4349fb374ccc811.displayName = $3f0d55d859c8c343$var$COMPONENT_NAME;





var $e217eb81988cd87b$var$_a, $e217eb81988cd87b$var$_b, $e217eb81988cd87b$var$_c, $e217eb81988cd87b$var$_d;
var $e217eb81988cd87b$var$GlobalClassNames = {
    root: "ms-MessageBar",
    error: "ms-MessageBar--error",
    blocked: "ms-MessageBar--blocked",
    severeWarning: "ms-MessageBar--severeWarning",
    success: "ms-MessageBar--success",
    warning: "ms-MessageBar--warning",
    multiline: "ms-MessageBar-multiline",
    singleline: "ms-MessageBar-singleline",
    dismissalSingleLine: "ms-MessageBar-dismissalSingleLine",
    expandingSingleLine: "ms-MessageBar-expandingSingleLine",
    content: "ms-MessageBar-content",
    iconContainer: "ms-MessageBar-icon",
    text: "ms-MessageBar-text",
    innerText: "ms-MessageBar-innerText",
    dismissSingleLine: "ms-MessageBar-dismissSingleLine",
    expandSingleLine: "ms-MessageBar-expandSingleLine",
    dismissal: "ms-MessageBar-dismissal",
    expand: "ms-MessageBar-expand",
    actions: "ms-MessageBar-actions",
    actionsSingleline: "ms-MessageBar-actionsSingleLine"
};
var $e217eb81988cd87b$var$backgroundColor = ($e217eb81988cd87b$var$_a = {}, $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error] = "errorBackground", $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked] = "errorBackground", $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success] = "successBackground", $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning] = "warningBackground", $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning] = "severeWarningBackground", $e217eb81988cd87b$var$_a[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info] = "infoBackground", $e217eb81988cd87b$var$_a);
var $e217eb81988cd87b$var$iconColor = ($e217eb81988cd87b$var$_b = {}, $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error] = "errorIcon", $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked] = "errorIcon", $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success] = "successIcon", $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning] = "warningIcon", $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning] = "severeWarningIcon", $e217eb81988cd87b$var$_b[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info] = "infoIcon", $e217eb81988cd87b$var$_b);
var $e217eb81988cd87b$var$highContrastBorderColor = ($e217eb81988cd87b$var$_c = {}, $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error] = "#ff0000", $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked] = "#ff0000", $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success] = "#bad80a", $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning] = "#fff100", $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning] = "#ff0000", $e217eb81988cd87b$var$_c[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info] = "WindowText", $e217eb81988cd87b$var$_c);
var $e217eb81988cd87b$var$highContrastWhiteBorderColor = ($e217eb81988cd87b$var$_d = {}, $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error] = "#e81123", $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked] = "#e81123", $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success] = "#107c10", $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning] = "#966400", $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning] = "#d83b01", $e217eb81988cd87b$var$_d[(0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info] = "WindowText", $e217eb81988cd87b$var$_d);
var $e217eb81988cd87b$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var theme = props.theme, className = props.className, onDismiss = props.onDismiss, truncated = props.truncated, isMultiline = props.isMultiline, expandSingleLine = props.expandSingleLine, _m = props.messageBarType, messageBarType = _m === void 0 ? (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info : _m;
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    var SmallScreenSelector = (0, $905fed6f1ccd845a$export$be136f2e7621e736)(0, (0, $905fed6f1ccd845a$export$b7949b403ba42a41));
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($e217eb81988cd87b$var$GlobalClassNames, theme);
    var dismissalAndExpandIconStyle = {
        fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).xSmall,
        height: 10,
        lineHeight: "10px",
        color: semanticColors.messageText,
        selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
            color: "WindowText"
        }), _a)
    };
    var dismissalAndExpandStyle = [
        (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
            inset: 1,
            highContrastStyle: {
                outlineOffset: "-6px",
                outline: "1px solid Highlight"
            },
            borderColor: "transparent"
        }),
        {
            flexShrink: 0,
            width: 32,
            height: 32,
            padding: "8px 12px",
            selectors: {
                "& .ms-Button-icon": dismissalAndExpandIconStyle,
                ":hover": {
                    backgroundColor: "transparent"
                },
                ":active": {
                    backgroundColor: "transparent"
                }
            }
        }
    ];
    return {
        root: [
            classNames.root,
            fonts.medium,
            messageBarType === (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error && classNames.error,
            messageBarType === (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).blocked && classNames.blocked,
            messageBarType === (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).severeWarning && classNames.severeWarning,
            messageBarType === (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).success && classNames.success,
            messageBarType === (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).warning && classNames.warning,
            isMultiline ? classNames.multiline : classNames.singleline,
            !isMultiline && onDismiss && classNames.dismissalSingleLine,
            !isMultiline && truncated && classNames.expandingSingleLine,
            {
                background: semanticColors[$e217eb81988cd87b$var$backgroundColor[messageBarType]],
                boxSizing: "border-box",
                color: semanticColors.messageText,
                minHeight: 32,
                width: "100%",
                display: "flex",
                wordBreak: "break-word",
                selectors: (_b = {
                    ".ms-Link": {
                        color: semanticColors.messageLink,
                        selectors: {
                            ":hover": {
                                color: semanticColors.messageLinkHovered
                            }
                        }
                    }
                }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                    background: "transparent",
                    border: "1px solid ".concat($e217eb81988cd87b$var$highContrastBorderColor[messageBarType]),
                    color: "WindowText"
                }), _b[0, $905fed6f1ccd845a$export$f57e8a065222a88e] = {
                    border: "1px solid ".concat($e217eb81988cd87b$var$highContrastWhiteBorderColor[messageBarType])
                }, _b)
            },
            isMultiline && {
                flexDirection: "column"
            },
            className
        ],
        content: [
            classNames.content,
            (_c = {
                display: "flex",
                width: "100%",
                lineHeight: "normal"
            }, _c[SmallScreenSelector] = {
                display: "grid",
                gridTemplateColumns: "auto 1fr auto",
                gridTemplateRows: "1fr auto",
                gridTemplateAreas: '\n            "icon text close"\n            "action action action"\n          '
            }, _c)
        ],
        iconContainer: [
            classNames.iconContainer,
            (_d = {
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
                minWidth: 16,
                minHeight: 16,
                display: "flex",
                flexShrink: 0,
                margin: "8px 0 8px 12px"
            }, _d[SmallScreenSelector] = {
                gridArea: "icon"
            }, _d)
        ],
        icon: {
            color: semanticColors[$e217eb81988cd87b$var$iconColor[messageBarType]],
            selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                color: "WindowText"
            }), _e)
        },
        text: [
            classNames.text,
            (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                minWidth: 0,
                display: "flex",
                flexGrow: 1,
                margin: 8
            }, fonts.small), (_f = {}, _f[SmallScreenSelector] = {
                gridArea: "text"
            }, _f.selectors = (_g = {}, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _g), _f)),
            !onDismiss && {
                marginRight: 12
            }
        ],
        innerText: [
            classNames.innerText,
            {
                lineHeight: 16,
                selectors: {
                    "& span a:last-child": {
                        paddingLeft: 4
                    }
                }
            },
            truncated && {
                overflow: "visible",
                whiteSpace: "pre-wrap"
            },
            !isMultiline && {
                // In high contrast this causes the top and bottom of links' focus outline to be clipped
                // (not sure of a good way around that while still maintaining text clipping)
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            },
            !isMultiline && !truncated && {
                selectors: (_h = {}, _h[SmallScreenSelector] = {
                    overflow: "visible",
                    whiteSpace: "pre-wrap"
                }, _h)
            },
            expandSingleLine && {
                overflow: "visible",
                whiteSpace: "pre-wrap"
            }
        ],
        dismissSingleLine: [
            classNames.dismissSingleLine,
            (_j = {}, _j[SmallScreenSelector] = {
                gridArea: "close"
            }, _j)
        ],
        expandSingleLine: classNames.expandSingleLine,
        dismissal: [
            classNames.dismissal,
            dismissalAndExpandStyle
        ],
        expand: [
            classNames.expand,
            dismissalAndExpandStyle
        ],
        actions: [
            isMultiline ? classNames.actions : classNames.actionsSingleline,
            (_k = {
                display: "flex",
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: "auto",
                flexDirection: "row-reverse",
                alignItems: "center",
                margin: "0 12px 0 8px",
                // reset forced colors to browser control for inner actions
                forcedColorAdjust: "auto",
                MsHighContrastAdjust: "auto"
            }, _k[SmallScreenSelector] = {
                gridArea: "action",
                marginRight: 8,
                marginBottom: 8
            }, _k.selectors = {
                "& button:nth-child(n+2)": (_l = {
                    marginLeft: 8
                }, _l[SmallScreenSelector] = {
                    marginBottom: 0
                }, _l)
            }, _k),
            isMultiline && {
                marginBottom: 8
            },
            onDismiss && !isMultiline && {
                marginRight: 0
            }
        ]
    };
};


var $9f5f9961c32ac024$export$1fa34b291900a3af = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $3f0d55d859c8c343$export$f4349fb374ccc811), (0, $e217eb81988cd87b$export$ffd58b7f6f099a57), undefined, {
    scope: "MessageBar"
});




var $acw62 = parcelRequire("acw62");

var $68fcab632ef25cc9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
// if the percentComplete is near 0, don't animate it.
// This prevents animations on reset to 0 scenarios
var $68fcab632ef25cc9$var$ZERO_THRESHOLD = 0.01;
/**
 * ProgressIndicator with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/microsoft/fluentui/wiki/Styling)
 */ var $68fcab632ef25cc9$export$a7e7bdd851b78592 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ProgressIndicatorBase, _super);
    function ProgressIndicatorBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderProgress = function(props) {
            var _a = _this.props, ariaLabel = _a.ariaLabel, ariaValueText = _a.ariaValueText, barHeight = _a.barHeight, className = _a.className, description = _a.description, // eslint-disable-next-line deprecation/deprecation
            _b = _a.label, // eslint-disable-next-line deprecation/deprecation
            label = _b === void 0 ? _this.props.title : _b, styles = _a.styles, theme = _a.theme;
            var percentComplete = typeof _this.props.percentComplete === "number" ? Math.min(100, Math.max(0, _this.props.percentComplete * 100)) : undefined;
            var classNames = $68fcab632ef25cc9$var$getClassNames(styles, {
                theme: theme,
                className: className,
                barHeight: barHeight,
                indeterminate: percentComplete === undefined ? true : false
            });
            var progressBarStyles = {
                width: percentComplete !== undefined ? percentComplete + "%" : undefined,
                transition: percentComplete !== undefined && percentComplete < $68fcab632ef25cc9$var$ZERO_THRESHOLD ? "none" : undefined
            };
            var ariaValueMin = percentComplete !== undefined ? 0 : undefined;
            var ariaValueMax = percentComplete !== undefined ? 100 : undefined;
            var ariaValueNow = percentComplete !== undefined ? Math.floor(percentComplete) : undefined;
            return $acw62.createElement("div", {
                className: classNames.itemProgress
            }, $acw62.createElement("div", {
                className: classNames.progressTrack
            }), $acw62.createElement("div", {
                className: classNames.progressBar,
                style: progressBarStyles,
                role: "progressbar",
                "aria-describedby": description ? _this._descriptionId : undefined,
                "aria-label": ariaLabel,
                "aria-labelledby": label ? _this._labelId : undefined,
                "aria-valuemin": ariaValueMin,
                "aria-valuemax": ariaValueMax,
                "aria-valuenow": ariaValueNow,
                "aria-valuetext": ariaValueText
            }));
        };
        var id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("progress-indicator");
        _this._labelId = id + "-label";
        _this._descriptionId = id + "-description";
        return _this;
    }
    ProgressIndicatorBase.prototype.render = function() {
        var _a = this.props, barHeight = _a.barHeight, className = _a.className, // eslint-disable-next-line deprecation/deprecation
        _b = _a.label, // eslint-disable-next-line deprecation/deprecation
        label = _b === void 0 ? this.props.title : _b, description = _a.description, styles = _a.styles, theme = _a.theme, progressHidden = _a.progressHidden, _c = _a.onRenderProgress, onRenderProgress = _c === void 0 ? this._onRenderProgress : _c;
        var percentComplete = typeof this.props.percentComplete === "number" ? Math.min(100, Math.max(0, this.props.percentComplete * 100)) : undefined;
        var classNames = $68fcab632ef25cc9$var$getClassNames(styles, {
            theme: theme,
            className: className,
            barHeight: barHeight,
            indeterminate: percentComplete === undefined ? true : false
        });
        return $acw62.createElement("div", {
            className: classNames.root
        }, label ? $acw62.createElement("div", {
            id: this._labelId,
            className: classNames.itemName
        }, label) : null, !progressHidden ? onRenderProgress((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props), {
            percentComplete: percentComplete
        }), this._onRenderProgress) : null, description ? $acw62.createElement("div", {
            id: this._descriptionId,
            className: classNames.itemDescription
        }, description) : null);
    };
    ProgressIndicatorBase.defaultProps = {
        label: "",
        description: "",
        width: 180
    };
    return ProgressIndicatorBase;
}($acw62.Component);





var $d128ae4039738a0a$var$GlobalClassNames = {
    root: "ms-ProgressIndicator",
    itemName: "ms-ProgressIndicator-itemName",
    itemDescription: "ms-ProgressIndicator-itemDescription",
    itemProgress: "ms-ProgressIndicator-itemProgress",
    progressTrack: "ms-ProgressIndicator-progressTrack",
    progressBar: "ms-ProgressIndicator-progressBar"
};
var $d128ae4039738a0a$var$IndeterminateProgress = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function() {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        "0%": {
            left: "-30%"
        },
        "100%": {
            left: "100%"
        }
    });
});
var $d128ae4039738a0a$var$IndeterminateProgressRTL = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function() {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        "100%": {
            right: "-30%"
        },
        "0%": {
            right: "100%"
        }
    });
});
var $d128ae4039738a0a$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c;
    var isRTL = (0, $723d0744d8fe4fde$export$b2303637e9533380)(props.theme);
    var className = props.className, indeterminate = props.indeterminate, theme = props.theme, _d = props.barHeight, barHeight = _d === void 0 ? 2 : _d;
    var palette = theme.palette, semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($d128ae4039738a0a$var$GlobalClassNames, theme);
    var marginBetweenText = 8;
    var textHeight = 18;
    var progressTrackColor = palette.neutralLight;
    return {
        root: [
            classNames.root,
            fonts.medium,
            className
        ],
        itemName: [
            classNames.itemName,
            (0, $3472c0f90c64fe40$export$2e0098041746c0f4),
            {
                color: semanticColors.bodyText,
                paddingTop: marginBetweenText / 2,
                lineHeight: textHeight + 2
            }
        ],
        itemDescription: [
            classNames.itemDescription,
            {
                color: semanticColors.bodySubtext,
                fontSize: fonts.small.fontSize,
                lineHeight: textHeight
            }
        ],
        itemProgress: [
            classNames.itemProgress,
            {
                position: "relative",
                overflow: "hidden",
                height: barHeight,
                padding: "".concat(marginBetweenText, "px 0")
            }
        ],
        progressTrack: [
            classNames.progressTrack,
            {
                position: "absolute",
                width: "100%",
                height: barHeight,
                backgroundColor: progressTrackColor,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderBottom: "1px solid WindowText"
                }, _a)
            }
        ],
        progressBar: [
            {
                backgroundColor: palette.themePrimary,
                height: barHeight,
                position: "absolute",
                transition: "width .3s ease",
                width: 0,
                selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    backgroundColor: "highlight"
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _b)
            },
            indeterminate ? {
                position: "absolute",
                minWidth: "33%",
                background: "linear-gradient(to right, ".concat(progressTrackColor, " 0%, ") + "".concat(palette.themePrimary, " 50%, ").concat(progressTrackColor, " 100%)"),
                animation: "".concat(isRTL ? $d128ae4039738a0a$var$IndeterminateProgressRTL() : $d128ae4039738a0a$var$IndeterminateProgress(), " 3s infinite"),
                selectors: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    background: "highlight"
                }, _c)
            } : {
                transition: "width .15s linear"
            },
            classNames.progressBar
        ]
    };
};


var $f6af8ac8c0971da3$export$2b776f7e7ee60dbd = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $68fcab632ef25cc9$export$a7e7bdd851b78592), (0, $d128ae4039738a0a$export$ffd58b7f6f099a57), undefined, {
    scope: "ProgressIndicator"
});




var $acw62 = parcelRequire("acw62");




var $45fcc7b649ae7f24$var$COMPONENT_NAME = "SearchBox";
var $45fcc7b649ae7f24$var$iconButtonStyles = {
    root: {
        height: "auto"
    },
    icon: {
        fontSize: "12px"
    }
};
var $45fcc7b649ae7f24$var$iconButtonProps = {
    iconName: "Clear"
};
var $45fcc7b649ae7f24$var$defaultClearButtonProps = {
    ariaLabel: "Clear text"
};
var $45fcc7b649ae7f24$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $45fcc7b649ae7f24$var$useComponentRef = function(componentRef, inputElementRef, hasFocus) {
    $acw62.useImperativeHandle(componentRef, function() {
        return {
            focus: function() {
                var _a;
                return (_a = inputElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: function() {
                var _a;
                return (_a = inputElementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
            hasFocus: function() {
                return hasFocus;
            }
        };
    }, [
        inputElementRef,
        hasFocus
    ]);
};
var $45fcc7b649ae7f24$export$60abe1afdf453b23 = $acw62.forwardRef(function(props, forwardedRef) {
    var ariaLabel = props.ariaLabel, className = props.className, _a = props.defaultValue, defaultValue = _a === void 0 ? "" : _a, disabled = props.disabled, underlined = props.underlined, styles = props.styles, // eslint-disable-next-line deprecation/deprecation
    labelText = props.labelText, // eslint-disable-next-line deprecation/deprecation
    _b = props.placeholder, // eslint-disable-next-line deprecation/deprecation
    placeholder = _b === void 0 ? labelText : _b, theme = props.theme, _c = props.clearButtonProps, clearButtonProps = _c === void 0 ? $45fcc7b649ae7f24$var$defaultClearButtonProps : _c, _d = props.disableAnimation, disableAnimation = _d === void 0 ? false : _d, _e = props.showIcon, showIcon = _e === void 0 ? false : _e, customOnClear = props.onClear, customOnBlur = props.onBlur, customOnEscape = props.onEscape, customOnSearch = props.onSearch, customOnKeyDown = props.onKeyDown, iconProps = props.iconProps, role = props.role, onChange = props.onChange, // eslint-disable-next-line deprecation/deprecation
    onChanged = props.onChanged;
    var _f = $acw62.useState(false), hasFocus = _f[0], setHasFocus = _f[1];
    var prevChangeTimestamp = $acw62.useRef();
    var _g = (0, $55cf7aa9f769b3e9$export$2400c890ca0180b4)(props.value, defaultValue, function(ev, newValue) {
        if (ev && ev.timeStamp === prevChangeTimestamp.current) // For historical reasons, SearchBox handles both onInput and onChange (we can't modify this
        // outside a major version due to potential to break partners' tests and possibly apps).
        // Only call props.onChange for one of the events.
        return;
        prevChangeTimestamp.current = ev === null || ev === void 0 ? void 0 : ev.timeStamp;
        onChange === null || onChange === void 0 || onChange(ev, newValue);
        onChanged === null || onChanged === void 0 || onChanged(newValue);
    }), uncastValue = _g[0], setValue = _g[1];
    var value = String(uncastValue);
    var rootElementRef = $acw62.useRef(null);
    var inputElementRef = $acw62.useRef(null);
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootElementRef, forwardedRef);
    var id = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)($45fcc7b649ae7f24$var$COMPONENT_NAME, props.id);
    var customOnClearClick = clearButtonProps.onClick;
    var classNames = $45fcc7b649ae7f24$var$getClassNames(styles, {
        theme: theme,
        className: className,
        underlined: underlined,
        hasFocus: hasFocus,
        disabled: disabled,
        hasInput: value.length > 0,
        disableAnimation: disableAnimation,
        showIcon: showIcon
    });
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$33c6815a27d08ce5), [
        "className",
        "placeholder",
        "onFocus",
        "onBlur",
        "value",
        "role"
    ]);
    var onClear = $acw62.useCallback(function(ev) {
        var _a;
        customOnClear === null || customOnClear === void 0 || customOnClear(ev);
        if (!ev.defaultPrevented) {
            setValue("");
            (_a = inputElementRef.current) === null || _a === void 0 || _a.focus();
            ev.stopPropagation();
            ev.preventDefault();
        }
    }, [
        customOnClear,
        setValue
    ]);
    var onClearClick = $acw62.useCallback(function(ev) {
        customOnClearClick === null || customOnClearClick === void 0 || customOnClearClick(ev);
        if (!ev.defaultPrevented) onClear(ev);
    }, [
        customOnClearClick,
        onClear
    ]);
    var onFocusCapture = function(ev) {
        var _a;
        setHasFocus(true);
        (_a = props.onFocus) === null || _a === void 0 || _a.call(props, ev);
    };
    var onClickFocus = function() {
        if (inputElementRef.current) {
            inputElementRef.current.focus();
            inputElementRef.current.selectionStart = inputElementRef.current.selectionEnd = 0;
        }
    };
    var onBlur = $acw62.useCallback(function(ev) {
        setHasFocus(false);
        customOnBlur === null || customOnBlur === void 0 || customOnBlur(ev);
    }, [
        customOnBlur
    ]);
    var onInputChange = function(ev) {
        setValue(ev.target.value, ev);
    };
    var onKeyDown = function(ev) {
        // eslint-disable-next-line deprecation/deprecation
        switch(ev.which){
            case (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape:
                customOnEscape === null || customOnEscape === void 0 || customOnEscape(ev);
                // Only call onClear if the search box has a value to clear. Otherwise, allow the Esc key
                // to propagate from the empty search box to a parent element such as a dialog, etc.
                if (value && !ev.defaultPrevented) onClear(ev);
                break;
            case (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter:
                if (customOnSearch) {
                    customOnSearch(value);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                break;
            default:
                // REVIEW: Why aren't we calling customOnKeyDown for Escape or Enter?
                customOnKeyDown === null || customOnKeyDown === void 0 || customOnKeyDown(ev);
                // REVIEW: Why are we calling stopPropagation if customOnKeyDown called preventDefault?
                // customOnKeyDown should call stopPropagation if it needs it.
                if (ev.defaultPrevented) ev.stopPropagation();
                break;
        }
    };
    $45fcc7b649ae7f24$var$useDebugWarning(props);
    $45fcc7b649ae7f24$var$useComponentRef(props.componentRef, inputElementRef, hasFocus);
    return $acw62.createElement("div", {
        role: role,
        ref: mergedRootRef,
        className: classNames.root,
        onFocusCapture: onFocusCapture
    }, $acw62.createElement("div", {
        className: classNames.iconContainer,
        onClick: onClickFocus,
        "aria-hidden": true
    }, $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        iconName: "Search"
    }, iconProps, {
        className: classNames.icon
    }))), $acw62.createElement("input", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps, {
        id: id,
        className: classNames.field,
        placeholder: placeholder,
        onChange: onInputChange,
        onInput: onInputChange,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        value: value,
        disabled: disabled,
        role: "searchbox",
        "aria-label": ariaLabel,
        ref: inputElementRef
    })), value.length > 0 && $acw62.createElement("div", {
        className: classNames.clearButton
    }, $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        onBlur: onBlur,
        styles: $45fcc7b649ae7f24$var$iconButtonStyles,
        iconProps: $45fcc7b649ae7f24$var$iconButtonProps
    }, clearButtonProps, {
        onClick: onClearClick
    }))));
});
$45fcc7b649ae7f24$export$60abe1afdf453b23.displayName = $45fcc7b649ae7f24$var$COMPONENT_NAME;
function $45fcc7b649ae7f24$var$useDebugWarning(props) {}




var $78be9c4b0a3e6f8c$var$GlobalClassNames = {
    root: "ms-SearchBox",
    iconContainer: "ms-SearchBox-iconContainer",
    icon: "ms-SearchBox-icon",
    clearButton: "ms-SearchBox-clearButton",
    field: "ms-SearchBox-field"
};
function $78be9c4b0a3e6f8c$export$ffd58b7f6f099a57(props) {
    var _a, _b, _c, _d, _e;
    var theme = props.theme, underlined = props.underlined, disabled = props.disabled, hasFocus = props.hasFocus, className = props.className, hasInput = props.hasInput, disableAnimation = props.disableAnimation, showIcon = props.showIcon;
    var palette = theme.palette, fonts = theme.fonts, semanticColors = theme.semanticColors, effects = theme.effects;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($78be9c4b0a3e6f8c$var$GlobalClassNames, theme);
    // placeholder style constants
    var placeholderStyles = {
        color: semanticColors.inputPlaceholderText,
        opacity: 1
    };
    var inputIconAlt = palette.neutralSecondary;
    var inputIconAltHovered = palette.neutralPrimary;
    var inputBorderDisabled = palette.neutralLighter;
    var inputBackgroundHovered = palette.neutralLighter;
    var inputBackgroundDisabled = palette.neutralLighter;
    return {
        root: [
            classNames.root,
            fonts.medium,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            {
                color: semanticColors.inputText,
                backgroundColor: semanticColors.inputBackground,
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                alignItems: "stretch",
                // The 1px top and bottom padding ensure the input field does not overlap the border
                padding: "1px 0 1px 4px",
                borderRadius: effects.roundedCorner2,
                border: "1px solid ".concat(semanticColors.inputBorder),
                height: 32,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderColor: "WindowText"
                }, _a[":hover"] = {
                    borderColor: semanticColors.inputBorderHovered,
                    selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        borderColor: "Highlight"
                    }, _b)
                }, _a[":hover .".concat(classNames.iconContainer)] = {
                    color: semanticColors.inputIconHovered
                }, _a)
            },
            !hasFocus && hasInput && {
                selectors: (_c = {}, _c[":hover .".concat(classNames.iconContainer)] = {
                    width: 4
                }, _c[":hover .".concat(classNames.icon)] = {
                    opacity: 0,
                    pointerEvents: "none"
                }, _c)
            },
            hasFocus && [
                "is-active",
                {
                    position: "relative"
                },
                (0, $3c8eab4e1d179dea$export$47ad9ea05ccc047b)(semanticColors.inputFocusBorderAlt, underlined ? 0 : effects.roundedCorner2, underlined ? "borderBottom" : "border")
            ],
            showIcon && [
                {
                    selectors: (_d = {}, _d[":hover .".concat(classNames.iconContainer)] = {
                        width: 32
                    }, _d[":hover .".concat(classNames.icon)] = {
                        opacity: 1
                    }, _d)
                }
            ],
            disabled && [
                "is-disabled",
                {
                    borderColor: inputBorderDisabled,
                    backgroundColor: inputBackgroundDisabled,
                    pointerEvents: "none",
                    cursor: "default",
                    selectors: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                        borderColor: "GrayText"
                    }, _e)
                }
            ],
            underlined && [
                "is-underlined",
                {
                    borderWidth: "0 0 1px 0",
                    borderRadius: 0,
                    // Underlined SearchBox has a larger padding left to vertically align with the waffle in product
                    padding: "1px 0 1px 8px"
                }
            ],
            underlined && disabled && {
                backgroundColor: "transparent"
            },
            hasInput && "can-clear",
            className
        ],
        iconContainer: [
            classNames.iconContainer,
            {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flexShrink: 0,
                fontSize: 16,
                width: 32,
                textAlign: "center",
                color: semanticColors.inputIcon,
                cursor: "text"
            },
            hasFocus && {
                width: 4
            },
            disabled && {
                color: semanticColors.inputIconDisabled
            },
            !disableAnimation && {
                transition: "width ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue1)
            },
            showIcon && hasFocus && {
                width: 32
            }
        ],
        icon: [
            classNames.icon,
            {
                opacity: 1
            },
            hasFocus && {
                opacity: 0,
                pointerEvents: "none"
            },
            !disableAnimation && {
                transition: "opacity ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue1, " 0s")
            },
            showIcon && hasFocus && {
                opacity: 1
            }
        ],
        clearButton: [
            classNames.clearButton,
            {
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                cursor: "pointer",
                flexBasis: "32px",
                flexShrink: 0,
                padding: 0,
                margin: "-1px 0px",
                selectors: {
                    "&:hover .ms-Button": {
                        backgroundColor: inputBackgroundHovered
                    },
                    "&:hover .ms-Button-icon": {
                        color: inputIconAltHovered
                    },
                    ".ms-Button": {
                        borderRadius: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? "1px 0 0 1px" : "0 1px 1px 0"
                    },
                    ".ms-Button-icon": {
                        color: inputIconAlt
                    }
                }
            }
        ],
        field: [
            classNames.field,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            (0, $0f1b07507d939466$export$be3d79419dd9c4a2)(placeholderStyles),
            {
                backgroundColor: "transparent",
                border: "none",
                outline: "none",
                fontWeight: "inherit",
                fontFamily: "inherit",
                fontSize: "inherit",
                color: semanticColors.inputText,
                flex: "1 1 0px",
                // The default implicit value of 'auto' prevents the input from shrinking. Setting min-width to
                // 0px allows the input element to shrink to fit the container.
                minWidth: "0px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                // This padding forces the text placement to round up.
                paddingBottom: 0.5,
                // This removes the IE specific clear button in the input since we implemented our own
                selectors: {
                    "::-ms-clear": {
                        display: "none"
                    }
                }
            },
            disabled && {
                color: semanticColors.disabledText
            }
        ]
    };
}


var $b5036eb0990bf9bc$export$5a58787633b0b5d8 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $45fcc7b649ae7f24$export$60abe1afdf453b23), (0, $78be9c4b0a3e6f8c$export$ffd58b7f6f099a57), undefined, {
    scope: "SearchBox"
});



var $acw62 = parcelRequire("acw62");
var $23490a8dec97b8ae$exports = {};

$parcel$export($23490a8dec97b8ae$exports, "JobSeekerDetails", () => $23490a8dec97b8ae$export$67322c398cb3229d);




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $179fcbdee77aba61$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $179fcbdee77aba61$export$e1997a00f7a6d44c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OverlayBase, _super);
    function OverlayBase(props) {
        var _this = _super.call(this, props) || this;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        var _a = _this.props.allowTouchBodyScroll, allowTouchBodyScroll = _a === void 0 ? false : _a;
        _this._allowTouchBodyScroll = allowTouchBodyScroll;
        return _this;
    }
    OverlayBase.prototype.componentDidMount = function() {
        !this._allowTouchBodyScroll && (0, $11f97b2a9a127629$export$24fdf68abf432c44)();
    };
    OverlayBase.prototype.componentWillUnmount = function() {
        !this._allowTouchBodyScroll && (0, $11f97b2a9a127629$export$e5d0524c3725571e)();
    };
    OverlayBase.prototype.render = function() {
        var _a = this.props, isDark = _a.isDarkThemed, className = _a.className, theme = _a.theme, styles = _a.styles;
        var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        var classNames = $179fcbdee77aba61$var$getClassNames(styles, {
            theme: theme,
            className: className,
            isDark: isDark
        });
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps, {
            className: classNames.root
        }));
    };
    return OverlayBase;
}($acw62.Component);



var $928f406b652d356e$var$GlobalClassNames = {
    root: "ms-Overlay",
    rootDark: "ms-Overlay--dark"
};
var $928f406b652d356e$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var className = props.className, theme = props.theme, isNone = props.isNone, isDark = props.isDark;
    var palette = theme.palette;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($928f406b652d356e$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                backgroundColor: palette.whiteTranslucent40,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                position: "absolute",
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: "1px solid WindowText",
                    opacity: 0
                }, _a)
            },
            isNone && {
                visibility: "hidden"
            },
            isDark && [
                classNames.rootDark,
                {
                    backgroundColor: palette.blackTranslucent40
                }
            ],
            className
        ]
    };
};


var $91037d22bd4739f3$export$c6fdb837b070b4ff = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $179fcbdee77aba61$export$e1997a00f7a6d44c), (0, $928f406b652d356e$export$ffd58b7f6f099a57), undefined, {
    scope: "Overlay"
});






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e(fn) {
    var callbackRef = $acw62.useRef(function() {
        throw new Error("Cannot call an event handler while rendering");
    });
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        callbackRef.current = fn;
    }, [
        fn
    ]);
    // useConst rather than useCallback to ensure the reference is always stable
    // (useCallback's deps list is an optimization, not a guarantee)
    return (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var callback = callbackRef.current;
            return callback.apply(void 0, args);
        };
    });
}


var $acw62 = parcelRequire("acw62");
var $6de8a0d93973ac84$export$89e33b3d84d8c331 = function(callback) {
    var unmountRef = $acw62.useRef(callback);
    unmountRef.current = callback;
    $acw62.useEffect(function() {
        return function() {
            var _a;
            (_a = unmountRef.current) === null || _a === void 0 || _a.call(unmountRef);
        };
    }, []);
};



var $a59e3b1923635c76$var$COMPONENT_NAME = "FocusTrapZone";
var $a59e3b1923635c76$var$DEFAULT_PROPS = {
    disabled: false,
    disableFirstFocus: false,
    forceFocusInsideTrap: true,
    isClickableOutsideFocusTrap: false
};
var $a59e3b1923635c76$var$useComponentRef = function(componentRef, previouslyFocusedElement, focusFTZ) {
    $acw62.useImperativeHandle(componentRef, function() {
        return {
            get previouslyFocusedElement () {
                return previouslyFocusedElement;
            },
            focus: focusFTZ
        };
    }, [
        focusFTZ,
        previouslyFocusedElement
    ]);
};
var $a59e3b1923635c76$export$d51d2fd1b83a7384 = $acw62.forwardRef(function(propsWithoutDefaults, ref) {
    var _a;
    var root = $acw62.useRef(null);
    var firstBumper = $acw62.useRef(null);
    var lastBumper = $acw62.useRef(null);
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(root, ref);
    var doc = (0, $b139ba3b4431b53f$export$e71e2fb5c5c476d5)();
    var isFirstRender = (_a = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(false)) !== null && _a !== void 0 ? _a : true;
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($a59e3b1923635c76$var$DEFAULT_PROPS, propsWithoutDefaults);
    var internalState = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)({
        hasFocus: false,
        focusStackId: (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)("ftz-", props.id)
    });
    var children = props.children, componentRef = props.componentRef, disabled = props.disabled, disableFirstFocus = props.disableFirstFocus, forceFocusInsideTrap = props.forceFocusInsideTrap, focusPreviouslyFocusedInnerElement = props.focusPreviouslyFocusedInnerElement, // eslint-disable-next-line deprecation/deprecation
    firstFocusableSelector = props.firstFocusableSelector, firstFocusableTarget = props.firstFocusableTarget, // eslint-disable-next-line deprecation/deprecation
    _b = props.disableRestoreFocus, // eslint-disable-next-line deprecation/deprecation
    disableRestoreFocus = _b === void 0 ? props.ignoreExternalFocusing : _b, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, enableAriaHiddenSiblings = props.enableAriaHiddenSiblings;
    var bumperProps = {
        "aria-hidden": true,
        style: {
            pointerEvents: "none",
            position: "fixed"
        },
        tabIndex: disabled ? -1 : 0,
        "data-is-visible": true,
        "data-is-focus-trap-zone-bumper": true
    };
    var focusElementAsync = $acw62.useCallback(function(element) {
        if (element !== firstBumper.current && element !== lastBumper.current) (0, $94bdc1ebed789608$export$b5a401136c35d08a)(element);
    }, []);
    /**
     * Callback to force focus into FTZ (named to avoid overlap with global focus() callback).
     * useEventCallback always returns the same callback reference but updates the implementation
     * every render to avoid stale captured values.
     */ var focusFTZ = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function() {
        if (!root.current) return; // not done mounting
        var previouslyFocusedElementInTrapZone = internalState.previouslyFocusedElementInTrapZone;
        if (focusPreviouslyFocusedInnerElement && previouslyFocusedElementInTrapZone && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, previouslyFocusedElementInTrapZone)) {
            // focus on the last item that had focus in the zone before we left the zone
            focusElementAsync(previouslyFocusedElementInTrapZone);
            return;
        }
        var firstFocusableChild = null;
        if (typeof firstFocusableTarget === "string") firstFocusableChild = root.current.querySelector(firstFocusableTarget);
        else if (firstFocusableTarget) firstFocusableChild = firstFocusableTarget(root.current);
        else if (firstFocusableSelector) {
            var focusSelector = typeof firstFocusableSelector === "string" ? firstFocusableSelector : firstFocusableSelector();
            firstFocusableChild = root.current.querySelector("." + focusSelector);
        }
        // Fall back to first element if query selector did not match any elements.
        if (!firstFocusableChild) firstFocusableChild = (0, $94bdc1ebed789608$export$4109ed81edd7716d)(root.current, root.current.firstChild, false, false, false, true);
        if (firstFocusableChild) focusElementAsync(firstFocusableChild);
    });
    /** Used in root div focus/blur handlers */ var focusBumper = function(isFirstBumper) {
        if (disabled || !root.current) return;
        var nextFocusable = isFirstBumper === internalState.hasFocus ? (0, $94bdc1ebed789608$export$73cc6e682b257cff)(root.current, lastBumper.current, true, false) : (0, $94bdc1ebed789608$export$9beaf9bf6ff178ae)(root.current, firstBumper.current, true, false);
        if (nextFocusable) {
            if (nextFocusable === firstBumper.current || nextFocusable === lastBumper.current) // This can happen when FTZ contains no tabbable elements.
            // focusFTZ() will take care of finding a focusable element in FTZ.
            focusFTZ();
            else nextFocusable.focus();
        }
    };
    /** Root div blur handler (doesn't need useCallback since it's for a native element) */ var onRootBlurCapture = function(ev) {
        var _a;
        (_a = props.onBlurCapture) === null || _a === void 0 || _a.call(props, ev);
        var relatedTarget = ev.relatedTarget;
        if (ev.relatedTarget === null) // In IE11, due to lack of support, event.relatedTarget is always
        // null making every onBlur call to be "outside" of the root
        // even when it's not. Using document.activeElement is another way
        // for us to be able to get what the relatedTarget without relying
        // on the event
        relatedTarget = doc.activeElement;
        if (!(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, relatedTarget)) internalState.hasFocus = false;
    };
    /** Root div focus handler (doesn't need useCallback since it's for a native element) */ var onRootFocusCapture = function(ev) {
        var _a;
        (_a = props.onFocusCapture) === null || _a === void 0 || _a.call(props, ev);
        if (ev.target === firstBumper.current) focusBumper(true);
        else if (ev.target === lastBumper.current) focusBumper(false);
        internalState.hasFocus = true;
        if (ev.target !== ev.currentTarget && !(ev.target === firstBumper.current || ev.target === lastBumper.current)) // every time focus changes within the trap zone, remember the focused element so that
        // it can be restored if focus leaves the pane and returns via keystroke (i.e. via a call to this.focus(true))
        internalState.previouslyFocusedElementInTrapZone = ev.target;
    };
    /** Called to restore focus on unmount or props change. (useEventCallback ensures latest prop values are used.) */ var returnFocusToInitiator = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function(elementToFocusOnDismiss) {
        $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack = $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.filter(function(value) {
            return internalState.focusStackId !== value;
        });
        if (!doc) return;
        var activeElement = doc.activeElement;
        if (!disableRestoreFocus && typeof (elementToFocusOnDismiss === null || elementToFocusOnDismiss === void 0 ? void 0 : elementToFocusOnDismiss.focus) === "function" && // only restore focus if the current focused element is within the FTZ, or if nothing is focused
        ((0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, activeElement) || activeElement === doc.body)) focusElementAsync(elementToFocusOnDismiss);
    });
    /** Called in window event handlers. (useEventCallback ensures latest prop values are used.) */ var forceFocusOrClickInTrap = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function(ev) {
        // be sure to use the latest values here
        if (disabled) return;
        if (internalState.focusStackId === $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.slice(-1)[0]) {
            var targetElement = ev.target;
            if (targetElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, targetElement)) {
                if (doc && doc.activeElement === doc.body) setTimeout(function() {
                    if (doc && doc.activeElement === doc.body) {
                        focusFTZ();
                        internalState.hasFocus = true; // set focus here since we stop event propagation
                    }
                }, 0);
                else {
                    focusFTZ();
                    internalState.hasFocus = true; // set focus here since we stop event propagation
                }
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    });
    // Update window event handlers when relevant props change
    $acw62.useEffect(function() {
        var disposables = [];
        if (forceFocusInsideTrap) disposables.push((0, $18e32c5a70ef0416$export$af631764ddc44097)(window, "focus", forceFocusOrClickInTrap, true));
        if (!isClickableOutsideFocusTrap) disposables.push((0, $18e32c5a70ef0416$export$af631764ddc44097)(window, "click", forceFocusOrClickInTrap, true));
        return function() {
            disposables.forEach(function(dispose) {
                return dispose();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when these two props change
    }, [
        forceFocusInsideTrap,
        isClickableOutsideFocusTrap
    ]);
    // On prop change or first render, focus the FTZ and update focusStack if appropriate
    $acw62.useEffect(function() {
        // Do nothing if disabled, or if it's a re-render and forceFocusInsideTrap is false
        // (to match existing behavior, the FTZ handles first focus even if forceFocusInsideTrap
        // is false, though it's debatable whether it should do this)
        if (disabled || !isFirstRender && !forceFocusInsideTrap || !root.current) return;
        // Transition from forceFocusInsideTrap / FTZ disabled to enabled (or initial mount)
        $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.push(internalState.focusStackId);
        var elementToFocusOnDismiss = props.elementToFocusOnDismiss || doc.activeElement;
        if (!disableFirstFocus && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, elementToFocusOnDismiss)) focusFTZ();
        // To match existing behavior, always return focus on cleanup (even if we didn't handle
        // initial focus), but it's debatable whether that's correct
        return function() {
            return returnFocusToInitiator(elementToFocusOnDismiss);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when these two props change
    }, [
        forceFocusInsideTrap,
        disabled
    ]);
    // Handle modalization separately from first focus
    $acw62.useEffect(function() {
        if (!disabled && enableAriaHiddenSiblings) {
            var unmodalize = (0, $4077fee6e96f12f4$export$6c6b3b5a8658bfc1)(root.current);
            return unmodalize;
        }
    }, [
        disabled,
        enableAriaHiddenSiblings,
        root
    ]);
    // Cleanup lifecyle method for internalState.
    (0, $6de8a0d93973ac84$export$89e33b3d84d8c331)(function() {
        // Dispose of element references so the DOM Nodes can be garbage-collected
        delete internalState.previouslyFocusedElementInTrapZone;
    });
    $a59e3b1923635c76$var$useComponentRef(componentRef, internalState.previouslyFocusedElementInTrapZone, focusFTZ);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        "aria-labelledby": props.ariaLabelledBy
    }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
        ref: mergedRootRef,
        onFocusCapture: onRootFocusCapture,
        onBlurCapture: onRootBlurCapture
    }), $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, bumperProps, {
        ref: firstBumper
    })), children, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, bumperProps, {
        ref: lastBumper
    })));
});
$a59e3b1923635c76$export$d51d2fd1b83a7384.displayName = $a59e3b1923635c76$var$COMPONENT_NAME;
$a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack = [];


/**
 * {@docCategory Panel}
 */ var $ab829e5818bb6888$export$969277cf61e5a7aa;
(function(PanelType) {
    /**
     * Renders the Panel with a `fluid` (full screen) width.
     * Recommended for use on small screen breakpoints.
     * - Small (320-479): full screen width, 16px left/right padding
     * - Medium (480-639): full screen width, 16px left/right padding
     * - Large (640-1023): full screen width, 32px left/right padding
     * - XLarge (1024-1365): full screen width, 32px left/right padding
     * - XXLarge (1366-up): full screen width, 40px left/right padding
     */ PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): 340px width, 16px left/right padding
     * - Large (640-1023): 340px width, 32px left/right padding
     * - XLarge (1024-1365): 340px width, 32px left/right padding
     * - XXLarge (1366-up): 340px width, 40px left/right padding
     */ PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the near side (left in LTR mode).
     * - Small (320-479): 272px width, 16px left/right padding
     * - Medium (480-639): 272px width, 16px left/right padding
     * - Large (640-1023): 272px width, 32px left/right padding
     * - XLarge (1024-1365): 272px width, 32px left/right padding
     * - XXLarge (1366-up): 272px width, 40px left/right padding
     */ PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
    /**
     * Renders the Panel in `medium` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): 592px width, 32px left/right padding
     * - XLarge (1024-1365): 644px width, 32px left/right padding
     * - XXLarge (1366-up): 644px width, 40px left/right padding
     */ PanelType[PanelType["medium"] = 3] = "medium";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639):  adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 428px fixed left margin, fluid width, 40px left/right padding
     */ PanelType[PanelType["large"] = 4] = "large";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode), with a fixed width at
     * XX-Large breakpoint.
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 940px width, 40px left/right padding
     */ PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
    /**
     * Renders the Panel in `extra large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): adapts to `PanelType.large` at this breakpoint
     * - XXLarge (1366-1919): 176px fixed left margin, fluid width, 40px left/right padding
     * - XXXLarge (1920-up): 176px fixed left margin, fluid width, 40px left/right padding
     */ PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the far side (right in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */ PanelType[PanelType["custom"] = 7] = "custom";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the near side (left in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */ PanelType[PanelType["customNear"] = 8] = "customNear";
})($ab829e5818bb6888$export$969277cf61e5a7aa || ($ab829e5818bb6888$export$969277cf61e5a7aa = {}));


var $bca47d16325c1107$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $bca47d16325c1107$var$COMPONENT_NAME = "Panel";
var $bca47d16325c1107$var$PanelVisibilityState;
(function(PanelVisibilityState) {
    PanelVisibilityState[PanelVisibilityState["closed"] = 0] = "closed";
    PanelVisibilityState[PanelVisibilityState["animatingOpen"] = 1] = "animatingOpen";
    PanelVisibilityState[PanelVisibilityState["open"] = 2] = "open";
    PanelVisibilityState[PanelVisibilityState["animatingClosed"] = 3] = "animatingClosed";
})($bca47d16325c1107$var$PanelVisibilityState || ($bca47d16325c1107$var$PanelVisibilityState = {}));
var $bca47d16325c1107$export$40183b776bb94340 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PanelBase, _super);
    function PanelBase(props) {
        var _this = _super.call(this, props) || this;
        _this._panel = $acw62.createRef();
        _this._animationCallback = null;
        _this._hasCustomNavigation = !!(_this.props.onRenderNavigation || _this.props.onRenderNavigationContent);
        _this.dismiss = function(ev) {
            if (_this.props.onDismiss && _this.isActive) _this.props.onDismiss(ev);
            if (!ev || ev && !ev.defaultPrevented) _this.close();
        };
        // Allow the user to scroll within the panel but not on the body
        _this._allowScrollOnPanel = function(elt) {
            if (elt) {
                if (_this._allowTouchBodyScroll) (0, $11f97b2a9a127629$export$d4daebbd8ba7010c)(elt, _this._events);
                else (0, $11f97b2a9a127629$export$f02f9101103a4939)(elt, _this._events);
            } else _this._events.off(_this._scrollableContent);
            _this._scrollableContent = elt;
        };
        _this._onRenderNavigation = function(props) {
            if (!_this.props.onRenderNavigationContent && !_this.props.onRenderNavigation && !_this.props.hasCloseButton) return null;
            var _a = _this.props.onRenderNavigationContent, onRenderNavigationContent = _a === void 0 ? _this._onRenderNavigationContent : _a;
            return $acw62.createElement("div", {
                className: _this._classNames.navigation
            }, onRenderNavigationContent(props, _this._onRenderNavigationContent));
        };
        _this._onRenderNavigationContent = function(props) {
            var _a;
            var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton, _b = props.onRenderHeader, onRenderHeader = _b === void 0 ? _this._onRenderHeader : _b;
            if (hasCloseButton) {
                var iconButtonStyles = (_a = _this._classNames.subComponentStyles) === null || _a === void 0 ? void 0 : _a.closeButton();
                return $acw62.createElement($acw62.Fragment, null, !_this._hasCustomNavigation && onRenderHeader(_this.props, _this._onRenderHeader, _this._headerTextId), $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), {
                    styles: iconButtonStyles,
                    className: _this._classNames.closeButton,
                    onClick: _this._onPanelClick,
                    ariaLabel: closeButtonAriaLabel,
                    title: closeButtonAriaLabel,
                    "data-is-visible": true,
                    iconProps: {
                        iconName: "Cancel"
                    }
                }));
            }
            return null;
        };
        _this._onRenderHeader = function(props, defaultRender, headerTextId) {
            var headerText = props.headerText, _a = props.headerTextProps, headerTextProps = _a === void 0 ? {} : _a;
            if (headerText) return $acw62.createElement("div", {
                className: _this._classNames.header
            }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                id: headerTextId,
                role: "heading",
                "aria-level": 1
            }, headerTextProps, {
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.headerText, headerTextProps.className)
            }), headerText));
            return null;
        };
        _this._onRenderBody = function(props) {
            return $acw62.createElement("div", {
                className: _this._classNames.content
            }, props.children);
        };
        _this._onRenderFooter = function(props) {
            var _a = _this.props.onRenderFooterContent, onRenderFooterContent = _a === void 0 ? null : _a;
            if (onRenderFooterContent) return $acw62.createElement("div", {
                className: _this._classNames.footer
            }, $acw62.createElement("div", {
                className: _this._classNames.footerInner
            }, onRenderFooterContent()));
            return null;
        };
        _this._animateTo = function(newVisibilityState) {
            if (newVisibilityState === $bca47d16325c1107$var$PanelVisibilityState.open && _this.props.onOpen) _this.props.onOpen();
            _this._animationCallback = _this._async.setTimeout(function() {
                _this.setState({
                    visibility: newVisibilityState
                });
                _this._onTransitionComplete(newVisibilityState);
            }, 200);
        };
        _this._clearExistingAnimationTimer = function() {
            if (_this._animationCallback !== null) _this._async.clearTimeout(_this._animationCallback);
        };
        _this._onPanelClick = function(ev) {
            _this.dismiss(ev);
        };
        _this._onTransitionComplete = function(newVisibilityState) {
            _this._updateFooterPosition();
            if (newVisibilityState === $bca47d16325c1107$var$PanelVisibilityState.open && _this.props.onOpened) _this.props.onOpened();
            if (newVisibilityState === $bca47d16325c1107$var$PanelVisibilityState.closed && _this.props.onDismissed) _this.props.onDismissed();
        };
        var _a = _this.props.allowTouchBodyScroll, allowTouchBodyScroll = _a === void 0 ? false : _a;
        _this._allowTouchBodyScroll = allowTouchBodyScroll;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)($bca47d16325c1107$var$COMPONENT_NAME, props, {
            ignoreExternalFocusing: "focusTrapZoneProps",
            forceFocusInsideTrap: "focusTrapZoneProps",
            firstFocusableSelector: "focusTrapZoneProps"
        });
        _this.state = {
            isFooterSticky: false,
            // intentionally ignore props so animation takes place during componentDidMount
            visibility: $bca47d16325c1107$var$PanelVisibilityState.closed,
            id: (0, $532a46d3b196c0f3$export$218c8c3169c024d2)("Panel")
        };
        return _this;
    }
    PanelBase.getDerivedStateFromProps = function(nextProps, prevState) {
        if (nextProps.isOpen === undefined) return null; // no state update
        if (nextProps.isOpen && (prevState.visibility === $bca47d16325c1107$var$PanelVisibilityState.closed || prevState.visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingClosed)) return {
            visibility: $bca47d16325c1107$var$PanelVisibilityState.animatingOpen
        };
        if (!nextProps.isOpen && (prevState.visibility === $bca47d16325c1107$var$PanelVisibilityState.open || prevState.visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingOpen)) return {
            visibility: $bca47d16325c1107$var$PanelVisibilityState.animatingClosed
        };
        return null;
    };
    PanelBase.prototype.componentDidMount = function() {
        this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(this);
        this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(this);
        this._events.on(window, "resize", this._updateFooterPosition);
        if (this._shouldListenForOuterClick(this.props)) this._events.on(document.body, "mousedown", this._dismissOnOuterClick, true);
        if (this.props.isOpen) this.setState({
            visibility: $bca47d16325c1107$var$PanelVisibilityState.animatingOpen
        });
    };
    PanelBase.prototype.componentDidUpdate = function(previousProps, previousState) {
        var shouldListenOnOuterClick = this._shouldListenForOuterClick(this.props);
        var previousShouldListenOnOuterClick = this._shouldListenForOuterClick(previousProps);
        if (this.state.visibility !== previousState.visibility) {
            this._clearExistingAnimationTimer();
            if (this.state.visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingOpen) this._animateTo($bca47d16325c1107$var$PanelVisibilityState.open);
            else if (this.state.visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingClosed) this._animateTo($bca47d16325c1107$var$PanelVisibilityState.closed);
        }
        if (shouldListenOnOuterClick && !previousShouldListenOnOuterClick) this._events.on(document.body, "mousedown", this._dismissOnOuterClick, true);
        else if (!shouldListenOnOuterClick && previousShouldListenOnOuterClick) this._events.off(document.body, "mousedown", this._dismissOnOuterClick, true);
    };
    PanelBase.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
    };
    PanelBase.prototype.render = function() {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? "" : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, /* eslint-disable deprecation/deprecation */ firstFocusableSelector = _a.firstFocusableSelector, focusTrapZoneProps = _a.focusTrapZoneProps, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, _c = _a.headerClassName, headerClassName = _c === void 0 ? "" : _c, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isFooterAtBottom = _a.isFooterAtBottom, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, overlayProps = _a.overlayProps, popupProps = _a.popupProps, type = _a.type, styles = _a.styles, theme = _a.theme, customWidth = _a.customWidth, _d = _a.onLightDismissClick, onLightDismissClick = _d === void 0 ? this._onPanelClick : _d, _e = _a.onRenderNavigation, onRenderNavigation = _e === void 0 ? this._onRenderNavigation : _e, _f = _a.onRenderHeader, onRenderHeader = _f === void 0 ? this._onRenderHeader : _f, _g = _a.onRenderBody, onRenderBody = _g === void 0 ? this._onRenderBody : _g, _h = _a.onRenderFooter, onRenderFooter = _h === void 0 ? this._onRenderFooter : _h;
        var _j = this.state, isFooterSticky = _j.isFooterSticky, visibility = _j.visibility, id = _j.id;
        var isLeft = type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFixedNear || type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).customNear ? true : false;
        var isRTL = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme);
        var isOnRightSide = isRTL ? isLeft : !isLeft;
        var customWidthStyles = type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).custom || type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).customNear ? {
            width: customWidth
        } : {};
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        var isOpen = this.isActive;
        var isAnimating = visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingClosed || visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingOpen;
        this._headerTextId = headerText && id + "-headerText";
        if (!isOpen && !isAnimating && !isHiddenOnDismiss) return null;
        this._classNames = $bca47d16325c1107$var$getClassNames(styles, {
            theme: theme,
            className: className,
            focusTrapZoneClassName: focusTrapZoneProps ? focusTrapZoneProps.className : undefined,
            hasCloseButton: hasCloseButton,
            headerClassName: headerClassName,
            isAnimating: isAnimating,
            isFooterSticky: isFooterSticky,
            isFooterAtBottom: isFooterAtBottom,
            isOnRightSide: isOnRightSide,
            isOpen: isOpen,
            isHiddenOnDismiss: isHiddenOnDismiss,
            type: type,
            hasCustomNavigation: this._hasCustomNavigation
        });
        var _k = this, _classNames = _k._classNames, _allowTouchBodyScroll = _k._allowTouchBodyScroll;
        var overlay;
        if (isBlocking && isOpen) overlay = $acw62.createElement((0, $91037d22bd4739f3$export$c6fdb837b070b4ff), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            className: _classNames.overlay,
            isDarkThemed: false,
            onClick: isLightDismiss ? onLightDismissClick : undefined,
            allowTouchBodyScroll: _allowTouchBodyScroll
        }, overlayProps));
        return $acw62.createElement((0, $0644c419e4ac4578$export$936d0764594b6eb3), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, layerProps), $acw62.createElement((0, $36276731e4f27f52$export$129a32eedafa97c5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            role: "dialog",
            "aria-modal": isBlocking ? "true" : undefined,
            ariaLabelledBy: this._headerTextId ? this._headerTextId : undefined,
            onDismiss: this.dismiss,
            className: _classNames.hiddenPanel,
            enableAriaHiddenSiblings: isOpen ? true : false
        }, popupProps), $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "aria-hidden": !isOpen && isAnimating
        }, nativeProps, {
            ref: this._panel,
            className: _classNames.root
        }), overlay, $acw62.createElement((0, $a59e3b1923635c76$export$d51d2fd1b83a7384), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            ignoreExternalFocusing: ignoreExternalFocusing,
            forceFocusInsideTrap: !isBlocking || isHiddenOnDismiss && !isOpen ? false : forceFocusInsideTrap,
            firstFocusableSelector: firstFocusableSelector,
            isClickableOutsideFocusTrap: true
        }, focusTrapZoneProps, {
            className: _classNames.main,
            style: customWidthStyles,
            elementToFocusOnDismiss: elementToFocusOnDismiss
        }), $acw62.createElement("div", {
            className: _classNames.contentInner
        }, $acw62.createElement("div", {
            ref: this._allowScrollOnPanel,
            className: _classNames.scrollableContent,
            "data-is-scrollable": true
        }, $acw62.createElement("div", {
            className: _classNames.commands,
            "data-is-visible": true
        }, onRenderNavigation(this.props, this._onRenderNavigation)), (this._hasCustomNavigation || !hasCloseButton) && onRenderHeader(this.props, this._onRenderHeader, this._headerTextId), onRenderBody(this.props, this._onRenderBody), onRenderFooter(this.props, this._onRenderFooter)))))));
    };
    PanelBase.prototype.open = function() {
        if (this.props.isOpen !== undefined) return;
        if (this.isActive) return;
        this.setState({
            visibility: $bca47d16325c1107$var$PanelVisibilityState.animatingOpen
        });
    };
    PanelBase.prototype.close = function() {
        if (this.props.isOpen !== undefined) return;
        if (!this.isActive) return;
        this.setState({
            visibility: $bca47d16325c1107$var$PanelVisibilityState.animatingClosed
        });
    };
    Object.defineProperty(PanelBase.prototype, "isActive", {
        /** isActive is true when panel is open or opening. */ get: function() {
            return this.state.visibility === $bca47d16325c1107$var$PanelVisibilityState.open || this.state.visibility === $bca47d16325c1107$var$PanelVisibilityState.animatingOpen;
        },
        enumerable: false,
        configurable: true
    });
    PanelBase.prototype._shouldListenForOuterClick = function(props) {
        return !!props.isBlocking && !!props.isOpen;
    };
    PanelBase.prototype._updateFooterPosition = function() {
        var scrollableContent = this._scrollableContent;
        if (scrollableContent) {
            var height = scrollableContent.clientHeight;
            var innerHeight_1 = scrollableContent.scrollHeight;
            this.setState({
                isFooterSticky: height < innerHeight_1 ? true : false
            });
        }
    };
    PanelBase.prototype._dismissOnOuterClick = function(ev) {
        var panel = this._panel.current;
        if (this.isActive && panel && !ev.defaultPrevented) {
            if (!(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(panel, ev.target)) {
                if (this.props.onOuterClick) this.props.onOuterClick(ev);
                else this.dismiss(ev);
            }
        }
    };
    PanelBase.defaultProps = {
        isHiddenOnDismiss: false,
        isOpen: undefined,
        isBlocking: true,
        hasCloseButton: true,
        type: (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFixedFar
    };
    return PanelBase;
}($acw62.Component);





var $18b5e429067b6c44$var$_a, $18b5e429067b6c44$var$_b, $18b5e429067b6c44$var$_c, $18b5e429067b6c44$var$_d, $18b5e429067b6c44$var$_e;
var $18b5e429067b6c44$var$GlobalClassNames = {
    root: "ms-Panel",
    main: "ms-Panel-main",
    commands: "ms-Panel-commands",
    contentInner: "ms-Panel-contentInner",
    scrollableContent: "ms-Panel-scrollableContent",
    navigation: "ms-Panel-navigation",
    closeButton: "ms-Panel-closeButton ms-PanelAction-close",
    header: "ms-Panel-header",
    headerText: "ms-Panel-headerText",
    content: "ms-Panel-content",
    footer: "ms-Panel-footer",
    footerInner: "ms-Panel-footerInner",
    isOpen: "is-open",
    hasCloseButton: "ms-Panel--hasCloseButton",
    smallFluid: "ms-Panel--smFluid",
    smallFixedNear: "ms-Panel--smLeft",
    smallFixedFar: "ms-Panel--sm",
    medium: "ms-Panel--md",
    large: "ms-Panel--lg",
    largeFixed: "ms-Panel--fixed",
    extraLarge: "ms-Panel--xl",
    custom: "ms-Panel--custom",
    customNear: "ms-Panel--customLeft"
};
var $18b5e429067b6c44$var$panelWidth = {
    full: "100%",
    auto: "auto",
    xs: 272,
    sm: 340,
    md1: 592,
    md2: 644,
    lg: 940
};
var $18b5e429067b6c44$var$panelMargin = {
    auto: "auto",
    none: 0,
    md: 48,
    lg: 428,
    xl: 176
};
// Following consts are used below in `getPanelBreakpoints()` function to provide
// necessary fallbacks for different types of Panel in different breakpoints.
var $18b5e429067b6c44$var$smallPanelSelectors = ($18b5e429067b6c44$var$_a = {}, $18b5e429067b6c44$var$_a["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$2a2cf3a4e575f28), "px)")] = {
    width: $18b5e429067b6c44$var$panelWidth.sm
}, $18b5e429067b6c44$var$_a);
var $18b5e429067b6c44$var$mediumPanelSelectors = ($18b5e429067b6c44$var$_b = {}, $18b5e429067b6c44$var$_b["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$3b8f430e18451172), "px)")] = {
    width: $18b5e429067b6c44$var$panelWidth.md1
}, $18b5e429067b6c44$var$_b["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$8063c2544c1fd1ee), "px)")] = {
    width: $18b5e429067b6c44$var$panelWidth.md2
}, $18b5e429067b6c44$var$_b);
var $18b5e429067b6c44$var$largePanelSelectors = ($18b5e429067b6c44$var$_c = {}, $18b5e429067b6c44$var$_c["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$db6df1a0c5d780ca), "px)")] = {
    left: $18b5e429067b6c44$var$panelMargin.md,
    width: $18b5e429067b6c44$var$panelWidth.auto
}, $18b5e429067b6c44$var$_c["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$21a5264b301ff8d4), "px)")] = {
    left: $18b5e429067b6c44$var$panelMargin.lg
}, $18b5e429067b6c44$var$_c);
var $18b5e429067b6c44$var$largeFixedPanelSelectors = ($18b5e429067b6c44$var$_d = {}, $18b5e429067b6c44$var$_d["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$21a5264b301ff8d4), "px)")] = {
    left: $18b5e429067b6c44$var$panelMargin.auto,
    width: $18b5e429067b6c44$var$panelWidth.lg
}, $18b5e429067b6c44$var$_d);
var $18b5e429067b6c44$var$extraLargePanelSelectors = ($18b5e429067b6c44$var$_e = {}, $18b5e429067b6c44$var$_e["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$21a5264b301ff8d4), "px)")] = {
    left: $18b5e429067b6c44$var$panelMargin.xl
}, $18b5e429067b6c44$var$_e);
// Make sure Panels have fallbacks to different breakpoints by reusing same selectors.
// This is done in the effort to follow design redlines.
var $18b5e429067b6c44$var$getPanelBreakpoints = function(type) {
    var selectors;
    // Panel types `smallFluid`, `smallFixedNear`, `custom` and `customNear`
    // are not checked in here because they render the same in all the breakpoints
    // and have the checks done separately in the `getStyles` function below.
    switch(type){
        case (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFixedFar:
            selectors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $18b5e429067b6c44$var$smallPanelSelectors);
            break;
        case (0, $ab829e5818bb6888$export$969277cf61e5a7aa).medium:
            selectors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $18b5e429067b6c44$var$smallPanelSelectors), $18b5e429067b6c44$var$mediumPanelSelectors);
            break;
        case (0, $ab829e5818bb6888$export$969277cf61e5a7aa).large:
            selectors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $18b5e429067b6c44$var$smallPanelSelectors), $18b5e429067b6c44$var$mediumPanelSelectors), $18b5e429067b6c44$var$largePanelSelectors);
            break;
        case (0, $ab829e5818bb6888$export$969277cf61e5a7aa).largeFixed:
            selectors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $18b5e429067b6c44$var$smallPanelSelectors), $18b5e429067b6c44$var$mediumPanelSelectors), $18b5e429067b6c44$var$largePanelSelectors), $18b5e429067b6c44$var$largeFixedPanelSelectors);
            break;
        case (0, $ab829e5818bb6888$export$969277cf61e5a7aa).extraLarge:
            selectors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $18b5e429067b6c44$var$smallPanelSelectors), $18b5e429067b6c44$var$mediumPanelSelectors), $18b5e429067b6c44$var$largePanelSelectors), $18b5e429067b6c44$var$extraLargePanelSelectors);
            break;
        default:
            break;
    }
    return selectors;
};
var $18b5e429067b6c44$var$commandBarHeight = "44px";
var $18b5e429067b6c44$var$sharedPaddingStyles = {
    paddingLeft: "24px",
    paddingRight: "24px"
};
var $18b5e429067b6c44$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d;
    var className = props.className, focusTrapZoneClassName = props.focusTrapZoneClassName, hasCloseButton = props.hasCloseButton, headerClassName = props.headerClassName, isAnimating = props.isAnimating, isFooterSticky = props.isFooterSticky, isFooterAtBottom = props.isFooterAtBottom, isOnRightSide = props.isOnRightSide, isOpen = props.isOpen, isHiddenOnDismiss = props.isHiddenOnDismiss, hasCustomNavigation = props.hasCustomNavigation, theme = props.theme, _e = props.type, type = _e === void 0 ? (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFixedFar : _e;
    var effects = theme.effects, fonts = theme.fonts, semanticColors = theme.semanticColors;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($18b5e429067b6c44$var$GlobalClassNames, theme);
    var isCustomPanel = type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).custom || type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).customNear;
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isOpen && classNames.isOpen,
            hasCloseButton && classNames.hasCloseButton,
            {
                pointerEvents: "none",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            isCustomPanel && isOnRightSide && classNames.custom,
            isCustomPanel && !isOnRightSide && classNames.customNear,
            className
        ],
        overlay: [
            {
                pointerEvents: "auto",
                cursor: "pointer"
            },
            isOpen && isAnimating && (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn100,
            !isOpen && isAnimating && (0, $e2629e8d47c94809$export$a386448ab9904275).fadeOut100
        ],
        hiddenPanel: [
            !isOpen && !isAnimating && isHiddenOnDismiss && {
                visibility: "hidden"
            }
        ],
        main: [
            classNames.main,
            {
                backgroundColor: semanticColors.bodyBackground,
                boxShadow: effects.elevation64,
                pointerEvents: "auto",
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                overflowX: "hidden",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                bottom: 0,
                top: 0,
                // left, right, width are overridden depending on the type of the Panel and the screen breakpoint.
                left: $18b5e429067b6c44$var$panelMargin.auto,
                right: $18b5e429067b6c44$var$panelMargin.none,
                width: $18b5e429067b6c44$var$panelWidth.full,
                selectors: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderLeft: "3px solid ".concat(semanticColors.variantBorder),
                    borderRight: "3px solid ".concat(semanticColors.variantBorder)
                }, _a), $18b5e429067b6c44$var$getPanelBreakpoints(type))
            },
            type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFluid && {
                left: $18b5e429067b6c44$var$panelMargin.none
            },
            type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).smallFixedNear && {
                left: $18b5e429067b6c44$var$panelMargin.none,
                right: $18b5e429067b6c44$var$panelMargin.auto,
                width: $18b5e429067b6c44$var$panelWidth.xs
            },
            type === (0, $ab829e5818bb6888$export$969277cf61e5a7aa).customNear && {
                right: "auto",
                left: 0
            },
            isCustomPanel && {
                maxWidth: "100vw"
            },
            isOpen && isAnimating && !isOnRightSide && (0, $e2629e8d47c94809$export$a386448ab9904275).slideRightIn40,
            isOpen && isAnimating && isOnRightSide && (0, $e2629e8d47c94809$export$a386448ab9904275).slideLeftIn40,
            !isOpen && isAnimating && !isOnRightSide && (0, $e2629e8d47c94809$export$a386448ab9904275).slideLeftOut40,
            !isOpen && isAnimating && isOnRightSide && (0, $e2629e8d47c94809$export$a386448ab9904275).slideRightOut40,
            focusTrapZoneClassName
        ],
        commands: [
            classNames.commands,
            {
                // Ensures that the sticky header always has a background to prevent overlaps on scroll.
                backgroundColor: semanticColors.bodyBackground,
                paddingTop: 18,
                selectors: (_b = {}, _b["@media (min-height: ".concat((0, $905fed6f1ccd845a$export$2a2cf3a4e575f28), "px)")] = {
                    position: "sticky",
                    top: 0,
                    zIndex: 1
                }, _b)
            },
            hasCustomNavigation && {
                paddingTop: "inherit"
            }
        ],
        navigation: [
            classNames.navigation,
            {
                display: "flex",
                justifyContent: "flex-end"
            },
            hasCustomNavigation && {
                height: $18b5e429067b6c44$var$commandBarHeight
            }
        ],
        contentInner: [
            classNames.contentInner,
            {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflowY: "hidden"
            }
        ],
        header: [
            classNames.header,
            $18b5e429067b6c44$var$sharedPaddingStyles,
            {
                alignSelf: "flex-start"
            },
            hasCloseButton && !hasCustomNavigation && {
                flexGrow: 1
            },
            hasCustomNavigation && {
                // Ensure that title doesn't shrink if screen is too small
                flexShrink: 0
            }
        ],
        headerText: [
            classNames.headerText,
            fonts.xLarge,
            {
                color: semanticColors.bodyText,
                lineHeight: "27px",
                overflowWrap: "break-word",
                wordWrap: "break-word",
                wordBreak: "break-word",
                hyphens: "auto"
            },
            headerClassName
        ],
        scrollableContent: [
            classNames.scrollableContent,
            {
                overflowY: "auto"
            },
            isFooterAtBottom && {
                flexGrow: 1,
                display: "inherit",
                flexDirection: "inherit"
            }
        ],
        content: [
            classNames.content,
            $18b5e429067b6c44$var$sharedPaddingStyles,
            {
                paddingBottom: 20
            },
            isFooterAtBottom && {
                selectors: (_c = {}, _c["@media (min-height: ".concat((0, $905fed6f1ccd845a$export$2a2cf3a4e575f28), "px)")] = {
                    flexGrow: 1
                }, _c)
            }
        ],
        footer: [
            classNames.footer,
            {
                // Ensure that footer doesn't shrink if screen is too small
                flexShrink: 0,
                borderTop: "1px solid transparent",
                transition: "opacity ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue3, " ").concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).easeFunction2),
                selectors: (_d = {}, _d["@media (min-height: ".concat((0, $905fed6f1ccd845a$export$2a2cf3a4e575f28), "px)")] = {
                    position: "sticky",
                    bottom: 0
                }, _d)
            },
            isFooterSticky && {
                backgroundColor: semanticColors.bodyBackground,
                borderTopColor: semanticColors.variantBorder
            }
        ],
        footerInner: [
            classNames.footerInner,
            $18b5e429067b6c44$var$sharedPaddingStyles,
            {
                paddingBottom: 16,
                paddingTop: 16
            }
        ],
        subComponentStyles: {
            closeButton: {
                root: [
                    classNames.closeButton,
                    {
                        marginRight: 14,
                        color: theme.palette.neutralSecondary,
                        fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large
                    },
                    hasCustomNavigation && {
                        marginRight: 0,
                        height: "auto",
                        width: "44px"
                    }
                ],
                rootHovered: {
                    color: theme.palette.neutralPrimary
                }
            }
        }
    };
};


var $51c56defc9953b3f$export$2ddb90ad54e5f587 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $bca47d16325c1107$export$40183b776bb94340), (0, $18b5e429067b6c44$export$ffd58b7f6f099a57), undefined, {
    scope: "Panel"
});


var $9d60c9ebb8df2ec3$exports = {};

$parcel$export($9d60c9ebb8df2ec3$exports, "JobSeekerField", () => $9d60c9ebb8df2ec3$export$be0400ac49c6da8c);


var $9d60c9ebb8df2ec3$var$__assign = undefined && undefined.__assign || function() {
    $9d60c9ebb8df2ec3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d60c9ebb8df2ec3$var$__assign.apply(this, arguments);
};
var $9d60c9ebb8df2ec3$var$DateFormatter = new Intl.DateTimeFormat(navigator.language, {
    month: "short",
    year: "numeric"
});
var $9d60c9ebb8df2ec3$var$formatDate = function(date) {
    var value = "";
    if (date) try {
        var match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(date);
        var month = Number(match && match[1]);
        var day = Number(match && match[2]);
        var year = Number(match && match[3]);
        if (!isNaN(month) && !isNaN(day) && !isNaN(year)) value = $9d60c9ebb8df2ec3$var$DateFormatter.format(new Date(year, month - 1, day));
    } catch (_a) {}
    return value;
};
function $9d60c9ebb8df2ec3$export$be0400ac49c6da8c(props) {
    var person = props.person, property = props.property, as = props.as;
    var Type = as !== null && as !== void 0 ? as : "div";
    switch(property){
        case "fullName":
        case "firstName":
        case "lastName":
        case "experience":
        case "expertise":
        case "otherExpertise":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property]
            }, void 0);
        case "credentials":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property] && (0, $7b02d682eb115277$exports.jsx)((0, $90af54869168591e$export$2c73285ae9390cec), {
                    label: "Credentials",
                    styles: {
                        field: {
                            padding: 0,
                            overflow: "visible"
                        }
                    },
                    multiline: true,
                    resizable: false,
                    borderless: true,
                    readOnly: true,
                    autoAdjustHeight: true,
                    value: person[property]
                }, void 0)
            }, void 0);
        case "email":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property] && (0, $7b02d682eb115277$exports.jsx)((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), $9d60c9ebb8df2ec3$var$__assign({
                    target: "_blank",
                    "data-interception": "off",
                    href: "mailto:".concat(person[property])
                }, {
                    children: person[property]
                }), void 0)
            }, void 0);
        case "phone":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property] && (0, $7b02d682eb115277$exports.jsx)((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), $9d60c9ebb8df2ec3$var$__assign({
                    target: "_blank",
                    "data-interception": "off",
                    href: "tel:".concat(person[property])
                }, {
                    children: person[property]
                }), void 0)
            }, void 0);
        case "linkedInProfile":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property] && (0, $7b02d682eb115277$exports.jsx)((0, $60ef620c1429fb92$export$a6c7ac8248d6e38a), $9d60c9ebb8df2ec3$var$__assign({
                    target: "_blank",
                    "data-interception": "off",
                    href: person[property]
                }, {
                    children: person[property]
                }), void 0)
            }, void 0);
        case "location":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: person[property].join(", ")
            }, void 0);
        case "workHistory":
            return (0, $7b02d682eb115277$exports.jsx)(Type, {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $9d60c9ebb8df2ec3$var$__assign({
                    tokens: {
                        childrenGap: 12
                    }
                }, {
                    children: person[property].map(function(x, i) {
                        return (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), $9d60c9ebb8df2ec3$var$__assign({
                                    styles: {
                                        root: {
                                            fontWeight: 500
                                        }
                                    }
                                }, {
                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: "".concat(x.position, " @ ").concat(x.employer)
                                        }
                                    }, void 0)
                                }), void 0),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), $9d60c9ebb8df2ec3$var$__assign({
                                    variant: "medium"
                                }, {
                                    children: [
                                        $9d60c9ebb8df2ec3$var$formatDate(x.from),
                                        " - ",
                                        $9d60c9ebb8df2ec3$var$formatDate(x.to) || "Present"
                                    ]
                                }), void 0)
                            ]
                        }, i);
                    })
                }), void 0)
            }, void 0);
    }
}



var $acw62 = parcelRequire("acw62");
var $06d61c41acc2a072$exports = {};


!function(e, t) {
    $06d61c41acc2a072$exports = t((parcelRequire("acw62")), (parcelRequire("1u0KT")));
}("undefined" != typeof self ? self : $06d61c41acc2a072$exports, function(e, t) {
    return function() {
        "use strict";
        var n = {
            156: function(t) {
                t.exports = e;
            },
            111: function(e) {
                e.exports = t;
            },
            582: function(e, t, n) {
                n.r(t), n.d(t, {
                    __assign: function() {
                        return i;
                    },
                    __asyncDelegator: function() {
                        return S;
                    },
                    __asyncGenerator: function() {
                        return x;
                    },
                    __asyncValues: function() {
                        return E;
                    },
                    __await: function() {
                        return O;
                    },
                    __awaiter: function() {
                        return h;
                    },
                    __classPrivateFieldGet: function() {
                        return k;
                    },
                    __classPrivateFieldIn: function() {
                        return R;
                    },
                    __classPrivateFieldSet: function() {
                        return M;
                    },
                    __createBinding: function() {
                        return g;
                    },
                    __decorate: function() {
                        return c;
                    },
                    __esDecorate: function() {
                        return u;
                    },
                    __exportStar: function() {
                        return v;
                    },
                    __extends: function() {
                        return o;
                    },
                    __generator: function() {
                        return y;
                    },
                    __importDefault: function() {
                        return C;
                    },
                    __importStar: function() {
                        return A;
                    },
                    __makeTemplateObject: function() {
                        return j;
                    },
                    __metadata: function() {
                        return p;
                    },
                    __param: function() {
                        return l;
                    },
                    __propKey: function() {
                        return f;
                    },
                    __read: function() {
                        return m;
                    },
                    __rest: function() {
                        return a;
                    },
                    __runInitializers: function() {
                        return s;
                    },
                    __setFunctionName: function() {
                        return d;
                    },
                    __spread: function() {
                        return _;
                    },
                    __spreadArray: function() {
                        return P;
                    },
                    __spreadArrays: function() {
                        return w;
                    },
                    __values: function() {
                        return b;
                    }
                });
                var r = function(e, t) {
                    return r = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }, r(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var n = {};
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(r = Object.getOwnPropertySymbols(e); o < r.length; o++)t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                    }
                    return n;
                }
                function c(e, t, n, r) {
                    var o, i = arguments.length, a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);
                    else for(var c = e.length - 1; c >= 0; c--)(o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
                    return i > 3 && a && Object.defineProperty(t, n, a), a;
                }
                function l(e, t) {
                    return function(n, r) {
                        t(n, r, e);
                    };
                }
                function u(e, t, n, r, o, i) {
                    function a(e) {
                        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                        return e;
                    }
                    for(var c, l = r.kind, u = "getter" === l ? "get" : "setter" === l ? "set" : "value", s = !t && e ? r.static ? e : e.prototype : null, f = t || (s ? Object.getOwnPropertyDescriptor(s, r.name) : {}), d = !1, p = n.length - 1; p >= 0; p--){
                        var h = {};
                        for(var y in r)h[y] = "access" === y ? {} : r[y];
                        for(var y in r.access)h.access[y] = r.access[y];
                        h.addInitializer = function(e) {
                            if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                            i.push(a(e || null));
                        };
                        var g = (0, n[p])("accessor" === l ? {
                            get: f.get,
                            set: f.set
                        } : f[u], h);
                        if ("accessor" === l) {
                            if (void 0 === g) continue;
                            if (null === g || "object" != typeof g) throw new TypeError("Object expected");
                            (c = a(g.get)) && (f.get = c), (c = a(g.set)) && (f.set = c), (c = a(g.init)) && o.unshift(c);
                        } else (c = a(g)) && ("field" === l ? o.unshift(c) : f[u] = c);
                    }
                    s && Object.defineProperty(s, r.name, f), d = !0;
                }
                function s(e, t, n) {
                    for(var r = arguments.length > 2, o = 0; o < t.length; o++)n = r ? t[o].call(e, n) : t[o].call(e);
                    return r ? n : void 0;
                }
                function f(e) {
                    return "symbol" == typeof e ? e : "".concat(e);
                }
                function d(e, t, n) {
                    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                        configurable: !0,
                        value: n ? "".concat(n, " ", t) : t
                    });
                }
                function p(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function h(e, t, n, r) {
                    return new (n || (n = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                l(r.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                l(r.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function l(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        l((r = r.apply(e, t || [])).next());
                    });
                }
                function y(e, t) {
                    var n, r, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(l) {
                            return function(c) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (n = 1, r && (o = 2 & c[0] ? r.return : c[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, c[1])).done) return o;
                                    switch(r = 0, o && (c = [
                                        2 & c[0],
                                        o.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            o = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, r = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < o[1]) {
                                                a.label = o[1], o = c;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(c);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], r = 0;
                                } finally{
                                    n = o = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                l
                            ]);
                        };
                    }
                }
                var g = Object.create ? function(e, t, n, r) {
                    void 0 === r && (r = n);
                    var o = Object.getOwnPropertyDescriptor(t, n);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, r, o);
                } : function(e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                };
                function v(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || g(t, e, n);
                }
                function b(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && r >= e.length && (e = void 0), {
                                value: e && e[r++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function m(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var r, o, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(r = i.next()).done;)a.push(r.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (n = i.return) && n.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function _() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(m(arguments[t]));
                    return e;
                }
                function w() {
                    for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
                    var r = Array(e), o = 0;
                    for(t = 0; t < n; t++)for(var i = arguments[t], a = 0, c = i.length; a < c; a++, o++)r[o] = i[a];
                    return r;
                }
                function P(e, t, n) {
                    if (n || 2 === arguments.length) for(var r, o = 0, i = t.length; o < i; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
                    return e.concat(r || Array.prototype.slice.call(t));
                }
                function O(e) {
                    return this instanceof O ? (this.v = e, this) : new O(e);
                }
                function x(e, t, n) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var r, o = n.apply(e, t || []), i = [];
                    return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function() {
                        return this;
                    }, r;
                    function a(e) {
                        o[e] && (r[e] = function(t) {
                            return new Promise(function(n, r) {
                                i.push([
                                    e,
                                    t,
                                    n,
                                    r
                                ]) > 1 || c(e, t);
                            });
                        });
                    }
                    function c(e, t) {
                        try {
                            (n = o[e](t)).value instanceof O ? Promise.resolve(n.value.v).then(l, u) : s(i[0][2], n);
                        } catch (e) {
                            s(i[0][3], e);
                        }
                        var n;
                    }
                    function l(e) {
                        c("next", e);
                    }
                    function u(e) {
                        c("throw", e);
                    }
                    function s(e, t) {
                        e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
                    }
                }
                function S(e) {
                    var t, n;
                    return t = {}, r("next"), r("throw", function(e) {
                        throw e;
                    }), r("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function r(r, o) {
                        t[r] = e[r] ? function(t) {
                            return (n = !n) ? {
                                value: O(e[r](t)),
                                done: !1
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function E(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, n = e[Symbol.asyncIterator];
                    return n ? n.call(e) : (e = b(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function r(n) {
                        t[n] = e[n] && function(t) {
                            return new Promise(function(r, o) {
                                !function(e, t, n, r) {
                                    Promise.resolve(r).then(function(t) {
                                        e({
                                            value: t,
                                            done: n
                                        });
                                    }, t);
                                }(r, o, (t = e[n](t)).done, t.value);
                            });
                        };
                    }
                }
                function j(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var T = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function A(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && g(t, e, n);
                    return T(t, e), t;
                }
                function C(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function k(e, t, n, r) {
                    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
                }
                function M(e, t, n, r, o) {
                    if ("m" === r) throw new TypeError("Private method is not writable");
                    if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
                }
                function R(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
                t.default = {
                    __extends: o,
                    __assign: i,
                    __rest: a,
                    __decorate: c,
                    __param: l,
                    __metadata: p,
                    __awaiter: h,
                    __generator: y,
                    __createBinding: g,
                    __exportStar: v,
                    __values: b,
                    __read: m,
                    __spread: _,
                    __spreadArrays: w,
                    __spreadArray: P,
                    __await: O,
                    __asyncGenerator: x,
                    __asyncDelegator: S,
                    __asyncValues: E,
                    __makeTemplateObject: j,
                    __importStar: A,
                    __importDefault: C,
                    __classPrivateFieldGet: k,
                    __classPrivateFieldSet: M,
                    __classPrivateFieldIn: R
                };
            }
        }, r = {};
        function o(e) {
            var t = r[e];
            if (void 0 !== t) return t.exports;
            var i = r[e] = {
                exports: {}
            };
            return n[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var n in t)o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(582), n = o(156), r = o(111), a = Object.prototype.hasOwnProperty.call(n, "createContext"), c = Object.prototype.hasOwnProperty.call(n, "useMemo") && Object.prototype.hasOwnProperty.call(n, "useCallback"), l = a ? n.createContext({}) : null;
            e.PrintContextConsumer = l ? l.Consumer : function() {
                return null;
            };
            var u = {
                copyStyles: !0,
                pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
                removeAfterPrint: !1,
                suppressErrors: !1
            }, s = function(e) {
                function o() {
                    var n = null !== e && e.apply(this, arguments) || this;
                    return n.startPrint = function(e) {
                        var t = n.props, r = t.onAfterPrint, o = t.onPrintError, i = t.print, a = t.documentTitle;
                        setTimeout(function() {
                            var t, c;
                            if (e.contentWindow) {
                                if (e.contentWindow.focus(), i) i(e).then(function() {
                                    return null == r ? void 0 : r();
                                }).then(function() {
                                    return n.handleRemoveIframe();
                                }).catch(function(e) {
                                    o ? o("print", e) : n.logMessages([
                                        "An error was thrown by the specified `print` function"
                                    ]);
                                });
                                else {
                                    if (e.contentWindow.print) {
                                        var l = null !== (c = null === (t = e.contentDocument) || void 0 === t ? void 0 : t.title) && void 0 !== c ? c : "", u = e.ownerDocument.title;
                                        a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = l));
                                    } else n.logMessages([
                                        "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                    ]);
                                    null == r || r(), n.handleRemoveIframe();
                                }
                            } else n.logMessages([
                                "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                            ]);
                        }, 500);
                    }, n.triggerPrint = function(e) {
                        var t = n.props, r = t.onBeforePrint, o = t.onPrintError;
                        if (r) {
                            var i = r();
                            i && "function" == typeof i.then ? i.then(function() {
                                n.startPrint(e);
                            }).catch(function(e) {
                                o && o("onBeforePrint", e);
                            }) : n.startPrint(e);
                        } else n.startPrint(e);
                    }, n.handleClick = function() {
                        var e = n.props, t = e.onBeforeGetContent, r = e.onPrintError;
                        if (t) {
                            var o = t();
                            o && "function" == typeof o.then ? o.then(n.handlePrint).catch(function(e) {
                                r && r("onBeforeGetContent", e);
                            }) : n.handlePrint();
                        } else n.handlePrint();
                    }, n.handlePrint = function() {
                        var e = n.props, o = e.bodyClass, i = e.content, a = e.copyStyles, c = e.fonts, l = e.pageStyle, u = e.nonce, s = i();
                        if (void 0 !== s) {
                            if (null !== s) {
                                var f = document.createElement("iframe");
                                f.width = "".concat(document.documentElement.clientWidth, "px"), f.height = "".concat(document.documentElement.clientHeight, "px"), f.style.position = "absolute", f.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), f.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), f.id = "printWindow", f.srcdoc = "<!DOCTYPE html>";
                                var d = (0, r.findDOMNode)(s);
                                if (d) {
                                    var p = d.cloneNode(!0), h = p instanceof Text, y = document.querySelectorAll("link[rel='stylesheet']"), g = h ? [] : p.querySelectorAll("img"), v = h ? [] : p.querySelectorAll("video"), b = c ? c.length : 0;
                                    n.numResourcesToLoad = y.length + g.length + v.length + b, n.resourcesLoaded = [], n.resourcesErrored = [];
                                    var m = function(e, r) {
                                        n.resourcesLoaded.includes(e) ? n.logMessages([
                                            "Tried to mark a resource that has already been handled",
                                            e
                                        ], "debug") : (r ? (n.logMessages(t.__spreadArray([
                                            '"react-to-print" was unable to load a resource but will continue attempting to print the page'
                                        ], t.__read(r), !1)), n.resourcesErrored.push(e)) : n.resourcesLoaded.push(e), n.resourcesLoaded.length + n.resourcesErrored.length === n.numResourcesToLoad && n.triggerPrint(f));
                                    };
                                    f.onload = function() {
                                        var e, r, i, s;
                                        f.onload = null;
                                        var y = f.contentDocument || (null === (r = f.contentWindow) || void 0 === r ? void 0 : r.document);
                                        if (y) {
                                            y.body.appendChild(p), c && ((null === (i = f.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (s = f.contentWindow) || void 0 === s ? void 0 : s.FontFace) ? c.forEach(function(e) {
                                                var t = new FontFace(e.family, e.source, {
                                                    weight: e.weight,
                                                    style: e.style
                                                });
                                                f.contentDocument.fonts.add(t), t.loaded.then(function() {
                                                    m(t);
                                                }).catch(function(e) {
                                                    m(t, [
                                                        "Failed loading the font:",
                                                        t,
                                                        "Load error:",
                                                        e
                                                    ]);
                                                });
                                            }) : (c.forEach(function(e) {
                                                return m(e);
                                            }), n.logMessages([
                                                '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
                                            ])));
                                            var b = "function" == typeof l ? l() : l;
                                            if ("string" != typeof b) n.logMessages([
                                                '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')
                                            ]);
                                            else {
                                                var _ = y.createElement("style");
                                                u && (_.setAttribute("nonce", u), y.head.setAttribute("nonce", u)), _.appendChild(y.createTextNode(b)), y.head.appendChild(_);
                                            }
                                            if (o && (e = y.body.classList).add.apply(e, t.__spreadArray([], t.__read(o.split(" ")), !1)), !h) {
                                                for(var w = h ? [] : d.querySelectorAll("canvas"), P = y.querySelectorAll("canvas"), O = 0; O < w.length; ++O){
                                                    var x = w[O], S = P[O].getContext("2d");
                                                    S && S.drawImage(x, 0, 0);
                                                }
                                                var E = function(e) {
                                                    var t = g[e], n = t.getAttribute("src");
                                                    if (n) {
                                                        var r = new Image;
                                                        r.onload = function() {
                                                            return m(t);
                                                        }, r.onerror = function(e, n, r, o, i) {
                                                            return m(t, [
                                                                "Error loading <img>",
                                                                t,
                                                                "Error",
                                                                i
                                                            ]);
                                                        }, r.src = n;
                                                    } else m(t, [
                                                        'Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',
                                                        t
                                                    ]);
                                                };
                                                for(O = 0; O < g.length; O++)E(O);
                                                var j = function(e) {
                                                    var t = v[e];
                                                    t.preload = "auto";
                                                    var n = t.getAttribute("poster");
                                                    if (n) {
                                                        var r = new Image;
                                                        r.onload = function() {
                                                            return m(t);
                                                        }, r.onerror = function(e, r, o, i, a) {
                                                            return m(t, [
                                                                "Error loading video poster",
                                                                n,
                                                                "for video",
                                                                t,
                                                                "Error:",
                                                                a
                                                            ]);
                                                        }, r.src = n;
                                                    } else t.readyState >= 2 ? m(t) : (t.onloadeddata = function() {
                                                        return m(t);
                                                    }, t.onerror = function(e, n, r, o, i) {
                                                        return m(t, [
                                                            "Error loading video",
                                                            t,
                                                            "Error",
                                                            i
                                                        ]);
                                                    }, t.onstalled = function() {
                                                        return m(t, [
                                                            "Loading video stalled, skipping",
                                                            t
                                                        ]);
                                                    });
                                                };
                                                for(O = 0; O < v.length; O++)j(O);
                                                var T = "input", A = d.querySelectorAll(T), C = y.querySelectorAll(T);
                                                for(O = 0; O < A.length; O++)C[O].value = A[O].value;
                                                var k = "input[type=checkbox],input[type=radio]", M = d.querySelectorAll(k), R = y.querySelectorAll(k);
                                                for(O = 0; O < M.length; O++)R[O].checked = M[O].checked;
                                                var D = "select", I = d.querySelectorAll(D), q = y.querySelectorAll(D);
                                                for(O = 0; O < I.length; O++)q[O].value = I[O].value;
                                            }
                                            if (a) for(var F = document.querySelectorAll("style, link[rel='stylesheet']"), L = function(e, t) {
                                                var r = F[e];
                                                if ("style" === r.tagName.toLowerCase()) {
                                                    var o = y.createElement(r.tagName), i = r.sheet;
                                                    if (i) {
                                                        var a = "";
                                                        try {
                                                            for(var c = i.cssRules.length, l = 0; l < c; ++l)"string" == typeof i.cssRules[l].cssText && (a += "".concat(i.cssRules[l].cssText, "\r\n"));
                                                        } catch (e) {
                                                            n.logMessages([
                                                                "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                r
                                                            ], "warning");
                                                        }
                                                        o.setAttribute("id", "react-to-print-".concat(e)), u && o.setAttribute("nonce", u), o.appendChild(y.createTextNode(a)), y.head.appendChild(o);
                                                    }
                                                } else if (r.getAttribute("href")) {
                                                    if (r.hasAttribute("disabled")) n.logMessages([
                                                        "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                        r
                                                    ], "warning"), m(r);
                                                    else {
                                                        for(var s = y.createElement(r.tagName), f = (l = 0, r.attributes.length); l < f; ++l){
                                                            var d = r.attributes[l];
                                                            d && s.setAttribute(d.nodeName, d.nodeValue || "");
                                                        }
                                                        s.onload = function() {
                                                            return m(s);
                                                        }, s.onerror = function(e, t, n, r, o) {
                                                            return m(s, [
                                                                "Failed to load",
                                                                s,
                                                                "Error:",
                                                                o
                                                            ]);
                                                        }, u && s.setAttribute("nonce", u), y.head.appendChild(s);
                                                    }
                                                } else n.logMessages([
                                                    "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                    r
                                                ], "warning"), m(r);
                                            }, W = (O = 0, F.length); O < W; ++O)L(O);
                                        }
                                        0 !== n.numResourcesToLoad && a || n.triggerPrint(f);
                                    }, n.handleRemoveIframe(!0), document.body.appendChild(f);
                                } else n.logMessages([
                                    '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                ]);
                            } else n.logMessages([
                                'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                            ]);
                        } else n.logMessages([
                            "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                        ]);
                    }, n.handleRemoveIframe = function(e) {
                        var t = n.props.removeAfterPrint;
                        if (e || t) {
                            var r = document.getElementById("printWindow");
                            r && document.body.removeChild(r);
                        }
                    }, n.logMessages = function(e, t) {
                        void 0 === t && (t = "error"), n.props.suppressErrors || ("error" === t ? console.error(e) : "warning" === t ? console.warn(e) : "debug" === t && console.debug(e));
                    }, n;
                }
                return t.__extends(o, e), o.prototype.render = function() {
                    var e = this.props, t = e.children, r = e.trigger;
                    if (r) return n.cloneElement(r(), {
                        onClick: this.handleClick
                    });
                    if (!l) return this.logMessages([
                        '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                    ]), null;
                    var o = {
                        handlePrint: this.handleClick
                    };
                    return n.createElement(l.Provider, {
                        value: o
                    }, t);
                }, o.defaultProps = u, o;
            }(n.Component);
            e.default = s, e.useReactToPrint = function(e) {
                if (!c) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                    throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                };
                var r = n.useMemo(function() {
                    return new s(t.__assign(t.__assign({}, u), e));
                }, [
                    e
                ]);
                return n.useCallback(function() {
                    return r.handleClick();
                }, [
                    r
                ]);
            };
        }(), i;
    }();
});


var $23490a8dec97b8ae$var$__assign = undefined && undefined.__assign || function() {
    $23490a8dec97b8ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23490a8dec97b8ae$var$__assign.apply(this, arguments);
};
var $23490a8dec97b8ae$var$buttonStyles = {
    root: {
        marginRight: 8
    }
};
function $23490a8dec97b8ae$export$67322c398cb3229d(props) {
    var person = props.person, onDismiss = props.onDismiss;
    var printContents = (0, $acw62.useRef)();
    var onPrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: function() {
            return printContents.current;
        },
        copyStyles: true
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $51c56defc9953b3f$export$2ddb90ad54e5f587), $23490a8dec97b8ae$var$__assign({
        styles: {
            footer: {
                backgroundColor: "#fff"
            }
        },
        headerText: "Jobseeker Details",
        isOpen: true,
        type: (0, $ab829e5818bb6888$export$969277cf61e5a7aa).medium,
        onDismiss: onDismiss,
        closeButtonAriaLabel: "Close",
        onRenderFooterContent: function() {
            return (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), $23490a8dec97b8ae$var$__assign({
                        onClick: onPrint,
                        styles: $23490a8dec97b8ae$var$buttonStyles
                    }, {
                        children: "Print"
                    }), void 0),
                    (0, $7b02d682eb115277$exports.jsx)((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), $23490a8dec97b8ae$var$__assign({
                        onClick: onDismiss
                    }, {
                        children: "Close"
                    }), void 0)
                ]
            }, void 0);
        },
        isFooterAtBottom: true
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("div", $23490a8dec97b8ae$var$__assign({
            className: "print-panel",
            ref: printContents
        }, {
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $23490a8dec97b8ae$var$__assign({
                styles: {
                    root: {
                        paddingTop: 0
                    }
                },
                tokens: {
                    childrenGap: 0
                }
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), $23490a8dec97b8ae$var$__assign({
                        variant: "xLargePlus",
                        styles: {
                            root: {
                                color: "#004990",
                                fontSize: 40,
                                fontWeight: 500
                            }
                        }
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                            person: person,
                            property: "fullName"
                        }, void 0)
                    }), void 0),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), $23490a8dec97b8ae$var$__assign({
                        variant: "mediumPlus",
                        styles: {
                            root: {
                                color: "#004990",
                                fontSize: 16,
                                fontWeight: 500,
                                marginTop: -12
                            }
                        }
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "expertise",
                                as: "span"
                            }, void 0),
                            " - ",
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "location",
                                as: "span"
                            }, void 0)
                        ]
                    }), void 0),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Contact information"
                            }, void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                className: "section-label"
                            }, {
                                children: $23490a8dec97b8ae$var$getPersonFieldLabel("email")
                            }), void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "email"
                            }, void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                className: "section-label"
                            }, {
                                children: $23490a8dec97b8ae$var$getPersonFieldLabel("phone")
                            }), void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "phone"
                            }, void 0),
                            person.linkedInProfile && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                        className: "section-label"
                                    }, {
                                        children: $23490a8dec97b8ae$var$getPersonFieldLabel("linkedInProfile")
                                    }), void 0),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                        person: person,
                                        property: "linkedInProfile"
                                    }, void 0)
                                ]
                            }, void 0)
                        ]
                    }, void 0),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Experience"
                            }, void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                className: "section-label"
                            }, {
                                children: $23490a8dec97b8ae$var$getPersonFieldLabel("expertise")
                            }), void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "expertise"
                            }, void 0),
                            "Other" === person.expertise && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                    person: person,
                                    property: "otherExpertise"
                                }, void 0)
                            }, void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                className: "section-label"
                            }, {
                                children: $23490a8dec97b8ae$var$getPersonFieldLabel("experience")
                            }), void 0),
                            (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                person: person,
                                property: "experience"
                            }, void 0),
                            person.workHistory && person.workHistory.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), $23490a8dec97b8ae$var$__assign({
                                        className: "section-label"
                                    }, {
                                        children: $23490a8dec97b8ae$var$getPersonFieldLabel("workHistory")
                                    }), void 0),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                        person: person,
                                        property: "workHistory"
                                    }, void 0)
                                ]
                            }, void 0),
                            person.credentials && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                                    person: person,
                                    property: "credentials"
                                }, void 0)
                            }, void 0)
                        ]
                    }, void 0)
                ]
            }), void 0)
        }), void 0)
    }), void 0);
}
function $23490a8dec97b8ae$var$getPersonFieldLabel(property) {
    switch(property){
        case "fullName":
            return "Name";
        case "firstName":
            return "First name";
        case "lastName":
            return "Last name";
        case "email":
            return "Email";
        case "credentials":
            return "Credentials";
        case "experience":
            return "Years of experience in work area";
        case "expertise":
            return "Area of work expertise";
        case "otherExpertise":
            return "";
        case "phone":
            return "Phone";
        case "linkedInProfile":
            return "Linked In";
        case "location":
            return "Preferred work location(s)";
        case "workHistory":
            return "Work history";
    }
}



var $dad8c4ad44cfb8f1$var$__assign = undefined && undefined.__assign || function() {
    $dad8c4ad44cfb8f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dad8c4ad44cfb8f1$var$__assign.apply(this, arguments);
};
var $dad8c4ad44cfb8f1$var$getPeople = function() {
    return fetch("/api/people?t=".concat(Date.now())).then(function(r) {
        return r.json();
    }).catch(function(err) {
        return console.log("Error logging in.", err);
    });
};
var $dad8c4ad44cfb8f1$var$buildColumn = function(name, field) {
    return {
        key: field,
        minWidth: 50,
        name: name,
        fieldName: field,
        isResizable: true,
        flexGrow: 1,
        isSorted: false,
        isSortedDescending: false,
        onRender: function(person) {
            return (0, $7b02d682eb115277$exports.jsx)((0, $9d60c9ebb8df2ec3$exports.JobSeekerField), {
                person: person,
                property: field
            }, void 0);
        }
    };
};
var $dad8c4ad44cfb8f1$var$buildFilterOption = function(name, checked, onClick) {
    return {
        key: name,
        text: name,
        canCheck: true,
        checked: checked,
        onClick: onClick
    };
};
var $dad8c4ad44cfb8f1$var$JobSeekerColumns = [
    $dad8c4ad44cfb8f1$var$buildColumn("Name", "fullName"),
    $dad8c4ad44cfb8f1$var$buildColumn("Area of Expertise", "expertise"),
    $dad8c4ad44cfb8f1$var$buildColumn("Years of Experience", "experience"),
    $dad8c4ad44cfb8f1$var$buildColumn("Preferred Location", "location")
];
var $dad8c4ad44cfb8f1$var$getFilteredPeople = function(items, searchText, filters) {
    var results = items.slice();
    if (searchText) {
        var searchTextLower_1 = searchText.toLocaleLowerCase();
        results = results.filter(function(person) {
            return person.firstName.toLocaleLowerCase().includes(searchTextLower_1) || person.lastName.toLocaleLowerCase().includes(searchTextLower_1) || person.fullName.toLocaleLowerCase().includes(searchTextLower_1) || person.email.toLocaleLowerCase().includes(searchTextLower_1) || person.expertise.toLocaleLowerCase().includes(searchTextLower_1) || person.location.some(function(l) {
                return l.toLocaleLowerCase().includes(searchTextLower_1);
            }) || person.workHistory.some(function(j) {
                return j.employer.toLocaleLowerCase().includes(searchTextLower_1) || j.position.toLocaleLowerCase().includes(searchTextLower_1);
            });
        });
    }
    if (filters.expertise.length > 0) results = results.filter(function(person) {
        return filters.expertise.some(function(expertise) {
            return person.expertise === expertise;
        });
    });
    if (filters.location.length > 0) results = results.filter(function(person) {
        return filters.location.some(function(location) {
            return person.location.some(function(l) {
                return l === location;
            });
        });
    });
    if (filters.experience.length > 0) results = results.filter(function(person) {
        var experienceNumber = Number(person.experience);
        return !isNaN(experienceNumber) && filters.experience.some(function(experience) {
            return experience && (typeof experience.low === "undefined" || experienceNumber >= experience.low) && (typeof experience.high === "undefined" || experienceNumber <= experience.high);
        });
    });
    return results.filter(function(r) {
        return r.fullName;
    });
};
var $dad8c4ad44cfb8f1$var$ExperienceOptions = {
    "< 3 Years": {
        high: 3
    },
    "3 - 5 Years": {
        low: 3,
        high: 5
    },
    "5 - 7 Years": {
        low: 5,
        high: 7
    },
    "7 - 10 Years": {
        low: 7,
        high: 10
    },
    "10 + Years": {
        low: 10
    }
};
var $dad8c4ad44cfb8f1$var$FilterColumns = [
    "expertise",
    "experience",
    "location"
];
function $dad8c4ad44cfb8f1$export$b1a2a875e9576fd(props) {
    var company = props.company, onSignOut = props.onSignOut;
    var _a = (0, $acw62.useState)(true), isMessageBarVisible = _a[0], setIsMessageBarVisible = _a[1];
    var _b = (0, $acw62.useState)(true), loading = _b[0], setLoading = _b[1];
    var _c = (0, $acw62.useState)(false), error = _c[0], setError = _c[1];
    var _d = (0, $acw62.useState)(""), searchText = _d[0], setSearchText = _d[1];
    var _e = (0, $acw62.useState)([]), filteredItems = _e[0], setFilteredItems = _e[1];
    var _f = (0, $acw62.useState)(), selectedItem = _f[0], setSelectedItem = _f[1];
    var _g = (0, $acw62.useState)([]), columnMenuItems = _g[0], setColumnMenuItems = _g[1];
    var _h = (0, $acw62.useState)({
        experience: [],
        expertise: [],
        location: []
    }), filters = _h[0], setFilters = _h[1];
    var contextMenuTarget = (0, $acw62.useRef)();
    var items = (0, $acw62.useRef)([]);
    var columns = (0, $acw62.useRef)($dad8c4ad44cfb8f1$var$JobSeekerColumns.map(function(c) {
        var column = $dad8c4ad44cfb8f1$var$__assign({}, c);
        if ($dad8c4ad44cfb8f1$var$FilterColumns.includes(c.key)) column.columnActionsMode = (0, $5103473855f147d2$export$e393753d4e31e51).hasDropdown;
        return column;
    }));
    var getFilterOptions = function(column) {
        var filterOptions = [];
        switch(column.key){
            case "expertise":
                var expertiseOptions_1 = {};
                items.current.forEach(function(person) {
                    var _a, _b;
                    if (((_b = (_a = person.expertise) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) > 0 && !expertiseOptions_1[person.expertise]) {
                        expertiseOptions_1[person.expertise] = true;
                        filterOptions.push($dad8c4ad44cfb8f1$var$buildFilterOption(person.expertise, filters.expertise.includes(person.expertise), function() {
                            var newExpertises = filters.expertise.slice();
                            var expertiseIndex = newExpertises.indexOf(person.expertise);
                            if (expertiseIndex >= 0) newExpertises.splice(expertiseIndex, 1);
                            else newExpertises.push(person.expertise);
                            setFilters({
                                experience: filters.experience,
                                location: filters.location,
                                expertise: newExpertises
                            });
                        }));
                    }
                });
                filterOptions.sort(function(a, b) {
                    return a.key < b.key ? -1 : 1;
                });
                break;
            case "location":
                var locationOptions_1 = {};
                items.current.forEach(function(person) {
                    (person.location || []).forEach(function(l) {
                        var _a;
                        if (((_a = l === null || l === void 0 ? void 0 : l.trim()) === null || _a === void 0 ? void 0 : _a.length) > 0 && !locationOptions_1[l]) {
                            locationOptions_1[l] = true;
                            filterOptions.push($dad8c4ad44cfb8f1$var$buildFilterOption(l, filters.location.includes(l), function() {
                                var newLocations = filters.location.slice();
                                var locationIndex = newLocations.indexOf(l);
                                if (locationIndex >= 0) newLocations.splice(locationIndex, 1);
                                else newLocations.push(l);
                                setFilters({
                                    experience: filters.experience,
                                    expertise: filters.expertise,
                                    location: newLocations
                                });
                            }));
                        }
                    });
                });
                filterOptions.sort(function(a, b) {
                    return a.key < b.key ? -1 : 1;
                });
                break;
            case "experience":
                Object.keys($dad8c4ad44cfb8f1$var$ExperienceOptions).forEach(function(key) {
                    filterOptions.push($dad8c4ad44cfb8f1$var$buildFilterOption(key, filters.experience.some(function(r) {
                        return r.key === key;
                    }), function() {
                        var newExperience = filters.experience.slice();
                        var experienceIndex = newExperience.findIndex(function(x) {
                            return x.key === key;
                        });
                        if (experienceIndex >= 0) newExperience.splice(experienceIndex, 1);
                        else newExperience.push({
                            key: key,
                            low: $dad8c4ad44cfb8f1$var$ExperienceOptions[key].low,
                            high: $dad8c4ad44cfb8f1$var$ExperienceOptions[key].high
                        });
                        setFilters({
                            expertise: filters.expertise,
                            location: filters.location,
                            experience: newExperience
                        });
                    }));
                });
                break;
        }
        return filterOptions;
    };
    var onColumnHeaderClick = function(ev, column) {
        if (column && column.columnActionsMode === (0, $5103473855f147d2$export$e393753d4e31e51).hasDropdown) {
            var filterOptions = getFilterOptions(column);
            if (filterOptions.length > 0) {
                contextMenuTarget.current = ev === null || ev === void 0 ? void 0 : ev.currentTarget;
                setColumnMenuItems(filterOptions);
            }
        }
    };
    var onDismissContextMenu = function() {
        setColumnMenuItems([]);
    };
    var onRenderRow = function(props, defaultRenderer) {
        return (0, $7b02d682eb115277$exports.jsx)("div", $dad8c4ad44cfb8f1$var$__assign({
            style: {
                cursor: "pointer"
            },
            onClick: function() {
                return setSelectedItem(props.item);
            }
        }, {
            children: defaultRenderer(props)
        }), void 0);
    };
    var refreshPeople = function() {
        setError(false);
        setLoading(true);
        $dad8c4ad44cfb8f1$var$getPeople().then(function(data) {
            items.current = data;
            setFilteredItems($dad8c4ad44cfb8f1$var$getFilteredPeople(data, searchText, filters));
        }).catch(function(err) {
            console.log("Error loading job seekers.", err);
            setError(true);
        }).finally(function() {
            return setLoading(false);
        });
    };
    (0, $acw62.useEffect)(function() {
        refreshPeople();
    }, []);
    (0, $acw62.useEffect)(function() {
        setFilteredItems($dad8c4ad44cfb8f1$var$getFilteredPeople(items.current, searchText, filters));
    }, [
        searchText,
        filters.experience,
        ,
        filters.expertise,
        filters.location
    ]);
    var handleDismiss = function() {
        setIsMessageBarVisible(false);
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $dad8c4ad44cfb8f1$var$__assign({
        className: "content-width",
        tokens: {
            padding: "12px 24px",
            childrenGap: 12
        }
    }, {
        children: error ? (0, $7b02d682eb115277$exports.jsx)((0, $9f5f9961c32ac024$export$1fa34b291900a3af), $dad8c4ad44cfb8f1$var$__assign({
            messageBarType: (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).error
        }, {
            children: "Failed to load job seekers. Please contact support."
        }), void 0) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: loading ? (0, $7b02d682eb115277$exports.jsx)((0, $f6af8ac8c0971da3$export$2b776f7e7ee60dbd), {
                label: "Loading job seekers..."
            }, void 0) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: items.current.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        isMessageBarVisible && (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $9f5f9961c32ac024$export$1fa34b291900a3af), $dad8c4ad44cfb8f1$var$__assign({
                                messageBarType: (0, $d2ca2ffbf75eeb82$export$4e445f5154412478).info,
                                onDismiss: handleDismiss,
                                dismissButtonAriaLabel: "Close",
                                truncated: true
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Instructions:"
                                    }, void 0),
                                    (0, $7b02d682eb115277$exports.jsxs)("ol", $dad8c4ad44cfb8f1$var$__assign({
                                        type: "1"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Filter data by selecting column headers. You can select more than one option. To clear filter, select the option again."
                                            }, void 0),
                                            (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Use Global Search to search and filter all profile data including data not shown in columns."
                                            }, void 0),
                                            (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Select a profile row to see full profile data and print to PDF to save locally or printer."
                                            }, void 0),
                                            (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Select Close in pane to resume search."
                                            }, void 0)
                                        ]
                                    }), void 0)
                                ]
                            }), void 0)
                        }, void 0),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), $dad8c4ad44cfb8f1$var$__assign({
                            horizontal: true,
                            horizontalAlign: "space-between"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $b5036eb0990bf9bc$export$5a58787633b0b5d8), {
                                    underlined: true,
                                    showIcon: true,
                                    placeholder: "Global search",
                                    onChange: function(_, newValue) {
                                        setSearchText(newValue);
                                    }
                                }, void 0),
                                (0, $7b02d682eb115277$exports.jsx)((0, $ac117d5d91b8c14b$export$afe2359305e787af), {
                                    items: [
                                        {
                                            key: "menu",
                                            text: "Logged in as ".concat(company),
                                            subMenuProps: {
                                                items: [
                                                    {
                                                        key: "signout",
                                                        text: "Sign Out",
                                                        onClick: onSignOut
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }, void 0)
                            ]
                        }), void 0),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ff260a7ce3c550d8$export$bdef74da83342439), {
                            items: filteredItems,
                            columns: columns.current,
                            onRenderRow: onRenderRow,
                            layoutMode: (0, $5103473855f147d2$export$2499c0b3a09a8cda).fixedColumns,
                            constrainMode: (0, $5103473855f147d2$export$ff960e2d30f8d80b).unconstrained,
                            selectionMode: (0, $eb906a1fe3c7a837$export$91484609d16ec765).none,
                            onColumnHeaderClick: onColumnHeaderClick
                        }, void 0),
                        selectedItem && (0, $7b02d682eb115277$exports.jsx)((0, $23490a8dec97b8ae$exports.JobSeekerDetails), {
                            person: selectedItem,
                            onDismiss: function() {
                                return setSelectedItem(undefined);
                            }
                        }, void 0),
                        columnMenuItems.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $ce0e54155b3ccf1a$export$f55c8e309b1cad66), {
                            items: columnMenuItems,
                            alignTargetEdge: true,
                            directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomLeftEdge,
                            useTargetWidth: true,
                            target: contextMenuTarget.current,
                            onDismiss: onDismissContextMenu,
                            styles: {
                                list: {
                                    maxHeight: 400
                                }
                            }
                        }, void 0),
                        filteredItems.length === 0 && (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), $dad8c4ad44cfb8f1$var$__assign({
                            variant: "large"
                        }, {
                            children: "No people to show."
                        }), void 0)
                    ]
                }, void 0)
            }, void 0)
        }, void 0)
    }), void 0);
}


$parcel$exportWildcard($defdd53b1fb54413$exports, $5607221af92f9c3a$exports);
$parcel$exportWildcard($defdd53b1fb54413$exports, $2da54d2112afb05d$exports);
$parcel$exportWildcard($defdd53b1fb54413$exports, $dad8c4ad44cfb8f1$exports);


const $dad545c909cfec2d$var$container = document.getElementById("root");
(0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5607221af92f9c3a$exports.App), {}), $dad545c909cfec2d$var$container);


//# sourceMappingURL=index.ef7162ad.js.map
